/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _jsonb: any;
  bigint: number;
  float8: number;
  jsonb: any;
  numeric: number;
  smallint: number;
  timestamp: string;
  uuid: any;
};

export type AcceptInviteInput = {
  Code: Scalars['String'];
};

export type AcceptInviteOutput = {
  __typename?: 'AcceptInviteOutput';
  Membership?: Maybe<Membership>;
  MembershipId: Scalars['uuid'];
};

/** columns and relationships of "Account" */
export type Account = {
  __typename?: 'Account';
  /** An array relationship */
  AccountNotes: Array<ActionNotes>;
  /** An aggregate relationship */
  AccountNotes_aggregate: ActionNotes_Aggregate;
  /** An array relationship */
  Addresses: Array<Address>;
  /** An aggregate relationship */
  Addresses_aggregate: Address_Aggregate;
  /** An array relationship */
  Attachments: Array<Attachment>;
  /** An aggregate relationship */
  Attachments_aggregate: Attachment_Aggregate;
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  BusinessSize?: Maybe<Scalars['String']>;
  BusinessType?: Maybe<Scalars['String']>;
  ContactFirstname?: Maybe<Scalars['String']>;
  ContactLastname?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Facebook?: Maybe<Scalars['String']>;
  FocusArea?: Maybe<Scalars['String']>;
  /** An object relationship */
  Funder?: Maybe<Funder>;
  FunderId?: Maybe<Scalars['uuid']>;
  GovType?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  /** An array relationship */
  Invites: Array<Invite>;
  /** An aggregate relationship */
  Invites_aggregate: Invite_Aggregate;
  /** An array relationship */
  Memberships: Array<Membership>;
  /** An aggregate relationship */
  Memberships_aggregate: Membership_Aggregate;
  MigratedId?: Maybe<Scalars['uuid']>;
  Mobile?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  OrgType?: Maybe<Scalars['String']>;
  PaymentMethodDescriptor?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planter?: Maybe<Planter>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PreferredDisplay: Scalars['Int'];
  Reference: Scalars['bigint'];
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegionRef: Scalars['Int'];
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  StripeCustomerId?: Maybe<Scalars['String']>;
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri: Scalars['String'];
  VolunteerId?: Maybe<Scalars['uuid']>;
  Website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Account" */
export type AccountAccountNotesArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountAccountNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountInvitesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountInvites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


/** columns and relationships of "Account" */
export type AccountMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};

export enum AccountAssetType {
  Avatar = 'Avatar',
  Banner = 'Banner'
}

export enum AccountReportRole {
  Funder = 'Funder',
  Planter = 'Planter'
}

/** columns and relationships of "AccountSupporters" */
export type AccountSupporters = {
  __typename?: 'AccountSupporters';
  Avatar: Scalars['String'];
  Id?: Maybe<Scalars['uuid']>;
  Name: Scalars['String'];
  Region?: Maybe<Scalars['String']>;
  SupportType: Scalars['String'];
  Trees?: Maybe<Scalars['numeric']>;
  Type: Scalars['String'];
  Uri: Scalars['String'];
};

/** aggregated selection of "AccountSupporters" */
export type AccountSupporters_Aggregate = {
  __typename?: 'AccountSupporters_aggregate';
  aggregate?: Maybe<AccountSupporters_Aggregate_Fields>;
  nodes: Array<AccountSupporters>;
};

/** aggregate fields of "AccountSupporters" */
export type AccountSupporters_Aggregate_Fields = {
  __typename?: 'AccountSupporters_aggregate_fields';
  avg?: Maybe<AccountSupporters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountSupporters_Max_Fields>;
  min?: Maybe<AccountSupporters_Min_Fields>;
  stddev?: Maybe<AccountSupporters_Stddev_Fields>;
  stddev_pop?: Maybe<AccountSupporters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountSupporters_Stddev_Samp_Fields>;
  sum?: Maybe<AccountSupporters_Sum_Fields>;
  var_pop?: Maybe<AccountSupporters_Var_Pop_Fields>;
  var_samp?: Maybe<AccountSupporters_Var_Samp_Fields>;
  variance?: Maybe<AccountSupporters_Variance_Fields>;
};


/** aggregate fields of "AccountSupporters" */
export type AccountSupporters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AccountSupporters_Avg_Fields = {
  __typename?: 'AccountSupporters_avg_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AccountSupporters". All fields are combined with a logical 'AND'. */
export type AccountSupporters_Bool_Exp = {
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Region?: InputMaybe<String_Comparison_Exp>;
  SupportType?: InputMaybe<String_Comparison_Exp>;
  Trees?: InputMaybe<Numeric_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AccountSupporters_Bool_Exp>>;
  _not?: InputMaybe<AccountSupporters_Bool_Exp>;
  _or?: InputMaybe<Array<AccountSupporters_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "AccountSupporters" */
export type AccountSupporters_Inc_Input = {
  Trees?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "AccountSupporters" */
export type AccountSupporters_Insert_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  SupportType?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AccountSupporters_Max_Fields = {
  __typename?: 'AccountSupporters_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  SupportType?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AccountSupporters_Min_Fields = {
  __typename?: 'AccountSupporters_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  SupportType?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AccountSupporters" */
export type AccountSupporters_Mutation_Response = {
  __typename?: 'AccountSupporters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountSupporters>;
};

/** Ordering options when selecting data from "AccountSupporters". */
export type AccountSupporters_Order_By = {
  Avatar?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Region?: InputMaybe<Order_By>;
  SupportType?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "AccountSupporters" */
export enum AccountSupporters_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Region = 'Region',
  /** column name */
  SupportType = 'SupportType',
  /** column name */
  Trees = 'Trees',
  /** column name */
  Type = 'Type',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "AccountSupporters" */
export type AccountSupporters_Set_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  SupportType?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AccountSupporters_Stddev_Fields = {
  __typename?: 'AccountSupporters_stddev_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AccountSupporters_Stddev_Pop_Fields = {
  __typename?: 'AccountSupporters_stddev_pop_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AccountSupporters_Stddev_Samp_Fields = {
  __typename?: 'AccountSupporters_stddev_samp_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AccountSupporters" */
export type AccountSupporters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountSupporters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountSupporters_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  SupportType?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AccountSupporters_Sum_Fields = {
  __typename?: 'AccountSupporters_sum_fields';
  Trees?: Maybe<Scalars['numeric']>;
};

export type AccountSupporters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountSupporters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountSupporters_Set_Input>;
  where: AccountSupporters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccountSupporters_Var_Pop_Fields = {
  __typename?: 'AccountSupporters_var_pop_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AccountSupporters_Var_Samp_Fields = {
  __typename?: 'AccountSupporters_var_samp_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccountSupporters_Variance_Fields = {
  __typename?: 'AccountSupporters_variance_fields';
  Trees?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AccountView" */
export type AccountView = {
  __typename?: 'AccountView';
  Address?: Maybe<Scalars['String']>;
  ApprovedBySeason?: Maybe<Scalars['_jsonb']>;
  BusinessType?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FundingsBySeason?: Maybe<Scalars['_jsonb']>;
  GovType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  IsFunder?: Maybe<Scalars['String']>;
  IsPlanter?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  OrgType?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingsBySeason?: Maybe<Scalars['_jsonb']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryTrees?: Maybe<Scalars['numeric']>;
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
  TotalFunded?: Maybe<Scalars['numeric']>;
  TotalPlanted?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "AccountView" */
export type AccountView_Aggregate = {
  __typename?: 'AccountView_aggregate';
  aggregate?: Maybe<AccountView_Aggregate_Fields>;
  nodes: Array<AccountView>;
};

/** aggregate fields of "AccountView" */
export type AccountView_Aggregate_Fields = {
  __typename?: 'AccountView_aggregate_fields';
  avg?: Maybe<AccountView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccountView_Max_Fields>;
  min?: Maybe<AccountView_Min_Fields>;
  stddev?: Maybe<AccountView_Stddev_Fields>;
  stddev_pop?: Maybe<AccountView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccountView_Stddev_Samp_Fields>;
  sum?: Maybe<AccountView_Sum_Fields>;
  var_pop?: Maybe<AccountView_Var_Pop_Fields>;
  var_samp?: Maybe<AccountView_Var_Samp_Fields>;
  variance?: Maybe<AccountView_Variance_Fields>;
};


/** aggregate fields of "AccountView" */
export type AccountView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccountView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AccountView_Avg_Fields = {
  __typename?: 'AccountView_avg_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AccountView". All fields are combined with a logical 'AND'. */
export type AccountView_Bool_Exp = {
  Address?: InputMaybe<String_Comparison_Exp>;
  ApprovedBySeason?: InputMaybe<_Jsonb_Comparison_Exp>;
  BusinessType?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DistrictName?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  FundingsBySeason?: InputMaybe<_Jsonb_Comparison_Exp>;
  GovType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsFunder?: InputMaybe<String_Comparison_Exp>;
  IsPlanter?: InputMaybe<String_Comparison_Exp>;
  Mobile?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OrgType?: InputMaybe<String_Comparison_Exp>;
  Phone?: InputMaybe<String_Comparison_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingsBySeason?: InputMaybe<_Jsonb_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  RegistryTrees?: InputMaybe<Numeric_Comparison_Exp>;
  SchoolType?: InputMaybe<String_Comparison_Exp>;
  Sector?: InputMaybe<String_Comparison_Exp>;
  TotalApproved?: InputMaybe<Numeric_Comparison_Exp>;
  TotalFunded?: InputMaybe<Numeric_Comparison_Exp>;
  TotalPlanted?: InputMaybe<Numeric_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<AccountView_Bool_Exp>>;
  _not?: InputMaybe<AccountView_Bool_Exp>;
  _or?: InputMaybe<Array<AccountView_Bool_Exp>>;
};

/** aggregate max on columns */
export type AccountView_Max_Fields = {
  __typename?: 'AccountView_max_fields';
  Address?: Maybe<Scalars['String']>;
  BusinessType?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GovType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  IsFunder?: Maybe<Scalars['String']>;
  IsPlanter?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  OrgType?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryTrees?: Maybe<Scalars['numeric']>;
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
  TotalFunded?: Maybe<Scalars['numeric']>;
  TotalPlanted?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AccountView_Min_Fields = {
  __typename?: 'AccountView_min_fields';
  Address?: Maybe<Scalars['String']>;
  BusinessType?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GovType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  IsFunder?: Maybe<Scalars['String']>;
  IsPlanter?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  OrgType?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryTrees?: Maybe<Scalars['numeric']>;
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
  TotalFunded?: Maybe<Scalars['numeric']>;
  TotalPlanted?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "AccountView". */
export type AccountView_Order_By = {
  Address?: InputMaybe<Order_By>;
  ApprovedBySeason?: InputMaybe<Order_By>;
  BusinessType?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  DistrictName?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  FundingsBySeason?: InputMaybe<Order_By>;
  GovType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsFunder?: InputMaybe<Order_By>;
  IsPlanter?: InputMaybe<Order_By>;
  Mobile?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OrgType?: InputMaybe<Order_By>;
  Phone?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingsBySeason?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  RegistryTrees?: InputMaybe<Order_By>;
  SchoolType?: InputMaybe<Order_By>;
  Sector?: InputMaybe<Order_By>;
  TotalApproved?: InputMaybe<Order_By>;
  TotalFunded?: InputMaybe<Order_By>;
  TotalPlanted?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "AccountView" */
export enum AccountView_Select_Column {
  /** column name */
  Address = 'Address',
  /** column name */
  ApprovedBySeason = 'ApprovedBySeason',
  /** column name */
  BusinessType = 'BusinessType',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  Email = 'Email',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  FundingsBySeason = 'FundingsBySeason',
  /** column name */
  GovType = 'GovType',
  /** column name */
  Id = 'Id',
  /** column name */
  IsFunder = 'IsFunder',
  /** column name */
  IsPlanter = 'IsPlanter',
  /** column name */
  Mobile = 'Mobile',
  /** column name */
  Name = 'Name',
  /** column name */
  OrgType = 'OrgType',
  /** column name */
  Phone = 'Phone',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingsBySeason = 'PlantingsBySeason',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegistryTrees = 'RegistryTrees',
  /** column name */
  SchoolType = 'SchoolType',
  /** column name */
  Sector = 'Sector',
  /** column name */
  TotalApproved = 'TotalApproved',
  /** column name */
  TotalFunded = 'TotalFunded',
  /** column name */
  TotalPlanted = 'TotalPlanted',
  /** column name */
  Type = 'Type',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type AccountView_Stddev_Fields = {
  __typename?: 'AccountView_stddev_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AccountView_Stddev_Pop_Fields = {
  __typename?: 'AccountView_stddev_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AccountView_Stddev_Samp_Fields = {
  __typename?: 'AccountView_stddev_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AccountView" */
export type AccountView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccountView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountView_Stream_Cursor_Value_Input = {
  Address?: InputMaybe<Scalars['String']>;
  ApprovedBySeason?: InputMaybe<Scalars['_jsonb']>;
  BusinessType?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  FundingsBySeason?: InputMaybe<Scalars['_jsonb']>;
  GovType?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsFunder?: InputMaybe<Scalars['String']>;
  IsPlanter?: InputMaybe<Scalars['String']>;
  Mobile?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  OrgType?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingsBySeason?: InputMaybe<Scalars['_jsonb']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegistryTrees?: InputMaybe<Scalars['numeric']>;
  SchoolType?: InputMaybe<Scalars['String']>;
  Sector?: InputMaybe<Scalars['String']>;
  TotalApproved?: InputMaybe<Scalars['numeric']>;
  TotalFunded?: InputMaybe<Scalars['numeric']>;
  TotalPlanted?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AccountView_Sum_Fields = {
  __typename?: 'AccountView_sum_fields';
  Reference?: Maybe<Scalars['bigint']>;
  RegistryTrees?: Maybe<Scalars['numeric']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
  TotalFunded?: Maybe<Scalars['numeric']>;
  TotalPlanted?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type AccountView_Var_Pop_Fields = {
  __typename?: 'AccountView_var_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AccountView_Var_Samp_Fields = {
  __typename?: 'AccountView_var_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccountView_Variance_Fields = {
  __typename?: 'AccountView_variance_fields';
  Reference?: Maybe<Scalars['Float']>;
  RegistryTrees?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
  TotalFunded?: Maybe<Scalars['Float']>;
  TotalPlanted?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Account" */
export type Account_Aggregate = {
  __typename?: 'Account_aggregate';
  aggregate?: Maybe<Account_Aggregate_Fields>;
  nodes: Array<Account>;
};

/** aggregate fields of "Account" */
export type Account_Aggregate_Fields = {
  __typename?: 'Account_aggregate_fields';
  avg?: Maybe<Account_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Account_Max_Fields>;
  min?: Maybe<Account_Min_Fields>;
  stddev?: Maybe<Account_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Sum_Fields>;
  var_pop?: Maybe<Account_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Var_Samp_Fields>;
  variance?: Maybe<Account_Variance_Fields>;
};


/** aggregate fields of "Account" */
export type Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Account_Avg_Fields = {
  __typename?: 'Account_avg_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Account". All fields are combined with a logical 'AND'. */
export type Account_Bool_Exp = {
  AccountNotes?: InputMaybe<ActionNotes_Bool_Exp>;
  AccountNotes_aggregate?: InputMaybe<ActionNotes_Aggregate_Bool_Exp>;
  Addresses?: InputMaybe<Address_Bool_Exp>;
  Addresses_aggregate?: InputMaybe<Address_Aggregate_Bool_Exp>;
  Attachments?: InputMaybe<Attachment_Bool_Exp>;
  Attachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Banner?: InputMaybe<String_Comparison_Exp>;
  BusinessSize?: InputMaybe<String_Comparison_Exp>;
  BusinessType?: InputMaybe<String_Comparison_Exp>;
  ContactFirstname?: InputMaybe<String_Comparison_Exp>;
  ContactLastname?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  DistrictName?: InputMaybe<String_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  Facebook?: InputMaybe<String_Comparison_Exp>;
  FocusArea?: InputMaybe<String_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  GovType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Invites?: InputMaybe<Invite_Bool_Exp>;
  Invites_aggregate?: InputMaybe<Invite_Aggregate_Bool_Exp>;
  Memberships?: InputMaybe<Membership_Bool_Exp>;
  Memberships_aggregate?: InputMaybe<Membership_Aggregate_Bool_Exp>;
  MigratedId?: InputMaybe<Uuid_Comparison_Exp>;
  Mobile?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OrgType?: InputMaybe<String_Comparison_Exp>;
  PaymentMethodDescriptor?: InputMaybe<String_Comparison_Exp>;
  Phone?: InputMaybe<String_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PreferredDisplay?: InputMaybe<Int_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  RegionRef?: InputMaybe<Int_Comparison_Exp>;
  SchoolType?: InputMaybe<String_Comparison_Exp>;
  Sector?: InputMaybe<String_Comparison_Exp>;
  StripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  VolunteerId?: InputMaybe<Uuid_Comparison_Exp>;
  Website?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Account_Bool_Exp>>;
  _not?: InputMaybe<Account_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Bool_Exp>>;
};

/** unique or primary key constraints on table "Account" */
export enum Account_Constraint {
  /** unique or primary key constraint on columns "Id" */
  AccountPkey = 'Account_pkey'
}

/** input type for incrementing numeric columns in table "Account" */
export type Account_Inc_Input = {
  PreferredDisplay?: InputMaybe<Scalars['Int']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionRef?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Account" */
export type Account_Insert_Input = {
  AccountNotes?: InputMaybe<ActionNotes_Arr_Rel_Insert_Input>;
  Addresses?: InputMaybe<Address_Arr_Rel_Insert_Input>;
  Attachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  BusinessSize?: InputMaybe<Scalars['String']>;
  BusinessType?: InputMaybe<Scalars['String']>;
  ContactFirstname?: InputMaybe<Scalars['String']>;
  ContactLastname?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  FocusArea?: InputMaybe<Scalars['String']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GovType?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Invites?: InputMaybe<Invite_Arr_Rel_Insert_Input>;
  Memberships?: InputMaybe<Membership_Arr_Rel_Insert_Input>;
  MigratedId?: InputMaybe<Scalars['uuid']>;
  Mobile?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  OrgType?: InputMaybe<Scalars['String']>;
  PaymentMethodDescriptor?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PreferredDisplay?: InputMaybe<Scalars['Int']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegionRef?: InputMaybe<Scalars['Int']>;
  SchoolType?: InputMaybe<Scalars['String']>;
  Sector?: InputMaybe<Scalars['String']>;
  StripeCustomerId?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  VolunteerId?: InputMaybe<Scalars['uuid']>;
  Website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Account_Max_Fields = {
  __typename?: 'Account_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  BusinessSize?: Maybe<Scalars['String']>;
  BusinessType?: Maybe<Scalars['String']>;
  ContactFirstname?: Maybe<Scalars['String']>;
  ContactLastname?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Facebook?: Maybe<Scalars['String']>;
  FocusArea?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GovType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  MigratedId?: Maybe<Scalars['uuid']>;
  Mobile?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  OrgType?: Maybe<Scalars['String']>;
  PaymentMethodDescriptor?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PreferredDisplay?: Maybe<Scalars['Int']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegionRef?: Maybe<Scalars['Int']>;
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  StripeCustomerId?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
  VolunteerId?: Maybe<Scalars['uuid']>;
  Website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Account_Min_Fields = {
  __typename?: 'Account_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  BusinessSize?: Maybe<Scalars['String']>;
  BusinessType?: Maybe<Scalars['String']>;
  ContactFirstname?: Maybe<Scalars['String']>;
  ContactLastname?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Facebook?: Maybe<Scalars['String']>;
  FocusArea?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GovType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  MigratedId?: Maybe<Scalars['uuid']>;
  Mobile?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  OrgType?: Maybe<Scalars['String']>;
  PaymentMethodDescriptor?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PreferredDisplay?: Maybe<Scalars['Int']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegionRef?: Maybe<Scalars['Int']>;
  SchoolType?: Maybe<Scalars['String']>;
  Sector?: Maybe<Scalars['String']>;
  StripeCustomerId?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
  VolunteerId?: Maybe<Scalars['uuid']>;
  Website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Account" */
export type Account_Mutation_Response = {
  __typename?: 'Account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** input type for inserting object relation for remote table "Account" */
export type Account_Obj_Rel_Insert_Input = {
  data: Account_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** on_conflict condition type for table "Account" */
export type Account_On_Conflict = {
  constraint: Account_Constraint;
  update_columns?: Array<Account_Update_Column>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** Ordering options when selecting data from "Account". */
export type Account_Order_By = {
  AccountNotes_aggregate?: InputMaybe<ActionNotes_Aggregate_Order_By>;
  Addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  Attachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  Avatar?: InputMaybe<Order_By>;
  Banner?: InputMaybe<Order_By>;
  BusinessSize?: InputMaybe<Order_By>;
  BusinessType?: InputMaybe<Order_By>;
  ContactFirstname?: InputMaybe<Order_By>;
  ContactLastname?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  DistrictName?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  Facebook?: InputMaybe<Order_By>;
  FocusArea?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  GovType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Invites_aggregate?: InputMaybe<Invite_Aggregate_Order_By>;
  Memberships_aggregate?: InputMaybe<Membership_Aggregate_Order_By>;
  MigratedId?: InputMaybe<Order_By>;
  Mobile?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OrgType?: InputMaybe<Order_By>;
  PaymentMethodDescriptor?: InputMaybe<Order_By>;
  Phone?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PreferredDisplay?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  RegionRef?: InputMaybe<Order_By>;
  SchoolType?: InputMaybe<Order_By>;
  Sector?: InputMaybe<Order_By>;
  StripeCustomerId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
  VolunteerId?: InputMaybe<Order_By>;
  Website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Account */
export type Account_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Account" */
export enum Account_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  BusinessSize = 'BusinessSize',
  /** column name */
  BusinessType = 'BusinessType',
  /** column name */
  ContactFirstname = 'ContactFirstname',
  /** column name */
  ContactLastname = 'ContactLastname',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  Email = 'Email',
  /** column name */
  Facebook = 'Facebook',
  /** column name */
  FocusArea = 'FocusArea',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  GovType = 'GovType',
  /** column name */
  Id = 'Id',
  /** column name */
  MigratedId = 'MigratedId',
  /** column name */
  Mobile = 'Mobile',
  /** column name */
  Name = 'Name',
  /** column name */
  OrgType = 'OrgType',
  /** column name */
  PaymentMethodDescriptor = 'PaymentMethodDescriptor',
  /** column name */
  Phone = 'Phone',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PreferredDisplay = 'PreferredDisplay',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegionRef = 'RegionRef',
  /** column name */
  SchoolType = 'SchoolType',
  /** column name */
  Sector = 'Sector',
  /** column name */
  StripeCustomerId = 'StripeCustomerId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri',
  /** column name */
  VolunteerId = 'VolunteerId',
  /** column name */
  Website = 'Website'
}

/** input type for updating data in table "Account" */
export type Account_Set_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  BusinessSize?: InputMaybe<Scalars['String']>;
  BusinessType?: InputMaybe<Scalars['String']>;
  ContactFirstname?: InputMaybe<Scalars['String']>;
  ContactLastname?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  FocusArea?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GovType?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MigratedId?: InputMaybe<Scalars['uuid']>;
  Mobile?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  OrgType?: InputMaybe<Scalars['String']>;
  PaymentMethodDescriptor?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PreferredDisplay?: InputMaybe<Scalars['Int']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegionRef?: InputMaybe<Scalars['Int']>;
  SchoolType?: InputMaybe<Scalars['String']>;
  Sector?: InputMaybe<Scalars['String']>;
  StripeCustomerId?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  VolunteerId?: InputMaybe<Scalars['uuid']>;
  Website?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Account_Stddev_Fields = {
  __typename?: 'Account_stddev_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Account_Stddev_Pop_Fields = {
  __typename?: 'Account_stddev_pop_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Account_Stddev_Samp_Fields = {
  __typename?: 'Account_stddev_samp_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Account" */
export type Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  BusinessSize?: InputMaybe<Scalars['String']>;
  BusinessType?: InputMaybe<Scalars['String']>;
  ContactFirstname?: InputMaybe<Scalars['String']>;
  ContactLastname?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  Facebook?: InputMaybe<Scalars['String']>;
  FocusArea?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GovType?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MigratedId?: InputMaybe<Scalars['uuid']>;
  Mobile?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  OrgType?: InputMaybe<Scalars['String']>;
  PaymentMethodDescriptor?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PreferredDisplay?: InputMaybe<Scalars['Int']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegionRef?: InputMaybe<Scalars['Int']>;
  SchoolType?: InputMaybe<Scalars['String']>;
  Sector?: InputMaybe<Scalars['String']>;
  StripeCustomerId?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  VolunteerId?: InputMaybe<Scalars['uuid']>;
  Website?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Account_Sum_Fields = {
  __typename?: 'Account_sum_fields';
  PreferredDisplay?: Maybe<Scalars['Int']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionRef?: Maybe<Scalars['Int']>;
};

/** update columns of table "Account" */
export enum Account_Update_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  BusinessSize = 'BusinessSize',
  /** column name */
  BusinessType = 'BusinessType',
  /** column name */
  ContactFirstname = 'ContactFirstname',
  /** column name */
  ContactLastname = 'ContactLastname',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  Email = 'Email',
  /** column name */
  Facebook = 'Facebook',
  /** column name */
  FocusArea = 'FocusArea',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  GovType = 'GovType',
  /** column name */
  Id = 'Id',
  /** column name */
  MigratedId = 'MigratedId',
  /** column name */
  Mobile = 'Mobile',
  /** column name */
  Name = 'Name',
  /** column name */
  OrgType = 'OrgType',
  /** column name */
  PaymentMethodDescriptor = 'PaymentMethodDescriptor',
  /** column name */
  Phone = 'Phone',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PreferredDisplay = 'PreferredDisplay',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegionRef = 'RegionRef',
  /** column name */
  SchoolType = 'SchoolType',
  /** column name */
  Sector = 'Sector',
  /** column name */
  StripeCustomerId = 'StripeCustomerId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri',
  /** column name */
  VolunteerId = 'VolunteerId',
  /** column name */
  Website = 'Website'
}

export type Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Var_Pop_Fields = {
  __typename?: 'Account_var_pop_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Account_Var_Samp_Fields = {
  __typename?: 'Account_var_samp_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Account_Variance_Fields = {
  __typename?: 'Account_variance_fields';
  PreferredDisplay?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  RegionRef?: Maybe<Scalars['Float']>;
};

export enum AccountsReportType {
  Business = 'Business',
  Community = 'Community',
  FarmingForestryRural = 'FarmingForestryRural',
  Government = 'Government',
  IndividualFamily = 'IndividualFamily',
  IwiMaori = 'IwiMaori',
  NgoTrust = 'NGOTrust',
  NurseryTreeSupplier = 'NurseryTreeSupplier',
  SchoolTertiary = 'SchoolTertiary'
}

/** columns and relationships of "ActionNotes" */
export type ActionNotes = {
  __typename?: 'ActionNotes';
  Action: Scalars['String'];
  Entity: Scalars['String'];
  EntityId: Scalars['uuid'];
  Id: Scalars['uuid'];
  Notes: Scalars['String'];
  TimeStamp: Scalars['timestamp'];
  UserId: Scalars['uuid'];
};

/** aggregated selection of "ActionNotes" */
export type ActionNotes_Aggregate = {
  __typename?: 'ActionNotes_aggregate';
  aggregate?: Maybe<ActionNotes_Aggregate_Fields>;
  nodes: Array<ActionNotes>;
};

export type ActionNotes_Aggregate_Bool_Exp = {
  count?: InputMaybe<ActionNotes_Aggregate_Bool_Exp_Count>;
};

export type ActionNotes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ActionNotes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActionNotes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ActionNotes" */
export type ActionNotes_Aggregate_Fields = {
  __typename?: 'ActionNotes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ActionNotes_Max_Fields>;
  min?: Maybe<ActionNotes_Min_Fields>;
};


/** aggregate fields of "ActionNotes" */
export type ActionNotes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ActionNotes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ActionNotes" */
export type ActionNotes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ActionNotes_Max_Order_By>;
  min?: InputMaybe<ActionNotes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ActionNotes" */
export type ActionNotes_Arr_Rel_Insert_Input = {
  data: Array<ActionNotes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActionNotes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ActionNotes". All fields are combined with a logical 'AND'. */
export type ActionNotes_Bool_Exp = {
  Action?: InputMaybe<String_Comparison_Exp>;
  Entity?: InputMaybe<String_Comparison_Exp>;
  EntityId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Notes?: InputMaybe<String_Comparison_Exp>;
  TimeStamp?: InputMaybe<Timestamp_Comparison_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<ActionNotes_Bool_Exp>>;
  _not?: InputMaybe<ActionNotes_Bool_Exp>;
  _or?: InputMaybe<Array<ActionNotes_Bool_Exp>>;
};

/** unique or primary key constraints on table "ActionNotes" */
export enum ActionNotes_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ApplicationNotesPkey = 'ApplicationNotes_pkey'
}

/** input type for inserting data into table "ActionNotes" */
export type ActionNotes_Insert_Input = {
  Action?: InputMaybe<Scalars['String']>;
  Entity?: InputMaybe<Scalars['String']>;
  EntityId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  TimeStamp?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ActionNotes_Max_Fields = {
  __typename?: 'ActionNotes_max_fields';
  Action?: Maybe<Scalars['String']>;
  Entity?: Maybe<Scalars['String']>;
  EntityId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  TimeStamp?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ActionNotes" */
export type ActionNotes_Max_Order_By = {
  Action?: InputMaybe<Order_By>;
  Entity?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  TimeStamp?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ActionNotes_Min_Fields = {
  __typename?: 'ActionNotes_min_fields';
  Action?: Maybe<Scalars['String']>;
  Entity?: Maybe<Scalars['String']>;
  EntityId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  TimeStamp?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ActionNotes" */
export type ActionNotes_Min_Order_By = {
  Action?: InputMaybe<Order_By>;
  Entity?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  TimeStamp?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ActionNotes" */
export type ActionNotes_Mutation_Response = {
  __typename?: 'ActionNotes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActionNotes>;
};

/** on_conflict condition type for table "ActionNotes" */
export type ActionNotes_On_Conflict = {
  constraint: ActionNotes_Constraint;
  update_columns?: Array<ActionNotes_Update_Column>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};

/** Ordering options when selecting data from "ActionNotes". */
export type ActionNotes_Order_By = {
  Action?: InputMaybe<Order_By>;
  Entity?: InputMaybe<Order_By>;
  EntityId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  TimeStamp?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ActionNotes */
export type ActionNotes_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ActionNotes" */
export enum ActionNotes_Select_Column {
  /** column name */
  Action = 'Action',
  /** column name */
  Entity = 'Entity',
  /** column name */
  EntityId = 'EntityId',
  /** column name */
  Id = 'Id',
  /** column name */
  Notes = 'Notes',
  /** column name */
  TimeStamp = 'TimeStamp',
  /** column name */
  UserId = 'UserId'
}

/** input type for updating data in table "ActionNotes" */
export type ActionNotes_Set_Input = {
  Action?: InputMaybe<Scalars['String']>;
  Entity?: InputMaybe<Scalars['String']>;
  EntityId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  TimeStamp?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ActionNotes" */
export type ActionNotes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ActionNotes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ActionNotes_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['String']>;
  Entity?: InputMaybe<Scalars['String']>;
  EntityId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  TimeStamp?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "ActionNotes" (current role has no relevant permissions) */
export enum ActionNotes_Update_Column {
  /** column name */
  Action = 'Action',
  /** column name */
  Entity = 'Entity',
  /** column name */
  EntityId = 'EntityId',
  /** column name */
  Id = 'Id',
  /** column name */
  Notes = 'Notes',
  /** column name */
  TimeStamp = 'TimeStamp',
  /** column name */
  UserId = 'UserId',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type ActionNotes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActionNotes_Set_Input>;
  where: ActionNotes_Bool_Exp;
};

/** columns and relationships of "Actual" */
export type Actual = {
  __typename?: 'Actual';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  PlantingId: Scalars['uuid'];
  UpdatedOn: Scalars['timestamp'];
};

/** columns and relationships of "ActualLine" */
export type ActualLine = {
  __typename?: 'ActualLine';
  Id: Scalars['uuid'];
  PlanId: Scalars['uuid'];
  Quantity: Scalars['float8'];
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "ActualLine" */
export type ActualLine_Aggregate = {
  __typename?: 'ActualLine_aggregate';
  aggregate?: Maybe<ActualLine_Aggregate_Fields>;
  nodes: Array<ActualLine>;
};

/** aggregate fields of "ActualLine" */
export type ActualLine_Aggregate_Fields = {
  __typename?: 'ActualLine_aggregate_fields';
  avg?: Maybe<ActualLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ActualLine_Max_Fields>;
  min?: Maybe<ActualLine_Min_Fields>;
  stddev?: Maybe<ActualLine_Stddev_Fields>;
  stddev_pop?: Maybe<ActualLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ActualLine_Stddev_Samp_Fields>;
  sum?: Maybe<ActualLine_Sum_Fields>;
  var_pop?: Maybe<ActualLine_Var_Pop_Fields>;
  var_samp?: Maybe<ActualLine_Var_Samp_Fields>;
  variance?: Maybe<ActualLine_Variance_Fields>;
};


/** aggregate fields of "ActualLine" */
export type ActualLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ActualLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ActualLine_Avg_Fields = {
  __typename?: 'ActualLine_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ActualLine". All fields are combined with a logical 'AND'. */
export type ActualLine_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlanId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Float8_Comparison_Exp>;
  SpeciesId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<ActualLine_Bool_Exp>>;
  _not?: InputMaybe<ActualLine_Bool_Exp>;
  _or?: InputMaybe<Array<ActualLine_Bool_Exp>>;
};

/** unique or primary key constraints on table "ActualLine" */
export enum ActualLine_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ActualLinePkey = 'ActualLine_pkey'
}

/** input type for incrementing numeric columns in table "ActualLine" */
export type ActualLine_Inc_Input = {
  Quantity?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "ActualLine" */
export type ActualLine_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ActualLine_Max_Fields = {
  __typename?: 'ActualLine_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  PlanId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['float8']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ActualLine_Min_Fields = {
  __typename?: 'ActualLine_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  PlanId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['float8']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "ActualLine" */
export type ActualLine_Mutation_Response = {
  __typename?: 'ActualLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActualLine>;
};

/** on_conflict condition type for table "ActualLine" */
export type ActualLine_On_Conflict = {
  constraint: ActualLine_Constraint;
  update_columns?: Array<ActualLine_Update_Column>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};

/** Ordering options when selecting data from "ActualLine". */
export type ActualLine_Order_By = {
  Id?: InputMaybe<Order_By>;
  PlanId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ActualLine */
export type ActualLine_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ActualLine" */
export enum ActualLine_Select_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  PlanId = 'PlanId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

/** input type for updating data in table "ActualLine" */
export type ActualLine_Set_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ActualLine_Stddev_Fields = {
  __typename?: 'ActualLine_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ActualLine_Stddev_Pop_Fields = {
  __typename?: 'ActualLine_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ActualLine_Stddev_Samp_Fields = {
  __typename?: 'ActualLine_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ActualLine" */
export type ActualLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ActualLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ActualLine_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type ActualLine_Sum_Fields = {
  __typename?: 'ActualLine_sum_fields';
  Quantity?: Maybe<Scalars['float8']>;
};

/** update columns of table "ActualLine" */
export enum ActualLine_Update_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  PlanId = 'PlanId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

export type ActualLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActualLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActualLine_Set_Input>;
  where: ActualLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ActualLine_Var_Pop_Fields = {
  __typename?: 'ActualLine_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ActualLine_Var_Samp_Fields = {
  __typename?: 'ActualLine_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ActualLine_Variance_Fields = {
  __typename?: 'ActualLine_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Actual" */
export type Actual_Aggregate = {
  __typename?: 'Actual_aggregate';
  aggregate?: Maybe<Actual_Aggregate_Fields>;
  nodes: Array<Actual>;
};

/** aggregate fields of "Actual" */
export type Actual_Aggregate_Fields = {
  __typename?: 'Actual_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Actual_Max_Fields>;
  min?: Maybe<Actual_Min_Fields>;
};


/** aggregate fields of "Actual" */
export type Actual_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Actual_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Actual". All fields are combined with a logical 'AND'. */
export type Actual_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Actual_Bool_Exp>>;
  _not?: InputMaybe<Actual_Bool_Exp>;
  _or?: InputMaybe<Array<Actual_Bool_Exp>>;
};

/** unique or primary key constraints on table "Actual" */
export enum Actual_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ActualPkey = 'Actual_pkey'
}

/** input type for inserting data into table "Actual" */
export type Actual_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Actual_Max_Fields = {
  __typename?: 'Actual_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Actual_Min_Fields = {
  __typename?: 'Actual_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Actual" */
export type Actual_Mutation_Response = {
  __typename?: 'Actual_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Actual>;
};

/** on_conflict condition type for table "Actual" */
export type Actual_On_Conflict = {
  constraint: Actual_Constraint;
  update_columns?: Array<Actual_Update_Column>;
  where?: InputMaybe<Actual_Bool_Exp>;
};

/** Ordering options when selecting data from "Actual". */
export type Actual_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Actual */
export type Actual_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Actual" */
export enum Actual_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Actual" */
export type Actual_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "Actual" */
export type Actual_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Actual_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Actual_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "Actual" */
export enum Actual_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Actual_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Actual_Set_Input>;
  where: Actual_Bool_Exp;
};

/** columns and relationships of "Address" */
export type Address = {
  __typename?: 'Address';
  /** An object relationship */
  Account: Account;
  AccountId: Scalars['uuid'];
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  District?: Maybe<Scalars['String']>;
  FullAddress?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Place?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  StreetName?: Maybe<Scalars['String']>;
  StreetNumber?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  SuiteRoom?: Maybe<Scalars['String']>;
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "Address" */
export type Address_Aggregate = {
  __typename?: 'Address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

export type Address_Aggregate_Bool_Exp = {
  count?: InputMaybe<Address_Aggregate_Bool_Exp_Count>;
};

export type Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Address_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Address" */
export type Address_Aggregate_Fields = {
  __typename?: 'Address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
};


/** aggregate fields of "Address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Address" */
export type Address_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Max_Order_By>;
  min?: InputMaybe<Address_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Address" */
export type Address_Arr_Rel_Insert_Input = {
  data: Array<Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  City?: InputMaybe<String_Comparison_Exp>;
  Country?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  District?: InputMaybe<String_Comparison_Exp>;
  FullAddress?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Place?: InputMaybe<String_Comparison_Exp>;
  PostalCode?: InputMaybe<String_Comparison_Exp>;
  Region?: InputMaybe<String_Comparison_Exp>;
  StreetName?: InputMaybe<String_Comparison_Exp>;
  StreetNumber?: InputMaybe<String_Comparison_Exp>;
  Suburb?: InputMaybe<String_Comparison_Exp>;
  SuiteRoom?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
};

/** unique or primary key constraints on table "Address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "Id" */
  AddressPkey = 'Address_pkey'
}

/** input type for inserting data into table "Address" */
export type Address_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  AccountId?: InputMaybe<Scalars['uuid']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  District?: InputMaybe<Scalars['String']>;
  FullAddress?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Place?: InputMaybe<Scalars['String']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  StreetName?: InputMaybe<Scalars['String']>;
  StreetNumber?: InputMaybe<Scalars['String']>;
  Suburb?: InputMaybe<Scalars['String']>;
  SuiteRoom?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'Address_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  District?: Maybe<Scalars['String']>;
  FullAddress?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Place?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  StreetName?: Maybe<Scalars['String']>;
  StreetNumber?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  SuiteRoom?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "Address" */
export type Address_Max_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  Country?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  District?: InputMaybe<Order_By>;
  FullAddress?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Place?: InputMaybe<Order_By>;
  PostalCode?: InputMaybe<Order_By>;
  Region?: InputMaybe<Order_By>;
  StreetName?: InputMaybe<Order_By>;
  StreetNumber?: InputMaybe<Order_By>;
  Suburb?: InputMaybe<Order_By>;
  SuiteRoom?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'Address_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  District?: Maybe<Scalars['String']>;
  FullAddress?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Place?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  StreetName?: Maybe<Scalars['String']>;
  StreetNumber?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  SuiteRoom?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "Address" */
export type Address_Min_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  Country?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  District?: InputMaybe<Order_By>;
  FullAddress?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Place?: InputMaybe<Order_By>;
  PostalCode?: InputMaybe<Order_By>;
  Region?: InputMaybe<Order_By>;
  StreetName?: InputMaybe<Order_By>;
  StreetNumber?: InputMaybe<Order_By>;
  Suburb?: InputMaybe<Order_By>;
  SuiteRoom?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Address" */
export type Address_Mutation_Response = {
  __typename?: 'Address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** on_conflict condition type for table "Address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "Address". */
export type Address_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  AccountId?: InputMaybe<Order_By>;
  City?: InputMaybe<Order_By>;
  Country?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  District?: InputMaybe<Order_By>;
  FullAddress?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Place?: InputMaybe<Order_By>;
  PostalCode?: InputMaybe<Order_By>;
  Region?: InputMaybe<Order_By>;
  StreetName?: InputMaybe<Order_By>;
  StreetNumber?: InputMaybe<Order_By>;
  Suburb?: InputMaybe<Order_By>;
  SuiteRoom?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Address */
export type Address_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Address" */
export enum Address_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  City = 'City',
  /** column name */
  Country = 'Country',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  District = 'District',
  /** column name */
  FullAddress = 'FullAddress',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  Place = 'Place',
  /** column name */
  PostalCode = 'PostalCode',
  /** column name */
  Region = 'Region',
  /** column name */
  StreetName = 'StreetName',
  /** column name */
  StreetNumber = 'StreetNumber',
  /** column name */
  Suburb = 'Suburb',
  /** column name */
  SuiteRoom = 'SuiteRoom',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Address" */
export type Address_Set_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  District?: InputMaybe<Scalars['String']>;
  FullAddress?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Place?: InputMaybe<Scalars['String']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  StreetName?: InputMaybe<Scalars['String']>;
  StreetNumber?: InputMaybe<Scalars['String']>;
  Suburb?: InputMaybe<Scalars['String']>;
  SuiteRoom?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "Address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  District?: InputMaybe<Scalars['String']>;
  FullAddress?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Place?: InputMaybe<Scalars['String']>;
  PostalCode?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  StreetName?: InputMaybe<Scalars['String']>;
  StreetNumber?: InputMaybe<Scalars['String']>;
  Suburb?: InputMaybe<Scalars['String']>;
  SuiteRoom?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "Address" */
export enum Address_Update_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  City = 'City',
  /** column name */
  Country = 'Country',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  District = 'District',
  /** column name */
  FullAddress = 'FullAddress',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  Place = 'Place',
  /** column name */
  PostalCode = 'PostalCode',
  /** column name */
  Region = 'Region',
  /** column name */
  StreetName = 'StreetName',
  /** column name */
  StreetNumber = 'StreetNumber',
  /** column name */
  Suburb = 'Suburb',
  /** column name */
  SuiteRoom = 'SuiteRoom',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Address_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};

/** columns and relationships of "AdminBulkGiftView" */
export type AdminBulkGiftView = {
  __typename?: 'AdminBulkGiftView';
  Amount?: Maybe<Scalars['numeric']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee?: Maybe<Scalars['numeric']>;
  From?: Maybe<Scalars['String']>;
  Funder?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GiftMessage?: Maybe<Scalars['String']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  IsReconciled?: Maybe<Scalars['Boolean']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Provider?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientCount?: Maybe<Scalars['bigint']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Tracking?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  User?: Maybe<User>;
  UserId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "AdminBulkGiftView" */
export type AdminBulkGiftViewData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "AdminBulkGiftView" */
export type AdminBulkGiftView_Aggregate = {
  __typename?: 'AdminBulkGiftView_aggregate';
  aggregate?: Maybe<AdminBulkGiftView_Aggregate_Fields>;
  nodes: Array<AdminBulkGiftView>;
};

/** aggregate fields of "AdminBulkGiftView" */
export type AdminBulkGiftView_Aggregate_Fields = {
  __typename?: 'AdminBulkGiftView_aggregate_fields';
  avg?: Maybe<AdminBulkGiftView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AdminBulkGiftView_Max_Fields>;
  min?: Maybe<AdminBulkGiftView_Min_Fields>;
  stddev?: Maybe<AdminBulkGiftView_Stddev_Fields>;
  stddev_pop?: Maybe<AdminBulkGiftView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AdminBulkGiftView_Stddev_Samp_Fields>;
  sum?: Maybe<AdminBulkGiftView_Sum_Fields>;
  var_pop?: Maybe<AdminBulkGiftView_Var_Pop_Fields>;
  var_samp?: Maybe<AdminBulkGiftView_Var_Samp_Fields>;
  variance?: Maybe<AdminBulkGiftView_Variance_Fields>;
};


/** aggregate fields of "AdminBulkGiftView" */
export type AdminBulkGiftView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AdminBulkGiftView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AdminBulkGiftView_Avg_Fields = {
  __typename?: 'AdminBulkGiftView_avg_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AdminBulkGiftView". All fields are combined with a logical 'AND'. */
export type AdminBulkGiftView_Bool_Exp = {
  Amount?: InputMaybe<Numeric_Comparison_Exp>;
  Code?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Fee?: InputMaybe<Numeric_Comparison_Exp>;
  From?: InputMaybe<String_Comparison_Exp>;
  Funder?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  GiftMessage?: InputMaybe<String_Comparison_Exp>;
  GiftTemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InvoiceAddress0?: InputMaybe<String_Comparison_Exp>;
  InvoiceAddress1?: InputMaybe<String_Comparison_Exp>;
  InvoiceCity?: InputMaybe<String_Comparison_Exp>;
  InvoiceCountry?: InputMaybe<String_Comparison_Exp>;
  InvoicePostCode?: InputMaybe<String_Comparison_Exp>;
  InvoiceState?: InputMaybe<String_Comparison_Exp>;
  IsReconciled?: InputMaybe<Boolean_Comparison_Exp>;
  PaymentIntentId?: InputMaybe<String_Comparison_Exp>;
  PaymentMethod?: InputMaybe<Int_Comparison_Exp>;
  ProductId?: InputMaybe<Uuid_Comparison_Exp>;
  Provider?: InputMaybe<String_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  ReceiptingType?: InputMaybe<Smallint_Comparison_Exp>;
  RecipientCount?: InputMaybe<Bigint_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientName?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegistryId?: InputMaybe<Uuid_Comparison_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  SubTotal?: InputMaybe<Numeric_Comparison_Exp>;
  SupporterId?: InputMaybe<Uuid_Comparison_Exp>;
  Tax?: InputMaybe<Numeric_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Numeric_Comparison_Exp>;
  Tracking?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  User?: InputMaybe<User_Bool_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<AdminBulkGiftView_Bool_Exp>>;
  _not?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
  _or?: InputMaybe<Array<AdminBulkGiftView_Bool_Exp>>;
};

/** aggregate max on columns */
export type AdminBulkGiftView_Max_Fields = {
  __typename?: 'AdminBulkGiftView_max_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee?: Maybe<Scalars['numeric']>;
  From?: Maybe<Scalars['String']>;
  Funder?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GiftMessage?: Maybe<Scalars['String']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Provider?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientCount?: Maybe<Scalars['bigint']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Tracking?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type AdminBulkGiftView_Min_Fields = {
  __typename?: 'AdminBulkGiftView_min_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee?: Maybe<Scalars['numeric']>;
  From?: Maybe<Scalars['String']>;
  Funder?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GiftMessage?: Maybe<Scalars['String']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Provider?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientCount?: Maybe<Scalars['bigint']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Tracking?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "AdminBulkGiftView". */
export type AdminBulkGiftView_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  GiftMessage?: InputMaybe<Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InvoiceAddress0?: InputMaybe<Order_By>;
  InvoiceAddress1?: InputMaybe<Order_By>;
  InvoiceCity?: InputMaybe<Order_By>;
  InvoiceCountry?: InputMaybe<Order_By>;
  InvoicePostCode?: InputMaybe<Order_By>;
  InvoiceState?: InputMaybe<Order_By>;
  IsReconciled?: InputMaybe<Order_By>;
  PaymentIntentId?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Provider?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  RecipientCount?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Tracking?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  User?: InputMaybe<User_Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** select columns of table "AdminBulkGiftView" */
export enum AdminBulkGiftView_Select_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Fee = 'Fee',
  /** column name */
  From = 'From',
  /** column name */
  Funder = 'Funder',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  GiftMessage = 'GiftMessage',
  /** column name */
  GiftTemplateId = 'GiftTemplateId',
  /** column name */
  Id = 'Id',
  /** column name */
  InvoiceAddress0 = 'InvoiceAddress0',
  /** column name */
  InvoiceAddress1 = 'InvoiceAddress1',
  /** column name */
  InvoiceCity = 'InvoiceCity',
  /** column name */
  InvoiceCountry = 'InvoiceCountry',
  /** column name */
  InvoicePostCode = 'InvoicePostCode',
  /** column name */
  InvoiceState = 'InvoiceState',
  /** column name */
  IsReconciled = 'IsReconciled',
  /** column name */
  PaymentIntentId = 'PaymentIntentId',
  /** column name */
  PaymentMethod = 'PaymentMethod',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  Provider = 'Provider',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  ReceiptingType = 'ReceiptingType',
  /** column name */
  RecipientCount = 'RecipientCount',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegistryId = 'RegistryId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  State = 'State',
  /** column name */
  SubTotal = 'SubTotal',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  Tax = 'Tax',
  /** column name */
  Token = 'Token',
  /** column name */
  Total = 'Total',
  /** column name */
  Tracking = 'Tracking',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

/** aggregate stddev on columns */
export type AdminBulkGiftView_Stddev_Fields = {
  __typename?: 'AdminBulkGiftView_stddev_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdminBulkGiftView_Stddev_Pop_Fields = {
  __typename?: 'AdminBulkGiftView_stddev_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdminBulkGiftView_Stddev_Samp_Fields = {
  __typename?: 'AdminBulkGiftView_stddev_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AdminBulkGiftView" */
export type AdminBulkGiftView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AdminBulkGiftView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AdminBulkGiftView_Stream_Cursor_Value_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Fee?: InputMaybe<Scalars['numeric']>;
  From?: InputMaybe<Scalars['String']>;
  Funder?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GiftMessage?: InputMaybe<Scalars['String']>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InvoiceAddress0?: InputMaybe<Scalars['String']>;
  InvoiceAddress1?: InputMaybe<Scalars['String']>;
  InvoiceCity?: InputMaybe<Scalars['String']>;
  InvoiceCountry?: InputMaybe<Scalars['String']>;
  InvoicePostCode?: InputMaybe<Scalars['String']>;
  InvoiceState?: InputMaybe<Scalars['String']>;
  IsReconciled?: InputMaybe<Scalars['Boolean']>;
  PaymentIntentId?: InputMaybe<Scalars['String']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Provider?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  RecipientCount?: InputMaybe<Scalars['bigint']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  SubTotal?: InputMaybe<Scalars['numeric']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Tracking?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AdminBulkGiftView_Sum_Fields = {
  __typename?: 'AdminBulkGiftView_sum_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Fee?: Maybe<Scalars['numeric']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientCount?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  State?: Maybe<Scalars['Int']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  Tax?: Maybe<Scalars['numeric']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type AdminBulkGiftView_Var_Pop_Fields = {
  __typename?: 'AdminBulkGiftView_var_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdminBulkGiftView_Var_Samp_Fields = {
  __typename?: 'AdminBulkGiftView_var_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdminBulkGiftView_Variance_Fields = {
  __typename?: 'AdminBulkGiftView_variance_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  RecipientCount?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AdminPurchaseView" */
export type AdminPurchaseView = {
  __typename?: 'AdminPurchaseView';
  /** An object relationship */
  Account?: Maybe<Account>;
  AccountId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  Attachments: Array<Attachment>;
  /** An aggregate relationship */
  Attachments_aggregate: Attachment_Aggregate;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  FilterState?: Maybe<Scalars['String']>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  HoldOnMatch?: Maybe<Scalars['Boolean']>;
  Id?: Maybe<Scalars['uuid']>;
  InstructionId?: Maybe<Scalars['uuid']>;
  IsMatched?: Maybe<Scalars['Boolean']>;
  IsUnmatched?: Maybe<Scalars['Boolean']>;
  Matched?: Maybe<Scalars['bigint']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductName?: Maybe<Scalars['String']>;
  PurchasePrice?: Maybe<Scalars['numeric']>;
  PurchaseReference?: Maybe<Scalars['bigint']>;
  PurchaseState?: Maybe<Scalars['Int']>;
  PurchaseTotal?: Maybe<Scalars['numeric']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "AdminPurchaseView" */
export type AdminPurchaseViewAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


/** columns and relationships of "AdminPurchaseView" */
export type AdminPurchaseViewAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** aggregated selection of "AdminPurchaseView" */
export type AdminPurchaseView_Aggregate = {
  __typename?: 'AdminPurchaseView_aggregate';
  aggregate?: Maybe<AdminPurchaseView_Aggregate_Fields>;
  nodes: Array<AdminPurchaseView>;
};

/** aggregate fields of "AdminPurchaseView" */
export type AdminPurchaseView_Aggregate_Fields = {
  __typename?: 'AdminPurchaseView_aggregate_fields';
  avg?: Maybe<AdminPurchaseView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AdminPurchaseView_Max_Fields>;
  min?: Maybe<AdminPurchaseView_Min_Fields>;
  stddev?: Maybe<AdminPurchaseView_Stddev_Fields>;
  stddev_pop?: Maybe<AdminPurchaseView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AdminPurchaseView_Stddev_Samp_Fields>;
  sum?: Maybe<AdminPurchaseView_Sum_Fields>;
  var_pop?: Maybe<AdminPurchaseView_Var_Pop_Fields>;
  var_samp?: Maybe<AdminPurchaseView_Var_Samp_Fields>;
  variance?: Maybe<AdminPurchaseView_Variance_Fields>;
};


/** aggregate fields of "AdminPurchaseView" */
export type AdminPurchaseView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AdminPurchaseView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AdminPurchaseView_Avg_Fields = {
  __typename?: 'AdminPurchaseView_avg_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AdminPurchaseView". All fields are combined with a logical 'AND'. */
export type AdminPurchaseView_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  Attachments?: InputMaybe<Attachment_Bool_Exp>;
  Attachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  CreatedOnFormatted?: InputMaybe<String_Comparison_Exp>;
  DistrictName?: InputMaybe<String_Comparison_Exp>;
  FilterState?: InputMaybe<String_Comparison_Exp>;
  FunderDistrictName?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  FunderName?: InputMaybe<String_Comparison_Exp>;
  FunderRegionName?: InputMaybe<String_Comparison_Exp>;
  GiftDeliveryDate?: InputMaybe<Timestamp_Comparison_Exp>;
  HoldOnMatch?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  InstructionId?: InputMaybe<Uuid_Comparison_Exp>;
  IsMatched?: InputMaybe<Boolean_Comparison_Exp>;
  IsUnmatched?: InputMaybe<Boolean_Comparison_Exp>;
  Matched?: InputMaybe<Bigint_Comparison_Exp>;
  PaymentMethod?: InputMaybe<Int_Comparison_Exp>;
  ProductName?: InputMaybe<String_Comparison_Exp>;
  PurchasePrice?: InputMaybe<Numeric_Comparison_Exp>;
  PurchaseReference?: InputMaybe<Bigint_Comparison_Exp>;
  PurchaseState?: InputMaybe<Int_Comparison_Exp>;
  PurchaseTotal?: InputMaybe<Numeric_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientName?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<String_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  RegistryId?: InputMaybe<Uuid_Comparison_Exp>;
  RegistryName?: InputMaybe<String_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  SubscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  Trees?: InputMaybe<Bigint_Comparison_Exp>;
  TypeName?: InputMaybe<Int_Comparison_Exp>;
  Unmatched?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<AdminPurchaseView_Bool_Exp>>;
  _not?: InputMaybe<AdminPurchaseView_Bool_Exp>;
  _or?: InputMaybe<Array<AdminPurchaseView_Bool_Exp>>;
};

/** aggregate max on columns */
export type AdminPurchaseView_Max_Fields = {
  __typename?: 'AdminPurchaseView_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  FilterState?: Maybe<Scalars['String']>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  InstructionId?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['bigint']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductName?: Maybe<Scalars['String']>;
  PurchasePrice?: Maybe<Scalars['numeric']>;
  PurchaseReference?: Maybe<Scalars['bigint']>;
  PurchaseState?: Maybe<Scalars['Int']>;
  PurchaseTotal?: Maybe<Scalars['numeric']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdminPurchaseView_Min_Fields = {
  __typename?: 'AdminPurchaseView_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  FilterState?: Maybe<Scalars['String']>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  InstructionId?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['bigint']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductName?: Maybe<Scalars['String']>;
  PurchasePrice?: Maybe<Scalars['numeric']>;
  PurchaseReference?: Maybe<Scalars['bigint']>;
  PurchaseState?: Maybe<Scalars['Int']>;
  PurchaseTotal?: Maybe<Scalars['numeric']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "AdminPurchaseView". */
export type AdminPurchaseView_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  AccountId?: InputMaybe<Order_By>;
  Attachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  CreatedOnFormatted?: InputMaybe<Order_By>;
  DistrictName?: InputMaybe<Order_By>;
  FilterState?: InputMaybe<Order_By>;
  FunderDistrictName?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  FunderName?: InputMaybe<Order_By>;
  FunderRegionName?: InputMaybe<Order_By>;
  GiftDeliveryDate?: InputMaybe<Order_By>;
  HoldOnMatch?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InstructionId?: InputMaybe<Order_By>;
  IsMatched?: InputMaybe<Order_By>;
  IsUnmatched?: InputMaybe<Order_By>;
  Matched?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  ProductName?: InputMaybe<Order_By>;
  PurchasePrice?: InputMaybe<Order_By>;
  PurchaseReference?: InputMaybe<Order_By>;
  PurchaseState?: InputMaybe<Order_By>;
  PurchaseTotal?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  RegistryName?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  SubscriptionId?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  TypeName?: InputMaybe<Order_By>;
  Unmatched?: InputMaybe<Order_By>;
};

/** select columns of table "AdminPurchaseView" */
export enum AdminPurchaseView_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  CreatedOnFormatted = 'CreatedOnFormatted',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  FilterState = 'FilterState',
  /** column name */
  FunderDistrictName = 'FunderDistrictName',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  FunderName = 'FunderName',
  /** column name */
  FunderRegionName = 'FunderRegionName',
  /** column name */
  GiftDeliveryDate = 'GiftDeliveryDate',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  InstructionId = 'InstructionId',
  /** column name */
  IsMatched = 'IsMatched',
  /** column name */
  IsUnmatched = 'IsUnmatched',
  /** column name */
  Matched = 'Matched',
  /** column name */
  PaymentMethod = 'PaymentMethod',
  /** column name */
  ProductName = 'ProductName',
  /** column name */
  PurchasePrice = 'PurchasePrice',
  /** column name */
  PurchaseReference = 'PurchaseReference',
  /** column name */
  PurchaseState = 'PurchaseState',
  /** column name */
  PurchaseTotal = 'PurchaseTotal',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegistryId = 'RegistryId',
  /** column name */
  RegistryName = 'RegistryName',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  SubscriptionId = 'SubscriptionId',
  /** column name */
  Trees = 'Trees',
  /** column name */
  TypeName = 'TypeName',
  /** column name */
  Unmatched = 'Unmatched'
}

/** aggregate stddev on columns */
export type AdminPurchaseView_Stddev_Fields = {
  __typename?: 'AdminPurchaseView_stddev_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdminPurchaseView_Stddev_Pop_Fields = {
  __typename?: 'AdminPurchaseView_stddev_pop_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdminPurchaseView_Stddev_Samp_Fields = {
  __typename?: 'AdminPurchaseView_stddev_samp_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AdminPurchaseView" */
export type AdminPurchaseView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AdminPurchaseView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AdminPurchaseView_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOnFormatted?: InputMaybe<Scalars['String']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  FilterState?: InputMaybe<Scalars['String']>;
  FunderDistrictName?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  FunderName?: InputMaybe<Scalars['String']>;
  FunderRegionName?: InputMaybe<Scalars['String']>;
  GiftDeliveryDate?: InputMaybe<Scalars['timestamp']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InstructionId?: InputMaybe<Scalars['uuid']>;
  IsMatched?: InputMaybe<Scalars['Boolean']>;
  IsUnmatched?: InputMaybe<Scalars['Boolean']>;
  Matched?: InputMaybe<Scalars['bigint']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  ProductName?: InputMaybe<Scalars['String']>;
  PurchasePrice?: InputMaybe<Scalars['numeric']>;
  PurchaseReference?: InputMaybe<Scalars['bigint']>;
  PurchaseState?: InputMaybe<Scalars['Int']>;
  PurchaseTotal?: InputMaybe<Scalars['numeric']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['String']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  RegistryName?: InputMaybe<Scalars['String']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  SubscriptionId?: InputMaybe<Scalars['uuid']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  TypeName?: InputMaybe<Scalars['Int']>;
  Unmatched?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdminPurchaseView_Sum_Fields = {
  __typename?: 'AdminPurchaseView_sum_fields';
  Matched?: Maybe<Scalars['bigint']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  PurchasePrice?: Maybe<Scalars['numeric']>;
  PurchaseReference?: Maybe<Scalars['bigint']>;
  PurchaseState?: Maybe<Scalars['Int']>;
  PurchaseTotal?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AdminPurchaseView_Var_Pop_Fields = {
  __typename?: 'AdminPurchaseView_var_pop_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdminPurchaseView_Var_Samp_Fields = {
  __typename?: 'AdminPurchaseView_var_samp_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdminPurchaseView_Variance_Fields = {
  __typename?: 'AdminPurchaseView_variance_fields';
  Matched?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  PurchasePrice?: Maybe<Scalars['Float']>;
  PurchaseReference?: Maybe<Scalars['Float']>;
  PurchaseState?: Maybe<Scalars['Float']>;
  PurchaseTotal?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Application" */
export type Application = {
  __typename?: 'Application';
  AccessToPublic?: Maybe<Scalars['Boolean']>;
  AddingToCount: Scalars['Boolean'];
  AgreeAssetUsage: Scalars['Boolean'];
  AgreeToMonitor: Scalars['Boolean'];
  AgreeToReport: Scalars['Boolean'];
  /** An array relationship */
  ApplicationAssets: Array<ApplicationAsset>;
  /** An aggregate relationship */
  ApplicationAssets_aggregate: ApplicationAsset_Aggregate;
  /** An array relationship */
  ApplicationNotes: Array<ActionNotes>;
  /** An aggregate relationship */
  ApplicationNotes_aggregate: ActionNotes_Aggregate;
  Approved: Scalars['bigint'];
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunities?: Maybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo: Scalars['String'];
  Goal?: Maybe<Scalars['String']>;
  HasOtherFunding?: Maybe<Scalars['Boolean']>;
  HelpWithPlanting?: Maybe<Scalars['Boolean']>;
  HoldOnMatch: Scalars['Boolean'];
  Id: Scalars['uuid'];
  /** A computed field, executes function "application_is_matched" */
  IsMatched?: Maybe<Scalars['Boolean']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandPermission?: Maybe<Scalars['Boolean']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LegalObligation?: Maybe<Scalars['Boolean']>;
  LocalBodies?: Maybe<Scalars['Boolean']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  /** A computed field, executes function "application_match_count" */
  Matched?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  Matches: Array<Match>;
  /** An aggregate relationship */
  Matches_aggregate: Match_Aggregate;
  Name: Scalars['String'];
  NumberOfSites: Scalars['bigint'];
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroups?: Maybe<Scalars['Boolean']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLand?: Maybe<Scalars['Boolean']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned: Scalars['bigint'];
  /** An object relationship */
  Planter?: Maybe<Planter>;
  PlanterId: Scalars['uuid'];
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  /** An array relationship */
  PlantingSites: Array<PlantingSite>;
  /** An aggregate relationship */
  PlantingSites_aggregate: PlantingSite_Aggregate;
  /** An array relationship */
  Plantings: Array<Planting>;
  /** An aggregate relationship */
  Plantings_aggregate: Planting_Aggregate;
  PreparedSite?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  Project?: Maybe<Project>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference: Scalars['bigint'];
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required: Scalars['bigint'];
  /** An object relationship */
  Season?: Maybe<Season>;
  SeasonId: Scalars['uuid'];
  SpeciesKnown?: Maybe<Scalars['Boolean']>;
  StockAccess?: Maybe<Scalars['Boolean']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  TermsAndConditions: Scalars['Boolean'];
  /** A computed field, executes function "application_unmatched_count" */
  Unmatched?: Maybe<Scalars['bigint']>;
  UpdatedOn: Scalars['timestamp'];
  WorkflowState: Scalars['String'];
};


/** columns and relationships of "Application" */
export type ApplicationApplicationAssetsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationApplicationAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationApplicationNotesArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationApplicationNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Application" */
export type ApplicationMatchesArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationMatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationPlantingSitesArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationPlantingSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationPlantingsArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


/** columns and relationships of "Application" */
export type ApplicationPlantings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};

/** columns and relationships of "ApplicationAsset" */
export type ApplicationAsset = {
  __typename?: 'ApplicationAsset';
  /** An object relationship */
  Application?: Maybe<Application>;
  Application_Id?: Maybe<Scalars['uuid']>;
  CreatedOn: Scalars['timestamp'];
  FileName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};

export enum ApplicationAssetType {
  MaintenancePlan = 'MaintenancePlan',
  Photo = 'Photo',
  SitePreparationAndPlantingPlan = 'SitePreparationAndPlantingPlan',
  SupportingDocument = 'SupportingDocument',
  Unknown = 'Unknown'
}

/** aggregated selection of "ApplicationAsset" */
export type ApplicationAsset_Aggregate = {
  __typename?: 'ApplicationAsset_aggregate';
  aggregate?: Maybe<ApplicationAsset_Aggregate_Fields>;
  nodes: Array<ApplicationAsset>;
};

export type ApplicationAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<ApplicationAsset_Aggregate_Bool_Exp_Count>;
};

export type ApplicationAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApplicationAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ApplicationAsset" */
export type ApplicationAsset_Aggregate_Fields = {
  __typename?: 'ApplicationAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ApplicationAsset_Max_Fields>;
  min?: Maybe<ApplicationAsset_Min_Fields>;
};


/** aggregate fields of "ApplicationAsset" */
export type ApplicationAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ApplicationAsset" */
export type ApplicationAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ApplicationAsset_Max_Order_By>;
  min?: InputMaybe<ApplicationAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ApplicationAsset" */
export type ApplicationAsset_Arr_Rel_Insert_Input = {
  data: Array<ApplicationAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ApplicationAsset". All fields are combined with a logical 'AND'. */
export type ApplicationAsset_Bool_Exp = {
  Application?: InputMaybe<Application_Bool_Exp>;
  Application_Id?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ApplicationAsset_Bool_Exp>>;
  _not?: InputMaybe<ApplicationAsset_Bool_Exp>;
  _or?: InputMaybe<Array<ApplicationAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "ApplicationAsset" */
export enum ApplicationAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ApplicationAssetPkey = 'ApplicationAsset_pkey'
}

/** input type for inserting data into table "ApplicationAsset" */
export type ApplicationAsset_Insert_Input = {
  Application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  Application_Id?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ApplicationAsset_Max_Fields = {
  __typename?: 'ApplicationAsset_max_fields';
  Application_Id?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ApplicationAsset" */
export type ApplicationAsset_Max_Order_By = {
  Application_Id?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ApplicationAsset_Min_Fields = {
  __typename?: 'ApplicationAsset_min_fields';
  Application_Id?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ApplicationAsset" */
export type ApplicationAsset_Min_Order_By = {
  Application_Id?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ApplicationAsset" */
export type ApplicationAsset_Mutation_Response = {
  __typename?: 'ApplicationAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationAsset>;
};

/** on_conflict condition type for table "ApplicationAsset" */
export type ApplicationAsset_On_Conflict = {
  constraint: ApplicationAsset_Constraint;
  update_columns?: Array<ApplicationAsset_Update_Column>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "ApplicationAsset". */
export type ApplicationAsset_Order_By = {
  Application?: InputMaybe<Application_Order_By>;
  Application_Id?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ApplicationAsset */
export type ApplicationAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ApplicationAsset" */
export enum ApplicationAsset_Select_Column {
  /** column name */
  ApplicationId = 'Application_Id',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "ApplicationAsset" */
export type ApplicationAsset_Set_Input = {
  Application_Id?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ApplicationAsset" */
export type ApplicationAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApplicationAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationAsset_Stream_Cursor_Value_Input = {
  Application_Id?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ApplicationAsset" */
export enum ApplicationAsset_Update_Column {
  /** column name */
  ApplicationId = 'Application_Id',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type ApplicationAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationAsset_Set_Input>;
  where: ApplicationAsset_Bool_Exp;
};

export type ApplicationSiteInput = {
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['String']>;
  LandCondition?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  LandConditionOther?: InputMaybe<Scalars['String']>;
  Landscape?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  LandscapeOther?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  OtherDetails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Species?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ApplicationView" */
export type ApplicationView = {
  __typename?: 'ApplicationView';
  AccessToPublic?: Maybe<Scalars['Boolean']>;
  AddingToCount?: Maybe<Scalars['Boolean']>;
  AgreeToMonitor?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  ApplicationAssets: Array<ApplicationAsset>;
  /** An aggregate relationship */
  ApplicationAssets_aggregate: ApplicationAsset_Aggregate;
  Approved?: Maybe<Scalars['bigint']>;
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunities?: Maybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Goal?: Maybe<Scalars['String']>;
  HasOtherFunding?: Maybe<Scalars['Boolean']>;
  HelpWithPlanting?: Maybe<Scalars['Boolean']>;
  HoldOnMatch?: Maybe<Scalars['Boolean']>;
  Id?: Maybe<Scalars['uuid']>;
  IsMatched?: Maybe<Scalars['Boolean']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandPermission?: Maybe<Scalars['Boolean']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LegalObligation?: Maybe<Scalars['Boolean']>;
  LocalBodies?: Maybe<Scalars['Boolean']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  MatchProgress?: Maybe<Scalars['numeric']>;
  Matched?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  Matches: Array<Match>;
  /** An aggregate relationship */
  Matches_aggregate: Match_Aggregate;
  Name?: Maybe<Scalars['String']>;
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroups?: Maybe<Scalars['Boolean']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLand?: Maybe<Scalars['Boolean']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  Planter?: Maybe<Planter>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Planting?: Maybe<Planting>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  PreparedSite?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  Project?: Maybe<Project>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  Season?: Maybe<Season>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SpeciesKnown?: Maybe<Scalars['Boolean']>;
  StockAccess?: Maybe<Scalars['Boolean']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  TermsAndConditions?: Maybe<Scalars['Boolean']>;
  Unmatched?: Maybe<Scalars['numeric']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ApplicationView" */
export type ApplicationViewApplicationAssetsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


/** columns and relationships of "ApplicationView" */
export type ApplicationViewApplicationAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


/** columns and relationships of "ApplicationView" */
export type ApplicationViewData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ApplicationView" */
export type ApplicationViewMatchesArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


/** columns and relationships of "ApplicationView" */
export type ApplicationViewMatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};

/** aggregated selection of "ApplicationView" */
export type ApplicationView_Aggregate = {
  __typename?: 'ApplicationView_aggregate';
  aggregate?: Maybe<ApplicationView_Aggregate_Fields>;
  nodes: Array<ApplicationView>;
};

/** aggregate fields of "ApplicationView" */
export type ApplicationView_Aggregate_Fields = {
  __typename?: 'ApplicationView_aggregate_fields';
  avg?: Maybe<ApplicationView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationView_Max_Fields>;
  min?: Maybe<ApplicationView_Min_Fields>;
  stddev?: Maybe<ApplicationView_Stddev_Fields>;
  stddev_pop?: Maybe<ApplicationView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ApplicationView_Stddev_Samp_Fields>;
  sum?: Maybe<ApplicationView_Sum_Fields>;
  var_pop?: Maybe<ApplicationView_Var_Pop_Fields>;
  var_samp?: Maybe<ApplicationView_Var_Samp_Fields>;
  variance?: Maybe<ApplicationView_Variance_Fields>;
};


/** aggregate fields of "ApplicationView" */
export type ApplicationView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ApplicationView_Avg_Fields = {
  __typename?: 'ApplicationView_avg_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ApplicationView". All fields are combined with a logical 'AND'. */
export type ApplicationView_Bool_Exp = {
  AccessToPublic?: InputMaybe<Boolean_Comparison_Exp>;
  AddingToCount?: InputMaybe<Boolean_Comparison_Exp>;
  AgreeToMonitor?: InputMaybe<Boolean_Comparison_Exp>;
  ApplicationAssets?: InputMaybe<ApplicationAsset_Bool_Exp>;
  ApplicationAssets_aggregate?: InputMaybe<ApplicationAsset_Aggregate_Bool_Exp>;
  Approved?: InputMaybe<Bigint_Comparison_Exp>;
  ApprovedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  Area?: InputMaybe<Numeric_Comparison_Exp>;
  AvailableActivities?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  DeclinedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  EmploymentOpportunities?: InputMaybe<Boolean_Comparison_Exp>;
  EmploymentOpportunitiesDesc?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Goal?: InputMaybe<String_Comparison_Exp>;
  HasOtherFunding?: InputMaybe<Boolean_Comparison_Exp>;
  HelpWithPlanting?: InputMaybe<Boolean_Comparison_Exp>;
  HoldOnMatch?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsMatched?: InputMaybe<Boolean_Comparison_Exp>;
  LandCondition?: InputMaybe<String_Comparison_Exp>;
  LandOwnership?: InputMaybe<String_Comparison_Exp>;
  LandPermission?: InputMaybe<Boolean_Comparison_Exp>;
  LandUse?: InputMaybe<String_Comparison_Exp>;
  LegacyState?: InputMaybe<String_Comparison_Exp>;
  LegalObligation?: InputMaybe<Boolean_Comparison_Exp>;
  LocalBodies?: InputMaybe<Boolean_Comparison_Exp>;
  LocalBodiesDesc?: InputMaybe<String_Comparison_Exp>;
  MaintainPlanting?: InputMaybe<String_Comparison_Exp>;
  MatchProgress?: InputMaybe<Numeric_Comparison_Exp>;
  Matched?: InputMaybe<Numeric_Comparison_Exp>;
  Matches?: InputMaybe<Match_Bool_Exp>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Bool_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OtherFunding?: InputMaybe<String_Comparison_Exp>;
  OtherGroups?: InputMaybe<Boolean_Comparison_Exp>;
  OtherGroupsDesc?: InputMaybe<String_Comparison_Exp>;
  OtherLand?: InputMaybe<Boolean_Comparison_Exp>;
  OtherLandArea?: InputMaybe<String_Comparison_Exp>;
  Planned?: InputMaybe<Bigint_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlanterRegistrationPlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  Planting?: InputMaybe<Planting_Bool_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingPlan?: InputMaybe<String_Comparison_Exp>;
  PreparedSite?: InputMaybe<Boolean_Comparison_Exp>;
  Project?: InputMaybe<Project_Bool_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Required?: InputMaybe<Bigint_Comparison_Exp>;
  Season?: InputMaybe<Season_Bool_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  SpeciesKnown?: InputMaybe<Boolean_Comparison_Exp>;
  StockAccess?: InputMaybe<Boolean_Comparison_Exp>;
  SubmittedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  TermsAndConditions?: InputMaybe<Boolean_Comparison_Exp>;
  Unmatched?: InputMaybe<Numeric_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ApplicationView_Bool_Exp>>;
  _not?: InputMaybe<ApplicationView_Bool_Exp>;
  _or?: InputMaybe<Array<ApplicationView_Bool_Exp>>;
};

/** aggregate max on columns */
export type ApplicationView_Max_Fields = {
  __typename?: 'ApplicationView_max_fields';
  Approved?: Maybe<Scalars['bigint']>;
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Goal?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  MatchProgress?: Maybe<Scalars['numeric']>;
  Matched?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required?: Maybe<Scalars['bigint']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  Unmatched?: Maybe<Scalars['numeric']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ApplicationView_Min_Fields = {
  __typename?: 'ApplicationView_min_fields';
  Approved?: Maybe<Scalars['bigint']>;
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Goal?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  MatchProgress?: Maybe<Scalars['numeric']>;
  Matched?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required?: Maybe<Scalars['bigint']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  Unmatched?: Maybe<Scalars['numeric']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "ApplicationView". */
export type ApplicationView_Order_By = {
  AccessToPublic?: InputMaybe<Order_By>;
  AddingToCount?: InputMaybe<Order_By>;
  AgreeToMonitor?: InputMaybe<Order_By>;
  ApplicationAssets_aggregate?: InputMaybe<ApplicationAsset_Aggregate_Order_By>;
  Approved?: InputMaybe<Order_By>;
  ApprovedAt?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  AvailableActivities?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  DeclinedAt?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  EmploymentOpportunities?: InputMaybe<Order_By>;
  EmploymentOpportunitiesDesc?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Goal?: InputMaybe<Order_By>;
  HasOtherFunding?: InputMaybe<Order_By>;
  HelpWithPlanting?: InputMaybe<Order_By>;
  HoldOnMatch?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsMatched?: InputMaybe<Order_By>;
  LandCondition?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandPermission?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LegacyState?: InputMaybe<Order_By>;
  LegalObligation?: InputMaybe<Order_By>;
  LocalBodies?: InputMaybe<Order_By>;
  LocalBodiesDesc?: InputMaybe<Order_By>;
  MaintainPlanting?: InputMaybe<Order_By>;
  MatchProgress?: InputMaybe<Order_By>;
  Matched?: InputMaybe<Order_By>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Order_By>;
  Name?: InputMaybe<Order_By>;
  OtherFunding?: InputMaybe<Order_By>;
  OtherGroups?: InputMaybe<Order_By>;
  OtherGroupsDesc?: InputMaybe<Order_By>;
  OtherLand?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlanterRegistrationPlantingId?: InputMaybe<Order_By>;
  Planting?: InputMaybe<Planting_Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  PlantingPlan?: InputMaybe<Order_By>;
  PreparedSite?: InputMaybe<Order_By>;
  Project?: InputMaybe<Project_Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
  Season?: InputMaybe<Season_Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  SpeciesKnown?: InputMaybe<Order_By>;
  StockAccess?: InputMaybe<Order_By>;
  SubmittedAt?: InputMaybe<Order_By>;
  TermsAndConditions?: InputMaybe<Order_By>;
  Unmatched?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** select columns of table "ApplicationView" */
export enum ApplicationView_Select_Column {
  /** column name */
  AccessToPublic = 'AccessToPublic',
  /** column name */
  AddingToCount = 'AddingToCount',
  /** column name */
  AgreeToMonitor = 'AgreeToMonitor',
  /** column name */
  Approved = 'Approved',
  /** column name */
  ApprovedAt = 'ApprovedAt',
  /** column name */
  Area = 'Area',
  /** column name */
  AvailableActivities = 'AvailableActivities',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeclinedAt = 'DeclinedAt',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  EmploymentOpportunities = 'EmploymentOpportunities',
  /** column name */
  EmploymentOpportunitiesDesc = 'EmploymentOpportunitiesDesc',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Goal = 'Goal',
  /** column name */
  HasOtherFunding = 'HasOtherFunding',
  /** column name */
  HelpWithPlanting = 'HelpWithPlanting',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  IsMatched = 'IsMatched',
  /** column name */
  LandCondition = 'LandCondition',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LegacyState = 'LegacyState',
  /** column name */
  LegalObligation = 'LegalObligation',
  /** column name */
  LocalBodies = 'LocalBodies',
  /** column name */
  LocalBodiesDesc = 'LocalBodiesDesc',
  /** column name */
  MaintainPlanting = 'MaintainPlanting',
  /** column name */
  MatchProgress = 'MatchProgress',
  /** column name */
  Matched = 'Matched',
  /** column name */
  Name = 'Name',
  /** column name */
  OtherFunding = 'OtherFunding',
  /** column name */
  OtherGroups = 'OtherGroups',
  /** column name */
  OtherGroupsDesc = 'OtherGroupsDesc',
  /** column name */
  OtherLand = 'OtherLand',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  Planned = 'Planned',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlanterRegistrationPlantingId = 'PlanterRegistrationPlantingId',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  PlantingPlan = 'PlantingPlan',
  /** column name */
  PreparedSite = 'PreparedSite',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  Required = 'Required',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  SpeciesKnown = 'SpeciesKnown',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  SubmittedAt = 'SubmittedAt',
  /** column name */
  TermsAndConditions = 'TermsAndConditions',
  /** column name */
  Unmatched = 'Unmatched',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** aggregate stddev on columns */
export type ApplicationView_Stddev_Fields = {
  __typename?: 'ApplicationView_stddev_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ApplicationView_Stddev_Pop_Fields = {
  __typename?: 'ApplicationView_stddev_pop_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ApplicationView_Stddev_Samp_Fields = {
  __typename?: 'ApplicationView_stddev_samp_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ApplicationView" */
export type ApplicationView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApplicationView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationView_Stream_Cursor_Value_Input = {
  AccessToPublic?: InputMaybe<Scalars['Boolean']>;
  AddingToCount?: InputMaybe<Scalars['Boolean']>;
  AgreeToMonitor?: InputMaybe<Scalars['Boolean']>;
  Approved?: InputMaybe<Scalars['bigint']>;
  ApprovedAt?: InputMaybe<Scalars['timestamp']>;
  Area?: InputMaybe<Scalars['numeric']>;
  AvailableActivities?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeclinedAt?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  EmploymentOpportunities?: InputMaybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Goal?: InputMaybe<Scalars['String']>;
  HasOtherFunding?: InputMaybe<Scalars['Boolean']>;
  HelpWithPlanting?: InputMaybe<Scalars['Boolean']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsMatched?: InputMaybe<Scalars['Boolean']>;
  LandCondition?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['String']>;
  LegacyState?: InputMaybe<Scalars['String']>;
  LegalObligation?: InputMaybe<Scalars['Boolean']>;
  LocalBodies?: InputMaybe<Scalars['Boolean']>;
  LocalBodiesDesc?: InputMaybe<Scalars['String']>;
  MaintainPlanting?: InputMaybe<Scalars['String']>;
  MatchProgress?: InputMaybe<Scalars['numeric']>;
  Matched?: InputMaybe<Scalars['numeric']>;
  Name?: InputMaybe<Scalars['String']>;
  OtherFunding?: InputMaybe<Scalars['String']>;
  OtherGroups?: InputMaybe<Scalars['Boolean']>;
  OtherGroupsDesc?: InputMaybe<Scalars['String']>;
  OtherLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  Planned?: InputMaybe<Scalars['bigint']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingPlan?: InputMaybe<Scalars['String']>;
  PreparedSite?: InputMaybe<Scalars['Boolean']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Required?: InputMaybe<Scalars['bigint']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  SpeciesKnown?: InputMaybe<Scalars['Boolean']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  SubmittedAt?: InputMaybe<Scalars['timestamp']>;
  TermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  Unmatched?: InputMaybe<Scalars['numeric']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ApplicationView_Sum_Fields = {
  __typename?: 'ApplicationView_sum_fields';
  Approved?: Maybe<Scalars['bigint']>;
  Area?: Maybe<Scalars['numeric']>;
  MatchProgress?: Maybe<Scalars['numeric']>;
  Matched?: Maybe<Scalars['numeric']>;
  Planned?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Required?: Maybe<Scalars['bigint']>;
  Unmatched?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type ApplicationView_Var_Pop_Fields = {
  __typename?: 'ApplicationView_var_pop_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ApplicationView_Var_Samp_Fields = {
  __typename?: 'ApplicationView_var_samp_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ApplicationView_Variance_Fields = {
  __typename?: 'ApplicationView_variance_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  MatchProgress?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Application" */
export type Application_Aggregate = {
  __typename?: 'Application_aggregate';
  aggregate?: Maybe<Application_Aggregate_Fields>;
  nodes: Array<Application>;
};

export type Application_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Application_Aggregate_Bool_Exp_Count>;
};

export type Application_Aggregate_Bool_Exp_Bool_And = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Application" */
export type Application_Aggregate_Fields = {
  __typename?: 'Application_aggregate_fields';
  avg?: Maybe<Application_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Application_Max_Fields>;
  min?: Maybe<Application_Min_Fields>;
  stddev?: Maybe<Application_Stddev_Fields>;
  stddev_pop?: Maybe<Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Application_Stddev_Samp_Fields>;
  sum?: Maybe<Application_Sum_Fields>;
  var_pop?: Maybe<Application_Var_Pop_Fields>;
  var_samp?: Maybe<Application_Var_Samp_Fields>;
  variance?: Maybe<Application_Variance_Fields>;
};


/** aggregate fields of "Application" */
export type Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Application" */
export type Application_Aggregate_Order_By = {
  avg?: InputMaybe<Application_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Max_Order_By>;
  min?: InputMaybe<Application_Min_Order_By>;
  stddev?: InputMaybe<Application_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Application_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Application_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Application_Sum_Order_By>;
  var_pop?: InputMaybe<Application_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Application_Var_Samp_Order_By>;
  variance?: InputMaybe<Application_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Application_Append_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "Application" */
export type Application_Arr_Rel_Insert_Input = {
  data: Array<Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** aggregate avg on columns */
export type Application_Avg_Fields = {
  __typename?: 'Application_avg_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Application" */
export type Application_Avg_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Application". All fields are combined with a logical 'AND'. */
export type Application_Bool_Exp = {
  AccessToPublic?: InputMaybe<Boolean_Comparison_Exp>;
  AddingToCount?: InputMaybe<Boolean_Comparison_Exp>;
  AgreeAssetUsage?: InputMaybe<Boolean_Comparison_Exp>;
  AgreeToMonitor?: InputMaybe<Boolean_Comparison_Exp>;
  AgreeToReport?: InputMaybe<Boolean_Comparison_Exp>;
  ApplicationAssets?: InputMaybe<ApplicationAsset_Bool_Exp>;
  ApplicationAssets_aggregate?: InputMaybe<ApplicationAsset_Aggregate_Bool_Exp>;
  ApplicationNotes?: InputMaybe<ActionNotes_Bool_Exp>;
  ApplicationNotes_aggregate?: InputMaybe<ActionNotes_Aggregate_Bool_Exp>;
  Approved?: InputMaybe<Bigint_Comparison_Exp>;
  ApprovedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  Area?: InputMaybe<Numeric_Comparison_Exp>;
  AvailableActivities?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  DeclinedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  EmploymentOpportunities?: InputMaybe<Boolean_Comparison_Exp>;
  EmploymentOpportunitiesDesc?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Goal?: InputMaybe<String_Comparison_Exp>;
  HasOtherFunding?: InputMaybe<Boolean_Comparison_Exp>;
  HelpWithPlanting?: InputMaybe<Boolean_Comparison_Exp>;
  HoldOnMatch?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsMatched?: InputMaybe<Boolean_Comparison_Exp>;
  LandCondition?: InputMaybe<String_Comparison_Exp>;
  LandOwnership?: InputMaybe<String_Comparison_Exp>;
  LandPermission?: InputMaybe<Boolean_Comparison_Exp>;
  LandUse?: InputMaybe<String_Comparison_Exp>;
  LegacyState?: InputMaybe<String_Comparison_Exp>;
  LegalObligation?: InputMaybe<Boolean_Comparison_Exp>;
  LocalBodies?: InputMaybe<Boolean_Comparison_Exp>;
  LocalBodiesDesc?: InputMaybe<String_Comparison_Exp>;
  MaintainPlanting?: InputMaybe<String_Comparison_Exp>;
  Matched?: InputMaybe<Bigint_Comparison_Exp>;
  Matches?: InputMaybe<Match_Bool_Exp>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Bool_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  NumberOfSites?: InputMaybe<Bigint_Comparison_Exp>;
  OtherFunding?: InputMaybe<String_Comparison_Exp>;
  OtherGroups?: InputMaybe<Boolean_Comparison_Exp>;
  OtherGroupsDesc?: InputMaybe<String_Comparison_Exp>;
  OtherLand?: InputMaybe<Boolean_Comparison_Exp>;
  OtherLandArea?: InputMaybe<String_Comparison_Exp>;
  Planned?: InputMaybe<Bigint_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlanterRegistrationPlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingPlan?: InputMaybe<String_Comparison_Exp>;
  PlantingSites?: InputMaybe<PlantingSite_Bool_Exp>;
  PlantingSites_aggregate?: InputMaybe<PlantingSite_Aggregate_Bool_Exp>;
  Plantings?: InputMaybe<Planting_Bool_Exp>;
  Plantings_aggregate?: InputMaybe<Planting_Aggregate_Bool_Exp>;
  PreparedSite?: InputMaybe<Boolean_Comparison_Exp>;
  Project?: InputMaybe<Project_Bool_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Required?: InputMaybe<Bigint_Comparison_Exp>;
  Season?: InputMaybe<Season_Bool_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  SpeciesKnown?: InputMaybe<Boolean_Comparison_Exp>;
  StockAccess?: InputMaybe<Boolean_Comparison_Exp>;
  SubmittedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  TermsAndConditions?: InputMaybe<Boolean_Comparison_Exp>;
  Unmatched?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Application_Bool_Exp>>;
  _not?: InputMaybe<Application_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Bool_Exp>>;
};

/** unique or primary key constraints on table "Application" */
export enum Application_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ApplicationPkey = 'Application_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Application_Delete_At_Path_Input = {
  Data_jsonb?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * delete the array element with specified index (negative integers count from the
 * end). throws an error if top level container is not an array
 */
export type Application_Delete_Elem_Input = {
  Data_jsonb?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Application_Delete_Key_Input = {
  Data_jsonb?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "Application" */
export type Application_Inc_Input = {
  Approved?: InputMaybe<Scalars['bigint']>;
  Area?: InputMaybe<Scalars['numeric']>;
  NumberOfSites?: InputMaybe<Scalars['bigint']>;
  Planned?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Required?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Application" */
export type Application_Insert_Input = {
  AccessToPublic?: InputMaybe<Scalars['Boolean']>;
  AddingToCount?: InputMaybe<Scalars['Boolean']>;
  AgreeAssetUsage?: InputMaybe<Scalars['Boolean']>;
  AgreeToMonitor?: InputMaybe<Scalars['Boolean']>;
  AgreeToReport?: InputMaybe<Scalars['Boolean']>;
  ApplicationAssets?: InputMaybe<ApplicationAsset_Arr_Rel_Insert_Input>;
  ApplicationNotes?: InputMaybe<ActionNotes_Arr_Rel_Insert_Input>;
  Approved?: InputMaybe<Scalars['bigint']>;
  ApprovedAt?: InputMaybe<Scalars['timestamp']>;
  Area?: InputMaybe<Scalars['numeric']>;
  AvailableActivities?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeclinedAt?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  EmploymentOpportunities?: InputMaybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Goal?: InputMaybe<Scalars['String']>;
  HasOtherFunding?: InputMaybe<Scalars['Boolean']>;
  HelpWithPlanting?: InputMaybe<Scalars['Boolean']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandCondition?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['String']>;
  LegacyState?: InputMaybe<Scalars['String']>;
  LegalObligation?: InputMaybe<Scalars['Boolean']>;
  LocalBodies?: InputMaybe<Scalars['Boolean']>;
  LocalBodiesDesc?: InputMaybe<Scalars['String']>;
  MaintainPlanting?: InputMaybe<Scalars['String']>;
  Matches?: InputMaybe<Match_Arr_Rel_Insert_Input>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfSites?: InputMaybe<Scalars['bigint']>;
  OtherFunding?: InputMaybe<Scalars['String']>;
  OtherGroups?: InputMaybe<Scalars['Boolean']>;
  OtherGroupsDesc?: InputMaybe<Scalars['String']>;
  OtherLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  Planned?: InputMaybe<Scalars['bigint']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingPlan?: InputMaybe<Scalars['String']>;
  PlantingSites?: InputMaybe<PlantingSite_Arr_Rel_Insert_Input>;
  Plantings?: InputMaybe<Planting_Arr_Rel_Insert_Input>;
  PreparedSite?: InputMaybe<Scalars['Boolean']>;
  Project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Required?: InputMaybe<Scalars['bigint']>;
  Season?: InputMaybe<Season_Obj_Rel_Insert_Input>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  SpeciesKnown?: InputMaybe<Scalars['Boolean']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  SubmittedAt?: InputMaybe<Scalars['timestamp']>;
  TermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Application_Max_Fields = {
  __typename?: 'Application_max_fields';
  Approved?: Maybe<Scalars['bigint']>;
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Goal?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfSites?: Maybe<Scalars['bigint']>;
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required?: Maybe<Scalars['bigint']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Application" */
export type Application_Max_Order_By = {
  Approved?: InputMaybe<Order_By>;
  ApprovedAt?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  AvailableActivities?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeclinedAt?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  EmploymentOpportunitiesDesc?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Goal?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandCondition?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LegacyState?: InputMaybe<Order_By>;
  LocalBodiesDesc?: InputMaybe<Order_By>;
  MaintainPlanting?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  OtherFunding?: InputMaybe<Order_By>;
  OtherGroupsDesc?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlanterRegistrationPlantingId?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  PlantingPlan?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  SubmittedAt?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Min_Fields = {
  __typename?: 'Application_min_fields';
  Approved?: Maybe<Scalars['bigint']>;
  ApprovedAt?: Maybe<Scalars['timestamp']>;
  Area?: Maybe<Scalars['numeric']>;
  AvailableActivities?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeclinedAt?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  EmploymentOpportunitiesDesc?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Goal?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandCondition?: Maybe<Scalars['String']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  LegacyState?: Maybe<Scalars['String']>;
  LocalBodiesDesc?: Maybe<Scalars['String']>;
  MaintainPlanting?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfSites?: Maybe<Scalars['bigint']>;
  OtherFunding?: Maybe<Scalars['String']>;
  OtherGroupsDesc?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  Planned?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PlantingPlan?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Required?: Maybe<Scalars['bigint']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SubmittedAt?: Maybe<Scalars['timestamp']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Application" */
export type Application_Min_Order_By = {
  Approved?: InputMaybe<Order_By>;
  ApprovedAt?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  AvailableActivities?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeclinedAt?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  EmploymentOpportunitiesDesc?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Goal?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandCondition?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LegacyState?: InputMaybe<Order_By>;
  LocalBodiesDesc?: InputMaybe<Order_By>;
  MaintainPlanting?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  OtherFunding?: InputMaybe<Order_By>;
  OtherGroupsDesc?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlanterRegistrationPlantingId?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  PlantingPlan?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  SubmittedAt?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Application" */
export type Application_Mutation_Response = {
  __typename?: 'Application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Application>;
};

/** input type for inserting object relation for remote table "Application" */
export type Application_Obj_Rel_Insert_Input = {
  data: Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** on_conflict condition type for table "Application" */
export type Application_On_Conflict = {
  constraint: Application_Constraint;
  update_columns?: Array<Application_Update_Column>;
  where?: InputMaybe<Application_Bool_Exp>;
};

/** Ordering options when selecting data from "Application". */
export type Application_Order_By = {
  AccessToPublic?: InputMaybe<Order_By>;
  AddingToCount?: InputMaybe<Order_By>;
  AgreeAssetUsage?: InputMaybe<Order_By>;
  AgreeToMonitor?: InputMaybe<Order_By>;
  AgreeToReport?: InputMaybe<Order_By>;
  ApplicationAssets_aggregate?: InputMaybe<ApplicationAsset_Aggregate_Order_By>;
  ApplicationNotes_aggregate?: InputMaybe<ActionNotes_Aggregate_Order_By>;
  Approved?: InputMaybe<Order_By>;
  ApprovedAt?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  AvailableActivities?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  DeclinedAt?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  EmploymentOpportunities?: InputMaybe<Order_By>;
  EmploymentOpportunitiesDesc?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Goal?: InputMaybe<Order_By>;
  HasOtherFunding?: InputMaybe<Order_By>;
  HelpWithPlanting?: InputMaybe<Order_By>;
  HoldOnMatch?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsMatched?: InputMaybe<Order_By>;
  LandCondition?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandPermission?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LegacyState?: InputMaybe<Order_By>;
  LegalObligation?: InputMaybe<Order_By>;
  LocalBodies?: InputMaybe<Order_By>;
  LocalBodiesDesc?: InputMaybe<Order_By>;
  MaintainPlanting?: InputMaybe<Order_By>;
  Matched?: InputMaybe<Order_By>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  OtherFunding?: InputMaybe<Order_By>;
  OtherGroups?: InputMaybe<Order_By>;
  OtherGroupsDesc?: InputMaybe<Order_By>;
  OtherLand?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlanterRegistrationPlantingId?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  PlantingPlan?: InputMaybe<Order_By>;
  PlantingSites_aggregate?: InputMaybe<PlantingSite_Aggregate_Order_By>;
  Plantings_aggregate?: InputMaybe<Planting_Aggregate_Order_By>;
  PreparedSite?: InputMaybe<Order_By>;
  Project?: InputMaybe<Project_Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
  Season?: InputMaybe<Season_Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  SpeciesKnown?: InputMaybe<Order_By>;
  StockAccess?: InputMaybe<Order_By>;
  SubmittedAt?: InputMaybe<Order_By>;
  TermsAndConditions?: InputMaybe<Order_By>;
  Unmatched?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Application */
export type Application_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Application_Prepend_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "Application" */
export enum Application_Select_Column {
  /** column name */
  AccessToPublic = 'AccessToPublic',
  /** column name */
  AddingToCount = 'AddingToCount',
  /** column name */
  AgreeAssetUsage = 'AgreeAssetUsage',
  /** column name */
  AgreeToMonitor = 'AgreeToMonitor',
  /** column name */
  AgreeToReport = 'AgreeToReport',
  /** column name */
  Approved = 'Approved',
  /** column name */
  ApprovedAt = 'ApprovedAt',
  /** column name */
  Area = 'Area',
  /** column name */
  AvailableActivities = 'AvailableActivities',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeclinedAt = 'DeclinedAt',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  EmploymentOpportunities = 'EmploymentOpportunities',
  /** column name */
  EmploymentOpportunitiesDesc = 'EmploymentOpportunitiesDesc',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Goal = 'Goal',
  /** column name */
  HasOtherFunding = 'HasOtherFunding',
  /** column name */
  HelpWithPlanting = 'HelpWithPlanting',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  LandCondition = 'LandCondition',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LegacyState = 'LegacyState',
  /** column name */
  LegalObligation = 'LegalObligation',
  /** column name */
  LocalBodies = 'LocalBodies',
  /** column name */
  LocalBodiesDesc = 'LocalBodiesDesc',
  /** column name */
  MaintainPlanting = 'MaintainPlanting',
  /** column name */
  Name = 'Name',
  /** column name */
  NumberOfSites = 'NumberOfSites',
  /** column name */
  OtherFunding = 'OtherFunding',
  /** column name */
  OtherGroups = 'OtherGroups',
  /** column name */
  OtherGroupsDesc = 'OtherGroupsDesc',
  /** column name */
  OtherLand = 'OtherLand',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  Planned = 'Planned',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlanterRegistrationPlantingId = 'PlanterRegistrationPlantingId',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  PlantingPlan = 'PlantingPlan',
  /** column name */
  PreparedSite = 'PreparedSite',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  Required = 'Required',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  SpeciesKnown = 'SpeciesKnown',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  SubmittedAt = 'SubmittedAt',
  /** column name */
  TermsAndConditions = 'TermsAndConditions',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** select "Application_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AccessToPublic = 'AccessToPublic',
  /** column name */
  AddingToCount = 'AddingToCount',
  /** column name */
  AgreeAssetUsage = 'AgreeAssetUsage',
  /** column name */
  AgreeToMonitor = 'AgreeToMonitor',
  /** column name */
  AgreeToReport = 'AgreeToReport',
  /** column name */
  EmploymentOpportunities = 'EmploymentOpportunities',
  /** column name */
  HasOtherFunding = 'HasOtherFunding',
  /** column name */
  HelpWithPlanting = 'HelpWithPlanting',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  LegalObligation = 'LegalObligation',
  /** column name */
  LocalBodies = 'LocalBodies',
  /** column name */
  OtherGroups = 'OtherGroups',
  /** column name */
  OtherLand = 'OtherLand',
  /** column name */
  PreparedSite = 'PreparedSite',
  /** column name */
  SpeciesKnown = 'SpeciesKnown',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  TermsAndConditions = 'TermsAndConditions'
}

/** select "Application_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AccessToPublic = 'AccessToPublic',
  /** column name */
  AddingToCount = 'AddingToCount',
  /** column name */
  AgreeAssetUsage = 'AgreeAssetUsage',
  /** column name */
  AgreeToMonitor = 'AgreeToMonitor',
  /** column name */
  AgreeToReport = 'AgreeToReport',
  /** column name */
  EmploymentOpportunities = 'EmploymentOpportunities',
  /** column name */
  HasOtherFunding = 'HasOtherFunding',
  /** column name */
  HelpWithPlanting = 'HelpWithPlanting',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  LegalObligation = 'LegalObligation',
  /** column name */
  LocalBodies = 'LocalBodies',
  /** column name */
  OtherGroups = 'OtherGroups',
  /** column name */
  OtherLand = 'OtherLand',
  /** column name */
  PreparedSite = 'PreparedSite',
  /** column name */
  SpeciesKnown = 'SpeciesKnown',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  TermsAndConditions = 'TermsAndConditions'
}

/** input type for updating data in table "Application" */
export type Application_Set_Input = {
  AccessToPublic?: InputMaybe<Scalars['Boolean']>;
  AddingToCount?: InputMaybe<Scalars['Boolean']>;
  AgreeAssetUsage?: InputMaybe<Scalars['Boolean']>;
  AgreeToMonitor?: InputMaybe<Scalars['Boolean']>;
  AgreeToReport?: InputMaybe<Scalars['Boolean']>;
  Approved?: InputMaybe<Scalars['bigint']>;
  ApprovedAt?: InputMaybe<Scalars['timestamp']>;
  Area?: InputMaybe<Scalars['numeric']>;
  AvailableActivities?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeclinedAt?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  EmploymentOpportunities?: InputMaybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Goal?: InputMaybe<Scalars['String']>;
  HasOtherFunding?: InputMaybe<Scalars['Boolean']>;
  HelpWithPlanting?: InputMaybe<Scalars['Boolean']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandCondition?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['String']>;
  LegacyState?: InputMaybe<Scalars['String']>;
  LegalObligation?: InputMaybe<Scalars['Boolean']>;
  LocalBodies?: InputMaybe<Scalars['Boolean']>;
  LocalBodiesDesc?: InputMaybe<Scalars['String']>;
  MaintainPlanting?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfSites?: InputMaybe<Scalars['bigint']>;
  OtherFunding?: InputMaybe<Scalars['String']>;
  OtherGroups?: InputMaybe<Scalars['Boolean']>;
  OtherGroupsDesc?: InputMaybe<Scalars['String']>;
  OtherLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  Planned?: InputMaybe<Scalars['bigint']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingPlan?: InputMaybe<Scalars['String']>;
  PreparedSite?: InputMaybe<Scalars['Boolean']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Required?: InputMaybe<Scalars['bigint']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  SpeciesKnown?: InputMaybe<Scalars['Boolean']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  SubmittedAt?: InputMaybe<Scalars['timestamp']>;
  TermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Application_Stddev_Fields = {
  __typename?: 'Application_stddev_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Application" */
export type Application_Stddev_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Application_Stddev_Pop_Fields = {
  __typename?: 'Application_stddev_pop_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Application" */
export type Application_Stddev_Pop_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Application_Stddev_Samp_Fields = {
  __typename?: 'Application_stddev_samp_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Application" */
export type Application_Stddev_Samp_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Application" */
export type Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Stream_Cursor_Value_Input = {
  AccessToPublic?: InputMaybe<Scalars['Boolean']>;
  AddingToCount?: InputMaybe<Scalars['Boolean']>;
  AgreeAssetUsage?: InputMaybe<Scalars['Boolean']>;
  AgreeToMonitor?: InputMaybe<Scalars['Boolean']>;
  AgreeToReport?: InputMaybe<Scalars['Boolean']>;
  Approved?: InputMaybe<Scalars['bigint']>;
  ApprovedAt?: InputMaybe<Scalars['timestamp']>;
  Area?: InputMaybe<Scalars['numeric']>;
  AvailableActivities?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeclinedAt?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  EmploymentOpportunities?: InputMaybe<Scalars['Boolean']>;
  EmploymentOpportunitiesDesc?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Goal?: InputMaybe<Scalars['String']>;
  HasOtherFunding?: InputMaybe<Scalars['Boolean']>;
  HelpWithPlanting?: InputMaybe<Scalars['Boolean']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandCondition?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['String']>;
  LegacyState?: InputMaybe<Scalars['String']>;
  LegalObligation?: InputMaybe<Scalars['Boolean']>;
  LocalBodies?: InputMaybe<Scalars['Boolean']>;
  LocalBodiesDesc?: InputMaybe<Scalars['String']>;
  MaintainPlanting?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfSites?: InputMaybe<Scalars['bigint']>;
  OtherFunding?: InputMaybe<Scalars['String']>;
  OtherGroups?: InputMaybe<Scalars['Boolean']>;
  OtherGroupsDesc?: InputMaybe<Scalars['String']>;
  OtherLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  Planned?: InputMaybe<Scalars['bigint']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationPlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PlantingPlan?: InputMaybe<Scalars['String']>;
  PreparedSite?: InputMaybe<Scalars['Boolean']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Required?: InputMaybe<Scalars['bigint']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  SpeciesKnown?: InputMaybe<Scalars['Boolean']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  SubmittedAt?: InputMaybe<Scalars['timestamp']>;
  TermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Application_Sum_Fields = {
  __typename?: 'Application_sum_fields';
  Approved?: Maybe<Scalars['bigint']>;
  Area?: Maybe<Scalars['numeric']>;
  NumberOfSites?: Maybe<Scalars['bigint']>;
  Planned?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Required?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Application" */
export type Application_Sum_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** update columns of table "Application" */
export enum Application_Update_Column {
  /** column name */
  AccessToPublic = 'AccessToPublic',
  /** column name */
  AddingToCount = 'AddingToCount',
  /** column name */
  AgreeAssetUsage = 'AgreeAssetUsage',
  /** column name */
  AgreeToMonitor = 'AgreeToMonitor',
  /** column name */
  AgreeToReport = 'AgreeToReport',
  /** column name */
  Approved = 'Approved',
  /** column name */
  ApprovedAt = 'ApprovedAt',
  /** column name */
  Area = 'Area',
  /** column name */
  AvailableActivities = 'AvailableActivities',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeclinedAt = 'DeclinedAt',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  EmploymentOpportunities = 'EmploymentOpportunities',
  /** column name */
  EmploymentOpportunitiesDesc = 'EmploymentOpportunitiesDesc',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Goal = 'Goal',
  /** column name */
  HasOtherFunding = 'HasOtherFunding',
  /** column name */
  HelpWithPlanting = 'HelpWithPlanting',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  LandCondition = 'LandCondition',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LegacyState = 'LegacyState',
  /** column name */
  LegalObligation = 'LegalObligation',
  /** column name */
  LocalBodies = 'LocalBodies',
  /** column name */
  LocalBodiesDesc = 'LocalBodiesDesc',
  /** column name */
  MaintainPlanting = 'MaintainPlanting',
  /** column name */
  Name = 'Name',
  /** column name */
  NumberOfSites = 'NumberOfSites',
  /** column name */
  OtherFunding = 'OtherFunding',
  /** column name */
  OtherGroups = 'OtherGroups',
  /** column name */
  OtherGroupsDesc = 'OtherGroupsDesc',
  /** column name */
  OtherLand = 'OtherLand',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  Planned = 'Planned',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlanterRegistrationPlantingId = 'PlanterRegistrationPlantingId',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  PlantingPlan = 'PlantingPlan',
  /** column name */
  PreparedSite = 'PreparedSite',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  Required = 'Required',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  SpeciesKnown = 'SpeciesKnown',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  SubmittedAt = 'SubmittedAt',
  /** column name */
  TermsAndConditions = 'TermsAndConditions',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  WorkflowState = 'WorkflowState'
}

export type Application_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Application_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  /**
   * delete the array element with specified index (negative integers count from
   * the end). throws an error if top level container is not an array
   */
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Application_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Application_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Application_Var_Pop_Fields = {
  __typename?: 'Application_var_pop_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Application" */
export type Application_Var_Pop_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Application_Var_Samp_Fields = {
  __typename?: 'Application_var_samp_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Application" */
export type Application_Var_Samp_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Application_Variance_Fields = {
  __typename?: 'Application_variance_fields';
  Approved?: Maybe<Scalars['Float']>;
  Area?: Maybe<Scalars['Float']>;
  NumberOfSites?: Maybe<Scalars['Float']>;
  Planned?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Required?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Application" */
export type Application_Variance_Order_By = {
  Approved?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  NumberOfSites?: InputMaybe<Order_By>;
  Planned?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Required?: InputMaybe<Order_By>;
};

/** columns and relationships of "ApprovedTreesView" */
export type ApprovedTreesView = {
  __typename?: 'ApprovedTreesView';
  AccountId?: Maybe<Scalars['uuid']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "ApprovedTreesView" */
export type ApprovedTreesView_Aggregate = {
  __typename?: 'ApprovedTreesView_aggregate';
  aggregate?: Maybe<ApprovedTreesView_Aggregate_Fields>;
  nodes: Array<ApprovedTreesView>;
};

/** aggregate fields of "ApprovedTreesView" */
export type ApprovedTreesView_Aggregate_Fields = {
  __typename?: 'ApprovedTreesView_aggregate_fields';
  avg?: Maybe<ApprovedTreesView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ApprovedTreesView_Max_Fields>;
  min?: Maybe<ApprovedTreesView_Min_Fields>;
  stddev?: Maybe<ApprovedTreesView_Stddev_Fields>;
  stddev_pop?: Maybe<ApprovedTreesView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ApprovedTreesView_Stddev_Samp_Fields>;
  sum?: Maybe<ApprovedTreesView_Sum_Fields>;
  var_pop?: Maybe<ApprovedTreesView_Var_Pop_Fields>;
  var_samp?: Maybe<ApprovedTreesView_Var_Samp_Fields>;
  variance?: Maybe<ApprovedTreesView_Variance_Fields>;
};


/** aggregate fields of "ApprovedTreesView" */
export type ApprovedTreesView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ApprovedTreesView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ApprovedTreesView_Avg_Fields = {
  __typename?: 'ApprovedTreesView_avg_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ApprovedTreesView". All fields are combined with a logical 'AND'. */
export type ApprovedTreesView_Bool_Exp = {
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  BeforeLastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  CurrentSeason?: InputMaybe<Numeric_Comparison_Exp>;
  LastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  TotalApproved?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<ApprovedTreesView_Bool_Exp>>;
  _not?: InputMaybe<ApprovedTreesView_Bool_Exp>;
  _or?: InputMaybe<Array<ApprovedTreesView_Bool_Exp>>;
};

/** aggregate max on columns */
export type ApprovedTreesView_Max_Fields = {
  __typename?: 'ApprovedTreesView_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type ApprovedTreesView_Min_Fields = {
  __typename?: 'ApprovedTreesView_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "ApprovedTreesView". */
export type ApprovedTreesView_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  BeforeLastSeason?: InputMaybe<Order_By>;
  CurrentSeason?: InputMaybe<Order_By>;
  LastSeason?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  TotalApproved?: InputMaybe<Order_By>;
};

/** select columns of table "ApprovedTreesView" */
export enum ApprovedTreesView_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  BeforeLastSeason = 'BeforeLastSeason',
  /** column name */
  CurrentSeason = 'CurrentSeason',
  /** column name */
  LastSeason = 'LastSeason',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  TotalApproved = 'TotalApproved'
}

/** aggregate stddev on columns */
export type ApprovedTreesView_Stddev_Fields = {
  __typename?: 'ApprovedTreesView_stddev_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ApprovedTreesView_Stddev_Pop_Fields = {
  __typename?: 'ApprovedTreesView_stddev_pop_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ApprovedTreesView_Stddev_Samp_Fields = {
  __typename?: 'ApprovedTreesView_stddev_samp_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ApprovedTreesView" */
export type ApprovedTreesView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ApprovedTreesView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ApprovedTreesView_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  BeforeLastSeason?: InputMaybe<Scalars['numeric']>;
  CurrentSeason?: InputMaybe<Scalars['numeric']>;
  LastSeason?: InputMaybe<Scalars['numeric']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  TotalApproved?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type ApprovedTreesView_Sum_Fields = {
  __typename?: 'ApprovedTreesView_sum_fields';
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  TotalApproved?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type ApprovedTreesView_Var_Pop_Fields = {
  __typename?: 'ApprovedTreesView_var_pop_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ApprovedTreesView_Var_Samp_Fields = {
  __typename?: 'ApprovedTreesView_var_samp_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ApprovedTreesView_Variance_Fields = {
  __typename?: 'ApprovedTreesView_variance_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  TotalApproved?: Maybe<Scalars['Float']>;
};

export enum AssetType {
  Avatar = 'Avatar',
  Banner = 'Banner',
  Image = 'Image',
  MaintenancePlan = 'MaintenancePlan',
  Photo = 'Photo',
  ProjectHero = 'ProjectHero',
  SitePreparationAndPlantingPlan = 'SitePreparationAndPlantingPlan',
  SupportingDocument = 'SupportingDocument',
  Unknown = 'Unknown',
  Video = 'Video'
}

/** columns and relationships of "Attachment" */
export type Attachment = {
  __typename?: 'Attachment';
  /** An object relationship */
  Account?: Maybe<Account>;
  Attempts: Scalars['Int'];
  CreatedOn: Scalars['timestamp'];
  EmailId?: Maybe<Scalars['uuid']>;
  Failed: Scalars['Boolean'];
  Filename?: Maybe<Scalars['String']>;
  Generated: Scalars['Boolean'];
  Id: Scalars['uuid'];
  Message?: Maybe<Scalars['String']>;
  /** An object relationship */
  Purchase?: Maybe<Purchase>;
  ReferenceId: Scalars['uuid'];
  SendEmail?: Maybe<Scalars['Boolean']>;
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
  Year?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "Attachment" */
export type Attachment_Aggregate = {
  __typename?: 'Attachment_aggregate';
  aggregate?: Maybe<Attachment_Aggregate_Fields>;
  nodes: Array<Attachment>;
};

export type Attachment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Attachment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Attachment_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Attachment_Aggregate_Bool_Exp_Count>;
};

export type Attachment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Attachment_Select_Column_Attachment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Attachment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Attachment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Attachment_Select_Column_Attachment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Attachment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Attachment" */
export type Attachment_Aggregate_Fields = {
  __typename?: 'Attachment_aggregate_fields';
  avg?: Maybe<Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Attachment_Max_Fields>;
  min?: Maybe<Attachment_Min_Fields>;
  stddev?: Maybe<Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Attachment_Sum_Fields>;
  var_pop?: Maybe<Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Attachment_Var_Samp_Fields>;
  variance?: Maybe<Attachment_Variance_Fields>;
};


/** aggregate fields of "Attachment" */
export type Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Attachment" */
export type Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Attachment_Max_Order_By>;
  min?: InputMaybe<Attachment_Min_Order_By>;
  stddev?: InputMaybe<Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Attachment" */
export type Attachment_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Attachment_Avg_Fields = {
  __typename?: 'Attachment_avg_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Attachment" */
export type Attachment_Avg_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Attachment". All fields are combined with a logical 'AND'. */
export type Attachment_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  Attempts?: InputMaybe<Int_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  EmailId?: InputMaybe<Uuid_Comparison_Exp>;
  Failed?: InputMaybe<Boolean_Comparison_Exp>;
  Filename?: InputMaybe<String_Comparison_Exp>;
  Generated?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  Purchase?: InputMaybe<Purchase_Bool_Exp>;
  ReferenceId?: InputMaybe<Uuid_Comparison_Exp>;
  SendEmail?: InputMaybe<Boolean_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Year?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Attachment_Bool_Exp>>;
  _not?: InputMaybe<Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Attachment_Bool_Exp>>;
};

/** unique or primary key constraints on table "Attachment" */
export enum Attachment_Constraint {
  /** unique or primary key constraint on columns "Id" */
  AttachmentPkey = 'Attachment_pkey'
}

/** input type for incrementing numeric columns in table "Attachment" */
export type Attachment_Inc_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Attachment" */
export type Attachment_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  Attempts?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  EmailId?: InputMaybe<Scalars['uuid']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  Filename?: InputMaybe<Scalars['String']>;
  Generated?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  Purchase?: InputMaybe<Purchase_Obj_Rel_Insert_Input>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  SendEmail?: InputMaybe<Scalars['Boolean']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Attachment_Max_Fields = {
  __typename?: 'Attachment_max_fields';
  Attempts?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  EmailId?: Maybe<Scalars['uuid']>;
  Filename?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "Attachment" */
export type Attachment_Max_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  EmailId?: InputMaybe<Order_By>;
  Filename?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Attachment_Min_Fields = {
  __typename?: 'Attachment_min_fields';
  Attempts?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  EmailId?: Maybe<Scalars['uuid']>;
  Filename?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "Attachment" */
export type Attachment_Min_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  EmailId?: InputMaybe<Order_By>;
  Filename?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Attachment" */
export type Attachment_Mutation_Response = {
  __typename?: 'Attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Attachment>;
};

/** on_conflict condition type for table "Attachment" */
export type Attachment_On_Conflict = {
  constraint: Attachment_Constraint;
  update_columns?: Array<Attachment_Update_Column>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "Attachment". */
export type Attachment_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  Attempts?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  EmailId?: InputMaybe<Order_By>;
  Failed?: InputMaybe<Order_By>;
  Filename?: InputMaybe<Order_By>;
  Generated?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  Purchase?: InputMaybe<Purchase_Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  SendEmail?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Attachment */
export type Attachment_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Attachment" */
export enum Attachment_Select_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  EmailId = 'EmailId',
  /** column name */
  Failed = 'Failed',
  /** column name */
  Filename = 'Filename',
  /** column name */
  Generated = 'Generated',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  SendEmail = 'SendEmail',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Year = 'Year'
}

/** select "Attachment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Attachment" */
export enum Attachment_Select_Column_Attachment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Failed = 'Failed',
  /** column name */
  Generated = 'Generated',
  /** column name */
  SendEmail = 'SendEmail'
}

/** select "Attachment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Attachment" */
export enum Attachment_Select_Column_Attachment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Failed = 'Failed',
  /** column name */
  Generated = 'Generated',
  /** column name */
  SendEmail = 'SendEmail'
}

/** input type for updating data in table "Attachment" */
export type Attachment_Set_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  EmailId?: InputMaybe<Scalars['uuid']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  Filename?: InputMaybe<Scalars['String']>;
  Generated?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  SendEmail?: InputMaybe<Scalars['Boolean']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Attachment_Stddev_Fields = {
  __typename?: 'Attachment_stddev_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Attachment" */
export type Attachment_Stddev_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Attachment_Stddev_Pop_Fields = {
  __typename?: 'Attachment_stddev_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Attachment" */
export type Attachment_Stddev_Pop_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Attachment_Stddev_Samp_Fields = {
  __typename?: 'Attachment_stddev_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Attachment" */
export type Attachment_Stddev_Samp_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Attachment" */
export type Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attachment_Stream_Cursor_Value_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  EmailId?: InputMaybe<Scalars['uuid']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  Filename?: InputMaybe<Scalars['String']>;
  Generated?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  SendEmail?: InputMaybe<Scalars['Boolean']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Attachment_Sum_Fields = {
  __typename?: 'Attachment_sum_fields';
  Attempts?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
  Year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "Attachment" */
export type Attachment_Sum_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "Attachment" (current role has no relevant permissions) */
export enum Attachment_Update_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  EmailId = 'EmailId',
  /** column name */
  Failed = 'Failed',
  /** column name */
  Filename = 'Filename',
  /** column name */
  Generated = 'Generated',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  SendEmail = 'SendEmail',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Year = 'Year',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attachment_Set_Input>;
  where: Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Attachment_Var_Pop_Fields = {
  __typename?: 'Attachment_var_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Attachment" */
export type Attachment_Var_Pop_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Attachment_Var_Samp_Fields = {
  __typename?: 'Attachment_var_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Attachment" */
export type Attachment_Var_Samp_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Attachment_Variance_Fields = {
  __typename?: 'Attachment_variance_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  Year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Attachment" */
export type Attachment_Variance_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Year?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "BulkRequest" */
export type BulkRequest = {
  __typename?: 'BulkRequest';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  Funder: Funder;
  FunderId: Scalars['uuid'];
  Id: Scalars['uuid'];
  OutputType: Scalars['Int'];
  ProductId: Scalars['uuid'];
  /** An array relationship */
  Purchase: Array<Purchase>;
  /** An aggregate relationship */
  Purchase_aggregate: Purchase_Aggregate;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Remarks?: Maybe<Scalars['String']>;
  State: Scalars['Int'];
  TemplateId: Scalars['uuid'];
  Token: Scalars['String'];
  TreePrice: Scalars['numeric'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "BulkRequest" */
export type BulkRequestPurchaseArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


/** columns and relationships of "BulkRequest" */
export type BulkRequestPurchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** columns and relationships of "BulkRequestLines" */
export type BulkRequestLines = {
  __typename?: 'BulkRequestLines';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  FromName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Message?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  RequestId: Scalars['uuid'];
  State: Scalars['Int'];
  ToEmail?: Maybe<Scalars['String']>;
  ToName?: Maybe<Scalars['String']>;
  Trees: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "BulkRequestLines" */
export type BulkRequestLines_Aggregate = {
  __typename?: 'BulkRequestLines_aggregate';
  aggregate?: Maybe<BulkRequestLines_Aggregate_Fields>;
  nodes: Array<BulkRequestLines>;
};

/** aggregate fields of "BulkRequestLines" */
export type BulkRequestLines_Aggregate_Fields = {
  __typename?: 'BulkRequestLines_aggregate_fields';
  avg?: Maybe<BulkRequestLines_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<BulkRequestLines_Max_Fields>;
  min?: Maybe<BulkRequestLines_Min_Fields>;
  stddev?: Maybe<BulkRequestLines_Stddev_Fields>;
  stddev_pop?: Maybe<BulkRequestLines_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BulkRequestLines_Stddev_Samp_Fields>;
  sum?: Maybe<BulkRequestLines_Sum_Fields>;
  var_pop?: Maybe<BulkRequestLines_Var_Pop_Fields>;
  var_samp?: Maybe<BulkRequestLines_Var_Samp_Fields>;
  variance?: Maybe<BulkRequestLines_Variance_Fields>;
};


/** aggregate fields of "BulkRequestLines" */
export type BulkRequestLines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BulkRequestLines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BulkRequestLines_Avg_Fields = {
  __typename?: 'BulkRequestLines_avg_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "BulkRequestLines". All fields are combined with a logical 'AND'. */
export type BulkRequestLines_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  FromName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  RequestId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  ToEmail?: InputMaybe<String_Comparison_Exp>;
  ToName?: InputMaybe<String_Comparison_Exp>;
  Trees?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<BulkRequestLines_Bool_Exp>>;
  _not?: InputMaybe<BulkRequestLines_Bool_Exp>;
  _or?: InputMaybe<Array<BulkRequestLines_Bool_Exp>>;
};

/** unique or primary key constraints on table "BulkRequestLines" */
export enum BulkRequestLines_Constraint {
  /** unique or primary key constraint on columns "Id" */
  BulkRequestLinesPkey = 'BulkRequestLines_pkey'
}

/** input type for incrementing numeric columns in table "BulkRequestLines" */
export type BulkRequestLines_Inc_Input = {
  State?: InputMaybe<Scalars['Int']>;
  Trees?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "BulkRequestLines" */
export type BulkRequestLines_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FromName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RequestId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  ToEmail?: InputMaybe<Scalars['String']>;
  ToName?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type BulkRequestLines_Max_Fields = {
  __typename?: 'BulkRequestLines_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  FromName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  RequestId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  ToEmail?: Maybe<Scalars['String']>;
  ToName?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type BulkRequestLines_Min_Fields = {
  __typename?: 'BulkRequestLines_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  FromName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  RequestId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  ToEmail?: Maybe<Scalars['String']>;
  ToName?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "BulkRequestLines" */
export type BulkRequestLines_Mutation_Response = {
  __typename?: 'BulkRequestLines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BulkRequestLines>;
};

/** on_conflict condition type for table "BulkRequestLines" */
export type BulkRequestLines_On_Conflict = {
  constraint: BulkRequestLines_Constraint;
  update_columns?: Array<BulkRequestLines_Update_Column>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};

/** Ordering options when selecting data from "BulkRequestLines". */
export type BulkRequestLines_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  FromName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  RequestId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  ToEmail?: InputMaybe<Order_By>;
  ToName?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: BulkRequestLines */
export type BulkRequestLines_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "BulkRequestLines" */
export enum BulkRequestLines_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  FromName = 'FromName',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  RequestId = 'RequestId',
  /** column name */
  State = 'State',
  /** column name */
  ToEmail = 'ToEmail',
  /** column name */
  ToName = 'ToName',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "BulkRequestLines" */
export type BulkRequestLines_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FromName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RequestId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  ToEmail?: InputMaybe<Scalars['String']>;
  ToName?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type BulkRequestLines_Stddev_Fields = {
  __typename?: 'BulkRequestLines_stddev_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BulkRequestLines_Stddev_Pop_Fields = {
  __typename?: 'BulkRequestLines_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BulkRequestLines_Stddev_Samp_Fields = {
  __typename?: 'BulkRequestLines_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BulkRequestLines" */
export type BulkRequestLines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BulkRequestLines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BulkRequestLines_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FromName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RequestId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  ToEmail?: InputMaybe<Scalars['String']>;
  ToName?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type BulkRequestLines_Sum_Fields = {
  __typename?: 'BulkRequestLines_sum_fields';
  State?: Maybe<Scalars['Int']>;
  Trees?: Maybe<Scalars['Int']>;
};

/** update columns of table "BulkRequestLines" */
export enum BulkRequestLines_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  FromName = 'FromName',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  RequestId = 'RequestId',
  /** column name */
  State = 'State',
  /** column name */
  ToEmail = 'ToEmail',
  /** column name */
  ToName = 'ToName',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type BulkRequestLines_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BulkRequestLines_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BulkRequestLines_Set_Input>;
  where: BulkRequestLines_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BulkRequestLines_Var_Pop_Fields = {
  __typename?: 'BulkRequestLines_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BulkRequestLines_Var_Samp_Fields = {
  __typename?: 'BulkRequestLines_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BulkRequestLines_Variance_Fields = {
  __typename?: 'BulkRequestLines_variance_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "BulkRequest" */
export type BulkRequest_Aggregate = {
  __typename?: 'BulkRequest_aggregate';
  aggregate?: Maybe<BulkRequest_Aggregate_Fields>;
  nodes: Array<BulkRequest>;
};

/** aggregate fields of "BulkRequest" */
export type BulkRequest_Aggregate_Fields = {
  __typename?: 'BulkRequest_aggregate_fields';
  avg?: Maybe<BulkRequest_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<BulkRequest_Max_Fields>;
  min?: Maybe<BulkRequest_Min_Fields>;
  stddev?: Maybe<BulkRequest_Stddev_Fields>;
  stddev_pop?: Maybe<BulkRequest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BulkRequest_Stddev_Samp_Fields>;
  sum?: Maybe<BulkRequest_Sum_Fields>;
  var_pop?: Maybe<BulkRequest_Var_Pop_Fields>;
  var_samp?: Maybe<BulkRequest_Var_Samp_Fields>;
  variance?: Maybe<BulkRequest_Variance_Fields>;
};


/** aggregate fields of "BulkRequest" */
export type BulkRequest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BulkRequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BulkRequest_Avg_Fields = {
  __typename?: 'BulkRequest_avg_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "BulkRequest". All fields are combined with a logical 'AND'. */
export type BulkRequest_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  OutputType?: InputMaybe<Int_Comparison_Exp>;
  ProductId?: InputMaybe<Uuid_Comparison_Exp>;
  Purchase?: InputMaybe<Purchase_Bool_Exp>;
  Purchase_aggregate?: InputMaybe<Purchase_Aggregate_Bool_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  Remarks?: InputMaybe<String_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  TemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  TreePrice?: InputMaybe<Numeric_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<BulkRequest_Bool_Exp>>;
  _not?: InputMaybe<BulkRequest_Bool_Exp>;
  _or?: InputMaybe<Array<BulkRequest_Bool_Exp>>;
};

/** unique or primary key constraints on table "BulkRequest" */
export enum BulkRequest_Constraint {
  /** unique or primary key constraint on columns "Id" */
  BulkRequestPkey = 'BulkRequest_pkey'
}

/** input type for incrementing numeric columns in table "BulkRequest" */
export type BulkRequest_Inc_Input = {
  OutputType?: InputMaybe<Scalars['Int']>;
  State?: InputMaybe<Scalars['Int']>;
  TreePrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "BulkRequest" */
export type BulkRequest_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  OutputType?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Purchase?: InputMaybe<Purchase_Arr_Rel_Insert_Input>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  Remarks?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  Token?: InputMaybe<Scalars['String']>;
  TreePrice?: InputMaybe<Scalars['numeric']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type BulkRequest_Max_Fields = {
  __typename?: 'BulkRequest_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  OutputType?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Remarks?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  TemplateId?: Maybe<Scalars['uuid']>;
  Token?: Maybe<Scalars['String']>;
  TreePrice?: Maybe<Scalars['numeric']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type BulkRequest_Min_Fields = {
  __typename?: 'BulkRequest_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  OutputType?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Remarks?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  TemplateId?: Maybe<Scalars['uuid']>;
  Token?: Maybe<Scalars['String']>;
  TreePrice?: Maybe<Scalars['numeric']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "BulkRequest" */
export type BulkRequest_Mutation_Response = {
  __typename?: 'BulkRequest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BulkRequest>;
};

/** on_conflict condition type for table "BulkRequest" */
export type BulkRequest_On_Conflict = {
  constraint: BulkRequest_Constraint;
  update_columns?: Array<BulkRequest_Update_Column>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};

/** Ordering options when selecting data from "BulkRequest". */
export type BulkRequest_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  OutputType?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Purchase_aggregate?: InputMaybe<Purchase_Aggregate_Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  Remarks?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  TemplateId?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  TreePrice?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: BulkRequest */
export type BulkRequest_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "BulkRequest" */
export enum BulkRequest_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  OutputType = 'OutputType',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  Remarks = 'Remarks',
  /** column name */
  State = 'State',
  /** column name */
  TemplateId = 'TemplateId',
  /** column name */
  Token = 'Token',
  /** column name */
  TreePrice = 'TreePrice',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "BulkRequest" */
export type BulkRequest_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  OutputType?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  Remarks?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  Token?: InputMaybe<Scalars['String']>;
  TreePrice?: InputMaybe<Scalars['numeric']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type BulkRequest_Stddev_Fields = {
  __typename?: 'BulkRequest_stddev_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BulkRequest_Stddev_Pop_Fields = {
  __typename?: 'BulkRequest_stddev_pop_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BulkRequest_Stddev_Samp_Fields = {
  __typename?: 'BulkRequest_stddev_samp_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "BulkRequest" */
export type BulkRequest_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BulkRequest_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BulkRequest_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  OutputType?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  Remarks?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  Token?: InputMaybe<Scalars['String']>;
  TreePrice?: InputMaybe<Scalars['numeric']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type BulkRequest_Sum_Fields = {
  __typename?: 'BulkRequest_sum_fields';
  OutputType?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['Int']>;
  TreePrice?: Maybe<Scalars['numeric']>;
};

/** update columns of table "BulkRequest" */
export enum BulkRequest_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  OutputType = 'OutputType',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  Remarks = 'Remarks',
  /** column name */
  State = 'State',
  /** column name */
  TemplateId = 'TemplateId',
  /** column name */
  Token = 'Token',
  /** column name */
  TreePrice = 'TreePrice',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type BulkRequest_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BulkRequest_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BulkRequest_Set_Input>;
  where: BulkRequest_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BulkRequest_Var_Pop_Fields = {
  __typename?: 'BulkRequest_var_pop_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BulkRequest_Var_Samp_Fields = {
  __typename?: 'BulkRequest_var_samp_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BulkRequest_Variance_Fields = {
  __typename?: 'BulkRequest_variance_fields';
  OutputType?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  TreePrice?: Maybe<Scalars['Float']>;
};

export type CancelSubscriptionInput = {
  Id: Scalars['String'];
  Reason: Scalars['String'];
};

export type CancelSubscriptionOutput = {
  __typename?: 'CancelSubscriptionOutput';
  Id: Scalars['String'];
};

export type Certification = {
  __typename?: 'Certification';
  Awarded: Scalars['Boolean'];
  CertificateType: Scalars['bigint'];
  Description: Scalars['String'];
  DownloadFilePath: Scalars['String'];
  Image: Scalars['String'];
  Name: Scalars['String'];
  SeasonName: Scalars['String'];
};

export type ChangeUserMembershipOutput = {
  __typename?: 'ChangeUserMembershipOutput';
  MembershipId: Scalars['uuid'];
  Role: Scalars['Int'];
  UserEmail: Scalars['String'];
};

export type ChangeUserMembershipTypeInput = {
  MembershipId: Scalars['uuid'];
  Role: Scalars['Int'];
};

/** columns and relationships of "ConfigAsset" */
export type ConfigAsset = {
  __typename?: 'ConfigAsset';
  Default?: Maybe<Scalars['String']>;
  Height: Scalars['Int'];
  Id: Scalars['uuid'];
  Name: Scalars['String'];
  Title: Scalars['String'];
  Width: Scalars['Int'];
};

/** aggregated selection of "ConfigAsset" */
export type ConfigAsset_Aggregate = {
  __typename?: 'ConfigAsset_aggregate';
  aggregate?: Maybe<ConfigAsset_Aggregate_Fields>;
  nodes: Array<ConfigAsset>;
};

/** aggregate fields of "ConfigAsset" */
export type ConfigAsset_Aggregate_Fields = {
  __typename?: 'ConfigAsset_aggregate_fields';
  avg?: Maybe<ConfigAsset_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ConfigAsset_Max_Fields>;
  min?: Maybe<ConfigAsset_Min_Fields>;
  stddev?: Maybe<ConfigAsset_Stddev_Fields>;
  stddev_pop?: Maybe<ConfigAsset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConfigAsset_Stddev_Samp_Fields>;
  sum?: Maybe<ConfigAsset_Sum_Fields>;
  var_pop?: Maybe<ConfigAsset_Var_Pop_Fields>;
  var_samp?: Maybe<ConfigAsset_Var_Samp_Fields>;
  variance?: Maybe<ConfigAsset_Variance_Fields>;
};


/** aggregate fields of "ConfigAsset" */
export type ConfigAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConfigAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ConfigAsset_Avg_Fields = {
  __typename?: 'ConfigAsset_avg_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ConfigAsset". All fields are combined with a logical 'AND'. */
export type ConfigAsset_Bool_Exp = {
  Default?: InputMaybe<String_Comparison_Exp>;
  Height?: InputMaybe<Int_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  Width?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<ConfigAsset_Bool_Exp>>;
  _not?: InputMaybe<ConfigAsset_Bool_Exp>;
  _or?: InputMaybe<Array<ConfigAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "ConfigAsset" */
export enum ConfigAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ConfigAssetPkey = 'ConfigAsset_pkey'
}

/** input type for incrementing numeric columns in table "ConfigAsset" */
export type ConfigAsset_Inc_Input = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ConfigAsset" */
export type ConfigAsset_Insert_Input = {
  Default?: InputMaybe<Scalars['String']>;
  Height?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Width?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ConfigAsset_Max_Fields = {
  __typename?: 'ConfigAsset_max_fields';
  Default?: Maybe<Scalars['String']>;
  Height?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ConfigAsset_Min_Fields = {
  __typename?: 'ConfigAsset_min_fields';
  Default?: Maybe<Scalars['String']>;
  Height?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ConfigAsset" */
export type ConfigAsset_Mutation_Response = {
  __typename?: 'ConfigAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigAsset>;
};

/** on_conflict condition type for table "ConfigAsset" */
export type ConfigAsset_On_Conflict = {
  constraint: ConfigAsset_Constraint;
  update_columns?: Array<ConfigAsset_Update_Column>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "ConfigAsset". */
export type ConfigAsset_Order_By = {
  Default?: InputMaybe<Order_By>;
  Height?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Title?: InputMaybe<Order_By>;
  Width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ConfigAsset */
export type ConfigAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ConfigAsset" */
export enum ConfigAsset_Select_Column {
  /** column name */
  Default = 'Default',
  /** column name */
  Height = 'Height',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Title = 'Title',
  /** column name */
  Width = 'Width'
}

/** input type for updating data in table "ConfigAsset" */
export type ConfigAsset_Set_Input = {
  Default?: InputMaybe<Scalars['String']>;
  Height?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Width?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ConfigAsset_Stddev_Fields = {
  __typename?: 'ConfigAsset_stddev_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ConfigAsset_Stddev_Pop_Fields = {
  __typename?: 'ConfigAsset_stddev_pop_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ConfigAsset_Stddev_Samp_Fields = {
  __typename?: 'ConfigAsset_stddev_samp_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ConfigAsset" */
export type ConfigAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConfigAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigAsset_Stream_Cursor_Value_Input = {
  Default?: InputMaybe<Scalars['String']>;
  Height?: InputMaybe<Scalars['Int']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  Width?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ConfigAsset_Sum_Fields = {
  __typename?: 'ConfigAsset_sum_fields';
  Height?: Maybe<Scalars['Int']>;
  Width?: Maybe<Scalars['Int']>;
};

/** update columns of table "ConfigAsset" */
export enum ConfigAsset_Update_Column {
  /** column name */
  Default = 'Default',
  /** column name */
  Height = 'Height',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Title = 'Title',
  /** column name */
  Width = 'Width'
}

export type ConfigAsset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConfigAsset_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigAsset_Set_Input>;
  where: ConfigAsset_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConfigAsset_Var_Pop_Fields = {
  __typename?: 'ConfigAsset_var_pop_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ConfigAsset_Var_Samp_Fields = {
  __typename?: 'ConfigAsset_var_samp_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ConfigAsset_Variance_Fields = {
  __typename?: 'ConfigAsset_variance_fields';
  Height?: Maybe<Scalars['Float']>;
  Width?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ConfigRedirect" */
export type ConfigRedirect = {
  __typename?: 'ConfigRedirect';
  Enabled: Scalars['Boolean'];
  Id: Scalars['uuid'];
  Name: Scalars['String'];
  Uri: Scalars['String'];
};

/** aggregated selection of "ConfigRedirect" */
export type ConfigRedirect_Aggregate = {
  __typename?: 'ConfigRedirect_aggregate';
  aggregate?: Maybe<ConfigRedirect_Aggregate_Fields>;
  nodes: Array<ConfigRedirect>;
};

/** aggregate fields of "ConfigRedirect" */
export type ConfigRedirect_Aggregate_Fields = {
  __typename?: 'ConfigRedirect_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ConfigRedirect_Max_Fields>;
  min?: Maybe<ConfigRedirect_Min_Fields>;
};


/** aggregate fields of "ConfigRedirect" */
export type ConfigRedirect_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConfigRedirect_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ConfigRedirect". All fields are combined with a logical 'AND'. */
export type ConfigRedirect_Bool_Exp = {
  Enabled?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ConfigRedirect_Bool_Exp>>;
  _not?: InputMaybe<ConfigRedirect_Bool_Exp>;
  _or?: InputMaybe<Array<ConfigRedirect_Bool_Exp>>;
};

/** unique or primary key constraints on table "ConfigRedirect" */
export enum ConfigRedirect_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ConfigRedirectPkey = 'ConfigRedirect_pkey'
}

/** input type for inserting data into table "ConfigRedirect" */
export type ConfigRedirect_Insert_Input = {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ConfigRedirect_Max_Fields = {
  __typename?: 'ConfigRedirect_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ConfigRedirect_Min_Fields = {
  __typename?: 'ConfigRedirect_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ConfigRedirect" */
export type ConfigRedirect_Mutation_Response = {
  __typename?: 'ConfigRedirect_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigRedirect>;
};

/** on_conflict condition type for table "ConfigRedirect" */
export type ConfigRedirect_On_Conflict = {
  constraint: ConfigRedirect_Constraint;
  update_columns?: Array<ConfigRedirect_Update_Column>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};

/** Ordering options when selecting data from "ConfigRedirect". */
export type ConfigRedirect_Order_By = {
  Enabled?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ConfigRedirect */
export type ConfigRedirect_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ConfigRedirect" */
export enum ConfigRedirect_Select_Column {
  /** column name */
  Enabled = 'Enabled',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "ConfigRedirect" */
export type ConfigRedirect_Set_Input = {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ConfigRedirect" */
export type ConfigRedirect_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConfigRedirect_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigRedirect_Stream_Cursor_Value_Input = {
  Enabled?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ConfigRedirect" */
export enum ConfigRedirect_Update_Column {
  /** column name */
  Enabled = 'Enabled',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Uri = 'Uri'
}

export type ConfigRedirect_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigRedirect_Set_Input>;
  where: ConfigRedirect_Bool_Exp;
};

export type CreateAccountAsset = {
  __typename?: 'CreateAccountAsset';
  Account?: Maybe<Account>;
  AccountId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreateAccountAssetInput = {
  AccountId: Scalars['String'];
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  Type: AccountAssetType;
};

export type CreateAccountInsertInput = {
  AccountActionType: Scalars['String'];
  BusinessSize?: InputMaybe<Scalars['String']>;
  BusinessType?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Email: Scalars['String'];
  FirstName?: InputMaybe<Scalars['String']>;
  FocusArea?: InputMaybe<Scalars['String']>;
  FunderHidden?: InputMaybe<Scalars['Boolean']>;
  FunderName?: InputMaybe<Scalars['String']>;
  GovType?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  OrgType?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  PlanterHidden?: InputMaybe<Scalars['Boolean']>;
  PlanterName?: InputMaybe<Scalars['String']>;
  SchoolType?: InputMaybe<Scalars['String']>;
  Sector?: InputMaybe<Scalars['String']>;
  Type: Scalars['String'];
  User: UserUpdateInput;
};

export type CreateAccountOutput = {
  __typename?: 'CreateAccountOutput';
  Id: Scalars['String'];
};

export type CreateAccountProfileInput = {
  accountId: Scalars['String'];
  profileType: Scalars['String'];
};

export type CreateAccountProfileOutput = {
  __typename?: 'CreateAccountProfileOutput';
  accountId: Scalars['String'];
  profileType: Scalars['String'];
};

export type CreateAccountsReportInput = {
  Role?: InputMaybe<AccountReportRole>;
  Type?: InputMaybe<AccountsReportType>;
};

export type CreateAccountsReportOutput = {
  __typename?: 'CreateAccountsReportOutput';
  Report?: Maybe<Report>;
  ReportId: Scalars['String'];
};

export type CreateAdminPaymentInput = {
  AccountId: Scalars['String'];
  Amount: Scalars['String'];
  InvoiceAddress: InvoiceAddress;
  IsPaid?: InputMaybe<Scalars['Boolean']>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  PricePerTree: Scalars['numeric'];
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  ReceiptEmail: Scalars['String'];
  ReceiptName: Scalars['String'];
  RegistryId?: InputMaybe<Scalars['String']>;
  SendInvoice?: InputMaybe<Scalars['Boolean']>;
  Total: Scalars['numeric'];
};

export type CreateAdminPaymentOutput = {
  __typename?: 'CreateAdminPaymentOutput';
  Purchase?: Maybe<Purchase>;
  PurchaseId: Scalars['String'];
};

export type CreateApplicationAssetInput = {
  ApplicationId: Scalars['String'];
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  Type: ApplicationAssetType;
};

export type CreateApplicationAssetOutput = {
  __typename?: 'CreateApplicationAssetOutput';
  ApplicationAsset?: Maybe<ApplicationAsset>;
  ApplicationAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreateApplicationMatchLine = {
  Id: Scalars['String'];
  Quantity: Scalars['bigint'];
};

export type CreateGiftGuestPaymentInput = {
  Amount: Scalars['String'];
  Gifts: Array<GiftInput>;
  GuestEmail: Scalars['String'];
  IsBulkGift?: InputMaybe<Scalars['Boolean']>;
  PaymentMethod?: InputMaybe<Scalars['String']>;
  PublicMessage: Scalars['String'];
  PublicName?: InputMaybe<Scalars['String']>;
  RecaptchaToken: Scalars['String'];
  ReceiptName: Scalars['String'];
};

export type CreateGiftGuestPaymentOutput = {
  __typename?: 'CreateGiftGuestPaymentOutput';
  Hash?: Maybe<Scalars['String']>;
  PaymentIntentClientSecret?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['String']>;
  Token?: Maybe<Scalars['String']>;
};

export type CreateGiftPaymentInput = {
  Amount: Scalars['String'];
  Gifts: Array<GiftInput>;
  InvoiceAddress?: InputMaybe<InvoiceAddress>;
  IsBulkGift: Scalars['Boolean'];
  PaymentMethod?: InputMaybe<Scalars['String']>;
  PublicMessage: Scalars['String'];
  PublicName?: InputMaybe<Scalars['String']>;
  ReceiptEmail: Scalars['String'];
  ReceiptName: Scalars['String'];
  SavePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

export type CreateGiftPaymentOutput = {
  __typename?: 'CreateGiftPaymentOutput';
  Hash?: Maybe<Scalars['String']>;
  PaymentIntentClientSecret?: Maybe<Scalars['String']>;
  Purchase?: Maybe<Purchase>;
  PurchaseId?: Maybe<Scalars['String']>;
  Token?: Maybe<Scalars['String']>;
};

export type CreateGuestPaymentInput = {
  Amount: Scalars['String'];
  GuestEmail: Scalars['String'];
  IsRecurring?: InputMaybe<Scalars['Boolean']>;
  PaymentMethod?: InputMaybe<Scalars['String']>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  RecaptchaToken: Scalars['String'];
  ReceiptName: Scalars['String'];
  RegistryId?: InputMaybe<Scalars['String']>;
};

export type CreateGuestPaymentOutput = {
  __typename?: 'CreateGuestPaymentOutput';
  Hash?: Maybe<Scalars['String']>;
  PaymentIntentClientSecret?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['String']>;
  SubscriptionId?: Maybe<Scalars['String']>;
  Token?: Maybe<Scalars['String']>;
};

export type CreateInstructionMatchLine = {
  Id: Scalars['String'];
  Quantity: Scalars['bigint'];
};

export type CreateMatchFromApplicationInput = {
  ApplicationId: Scalars['String'];
  MatchLines: Array<CreateApplicationMatchLine>;
};

export type CreateMatchFromApplicationOutput = {
  __typename?: 'CreateMatchFromApplicationOutput';
  ApplicationId: Scalars['String'];
};

export type CreateMatchFromInstructionInput = {
  InstructionId: Scalars['String'];
  MatchLines: Array<CreateInstructionMatchLine>;
};

export type CreateMatchFromInstructionOutput = {
  __typename?: 'CreateMatchFromInstructionOutput';
  Instruction?: Maybe<Instruction>;
  InstructionId: Scalars['String'];
  InstructionView?: Maybe<InstructionView>;
};

export type CreateMonitoringAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  MonitoringEventId: Scalars['String'];
  Type: AssetType;
};

export type CreateMonitoringAssetOutput = {
  __typename?: 'CreateMonitoringAssetOutput';
  MonitoringAsset?: Maybe<MonitoringAsset>;
  MonitoringAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreatePaymentInput = {
  Amount: Scalars['String'];
  InvoiceAddress?: InputMaybe<InvoiceAddress>;
  IsRecurring?: InputMaybe<Scalars['Boolean']>;
  PaymentMethod?: InputMaybe<Scalars['String']>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  ReceiptEmail: Scalars['String'];
  ReceiptName: Scalars['String'];
  RegistryId?: InputMaybe<Scalars['String']>;
  SavePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

export type CreatePaymentOutput = {
  __typename?: 'CreatePaymentOutput';
  Hash?: Maybe<Scalars['String']>;
  PaymentIntentClientSecret?: Maybe<Scalars['String']>;
  Purchase?: Maybe<Purchase>;
  PurchaseId?: Maybe<Scalars['String']>;
  SubscriptionId?: Maybe<Scalars['String']>;
  Token?: Maybe<Scalars['String']>;
};

export type CreatePlanterRegistrationAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  PlanterRegistrationId: Scalars['String'];
  Type: AssetType;
};

export type CreatePlanterRegistrationAssetOutput = {
  __typename?: 'CreatePlanterRegistrationAssetOutput';
  PlanterRegistrationAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreatePlanterRegistrationInsertInput = {
  Description?: InputMaybe<Scalars['String']>;
  MonitoringDescription?: InputMaybe<Scalars['String']>;
  NumberOfTrees?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

export type CreatePlanterRegistrationOutput = {
  __typename?: 'CreatePlanterRegistrationOutput';
  Id: Scalars['uuid'];
  PlanterRegistration?: Maybe<PlanterRegistration>;
};

export type CreatePlantingAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  PlantingId: Scalars['String'];
  Type: AssetType;
};

export type CreatePlantingAssetOutput = {
  __typename?: 'CreatePlantingAssetOutput';
  PlantingAsset?: Maybe<PlantingAsset>;
  PlantingAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreatePlantingBigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

export type CreatePlantingInput = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  Data?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Photo?: InputMaybe<Scalars['String']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingLines?: InputMaybe<CreatePlantingPlantinglineArrRelInsertInput>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['String']>;
  SeasonId: Scalars['String'];
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
  WorkflowState: Scalars['String'];
};

export type CreatePlantingOutput = {
  __typename?: 'CreatePlantingOutput';
  Id: Scalars['String'];
  Planting?: Maybe<Planting>;
};

export type CreatePlantingPlantinglineArrRelInsertInput = {
  data: Array<CreatePlantingPlantinglineInsertInput>;
  on_conflict?: InputMaybe<CreatePlantingPlantinglineOnConflict>;
};

export type CreatePlantingPlantinglineBoolExp = {
  Id?: InputMaybe<CreatePlantingStringComparisonExp>;
  PlantingId?: InputMaybe<CreatePlantingStringComparisonExp>;
  Quantity?: InputMaybe<CreatePlantingBigintComparisonExp>;
  SpeciesId?: InputMaybe<CreatePlantingStringComparisonExp>;
  _and?: InputMaybe<Array<CreatePlantingPlantinglineBoolExp>>;
  _not?: InputMaybe<CreatePlantingPlantinglineBoolExp>;
  _or?: InputMaybe<Array<CreatePlantingPlantinglineBoolExp>>;
};

export enum CreatePlantingPlantinglineConstraint {
  /** unique or primary key constraint */
  PlantingLinePkey = 'PlantingLine_pkey'
}

export type CreatePlantingPlantinglineInsertInput = {
  Id?: InputMaybe<Scalars['String']>;
  OtherSpeciesName?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  SpeciesId: Scalars['String'];
};

export type CreatePlantingPlantinglineOnConflict = {
  constraint: CreatePlantingPlantinglineConstraint;
  update_columns: Array<CreatePlantingPlantinglineUpdateColumn>;
  where?: InputMaybe<CreatePlantingPlantinglineBoolExp>;
};

export enum CreatePlantingPlantinglineUpdateColumn {
  /** column name */
  Id = 'Id',
  /** column name */
  OtherSpeciesName = 'OtherSpeciesName',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

export type CreatePlantingSiteAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  PlantingSiteId: Scalars['String'];
  Type: PlantingSiteAssetType;
};

export type CreatePlantingSiteAssetOutput = {
  __typename?: 'CreatePlantingSiteAssetOutput';
  PlantingSiteAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreatePlantingStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  _niregex?: InputMaybe<Scalars['String']>;
  _nlike?: InputMaybe<Scalars['String']>;
  _nregex?: InputMaybe<Scalars['String']>;
  _nsimilar?: InputMaybe<Scalars['String']>;
  _regex?: InputMaybe<Scalars['String']>;
  _similar?: InputMaybe<Scalars['String']>;
};

export type CreateProjectAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  ProjectId: Scalars['String'];
  Type: AssetType;
};

export type CreateProjectAssetOutput = {
  __typename?: 'CreateProjectAssetOutput';
  ProjectAsset?: Maybe<ProjectAsset>;
  ProjectAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreateProjectHeroInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  ProjectId: Scalars['String'];
  Type: ProjectAssetType;
};

export type CreateProjectHeroOutput = {
  __typename?: 'CreateProjectHeroOutput';
  ProjectId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreateProjectInput = {
  Area: Scalars['String'];
  Description: Scalars['String'];
  DistrictId?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  RegionId?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

export type CreateProjectNoteAssetInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  ProjectNoteId: Scalars['String'];
  Type: ProjectNoteAssetType;
};

export type CreateProjectNoteAssetOutput = {
  __typename?: 'CreateProjectNoteAssetOutput';
  ProjectNoteAssetId: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type CreateProjectOutput = {
  __typename?: 'CreateProjectOutput';
  Id: Scalars['String'];
};

export type CreatePurchasesReportInput = {
  FromDate?: InputMaybe<Scalars['timestamp']>;
  InvoiceAddress?: InputMaybe<InvoiceAddress>;
  State?: InputMaybe<PurchaseReportState>;
  ToDate?: InputMaybe<Scalars['timestamp']>;
  Type?: InputMaybe<PurchaseReportType>;
};

export type CreatePurchasesReportOutput = {
  __typename?: 'CreatePurchasesReportOutput';
  Report?: Maybe<Report>;
  ReportId: Scalars['String'];
};

export type CreateRegistryInput = {
  AccountId?: InputMaybe<Scalars['String']>;
  ClosesOn?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  IsCampaign?: InputMaybe<Scalars['Boolean']>;
  IsClosed?: InputMaybe<Scalars['Boolean']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  RegionId?: InputMaybe<Scalars['String']>;
  Summary?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryOutput = {
  __typename?: 'CreateRegistryOutput';
  Id: Scalars['String'];
  Registry?: Maybe<Registry>;
};

export type CreateTreePoolReportInput = {
  Season?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<TreePoolReportState>;
  Type: TreePoolReportType;
};

export type CreateTreePoolReportOutput = {
  __typename?: 'CreateTreePoolReportOutput';
  Report?: Maybe<Report>;
  ReportId: Scalars['String'];
};

export type DeclineInviteInput = {
  Code: Scalars['String'];
};

export type DeclineInviteOutput = {
  __typename?: 'DeclineInviteOutput';
  Id: Scalars['String'];
  Status: Scalars['String'];
};

export type DeleteMatchesInput = {
  MatchIds: Array<Scalars['String']>;
};

export type DeleteMatchesOutput = {
  __typename?: 'DeleteMatchesOutput';
  MatchIds: Array<Scalars['String']>;
  TreeEventIds: Array<Scalars['String']>;
};

export type DeleteProjectByIdInput = {
  ProjectId: Scalars['String'];
  Reason: Scalars['String'];
};

export type DeleteProjectByIdOutput = {
  __typename?: 'DeleteProjectByIdOutput';
  ProjectId: Scalars['String'];
};

export type DeleteRegistryWithNoGiftsInput = {
  registryId: Scalars['uuid'];
};

export type DeleteRegistryWithNoGiftsOutput = {
  __typename?: 'DeleteRegistryWithNoGiftsOutput';
  afffectedRows: Scalars['numeric'];
};

export type DeleteUserMembershipInput = {
  MembershipId: Scalars['uuid'];
};

export type DeleteUserMembershipOutput = {
  __typename?: 'DeleteUserMembershipOutput';
  Membership?: Maybe<Membership>;
  MembershipId: Scalars['uuid'];
};

/** columns and relationships of "District" */
export type District = {
  __typename?: 'District';
  Id: Scalars['uuid'];
  Lookups?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  ProperSpelling?: Maybe<Scalars['String']>;
  /** An array relationship */
  RegionDistricts: Array<RegionDistrict>;
  /** An aggregate relationship */
  RegionDistricts_aggregate: RegionDistrict_Aggregate;
};


/** columns and relationships of "District" */
export type DistrictRegionDistrictsArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


/** columns and relationships of "District" */
export type DistrictRegionDistricts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};

/** aggregated selection of "District" */
export type District_Aggregate = {
  __typename?: 'District_aggregate';
  aggregate?: Maybe<District_Aggregate_Fields>;
  nodes: Array<District>;
};

/** aggregate fields of "District" */
export type District_Aggregate_Fields = {
  __typename?: 'District_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<District_Max_Fields>;
  min?: Maybe<District_Min_Fields>;
};


/** aggregate fields of "District" */
export type District_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<District_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "District". All fields are combined with a logical 'AND'. */
export type District_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Lookups?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  ProperSpelling?: InputMaybe<String_Comparison_Exp>;
  RegionDistricts?: InputMaybe<RegionDistrict_Bool_Exp>;
  RegionDistricts_aggregate?: InputMaybe<RegionDistrict_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<District_Bool_Exp>>;
  _not?: InputMaybe<District_Bool_Exp>;
  _or?: InputMaybe<Array<District_Bool_Exp>>;
};

/** unique or primary key constraints on table "District" */
export enum District_Constraint {
  /** unique or primary key constraint on columns "Id" */
  DistrictPkey = 'District_pkey'
}

/** input type for inserting data into table "District" */
export type District_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
  RegionDistricts?: InputMaybe<RegionDistrict_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type District_Max_Fields = {
  __typename?: 'District_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  Lookups?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProperSpelling?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type District_Min_Fields = {
  __typename?: 'District_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  Lookups?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProperSpelling?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "District" */
export type District_Mutation_Response = {
  __typename?: 'District_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<District>;
};

/** input type for inserting object relation for remote table "District" */
export type District_Obj_Rel_Insert_Input = {
  data: District_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<District_On_Conflict>;
};

/** on_conflict condition type for table "District" */
export type District_On_Conflict = {
  constraint: District_Constraint;
  update_columns?: Array<District_Update_Column>;
  where?: InputMaybe<District_Bool_Exp>;
};

/** Ordering options when selecting data from "District". */
export type District_Order_By = {
  Id?: InputMaybe<Order_By>;
  Lookups?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ProperSpelling?: InputMaybe<Order_By>;
  RegionDistricts_aggregate?: InputMaybe<RegionDistrict_Aggregate_Order_By>;
};

/** primary key columns input for table: District */
export type District_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "District" */
export enum District_Select_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  Lookups = 'Lookups',
  /** column name */
  Name = 'Name',
  /** column name */
  ProperSpelling = 'ProperSpelling'
}

/** input type for updating data in table "District" */
export type District_Set_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "District" */
export type District_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: District_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type District_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
};

/** update columns of table "District" */
export enum District_Update_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  Lookups = 'Lookups',
  /** column name */
  Name = 'Name',
  /** column name */
  ProperSpelling = 'ProperSpelling'
}

export type District_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<District_Set_Input>;
  where: District_Bool_Exp;
};

/** columns and relationships of "Email" */
export type Email = {
  __typename?: 'Email';
  Attempts: Scalars['Int'];
  Bcc?: Maybe<Scalars['String']>;
  Cc?: Maybe<Scalars['String']>;
  Content: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  Delivered: Scalars['Boolean'];
  Failed: Scalars['Boolean'];
  From: Scalars['String'];
  Headers?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Message?: Maybe<Scalars['String']>;
  ReplyTo?: Maybe<Scalars['String']>;
  Subject: Scalars['String'];
  To?: Maybe<Scalars['String']>;
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "Email" */
export type Email_Aggregate = {
  __typename?: 'Email_aggregate';
  aggregate?: Maybe<Email_Aggregate_Fields>;
  nodes: Array<Email>;
};

/** aggregate fields of "Email" */
export type Email_Aggregate_Fields = {
  __typename?: 'Email_aggregate_fields';
  avg?: Maybe<Email_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Email_Max_Fields>;
  min?: Maybe<Email_Min_Fields>;
  stddev?: Maybe<Email_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Sum_Fields>;
  var_pop?: Maybe<Email_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Var_Samp_Fields>;
  variance?: Maybe<Email_Variance_Fields>;
};


/** aggregate fields of "Email" */
export type Email_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Email_Avg_Fields = {
  __typename?: 'Email_avg_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Email". All fields are combined with a logical 'AND'. */
export type Email_Bool_Exp = {
  Attempts?: InputMaybe<Int_Comparison_Exp>;
  Bcc?: InputMaybe<String_Comparison_Exp>;
  Cc?: InputMaybe<String_Comparison_Exp>;
  Content?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Delivered?: InputMaybe<Boolean_Comparison_Exp>;
  Failed?: InputMaybe<Boolean_Comparison_Exp>;
  From?: InputMaybe<String_Comparison_Exp>;
  Headers?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  ReplyTo?: InputMaybe<String_Comparison_Exp>;
  Subject?: InputMaybe<String_Comparison_Exp>;
  To?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Email_Bool_Exp>>;
  _not?: InputMaybe<Email_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Bool_Exp>>;
};

/** unique or primary key constraints on table "Email" */
export enum Email_Constraint {
  /** unique or primary key constraint on columns "Id" */
  EmailPkey = 'Email_pkey'
}

/** input type for incrementing numeric columns in table "Email" */
export type Email_Inc_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Email" */
export type Email_Insert_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  Bcc?: InputMaybe<Scalars['String']>;
  Cc?: InputMaybe<Scalars['String']>;
  Content?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Delivered?: InputMaybe<Scalars['Boolean']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  From?: InputMaybe<Scalars['String']>;
  Headers?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  ReplyTo?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  To?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Email_Max_Fields = {
  __typename?: 'Email_max_fields';
  Attempts?: Maybe<Scalars['Int']>;
  Bcc?: Maybe<Scalars['String']>;
  Cc?: Maybe<Scalars['String']>;
  Content?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  From?: Maybe<Scalars['String']>;
  Headers?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  ReplyTo?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  To?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Email_Min_Fields = {
  __typename?: 'Email_min_fields';
  Attempts?: Maybe<Scalars['Int']>;
  Bcc?: Maybe<Scalars['String']>;
  Cc?: Maybe<Scalars['String']>;
  Content?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  From?: Maybe<Scalars['String']>;
  Headers?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  ReplyTo?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  To?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Email" */
export type Email_Mutation_Response = {
  __typename?: 'Email_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email>;
};

/** on_conflict condition type for table "Email" */
export type Email_On_Conflict = {
  constraint: Email_Constraint;
  update_columns?: Array<Email_Update_Column>;
  where?: InputMaybe<Email_Bool_Exp>;
};

/** Ordering options when selecting data from "Email". */
export type Email_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  Bcc?: InputMaybe<Order_By>;
  Cc?: InputMaybe<Order_By>;
  Content?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Delivered?: InputMaybe<Order_By>;
  Failed?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  Headers?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  ReplyTo?: InputMaybe<Order_By>;
  Subject?: InputMaybe<Order_By>;
  To?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Email */
export type Email_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Email" */
export enum Email_Select_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  Bcc = 'Bcc',
  /** column name */
  Cc = 'Cc',
  /** column name */
  Content = 'Content',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Delivered = 'Delivered',
  /** column name */
  Failed = 'Failed',
  /** column name */
  From = 'From',
  /** column name */
  Headers = 'Headers',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  ReplyTo = 'ReplyTo',
  /** column name */
  Subject = 'Subject',
  /** column name */
  To = 'To',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Email" */
export type Email_Set_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  Bcc?: InputMaybe<Scalars['String']>;
  Cc?: InputMaybe<Scalars['String']>;
  Content?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Delivered?: InputMaybe<Scalars['Boolean']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  From?: InputMaybe<Scalars['String']>;
  Headers?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  ReplyTo?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  To?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Email_Stddev_Fields = {
  __typename?: 'Email_stddev_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Email_Stddev_Pop_Fields = {
  __typename?: 'Email_stddev_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Email_Stddev_Samp_Fields = {
  __typename?: 'Email_stddev_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Email" */
export type Email_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Stream_Cursor_Value_Input = {
  Attempts?: InputMaybe<Scalars['Int']>;
  Bcc?: InputMaybe<Scalars['String']>;
  Cc?: InputMaybe<Scalars['String']>;
  Content?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Delivered?: InputMaybe<Scalars['Boolean']>;
  Failed?: InputMaybe<Scalars['Boolean']>;
  From?: InputMaybe<Scalars['String']>;
  Headers?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  ReplyTo?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  To?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Email_Sum_Fields = {
  __typename?: 'Email_sum_fields';
  Attempts?: Maybe<Scalars['Int']>;
};

/** update columns of table "Email" */
export enum Email_Update_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  Bcc = 'Bcc',
  /** column name */
  Cc = 'Cc',
  /** column name */
  Content = 'Content',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Delivered = 'Delivered',
  /** column name */
  Failed = 'Failed',
  /** column name */
  From = 'From',
  /** column name */
  Headers = 'Headers',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  ReplyTo = 'ReplyTo',
  /** column name */
  Subject = 'Subject',
  /** column name */
  To = 'To',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Email_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Set_Input>;
  where: Email_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Var_Pop_Fields = {
  __typename?: 'Email_var_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Email_Var_Samp_Fields = {
  __typename?: 'Email_var_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Email_Variance_Fields = {
  __typename?: 'Email_variance_fields';
  Attempts?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "EventPermission" */
export type EventPermission = {
  __typename?: 'EventPermission';
  Address: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  ExpiresOn?: Maybe<Scalars['timestamp']>;
  Id: Scalars['uuid'];
  IsActive: Scalars['Boolean'];
  IsPermanent: Scalars['Boolean'];
  Remark?: Maybe<Scalars['String']>;
  State: Scalars['smallint'];
  Type: Scalars['smallint'];
};

/** aggregated selection of "EventPermission" */
export type EventPermission_Aggregate = {
  __typename?: 'EventPermission_aggregate';
  aggregate?: Maybe<EventPermission_Aggregate_Fields>;
  nodes: Array<EventPermission>;
};

/** aggregate fields of "EventPermission" */
export type EventPermission_Aggregate_Fields = {
  __typename?: 'EventPermission_aggregate_fields';
  avg?: Maybe<EventPermission_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EventPermission_Max_Fields>;
  min?: Maybe<EventPermission_Min_Fields>;
  stddev?: Maybe<EventPermission_Stddev_Fields>;
  stddev_pop?: Maybe<EventPermission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventPermission_Stddev_Samp_Fields>;
  sum?: Maybe<EventPermission_Sum_Fields>;
  var_pop?: Maybe<EventPermission_Var_Pop_Fields>;
  var_samp?: Maybe<EventPermission_Var_Samp_Fields>;
  variance?: Maybe<EventPermission_Variance_Fields>;
};


/** aggregate fields of "EventPermission" */
export type EventPermission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventPermission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventPermission_Avg_Fields = {
  __typename?: 'EventPermission_avg_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "EventPermission". All fields are combined with a logical 'AND'. */
export type EventPermission_Bool_Exp = {
  Address?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  ExpiresOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsActive?: InputMaybe<Boolean_Comparison_Exp>;
  IsPermanent?: InputMaybe<Boolean_Comparison_Exp>;
  Remark?: InputMaybe<String_Comparison_Exp>;
  State?: InputMaybe<Smallint_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  _and?: InputMaybe<Array<EventPermission_Bool_Exp>>;
  _not?: InputMaybe<EventPermission_Bool_Exp>;
  _or?: InputMaybe<Array<EventPermission_Bool_Exp>>;
};

/** unique or primary key constraints on table "EventPermission" */
export enum EventPermission_Constraint {
  /** unique or primary key constraint on columns "Id" */
  EventPermissionPkey = 'EventPermission_pkey'
}

/** input type for incrementing numeric columns in table "EventPermission" */
export type EventPermission_Inc_Input = {
  State?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "EventPermission" */
export type EventPermission_Insert_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsPermanent?: InputMaybe<Scalars['Boolean']>;
  Remark?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type EventPermission_Max_Fields = {
  __typename?: 'EventPermission_max_fields';
  Address?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ExpiresOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Remark?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** aggregate min on columns */
export type EventPermission_Min_Fields = {
  __typename?: 'EventPermission_min_fields';
  Address?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ExpiresOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Remark?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** response of any mutation on the table "EventPermission" */
export type EventPermission_Mutation_Response = {
  __typename?: 'EventPermission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPermission>;
};

/** on_conflict condition type for table "EventPermission" */
export type EventPermission_On_Conflict = {
  constraint: EventPermission_Constraint;
  update_columns?: Array<EventPermission_Update_Column>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};

/** Ordering options when selecting data from "EventPermission". */
export type EventPermission_Order_By = {
  Address?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ExpiresOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsActive?: InputMaybe<Order_By>;
  IsPermanent?: InputMaybe<Order_By>;
  Remark?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: EventPermission */
export type EventPermission_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "EventPermission" */
export enum EventPermission_Select_Column {
  /** column name */
  Address = 'Address',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ExpiresOn = 'ExpiresOn',
  /** column name */
  Id = 'Id',
  /** column name */
  IsActive = 'IsActive',
  /** column name */
  IsPermanent = 'IsPermanent',
  /** column name */
  Remark = 'Remark',
  /** column name */
  State = 'State',
  /** column name */
  Type = 'Type'
}

/** input type for updating data in table "EventPermission" */
export type EventPermission_Set_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsPermanent?: InputMaybe<Scalars['Boolean']>;
  Remark?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type EventPermission_Stddev_Fields = {
  __typename?: 'EventPermission_stddev_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventPermission_Stddev_Pop_Fields = {
  __typename?: 'EventPermission_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventPermission_Stddev_Samp_Fields = {
  __typename?: 'EventPermission_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "EventPermission" */
export type EventPermission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventPermission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPermission_Stream_Cursor_Value_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsActive?: InputMaybe<Scalars['Boolean']>;
  IsPermanent?: InputMaybe<Scalars['Boolean']>;
  Remark?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type EventPermission_Sum_Fields = {
  __typename?: 'EventPermission_sum_fields';
  State?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "EventPermission" */
export enum EventPermission_Update_Column {
  /** column name */
  Address = 'Address',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ExpiresOn = 'ExpiresOn',
  /** column name */
  Id = 'Id',
  /** column name */
  IsActive = 'IsActive',
  /** column name */
  IsPermanent = 'IsPermanent',
  /** column name */
  Remark = 'Remark',
  /** column name */
  State = 'State',
  /** column name */
  Type = 'Type'
}

export type EventPermission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventPermission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPermission_Set_Input>;
  where: EventPermission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventPermission_Var_Pop_Fields = {
  __typename?: 'EventPermission_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventPermission_Var_Samp_Fields = {
  __typename?: 'EventPermission_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventPermission_Variance_Fields = {
  __typename?: 'EventPermission_variance_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "FundedTree" */
export type FundedTree = {
  __typename?: 'FundedTree';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  FunderId: Scalars['uuid'];
  Id: Scalars['uuid'];
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId: Scalars['uuid'];
  State: Scalars['Int'];
  SupporterId?: Maybe<Scalars['uuid']>;
  Trees: Scalars['bigint'];
  UpdatedOn: Scalars['timestamp'];
  UserId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "FundedTree" */
export type FundedTree_Aggregate = {
  __typename?: 'FundedTree_aggregate';
  aggregate?: Maybe<FundedTree_Aggregate_Fields>;
  nodes: Array<FundedTree>;
};

/** aggregate fields of "FundedTree" */
export type FundedTree_Aggregate_Fields = {
  __typename?: 'FundedTree_aggregate_fields';
  avg?: Maybe<FundedTree_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FundedTree_Max_Fields>;
  min?: Maybe<FundedTree_Min_Fields>;
  stddev?: Maybe<FundedTree_Stddev_Fields>;
  stddev_pop?: Maybe<FundedTree_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FundedTree_Stddev_Samp_Fields>;
  sum?: Maybe<FundedTree_Sum_Fields>;
  var_pop?: Maybe<FundedTree_Var_Pop_Fields>;
  var_samp?: Maybe<FundedTree_Var_Samp_Fields>;
  variance?: Maybe<FundedTree_Variance_Fields>;
};


/** aggregate fields of "FundedTree" */
export type FundedTree_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FundedTree_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FundedTree_Avg_Fields = {
  __typename?: 'FundedTree_avg_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "FundedTree". All fields are combined with a logical 'AND'. */
export type FundedTree_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  SupporterId?: InputMaybe<Uuid_Comparison_Exp>;
  Trees?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  UserId?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FundedTree_Bool_Exp>>;
  _not?: InputMaybe<FundedTree_Bool_Exp>;
  _or?: InputMaybe<Array<FundedTree_Bool_Exp>>;
};

/** unique or primary key constraints on table "FundedTree" */
export enum FundedTree_Constraint {
  /** unique or primary key constraint on columns "Id" */
  FundedTreePkey = 'FundedTree_pkey'
}

/** input type for incrementing numeric columns in table "FundedTree" */
export type FundedTree_Inc_Input = {
  State?: InputMaybe<Scalars['Int']>;
  Trees?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "FundedTree" */
export type FundedTree_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FundedTree_Max_Fields = {
  __typename?: 'FundedTree_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Trees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FundedTree_Min_Fields = {
  __typename?: 'FundedTree_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Trees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "FundedTree" */
export type FundedTree_Mutation_Response = {
  __typename?: 'FundedTree_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FundedTree>;
};

/** on_conflict condition type for table "FundedTree" */
export type FundedTree_On_Conflict = {
  constraint: FundedTree_Constraint;
  update_columns?: Array<FundedTree_Update_Column>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};

/** Ordering options when selecting data from "FundedTree". */
export type FundedTree_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: FundedTree */
export type FundedTree_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "FundedTree" */
export enum FundedTree_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  State = 'State',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

/** input type for updating data in table "FundedTree" */
export type FundedTree_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FundedTree_Stddev_Fields = {
  __typename?: 'FundedTree_stddev_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FundedTree_Stddev_Pop_Fields = {
  __typename?: 'FundedTree_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FundedTree_Stddev_Samp_Fields = {
  __typename?: 'FundedTree_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FundedTree" */
export type FundedTree_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FundedTree_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FundedTree_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FundedTree_Sum_Fields = {
  __typename?: 'FundedTree_sum_fields';
  State?: Maybe<Scalars['Int']>;
  Trees?: Maybe<Scalars['bigint']>;
};

/** update columns of table "FundedTree" */
export enum FundedTree_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  State = 'State',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

export type FundedTree_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FundedTree_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FundedTree_Set_Input>;
  where: FundedTree_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FundedTree_Var_Pop_Fields = {
  __typename?: 'FundedTree_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FundedTree_Var_Samp_Fields = {
  __typename?: 'FundedTree_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FundedTree_Variance_Fields = {
  __typename?: 'FundedTree_variance_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Funder" */
export type Funder = {
  __typename?: 'Funder';
  /** An object relationship */
  Account?: Maybe<Account>;
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  /** An array relationship */
  Instruction: Array<Instruction>;
  /** An aggregate relationship */
  Instruction_aggregate: Instruction_Aggregate;
  IsHidden: Scalars['Boolean'];
  Name?: Maybe<Scalars['String']>;
  OwnerId: Scalars['uuid'];
  OwnerType: Scalars['smallint'];
  /** An array relationship */
  Subscriptions: Array<Subscription>;
  /** An aggregate relationship */
  Subscriptions_aggregate: Subscription_Aggregate;
  Type: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "Funder" */
export type FunderInstructionArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


/** columns and relationships of "Funder" */
export type FunderInstruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


/** columns and relationships of "Funder" */
export type FunderSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "Funder" */
export type FunderSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};

/** Placeholder table containing columns returned for the FunderStats function */
export type FunderStat = {
  __typename?: 'FunderStat';
  AccountYearJoined: Scalars['bigint'];
  PlantersSupported: Scalars['bigint'];
  ProjectSupported: Scalars['bigint'];
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName: Scalars['String'];
  TreesFunded: Scalars['bigint'];
};

/** aggregated selection of "FunderStat" */
export type FunderStat_Aggregate = {
  __typename?: 'FunderStat_aggregate';
  aggregate?: Maybe<FunderStat_Aggregate_Fields>;
  nodes: Array<FunderStat>;
};

/** aggregate fields of "FunderStat" */
export type FunderStat_Aggregate_Fields = {
  __typename?: 'FunderStat_aggregate_fields';
  avg?: Maybe<FunderStat_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FunderStat_Max_Fields>;
  min?: Maybe<FunderStat_Min_Fields>;
  stddev?: Maybe<FunderStat_Stddev_Fields>;
  stddev_pop?: Maybe<FunderStat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FunderStat_Stddev_Samp_Fields>;
  sum?: Maybe<FunderStat_Sum_Fields>;
  var_pop?: Maybe<FunderStat_Var_Pop_Fields>;
  var_samp?: Maybe<FunderStat_Var_Samp_Fields>;
  variance?: Maybe<FunderStat_Variance_Fields>;
};


/** aggregate fields of "FunderStat" */
export type FunderStat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FunderStat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FunderStat_Avg_Fields = {
  __typename?: 'FunderStat_avg_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "FunderStat". All fields are combined with a logical 'AND'. */
export type FunderStat_Bool_Exp = {
  AccountYearJoined?: InputMaybe<Bigint_Comparison_Exp>;
  PlantersSupported?: InputMaybe<Bigint_Comparison_Exp>;
  ProjectSupported?: InputMaybe<Bigint_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  TreesFunded?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<FunderStat_Bool_Exp>>;
  _not?: InputMaybe<FunderStat_Bool_Exp>;
  _or?: InputMaybe<Array<FunderStat_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "FunderStat" */
export type FunderStat_Inc_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "FunderStat" */
export type FunderStat_Insert_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type FunderStat_Max_Fields = {
  __typename?: 'FunderStat_max_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type FunderStat_Min_Fields = {
  __typename?: 'FunderStat_min_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "FunderStat" */
export type FunderStat_Mutation_Response = {
  __typename?: 'FunderStat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FunderStat>;
};

/** Ordering options when selecting data from "FunderStat". */
export type FunderStat_Order_By = {
  AccountYearJoined?: InputMaybe<Order_By>;
  PlantersSupported?: InputMaybe<Order_By>;
  ProjectSupported?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  TreesFunded?: InputMaybe<Order_By>;
};

/** select columns of table "FunderStat" */
export enum FunderStat_Select_Column {
  /** column name */
  AccountYearJoined = 'AccountYearJoined',
  /** column name */
  PlantersSupported = 'PlantersSupported',
  /** column name */
  ProjectSupported = 'ProjectSupported',
  /** column name */
  Rank = 'Rank',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  TreesFunded = 'TreesFunded'
}

/** input type for updating data in table "FunderStat" */
export type FunderStat_Set_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type FunderStat_Stddev_Fields = {
  __typename?: 'FunderStat_stddev_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FunderStat_Stddev_Pop_Fields = {
  __typename?: 'FunderStat_stddev_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FunderStat_Stddev_Samp_Fields = {
  __typename?: 'FunderStat_stddev_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FunderStat" */
export type FunderStat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FunderStat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FunderStat_Stream_Cursor_Value_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type FunderStat_Sum_Fields = {
  __typename?: 'FunderStat_sum_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

export type FunderStat_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FunderStat_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FunderStat_Set_Input>;
  where: FunderStat_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FunderStat_Var_Pop_Fields = {
  __typename?: 'FunderStat_var_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FunderStat_Var_Samp_Fields = {
  __typename?: 'FunderStat_var_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FunderStat_Variance_Fields = {
  __typename?: 'FunderStat_variance_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "FunderView" */
export type FunderView = {
  __typename?: 'FunderView';
  AccountName?: Maybe<Scalars['String']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  IsHidden?: Maybe<Scalars['Boolean']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  PlanterCount?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalCount?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "FunderView" */
export type FunderView_Aggregate = {
  __typename?: 'FunderView_aggregate';
  aggregate?: Maybe<FunderView_Aggregate_Fields>;
  nodes: Array<FunderView>;
};

/** aggregate fields of "FunderView" */
export type FunderView_Aggregate_Fields = {
  __typename?: 'FunderView_aggregate_fields';
  avg?: Maybe<FunderView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<FunderView_Max_Fields>;
  min?: Maybe<FunderView_Min_Fields>;
  stddev?: Maybe<FunderView_Stddev_Fields>;
  stddev_pop?: Maybe<FunderView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FunderView_Stddev_Samp_Fields>;
  sum?: Maybe<FunderView_Sum_Fields>;
  var_pop?: Maybe<FunderView_Var_Pop_Fields>;
  var_samp?: Maybe<FunderView_Var_Samp_Fields>;
  variance?: Maybe<FunderView_Variance_Fields>;
};


/** aggregate fields of "FunderView" */
export type FunderView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FunderView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FunderView_Avg_Fields = {
  __typename?: 'FunderView_avg_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "FunderView". All fields are combined with a logical 'AND'. */
export type FunderView_Bool_Exp = {
  AccountName?: InputMaybe<String_Comparison_Exp>;
  Avatar?: InputMaybe<String_Comparison_Exp>;
  BeforeLastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  CurrentSeason?: InputMaybe<Numeric_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  LastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  PlanterCount?: InputMaybe<Bigint_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  TotalCount?: InputMaybe<Numeric_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<FunderView_Bool_Exp>>;
  _not?: InputMaybe<FunderView_Bool_Exp>;
  _or?: InputMaybe<Array<FunderView_Bool_Exp>>;
};

/** aggregate max on columns */
export type FunderView_Max_Fields = {
  __typename?: 'FunderView_max_fields';
  AccountName?: Maybe<Scalars['String']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  PlanterCount?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalCount?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FunderView_Min_Fields = {
  __typename?: 'FunderView_min_fields';
  AccountName?: Maybe<Scalars['String']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  PlanterCount?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalCount?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "FunderView". */
export type FunderView_Order_By = {
  AccountName?: InputMaybe<Order_By>;
  Avatar?: InputMaybe<Order_By>;
  BeforeLastSeason?: InputMaybe<Order_By>;
  CurrentSeason?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  LastSeason?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PlanterCount?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  TotalCount?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "FunderView" */
export enum FunderView_Select_Column {
  /** column name */
  AccountName = 'AccountName',
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  BeforeLastSeason = 'BeforeLastSeason',
  /** column name */
  CurrentSeason = 'CurrentSeason',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  LastSeason = 'LastSeason',
  /** column name */
  Name = 'Name',
  /** column name */
  PlanterCount = 'PlanterCount',
  /** column name */
  Rank = 'Rank',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  TotalCount = 'TotalCount',
  /** column name */
  Type = 'Type',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type FunderView_Stddev_Fields = {
  __typename?: 'FunderView_stddev_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FunderView_Stddev_Pop_Fields = {
  __typename?: 'FunderView_stddev_pop_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FunderView_Stddev_Samp_Fields = {
  __typename?: 'FunderView_stddev_samp_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "FunderView" */
export type FunderView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FunderView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FunderView_Stream_Cursor_Value_Input = {
  AccountName?: InputMaybe<Scalars['String']>;
  Avatar?: InputMaybe<Scalars['String']>;
  BeforeLastSeason?: InputMaybe<Scalars['numeric']>;
  CurrentSeason?: InputMaybe<Scalars['numeric']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  LastSeason?: InputMaybe<Scalars['numeric']>;
  Name?: InputMaybe<Scalars['String']>;
  PlanterCount?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  TotalCount?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type FunderView_Sum_Fields = {
  __typename?: 'FunderView_sum_fields';
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  PlanterCount?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  TotalCount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type FunderView_Var_Pop_Fields = {
  __typename?: 'FunderView_var_pop_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FunderView_Var_Samp_Fields = {
  __typename?: 'FunderView_var_samp_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FunderView_Variance_Fields = {
  __typename?: 'FunderView_variance_fields';
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  PlanterCount?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalCount?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Funder" */
export type Funder_Aggregate = {
  __typename?: 'Funder_aggregate';
  aggregate?: Maybe<Funder_Aggregate_Fields>;
  nodes: Array<Funder>;
};

/** aggregate fields of "Funder" */
export type Funder_Aggregate_Fields = {
  __typename?: 'Funder_aggregate_fields';
  avg?: Maybe<Funder_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Funder_Max_Fields>;
  min?: Maybe<Funder_Min_Fields>;
  stddev?: Maybe<Funder_Stddev_Fields>;
  stddev_pop?: Maybe<Funder_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Funder_Stddev_Samp_Fields>;
  sum?: Maybe<Funder_Sum_Fields>;
  var_pop?: Maybe<Funder_Var_Pop_Fields>;
  var_samp?: Maybe<Funder_Var_Samp_Fields>;
  variance?: Maybe<Funder_Variance_Fields>;
};


/** aggregate fields of "Funder" */
export type Funder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Funder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Funder_Avg_Fields = {
  __typename?: 'Funder_avg_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Funder". All fields are combined with a logical 'AND'. */
export type Funder_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Banner?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Instruction?: InputMaybe<Instruction_Bool_Exp>;
  Instruction_aggregate?: InputMaybe<Instruction_Aggregate_Bool_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerId?: InputMaybe<Uuid_Comparison_Exp>;
  OwnerType?: InputMaybe<Smallint_Comparison_Exp>;
  Subscriptions?: InputMaybe<Subscription_Bool_Exp>;
  Subscriptions_aggregate?: InputMaybe<Subscription_Aggregate_Bool_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  YearLastTaxReceiptProcessed?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<Funder_Bool_Exp>>;
  _not?: InputMaybe<Funder_Bool_Exp>;
  _or?: InputMaybe<Array<Funder_Bool_Exp>>;
};

/** unique or primary key constraints on table "Funder" */
export enum Funder_Constraint {
  /** unique or primary key constraint on columns "Id" */
  FunderPkey = 'Funder_pkey'
}

/** input type for incrementing numeric columns in table "Funder" */
export type Funder_Inc_Input = {
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  YearLastTaxReceiptProcessed?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Funder" */
export type Funder_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Instruction?: InputMaybe<Instruction_Arr_Rel_Insert_Input>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Subscriptions?: InputMaybe<Subscription_Arr_Rel_Insert_Input>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  YearLastTaxReceiptProcessed?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Funder_Max_Fields = {
  __typename?: 'Funder_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Funder_Min_Fields = {
  __typename?: 'Funder_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "Funder" */
export type Funder_Mutation_Response = {
  __typename?: 'Funder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Funder>;
};

/** input type for inserting object relation for remote table "Funder" */
export type Funder_Obj_Rel_Insert_Input = {
  data: Funder_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Funder_On_Conflict>;
};

/** on_conflict condition type for table "Funder" */
export type Funder_On_Conflict = {
  constraint: Funder_Constraint;
  update_columns?: Array<Funder_Update_Column>;
  where?: InputMaybe<Funder_Bool_Exp>;
};

/** Ordering options when selecting data from "Funder". */
export type Funder_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  Avatar?: InputMaybe<Order_By>;
  Banner?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Instruction_aggregate?: InputMaybe<Instruction_Aggregate_Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerId?: InputMaybe<Order_By>;
  OwnerType?: InputMaybe<Order_By>;
  Subscriptions_aggregate?: InputMaybe<Subscription_Aggregate_Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  YearLastTaxReceiptProcessed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Funder */
export type Funder_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Funder" */
export enum Funder_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  YearLastTaxReceiptProcessed = 'YearLastTaxReceiptProcessed'
}

/** input type for updating data in table "Funder" */
export type Funder_Set_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  YearLastTaxReceiptProcessed?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Funder_Stddev_Fields = {
  __typename?: 'Funder_stddev_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Funder_Stddev_Pop_Fields = {
  __typename?: 'Funder_stddev_pop_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Funder_Stddev_Samp_Fields = {
  __typename?: 'Funder_stddev_samp_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Funder" */
export type Funder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Funder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Funder_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  YearLastTaxReceiptProcessed?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Funder_Sum_Fields = {
  __typename?: 'Funder_sum_fields';
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Int']>;
};

/** update columns of table "Funder" */
export enum Funder_Update_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  YearLastTaxReceiptProcessed = 'YearLastTaxReceiptProcessed'
}

export type Funder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Funder_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Funder_Set_Input>;
  where: Funder_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Funder_Var_Pop_Fields = {
  __typename?: 'Funder_var_pop_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Funder_Var_Samp_Fields = {
  __typename?: 'Funder_var_samp_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Funder_Variance_Fields = {
  __typename?: 'Funder_variance_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  YearLastTaxReceiptProcessed?: Maybe<Scalars['Float']>;
};

export type GeneratePutObjectPresignedUrlInput = {
  ContentType: Scalars['String'];
  FileName: Scalars['String'];
  IsPublic?: InputMaybe<Scalars['Boolean']>;
};

export type GeneratePutObjectPresignedUrlOutput = {
  __typename?: 'GeneratePutObjectPresignedUrlOutput';
  S3Key: Scalars['String'];
  SignedUrl: Scalars['String'];
};

export type GetBulkGiftRecipientsInput = {
  S3Key: Scalars['String'];
};

export type GetBulkGiftRecipientsOutput = {
  __typename?: 'GetBulkGiftRecipientsOutput';
  Gifts?: Maybe<Array<Maybe<Gifts>>>;
};

export type GetGiftPreviewInput = {
  FromName: Scalars['String'];
  Message?: InputMaybe<Scalars['String']>;
  TemplateId: Scalars['String'];
  ToName: Scalars['String'];
  Trees: Scalars['Int'];
};

export type GetStripeSubscriptionInput = {
  AccountId?: InputMaybe<Scalars['String']>;
};

export type GetUserIntercomDataOutput = {
  __typename?: 'GetUserIntercomDataOutput';
  AdminProfileLink?: Maybe<Scalars['String']>;
  ApplicationDate?: Maybe<Scalars['String']>;
  Avatar?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['String']>;
  District?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  FundedAmount?: Maybe<Scalars['String']>;
  FundedQuantity?: Maybe<Scalars['String']>;
  HasSubscriptions?: Maybe<Scalars['Boolean']>;
  Hash?: Maybe<Scalars['String']>;
  IdType?: Maybe<Scalars['String']>;
  IsProfileHidden?: Maybe<Scalars['Boolean']>;
  LastApplied?: Maybe<Scalars['String']>;
  LastFunded?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  PrimaryCategory?: Maybe<Scalars['String']>;
  ProfileId?: Maybe<Scalars['String']>;
  ProfileLink?: Maybe<Scalars['String']>;
  ProfileName?: Maybe<Scalars['String']>;
  Profiles?: Maybe<Array<Maybe<LinkedUserProfile>>>;
  Region?: Maybe<Scalars['String']>;
  SecondaryCategory?: Maybe<Scalars['String']>;
  SubscriptionCancelledOn?: Maybe<Scalars['String']>;
  SubscriptionCreatedOn?: Maybe<Scalars['String']>;
  SubscriptionQuantity?: Maybe<Scalars['Int']>;
  SubscriptionState?: Maybe<Scalars['String']>;
  TreesAppliedFor?: Maybe<Scalars['String']>;
  TreesApproved?: Maybe<Scalars['String']>;
  TreesPlanted?: Maybe<Scalars['String']>;
};

/** columns and relationships of "GiftCategory" */
export type GiftCategory = {
  __typename?: 'GiftCategory';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Name: Scalars['String'];
  Order: Scalars['Int'];
  /** An array relationship */
  TemplateCategories: Array<TemplateCategory>;
  /** An aggregate relationship */
  TemplateCategories_aggregate: TemplateCategory_Aggregate;
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "GiftCategory" */
export type GiftCategoryTemplateCategoriesArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


/** columns and relationships of "GiftCategory" */
export type GiftCategoryTemplateCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};

/** aggregated selection of "GiftCategory" */
export type GiftCategory_Aggregate = {
  __typename?: 'GiftCategory_aggregate';
  aggregate?: Maybe<GiftCategory_Aggregate_Fields>;
  nodes: Array<GiftCategory>;
};

/** aggregate fields of "GiftCategory" */
export type GiftCategory_Aggregate_Fields = {
  __typename?: 'GiftCategory_aggregate_fields';
  avg?: Maybe<GiftCategory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<GiftCategory_Max_Fields>;
  min?: Maybe<GiftCategory_Min_Fields>;
  stddev?: Maybe<GiftCategory_Stddev_Fields>;
  stddev_pop?: Maybe<GiftCategory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<GiftCategory_Stddev_Samp_Fields>;
  sum?: Maybe<GiftCategory_Sum_Fields>;
  var_pop?: Maybe<GiftCategory_Var_Pop_Fields>;
  var_samp?: Maybe<GiftCategory_Var_Samp_Fields>;
  variance?: Maybe<GiftCategory_Variance_Fields>;
};


/** aggregate fields of "GiftCategory" */
export type GiftCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GiftCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GiftCategory_Avg_Fields = {
  __typename?: 'GiftCategory_avg_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "GiftCategory". All fields are combined with a logical 'AND'. */
export type GiftCategory_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Order?: InputMaybe<Int_Comparison_Exp>;
  TemplateCategories?: InputMaybe<TemplateCategory_Bool_Exp>;
  TemplateCategories_aggregate?: InputMaybe<TemplateCategory_Aggregate_Bool_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<GiftCategory_Bool_Exp>>;
  _not?: InputMaybe<GiftCategory_Bool_Exp>;
  _or?: InputMaybe<Array<GiftCategory_Bool_Exp>>;
};

/** unique or primary key constraints on table "GiftCategory" */
export enum GiftCategory_Constraint {
  /** unique or primary key constraint on columns "Id" */
  GiftCategoryPkey = 'GiftCategory_pkey'
}

/** input type for incrementing numeric columns in table "GiftCategory" */
export type GiftCategory_Inc_Input = {
  Order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "GiftCategory" */
export type GiftCategory_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  TemplateCategories?: InputMaybe<TemplateCategory_Arr_Rel_Insert_Input>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type GiftCategory_Max_Fields = {
  __typename?: 'GiftCategory_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Order?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type GiftCategory_Min_Fields = {
  __typename?: 'GiftCategory_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Order?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "GiftCategory" */
export type GiftCategory_Mutation_Response = {
  __typename?: 'GiftCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GiftCategory>;
};

/** input type for inserting object relation for remote table "GiftCategory" */
export type GiftCategory_Obj_Rel_Insert_Input = {
  data: GiftCategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GiftCategory_On_Conflict>;
};

/** on_conflict condition type for table "GiftCategory" */
export type GiftCategory_On_Conflict = {
  constraint: GiftCategory_Constraint;
  update_columns?: Array<GiftCategory_Update_Column>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "GiftCategory". */
export type GiftCategory_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Order?: InputMaybe<Order_By>;
  TemplateCategories_aggregate?: InputMaybe<TemplateCategory_Aggregate_Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: GiftCategory */
export type GiftCategory_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "GiftCategory" */
export enum GiftCategory_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Order = 'Order',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "GiftCategory" */
export type GiftCategory_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type GiftCategory_Stddev_Fields = {
  __typename?: 'GiftCategory_stddev_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GiftCategory_Stddev_Pop_Fields = {
  __typename?: 'GiftCategory_stddev_pop_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GiftCategory_Stddev_Samp_Fields = {
  __typename?: 'GiftCategory_stddev_samp_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "GiftCategory" */
export type GiftCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GiftCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GiftCategory_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type GiftCategory_Sum_Fields = {
  __typename?: 'GiftCategory_sum_fields';
  Order?: Maybe<Scalars['Int']>;
};

/** update columns of table "GiftCategory" */
export enum GiftCategory_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Order = 'Order',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type GiftCategory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GiftCategory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GiftCategory_Set_Input>;
  where: GiftCategory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type GiftCategory_Var_Pop_Fields = {
  __typename?: 'GiftCategory_var_pop_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GiftCategory_Var_Samp_Fields = {
  __typename?: 'GiftCategory_var_samp_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GiftCategory_Variance_Fields = {
  __typename?: 'GiftCategory_variance_fields';
  Order?: Maybe<Scalars['Float']>;
};

export type GiftInput = {
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  From: Scalars['String'];
  GiftTemplateId: Scalars['String'];
  Message?: InputMaybe<Scalars['String']>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  RecipientEmail: Scalars['String'];
  RecipientName: Scalars['String'];
};

export type GiftPreviewOutput = {
  __typename?: 'GiftPreviewOutput';
  base64Data: Scalars['String'];
};

/** columns and relationships of "GiftTemplate" */
export type GiftTemplate = {
  __typename?: 'GiftTemplate';
  BackgroundImage?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Description: Scalars['String'];
  Heading?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  IsAvailable: Scalars['Boolean'];
  IsBulkOnly: Scalars['Boolean'];
  IsDefault: Scalars['Boolean'];
  IsFeatured: Scalars['Boolean'];
  MailTemplate?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Order: Scalars['Int'];
  Preview: Scalars['String'];
  Subject: Scalars['String'];
  Template?: Maybe<Scalars['String']>;
  /** An array relationship */
  TemplateCategories: Array<TemplateCategory>;
  /** An aggregate relationship */
  TemplateCategories_aggregate: TemplateCategory_Aggregate;
  Title: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "GiftTemplate" */
export type GiftTemplateTemplateCategoriesArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


/** columns and relationships of "GiftTemplate" */
export type GiftTemplateTemplateCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};

/** aggregated selection of "GiftTemplate" */
export type GiftTemplate_Aggregate = {
  __typename?: 'GiftTemplate_aggregate';
  aggregate?: Maybe<GiftTemplate_Aggregate_Fields>;
  nodes: Array<GiftTemplate>;
};

/** aggregate fields of "GiftTemplate" */
export type GiftTemplate_Aggregate_Fields = {
  __typename?: 'GiftTemplate_aggregate_fields';
  avg?: Maybe<GiftTemplate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<GiftTemplate_Max_Fields>;
  min?: Maybe<GiftTemplate_Min_Fields>;
  stddev?: Maybe<GiftTemplate_Stddev_Fields>;
  stddev_pop?: Maybe<GiftTemplate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<GiftTemplate_Stddev_Samp_Fields>;
  sum?: Maybe<GiftTemplate_Sum_Fields>;
  var_pop?: Maybe<GiftTemplate_Var_Pop_Fields>;
  var_samp?: Maybe<GiftTemplate_Var_Samp_Fields>;
  variance?: Maybe<GiftTemplate_Variance_Fields>;
};


/** aggregate fields of "GiftTemplate" */
export type GiftTemplate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GiftTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GiftTemplate_Avg_Fields = {
  __typename?: 'GiftTemplate_avg_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "GiftTemplate". All fields are combined with a logical 'AND'. */
export type GiftTemplate_Bool_Exp = {
  BackgroundImage?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Heading?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsAvailable?: InputMaybe<Boolean_Comparison_Exp>;
  IsBulkOnly?: InputMaybe<Boolean_Comparison_Exp>;
  IsDefault?: InputMaybe<Boolean_Comparison_Exp>;
  IsFeatured?: InputMaybe<Boolean_Comparison_Exp>;
  MailTemplate?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Order?: InputMaybe<Int_Comparison_Exp>;
  Preview?: InputMaybe<String_Comparison_Exp>;
  Subject?: InputMaybe<String_Comparison_Exp>;
  Template?: InputMaybe<String_Comparison_Exp>;
  TemplateCategories?: InputMaybe<TemplateCategory_Bool_Exp>;
  TemplateCategories_aggregate?: InputMaybe<TemplateCategory_Aggregate_Bool_Exp>;
  Title?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<GiftTemplate_Bool_Exp>>;
  _not?: InputMaybe<GiftTemplate_Bool_Exp>;
  _or?: InputMaybe<Array<GiftTemplate_Bool_Exp>>;
};

/** unique or primary key constraints on table "GiftTemplate" */
export enum GiftTemplate_Constraint {
  /** unique or primary key constraint on columns "Id" */
  GiftTemplatePkey = 'GiftTemplate_pkey'
}

/** input type for incrementing numeric columns in table "GiftTemplate" */
export type GiftTemplate_Inc_Input = {
  Order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "GiftTemplate" */
export type GiftTemplate_Insert_Input = {
  BackgroundImage?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsAvailable?: InputMaybe<Scalars['Boolean']>;
  IsBulkOnly?: InputMaybe<Scalars['Boolean']>;
  IsDefault?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  MailTemplate?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  Preview?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  Template?: InputMaybe<Scalars['String']>;
  TemplateCategories?: InputMaybe<TemplateCategory_Arr_Rel_Insert_Input>;
  Title?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type GiftTemplate_Max_Fields = {
  __typename?: 'GiftTemplate_max_fields';
  BackgroundImage?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Heading?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  MailTemplate?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Order?: Maybe<Scalars['Int']>;
  Preview?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  Template?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type GiftTemplate_Min_Fields = {
  __typename?: 'GiftTemplate_min_fields';
  BackgroundImage?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Heading?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  MailTemplate?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Order?: Maybe<Scalars['Int']>;
  Preview?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  Template?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "GiftTemplate" */
export type GiftTemplate_Mutation_Response = {
  __typename?: 'GiftTemplate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GiftTemplate>;
};

/** input type for inserting object relation for remote table "GiftTemplate" */
export type GiftTemplate_Obj_Rel_Insert_Input = {
  data: GiftTemplate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GiftTemplate_On_Conflict>;
};

/** on_conflict condition type for table "GiftTemplate" */
export type GiftTemplate_On_Conflict = {
  constraint: GiftTemplate_Constraint;
  update_columns?: Array<GiftTemplate_Update_Column>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};

/** Ordering options when selecting data from "GiftTemplate". */
export type GiftTemplate_Order_By = {
  BackgroundImage?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Heading?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsAvailable?: InputMaybe<Order_By>;
  IsBulkOnly?: InputMaybe<Order_By>;
  IsDefault?: InputMaybe<Order_By>;
  IsFeatured?: InputMaybe<Order_By>;
  MailTemplate?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Order?: InputMaybe<Order_By>;
  Preview?: InputMaybe<Order_By>;
  Subject?: InputMaybe<Order_By>;
  Template?: InputMaybe<Order_By>;
  TemplateCategories_aggregate?: InputMaybe<TemplateCategory_Aggregate_Order_By>;
  Title?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: GiftTemplate */
export type GiftTemplate_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "GiftTemplate" */
export enum GiftTemplate_Select_Column {
  /** column name */
  BackgroundImage = 'BackgroundImage',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  Heading = 'Heading',
  /** column name */
  Id = 'Id',
  /** column name */
  IsAvailable = 'IsAvailable',
  /** column name */
  IsBulkOnly = 'IsBulkOnly',
  /** column name */
  IsDefault = 'IsDefault',
  /** column name */
  IsFeatured = 'IsFeatured',
  /** column name */
  MailTemplate = 'MailTemplate',
  /** column name */
  Name = 'Name',
  /** column name */
  Order = 'Order',
  /** column name */
  Preview = 'Preview',
  /** column name */
  Subject = 'Subject',
  /** column name */
  Template = 'Template',
  /** column name */
  Title = 'Title',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "GiftTemplate" */
export type GiftTemplate_Set_Input = {
  BackgroundImage?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsAvailable?: InputMaybe<Scalars['Boolean']>;
  IsBulkOnly?: InputMaybe<Scalars['Boolean']>;
  IsDefault?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  MailTemplate?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  Preview?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  Template?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type GiftTemplate_Stddev_Fields = {
  __typename?: 'GiftTemplate_stddev_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GiftTemplate_Stddev_Pop_Fields = {
  __typename?: 'GiftTemplate_stddev_pop_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GiftTemplate_Stddev_Samp_Fields = {
  __typename?: 'GiftTemplate_stddev_samp_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "GiftTemplate" */
export type GiftTemplate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GiftTemplate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GiftTemplate_Stream_Cursor_Value_Input = {
  BackgroundImage?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsAvailable?: InputMaybe<Scalars['Boolean']>;
  IsBulkOnly?: InputMaybe<Scalars['Boolean']>;
  IsDefault?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  MailTemplate?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Order?: InputMaybe<Scalars['Int']>;
  Preview?: InputMaybe<Scalars['String']>;
  Subject?: InputMaybe<Scalars['String']>;
  Template?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type GiftTemplate_Sum_Fields = {
  __typename?: 'GiftTemplate_sum_fields';
  Order?: Maybe<Scalars['Int']>;
};

/** update columns of table "GiftTemplate" */
export enum GiftTemplate_Update_Column {
  /** column name */
  BackgroundImage = 'BackgroundImage',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  Heading = 'Heading',
  /** column name */
  Id = 'Id',
  /** column name */
  IsAvailable = 'IsAvailable',
  /** column name */
  IsBulkOnly = 'IsBulkOnly',
  /** column name */
  IsDefault = 'IsDefault',
  /** column name */
  IsFeatured = 'IsFeatured',
  /** column name */
  MailTemplate = 'MailTemplate',
  /** column name */
  Name = 'Name',
  /** column name */
  Order = 'Order',
  /** column name */
  Preview = 'Preview',
  /** column name */
  Subject = 'Subject',
  /** column name */
  Template = 'Template',
  /** column name */
  Title = 'Title',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type GiftTemplate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GiftTemplate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GiftTemplate_Set_Input>;
  where: GiftTemplate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type GiftTemplate_Var_Pop_Fields = {
  __typename?: 'GiftTemplate_var_pop_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GiftTemplate_Var_Samp_Fields = {
  __typename?: 'GiftTemplate_var_samp_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GiftTemplate_Variance_Fields = {
  __typename?: 'GiftTemplate_variance_fields';
  Order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "GiftedTree" */
export type GiftedTree = {
  __typename?: 'GiftedTree';
  Code: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  From: Scalars['String'];
  FunderId: Scalars['uuid'];
  Heading: Scalars['String'];
  Id: Scalars['uuid'];
  Message: Scalars['String'];
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId: Scalars['uuid'];
  RecipientEmail: Scalars['String'];
  RecipientName: Scalars['String'];
  State: Scalars['Int'];
  SupporterId?: Maybe<Scalars['uuid']>;
  TemplateId: Scalars['uuid'];
  To: Scalars['String'];
  Trees: Scalars['bigint'];
  UpdatedOn: Scalars['timestamp'];
  UserId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "GiftedTree" */
export type GiftedTree_Aggregate = {
  __typename?: 'GiftedTree_aggregate';
  aggregate?: Maybe<GiftedTree_Aggregate_Fields>;
  nodes: Array<GiftedTree>;
};

/** aggregate fields of "GiftedTree" */
export type GiftedTree_Aggregate_Fields = {
  __typename?: 'GiftedTree_aggregate_fields';
  avg?: Maybe<GiftedTree_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<GiftedTree_Max_Fields>;
  min?: Maybe<GiftedTree_Min_Fields>;
  stddev?: Maybe<GiftedTree_Stddev_Fields>;
  stddev_pop?: Maybe<GiftedTree_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<GiftedTree_Stddev_Samp_Fields>;
  sum?: Maybe<GiftedTree_Sum_Fields>;
  var_pop?: Maybe<GiftedTree_Var_Pop_Fields>;
  var_samp?: Maybe<GiftedTree_Var_Samp_Fields>;
  variance?: Maybe<GiftedTree_Variance_Fields>;
};


/** aggregate fields of "GiftedTree" */
export type GiftedTree_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GiftedTree_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type GiftedTree_Avg_Fields = {
  __typename?: 'GiftedTree_avg_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "GiftedTree". All fields are combined with a logical 'AND'. */
export type GiftedTree_Bool_Exp = {
  Code?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  From?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Heading?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientName?: InputMaybe<String_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  SupporterId?: InputMaybe<Uuid_Comparison_Exp>;
  TemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  To?: InputMaybe<String_Comparison_Exp>;
  Trees?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<GiftedTree_Bool_Exp>>;
  _not?: InputMaybe<GiftedTree_Bool_Exp>;
  _or?: InputMaybe<Array<GiftedTree_Bool_Exp>>;
};

/** unique or primary key constraints on table "GiftedTree" */
export enum GiftedTree_Constraint {
  /** unique or primary key constraint on columns "Id" */
  GiftedTreePkey = 'GiftedTree_pkey'
}

/** input type for incrementing numeric columns in table "GiftedTree" */
export type GiftedTree_Inc_Input = {
  State?: InputMaybe<Scalars['Int']>;
  Trees?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "GiftedTree" */
export type GiftedTree_Insert_Input = {
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  From?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  To?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type GiftedTree_Max_Fields = {
  __typename?: 'GiftedTree_max_fields';
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  From?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Heading?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  TemplateId?: Maybe<Scalars['uuid']>;
  To?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type GiftedTree_Min_Fields = {
  __typename?: 'GiftedTree_min_fields';
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  From?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Heading?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  TemplateId?: Maybe<Scalars['uuid']>;
  To?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "GiftedTree" */
export type GiftedTree_Mutation_Response = {
  __typename?: 'GiftedTree_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GiftedTree>;
};

/** on_conflict condition type for table "GiftedTree" */
export type GiftedTree_On_Conflict = {
  constraint: GiftedTree_Constraint;
  update_columns?: Array<GiftedTree_Update_Column>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};

/** Ordering options when selecting data from "GiftedTree". */
export type GiftedTree_Order_By = {
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Heading?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  TemplateId?: InputMaybe<Order_By>;
  To?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: GiftedTree */
export type GiftedTree_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "GiftedTree" */
export enum GiftedTree_Select_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  From = 'From',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Heading = 'Heading',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  State = 'State',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  TemplateId = 'TemplateId',
  /** column name */
  To = 'To',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

/** input type for updating data in table "GiftedTree" */
export type GiftedTree_Set_Input = {
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  From?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  To?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type GiftedTree_Stddev_Fields = {
  __typename?: 'GiftedTree_stddev_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type GiftedTree_Stddev_Pop_Fields = {
  __typename?: 'GiftedTree_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type GiftedTree_Stddev_Samp_Fields = {
  __typename?: 'GiftedTree_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "GiftedTree" */
export type GiftedTree_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GiftedTree_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GiftedTree_Stream_Cursor_Value_Input = {
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  From?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Heading?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  TemplateId?: InputMaybe<Scalars['uuid']>;
  To?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type GiftedTree_Sum_Fields = {
  __typename?: 'GiftedTree_sum_fields';
  State?: Maybe<Scalars['Int']>;
  Trees?: Maybe<Scalars['bigint']>;
};

/** update columns of table "GiftedTree" */
export enum GiftedTree_Update_Column {
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  From = 'From',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Heading = 'Heading',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  State = 'State',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  TemplateId = 'TemplateId',
  /** column name */
  To = 'To',
  /** column name */
  Trees = 'Trees',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

export type GiftedTree_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GiftedTree_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GiftedTree_Set_Input>;
  where: GiftedTree_Bool_Exp;
};

/** aggregate var_pop on columns */
export type GiftedTree_Var_Pop_Fields = {
  __typename?: 'GiftedTree_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type GiftedTree_Var_Samp_Fields = {
  __typename?: 'GiftedTree_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type GiftedTree_Variance_Fields = {
  __typename?: 'GiftedTree_variance_fields';
  State?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

export type Gifts = {
  __typename?: 'Gifts';
  FromName: Scalars['String'];
  Message?: Maybe<Scalars['String']>;
  ToEmail: Scalars['String'];
  ToName: Scalars['String'];
  Trees: Scalars['Int'];
};

/** columns and relationships of "IPLocation" */
export type IpLocation = {
  __typename?: 'IPLocation';
  Address: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "IPLocation" */
export type IpLocation_Aggregate = {
  __typename?: 'IPLocation_aggregate';
  aggregate?: Maybe<IpLocation_Aggregate_Fields>;
  nodes: Array<IpLocation>;
};

/** aggregate fields of "IPLocation" */
export type IpLocation_Aggregate_Fields = {
  __typename?: 'IPLocation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IpLocation_Max_Fields>;
  min?: Maybe<IpLocation_Min_Fields>;
};


/** aggregate fields of "IPLocation" */
export type IpLocation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IpLocation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "IPLocation". All fields are combined with a logical 'AND'. */
export type IpLocation_Bool_Exp = {
  Address?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<IpLocation_Bool_Exp>>;
  _not?: InputMaybe<IpLocation_Bool_Exp>;
  _or?: InputMaybe<Array<IpLocation_Bool_Exp>>;
};

/** unique or primary key constraints on table "IPLocation" */
export enum IpLocation_Constraint {
  /** unique or primary key constraint on columns "Id" */
  IpLocationPkey = 'IPLocation_pkey'
}

/** input type for inserting data into table "IPLocation" */
export type IpLocation_Insert_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type IpLocation_Max_Fields = {
  __typename?: 'IPLocation_max_fields';
  Address?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type IpLocation_Min_Fields = {
  __typename?: 'IPLocation_min_fields';
  Address?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "IPLocation" */
export type IpLocation_Mutation_Response = {
  __typename?: 'IPLocation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IpLocation>;
};

/** on_conflict condition type for table "IPLocation" */
export type IpLocation_On_Conflict = {
  constraint: IpLocation_Constraint;
  update_columns?: Array<IpLocation_Update_Column>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};

/** Ordering options when selecting data from "IPLocation". */
export type IpLocation_Order_By = {
  Address?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: IPLocation */
export type IpLocation_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "IPLocation" */
export enum IpLocation_Select_Column {
  /** column name */
  Address = 'Address',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "IPLocation" */
export type IpLocation_Set_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "IPLocation" */
export type IpLocation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IpLocation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IpLocation_Stream_Cursor_Value_Input = {
  Address?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "IPLocation" */
export enum IpLocation_Update_Column {
  /** column name */
  Address = 'Address',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type IpLocation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IpLocation_Set_Input>;
  where: IpLocation_Bool_Exp;
};

export type ImportBulkGiftInput = {
  AccountId: Scalars['String'];
  CsvPath: Scalars['String'];
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  GiftTemplateId: Scalars['String'];
  InvoiceAddress?: InputMaybe<InvoiceAddress>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  PricePerTree: Scalars['numeric'];
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  ReceiptEmail: Scalars['String'];
  ReceiptName: Scalars['String'];
  SendEmailToRecipients: Scalars['Boolean'];
};

export type ImportBulkGiftOutput = {
  __typename?: 'ImportBulkGiftOutput';
  PurchaseIds: Array<Scalars['String']>;
};

/** columns and relationships of "Instruction" */
export type Instruction = {
  __typename?: 'Instruction';
  AssignToAny: Scalars['Boolean'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Funder?: Maybe<Funder>;
  FunderId: Scalars['uuid'];
  HoldOnMatch: Scalars['Boolean'];
  Id: Scalars['uuid'];
  /** An array relationship */
  Matches: Array<Match>;
  /** An aggregate relationship */
  Matches_aggregate: Match_Aggregate;
  /** An object relationship */
  Purchase?: Maybe<Purchase>;
  PurchaseId: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  RegionId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Season?: Maybe<Season>;
  SeasonId: Scalars['uuid'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "Instruction" */
export type InstructionMatchesArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


/** columns and relationships of "Instruction" */
export type InstructionMatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};

/** columns and relationships of "InstructionView" */
export type InstructionView = {
  __typename?: 'InstructionView';
  /** An object relationship */
  AdminPurchaseView?: Maybe<AdminPurchaseView>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  /** An object relationship */
  Funder?: Maybe<Funder>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  HoldOnMatch?: Maybe<Scalars['Boolean']>;
  Id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Instruction?: Maybe<Instruction>;
  IsMatched?: Maybe<Scalars['Boolean']>;
  IsUnmatched?: Maybe<Scalars['Boolean']>;
  Matched?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  Matches: Array<Match>;
  /** An aggregate relationship */
  Matches_aggregate: Match_Aggregate;
  ProductName?: Maybe<Scalars['String']>;
  /** An object relationship */
  Purchase?: Maybe<Purchase>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "InstructionView" */
export type InstructionViewMatchesArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


/** columns and relationships of "InstructionView" */
export type InstructionViewMatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};

/** aggregated selection of "InstructionView" */
export type InstructionView_Aggregate = {
  __typename?: 'InstructionView_aggregate';
  aggregate?: Maybe<InstructionView_Aggregate_Fields>;
  nodes: Array<InstructionView>;
};

/** aggregate fields of "InstructionView" */
export type InstructionView_Aggregate_Fields = {
  __typename?: 'InstructionView_aggregate_fields';
  avg?: Maybe<InstructionView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<InstructionView_Max_Fields>;
  min?: Maybe<InstructionView_Min_Fields>;
  stddev?: Maybe<InstructionView_Stddev_Fields>;
  stddev_pop?: Maybe<InstructionView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<InstructionView_Stddev_Samp_Fields>;
  sum?: Maybe<InstructionView_Sum_Fields>;
  var_pop?: Maybe<InstructionView_Var_Pop_Fields>;
  var_samp?: Maybe<InstructionView_Var_Samp_Fields>;
  variance?: Maybe<InstructionView_Variance_Fields>;
};


/** aggregate fields of "InstructionView" */
export type InstructionView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InstructionView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InstructionView_Avg_Fields = {
  __typename?: 'InstructionView_avg_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "InstructionView". All fields are combined with a logical 'AND'. */
export type InstructionView_Bool_Exp = {
  AdminPurchaseView?: InputMaybe<AdminPurchaseView_Bool_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  CreatedOnFormatted?: InputMaybe<String_Comparison_Exp>;
  DistrictName?: InputMaybe<String_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderDistrictName?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  FunderName?: InputMaybe<String_Comparison_Exp>;
  FunderRegionName?: InputMaybe<String_Comparison_Exp>;
  GiftDeliveryDate?: InputMaybe<Timestamp_Comparison_Exp>;
  HoldOnMatch?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Instruction?: InputMaybe<Instruction_Bool_Exp>;
  IsMatched?: InputMaybe<Boolean_Comparison_Exp>;
  IsUnmatched?: InputMaybe<Boolean_Comparison_Exp>;
  Matched?: InputMaybe<Numeric_Comparison_Exp>;
  Matches?: InputMaybe<Match_Bool_Exp>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Bool_Exp>;
  ProductName?: InputMaybe<String_Comparison_Exp>;
  Purchase?: InputMaybe<Purchase_Bool_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<String_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  RegistryName?: InputMaybe<String_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  Trees?: InputMaybe<Bigint_Comparison_Exp>;
  TypeName?: InputMaybe<Int_Comparison_Exp>;
  Unmatched?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<InstructionView_Bool_Exp>>;
  _not?: InputMaybe<InstructionView_Bool_Exp>;
  _or?: InputMaybe<Array<InstructionView_Bool_Exp>>;
};

/** aggregate max on columns */
export type InstructionView_Max_Fields = {
  __typename?: 'InstructionView_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['numeric']>;
  ProductName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type InstructionView_Min_Fields = {
  __typename?: 'InstructionView_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  CreatedOnFormatted?: Maybe<Scalars['String']>;
  DistrictName?: Maybe<Scalars['String']>;
  FunderDistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  FunderName?: Maybe<Scalars['String']>;
  FunderRegionName?: Maybe<Scalars['String']>;
  GiftDeliveryDate?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['numeric']>;
  ProductName?: Maybe<Scalars['String']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['String']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryName?: Maybe<Scalars['String']>;
  SeasonName?: Maybe<Scalars['String']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "InstructionView". */
export type InstructionView_Order_By = {
  AdminPurchaseView?: InputMaybe<AdminPurchaseView_Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  CreatedOnFormatted?: InputMaybe<Order_By>;
  DistrictName?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderDistrictName?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  FunderName?: InputMaybe<Order_By>;
  FunderRegionName?: InputMaybe<Order_By>;
  GiftDeliveryDate?: InputMaybe<Order_By>;
  HoldOnMatch?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Instruction?: InputMaybe<Instruction_Order_By>;
  IsMatched?: InputMaybe<Order_By>;
  IsUnmatched?: InputMaybe<Order_By>;
  Matched?: InputMaybe<Order_By>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Order_By>;
  ProductName?: InputMaybe<Order_By>;
  Purchase?: InputMaybe<Purchase_Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  RegistryName?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  TypeName?: InputMaybe<Order_By>;
  Unmatched?: InputMaybe<Order_By>;
};

/** select columns of table "InstructionView" */
export enum InstructionView_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  CreatedOnFormatted = 'CreatedOnFormatted',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  FunderDistrictName = 'FunderDistrictName',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  FunderName = 'FunderName',
  /** column name */
  FunderRegionName = 'FunderRegionName',
  /** column name */
  GiftDeliveryDate = 'GiftDeliveryDate',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  IsMatched = 'IsMatched',
  /** column name */
  IsUnmatched = 'IsUnmatched',
  /** column name */
  Matched = 'Matched',
  /** column name */
  ProductName = 'ProductName',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegistryName = 'RegistryName',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  Trees = 'Trees',
  /** column name */
  TypeName = 'TypeName',
  /** column name */
  Unmatched = 'Unmatched'
}

/** aggregate stddev on columns */
export type InstructionView_Stddev_Fields = {
  __typename?: 'InstructionView_stddev_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type InstructionView_Stddev_Pop_Fields = {
  __typename?: 'InstructionView_stddev_pop_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type InstructionView_Stddev_Samp_Fields = {
  __typename?: 'InstructionView_stddev_samp_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "InstructionView" */
export type InstructionView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InstructionView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InstructionView_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOnFormatted?: InputMaybe<Scalars['String']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  FunderDistrictName?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  FunderName?: InputMaybe<Scalars['String']>;
  FunderRegionName?: InputMaybe<Scalars['String']>;
  GiftDeliveryDate?: InputMaybe<Scalars['timestamp']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsMatched?: InputMaybe<Scalars['Boolean']>;
  IsUnmatched?: InputMaybe<Scalars['Boolean']>;
  Matched?: InputMaybe<Scalars['numeric']>;
  ProductName?: InputMaybe<Scalars['String']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['String']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegistryName?: InputMaybe<Scalars['String']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  TypeName?: InputMaybe<Scalars['Int']>;
  Unmatched?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type InstructionView_Sum_Fields = {
  __typename?: 'InstructionView_sum_fields';
  Matched?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  TypeName?: Maybe<Scalars['Int']>;
  Unmatched?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type InstructionView_Var_Pop_Fields = {
  __typename?: 'InstructionView_var_pop_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type InstructionView_Var_Samp_Fields = {
  __typename?: 'InstructionView_var_samp_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InstructionView_Variance_Fields = {
  __typename?: 'InstructionView_variance_fields';
  Matched?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  TypeName?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Instruction" */
export type Instruction_Aggregate = {
  __typename?: 'Instruction_aggregate';
  aggregate?: Maybe<Instruction_Aggregate_Fields>;
  nodes: Array<Instruction>;
};

export type Instruction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Instruction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Instruction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Instruction_Aggregate_Bool_Exp_Count>;
};

export type Instruction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Instruction_Select_Column_Instruction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instruction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Instruction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Instruction_Select_Column_Instruction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instruction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Instruction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Instruction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Instruction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Instruction" */
export type Instruction_Aggregate_Fields = {
  __typename?: 'Instruction_aggregate_fields';
  avg?: Maybe<Instruction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Instruction_Max_Fields>;
  min?: Maybe<Instruction_Min_Fields>;
  stddev?: Maybe<Instruction_Stddev_Fields>;
  stddev_pop?: Maybe<Instruction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Instruction_Stddev_Samp_Fields>;
  sum?: Maybe<Instruction_Sum_Fields>;
  var_pop?: Maybe<Instruction_Var_Pop_Fields>;
  var_samp?: Maybe<Instruction_Var_Samp_Fields>;
  variance?: Maybe<Instruction_Variance_Fields>;
};


/** aggregate fields of "Instruction" */
export type Instruction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Instruction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Instruction" */
export type Instruction_Aggregate_Order_By = {
  avg?: InputMaybe<Instruction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Instruction_Max_Order_By>;
  min?: InputMaybe<Instruction_Min_Order_By>;
  stddev?: InputMaybe<Instruction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Instruction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Instruction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Instruction_Sum_Order_By>;
  var_pop?: InputMaybe<Instruction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Instruction_Var_Samp_Order_By>;
  variance?: InputMaybe<Instruction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Instruction" */
export type Instruction_Arr_Rel_Insert_Input = {
  data: Array<Instruction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Instruction_On_Conflict>;
};

/** aggregate avg on columns */
export type Instruction_Avg_Fields = {
  __typename?: 'Instruction_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Instruction" */
export type Instruction_Avg_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Instruction". All fields are combined with a logical 'AND'. */
export type Instruction_Bool_Exp = {
  AssignToAny?: InputMaybe<Boolean_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  HoldOnMatch?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Matches?: InputMaybe<Match_Bool_Exp>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Bool_Exp>;
  Purchase?: InputMaybe<Purchase_Bool_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Season?: InputMaybe<Season_Bool_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Instruction_Bool_Exp>>;
  _not?: InputMaybe<Instruction_Bool_Exp>;
  _or?: InputMaybe<Array<Instruction_Bool_Exp>>;
};

/** unique or primary key constraints on table "Instruction" */
export enum Instruction_Constraint {
  /** unique or primary key constraint on columns "Id" */
  InstructionPkey = 'Instruction_pkey'
}

/** input type for incrementing numeric columns in table "Instruction" */
export type Instruction_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Instruction" */
export type Instruction_Insert_Input = {
  AssignToAny?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Matches?: InputMaybe<Match_Arr_Rel_Insert_Input>;
  Purchase?: InputMaybe<Purchase_Obj_Rel_Insert_Input>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Season?: InputMaybe<Season_Obj_Rel_Insert_Input>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Instruction_Max_Fields = {
  __typename?: 'Instruction_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "Instruction" */
export type Instruction_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Instruction_Min_Fields = {
  __typename?: 'Instruction_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "Instruction" */
export type Instruction_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Instruction" */
export type Instruction_Mutation_Response = {
  __typename?: 'Instruction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Instruction>;
};

/** input type for inserting object relation for remote table "Instruction" */
export type Instruction_Obj_Rel_Insert_Input = {
  data: Instruction_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Instruction_On_Conflict>;
};

/** on_conflict condition type for table "Instruction" */
export type Instruction_On_Conflict = {
  constraint: Instruction_Constraint;
  update_columns?: Array<Instruction_Update_Column>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};

/** Ordering options when selecting data from "Instruction". */
export type Instruction_Order_By = {
  AssignToAny?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  HoldOnMatch?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Matches_aggregate?: InputMaybe<Match_Aggregate_Order_By>;
  Purchase?: InputMaybe<Purchase_Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Season?: InputMaybe<Season_Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Instruction */
export type Instruction_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Instruction" */
export enum Instruction_Select_Column {
  /** column name */
  AssignToAny = 'AssignToAny',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** select "Instruction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Instruction" */
export enum Instruction_Select_Column_Instruction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AssignToAny = 'AssignToAny',
  /** column name */
  HoldOnMatch = 'HoldOnMatch'
}

/** select "Instruction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Instruction" */
export enum Instruction_Select_Column_Instruction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AssignToAny = 'AssignToAny',
  /** column name */
  HoldOnMatch = 'HoldOnMatch'
}

/** input type for updating data in table "Instruction" */
export type Instruction_Set_Input = {
  AssignToAny?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Instruction_Stddev_Fields = {
  __typename?: 'Instruction_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Instruction" */
export type Instruction_Stddev_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Instruction_Stddev_Pop_Fields = {
  __typename?: 'Instruction_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Instruction" */
export type Instruction_Stddev_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Instruction_Stddev_Samp_Fields = {
  __typename?: 'Instruction_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Instruction" */
export type Instruction_Stddev_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Instruction" */
export type Instruction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Instruction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Instruction_Stream_Cursor_Value_Input = {
  AssignToAny?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  HoldOnMatch?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Instruction_Sum_Fields = {
  __typename?: 'Instruction_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Instruction" */
export type Instruction_Sum_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** update columns of table "Instruction" */
export enum Instruction_Update_Column {
  /** column name */
  AssignToAny = 'AssignToAny',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  HoldOnMatch = 'HoldOnMatch',
  /** column name */
  Id = 'Id',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Instruction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Instruction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Instruction_Set_Input>;
  where: Instruction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Instruction_Var_Pop_Fields = {
  __typename?: 'Instruction_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Instruction" */
export type Instruction_Var_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Instruction_Var_Samp_Fields = {
  __typename?: 'Instruction_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Instruction" */
export type Instruction_Var_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Instruction_Variance_Fields = {
  __typename?: 'Instruction_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Instruction" */
export type Instruction_Variance_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "Invite" */
export type Invite = {
  __typename?: 'Invite';
  /** An object relationship */
  Account: Account;
  AccountId: Scalars['uuid'];
  Code: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  ExpiresAt: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Message?: Maybe<Scalars['String']>;
  RecipientEmail: Scalars['String'];
  RecipientFirstname?: Maybe<Scalars['String']>;
  RecipientLastname?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  /** An object relationship */
  User?: Maybe<User>;
};

/** aggregated selection of "Invite" */
export type Invite_Aggregate = {
  __typename?: 'Invite_aggregate';
  aggregate?: Maybe<Invite_Aggregate_Fields>;
  nodes: Array<Invite>;
};

export type Invite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invite_Aggregate_Bool_Exp_Count>;
};

export type Invite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Invite" */
export type Invite_Aggregate_Fields = {
  __typename?: 'Invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invite_Max_Fields>;
  min?: Maybe<Invite_Min_Fields>;
};


/** aggregate fields of "Invite" */
export type Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Invite" */
export type Invite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invite_Max_Order_By>;
  min?: InputMaybe<Invite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Invite" */
export type Invite_Arr_Rel_Insert_Input = {
  data: Array<Invite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Invite". All fields are combined with a logical 'AND'. */
export type Invite_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  Code?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  ExpiresAt?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Message?: InputMaybe<String_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientFirstname?: InputMaybe<String_Comparison_Exp>;
  RecipientLastname?: InputMaybe<String_Comparison_Exp>;
  Status?: InputMaybe<String_Comparison_Exp>;
  User?: InputMaybe<User_Bool_Exp>;
  _and?: InputMaybe<Array<Invite_Bool_Exp>>;
  _not?: InputMaybe<Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Invite_Bool_Exp>>;
};

/** unique or primary key constraints on table "Invite" */
export enum Invite_Constraint {
  /** unique or primary key constraint on columns "Code" */
  IxCode = 'IX_Code',
  /** unique or primary key constraint on columns "Id" */
  InvitePkey = 'Invite_pkey'
}

/** input type for inserting data into table "Invite" */
export type Invite_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  AccountId?: InputMaybe<Scalars['uuid']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresAt?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientFirstname?: InputMaybe<Scalars['String']>;
  RecipientLastname?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['String']>;
  User?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invite_Max_Fields = {
  __typename?: 'Invite_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ExpiresAt?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientFirstname?: Maybe<Scalars['String']>;
  RecipientLastname?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Invite" */
export type Invite_Max_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientFirstname?: InputMaybe<Order_By>;
  RecipientLastname?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invite_Min_Fields = {
  __typename?: 'Invite_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  ExpiresAt?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Message?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientFirstname?: Maybe<Scalars['String']>;
  RecipientLastname?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Invite" */
export type Invite_Min_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientFirstname?: InputMaybe<Order_By>;
  RecipientLastname?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Invite" */
export type Invite_Mutation_Response = {
  __typename?: 'Invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite>;
};

/** on_conflict condition type for table "Invite" */
export type Invite_On_Conflict = {
  constraint: Invite_Constraint;
  update_columns?: Array<Invite_Update_Column>;
  where?: InputMaybe<Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "Invite". */
export type Invite_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  AccountId?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  ExpiresAt?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Message?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientFirstname?: InputMaybe<Order_By>;
  RecipientLastname?: InputMaybe<Order_By>;
  Status?: InputMaybe<Order_By>;
  User?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: Invite */
export type Invite_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Invite" */
export enum Invite_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ExpiresAt = 'ExpiresAt',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientFirstname = 'RecipientFirstname',
  /** column name */
  RecipientLastname = 'RecipientLastname',
  /** column name */
  Status = 'Status'
}

/** input type for updating data in table "Invite" */
export type Invite_Set_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresAt?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientFirstname?: InputMaybe<Scalars['String']>;
  RecipientLastname?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Invite" */
export type Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invite_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  ExpiresAt?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Message?: InputMaybe<Scalars['String']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientFirstname?: InputMaybe<Scalars['String']>;
  RecipientLastname?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Invite" */
export enum Invite_Update_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  ExpiresAt = 'ExpiresAt',
  /** column name */
  Id = 'Id',
  /** column name */
  Message = 'Message',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientFirstname = 'RecipientFirstname',
  /** column name */
  RecipientLastname = 'RecipientLastname',
  /** column name */
  Status = 'Status'
}

export type Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Set_Input>;
  where: Invite_Bool_Exp;
};

export type InvoiceAddress = {
  InvoiceAddress0?: InputMaybe<Scalars['String']>;
  InvoiceAddress1?: InputMaybe<Scalars['String']>;
  InvoiceCity?: InputMaybe<Scalars['String']>;
  InvoiceCountry?: InputMaybe<Scalars['String']>;
  InvoicePostCode?: InputMaybe<Scalars['String']>;
  InvoiceState?: InputMaybe<Scalars['String']>;
};

export type LinkedUserProfile = {
  __typename?: 'LinkedUserProfile';
  Name?: Maybe<Scalars['String']>;
  ProfileLink?: Maybe<Scalars['String']>;
  ProfileType?: Maybe<Scalars['String']>;
};

export type ListAccountSupportersAggregate = {
  __typename?: 'ListAccountSupportersAggregate';
  aggregate?: Maybe<ListAccountSupportersAggregateAggregate>;
};

export type ListAccountSupportersAggregateAggregate = {
  __typename?: 'ListAccountSupportersAggregateAggregate';
  count: Scalars['Int'];
};

export type ListAccountSupportersInput = {
  AccountId: Scalars['uuid'];
  Offset?: InputMaybe<Scalars['Int']>;
};

export type ListAccountSupportersOutput = {
  __typename?: 'ListAccountSupportersOutput';
  Funder?: Maybe<Array<ListAccountSupportersSupporter>>;
  Funder_aggregate?: Maybe<ListAccountSupportersAggregate>;
  Planter?: Maybe<Array<ListAccountSupportersSupporter>>;
  Planter_aggregate?: Maybe<ListAccountSupportersAggregate>;
};

export type ListAccountSupportersSupporter = {
  __typename?: 'ListAccountSupportersSupporter';
  Avatar?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Name: Scalars['String'];
  Region: Scalars['String'];
  Trees: Scalars['bigint'];
  Type: Scalars['String'];
  Uri: Scalars['String'];
};

export type ListCertificationsOutput = {
  __typename?: 'ListCertificationsOutput';
  result: ListCertificationsResult;
};

export type ListCertificationsResult = {
  __typename?: 'ListCertificationsResult';
  data?: Maybe<ListCertificationsResultData>;
  type: Scalars['String'];
};

export type ListCertificationsResultData = {
  __typename?: 'ListCertificationsResultData';
  json: Array<Certification>;
};

/** columns and relationships of "LoginEvent" */
export type LoginEvent = {
  __typename?: 'LoginEvent';
  CreatedOn: Scalars['timestamp'];
  IPAddress: Scalars['String'];
  IPLocation: Scalars['String'];
  Id: Scalars['uuid'];
  Identifier: Scalars['String'];
  Type: Scalars['smallint'];
};

/** aggregated selection of "LoginEvent" */
export type LoginEvent_Aggregate = {
  __typename?: 'LoginEvent_aggregate';
  aggregate?: Maybe<LoginEvent_Aggregate_Fields>;
  nodes: Array<LoginEvent>;
};

/** aggregate fields of "LoginEvent" */
export type LoginEvent_Aggregate_Fields = {
  __typename?: 'LoginEvent_aggregate_fields';
  avg?: Maybe<LoginEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<LoginEvent_Max_Fields>;
  min?: Maybe<LoginEvent_Min_Fields>;
  stddev?: Maybe<LoginEvent_Stddev_Fields>;
  stddev_pop?: Maybe<LoginEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<LoginEvent_Stddev_Samp_Fields>;
  sum?: Maybe<LoginEvent_Sum_Fields>;
  var_pop?: Maybe<LoginEvent_Var_Pop_Fields>;
  var_samp?: Maybe<LoginEvent_Var_Samp_Fields>;
  variance?: Maybe<LoginEvent_Variance_Fields>;
};


/** aggregate fields of "LoginEvent" */
export type LoginEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LoginEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LoginEvent_Avg_Fields = {
  __typename?: 'LoginEvent_avg_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "LoginEvent". All fields are combined with a logical 'AND'. */
export type LoginEvent_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  IPAddress?: InputMaybe<String_Comparison_Exp>;
  IPLocation?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Identifier?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  _and?: InputMaybe<Array<LoginEvent_Bool_Exp>>;
  _not?: InputMaybe<LoginEvent_Bool_Exp>;
  _or?: InputMaybe<Array<LoginEvent_Bool_Exp>>;
};

/** unique or primary key constraints on table "LoginEvent" */
export enum LoginEvent_Constraint {
  /** unique or primary key constraint on columns "Id" */
  LoginEventPkey = 'LoginEvent_pkey'
}

/** input type for incrementing numeric columns in table "LoginEvent" */
export type LoginEvent_Inc_Input = {
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "LoginEvent" */
export type LoginEvent_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate max on columns */
export type LoginEvent_Max_Fields = {
  __typename?: 'LoginEvent_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  IPAddress?: Maybe<Scalars['String']>;
  IPLocation?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Identifier?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** aggregate min on columns */
export type LoginEvent_Min_Fields = {
  __typename?: 'LoginEvent_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  IPAddress?: Maybe<Scalars['String']>;
  IPLocation?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Identifier?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** response of any mutation on the table "LoginEvent" */
export type LoginEvent_Mutation_Response = {
  __typename?: 'LoginEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LoginEvent>;
};

/** on_conflict condition type for table "LoginEvent" */
export type LoginEvent_On_Conflict = {
  constraint: LoginEvent_Constraint;
  update_columns?: Array<LoginEvent_Update_Column>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "LoginEvent". */
export type LoginEvent_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  IPAddress?: InputMaybe<Order_By>;
  IPLocation?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Identifier?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: LoginEvent */
export type LoginEvent_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "LoginEvent" */
export enum LoginEvent_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  IpAddress = 'IPAddress',
  /** column name */
  IpLocation = 'IPLocation',
  /** column name */
  Id = 'Id',
  /** column name */
  Identifier = 'Identifier',
  /** column name */
  Type = 'Type'
}

/** input type for updating data in table "LoginEvent" */
export type LoginEvent_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type LoginEvent_Stddev_Fields = {
  __typename?: 'LoginEvent_stddev_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LoginEvent_Stddev_Pop_Fields = {
  __typename?: 'LoginEvent_stddev_pop_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LoginEvent_Stddev_Samp_Fields = {
  __typename?: 'LoginEvent_stddev_samp_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "LoginEvent" */
export type LoginEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: LoginEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type LoginEvent_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type LoginEvent_Sum_Fields = {
  __typename?: 'LoginEvent_sum_fields';
  Type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "LoginEvent" */
export enum LoginEvent_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  IpAddress = 'IPAddress',
  /** column name */
  IpLocation = 'IPLocation',
  /** column name */
  Id = 'Id',
  /** column name */
  Identifier = 'Identifier',
  /** column name */
  Type = 'Type'
}

export type LoginEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LoginEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LoginEvent_Set_Input>;
  where: LoginEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type LoginEvent_Var_Pop_Fields = {
  __typename?: 'LoginEvent_var_pop_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LoginEvent_Var_Samp_Fields = {
  __typename?: 'LoginEvent_var_samp_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LoginEvent_Variance_Fields = {
  __typename?: 'LoginEvent_variance_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Match" */
export type Match = {
  __typename?: 'Match';
  /** An object relationship */
  Application: Application;
  ApplicationId: Scalars['uuid'];
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  /** An object relationship */
  Instruction: Instruction;
  InstructionId: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "Match" */
export type Match_Aggregate = {
  __typename?: 'Match_aggregate';
  aggregate?: Maybe<Match_Aggregate_Fields>;
  nodes: Array<Match>;
};

export type Match_Aggregate_Bool_Exp = {
  count?: InputMaybe<Match_Aggregate_Bool_Exp_Count>;
};

export type Match_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Match_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Match_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Match" */
export type Match_Aggregate_Fields = {
  __typename?: 'Match_aggregate_fields';
  avg?: Maybe<Match_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Match_Max_Fields>;
  min?: Maybe<Match_Min_Fields>;
  stddev?: Maybe<Match_Stddev_Fields>;
  stddev_pop?: Maybe<Match_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Match_Stddev_Samp_Fields>;
  sum?: Maybe<Match_Sum_Fields>;
  var_pop?: Maybe<Match_Var_Pop_Fields>;
  var_samp?: Maybe<Match_Var_Samp_Fields>;
  variance?: Maybe<Match_Variance_Fields>;
};


/** aggregate fields of "Match" */
export type Match_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Match_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Match" */
export type Match_Aggregate_Order_By = {
  avg?: InputMaybe<Match_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Match_Max_Order_By>;
  min?: InputMaybe<Match_Min_Order_By>;
  stddev?: InputMaybe<Match_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Match_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Match_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Match_Sum_Order_By>;
  var_pop?: InputMaybe<Match_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Match_Var_Samp_Order_By>;
  variance?: InputMaybe<Match_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Match" */
export type Match_Arr_Rel_Insert_Input = {
  data: Array<Match_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Match_On_Conflict>;
};

/** aggregate avg on columns */
export type Match_Avg_Fields = {
  __typename?: 'Match_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Match" */
export type Match_Avg_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Match". All fields are combined with a logical 'AND'. */
export type Match_Bool_Exp = {
  Application?: InputMaybe<Application_Bool_Exp>;
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Instruction?: InputMaybe<Instruction_Bool_Exp>;
  InstructionId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Match_Bool_Exp>>;
  _not?: InputMaybe<Match_Bool_Exp>;
  _or?: InputMaybe<Array<Match_Bool_Exp>>;
};

/** unique or primary key constraints on table "Match" */
export enum Match_Constraint {
  /** unique or primary key constraint on columns "Id" */
  MatchPkey = 'Match_pkey'
}

/** input type for incrementing numeric columns in table "Match" */
export type Match_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Match" */
export type Match_Insert_Input = {
  Application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Instruction?: InputMaybe<Instruction_Obj_Rel_Insert_Input>;
  InstructionId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Match_Max_Fields = {
  __typename?: 'Match_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  InstructionId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "Match" */
export type Match_Max_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InstructionId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Match_Min_Fields = {
  __typename?: 'Match_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  InstructionId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "Match" */
export type Match_Min_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InstructionId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Match" */
export type Match_Mutation_Response = {
  __typename?: 'Match_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Match>;
};

/** on_conflict condition type for table "Match" */
export type Match_On_Conflict = {
  constraint: Match_Constraint;
  update_columns?: Array<Match_Update_Column>;
  where?: InputMaybe<Match_Bool_Exp>;
};

/** Ordering options when selecting data from "Match". */
export type Match_Order_By = {
  Application?: InputMaybe<Application_Order_By>;
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Instruction?: InputMaybe<Instruction_Order_By>;
  InstructionId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Match */
export type Match_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Match" */
export enum Match_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  InstructionId = 'InstructionId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Match" */
export type Match_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InstructionId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Match_Stddev_Fields = {
  __typename?: 'Match_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Match" */
export type Match_Stddev_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Match_Stddev_Pop_Fields = {
  __typename?: 'Match_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Match" */
export type Match_Stddev_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Match_Stddev_Samp_Fields = {
  __typename?: 'Match_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Match" */
export type Match_Stddev_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Match" */
export type Match_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Match_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Match_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InstructionId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Match_Sum_Fields = {
  __typename?: 'Match_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Match" */
export type Match_Sum_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** update columns of table "Match" */
export enum Match_Update_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  InstructionId = 'InstructionId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Match_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Match_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Match_Set_Input>;
  where: Match_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Match_Var_Pop_Fields = {
  __typename?: 'Match_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Match" */
export type Match_Var_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Match_Var_Samp_Fields = {
  __typename?: 'Match_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Match" */
export type Match_Var_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Match_Variance_Fields = {
  __typename?: 'Match_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Match" */
export type Match_Variance_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "Membership" */
export type Membership = {
  __typename?: 'Membership';
  /** An object relationship */
  Account: Account;
  AccountId: Scalars['uuid'];
  Id: Scalars['uuid'];
  Type: Scalars['smallint'];
  /** An object relationship */
  User: User;
  UserId: Scalars['uuid'];
};

/** aggregated selection of "Membership" */
export type Membership_Aggregate = {
  __typename?: 'Membership_aggregate';
  aggregate?: Maybe<Membership_Aggregate_Fields>;
  nodes: Array<Membership>;
};

export type Membership_Aggregate_Bool_Exp = {
  count?: InputMaybe<Membership_Aggregate_Bool_Exp_Count>;
};

export type Membership_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Membership_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Membership" */
export type Membership_Aggregate_Fields = {
  __typename?: 'Membership_aggregate_fields';
  avg?: Maybe<Membership_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Membership_Max_Fields>;
  min?: Maybe<Membership_Min_Fields>;
  stddev?: Maybe<Membership_Stddev_Fields>;
  stddev_pop?: Maybe<Membership_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Membership_Stddev_Samp_Fields>;
  sum?: Maybe<Membership_Sum_Fields>;
  var_pop?: Maybe<Membership_Var_Pop_Fields>;
  var_samp?: Maybe<Membership_Var_Samp_Fields>;
  variance?: Maybe<Membership_Variance_Fields>;
};


/** aggregate fields of "Membership" */
export type Membership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Membership" */
export type Membership_Aggregate_Order_By = {
  avg?: InputMaybe<Membership_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Membership_Max_Order_By>;
  min?: InputMaybe<Membership_Min_Order_By>;
  stddev?: InputMaybe<Membership_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Membership_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Membership_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Membership_Sum_Order_By>;
  var_pop?: InputMaybe<Membership_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Membership_Var_Samp_Order_By>;
  variance?: InputMaybe<Membership_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Membership" */
export type Membership_Arr_Rel_Insert_Input = {
  data: Array<Membership_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Membership_On_Conflict>;
};

/** aggregate avg on columns */
export type Membership_Avg_Fields = {
  __typename?: 'Membership_avg_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Membership" */
export type Membership_Avg_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Membership". All fields are combined with a logical 'AND'. */
export type Membership_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  User?: InputMaybe<User_Bool_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Membership_Bool_Exp>>;
  _not?: InputMaybe<Membership_Bool_Exp>;
  _or?: InputMaybe<Array<Membership_Bool_Exp>>;
};

/** unique or primary key constraints on table "Membership" */
export enum Membership_Constraint {
  /** unique or primary key constraint on columns "Id" */
  MembershipPkey = 'Membership_pkey'
}

/** input type for incrementing numeric columns in table "Membership" */
export type Membership_Inc_Input = {
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "Membership" */
export type Membership_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  AccountId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['smallint']>;
  User?: InputMaybe<User_Obj_Rel_Insert_Input>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Membership_Max_Fields = {
  __typename?: 'Membership_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['smallint']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "Membership" */
export type Membership_Max_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Membership_Min_Fields = {
  __typename?: 'Membership_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['smallint']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "Membership" */
export type Membership_Min_Order_By = {
  AccountId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Membership" */
export type Membership_Mutation_Response = {
  __typename?: 'Membership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Membership>;
};

/** on_conflict condition type for table "Membership" */
export type Membership_On_Conflict = {
  constraint: Membership_Constraint;
  update_columns?: Array<Membership_Update_Column>;
  where?: InputMaybe<Membership_Bool_Exp>;
};

/** Ordering options when selecting data from "Membership". */
export type Membership_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  AccountId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  User?: InputMaybe<User_Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Membership */
export type Membership_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Membership" */
export enum Membership_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  Id = 'Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UserId = 'UserId'
}

/** input type for updating data in table "Membership" */
export type Membership_Set_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Membership_Stddev_Fields = {
  __typename?: 'Membership_stddev_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Membership" */
export type Membership_Stddev_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Membership_Stddev_Pop_Fields = {
  __typename?: 'Membership_stddev_pop_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Membership" */
export type Membership_Stddev_Pop_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Membership_Stddev_Samp_Fields = {
  __typename?: 'Membership_stddev_samp_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Membership" */
export type Membership_Stddev_Samp_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Membership" */
export type Membership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Membership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Membership_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Membership_Sum_Fields = {
  __typename?: 'Membership_sum_fields';
  Type?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "Membership" */
export type Membership_Sum_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** update columns of table "Membership" */
export enum Membership_Update_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  Id = 'Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UserId = 'UserId'
}

export type Membership_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Membership_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Membership_Set_Input>;
  where: Membership_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Membership_Var_Pop_Fields = {
  __typename?: 'Membership_var_pop_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Membership" */
export type Membership_Var_Pop_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Membership_Var_Samp_Fields = {
  __typename?: 'Membership_var_samp_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Membership" */
export type Membership_Var_Samp_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Membership_Variance_Fields = {
  __typename?: 'Membership_variance_fields';
  Type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Membership" */
export type Membership_Variance_Order_By = {
  Type?: InputMaybe<Order_By>;
};

/** columns and relationships of "MonitoringAsset" */
export type MonitoringAsset = {
  __typename?: 'MonitoringAsset';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  /** An object relationship */
  MonitoringEvent?: Maybe<MonitoringEvent>;
  MonitoringEventId?: Maybe<Scalars['uuid']>;
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "MonitoringAsset" */
export type MonitoringAsset_Aggregate = {
  __typename?: 'MonitoringAsset_aggregate';
  aggregate?: Maybe<MonitoringAsset_Aggregate_Fields>;
  nodes: Array<MonitoringAsset>;
};

export type MonitoringAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<MonitoringAsset_Aggregate_Bool_Exp_Count>;
};

export type MonitoringAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "MonitoringAsset" */
export type MonitoringAsset_Aggregate_Fields = {
  __typename?: 'MonitoringAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<MonitoringAsset_Max_Fields>;
  min?: Maybe<MonitoringAsset_Min_Fields>;
};


/** aggregate fields of "MonitoringAsset" */
export type MonitoringAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "MonitoringAsset" */
export type MonitoringAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MonitoringAsset_Max_Order_By>;
  min?: InputMaybe<MonitoringAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "MonitoringAsset" */
export type MonitoringAsset_Arr_Rel_Insert_Input = {
  data: Array<MonitoringAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MonitoringAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "MonitoringAsset". All fields are combined with a logical 'AND'. */
export type MonitoringAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Bool_Exp>;
  MonitoringEventId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<MonitoringAsset_Bool_Exp>>;
  _not?: InputMaybe<MonitoringAsset_Bool_Exp>;
  _or?: InputMaybe<Array<MonitoringAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "MonitoringAsset" */
export enum MonitoringAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  MonitoringAssetPkey = 'MonitoringAsset_pkey'
}

/** input type for inserting data into table "MonitoringAsset" */
export type MonitoringAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Obj_Rel_Insert_Input>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MonitoringAsset_Max_Fields = {
  __typename?: 'MonitoringAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoringEventId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "MonitoringAsset" */
export type MonitoringAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MonitoringAsset_Min_Fields = {
  __typename?: 'MonitoringAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoringEventId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "MonitoringAsset" */
export type MonitoringAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "MonitoringAsset" */
export type MonitoringAsset_Mutation_Response = {
  __typename?: 'MonitoringAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MonitoringAsset>;
};

/** on_conflict condition type for table "MonitoringAsset" */
export type MonitoringAsset_On_Conflict = {
  constraint: MonitoringAsset_Constraint;
  update_columns?: Array<MonitoringAsset_Update_Column>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "MonitoringAsset". */
export type MonitoringAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: MonitoringAsset */
export type MonitoringAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "MonitoringAsset" */
export enum MonitoringAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoringEventId = 'MonitoringEventId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "MonitoringAsset" */
export type MonitoringAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "MonitoringAsset" */
export type MonitoringAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MonitoringAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MonitoringAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "MonitoringAsset" */
export enum MonitoringAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoringEventId = 'MonitoringEventId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type MonitoringAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MonitoringAsset_Set_Input>;
  where: MonitoringAsset_Bool_Exp;
};

/** columns and relationships of "MonitoringEvent" */
export type MonitoringEvent = {
  __typename?: 'MonitoringEvent';
  Action: Scalars['Int'];
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  MonitoredOn: Scalars['timestamp'];
  /** An array relationship */
  MonitoringAssets: Array<MonitoringAsset>;
  /** An aggregate relationship */
  MonitoringAssets_aggregate: MonitoringAsset_Aggregate;
  /** An array relationship */
  MonitoringLines: Array<MonitoringLine>;
  /** An aggregate relationship */
  MonitoringLines_aggregate: MonitoringLine_Aggregate;
  Notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planter: Planter;
  PlanterId: Scalars['uuid'];
  /** An object relationship */
  Planting: Planting;
  PlantingId: Scalars['uuid'];
  SampleId?: Maybe<Scalars['uuid']>;
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "MonitoringEvent" */
export type MonitoringEventMonitoringAssetsArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


/** columns and relationships of "MonitoringEvent" */
export type MonitoringEventMonitoringAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


/** columns and relationships of "MonitoringEvent" */
export type MonitoringEventMonitoringLinesArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


/** columns and relationships of "MonitoringEvent" */
export type MonitoringEventMonitoringLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};

/** aggregated selection of "MonitoringEvent" */
export type MonitoringEvent_Aggregate = {
  __typename?: 'MonitoringEvent_aggregate';
  aggregate?: Maybe<MonitoringEvent_Aggregate_Fields>;
  nodes: Array<MonitoringEvent>;
};

export type MonitoringEvent_Aggregate_Bool_Exp = {
  count?: InputMaybe<MonitoringEvent_Aggregate_Bool_Exp_Count>;
};

export type MonitoringEvent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringEvent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "MonitoringEvent" */
export type MonitoringEvent_Aggregate_Fields = {
  __typename?: 'MonitoringEvent_aggregate_fields';
  avg?: Maybe<MonitoringEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MonitoringEvent_Max_Fields>;
  min?: Maybe<MonitoringEvent_Min_Fields>;
  stddev?: Maybe<MonitoringEvent_Stddev_Fields>;
  stddev_pop?: Maybe<MonitoringEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MonitoringEvent_Stddev_Samp_Fields>;
  sum?: Maybe<MonitoringEvent_Sum_Fields>;
  var_pop?: Maybe<MonitoringEvent_Var_Pop_Fields>;
  var_samp?: Maybe<MonitoringEvent_Var_Samp_Fields>;
  variance?: Maybe<MonitoringEvent_Variance_Fields>;
};


/** aggregate fields of "MonitoringEvent" */
export type MonitoringEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "MonitoringEvent" */
export type MonitoringEvent_Aggregate_Order_By = {
  avg?: InputMaybe<MonitoringEvent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MonitoringEvent_Max_Order_By>;
  min?: InputMaybe<MonitoringEvent_Min_Order_By>;
  stddev?: InputMaybe<MonitoringEvent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MonitoringEvent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MonitoringEvent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MonitoringEvent_Sum_Order_By>;
  var_pop?: InputMaybe<MonitoringEvent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MonitoringEvent_Var_Samp_Order_By>;
  variance?: InputMaybe<MonitoringEvent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "MonitoringEvent" */
export type MonitoringEvent_Arr_Rel_Insert_Input = {
  data: Array<MonitoringEvent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MonitoringEvent_On_Conflict>;
};

/** aggregate avg on columns */
export type MonitoringEvent_Avg_Fields = {
  __typename?: 'MonitoringEvent_avg_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Avg_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MonitoringEvent". All fields are combined with a logical 'AND'. */
export type MonitoringEvent_Bool_Exp = {
  Action?: InputMaybe<Int_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  MonitoredOn?: InputMaybe<Timestamp_Comparison_Exp>;
  MonitoringAssets?: InputMaybe<MonitoringAsset_Bool_Exp>;
  MonitoringAssets_aggregate?: InputMaybe<MonitoringAsset_Aggregate_Bool_Exp>;
  MonitoringLines?: InputMaybe<MonitoringLine_Bool_Exp>;
  MonitoringLines_aggregate?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp>;
  Notes?: InputMaybe<String_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  Planting?: InputMaybe<Planting_Bool_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  SampleId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<MonitoringEvent_Bool_Exp>>;
  _not?: InputMaybe<MonitoringEvent_Bool_Exp>;
  _or?: InputMaybe<Array<MonitoringEvent_Bool_Exp>>;
};

/** unique or primary key constraints on table "MonitoringEvent" */
export enum MonitoringEvent_Constraint {
  /** unique or primary key constraint on columns "Id" */
  MonitoringEventPkey = 'MonitoringEvent_pkey'
}

/** input type for incrementing numeric columns in table "MonitoringEvent" */
export type MonitoringEvent_Inc_Input = {
  Action?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "MonitoringEvent" */
export type MonitoringEvent_Insert_Input = {
  Action?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoredOn?: InputMaybe<Scalars['timestamp']>;
  MonitoringAssets?: InputMaybe<MonitoringAsset_Arr_Rel_Insert_Input>;
  MonitoringLines?: InputMaybe<MonitoringLine_Arr_Rel_Insert_Input>;
  Notes?: InputMaybe<Scalars['String']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  Planting?: InputMaybe<Planting_Obj_Rel_Insert_Input>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type MonitoringEvent_Max_Fields = {
  __typename?: 'MonitoringEvent_max_fields';
  Action?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoredOn?: Maybe<Scalars['timestamp']>;
  Notes?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  SampleId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Max_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoredOn?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  SampleId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MonitoringEvent_Min_Fields = {
  __typename?: 'MonitoringEvent_min_fields';
  Action?: Maybe<Scalars['Int']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoredOn?: Maybe<Scalars['timestamp']>;
  Notes?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  SampleId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Min_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoredOn?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  SampleId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "MonitoringEvent" */
export type MonitoringEvent_Mutation_Response = {
  __typename?: 'MonitoringEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MonitoringEvent>;
};

/** input type for inserting object relation for remote table "MonitoringEvent" */
export type MonitoringEvent_Obj_Rel_Insert_Input = {
  data: MonitoringEvent_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MonitoringEvent_On_Conflict>;
};

/** on_conflict condition type for table "MonitoringEvent" */
export type MonitoringEvent_On_Conflict = {
  constraint: MonitoringEvent_Constraint;
  update_columns?: Array<MonitoringEvent_Update_Column>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "MonitoringEvent". */
export type MonitoringEvent_Order_By = {
  Action?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoredOn?: InputMaybe<Order_By>;
  MonitoringAssets_aggregate?: InputMaybe<MonitoringAsset_Aggregate_Order_By>;
  MonitoringLines_aggregate?: InputMaybe<MonitoringLine_Aggregate_Order_By>;
  Notes?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  Planting?: InputMaybe<Planting_Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  SampleId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: MonitoringEvent */
export type MonitoringEvent_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "MonitoringEvent" */
export enum MonitoringEvent_Select_Column {
  /** column name */
  Action = 'Action',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoredOn = 'MonitoredOn',
  /** column name */
  Notes = 'Notes',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  SampleId = 'SampleId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "MonitoringEvent" */
export type MonitoringEvent_Set_Input = {
  Action?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoredOn?: InputMaybe<Scalars['timestamp']>;
  Notes?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type MonitoringEvent_Stddev_Fields = {
  __typename?: 'MonitoringEvent_stddev_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Stddev_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MonitoringEvent_Stddev_Pop_Fields = {
  __typename?: 'MonitoringEvent_stddev_pop_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Stddev_Pop_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MonitoringEvent_Stddev_Samp_Fields = {
  __typename?: 'MonitoringEvent_stddev_samp_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Stddev_Samp_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "MonitoringEvent" */
export type MonitoringEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MonitoringEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MonitoringEvent_Stream_Cursor_Value_Input = {
  Action?: InputMaybe<Scalars['Int']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoredOn?: InputMaybe<Scalars['timestamp']>;
  Notes?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type MonitoringEvent_Sum_Fields = {
  __typename?: 'MonitoringEvent_sum_fields';
  Action?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Sum_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "MonitoringEvent" (current role has no relevant permissions) */
export enum MonitoringEvent_Update_Column {
  /** column name */
  Action = 'Action',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoredOn = 'MonitoredOn',
  /** column name */
  Notes = 'Notes',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  SampleId = 'SampleId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type MonitoringEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MonitoringEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MonitoringEvent_Set_Input>;
  where: MonitoringEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MonitoringEvent_Var_Pop_Fields = {
  __typename?: 'MonitoringEvent_var_pop_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Var_Pop_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MonitoringEvent_Var_Samp_Fields = {
  __typename?: 'MonitoringEvent_var_samp_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Var_Samp_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MonitoringEvent_Variance_Fields = {
  __typename?: 'MonitoringEvent_variance_fields';
  Action?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "MonitoringEvent" */
export type MonitoringEvent_Variance_Order_By = {
  Action?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** columns and relationships of "MonitoringLine" */
export type MonitoringLine = {
  __typename?: 'MonitoringLine';
  CreatedOn: Scalars['timestamp'];
  HeightAverage: Scalars['float8'];
  HeightPercentage: Scalars['float8'];
  Id: Scalars['uuid'];
  /** An object relationship */
  MonitoringEvent: MonitoringEvent;
  MonitoringEventId: Scalars['uuid'];
  Notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  PlantingLine?: Maybe<PlantingLine>;
  PlantingLineId?: Maybe<Scalars['uuid']>;
  SampleLineId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Species: Species;
  SpeciesId: Scalars['uuid'];
  SurvivingPercent: Scalars['float8'];
  SurvivingTrees: Scalars['bigint'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "MonitoringLine" */
export type MonitoringLine_Aggregate = {
  __typename?: 'MonitoringLine_aggregate';
  aggregate?: Maybe<MonitoringLine_Aggregate_Fields>;
  nodes: Array<MonitoringLine>;
};

export type MonitoringLine_Aggregate_Bool_Exp = {
  avg?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<MonitoringLine_Aggregate_Bool_Exp_Var_Samp>;
};

export type MonitoringLine_Aggregate_Bool_Exp_Avg = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Corr = {
  arguments: MonitoringLine_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Corr_Arguments = {
  X: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type MonitoringLine_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: MonitoringLine_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type MonitoringLine_Aggregate_Bool_Exp_Max = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Min = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Sum = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MonitoringLine_Aggregate_Bool_Exp_Var_Samp = {
  arguments: MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MonitoringLine_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "MonitoringLine" */
export type MonitoringLine_Aggregate_Fields = {
  __typename?: 'MonitoringLine_aggregate_fields';
  avg?: Maybe<MonitoringLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MonitoringLine_Max_Fields>;
  min?: Maybe<MonitoringLine_Min_Fields>;
  stddev?: Maybe<MonitoringLine_Stddev_Fields>;
  stddev_pop?: Maybe<MonitoringLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MonitoringLine_Stddev_Samp_Fields>;
  sum?: Maybe<MonitoringLine_Sum_Fields>;
  var_pop?: Maybe<MonitoringLine_Var_Pop_Fields>;
  var_samp?: Maybe<MonitoringLine_Var_Samp_Fields>;
  variance?: Maybe<MonitoringLine_Variance_Fields>;
};


/** aggregate fields of "MonitoringLine" */
export type MonitoringLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "MonitoringLine" */
export type MonitoringLine_Aggregate_Order_By = {
  avg?: InputMaybe<MonitoringLine_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MonitoringLine_Max_Order_By>;
  min?: InputMaybe<MonitoringLine_Min_Order_By>;
  stddev?: InputMaybe<MonitoringLine_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MonitoringLine_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MonitoringLine_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MonitoringLine_Sum_Order_By>;
  var_pop?: InputMaybe<MonitoringLine_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MonitoringLine_Var_Samp_Order_By>;
  variance?: InputMaybe<MonitoringLine_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "MonitoringLine" */
export type MonitoringLine_Arr_Rel_Insert_Input = {
  data: Array<MonitoringLine_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MonitoringLine_On_Conflict>;
};

/** aggregate avg on columns */
export type MonitoringLine_Avg_Fields = {
  __typename?: 'MonitoringLine_avg_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "MonitoringLine" */
export type MonitoringLine_Avg_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "MonitoringLine". All fields are combined with a logical 'AND'. */
export type MonitoringLine_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  HeightAverage?: InputMaybe<Float8_Comparison_Exp>;
  HeightPercentage?: InputMaybe<Float8_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Bool_Exp>;
  MonitoringEventId?: InputMaybe<Uuid_Comparison_Exp>;
  Notes?: InputMaybe<String_Comparison_Exp>;
  PlantingLine?: InputMaybe<PlantingLine_Bool_Exp>;
  PlantingLineId?: InputMaybe<Uuid_Comparison_Exp>;
  SampleLineId?: InputMaybe<Uuid_Comparison_Exp>;
  Species?: InputMaybe<Species_Bool_Exp>;
  SpeciesId?: InputMaybe<Uuid_Comparison_Exp>;
  SurvivingPercent?: InputMaybe<Float8_Comparison_Exp>;
  SurvivingTrees?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<MonitoringLine_Bool_Exp>>;
  _not?: InputMaybe<MonitoringLine_Bool_Exp>;
  _or?: InputMaybe<Array<MonitoringLine_Bool_Exp>>;
};

/** unique or primary key constraints on table "MonitoringLine" */
export enum MonitoringLine_Constraint {
  /** unique or primary key constraint on columns "Id" */
  MonitoringLinePkey = 'MonitoringLine_pkey'
}

/** input type for incrementing numeric columns in table "MonitoringLine" */
export type MonitoringLine_Inc_Input = {
  HeightAverage?: InputMaybe<Scalars['float8']>;
  HeightPercentage?: InputMaybe<Scalars['float8']>;
  SurvivingPercent?: InputMaybe<Scalars['float8']>;
  SurvivingTrees?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "MonitoringLine" */
export type MonitoringLine_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  HeightAverage?: InputMaybe<Scalars['float8']>;
  HeightPercentage?: InputMaybe<Scalars['float8']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Obj_Rel_Insert_Input>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  PlantingLine?: InputMaybe<PlantingLine_Obj_Rel_Insert_Input>;
  PlantingLineId?: InputMaybe<Scalars['uuid']>;
  SampleLineId?: InputMaybe<Scalars['uuid']>;
  Species?: InputMaybe<Species_Obj_Rel_Insert_Input>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
  SurvivingPercent?: InputMaybe<Scalars['float8']>;
  SurvivingTrees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type MonitoringLine_Max_Fields = {
  __typename?: 'MonitoringLine_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  HeightAverage?: Maybe<Scalars['float8']>;
  HeightPercentage?: Maybe<Scalars['float8']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoringEventId?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  PlantingLineId?: Maybe<Scalars['uuid']>;
  SampleLineId?: Maybe<Scalars['uuid']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
  SurvivingPercent?: Maybe<Scalars['float8']>;
  SurvivingTrees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "MonitoringLine" */
export type MonitoringLine_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  PlantingLineId?: InputMaybe<Order_By>;
  SampleLineId?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MonitoringLine_Min_Fields = {
  __typename?: 'MonitoringLine_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  HeightAverage?: Maybe<Scalars['float8']>;
  HeightPercentage?: Maybe<Scalars['float8']>;
  Id?: Maybe<Scalars['uuid']>;
  MonitoringEventId?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  PlantingLineId?: Maybe<Scalars['uuid']>;
  SampleLineId?: Maybe<Scalars['uuid']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
  SurvivingPercent?: Maybe<Scalars['float8']>;
  SurvivingTrees?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "MonitoringLine" */
export type MonitoringLine_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  PlantingLineId?: InputMaybe<Order_By>;
  SampleLineId?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "MonitoringLine" */
export type MonitoringLine_Mutation_Response = {
  __typename?: 'MonitoringLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MonitoringLine>;
};

/** on_conflict condition type for table "MonitoringLine" */
export type MonitoringLine_On_Conflict = {
  constraint: MonitoringLine_Constraint;
  update_columns?: Array<MonitoringLine_Update_Column>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};

/** Ordering options when selecting data from "MonitoringLine". */
export type MonitoringLine_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  MonitoringEvent?: InputMaybe<MonitoringEvent_Order_By>;
  MonitoringEventId?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  PlantingLine?: InputMaybe<PlantingLine_Order_By>;
  PlantingLineId?: InputMaybe<Order_By>;
  SampleLineId?: InputMaybe<Order_By>;
  Species?: InputMaybe<Species_Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: MonitoringLine */
export type MonitoringLine_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoringEventId = 'MonitoringEventId',
  /** column name */
  Notes = 'Notes',
  /** column name */
  PlantingLineId = 'PlantingLineId',
  /** column name */
  SampleLineId = 'SampleLineId',
  /** column name */
  SpeciesId = 'SpeciesId',
  /** column name */
  SurvivingPercent = 'SurvivingPercent',
  /** column name */
  SurvivingTrees = 'SurvivingTrees',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** select "MonitoringLine_aggregate_bool_exp_avg_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_corr_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_max_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_min_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_sum_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** select "MonitoringLine_aggregate_bool_exp_var_samp_arguments_columns" columns of table "MonitoringLine" */
export enum MonitoringLine_Select_Column_MonitoringLine_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  SurvivingPercent = 'SurvivingPercent'
}

/** input type for updating data in table "MonitoringLine" */
export type MonitoringLine_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  HeightAverage?: InputMaybe<Scalars['float8']>;
  HeightPercentage?: InputMaybe<Scalars['float8']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  PlantingLineId?: InputMaybe<Scalars['uuid']>;
  SampleLineId?: InputMaybe<Scalars['uuid']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
  SurvivingPercent?: InputMaybe<Scalars['float8']>;
  SurvivingTrees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type MonitoringLine_Stddev_Fields = {
  __typename?: 'MonitoringLine_stddev_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "MonitoringLine" */
export type MonitoringLine_Stddev_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MonitoringLine_Stddev_Pop_Fields = {
  __typename?: 'MonitoringLine_stddev_pop_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "MonitoringLine" */
export type MonitoringLine_Stddev_Pop_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MonitoringLine_Stddev_Samp_Fields = {
  __typename?: 'MonitoringLine_stddev_samp_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "MonitoringLine" */
export type MonitoringLine_Stddev_Samp_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "MonitoringLine" */
export type MonitoringLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MonitoringLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MonitoringLine_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  HeightAverage?: InputMaybe<Scalars['float8']>;
  HeightPercentage?: InputMaybe<Scalars['float8']>;
  Id?: InputMaybe<Scalars['uuid']>;
  MonitoringEventId?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  PlantingLineId?: InputMaybe<Scalars['uuid']>;
  SampleLineId?: InputMaybe<Scalars['uuid']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
  SurvivingPercent?: InputMaybe<Scalars['float8']>;
  SurvivingTrees?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type MonitoringLine_Sum_Fields = {
  __typename?: 'MonitoringLine_sum_fields';
  HeightAverage?: Maybe<Scalars['float8']>;
  HeightPercentage?: Maybe<Scalars['float8']>;
  SurvivingPercent?: Maybe<Scalars['float8']>;
  SurvivingTrees?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "MonitoringLine" */
export type MonitoringLine_Sum_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "MonitoringLine" (current role has no relevant permissions) */
export enum MonitoringLine_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  HeightAverage = 'HeightAverage',
  /** column name */
  HeightPercentage = 'HeightPercentage',
  /** column name */
  Id = 'Id',
  /** column name */
  MonitoringEventId = 'MonitoringEventId',
  /** column name */
  Notes = 'Notes',
  /** column name */
  PlantingLineId = 'PlantingLineId',
  /** column name */
  SampleLineId = 'SampleLineId',
  /** column name */
  SpeciesId = 'SpeciesId',
  /** column name */
  SurvivingPercent = 'SurvivingPercent',
  /** column name */
  SurvivingTrees = 'SurvivingTrees',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type MonitoringLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MonitoringLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MonitoringLine_Set_Input>;
  where: MonitoringLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MonitoringLine_Var_Pop_Fields = {
  __typename?: 'MonitoringLine_var_pop_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "MonitoringLine" */
export type MonitoringLine_Var_Pop_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MonitoringLine_Var_Samp_Fields = {
  __typename?: 'MonitoringLine_var_samp_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "MonitoringLine" */
export type MonitoringLine_Var_Samp_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MonitoringLine_Variance_Fields = {
  __typename?: 'MonitoringLine_variance_fields';
  HeightAverage?: Maybe<Scalars['Float']>;
  HeightPercentage?: Maybe<Scalars['Float']>;
  SurvivingPercent?: Maybe<Scalars['Float']>;
  SurvivingTrees?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "MonitoringLine" */
export type MonitoringLine_Variance_Order_By = {
  HeightAverage?: InputMaybe<Order_By>;
  HeightPercentage?: InputMaybe<Order_By>;
  SurvivingPercent?: InputMaybe<Order_By>;
  SurvivingTrees?: InputMaybe<Order_By>;
};

/** columns and relationships of "Plan" */
export type Plan = {
  __typename?: 'Plan';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  PlantingId: Scalars['uuid'];
  State: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};

/** columns and relationships of "PlanLine" */
export type PlanLine = {
  __typename?: 'PlanLine';
  Id: Scalars['uuid'];
  PlanId: Scalars['uuid'];
  Quantity: Scalars['float8'];
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "PlanLine" */
export type PlanLine_Aggregate = {
  __typename?: 'PlanLine_aggregate';
  aggregate?: Maybe<PlanLine_Aggregate_Fields>;
  nodes: Array<PlanLine>;
};

/** aggregate fields of "PlanLine" */
export type PlanLine_Aggregate_Fields = {
  __typename?: 'PlanLine_aggregate_fields';
  avg?: Maybe<PlanLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlanLine_Max_Fields>;
  min?: Maybe<PlanLine_Min_Fields>;
  stddev?: Maybe<PlanLine_Stddev_Fields>;
  stddev_pop?: Maybe<PlanLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlanLine_Stddev_Samp_Fields>;
  sum?: Maybe<PlanLine_Sum_Fields>;
  var_pop?: Maybe<PlanLine_Var_Pop_Fields>;
  var_samp?: Maybe<PlanLine_Var_Samp_Fields>;
  variance?: Maybe<PlanLine_Variance_Fields>;
};


/** aggregate fields of "PlanLine" */
export type PlanLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlanLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PlanLine_Avg_Fields = {
  __typename?: 'PlanLine_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PlanLine". All fields are combined with a logical 'AND'. */
export type PlanLine_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlanId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Float8_Comparison_Exp>;
  SpeciesId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<PlanLine_Bool_Exp>>;
  _not?: InputMaybe<PlanLine_Bool_Exp>;
  _or?: InputMaybe<Array<PlanLine_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlanLine" */
export enum PlanLine_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlanLinePkey = 'PlanLine_pkey'
}

/** input type for incrementing numeric columns in table "PlanLine" */
export type PlanLine_Inc_Input = {
  Quantity?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "PlanLine" */
export type PlanLine_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlanLine_Max_Fields = {
  __typename?: 'PlanLine_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  PlanId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['float8']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PlanLine_Min_Fields = {
  __typename?: 'PlanLine_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  PlanId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['float8']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "PlanLine" */
export type PlanLine_Mutation_Response = {
  __typename?: 'PlanLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlanLine>;
};

/** on_conflict condition type for table "PlanLine" */
export type PlanLine_On_Conflict = {
  constraint: PlanLine_Constraint;
  update_columns?: Array<PlanLine_Update_Column>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};

/** Ordering options when selecting data from "PlanLine". */
export type PlanLine_Order_By = {
  Id?: InputMaybe<Order_By>;
  PlanId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlanLine */
export type PlanLine_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlanLine" */
export enum PlanLine_Select_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  PlanId = 'PlanId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

/** input type for updating data in table "PlanLine" */
export type PlanLine_Set_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PlanLine_Stddev_Fields = {
  __typename?: 'PlanLine_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PlanLine_Stddev_Pop_Fields = {
  __typename?: 'PlanLine_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PlanLine_Stddev_Samp_Fields = {
  __typename?: 'PlanLine_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PlanLine" */
export type PlanLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlanLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlanLine_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  PlanId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['float8']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PlanLine_Sum_Fields = {
  __typename?: 'PlanLine_sum_fields';
  Quantity?: Maybe<Scalars['float8']>;
};

/** update columns of table "PlanLine" */
export enum PlanLine_Update_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  PlanId = 'PlanId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

export type PlanLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlanLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlanLine_Set_Input>;
  where: PlanLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PlanLine_Var_Pop_Fields = {
  __typename?: 'PlanLine_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PlanLine_Var_Samp_Fields = {
  __typename?: 'PlanLine_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PlanLine_Variance_Fields = {
  __typename?: 'PlanLine_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

export type PlanOutput = {
  __typename?: 'PlanOutput';
  planType: Scalars['String'];
  userId: Scalars['Int'];
};

/** aggregated selection of "Plan" */
export type Plan_Aggregate = {
  __typename?: 'Plan_aggregate';
  aggregate?: Maybe<Plan_Aggregate_Fields>;
  nodes: Array<Plan>;
};

/** aggregate fields of "Plan" */
export type Plan_Aggregate_Fields = {
  __typename?: 'Plan_aggregate_fields';
  avg?: Maybe<Plan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plan_Max_Fields>;
  min?: Maybe<Plan_Min_Fields>;
  stddev?: Maybe<Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Plan_Sum_Fields>;
  var_pop?: Maybe<Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Plan_Var_Samp_Fields>;
  variance?: Maybe<Plan_Variance_Fields>;
};


/** aggregate fields of "Plan" */
export type Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plan_Avg_Fields = {
  __typename?: 'Plan_avg_fields';
  State?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Plan". All fields are combined with a logical 'AND'. */
export type Plan_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Plan_Bool_Exp>>;
  _not?: InputMaybe<Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Bool_Exp>>;
};

/** unique or primary key constraints on table "Plan" */
export enum Plan_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlanPkey = 'Plan_pkey'
}

/** input type for incrementing numeric columns in table "Plan" */
export type Plan_Inc_Input = {
  State?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Plan" */
export type Plan_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Plan_Max_Fields = {
  __typename?: 'Plan_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Plan_Min_Fields = {
  __typename?: 'Plan_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Plan" */
export type Plan_Mutation_Response = {
  __typename?: 'Plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan>;
};

/** on_conflict condition type for table "Plan" */
export type Plan_On_Conflict = {
  constraint: Plan_Constraint;
  update_columns?: Array<Plan_Update_Column>;
  where?: InputMaybe<Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "Plan". */
export type Plan_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Plan */
export type Plan_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Plan" */
export enum Plan_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  State = 'State',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Plan" */
export type Plan_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Plan_Stddev_Fields = {
  __typename?: 'Plan_stddev_fields';
  State?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plan_Stddev_Pop_Fields = {
  __typename?: 'Plan_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plan_Stddev_Samp_Fields = {
  __typename?: 'Plan_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Plan" */
export type Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Plan_Sum_Fields = {
  __typename?: 'Plan_sum_fields';
  State?: Maybe<Scalars['Int']>;
};

/** update columns of table "Plan" */
export enum Plan_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  State = 'State',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Set_Input>;
  where: Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plan_Var_Pop_Fields = {
  __typename?: 'Plan_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plan_Var_Samp_Fields = {
  __typename?: 'Plan_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plan_Variance_Fields = {
  __typename?: 'Plan_variance_fields';
  State?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Planter" */
export type Planter = {
  __typename?: 'Planter';
  /** An object relationship */
  Account?: Maybe<Account>;
  /** An array relationship */
  Application: Array<Application>;
  /** An aggregate relationship */
  Application_aggregate: Application_Aggregate;
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  IsHidden: Scalars['Boolean'];
  IsPrivate: Scalars['Boolean'];
  MasterPlanter: Scalars['Boolean'];
  Name?: Maybe<Scalars['String']>;
  OwnerId: Scalars['uuid'];
  OwnerType: Scalars['smallint'];
  /** A computed field, executes function "planter_trees_planned_count" */
  PlansCount?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  PlanterRegistrations: Array<PlanterRegistration>;
  /** An aggregate relationship */
  PlanterRegistrations_aggregate: PlanterRegistration_Aggregate;
  /** A computed field, executes function "planter_plantings_count" */
  PlantingsCount?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  Projects: Array<Project>;
  /** A computed field, executes function "planter_projects_count" */
  ProjectsCount?: Maybe<Scalars['bigint']>;
  /** An aggregate relationship */
  Projects_aggregate: Project_Aggregate;
  /** A computed field, executes function "planter_trees_planted_count" */
  TreesPlanted?: Maybe<Scalars['bigint']>;
  Type: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "Planter" */
export type PlanterApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "Planter" */
export type PlanterApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "Planter" */
export type PlanterPlanterRegistrationsArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


/** columns and relationships of "Planter" */
export type PlanterPlanterRegistrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


/** columns and relationships of "Planter" */
export type PlanterProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "Planter" */
export type PlanterProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** columns and relationships of "PlanterRegistration" */
export type PlanterRegistration = {
  __typename?: 'PlanterRegistration';
  CreatedOn: Scalars['timestamp'];
  Description?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  LegacyNumberOfTrees?: Maybe<Scalars['bigint']>;
  Locations?: Maybe<Scalars['String']>;
  MonitoringDescription?: Maybe<Scalars['String']>;
  NumberOfTrees?: Maybe<Scalars['String']>;
  NumberOfYears?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  Planter: Planter;
  PlanterId: Scalars['uuid'];
  /** An array relationship */
  PlanterRegistrationAssets: Array<PlanterRegistrationAsset>;
  /** An aggregate relationship */
  PlanterRegistrationAssets_aggregate: PlanterRegistrationAsset_Aggregate;
  UpdatedOn: Scalars['timestamp'];
  WorkflowState: Scalars['String'];
};


/** columns and relationships of "PlanterRegistration" */
export type PlanterRegistrationPlanterRegistrationAssetsArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


/** columns and relationships of "PlanterRegistration" */
export type PlanterRegistrationPlanterRegistrationAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};

/** columns and relationships of "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset = {
  __typename?: 'PlanterRegistrationAsset';
  CreatedOn: Scalars['timestamp'];
  FileName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  PlanterRegistrationId: Scalars['uuid'];
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Aggregate = {
  __typename?: 'PlanterRegistrationAsset_aggregate';
  aggregate?: Maybe<PlanterRegistrationAsset_Aggregate_Fields>;
  nodes: Array<PlanterRegistrationAsset>;
};

export type PlanterRegistrationAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlanterRegistrationAsset_Aggregate_Bool_Exp_Count>;
};

export type PlanterRegistrationAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Aggregate_Fields = {
  __typename?: 'PlanterRegistrationAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PlanterRegistrationAsset_Max_Fields>;
  min?: Maybe<PlanterRegistrationAsset_Min_Fields>;
};


/** aggregate fields of "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlanterRegistrationAsset_Max_Order_By>;
  min?: InputMaybe<PlanterRegistrationAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Arr_Rel_Insert_Input = {
  data: Array<PlanterRegistrationAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlanterRegistrationAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "PlanterRegistrationAsset". All fields are combined with a logical 'AND'. */
export type PlanterRegistrationAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlanterRegistrationId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PlanterRegistrationAsset_Bool_Exp>>;
  _not?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
  _or?: InputMaybe<Array<PlanterRegistrationAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlanterRegistrationAsset" */
export enum PlanterRegistrationAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlanterRegistrationAssetPkey = 'PlanterRegistrationAsset_pkey'
}

/** input type for inserting data into table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlanterRegistrationAsset_Max_Fields = {
  __typename?: 'PlanterRegistrationAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlanterRegistrationId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlanterRegistrationId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlanterRegistrationAsset_Min_Fields = {
  __typename?: 'PlanterRegistrationAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlanterRegistrationId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlanterRegistrationId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Mutation_Response = {
  __typename?: 'PlanterRegistrationAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlanterRegistrationAsset>;
};

/** on_conflict condition type for table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_On_Conflict = {
  constraint: PlanterRegistrationAsset_Constraint;
  update_columns?: Array<PlanterRegistrationAsset_Update_Column>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "PlanterRegistrationAsset". */
export type PlanterRegistrationAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlanterRegistrationId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlanterRegistrationAsset */
export type PlanterRegistrationAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlanterRegistrationAsset" */
export enum PlanterRegistrationAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  PlanterRegistrationId = 'PlanterRegistrationId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "PlanterRegistrationAsset" */
export type PlanterRegistrationAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlanterRegistrationAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlanterRegistrationAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "PlanterRegistrationAsset" */
export enum PlanterRegistrationAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  PlanterRegistrationId = 'PlanterRegistrationId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type PlanterRegistrationAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlanterRegistrationAsset_Set_Input>;
  where: PlanterRegistrationAsset_Bool_Exp;
};

/** aggregated selection of "PlanterRegistration" */
export type PlanterRegistration_Aggregate = {
  __typename?: 'PlanterRegistration_aggregate';
  aggregate?: Maybe<PlanterRegistration_Aggregate_Fields>;
  nodes: Array<PlanterRegistration>;
};

export type PlanterRegistration_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlanterRegistration_Aggregate_Bool_Exp_Count>;
};

export type PlanterRegistration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlanterRegistration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlanterRegistration" */
export type PlanterRegistration_Aggregate_Fields = {
  __typename?: 'PlanterRegistration_aggregate_fields';
  avg?: Maybe<PlanterRegistration_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlanterRegistration_Max_Fields>;
  min?: Maybe<PlanterRegistration_Min_Fields>;
  stddev?: Maybe<PlanterRegistration_Stddev_Fields>;
  stddev_pop?: Maybe<PlanterRegistration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlanterRegistration_Stddev_Samp_Fields>;
  sum?: Maybe<PlanterRegistration_Sum_Fields>;
  var_pop?: Maybe<PlanterRegistration_Var_Pop_Fields>;
  var_samp?: Maybe<PlanterRegistration_Var_Samp_Fields>;
  variance?: Maybe<PlanterRegistration_Variance_Fields>;
};


/** aggregate fields of "PlanterRegistration" */
export type PlanterRegistration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlanterRegistration" */
export type PlanterRegistration_Aggregate_Order_By = {
  avg?: InputMaybe<PlanterRegistration_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlanterRegistration_Max_Order_By>;
  min?: InputMaybe<PlanterRegistration_Min_Order_By>;
  stddev?: InputMaybe<PlanterRegistration_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PlanterRegistration_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PlanterRegistration_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PlanterRegistration_Sum_Order_By>;
  var_pop?: InputMaybe<PlanterRegistration_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PlanterRegistration_Var_Samp_Order_By>;
  variance?: InputMaybe<PlanterRegistration_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "PlanterRegistration" */
export type PlanterRegistration_Arr_Rel_Insert_Input = {
  data: Array<PlanterRegistration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlanterRegistration_On_Conflict>;
};

/** aggregate avg on columns */
export type PlanterRegistration_Avg_Fields = {
  __typename?: 'PlanterRegistration_avg_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Avg_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "PlanterRegistration". All fields are combined with a logical 'AND'. */
export type PlanterRegistration_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LegacyNumberOfTrees?: InputMaybe<Bigint_Comparison_Exp>;
  Locations?: InputMaybe<String_Comparison_Exp>;
  MonitoringDescription?: InputMaybe<String_Comparison_Exp>;
  NumberOfTrees?: InputMaybe<String_Comparison_Exp>;
  NumberOfYears?: InputMaybe<Bigint_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlanterRegistrationAssets?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
  PlanterRegistrationAssets_aggregate?: InputMaybe<PlanterRegistrationAsset_Aggregate_Bool_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PlanterRegistration_Bool_Exp>>;
  _not?: InputMaybe<PlanterRegistration_Bool_Exp>;
  _or?: InputMaybe<Array<PlanterRegistration_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlanterRegistration" */
export enum PlanterRegistration_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlanterRegistrationPkey = 'PlanterRegistration_pkey'
}

/** input type for incrementing numeric columns in table "PlanterRegistration" */
export type PlanterRegistration_Inc_Input = {
  LegacyNumberOfTrees?: InputMaybe<Scalars['bigint']>;
  NumberOfYears?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "PlanterRegistration" */
export type PlanterRegistration_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LegacyNumberOfTrees?: InputMaybe<Scalars['bigint']>;
  Locations?: InputMaybe<Scalars['String']>;
  MonitoringDescription?: InputMaybe<Scalars['String']>;
  NumberOfTrees?: InputMaybe<Scalars['String']>;
  NumberOfYears?: InputMaybe<Scalars['bigint']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlanterRegistrationAssets?: InputMaybe<PlanterRegistrationAsset_Arr_Rel_Insert_Input>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlanterRegistration_Max_Fields = {
  __typename?: 'PlanterRegistration_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LegacyNumberOfTrees?: Maybe<Scalars['bigint']>;
  Locations?: Maybe<Scalars['String']>;
  MonitoringDescription?: Maybe<Scalars['String']>;
  NumberOfTrees?: Maybe<Scalars['String']>;
  NumberOfYears?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  Locations?: InputMaybe<Order_By>;
  MonitoringDescription?: InputMaybe<Order_By>;
  NumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlanterRegistration_Min_Fields = {
  __typename?: 'PlanterRegistration_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LegacyNumberOfTrees?: Maybe<Scalars['bigint']>;
  Locations?: Maybe<Scalars['String']>;
  MonitoringDescription?: Maybe<Scalars['String']>;
  NumberOfTrees?: Maybe<Scalars['String']>;
  NumberOfYears?: Maybe<Scalars['bigint']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  Locations?: InputMaybe<Order_By>;
  MonitoringDescription?: InputMaybe<Order_By>;
  NumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlanterRegistration" */
export type PlanterRegistration_Mutation_Response = {
  __typename?: 'PlanterRegistration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlanterRegistration>;
};

/** on_conflict condition type for table "PlanterRegistration" */
export type PlanterRegistration_On_Conflict = {
  constraint: PlanterRegistration_Constraint;
  update_columns?: Array<PlanterRegistration_Update_Column>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};

/** Ordering options when selecting data from "PlanterRegistration". */
export type PlanterRegistration_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  Locations?: InputMaybe<Order_By>;
  MonitoringDescription?: InputMaybe<Order_By>;
  NumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlanterRegistrationAssets_aggregate?: InputMaybe<PlanterRegistrationAsset_Aggregate_Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlanterRegistration */
export type PlanterRegistration_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlanterRegistration" */
export enum PlanterRegistration_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  LegacyNumberOfTrees = 'LegacyNumberOfTrees',
  /** column name */
  Locations = 'Locations',
  /** column name */
  MonitoringDescription = 'MonitoringDescription',
  /** column name */
  NumberOfTrees = 'NumberOfTrees',
  /** column name */
  NumberOfYears = 'NumberOfYears',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** input type for updating data in table "PlanterRegistration" */
export type PlanterRegistration_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LegacyNumberOfTrees?: InputMaybe<Scalars['bigint']>;
  Locations?: InputMaybe<Scalars['String']>;
  MonitoringDescription?: InputMaybe<Scalars['String']>;
  NumberOfTrees?: InputMaybe<Scalars['String']>;
  NumberOfYears?: InputMaybe<Scalars['bigint']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PlanterRegistration_Stddev_Fields = {
  __typename?: 'PlanterRegistration_stddev_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Stddev_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PlanterRegistration_Stddev_Pop_Fields = {
  __typename?: 'PlanterRegistration_stddev_pop_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Stddev_Pop_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PlanterRegistration_Stddev_Samp_Fields = {
  __typename?: 'PlanterRegistration_stddev_samp_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Stddev_Samp_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "PlanterRegistration" */
export type PlanterRegistration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlanterRegistration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlanterRegistration_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LegacyNumberOfTrees?: InputMaybe<Scalars['bigint']>;
  Locations?: InputMaybe<Scalars['String']>;
  MonitoringDescription?: InputMaybe<Scalars['String']>;
  NumberOfTrees?: InputMaybe<Scalars['String']>;
  NumberOfYears?: InputMaybe<Scalars['bigint']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PlanterRegistration_Sum_Fields = {
  __typename?: 'PlanterRegistration_sum_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['bigint']>;
  NumberOfYears?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Sum_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** update columns of table "PlanterRegistration" */
export enum PlanterRegistration_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  LegacyNumberOfTrees = 'LegacyNumberOfTrees',
  /** column name */
  Locations = 'Locations',
  /** column name */
  MonitoringDescription = 'MonitoringDescription',
  /** column name */
  NumberOfTrees = 'NumberOfTrees',
  /** column name */
  NumberOfYears = 'NumberOfYears',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  WorkflowState = 'WorkflowState'
}

export type PlanterRegistration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlanterRegistration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlanterRegistration_Set_Input>;
  where: PlanterRegistration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PlanterRegistration_Var_Pop_Fields = {
  __typename?: 'PlanterRegistration_var_pop_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Var_Pop_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PlanterRegistration_Var_Samp_Fields = {
  __typename?: 'PlanterRegistration_var_samp_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Var_Samp_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PlanterRegistration_Variance_Fields = {
  __typename?: 'PlanterRegistration_variance_fields';
  LegacyNumberOfTrees?: Maybe<Scalars['Float']>;
  NumberOfYears?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "PlanterRegistration" */
export type PlanterRegistration_Variance_Order_By = {
  LegacyNumberOfTrees?: InputMaybe<Order_By>;
  NumberOfYears?: InputMaybe<Order_By>;
};

/** Placeholder table containing columns returned for the PlanterStats function */
export type PlanterStat = {
  __typename?: 'PlanterStat';
  AccountYearJoined: Scalars['bigint'];
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName: Scalars['String'];
  TotalApplications: Scalars['bigint'];
  TotalMonitorings: Scalars['bigint'];
  TotalProjects: Scalars['bigint'];
  TreesApproved: Scalars['bigint'];
  TreesReceived: Scalars['bigint'];
};

/** aggregated selection of "PlanterStat" */
export type PlanterStat_Aggregate = {
  __typename?: 'PlanterStat_aggregate';
  aggregate?: Maybe<PlanterStat_Aggregate_Fields>;
  nodes: Array<PlanterStat>;
};

/** aggregate fields of "PlanterStat" */
export type PlanterStat_Aggregate_Fields = {
  __typename?: 'PlanterStat_aggregate_fields';
  avg?: Maybe<PlanterStat_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlanterStat_Max_Fields>;
  min?: Maybe<PlanterStat_Min_Fields>;
  stddev?: Maybe<PlanterStat_Stddev_Fields>;
  stddev_pop?: Maybe<PlanterStat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlanterStat_Stddev_Samp_Fields>;
  sum?: Maybe<PlanterStat_Sum_Fields>;
  var_pop?: Maybe<PlanterStat_Var_Pop_Fields>;
  var_samp?: Maybe<PlanterStat_Var_Samp_Fields>;
  variance?: Maybe<PlanterStat_Variance_Fields>;
};


/** aggregate fields of "PlanterStat" */
export type PlanterStat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlanterStat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PlanterStat_Avg_Fields = {
  __typename?: 'PlanterStat_avg_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PlanterStat". All fields are combined with a logical 'AND'. */
export type PlanterStat_Bool_Exp = {
  AccountYearJoined?: InputMaybe<Bigint_Comparison_Exp>;
  MostPopularRegion?: InputMaybe<String_Comparison_Exp>;
  MostPopularSpecies?: InputMaybe<String_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  TotalApplications?: InputMaybe<Bigint_Comparison_Exp>;
  TotalMonitorings?: InputMaybe<Bigint_Comparison_Exp>;
  TotalProjects?: InputMaybe<Bigint_Comparison_Exp>;
  TreesApproved?: InputMaybe<Bigint_Comparison_Exp>;
  TreesReceived?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<PlanterStat_Bool_Exp>>;
  _not?: InputMaybe<PlanterStat_Bool_Exp>;
  _or?: InputMaybe<Array<PlanterStat_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "PlanterStat" */
export type PlanterStat_Inc_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TreesReceived?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "PlanterStat" */
export type PlanterStat_Insert_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TreesReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PlanterStat_Max_Fields = {
  __typename?: 'PlanterStat_max_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TreesReceived?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PlanterStat_Min_Fields = {
  __typename?: 'PlanterStat_min_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TreesReceived?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "PlanterStat" */
export type PlanterStat_Mutation_Response = {
  __typename?: 'PlanterStat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlanterStat>;
};

/** Ordering options when selecting data from "PlanterStat". */
export type PlanterStat_Order_By = {
  AccountYearJoined?: InputMaybe<Order_By>;
  MostPopularRegion?: InputMaybe<Order_By>;
  MostPopularSpecies?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  TotalApplications?: InputMaybe<Order_By>;
  TotalMonitorings?: InputMaybe<Order_By>;
  TotalProjects?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
  TreesReceived?: InputMaybe<Order_By>;
};

/** select columns of table "PlanterStat" */
export enum PlanterStat_Select_Column {
  /** column name */
  AccountYearJoined = 'AccountYearJoined',
  /** column name */
  MostPopularRegion = 'MostPopularRegion',
  /** column name */
  MostPopularSpecies = 'MostPopularSpecies',
  /** column name */
  Rank = 'Rank',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  TotalApplications = 'TotalApplications',
  /** column name */
  TotalMonitorings = 'TotalMonitorings',
  /** column name */
  TotalProjects = 'TotalProjects',
  /** column name */
  TreesApproved = 'TreesApproved',
  /** column name */
  TreesReceived = 'TreesReceived'
}

/** input type for updating data in table "PlanterStat" */
export type PlanterStat_Set_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TreesReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PlanterStat_Stddev_Fields = {
  __typename?: 'PlanterStat_stddev_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PlanterStat_Stddev_Pop_Fields = {
  __typename?: 'PlanterStat_stddev_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PlanterStat_Stddev_Samp_Fields = {
  __typename?: 'PlanterStat_stddev_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PlanterStat" */
export type PlanterStat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlanterStat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlanterStat_Stream_Cursor_Value_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TreesReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PlanterStat_Sum_Fields = {
  __typename?: 'PlanterStat_sum_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TreesReceived?: Maybe<Scalars['bigint']>;
};

export type PlanterStat_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlanterStat_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlanterStat_Set_Input>;
  where: PlanterStat_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PlanterStat_Var_Pop_Fields = {
  __typename?: 'PlanterStat_var_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PlanterStat_Var_Samp_Fields = {
  __typename?: 'PlanterStat_var_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PlanterStat_Variance_Fields = {
  __typename?: 'PlanterStat_variance_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesReceived?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "PlanterView" */
export type PlanterView = {
  __typename?: 'PlanterView';
  AccountName?: Maybe<Scalars['String']>;
  ApplicationCount?: Maybe<Scalars['bigint']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  IsHidden?: Maybe<Scalars['Boolean']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalTreesApproved?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "PlanterView" */
export type PlanterView_Aggregate = {
  __typename?: 'PlanterView_aggregate';
  aggregate?: Maybe<PlanterView_Aggregate_Fields>;
  nodes: Array<PlanterView>;
};

/** aggregate fields of "PlanterView" */
export type PlanterView_Aggregate_Fields = {
  __typename?: 'PlanterView_aggregate_fields';
  avg?: Maybe<PlanterView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlanterView_Max_Fields>;
  min?: Maybe<PlanterView_Min_Fields>;
  stddev?: Maybe<PlanterView_Stddev_Fields>;
  stddev_pop?: Maybe<PlanterView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlanterView_Stddev_Samp_Fields>;
  sum?: Maybe<PlanterView_Sum_Fields>;
  var_pop?: Maybe<PlanterView_Var_Pop_Fields>;
  var_samp?: Maybe<PlanterView_Var_Samp_Fields>;
  variance?: Maybe<PlanterView_Variance_Fields>;
};


/** aggregate fields of "PlanterView" */
export type PlanterView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlanterView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PlanterView_Avg_Fields = {
  __typename?: 'PlanterView_avg_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PlanterView". All fields are combined with a logical 'AND'. */
export type PlanterView_Bool_Exp = {
  AccountName?: InputMaybe<String_Comparison_Exp>;
  ApplicationCount?: InputMaybe<Bigint_Comparison_Exp>;
  Avatar?: InputMaybe<String_Comparison_Exp>;
  BeforeLastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  CurrentSeason?: InputMaybe<Numeric_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  LastSeason?: InputMaybe<Numeric_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  TotalTreesApproved?: InputMaybe<Numeric_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PlanterView_Bool_Exp>>;
  _not?: InputMaybe<PlanterView_Bool_Exp>;
  _or?: InputMaybe<Array<PlanterView_Bool_Exp>>;
};

/** aggregate max on columns */
export type PlanterView_Max_Fields = {
  __typename?: 'PlanterView_max_fields';
  AccountName?: Maybe<Scalars['String']>;
  ApplicationCount?: Maybe<Scalars['bigint']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalTreesApproved?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PlanterView_Min_Fields = {
  __typename?: 'PlanterView_min_fields';
  AccountName?: Maybe<Scalars['String']>;
  ApplicationCount?: Maybe<Scalars['bigint']>;
  Avatar?: Maybe<Scalars['String']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  Id?: Maybe<Scalars['uuid']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  TotalTreesApproved?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "PlanterView". */
export type PlanterView_Order_By = {
  AccountName?: InputMaybe<Order_By>;
  ApplicationCount?: InputMaybe<Order_By>;
  Avatar?: InputMaybe<Order_By>;
  BeforeLastSeason?: InputMaybe<Order_By>;
  CurrentSeason?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  LastSeason?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  TotalTreesApproved?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "PlanterView" */
export enum PlanterView_Select_Column {
  /** column name */
  AccountName = 'AccountName',
  /** column name */
  ApplicationCount = 'ApplicationCount',
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  BeforeLastSeason = 'BeforeLastSeason',
  /** column name */
  CurrentSeason = 'CurrentSeason',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  LastSeason = 'LastSeason',
  /** column name */
  Name = 'Name',
  /** column name */
  Rank = 'Rank',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  TotalTreesApproved = 'TotalTreesApproved',
  /** column name */
  Type = 'Type',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type PlanterView_Stddev_Fields = {
  __typename?: 'PlanterView_stddev_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PlanterView_Stddev_Pop_Fields = {
  __typename?: 'PlanterView_stddev_pop_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PlanterView_Stddev_Samp_Fields = {
  __typename?: 'PlanterView_stddev_samp_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PlanterView" */
export type PlanterView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlanterView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlanterView_Stream_Cursor_Value_Input = {
  AccountName?: InputMaybe<Scalars['String']>;
  ApplicationCount?: InputMaybe<Scalars['bigint']>;
  Avatar?: InputMaybe<Scalars['String']>;
  BeforeLastSeason?: InputMaybe<Scalars['numeric']>;
  CurrentSeason?: InputMaybe<Scalars['numeric']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  LastSeason?: InputMaybe<Scalars['numeric']>;
  Name?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  TotalTreesApproved?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type PlanterView_Sum_Fields = {
  __typename?: 'PlanterView_sum_fields';
  ApplicationCount?: Maybe<Scalars['bigint']>;
  BeforeLastSeason?: Maybe<Scalars['numeric']>;
  CurrentSeason?: Maybe<Scalars['numeric']>;
  LastSeason?: Maybe<Scalars['numeric']>;
  Rank?: Maybe<Scalars['bigint']>;
  TotalTreesApproved?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type PlanterView_Var_Pop_Fields = {
  __typename?: 'PlanterView_var_pop_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PlanterView_Var_Samp_Fields = {
  __typename?: 'PlanterView_var_samp_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PlanterView_Variance_Fields = {
  __typename?: 'PlanterView_variance_fields';
  ApplicationCount?: Maybe<Scalars['Float']>;
  BeforeLastSeason?: Maybe<Scalars['Float']>;
  CurrentSeason?: Maybe<Scalars['Float']>;
  LastSeason?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalTreesApproved?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Planter" */
export type Planter_Aggregate = {
  __typename?: 'Planter_aggregate';
  aggregate?: Maybe<Planter_Aggregate_Fields>;
  nodes: Array<Planter>;
};

/** aggregate fields of "Planter" */
export type Planter_Aggregate_Fields = {
  __typename?: 'Planter_aggregate_fields';
  avg?: Maybe<Planter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Planter_Max_Fields>;
  min?: Maybe<Planter_Min_Fields>;
  stddev?: Maybe<Planter_Stddev_Fields>;
  stddev_pop?: Maybe<Planter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Planter_Stddev_Samp_Fields>;
  sum?: Maybe<Planter_Sum_Fields>;
  var_pop?: Maybe<Planter_Var_Pop_Fields>;
  var_samp?: Maybe<Planter_Var_Samp_Fields>;
  variance?: Maybe<Planter_Variance_Fields>;
};


/** aggregate fields of "Planter" */
export type Planter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Planter_Avg_Fields = {
  __typename?: 'Planter_avg_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Planter". All fields are combined with a logical 'AND'. */
export type Planter_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  Application?: InputMaybe<Application_Bool_Exp>;
  Application_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Banner?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  IsPrivate?: InputMaybe<Boolean_Comparison_Exp>;
  MasterPlanter?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerId?: InputMaybe<Uuid_Comparison_Exp>;
  OwnerType?: InputMaybe<Smallint_Comparison_Exp>;
  PlansCount?: InputMaybe<Bigint_Comparison_Exp>;
  PlanterRegistrations?: InputMaybe<PlanterRegistration_Bool_Exp>;
  PlanterRegistrations_aggregate?: InputMaybe<PlanterRegistration_Aggregate_Bool_Exp>;
  PlantingsCount?: InputMaybe<Bigint_Comparison_Exp>;
  Projects?: InputMaybe<Project_Bool_Exp>;
  ProjectsCount?: InputMaybe<Bigint_Comparison_Exp>;
  Projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  TreesPlanted?: InputMaybe<Bigint_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Planter_Bool_Exp>>;
  _not?: InputMaybe<Planter_Bool_Exp>;
  _or?: InputMaybe<Array<Planter_Bool_Exp>>;
};

/** unique or primary key constraints on table "Planter" */
export enum Planter_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlanterPkey = 'Planter_pkey'
}

/** input type for incrementing numeric columns in table "Planter" */
export type Planter_Inc_Input = {
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "Planter" */
export type Planter_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  Application?: InputMaybe<Application_Arr_Rel_Insert_Input>;
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  MasterPlanter?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  PlanterRegistrations?: InputMaybe<PlanterRegistration_Arr_Rel_Insert_Input>;
  Projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Planter_Max_Fields = {
  __typename?: 'Planter_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Planter_Min_Fields = {
  __typename?: 'Planter_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Banner?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Planter" */
export type Planter_Mutation_Response = {
  __typename?: 'Planter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Planter>;
};

/** input type for inserting object relation for remote table "Planter" */
export type Planter_Obj_Rel_Insert_Input = {
  data: Planter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Planter_On_Conflict>;
};

/** on_conflict condition type for table "Planter" */
export type Planter_On_Conflict = {
  constraint: Planter_Constraint;
  update_columns?: Array<Planter_Update_Column>;
  where?: InputMaybe<Planter_Bool_Exp>;
};

/** Ordering options when selecting data from "Planter". */
export type Planter_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  Application_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  Avatar?: InputMaybe<Order_By>;
  Banner?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  IsPrivate?: InputMaybe<Order_By>;
  MasterPlanter?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerId?: InputMaybe<Order_By>;
  OwnerType?: InputMaybe<Order_By>;
  PlansCount?: InputMaybe<Order_By>;
  PlanterRegistrations_aggregate?: InputMaybe<PlanterRegistration_Aggregate_Order_By>;
  PlantingsCount?: InputMaybe<Order_By>;
  ProjectsCount?: InputMaybe<Order_By>;
  Projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  TreesPlanted?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Planter */
export type Planter_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Planter" */
export enum Planter_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  IsPrivate = 'IsPrivate',
  /** column name */
  MasterPlanter = 'MasterPlanter',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Planter" */
export type Planter_Set_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  MasterPlanter?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Planter_Stddev_Fields = {
  __typename?: 'Planter_stddev_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Planter_Stddev_Pop_Fields = {
  __typename?: 'Planter_stddev_pop_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Planter_Stddev_Samp_Fields = {
  __typename?: 'Planter_stddev_samp_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Planter" */
export type Planter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planter_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Banner?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  IsPrivate?: InputMaybe<Scalars['Boolean']>;
  MasterPlanter?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Planter_Sum_Fields = {
  __typename?: 'Planter_sum_fields';
  OwnerType?: Maybe<Scalars['smallint']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "Planter" */
export enum Planter_Update_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Banner = 'Banner',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Id = 'Id',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  IsPrivate = 'IsPrivate',
  /** column name */
  MasterPlanter = 'MasterPlanter',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Planter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Planter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Planter_Set_Input>;
  where: Planter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Planter_Var_Pop_Fields = {
  __typename?: 'Planter_var_pop_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Planter_Var_Samp_Fields = {
  __typename?: 'Planter_var_samp_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Planter_Variance_Fields = {
  __typename?: 'Planter_variance_fields';
  OwnerType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Planting" */
export type Planting = {
  __typename?: 'Planting';
  /** An object relationship */
  Application?: Maybe<Application>;
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area: Scalars['float8'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo: Scalars['String'];
  Id: Scalars['uuid'];
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  /** An array relationship */
  MonitoringEvents: Array<MonitoringEvent>;
  /** An aggregate relationship */
  MonitoringEvents_aggregate: MonitoringEvent_Aggregate;
  Name: Scalars['String'];
  Photo?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planter: Planter;
  PlanterId: Scalars['uuid'];
  /** An array relationship */
  PlantingAssets: Array<PlantingAsset>;
  /** An aggregate relationship */
  PlantingAssets_aggregate: PlantingAsset_Aggregate;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  PlantingLines: Array<PlantingLine>;
  /** An aggregate relationship */
  PlantingLines_aggregate: PlantingLine_Aggregate;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  Project?: Maybe<Project>;
  ProjectId?: Maybe<Scalars['uuid']>;
  ProjectId_archived?: Maybe<Scalars['uuid']>;
  Quantity: Scalars['bigint'];
  Reference: Scalars['bigint'];
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Season: Season;
  SeasonId: Scalars['uuid'];
  Spacing: Scalars['float8'];
  SubmittedOn?: Maybe<Scalars['timestamp']>;
  Type: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
  VolunteerCount?: Maybe<Scalars['bigint']>;
  WorkflowState: Scalars['String'];
};


/** columns and relationships of "Planting" */
export type PlantingData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Planting" */
export type PlantingMonitoringEventsArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


/** columns and relationships of "Planting" */
export type PlantingMonitoringEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


/** columns and relationships of "Planting" */
export type PlantingPlantingAssetsArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


/** columns and relationships of "Planting" */
export type PlantingPlantingAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


/** columns and relationships of "Planting" */
export type PlantingPlantingLinesArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


/** columns and relationships of "Planting" */
export type PlantingPlantingLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};

/** columns and relationships of "PlantingAsset" */
export type PlantingAsset = {
  __typename?: 'PlantingAsset';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  /** An object relationship */
  Planting?: Maybe<Planting>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "PlantingAsset" */
export type PlantingAsset_Aggregate = {
  __typename?: 'PlantingAsset_aggregate';
  aggregate?: Maybe<PlantingAsset_Aggregate_Fields>;
  nodes: Array<PlantingAsset>;
};

export type PlantingAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlantingAsset_Aggregate_Bool_Exp_Count>;
};

export type PlantingAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlantingAsset" */
export type PlantingAsset_Aggregate_Fields = {
  __typename?: 'PlantingAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PlantingAsset_Max_Fields>;
  min?: Maybe<PlantingAsset_Min_Fields>;
};


/** aggregate fields of "PlantingAsset" */
export type PlantingAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlantingAsset" */
export type PlantingAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlantingAsset_Max_Order_By>;
  min?: InputMaybe<PlantingAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "PlantingAsset" */
export type PlantingAsset_Arr_Rel_Insert_Input = {
  data: Array<PlantingAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "PlantingAsset". All fields are combined with a logical 'AND'. */
export type PlantingAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Planting?: InputMaybe<Planting_Bool_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PlantingAsset_Bool_Exp>>;
  _not?: InputMaybe<PlantingAsset_Bool_Exp>;
  _or?: InputMaybe<Array<PlantingAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlantingAsset" */
export enum PlantingAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlantingAssetPkey = 'PlantingAsset_pkey'
}

/** input type for inserting data into table "PlantingAsset" */
export type PlantingAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Planting?: InputMaybe<Planting_Obj_Rel_Insert_Input>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlantingAsset_Max_Fields = {
  __typename?: 'PlantingAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "PlantingAsset" */
export type PlantingAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlantingAsset_Min_Fields = {
  __typename?: 'PlantingAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "PlantingAsset" */
export type PlantingAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlantingAsset" */
export type PlantingAsset_Mutation_Response = {
  __typename?: 'PlantingAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlantingAsset>;
};

/** on_conflict condition type for table "PlantingAsset" */
export type PlantingAsset_On_Conflict = {
  constraint: PlantingAsset_Constraint;
  update_columns?: Array<PlantingAsset_Update_Column>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "PlantingAsset". */
export type PlantingAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Planting?: InputMaybe<Planting_Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlantingAsset */
export type PlantingAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlantingAsset" */
export enum PlantingAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "PlantingAsset" */
export type PlantingAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "PlantingAsset" */
export type PlantingAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlantingAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlantingAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "PlantingAsset" */
export enum PlantingAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type PlantingAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlantingAsset_Set_Input>;
  where: PlantingAsset_Bool_Exp;
};

/** columns and relationships of "PlantingLine" */
export type PlantingLine = {
  __typename?: 'PlantingLine';
  Id: Scalars['uuid'];
  OtherSpeciesName?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planting: Planting;
  PlantingId: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  /** An object relationship */
  Species: Species;
  SpeciesId: Scalars['uuid'];
};

/** aggregated selection of "PlantingLine" */
export type PlantingLine_Aggregate = {
  __typename?: 'PlantingLine_aggregate';
  aggregate?: Maybe<PlantingLine_Aggregate_Fields>;
  nodes: Array<PlantingLine>;
};

export type PlantingLine_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlantingLine_Aggregate_Bool_Exp_Count>;
};

export type PlantingLine_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlantingLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingLine_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlantingLine" */
export type PlantingLine_Aggregate_Fields = {
  __typename?: 'PlantingLine_aggregate_fields';
  avg?: Maybe<PlantingLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PlantingLine_Max_Fields>;
  min?: Maybe<PlantingLine_Min_Fields>;
  stddev?: Maybe<PlantingLine_Stddev_Fields>;
  stddev_pop?: Maybe<PlantingLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PlantingLine_Stddev_Samp_Fields>;
  sum?: Maybe<PlantingLine_Sum_Fields>;
  var_pop?: Maybe<PlantingLine_Var_Pop_Fields>;
  var_samp?: Maybe<PlantingLine_Var_Samp_Fields>;
  variance?: Maybe<PlantingLine_Variance_Fields>;
};


/** aggregate fields of "PlantingLine" */
export type PlantingLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlantingLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlantingLine" */
export type PlantingLine_Aggregate_Order_By = {
  avg?: InputMaybe<PlantingLine_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlantingLine_Max_Order_By>;
  min?: InputMaybe<PlantingLine_Min_Order_By>;
  stddev?: InputMaybe<PlantingLine_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PlantingLine_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PlantingLine_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PlantingLine_Sum_Order_By>;
  var_pop?: InputMaybe<PlantingLine_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PlantingLine_Var_Samp_Order_By>;
  variance?: InputMaybe<PlantingLine_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "PlantingLine" */
export type PlantingLine_Arr_Rel_Insert_Input = {
  data: Array<PlantingLine_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingLine_On_Conflict>;
};

/** aggregate avg on columns */
export type PlantingLine_Avg_Fields = {
  __typename?: 'PlantingLine_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "PlantingLine" */
export type PlantingLine_Avg_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "PlantingLine". All fields are combined with a logical 'AND'. */
export type PlantingLine_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  OtherSpeciesName?: InputMaybe<String_Comparison_Exp>;
  Planting?: InputMaybe<Planting_Bool_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Species?: InputMaybe<Species_Bool_Exp>;
  SpeciesId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<PlantingLine_Bool_Exp>>;
  _not?: InputMaybe<PlantingLine_Bool_Exp>;
  _or?: InputMaybe<Array<PlantingLine_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlantingLine" */
export enum PlantingLine_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlantingLinePkey = 'PlantingLine_pkey'
}

/** input type for incrementing numeric columns in table "PlantingLine" */
export type PlantingLine_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "PlantingLine" */
export type PlantingLine_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  OtherSpeciesName?: InputMaybe<Scalars['String']>;
  Planting?: InputMaybe<Planting_Obj_Rel_Insert_Input>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Species?: InputMaybe<Species_Obj_Rel_Insert_Input>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PlantingLine_Max_Fields = {
  __typename?: 'PlantingLine_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  OtherSpeciesName?: Maybe<Scalars['String']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "PlantingLine" */
export type PlantingLine_Max_Order_By = {
  Id?: InputMaybe<Order_By>;
  OtherSpeciesName?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlantingLine_Min_Fields = {
  __typename?: 'PlantingLine_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  OtherSpeciesName?: Maybe<Scalars['String']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "PlantingLine" */
export type PlantingLine_Min_Order_By = {
  Id?: InputMaybe<Order_By>;
  OtherSpeciesName?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlantingLine" */
export type PlantingLine_Mutation_Response = {
  __typename?: 'PlantingLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlantingLine>;
};

/** input type for inserting object relation for remote table "PlantingLine" */
export type PlantingLine_Obj_Rel_Insert_Input = {
  data: PlantingLine_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingLine_On_Conflict>;
};

/** on_conflict condition type for table "PlantingLine" */
export type PlantingLine_On_Conflict = {
  constraint: PlantingLine_Constraint;
  update_columns?: Array<PlantingLine_Update_Column>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};

/** Ordering options when selecting data from "PlantingLine". */
export type PlantingLine_Order_By = {
  Id?: InputMaybe<Order_By>;
  OtherSpeciesName?: InputMaybe<Order_By>;
  Planting?: InputMaybe<Planting_Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Species?: InputMaybe<Species_Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlantingLine */
export type PlantingLine_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlantingLine" */
export enum PlantingLine_Select_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  OtherSpeciesName = 'OtherSpeciesName',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

/** input type for updating data in table "PlantingLine" */
export type PlantingLine_Set_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  OtherSpeciesName?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PlantingLine_Stddev_Fields = {
  __typename?: 'PlantingLine_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "PlantingLine" */
export type PlantingLine_Stddev_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PlantingLine_Stddev_Pop_Fields = {
  __typename?: 'PlantingLine_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "PlantingLine" */
export type PlantingLine_Stddev_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PlantingLine_Stddev_Samp_Fields = {
  __typename?: 'PlantingLine_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "PlantingLine" */
export type PlantingLine_Stddev_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "PlantingLine" */
export type PlantingLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlantingLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlantingLine_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  OtherSpeciesName?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PlantingLine_Sum_Fields = {
  __typename?: 'PlantingLine_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "PlantingLine" */
export type PlantingLine_Sum_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** update columns of table "PlantingLine" */
export enum PlantingLine_Update_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  OtherSpeciesName = 'OtherSpeciesName',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  SpeciesId = 'SpeciesId'
}

export type PlantingLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PlantingLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlantingLine_Set_Input>;
  where: PlantingLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PlantingLine_Var_Pop_Fields = {
  __typename?: 'PlantingLine_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "PlantingLine" */
export type PlantingLine_Var_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PlantingLine_Var_Samp_Fields = {
  __typename?: 'PlantingLine_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "PlantingLine" */
export type PlantingLine_Var_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PlantingLine_Variance_Fields = {
  __typename?: 'PlantingLine_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "PlantingLine" */
export type PlantingLine_Variance_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "PlantingSite" */
export type PlantingSite = {
  __typename?: 'PlantingSite';
  /** An object relationship */
  Application: Application;
  ApplicationId: Scalars['uuid'];
  CovenantProtected: Scalars['Boolean'];
  CreatedOn: Scalars['timestamp'];
  Geo: Scalars['String'];
  Id: Scalars['uuid'];
  LandPermission: Scalars['Boolean'];
  Name: Scalars['String'];
  NativeTreeConsent: Scalars['Boolean'];
  /** An array relationship */
  PlantingSiteAssets: Array<PlantingSiteAsset>;
  /** An aggregate relationship */
  PlantingSiteAssets_aggregate: PlantingSiteAsset_Aggregate;
  SiteLandCondition: Scalars['String'];
  SiteLandscape: Scalars['String'];
  Species?: Maybe<Scalars['String']>;
  StockAccess: Scalars['Boolean'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "PlantingSite" */
export type PlantingSitePlantingSiteAssetsArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


/** columns and relationships of "PlantingSite" */
export type PlantingSitePlantingSiteAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};

/** columns and relationships of "PlantingSiteAsset" */
export type PlantingSiteAsset = {
  __typename?: 'PlantingSiteAsset';
  CreatedOn: Scalars['timestamp'];
  FileName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  /** An object relationship */
  PlantingSite: PlantingSite;
  PlantingSiteId: Scalars['uuid'];
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri: Scalars['String'];
};

export enum PlantingSiteAssetType {
  Photo = 'Photo',
  Unknown = 'Unknown'
}

/** aggregated selection of "PlantingSiteAsset" */
export type PlantingSiteAsset_Aggregate = {
  __typename?: 'PlantingSiteAsset_aggregate';
  aggregate?: Maybe<PlantingSiteAsset_Aggregate_Fields>;
  nodes: Array<PlantingSiteAsset>;
};

export type PlantingSiteAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<PlantingSiteAsset_Aggregate_Bool_Exp_Count>;
};

export type PlantingSiteAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlantingSiteAsset" */
export type PlantingSiteAsset_Aggregate_Fields = {
  __typename?: 'PlantingSiteAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PlantingSiteAsset_Max_Fields>;
  min?: Maybe<PlantingSiteAsset_Min_Fields>;
};


/** aggregate fields of "PlantingSiteAsset" */
export type PlantingSiteAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlantingSiteAsset" */
export type PlantingSiteAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlantingSiteAsset_Max_Order_By>;
  min?: InputMaybe<PlantingSiteAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "PlantingSiteAsset" */
export type PlantingSiteAsset_Arr_Rel_Insert_Input = {
  data: Array<PlantingSiteAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingSiteAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "PlantingSiteAsset". All fields are combined with a logical 'AND'. */
export type PlantingSiteAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingSite?: InputMaybe<PlantingSite_Bool_Exp>;
  PlantingSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<PlantingSiteAsset_Bool_Exp>>;
  _not?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
  _or?: InputMaybe<Array<PlantingSiteAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlantingSiteAsset" */
export enum PlantingSiteAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlantingSiteAssetPkey = 'PlantingSiteAsset_pkey'
}

/** input type for inserting data into table "PlantingSiteAsset" */
export type PlantingSiteAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingSite?: InputMaybe<PlantingSite_Obj_Rel_Insert_Input>;
  PlantingSiteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PlantingSiteAsset_Max_Fields = {
  __typename?: 'PlantingSiteAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingSiteId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "PlantingSiteAsset" */
export type PlantingSiteAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingSiteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlantingSiteAsset_Min_Fields = {
  __typename?: 'PlantingSiteAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingSiteId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "PlantingSiteAsset" */
export type PlantingSiteAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingSiteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlantingSiteAsset" */
export type PlantingSiteAsset_Mutation_Response = {
  __typename?: 'PlantingSiteAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlantingSiteAsset>;
};

/** on_conflict condition type for table "PlantingSiteAsset" */
export type PlantingSiteAsset_On_Conflict = {
  constraint: PlantingSiteAsset_Constraint;
  update_columns?: Array<PlantingSiteAsset_Update_Column>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "PlantingSiteAsset". */
export type PlantingSiteAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingSite?: InputMaybe<PlantingSite_Order_By>;
  PlantingSiteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlantingSiteAsset */
export type PlantingSiteAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlantingSiteAsset" */
export enum PlantingSiteAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingSiteId = 'PlantingSiteId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "PlantingSiteAsset" */
export type PlantingSiteAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingSiteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "PlantingSiteAsset" */
export type PlantingSiteAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlantingSiteAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlantingSiteAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingSiteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "PlantingSiteAsset" */
export enum PlantingSiteAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingSiteId = 'PlantingSiteId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type PlantingSiteAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlantingSiteAsset_Set_Input>;
  where: PlantingSiteAsset_Bool_Exp;
};

/** aggregated selection of "PlantingSite" */
export type PlantingSite_Aggregate = {
  __typename?: 'PlantingSite_aggregate';
  aggregate?: Maybe<PlantingSite_Aggregate_Fields>;
  nodes: Array<PlantingSite>;
};

export type PlantingSite_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<PlantingSite_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<PlantingSite_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<PlantingSite_Aggregate_Bool_Exp_Count>;
};

export type PlantingSite_Aggregate_Bool_Exp_Bool_And = {
  arguments: PlantingSite_Select_Column_PlantingSite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingSite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PlantingSite_Aggregate_Bool_Exp_Bool_Or = {
  arguments: PlantingSite_Select_Column_PlantingSite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingSite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type PlantingSite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PlantingSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PlantingSite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PlantingSite" */
export type PlantingSite_Aggregate_Fields = {
  __typename?: 'PlantingSite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PlantingSite_Max_Fields>;
  min?: Maybe<PlantingSite_Min_Fields>;
};


/** aggregate fields of "PlantingSite" */
export type PlantingSite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PlantingSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PlantingSite" */
export type PlantingSite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PlantingSite_Max_Order_By>;
  min?: InputMaybe<PlantingSite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "PlantingSite" */
export type PlantingSite_Arr_Rel_Insert_Input = {
  data: Array<PlantingSite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingSite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "PlantingSite". All fields are combined with a logical 'AND'. */
export type PlantingSite_Bool_Exp = {
  Application?: InputMaybe<Application_Bool_Exp>;
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  CovenantProtected?: InputMaybe<Boolean_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LandPermission?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  NativeTreeConsent?: InputMaybe<Boolean_Comparison_Exp>;
  PlantingSiteAssets?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
  PlantingSiteAssets_aggregate?: InputMaybe<PlantingSiteAsset_Aggregate_Bool_Exp>;
  SiteLandCondition?: InputMaybe<String_Comparison_Exp>;
  SiteLandscape?: InputMaybe<String_Comparison_Exp>;
  Species?: InputMaybe<String_Comparison_Exp>;
  StockAccess?: InputMaybe<Boolean_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<PlantingSite_Bool_Exp>>;
  _not?: InputMaybe<PlantingSite_Bool_Exp>;
  _or?: InputMaybe<Array<PlantingSite_Bool_Exp>>;
};

/** unique or primary key constraints on table "PlantingSite" */
export enum PlantingSite_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlantingSitePkey = 'PlantingSite_pkey'
}

/** input type for inserting data into table "PlantingSite" */
export type PlantingSite_Insert_Input = {
  Application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CovenantProtected?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  NativeTreeConsent?: InputMaybe<Scalars['Boolean']>;
  PlantingSiteAssets?: InputMaybe<PlantingSiteAsset_Arr_Rel_Insert_Input>;
  SiteLandCondition?: InputMaybe<Scalars['String']>;
  SiteLandscape?: InputMaybe<Scalars['String']>;
  Species?: InputMaybe<Scalars['String']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type PlantingSite_Max_Fields = {
  __typename?: 'PlantingSite_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  SiteLandCondition?: Maybe<Scalars['String']>;
  SiteLandscape?: Maybe<Scalars['String']>;
  Species?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "PlantingSite" */
export type PlantingSite_Max_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  SiteLandCondition?: InputMaybe<Order_By>;
  SiteLandscape?: InputMaybe<Order_By>;
  Species?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PlantingSite_Min_Fields = {
  __typename?: 'PlantingSite_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  SiteLandCondition?: Maybe<Scalars['String']>;
  SiteLandscape?: Maybe<Scalars['String']>;
  Species?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "PlantingSite" */
export type PlantingSite_Min_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  SiteLandCondition?: InputMaybe<Order_By>;
  SiteLandscape?: InputMaybe<Order_By>;
  Species?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PlantingSite" */
export type PlantingSite_Mutation_Response = {
  __typename?: 'PlantingSite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PlantingSite>;
};

/** input type for inserting object relation for remote table "PlantingSite" */
export type PlantingSite_Obj_Rel_Insert_Input = {
  data: PlantingSite_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PlantingSite_On_Conflict>;
};

/** on_conflict condition type for table "PlantingSite" */
export type PlantingSite_On_Conflict = {
  constraint: PlantingSite_Constraint;
  update_columns?: Array<PlantingSite_Update_Column>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};

/** Ordering options when selecting data from "PlantingSite". */
export type PlantingSite_Order_By = {
  Application?: InputMaybe<Application_Order_By>;
  ApplicationId?: InputMaybe<Order_By>;
  CovenantProtected?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandPermission?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NativeTreeConsent?: InputMaybe<Order_By>;
  PlantingSiteAssets_aggregate?: InputMaybe<PlantingSiteAsset_Aggregate_Order_By>;
  SiteLandCondition?: InputMaybe<Order_By>;
  SiteLandscape?: InputMaybe<Order_By>;
  Species?: InputMaybe<Order_By>;
  StockAccess?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PlantingSite */
export type PlantingSite_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PlantingSite" */
export enum PlantingSite_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CovenantProtected = 'CovenantProtected',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  Name = 'Name',
  /** column name */
  NativeTreeConsent = 'NativeTreeConsent',
  /** column name */
  SiteLandCondition = 'SiteLandCondition',
  /** column name */
  SiteLandscape = 'SiteLandscape',
  /** column name */
  Species = 'Species',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** select "PlantingSite_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PlantingSite" */
export enum PlantingSite_Select_Column_PlantingSite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CovenantProtected = 'CovenantProtected',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  NativeTreeConsent = 'NativeTreeConsent',
  /** column name */
  StockAccess = 'StockAccess'
}

/** select "PlantingSite_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PlantingSite" */
export enum PlantingSite_Select_Column_PlantingSite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CovenantProtected = 'CovenantProtected',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  NativeTreeConsent = 'NativeTreeConsent',
  /** column name */
  StockAccess = 'StockAccess'
}

/** input type for updating data in table "PlantingSite" */
export type PlantingSite_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CovenantProtected?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  NativeTreeConsent?: InputMaybe<Scalars['Boolean']>;
  SiteLandCondition?: InputMaybe<Scalars['String']>;
  SiteLandscape?: InputMaybe<Scalars['String']>;
  Species?: InputMaybe<Scalars['String']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "PlantingSite" */
export type PlantingSite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PlantingSite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PlantingSite_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CovenantProtected?: InputMaybe<Scalars['Boolean']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandPermission?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  NativeTreeConsent?: InputMaybe<Scalars['Boolean']>;
  SiteLandCondition?: InputMaybe<Scalars['String']>;
  SiteLandscape?: InputMaybe<Scalars['String']>;
  Species?: InputMaybe<Scalars['String']>;
  StockAccess?: InputMaybe<Scalars['Boolean']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "PlantingSite" */
export enum PlantingSite_Update_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CovenantProtected = 'CovenantProtected',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  LandPermission = 'LandPermission',
  /** column name */
  Name = 'Name',
  /** column name */
  NativeTreeConsent = 'NativeTreeConsent',
  /** column name */
  SiteLandCondition = 'SiteLandCondition',
  /** column name */
  SiteLandscape = 'SiteLandscape',
  /** column name */
  Species = 'Species',
  /** column name */
  StockAccess = 'StockAccess',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type PlantingSite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PlantingSite_Set_Input>;
  where: PlantingSite_Bool_Exp;
};

/** aggregated selection of "Planting" */
export type Planting_Aggregate = {
  __typename?: 'Planting_aggregate';
  aggregate?: Maybe<Planting_Aggregate_Fields>;
  nodes: Array<Planting>;
};

export type Planting_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Planting_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Planting_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Planting_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Planting_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Planting_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Planting_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Planting_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Planting_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Planting_Aggregate_Bool_Exp_Var_Samp>;
};

export type Planting_Aggregate_Bool_Exp_Avg = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Corr = {
  arguments: Planting_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Planting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Planting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Planting_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Planting_Aggregate_Bool_Exp_Max = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Min = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Sum = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Planting_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Planting_Select_Column_Planting_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Planting_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "Planting" */
export type Planting_Aggregate_Fields = {
  __typename?: 'Planting_aggregate_fields';
  avg?: Maybe<Planting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Planting_Max_Fields>;
  min?: Maybe<Planting_Min_Fields>;
  stddev?: Maybe<Planting_Stddev_Fields>;
  stddev_pop?: Maybe<Planting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Planting_Stddev_Samp_Fields>;
  sum?: Maybe<Planting_Sum_Fields>;
  var_pop?: Maybe<Planting_Var_Pop_Fields>;
  var_samp?: Maybe<Planting_Var_Samp_Fields>;
  variance?: Maybe<Planting_Variance_Fields>;
};


/** aggregate fields of "Planting" */
export type Planting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Planting" */
export type Planting_Aggregate_Order_By = {
  avg?: InputMaybe<Planting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Planting_Max_Order_By>;
  min?: InputMaybe<Planting_Min_Order_By>;
  stddev?: InputMaybe<Planting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Planting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Planting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Planting_Sum_Order_By>;
  var_pop?: InputMaybe<Planting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Planting_Var_Samp_Order_By>;
  variance?: InputMaybe<Planting_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Planting_Append_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "Planting" */
export type Planting_Arr_Rel_Insert_Input = {
  data: Array<Planting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Planting_On_Conflict>;
};

/** aggregate avg on columns */
export type Planting_Avg_Fields = {
  __typename?: 'Planting_avg_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Planting" */
export type Planting_Avg_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Planting". All fields are combined with a logical 'AND'. */
export type Planting_Bool_Exp = {
  Application?: InputMaybe<Application_Bool_Exp>;
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  Area?: InputMaybe<Float8_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LandOwnership?: InputMaybe<String_Comparison_Exp>;
  LandUse?: InputMaybe<String_Comparison_Exp>;
  Location?: InputMaybe<String_Comparison_Exp>;
  MonitoringEvents?: InputMaybe<MonitoringEvent_Bool_Exp>;
  MonitoringEvents_aggregate?: InputMaybe<MonitoringEvent_Aggregate_Bool_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Photo?: InputMaybe<String_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingAssets?: InputMaybe<PlantingAsset_Bool_Exp>;
  PlantingAssets_aggregate?: InputMaybe<PlantingAsset_Aggregate_Bool_Exp>;
  PlantingFrom?: InputMaybe<Timestamp_Comparison_Exp>;
  PlantingLines?: InputMaybe<PlantingLine_Bool_Exp>;
  PlantingLines_aggregate?: InputMaybe<PlantingLine_Aggregate_Bool_Exp>;
  PlantingTo?: InputMaybe<Timestamp_Comparison_Exp>;
  Project?: InputMaybe<Project_Bool_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  ProjectId_archived?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Season?: InputMaybe<Season_Bool_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  Spacing?: InputMaybe<Float8_Comparison_Exp>;
  SubmittedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VolunteerCount?: InputMaybe<Bigint_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Planting_Bool_Exp>>;
  _not?: InputMaybe<Planting_Bool_Exp>;
  _or?: InputMaybe<Array<Planting_Bool_Exp>>;
};

/** unique or primary key constraints on table "Planting" */
export enum Planting_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PlantingPkey = 'Planting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Planting_Delete_At_Path_Input = {
  Data_jsonb?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * delete the array element with specified index (negative integers count from the
 * end). throws an error if top level container is not an array
 */
export type Planting_Delete_Elem_Input = {
  Data_jsonb?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Planting_Delete_Key_Input = {
  Data_jsonb?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "Planting" */
export type Planting_Inc_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Planting" */
export type Planting_Insert_Input = {
  Application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  MonitoringEvents?: InputMaybe<MonitoringEvent_Arr_Rel_Insert_Input>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingAssets?: InputMaybe<PlantingAsset_Arr_Rel_Insert_Input>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingLines?: InputMaybe<PlantingLine_Arr_Rel_Insert_Input>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  Project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  ProjectId_archived?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Season?: InputMaybe<Season_Obj_Rel_Insert_Input>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  SubmittedOn?: InputMaybe<Scalars['timestamp']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Planting_Max_Fields = {
  __typename?: 'Planting_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  ProjectId_archived?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  Spacing?: Maybe<Scalars['float8']>;
  SubmittedOn?: Maybe<Scalars['timestamp']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VolunteerCount?: Maybe<Scalars['bigint']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Planting" */
export type Planting_Max_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  Location?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Photo?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingFrom?: InputMaybe<Order_By>;
  PlantingTo?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  ProjectId_archived?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  SubmittedOn?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Planting_Min_Fields = {
  __typename?: 'Planting_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  ProjectId_archived?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  Spacing?: Maybe<Scalars['float8']>;
  SubmittedOn?: Maybe<Scalars['timestamp']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VolunteerCount?: Maybe<Scalars['bigint']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Planting" */
export type Planting_Min_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  Location?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Photo?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingFrom?: InputMaybe<Order_By>;
  PlantingTo?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  ProjectId_archived?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  SubmittedOn?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Planting" */
export type Planting_Mutation_Response = {
  __typename?: 'Planting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Planting>;
};

/** input type for inserting object relation for remote table "Planting" */
export type Planting_Obj_Rel_Insert_Input = {
  data: Planting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Planting_On_Conflict>;
};

/** on_conflict condition type for table "Planting" */
export type Planting_On_Conflict = {
  constraint: Planting_Constraint;
  update_columns?: Array<Planting_Update_Column>;
  where?: InputMaybe<Planting_Bool_Exp>;
};

/** Ordering options when selecting data from "Planting". */
export type Planting_Order_By = {
  Application?: InputMaybe<Application_Order_By>;
  ApplicationId?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  Location?: InputMaybe<Order_By>;
  MonitoringEvents_aggregate?: InputMaybe<MonitoringEvent_Aggregate_Order_By>;
  Name?: InputMaybe<Order_By>;
  Photo?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingAssets_aggregate?: InputMaybe<PlantingAsset_Aggregate_Order_By>;
  PlantingFrom?: InputMaybe<Order_By>;
  PlantingLines_aggregate?: InputMaybe<PlantingLine_Aggregate_Order_By>;
  PlantingTo?: InputMaybe<Order_By>;
  Project?: InputMaybe<Project_Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  ProjectId_archived?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Season?: InputMaybe<Season_Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  SubmittedOn?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Planting */
export type Planting_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Planting_Prepend_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "Planting" */
export enum Planting_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  Location = 'Location',
  /** column name */
  Name = 'Name',
  /** column name */
  Photo = 'Photo',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingFrom = 'PlantingFrom',
  /** column name */
  PlantingTo = 'PlantingTo',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  ProjectIdArchived = 'ProjectId_archived',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  Spacing = 'Spacing',
  /** column name */
  SubmittedOn = 'SubmittedOn',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VolunteerCount = 'VolunteerCount',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** select "Planting_aggregate_bool_exp_avg_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_corr_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_max_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_min_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_sum_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** select "Planting_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Planting" */
export enum Planting_Select_Column_Planting_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Area = 'Area',
  /** column name */
  Spacing = 'Spacing'
}

/** input type for updating data in table "Planting" */
export type Planting_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  ProjectId_archived?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  SubmittedOn?: InputMaybe<Scalars['timestamp']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Planting_Stddev_Fields = {
  __typename?: 'Planting_stddev_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Planting" */
export type Planting_Stddev_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Planting_Stddev_Pop_Fields = {
  __typename?: 'Planting_stddev_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Planting" */
export type Planting_Stddev_Pop_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Planting_Stddev_Samp_Fields = {
  __typename?: 'Planting_stddev_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Planting" */
export type Planting_Stddev_Samp_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Planting" */
export type Planting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planting_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  ProjectId_archived?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  SubmittedOn?: InputMaybe<Scalars['timestamp']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Planting_Sum_Fields = {
  __typename?: 'Planting_sum_fields';
  Area?: Maybe<Scalars['float8']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Spacing?: Maybe<Scalars['float8']>;
  Type?: Maybe<Scalars['smallint']>;
  VolunteerCount?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Planting" */
export type Planting_Sum_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "Planting" (current role has no relevant permissions) */
export enum Planting_Update_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  Location = 'Location',
  /** column name */
  Name = 'Name',
  /** column name */
  Photo = 'Photo',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingFrom = 'PlantingFrom',
  /** column name */
  PlantingTo = 'PlantingTo',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  ProjectIdArchived = 'ProjectId_archived',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  Spacing = 'Spacing',
  /** column name */
  SubmittedOn = 'SubmittedOn',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VolunteerCount = 'VolunteerCount',
  /** column name */
  WorkflowState = 'WorkflowState',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type Planting_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Planting_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Planting_Delete_At_Path_Input>;
  /**
   * delete the array element with specified index (negative integers count from
   * the end). throws an error if top level container is not an array
   */
  _delete_elem?: InputMaybe<Planting_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Planting_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Planting_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Planting_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Planting_Set_Input>;
  where: Planting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Planting_Var_Pop_Fields = {
  __typename?: 'Planting_var_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Planting" */
export type Planting_Var_Pop_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Planting_Var_Samp_Fields = {
  __typename?: 'Planting_var_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Planting" */
export type Planting_Var_Samp_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Planting_Variance_Fields = {
  __typename?: 'Planting_variance_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
  VolunteerCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Planting" */
export type Planting_Variance_Order_By = {
  Area?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  VolunteerCount?: InputMaybe<Order_By>;
};

export type ProcessPurchaseInput = {
  PurchaseId: Scalars['String'];
};

export type ProcessPurchaseOutput = {
  __typename?: 'ProcessPurchaseOutput';
  Purchase?: Maybe<Purchase>;
  PurchaseId: Scalars['String'];
};

/** columns and relationships of "Product" */
export type Product = {
  __typename?: 'Product';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  EnquiryOnly: Scalars['Boolean'];
  Id: Scalars['uuid'];
  IsArchived: Scalars['Boolean'];
  IsRestricted: Scalars['Boolean'];
  Name: Scalars['String'];
  Ordering: Scalars['Int'];
  /** An array relationship */
  ProductPrices: Array<ProductPrice>;
  /** An aggregate relationship */
  ProductPrices_aggregate: ProductPrice_Aggregate;
  ReceiptingType: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "Product" */
export type ProductProductPricesArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


/** columns and relationships of "Product" */
export type ProductProductPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};

/** columns and relationships of "ProductPrice" */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  Amount: Scalars['numeric'];
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  IsArchived: Scalars['Boolean'];
  IsCurrent: Scalars['Boolean'];
  ProductId: Scalars['uuid'];
  UpdatedOn: Scalars['timestamp'];
  VolumeMax?: Maybe<Scalars['bigint']>;
  VolumeMin?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "ProductPrice" */
export type ProductPrice_Aggregate = {
  __typename?: 'ProductPrice_aggregate';
  aggregate?: Maybe<ProductPrice_Aggregate_Fields>;
  nodes: Array<ProductPrice>;
};

export type ProductPrice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ProductPrice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ProductPrice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ProductPrice_Aggregate_Bool_Exp_Count>;
};

export type ProductPrice_Aggregate_Bool_Exp_Bool_And = {
  arguments: ProductPrice_Select_Column_ProductPrice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductPrice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProductPrice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ProductPrice_Select_Column_ProductPrice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductPrice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ProductPrice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProductPrice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProductPrice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ProductPrice" */
export type ProductPrice_Aggregate_Fields = {
  __typename?: 'ProductPrice_aggregate_fields';
  avg?: Maybe<ProductPrice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProductPrice_Max_Fields>;
  min?: Maybe<ProductPrice_Min_Fields>;
  stddev?: Maybe<ProductPrice_Stddev_Fields>;
  stddev_pop?: Maybe<ProductPrice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProductPrice_Stddev_Samp_Fields>;
  sum?: Maybe<ProductPrice_Sum_Fields>;
  var_pop?: Maybe<ProductPrice_Var_Pop_Fields>;
  var_samp?: Maybe<ProductPrice_Var_Samp_Fields>;
  variance?: Maybe<ProductPrice_Variance_Fields>;
};


/** aggregate fields of "ProductPrice" */
export type ProductPrice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProductPrice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ProductPrice" */
export type ProductPrice_Aggregate_Order_By = {
  avg?: InputMaybe<ProductPrice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProductPrice_Max_Order_By>;
  min?: InputMaybe<ProductPrice_Min_Order_By>;
  stddev?: InputMaybe<ProductPrice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProductPrice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProductPrice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProductPrice_Sum_Order_By>;
  var_pop?: InputMaybe<ProductPrice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProductPrice_Var_Samp_Order_By>;
  variance?: InputMaybe<ProductPrice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ProductPrice" */
export type ProductPrice_Arr_Rel_Insert_Input = {
  data: Array<ProductPrice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductPrice_On_Conflict>;
};

/** aggregate avg on columns */
export type ProductPrice_Avg_Fields = {
  __typename?: 'ProductPrice_avg_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ProductPrice" */
export type ProductPrice_Avg_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ProductPrice". All fields are combined with a logical 'AND'. */
export type ProductPrice_Bool_Exp = {
  Amount?: InputMaybe<Numeric_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsArchived?: InputMaybe<Boolean_Comparison_Exp>;
  IsCurrent?: InputMaybe<Boolean_Comparison_Exp>;
  ProductId?: InputMaybe<Uuid_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  VolumeMax?: InputMaybe<Bigint_Comparison_Exp>;
  VolumeMin?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<ProductPrice_Bool_Exp>>;
  _not?: InputMaybe<ProductPrice_Bool_Exp>;
  _or?: InputMaybe<Array<ProductPrice_Bool_Exp>>;
};

/** unique or primary key constraints on table "ProductPrice" */
export enum ProductPrice_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProductPricePkey = 'ProductPrice_pkey'
}

/** input type for incrementing numeric columns in table "ProductPrice" */
export type ProductPrice_Inc_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  VolumeMax?: InputMaybe<Scalars['bigint']>;
  VolumeMin?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "ProductPrice" */
export type ProductPrice_Insert_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsCurrent?: InputMaybe<Scalars['Boolean']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolumeMax?: InputMaybe<Scalars['bigint']>;
  VolumeMin?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ProductPrice_Max_Fields = {
  __typename?: 'ProductPrice_max_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  ProductId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VolumeMax?: Maybe<Scalars['bigint']>;
  VolumeMin?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ProductPrice" */
export type ProductPrice_Max_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProductPrice_Min_Fields = {
  __typename?: 'ProductPrice_min_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  ProductId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  VolumeMax?: Maybe<Scalars['bigint']>;
  VolumeMin?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ProductPrice" */
export type ProductPrice_Min_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ProductPrice" */
export type ProductPrice_Mutation_Response = {
  __typename?: 'ProductPrice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductPrice>;
};

/** on_conflict condition type for table "ProductPrice" */
export type ProductPrice_On_Conflict = {
  constraint: ProductPrice_Constraint;
  update_columns?: Array<ProductPrice_Update_Column>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};

/** Ordering options when selecting data from "ProductPrice". */
export type ProductPrice_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsArchived?: InputMaybe<Order_By>;
  IsCurrent?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ProductPrice */
export type ProductPrice_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ProductPrice" */
export enum ProductPrice_Select_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsCurrent = 'IsCurrent',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VolumeMax = 'VolumeMax',
  /** column name */
  VolumeMin = 'VolumeMin'
}

/** select "ProductPrice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ProductPrice" */
export enum ProductPrice_Select_Column_ProductPrice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsCurrent = 'IsCurrent'
}

/** select "ProductPrice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ProductPrice" */
export enum ProductPrice_Select_Column_ProductPrice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsCurrent = 'IsCurrent'
}

/** input type for updating data in table "ProductPrice" */
export type ProductPrice_Set_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsCurrent?: InputMaybe<Scalars['Boolean']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolumeMax?: InputMaybe<Scalars['bigint']>;
  VolumeMin?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ProductPrice_Stddev_Fields = {
  __typename?: 'ProductPrice_stddev_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ProductPrice" */
export type ProductPrice_Stddev_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProductPrice_Stddev_Pop_Fields = {
  __typename?: 'ProductPrice_stddev_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ProductPrice" */
export type ProductPrice_Stddev_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProductPrice_Stddev_Samp_Fields = {
  __typename?: 'ProductPrice_stddev_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ProductPrice" */
export type ProductPrice_Stddev_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ProductPrice" */
export type ProductPrice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProductPrice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductPrice_Stream_Cursor_Value_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsCurrent?: InputMaybe<Scalars['Boolean']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  VolumeMax?: InputMaybe<Scalars['bigint']>;
  VolumeMin?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ProductPrice_Sum_Fields = {
  __typename?: 'ProductPrice_sum_fields';
  Amount?: Maybe<Scalars['numeric']>;
  VolumeMax?: Maybe<Scalars['bigint']>;
  VolumeMin?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ProductPrice" */
export type ProductPrice_Sum_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** update columns of table "ProductPrice" */
export enum ProductPrice_Update_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsCurrent = 'IsCurrent',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  VolumeMax = 'VolumeMax',
  /** column name */
  VolumeMin = 'VolumeMin'
}

export type ProductPrice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProductPrice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductPrice_Set_Input>;
  where: ProductPrice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProductPrice_Var_Pop_Fields = {
  __typename?: 'ProductPrice_var_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ProductPrice" */
export type ProductPrice_Var_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProductPrice_Var_Samp_Fields = {
  __typename?: 'ProductPrice_var_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ProductPrice" */
export type ProductPrice_Var_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProductPrice_Variance_Fields = {
  __typename?: 'ProductPrice_variance_fields';
  Amount?: Maybe<Scalars['Float']>;
  VolumeMax?: Maybe<Scalars['Float']>;
  VolumeMin?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ProductPrice" */
export type ProductPrice_Variance_Order_By = {
  Amount?: InputMaybe<Order_By>;
  VolumeMax?: InputMaybe<Order_By>;
  VolumeMin?: InputMaybe<Order_By>;
};

/** aggregated selection of "Product" */
export type Product_Aggregate = {
  __typename?: 'Product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "Product" */
export type Product_Aggregate_Fields = {
  __typename?: 'Product_aggregate_fields';
  avg?: Maybe<Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
  stddev?: Maybe<Product_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sum_Fields>;
  var_pop?: Maybe<Product_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Var_Samp_Fields>;
  variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "Product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: 'Product_avg_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  EnquiryOnly?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsArchived?: InputMaybe<Boolean_Comparison_Exp>;
  IsRestricted?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Ordering?: InputMaybe<Int_Comparison_Exp>;
  ProductPrices?: InputMaybe<ProductPrice_Bool_Exp>;
  ProductPrices_aggregate?: InputMaybe<ProductPrice_Aggregate_Bool_Exp>;
  ReceiptingType?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
};

/** unique or primary key constraints on table "Product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProductPkey = 'Product_pkey'
}

/** input type for incrementing numeric columns in table "Product" */
export type Product_Inc_Input = {
  Ordering?: InputMaybe<Scalars['Int']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "Product" */
export type Product_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  EnquiryOnly?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsRestricted?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  ProductPrices?: InputMaybe<ProductPrice_Arr_Rel_Insert_Input>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'Product_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'Product_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Product" */
export type Product_Mutation_Response = {
  __typename?: 'Product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "Product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "Product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "Product". */
export type Product_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  EnquiryOnly?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsArchived?: InputMaybe<Order_By>;
  IsRestricted?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Ordering?: InputMaybe<Order_By>;
  ProductPrices_aggregate?: InputMaybe<ProductPrice_Aggregate_Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Product */
export type Product_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Product" */
export enum Product_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  EnquiryOnly = 'EnquiryOnly',
  /** column name */
  Id = 'Id',
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsRestricted = 'IsRestricted',
  /** column name */
  Name = 'Name',
  /** column name */
  Ordering = 'Ordering',
  /** column name */
  ReceiptingType = 'ReceiptingType',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Product" */
export type Product_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  EnquiryOnly?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsRestricted?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: 'Product_stddev_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: 'Product_stddev_pop_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: 'Product_stddev_samp_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  EnquiryOnly?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsArchived?: InputMaybe<Scalars['Boolean']>;
  IsRestricted?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: 'Product_sum_fields';
  Ordering?: Maybe<Scalars['Int']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
};

/** update columns of table "Product" */
export enum Product_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  EnquiryOnly = 'EnquiryOnly',
  /** column name */
  Id = 'Id',
  /** column name */
  IsArchived = 'IsArchived',
  /** column name */
  IsRestricted = 'IsRestricted',
  /** column name */
  Name = 'Name',
  /** column name */
  Ordering = 'Ordering',
  /** column name */
  ReceiptingType = 'ReceiptingType',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: 'Product_var_pop_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: 'Product_var_samp_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: 'Product_variance_fields';
  Ordering?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Project" */
export type Project = {
  __typename?: 'Project';
  /** An array relationship */
  Applications: Array<Application>;
  /** An aggregate relationship */
  Applications_aggregate: Application_Aggregate;
  Area: Scalars['String'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  IsPublic: Scalars['Boolean'];
  LandUse: Scalars['jsonb'];
  LandUseOther?: Maybe<Scalars['String']>;
  LegacyArea?: Maybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Int']>;
  LegacySocialUrl?: Maybe<Scalars['String']>;
  LegacyWebsiteUrl?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  NumberOfProperties: Scalars['String'];
  NumberOfTreesFundedPreviously: Scalars['Int'];
  OpenFrom?: Maybe<Scalars['timestamp']>;
  OpenTo?: Maybe<Scalars['timestamp']>;
  OtherAvailableLand: Scalars['Boolean'];
  OtherLandArea?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planter: Planter;
  PlanterId: Scalars['uuid'];
  PlantingTimeframes: Scalars['String'];
  /** An array relationship */
  ProjectAssets: Array<ProjectAsset>;
  /** An aggregate relationship */
  ProjectAssets_aggregate: ProjectAsset_Aggregate;
  PublicPage?: Maybe<Scalars['Boolean']>;
  Purpose?: Maybe<Scalars['jsonb']>;
  ReceivedFundingPreviously?: Maybe<Scalars['Boolean']>;
  Reference: Scalars['bigint'];
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
  WebsiteLinks?: Maybe<Scalars['jsonb']>;
  WorkflowState: Scalars['String'];
};


/** columns and relationships of "Project" */
export type ProjectApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "Project" */
export type ProjectApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "Project" */
export type ProjectLandUseArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Project" */
export type ProjectProjectAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


/** columns and relationships of "Project" */
export type ProjectProjectAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


/** columns and relationships of "Project" */
export type ProjectPurposeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Project" */
export type ProjectWebsiteLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ProjectAsset" */
export type ProjectAsset = {
  __typename?: 'ProjectAsset';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  /** An object relationship */
  Project?: Maybe<Project>;
  Project_Id?: Maybe<Scalars['uuid']>;
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};

export enum ProjectAssetType {
  ProjectHero = 'ProjectHero'
}

/** aggregated selection of "ProjectAsset" */
export type ProjectAsset_Aggregate = {
  __typename?: 'ProjectAsset_aggregate';
  aggregate?: Maybe<ProjectAsset_Aggregate_Fields>;
  nodes: Array<ProjectAsset>;
};

export type ProjectAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectAsset_Aggregate_Bool_Exp_Count>;
};

export type ProjectAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProjectAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ProjectAsset" */
export type ProjectAsset_Aggregate_Fields = {
  __typename?: 'ProjectAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProjectAsset_Max_Fields>;
  min?: Maybe<ProjectAsset_Min_Fields>;
};


/** aggregate fields of "ProjectAsset" */
export type ProjectAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ProjectAsset" */
export type ProjectAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectAsset_Max_Order_By>;
  min?: InputMaybe<ProjectAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ProjectAsset" */
export type ProjectAsset_Arr_Rel_Insert_Input = {
  data: Array<ProjectAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ProjectAsset". All fields are combined with a logical 'AND'. */
export type ProjectAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Project?: InputMaybe<Project_Bool_Exp>;
  Project_Id?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectAsset_Bool_Exp>>;
  _not?: InputMaybe<ProjectAsset_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "ProjectAsset" */
export enum ProjectAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProjectAssetPkey = 'ProjectAsset_pkey'
}

/** input type for inserting data into table "ProjectAsset" */
export type ProjectAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  Project_Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProjectAsset_Max_Fields = {
  __typename?: 'ProjectAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Project_Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ProjectAsset" */
export type ProjectAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Project_Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectAsset_Min_Fields = {
  __typename?: 'ProjectAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Project_Id?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ProjectAsset" */
export type ProjectAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Project_Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ProjectAsset" */
export type ProjectAsset_Mutation_Response = {
  __typename?: 'ProjectAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectAsset>;
};

/** on_conflict condition type for table "ProjectAsset" */
export type ProjectAsset_On_Conflict = {
  constraint: ProjectAsset_Constraint;
  update_columns?: Array<ProjectAsset_Update_Column>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "ProjectAsset". */
export type ProjectAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Project?: InputMaybe<Project_Order_By>;
  Project_Id?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ProjectAsset */
export type ProjectAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ProjectAsset" */
export enum ProjectAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectId = 'Project_Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "ProjectAsset" */
export type ProjectAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Project_Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ProjectAsset" */
export type ProjectAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Project_Id?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ProjectAsset" */
export enum ProjectAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectId = 'Project_Id',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type ProjectAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectAsset_Set_Input>;
  where: ProjectAsset_Bool_Exp;
};

/** columns and relationships of "ProjectNote" */
export type ProjectNote = {
  __typename?: 'ProjectNote';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Notes: Scalars['String'];
  Participants: Scalars['String'];
  /** An object relationship */
  Project?: Maybe<Project>;
  ProjectId: Scalars['uuid'];
  /** An array relationship */
  ProjectNoteApplications: Array<ProjectNoteApplication>;
  /** An aggregate relationship */
  ProjectNoteApplications_aggregate: ProjectNoteApplication_Aggregate;
  /** An array relationship */
  ProjectNoteAssets: Array<ProjectNoteAsset>;
  /** An aggregate relationship */
  ProjectNoteAssets_aggregate: ProjectNoteAsset_Aggregate;
  Purpose: Scalars['String'];
  Reference: Scalars['bigint'];
  UpdatedOn: Scalars['timestamp'];
  /** An object relationship */
  User?: Maybe<User>;
  UserId: Scalars['uuid'];
  VisitedOn: Scalars['timestamp'];
};


/** columns and relationships of "ProjectNote" */
export type ProjectNoteProjectNoteApplicationsArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


/** columns and relationships of "ProjectNote" */
export type ProjectNoteProjectNoteApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


/** columns and relationships of "ProjectNote" */
export type ProjectNoteProjectNoteAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


/** columns and relationships of "ProjectNote" */
export type ProjectNoteProjectNoteAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};

/** Joins project notes to aplications */
export type ProjectNoteApplication = {
  __typename?: 'ProjectNoteApplication';
  /** An object relationship */
  Application?: Maybe<Application>;
  ApplicationId: Scalars['uuid'];
  Id: Scalars['uuid'];
  /** An object relationship */
  ProjectNote?: Maybe<ProjectNote>;
  ProjectNoteId: Scalars['uuid'];
};

/** aggregated selection of "ProjectNoteApplication" */
export type ProjectNoteApplication_Aggregate = {
  __typename?: 'ProjectNoteApplication_aggregate';
  aggregate?: Maybe<ProjectNoteApplication_Aggregate_Fields>;
  nodes: Array<ProjectNoteApplication>;
};

export type ProjectNoteApplication_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectNoteApplication_Aggregate_Bool_Exp_Count>;
};

export type ProjectNoteApplication_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ProjectNoteApplication" */
export type ProjectNoteApplication_Aggregate_Fields = {
  __typename?: 'ProjectNoteApplication_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProjectNoteApplication_Max_Fields>;
  min?: Maybe<ProjectNoteApplication_Min_Fields>;
};


/** aggregate fields of "ProjectNoteApplication" */
export type ProjectNoteApplication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ProjectNoteApplication" */
export type ProjectNoteApplication_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectNoteApplication_Max_Order_By>;
  min?: InputMaybe<ProjectNoteApplication_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ProjectNoteApplication" */
export type ProjectNoteApplication_Arr_Rel_Insert_Input = {
  data: Array<ProjectNoteApplication_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectNoteApplication_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ProjectNoteApplication". All fields are combined with a logical 'AND'. */
export type ProjectNoteApplication_Bool_Exp = {
  Application?: InputMaybe<Application_Bool_Exp>;
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ProjectNote?: InputMaybe<ProjectNote_Bool_Exp>;
  ProjectNoteId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectNoteApplication_Bool_Exp>>;
  _not?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectNoteApplication_Bool_Exp>>;
};

/** unique or primary key constraints on table "ProjectNoteApplication" */
export enum ProjectNoteApplication_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProjectNoteApplicationPkey = 'ProjectNoteApplication_pkey'
}

/** input type for inserting data into table "ProjectNoteApplication" */
export type ProjectNoteApplication_Insert_Input = {
  Application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNote?: InputMaybe<ProjectNote_Obj_Rel_Insert_Input>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ProjectNoteApplication_Max_Fields = {
  __typename?: 'ProjectNoteApplication_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  ProjectNoteId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ProjectNoteApplication" */
export type ProjectNoteApplication_Max_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectNoteApplication_Min_Fields = {
  __typename?: 'ProjectNoteApplication_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  ProjectNoteId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ProjectNoteApplication" */
export type ProjectNoteApplication_Min_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ProjectNoteApplication" */
export type ProjectNoteApplication_Mutation_Response = {
  __typename?: 'ProjectNoteApplication_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectNoteApplication>;
};

/** on_conflict condition type for table "ProjectNoteApplication" */
export type ProjectNoteApplication_On_Conflict = {
  constraint: ProjectNoteApplication_Constraint;
  update_columns?: Array<ProjectNoteApplication_Update_Column>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};

/** Ordering options when selecting data from "ProjectNoteApplication". */
export type ProjectNoteApplication_Order_By = {
  Application?: InputMaybe<Application_Order_By>;
  ApplicationId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNote?: InputMaybe<ProjectNote_Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ProjectNoteApplication */
export type ProjectNoteApplication_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ProjectNoteApplication" */
export enum ProjectNoteApplication_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectNoteId = 'ProjectNoteId'
}

/** input type for updating data in table "ProjectNoteApplication" */
export type ProjectNoteApplication_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ProjectNoteApplication" */
export type ProjectNoteApplication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectNoteApplication_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectNoteApplication_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
};

/** placeholder for update columns of table "ProjectNoteApplication" (current role has no relevant permissions) */
export enum ProjectNoteApplication_Update_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectNoteId = 'ProjectNoteId',
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type ProjectNoteApplication_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectNoteApplication_Set_Input>;
  where: ProjectNoteApplication_Bool_Exp;
};

/** columns and relationships of "ProjectNoteAsset" */
export type ProjectNoteAsset = {
  __typename?: 'ProjectNoteAsset';
  CreatedOn: Scalars['timestamp'];
  FileName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  ProjectNoteId: Scalars['uuid'];
  Type: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Uri: Scalars['String'];
};

export enum ProjectNoteAssetType {
  Photo = 'Photo',
  Unknown = 'Unknown'
}

/** aggregated selection of "ProjectNoteAsset" */
export type ProjectNoteAsset_Aggregate = {
  __typename?: 'ProjectNoteAsset_aggregate';
  aggregate?: Maybe<ProjectNoteAsset_Aggregate_Fields>;
  nodes: Array<ProjectNoteAsset>;
};

export type ProjectNoteAsset_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectNoteAsset_Aggregate_Bool_Exp_Count>;
};

export type ProjectNoteAsset_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ProjectNoteAsset" */
export type ProjectNoteAsset_Aggregate_Fields = {
  __typename?: 'ProjectNoteAsset_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ProjectNoteAsset_Max_Fields>;
  min?: Maybe<ProjectNoteAsset_Min_Fields>;
};


/** aggregate fields of "ProjectNoteAsset" */
export type ProjectNoteAsset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ProjectNoteAsset" */
export type ProjectNoteAsset_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectNoteAsset_Max_Order_By>;
  min?: InputMaybe<ProjectNoteAsset_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ProjectNoteAsset" */
export type ProjectNoteAsset_Arr_Rel_Insert_Input = {
  data: Array<ProjectNoteAsset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectNoteAsset_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ProjectNoteAsset". All fields are combined with a logical 'AND'. */
export type ProjectNoteAsset_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  FileName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  ProjectNoteId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectNoteAsset_Bool_Exp>>;
  _not?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectNoteAsset_Bool_Exp>>;
};

/** unique or primary key constraints on table "ProjectNoteAsset" */
export enum ProjectNoteAsset_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProjectNoteAssetPkey = 'ProjectNoteAsset_pkey'
}

/** input type for inserting data into table "ProjectNoteAsset" */
export type ProjectNoteAsset_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProjectNoteAsset_Max_Fields = {
  __typename?: 'ProjectNoteAsset_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  ProjectNoteId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ProjectNoteAsset" */
export type ProjectNoteAsset_Max_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectNoteAsset_Min_Fields = {
  __typename?: 'ProjectNoteAsset_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  ProjectNoteId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ProjectNoteAsset" */
export type ProjectNoteAsset_Min_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ProjectNoteAsset" */
export type ProjectNoteAsset_Mutation_Response = {
  __typename?: 'ProjectNoteAsset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectNoteAsset>;
};

/** on_conflict condition type for table "ProjectNoteAsset" */
export type ProjectNoteAsset_On_Conflict = {
  constraint: ProjectNoteAsset_Constraint;
  update_columns?: Array<ProjectNoteAsset_Update_Column>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};

/** Ordering options when selecting data from "ProjectNoteAsset". */
export type ProjectNoteAsset_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  FileName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  ProjectNoteId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ProjectNoteAsset */
export type ProjectNoteAsset_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ProjectNoteAsset" */
export enum ProjectNoteAsset_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectNoteId = 'ProjectNoteId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "ProjectNoteAsset" */
export type ProjectNoteAsset_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ProjectNoteAsset" */
export type ProjectNoteAsset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectNoteAsset_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectNoteAsset_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FileName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  ProjectNoteId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ProjectNoteAsset" */
export enum ProjectNoteAsset_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FileName = 'FileName',
  /** column name */
  Id = 'Id',
  /** column name */
  ProjectNoteId = 'ProjectNoteId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type ProjectNoteAsset_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectNoteAsset_Set_Input>;
  where: ProjectNoteAsset_Bool_Exp;
};

/** aggregated selection of "ProjectNote" */
export type ProjectNote_Aggregate = {
  __typename?: 'ProjectNote_aggregate';
  aggregate?: Maybe<ProjectNote_Aggregate_Fields>;
  nodes: Array<ProjectNote>;
};

/** aggregate fields of "ProjectNote" */
export type ProjectNote_Aggregate_Fields = {
  __typename?: 'ProjectNote_aggregate_fields';
  avg?: Maybe<ProjectNote_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProjectNote_Max_Fields>;
  min?: Maybe<ProjectNote_Min_Fields>;
  stddev?: Maybe<ProjectNote_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectNote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectNote_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectNote_Sum_Fields>;
  var_pop?: Maybe<ProjectNote_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectNote_Var_Samp_Fields>;
  variance?: Maybe<ProjectNote_Variance_Fields>;
};


/** aggregate fields of "ProjectNote" */
export type ProjectNote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectNote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProjectNote_Avg_Fields = {
  __typename?: 'ProjectNote_avg_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ProjectNote". All fields are combined with a logical 'AND'. */
export type ProjectNote_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Notes?: InputMaybe<String_Comparison_Exp>;
  Participants?: InputMaybe<String_Comparison_Exp>;
  Project?: InputMaybe<Project_Bool_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  ProjectNoteApplications?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
  ProjectNoteApplications_aggregate?: InputMaybe<ProjectNoteApplication_Aggregate_Bool_Exp>;
  ProjectNoteAssets?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
  ProjectNoteAssets_aggregate?: InputMaybe<ProjectNoteAsset_Aggregate_Bool_Exp>;
  Purpose?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  User?: InputMaybe<User_Bool_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  VisitedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectNote_Bool_Exp>>;
  _not?: InputMaybe<ProjectNote_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectNote_Bool_Exp>>;
};

/** unique or primary key constraints on table "ProjectNote" */
export enum ProjectNote_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProjectNotePkey = 'ProjectNote_pkey'
}

/** input type for incrementing numeric columns in table "ProjectNote" */
export type ProjectNote_Inc_Input = {
  Reference?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "ProjectNote" */
export type ProjectNote_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  Participants?: InputMaybe<Scalars['String']>;
  Project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  ProjectNoteApplications?: InputMaybe<ProjectNoteApplication_Arr_Rel_Insert_Input>;
  ProjectNoteAssets?: InputMaybe<ProjectNoteAsset_Arr_Rel_Insert_Input>;
  Purpose?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  User?: InputMaybe<User_Obj_Rel_Insert_Input>;
  UserId?: InputMaybe<Scalars['uuid']>;
  VisitedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type ProjectNote_Max_Fields = {
  __typename?: 'ProjectNote_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  Participants?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Purpose?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
  VisitedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type ProjectNote_Min_Fields = {
  __typename?: 'ProjectNote_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Notes?: Maybe<Scalars['String']>;
  Participants?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Purpose?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
  VisitedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "ProjectNote" */
export type ProjectNote_Mutation_Response = {
  __typename?: 'ProjectNote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProjectNote>;
};

/** input type for inserting object relation for remote table "ProjectNote" */
export type ProjectNote_Obj_Rel_Insert_Input = {
  data: ProjectNote_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ProjectNote_On_Conflict>;
};

/** on_conflict condition type for table "ProjectNote" */
export type ProjectNote_On_Conflict = {
  constraint: ProjectNote_Constraint;
  update_columns?: Array<ProjectNote_Update_Column>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};

/** Ordering options when selecting data from "ProjectNote". */
export type ProjectNote_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  Participants?: InputMaybe<Order_By>;
  Project?: InputMaybe<Project_Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  ProjectNoteApplications_aggregate?: InputMaybe<ProjectNoteApplication_Aggregate_Order_By>;
  ProjectNoteAssets_aggregate?: InputMaybe<ProjectNoteAsset_Aggregate_Order_By>;
  Purpose?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  User?: InputMaybe<User_Order_By>;
  UserId?: InputMaybe<Order_By>;
  VisitedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ProjectNote */
export type ProjectNote_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ProjectNote" */
export enum ProjectNote_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Notes = 'Notes',
  /** column name */
  Participants = 'Participants',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  Reference = 'Reference',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId',
  /** column name */
  VisitedOn = 'VisitedOn'
}

/** input type for updating data in table "ProjectNote" */
export type ProjectNote_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  Participants?: InputMaybe<Scalars['String']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Purpose?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
  VisitedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type ProjectNote_Stddev_Fields = {
  __typename?: 'ProjectNote_stddev_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProjectNote_Stddev_Pop_Fields = {
  __typename?: 'ProjectNote_stddev_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProjectNote_Stddev_Samp_Fields = {
  __typename?: 'ProjectNote_stddev_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ProjectNote" */
export type ProjectNote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectNote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectNote_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Notes?: InputMaybe<Scalars['String']>;
  Participants?: InputMaybe<Scalars['String']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Purpose?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
  VisitedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type ProjectNote_Sum_Fields = {
  __typename?: 'ProjectNote_sum_fields';
  Reference?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ProjectNote" */
export enum ProjectNote_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Notes = 'Notes',
  /** column name */
  Participants = 'Participants',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  Reference = 'Reference',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId',
  /** column name */
  VisitedOn = 'VisitedOn'
}

export type ProjectNote_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProjectNote_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProjectNote_Set_Input>;
  where: ProjectNote_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProjectNote_Var_Pop_Fields = {
  __typename?: 'ProjectNote_var_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProjectNote_Var_Samp_Fields = {
  __typename?: 'ProjectNote_var_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProjectNote_Variance_Fields = {
  __typename?: 'ProjectNote_variance_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ProjectStats" */
export type ProjectStats = {
  __typename?: 'ProjectStats';
  ProjectId?: Maybe<Scalars['uuid']>;
  Season?: Maybe<Scalars['String']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "ProjectStats" */
export type ProjectStats_Aggregate = {
  __typename?: 'ProjectStats_aggregate';
  aggregate?: Maybe<ProjectStats_Aggregate_Fields>;
  nodes: Array<ProjectStats>;
};

export type ProjectStats_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProjectStats_Aggregate_Bool_Exp_Count>;
};

export type ProjectStats_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProjectStats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProjectStats_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ProjectStats" */
export type ProjectStats_Aggregate_Fields = {
  __typename?: 'ProjectStats_aggregate_fields';
  avg?: Maybe<ProjectStats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProjectStats_Max_Fields>;
  min?: Maybe<ProjectStats_Min_Fields>;
  stddev?: Maybe<ProjectStats_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectStats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectStats_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectStats_Sum_Fields>;
  var_pop?: Maybe<ProjectStats_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectStats_Var_Samp_Fields>;
  variance?: Maybe<ProjectStats_Variance_Fields>;
};


/** aggregate fields of "ProjectStats" */
export type ProjectStats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectStats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ProjectStats" */
export type ProjectStats_Aggregate_Order_By = {
  avg?: InputMaybe<ProjectStats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProjectStats_Max_Order_By>;
  min?: InputMaybe<ProjectStats_Min_Order_By>;
  stddev?: InputMaybe<ProjectStats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProjectStats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProjectStats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProjectStats_Sum_Order_By>;
  var_pop?: InputMaybe<ProjectStats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProjectStats_Var_Samp_Order_By>;
  variance?: InputMaybe<ProjectStats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type ProjectStats_Avg_Fields = {
  __typename?: 'ProjectStats_avg_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ProjectStats" */
export type ProjectStats_Avg_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ProjectStats". All fields are combined with a logical 'AND'. */
export type ProjectStats_Bool_Exp = {
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  Season?: InputMaybe<String_Comparison_Exp>;
  TreesApproved?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectStats_Bool_Exp>>;
  _not?: InputMaybe<ProjectStats_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectStats_Bool_Exp>>;
};

/** aggregate max on columns */
export type ProjectStats_Max_Fields = {
  __typename?: 'ProjectStats_max_fields';
  ProjectId?: Maybe<Scalars['uuid']>;
  Season?: Maybe<Scalars['String']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "ProjectStats" */
export type ProjectStats_Max_Order_By = {
  ProjectId?: InputMaybe<Order_By>;
  Season?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProjectStats_Min_Fields = {
  __typename?: 'ProjectStats_min_fields';
  ProjectId?: Maybe<Scalars['uuid']>;
  Season?: Maybe<Scalars['String']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "ProjectStats" */
export type ProjectStats_Min_Order_By = {
  ProjectId?: InputMaybe<Order_By>;
  Season?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "ProjectStats". */
export type ProjectStats_Order_By = {
  ProjectId?: InputMaybe<Order_By>;
  Season?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
};

/** select columns of table "ProjectStats" */
export enum ProjectStats_Select_Column {
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Season = 'Season',
  /** column name */
  TreesApproved = 'TreesApproved'
}

/** aggregate stddev on columns */
export type ProjectStats_Stddev_Fields = {
  __typename?: 'ProjectStats_stddev_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ProjectStats" */
export type ProjectStats_Stddev_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProjectStats_Stddev_Pop_Fields = {
  __typename?: 'ProjectStats_stddev_pop_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ProjectStats" */
export type ProjectStats_Stddev_Pop_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProjectStats_Stddev_Samp_Fields = {
  __typename?: 'ProjectStats_stddev_samp_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ProjectStats" */
export type ProjectStats_Stddev_Samp_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ProjectStats" */
export type ProjectStats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectStats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectStats_Stream_Cursor_Value_Input = {
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Season?: InputMaybe<Scalars['String']>;
  TreesApproved?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type ProjectStats_Sum_Fields = {
  __typename?: 'ProjectStats_sum_fields';
  TreesApproved?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "ProjectStats" */
export type ProjectStats_Sum_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type ProjectStats_Var_Pop_Fields = {
  __typename?: 'ProjectStats_var_pop_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ProjectStats" */
export type ProjectStats_Var_Pop_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProjectStats_Var_Samp_Fields = {
  __typename?: 'ProjectStats_var_samp_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ProjectStats" */
export type ProjectStats_Var_Samp_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProjectStats_Variance_Fields = {
  __typename?: 'ProjectStats_variance_fields';
  TreesApproved?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ProjectStats" */
export type ProjectStats_Variance_Order_By = {
  TreesApproved?: InputMaybe<Order_By>;
};

/** columns and relationships of "ProjectView" */
export type ProjectView = {
  __typename?: 'ProjectView';
  /** An array relationship */
  Applications: Array<Application>;
  /** An aggregate relationship */
  Applications_aggregate: Application_Aggregate;
  Area?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandUse?: Maybe<Scalars['jsonb']>;
  LandUseOther?: Maybe<Scalars['String']>;
  MonitoringEvents?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfProperties?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  /** An object relationship */
  Planter?: Maybe<Planter>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingTimeframes?: Maybe<Scalars['String']>;
  Plantings?: Maybe<Scalars['bigint']>;
  /** fetch data from the table: "ProjectStats" */
  ProjectStats: Array<ProjectStats>;
  /** fetch aggregated fields from the table: "ProjectStats" */
  ProjectStats_aggregate: ProjectStats_Aggregate;
  PublicPage?: Maybe<Scalars['Boolean']>;
  Purpose?: Maybe<Scalars['jsonb']>;
  Reference?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
  TreesPlanted?: Maybe<Scalars['numeric']>;
  WebsiteLinks?: Maybe<Scalars['jsonb']>;
  WorkflowState?: Maybe<Scalars['String']>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewLandUseArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewProjectStatsArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewProjectStats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewPurposeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ProjectView" */
export type ProjectViewWebsiteLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ProjectView" */
export type ProjectView_Aggregate = {
  __typename?: 'ProjectView_aggregate';
  aggregate?: Maybe<ProjectView_Aggregate_Fields>;
  nodes: Array<ProjectView>;
};

/** aggregate fields of "ProjectView" */
export type ProjectView_Aggregate_Fields = {
  __typename?: 'ProjectView_aggregate_fields';
  avg?: Maybe<ProjectView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProjectView_Max_Fields>;
  min?: Maybe<ProjectView_Min_Fields>;
  stddev?: Maybe<ProjectView_Stddev_Fields>;
  stddev_pop?: Maybe<ProjectView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProjectView_Stddev_Samp_Fields>;
  sum?: Maybe<ProjectView_Sum_Fields>;
  var_pop?: Maybe<ProjectView_Var_Pop_Fields>;
  var_samp?: Maybe<ProjectView_Var_Samp_Fields>;
  variance?: Maybe<ProjectView_Variance_Fields>;
};


/** aggregate fields of "ProjectView" */
export type ProjectView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProjectView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ProjectView_Avg_Fields = {
  __typename?: 'ProjectView_avg_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ProjectView". All fields are combined with a logical 'AND'. */
export type ProjectView_Bool_Exp = {
  Applications?: InputMaybe<Application_Bool_Exp>;
  Applications_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  Area?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  FeaturedOn?: InputMaybe<String_Comparison_Exp>;
  Hero?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LandUse?: InputMaybe<Jsonb_Comparison_Exp>;
  LandUseOther?: InputMaybe<String_Comparison_Exp>;
  MonitoringEvents?: InputMaybe<Numeric_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  NumberOfProperties?: InputMaybe<String_Comparison_Exp>;
  OtherLandArea?: InputMaybe<String_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingTimeframes?: InputMaybe<String_Comparison_Exp>;
  Plantings?: InputMaybe<Bigint_Comparison_Exp>;
  ProjectStats?: InputMaybe<ProjectStats_Bool_Exp>;
  ProjectStats_aggregate?: InputMaybe<ProjectStats_Aggregate_Bool_Exp>;
  PublicPage?: InputMaybe<Boolean_Comparison_Exp>;
  Purpose?: InputMaybe<Jsonb_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  TreesApproved?: InputMaybe<Numeric_Comparison_Exp>;
  TreesPlanted?: InputMaybe<Numeric_Comparison_Exp>;
  WebsiteLinks?: InputMaybe<Jsonb_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<ProjectView_Bool_Exp>>;
  _not?: InputMaybe<ProjectView_Bool_Exp>;
  _or?: InputMaybe<Array<ProjectView_Bool_Exp>>;
};

/** aggregate max on columns */
export type ProjectView_Max_Fields = {
  __typename?: 'ProjectView_max_fields';
  Area?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandUseOther?: Maybe<Scalars['String']>;
  MonitoringEvents?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfProperties?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingTimeframes?: Maybe<Scalars['String']>;
  Plantings?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
  TreesPlanted?: Maybe<Scalars['numeric']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProjectView_Min_Fields = {
  __typename?: 'ProjectView_min_fields';
  Area?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandUseOther?: Maybe<Scalars['String']>;
  MonitoringEvents?: Maybe<Scalars['numeric']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfProperties?: Maybe<Scalars['String']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingTimeframes?: Maybe<Scalars['String']>;
  Plantings?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
  TreesPlanted?: Maybe<Scalars['numeric']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "ProjectView". */
export type ProjectView_Order_By = {
  Applications_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FeaturedOn?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LandUseOther?: InputMaybe<Order_By>;
  MonitoringEvents?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfProperties?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingTimeframes?: InputMaybe<Order_By>;
  Plantings?: InputMaybe<Order_By>;
  ProjectStats_aggregate?: InputMaybe<ProjectStats_Aggregate_Order_By>;
  PublicPage?: InputMaybe<Order_By>;
  Purpose?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
  TreesPlanted?: InputMaybe<Order_By>;
  WebsiteLinks?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** select columns of table "ProjectView" */
export enum ProjectView_Select_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FeaturedOn = 'FeaturedOn',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LandUseOther = 'LandUseOther',
  /** column name */
  MonitoringEvents = 'MonitoringEvents',
  /** column name */
  Name = 'Name',
  /** column name */
  NumberOfProperties = 'NumberOfProperties',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingTimeframes = 'PlantingTimeframes',
  /** column name */
  Plantings = 'Plantings',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  TreesApproved = 'TreesApproved',
  /** column name */
  TreesPlanted = 'TreesPlanted',
  /** column name */
  WebsiteLinks = 'WebsiteLinks',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** aggregate stddev on columns */
export type ProjectView_Stddev_Fields = {
  __typename?: 'ProjectView_stddev_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ProjectView_Stddev_Pop_Fields = {
  __typename?: 'ProjectView_stddev_pop_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ProjectView_Stddev_Samp_Fields = {
  __typename?: 'ProjectView_stddev_samp_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ProjectView" */
export type ProjectView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProjectView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProjectView_Stream_Cursor_Value_Input = {
  Area?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FeaturedOn?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  MonitoringEvents?: InputMaybe<Scalars['numeric']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  Plantings?: InputMaybe<Scalars['bigint']>;
  PublicPage?: InputMaybe<Scalars['Boolean']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  TreesApproved?: InputMaybe<Scalars['numeric']>;
  TreesPlanted?: InputMaybe<Scalars['numeric']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ProjectView_Sum_Fields = {
  __typename?: 'ProjectView_sum_fields';
  MonitoringEvents?: Maybe<Scalars['numeric']>;
  Plantings?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['numeric']>;
  TreesPlanted?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type ProjectView_Var_Pop_Fields = {
  __typename?: 'ProjectView_var_pop_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ProjectView_Var_Samp_Fields = {
  __typename?: 'ProjectView_var_samp_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ProjectView_Variance_Fields = {
  __typename?: 'ProjectView_variance_fields';
  MonitoringEvents?: Maybe<Scalars['Float']>;
  Plantings?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TreesPlanted?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Project" */
export type Project_Aggregate = {
  __typename?: 'Project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

export type Project_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Project_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Project_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Project_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Project_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Project_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Project_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Project_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Project_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Project_Aggregate_Bool_Exp_Var_Samp>;
};

export type Project_Aggregate_Bool_Exp_Avg = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Corr = {
  arguments: Project_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Project_Select_Column_Project_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Project_Select_Column_Project_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Project_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Project_Select_Column_Project_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Project_Select_Column_Project_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Project_Aggregate_Bool_Exp_Max = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Min = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Sum = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "Project" */
export type Project_Aggregate_Fields = {
  __typename?: 'Project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "Project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Project" */
export type Project_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Max_Order_By>;
  min?: InputMaybe<Project_Min_Order_By>;
  stddev?: InputMaybe<Project_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Append_Input = {
  LandUse?: InputMaybe<Scalars['jsonb']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "Project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'Project_avg_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Project" */
export type Project_Avg_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  Applications?: InputMaybe<Application_Bool_Exp>;
  Applications_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  Area?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  FeaturedOn?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Hero?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsPublic?: InputMaybe<Boolean_Comparison_Exp>;
  LandUse?: InputMaybe<Jsonb_Comparison_Exp>;
  LandUseOther?: InputMaybe<String_Comparison_Exp>;
  LegacyArea?: InputMaybe<Float8_Comparison_Exp>;
  LegacyPlantingTimeframes?: InputMaybe<Int_Comparison_Exp>;
  LegacySocialUrl?: InputMaybe<String_Comparison_Exp>;
  LegacyWebsiteUrl?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  NumberOfProperties?: InputMaybe<String_Comparison_Exp>;
  NumberOfTreesFundedPreviously?: InputMaybe<Int_Comparison_Exp>;
  OpenFrom?: InputMaybe<Timestamp_Comparison_Exp>;
  OpenTo?: InputMaybe<Timestamp_Comparison_Exp>;
  OtherAvailableLand?: InputMaybe<Boolean_Comparison_Exp>;
  OtherLandArea?: InputMaybe<String_Comparison_Exp>;
  Planter?: InputMaybe<Planter_Bool_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingTimeframes?: InputMaybe<String_Comparison_Exp>;
  ProjectAssets?: InputMaybe<ProjectAsset_Bool_Exp>;
  ProjectAssets_aggregate?: InputMaybe<ProjectAsset_Aggregate_Bool_Exp>;
  PublicPage?: InputMaybe<Boolean_Comparison_Exp>;
  Purpose?: InputMaybe<Jsonb_Comparison_Exp>;
  ReceivedFundingPreviously?: InputMaybe<Boolean_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  WebsiteLinks?: InputMaybe<Jsonb_Comparison_Exp>;
  WorkflowState?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
};

/** unique or primary key constraints on table "Project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ProjectPkey = 'Project_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Delete_At_Path_Input = {
  LandUse?: InputMaybe<Array<Scalars['String']>>;
  Purpose?: InputMaybe<Array<Scalars['String']>>;
  WebsiteLinks?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * delete the array element with specified index (negative integers count from the
 * end). throws an error if top level container is not an array
 */
export type Project_Delete_Elem_Input = {
  LandUse?: InputMaybe<Scalars['Int']>;
  Purpose?: InputMaybe<Scalars['Int']>;
  WebsiteLinks?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Delete_Key_Input = {
  LandUse?: InputMaybe<Scalars['String']>;
  Purpose?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "Project" */
export type Project_Inc_Input = {
  LegacyArea?: InputMaybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: InputMaybe<Scalars['Int']>;
  NumberOfTreesFundedPreviously?: InputMaybe<Scalars['Int']>;
  Reference?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Project" */
export type Project_Insert_Input = {
  Applications?: InputMaybe<Application_Arr_Rel_Insert_Input>;
  Area?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FeaturedOn?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsPublic?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  LegacyArea?: InputMaybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: InputMaybe<Scalars['Int']>;
  LegacySocialUrl?: InputMaybe<Scalars['String']>;
  LegacyWebsiteUrl?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  NumberOfTreesFundedPreviously?: InputMaybe<Scalars['Int']>;
  OpenFrom?: InputMaybe<Scalars['timestamp']>;
  OpenTo?: InputMaybe<Scalars['timestamp']>;
  OtherAvailableLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  Planter?: InputMaybe<Planter_Obj_Rel_Insert_Input>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  ProjectAssets?: InputMaybe<ProjectAsset_Arr_Rel_Insert_Input>;
  PublicPage?: InputMaybe<Scalars['Boolean']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  ReceivedFundingPreviously?: InputMaybe<Scalars['Boolean']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'Project_max_fields';
  Area?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandUseOther?: Maybe<Scalars['String']>;
  LegacyArea?: Maybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Int']>;
  LegacySocialUrl?: Maybe<Scalars['String']>;
  LegacyWebsiteUrl?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfProperties?: Maybe<Scalars['String']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Int']>;
  OpenFrom?: Maybe<Scalars['timestamp']>;
  OpenTo?: Maybe<Scalars['timestamp']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingTimeframes?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Project" */
export type Project_Max_Order_By = {
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  FeaturedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandUseOther?: InputMaybe<Order_By>;
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  LegacySocialUrl?: InputMaybe<Order_By>;
  LegacyWebsiteUrl?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfProperties?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  OpenFrom?: InputMaybe<Order_By>;
  OpenTo?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingTimeframes?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'Project_min_fields';
  Area?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FeaturedOn?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandUseOther?: Maybe<Scalars['String']>;
  LegacyArea?: Maybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Int']>;
  LegacySocialUrl?: Maybe<Scalars['String']>;
  LegacyWebsiteUrl?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  NumberOfProperties?: Maybe<Scalars['String']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Int']>;
  OpenFrom?: Maybe<Scalars['timestamp']>;
  OpenTo?: Maybe<Scalars['timestamp']>;
  OtherLandArea?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingTimeframes?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
  WorkflowState?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Project" */
export type Project_Min_Order_By = {
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  FeaturedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandUseOther?: InputMaybe<Order_By>;
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  LegacySocialUrl?: InputMaybe<Order_By>;
  LegacyWebsiteUrl?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfProperties?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  OpenFrom?: InputMaybe<Order_By>;
  OpenTo?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingTimeframes?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Project" */
export type Project_Mutation_Response = {
  __typename?: 'Project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "Project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "Project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "Project". */
export type Project_Order_By = {
  Applications_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  FeaturedOn?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsPublic?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  LandUseOther?: InputMaybe<Order_By>;
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  LegacySocialUrl?: InputMaybe<Order_By>;
  LegacyWebsiteUrl?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  NumberOfProperties?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  OpenFrom?: InputMaybe<Order_By>;
  OpenTo?: InputMaybe<Order_By>;
  OtherAvailableLand?: InputMaybe<Order_By>;
  OtherLandArea?: InputMaybe<Order_By>;
  Planter?: InputMaybe<Planter_Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingTimeframes?: InputMaybe<Order_By>;
  ProjectAssets_aggregate?: InputMaybe<ProjectAsset_Aggregate_Order_By>;
  PublicPage?: InputMaybe<Order_By>;
  Purpose?: InputMaybe<Order_By>;
  ReceivedFundingPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
  WebsiteLinks?: InputMaybe<Order_By>;
  WorkflowState?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Project */
export type Project_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Prepend_Input = {
  LandUse?: InputMaybe<Scalars['jsonb']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "Project" */
export enum Project_Select_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FeaturedOn = 'FeaturedOn',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  IsPublic = 'IsPublic',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LandUseOther = 'LandUseOther',
  /** column name */
  LegacyArea = 'LegacyArea',
  /** column name */
  LegacyPlantingTimeframes = 'LegacyPlantingTimeframes',
  /** column name */
  LegacySocialUrl = 'LegacySocialUrl',
  /** column name */
  LegacyWebsiteUrl = 'LegacyWebsiteUrl',
  /** column name */
  Name = 'Name',
  /** column name */
  NumberOfProperties = 'NumberOfProperties',
  /** column name */
  NumberOfTreesFundedPreviously = 'NumberOfTreesFundedPreviously',
  /** column name */
  OpenFrom = 'OpenFrom',
  /** column name */
  OpenTo = 'OpenTo',
  /** column name */
  OtherAvailableLand = 'OtherAvailableLand',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingTimeframes = 'PlantingTimeframes',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  ReceivedFundingPreviously = 'ReceivedFundingPreviously',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri',
  /** column name */
  WebsiteLinks = 'WebsiteLinks',
  /** column name */
  WorkflowState = 'WorkflowState'
}

/** select "Project_aggregate_bool_exp_avg_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPublic = 'IsPublic',
  /** column name */
  OtherAvailableLand = 'OtherAvailableLand',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  ReceivedFundingPreviously = 'ReceivedFundingPreviously'
}

/** select "Project_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPublic = 'IsPublic',
  /** column name */
  OtherAvailableLand = 'OtherAvailableLand',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  ReceivedFundingPreviously = 'ReceivedFundingPreviously'
}

/** select "Project_aggregate_bool_exp_corr_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_max_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_min_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_sum_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** select "Project_aggregate_bool_exp_var_samp_arguments_columns" columns of table "Project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  LegacyArea = 'LegacyArea'
}

/** input type for updating data in table "Project" */
export type Project_Set_Input = {
  Area?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FeaturedOn?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsPublic?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  LegacyArea?: InputMaybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: InputMaybe<Scalars['Int']>;
  LegacySocialUrl?: InputMaybe<Scalars['String']>;
  LegacyWebsiteUrl?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  NumberOfTreesFundedPreviously?: InputMaybe<Scalars['Int']>;
  OpenFrom?: InputMaybe<Scalars['timestamp']>;
  OpenTo?: InputMaybe<Scalars['timestamp']>;
  OtherAvailableLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  PublicPage?: InputMaybe<Scalars['Boolean']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  ReceivedFundingPreviously?: InputMaybe<Scalars['Boolean']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'Project_stddev_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Project" */
export type Project_Stddev_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'Project_stddev_pop_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Project" */
export type Project_Stddev_Pop_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'Project_stddev_samp_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Project" */
export type Project_Stddev_Samp_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  Area?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FeaturedOn?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsPublic?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  LegacyArea?: InputMaybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: InputMaybe<Scalars['Int']>;
  LegacySocialUrl?: InputMaybe<Scalars['String']>;
  LegacyWebsiteUrl?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  NumberOfTreesFundedPreviously?: InputMaybe<Scalars['Int']>;
  OpenFrom?: InputMaybe<Scalars['timestamp']>;
  OpenTo?: InputMaybe<Scalars['timestamp']>;
  OtherAvailableLand?: InputMaybe<Scalars['Boolean']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  PublicPage?: InputMaybe<Scalars['Boolean']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  ReceivedFundingPreviously?: InputMaybe<Scalars['Boolean']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
  WorkflowState?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'Project_sum_fields';
  LegacyArea?: Maybe<Scalars['float8']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Int']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Int']>;
  Reference?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Project" */
export type Project_Sum_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** update columns of table "Project" */
export enum Project_Update_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FeaturedOn = 'FeaturedOn',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  IsPublic = 'IsPublic',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  LandUseOther = 'LandUseOther',
  /** column name */
  LegacyArea = 'LegacyArea',
  /** column name */
  LegacyPlantingTimeframes = 'LegacyPlantingTimeframes',
  /** column name */
  LegacySocialUrl = 'LegacySocialUrl',
  /** column name */
  LegacyWebsiteUrl = 'LegacyWebsiteUrl',
  /** column name */
  Name = 'Name',
  /** column name */
  NumberOfProperties = 'NumberOfProperties',
  /** column name */
  NumberOfTreesFundedPreviously = 'NumberOfTreesFundedPreviously',
  /** column name */
  OpenFrom = 'OpenFrom',
  /** column name */
  OpenTo = 'OpenTo',
  /** column name */
  OtherAvailableLand = 'OtherAvailableLand',
  /** column name */
  OtherLandArea = 'OtherLandArea',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingTimeframes = 'PlantingTimeframes',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  ReceivedFundingPreviously = 'ReceivedFundingPreviously',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri',
  /** column name */
  WebsiteLinks = 'WebsiteLinks',
  /** column name */
  WorkflowState = 'WorkflowState'
}

export type Project_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  /**
   * delete the array element with specified index (negative integers count from
   * the end). throws an error if top level container is not an array
   */
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'Project_var_pop_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Project" */
export type Project_Var_Pop_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'Project_var_samp_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Project" */
export type Project_Var_Samp_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'Project_variance_fields';
  LegacyArea?: Maybe<Scalars['Float']>;
  LegacyPlantingTimeframes?: Maybe<Scalars['Float']>;
  NumberOfTreesFundedPreviously?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Project" */
export type Project_Variance_Order_By = {
  LegacyArea?: InputMaybe<Order_By>;
  LegacyPlantingTimeframes?: InputMaybe<Order_By>;
  NumberOfTreesFundedPreviously?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
};

/** Placeholder table containing columns returned for the PlanterStats function - only accessible by the public */
export type PublicFunderStat = {
  __typename?: 'PublicFunderStat';
  AccountYearJoined: Scalars['bigint'];
  PlantersSupported: Scalars['bigint'];
  ProjectSupported: Scalars['bigint'];
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName: Scalars['String'];
  TreesFunded: Scalars['bigint'];
};

/** aggregated selection of "PublicFunderStat" */
export type PublicFunderStat_Aggregate = {
  __typename?: 'PublicFunderStat_aggregate';
  aggregate?: Maybe<PublicFunderStat_Aggregate_Fields>;
  nodes: Array<PublicFunderStat>;
};

/** aggregate fields of "PublicFunderStat" */
export type PublicFunderStat_Aggregate_Fields = {
  __typename?: 'PublicFunderStat_aggregate_fields';
  avg?: Maybe<PublicFunderStat_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PublicFunderStat_Max_Fields>;
  min?: Maybe<PublicFunderStat_Min_Fields>;
  stddev?: Maybe<PublicFunderStat_Stddev_Fields>;
  stddev_pop?: Maybe<PublicFunderStat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicFunderStat_Stddev_Samp_Fields>;
  sum?: Maybe<PublicFunderStat_Sum_Fields>;
  var_pop?: Maybe<PublicFunderStat_Var_Pop_Fields>;
  var_samp?: Maybe<PublicFunderStat_Var_Samp_Fields>;
  variance?: Maybe<PublicFunderStat_Variance_Fields>;
};


/** aggregate fields of "PublicFunderStat" */
export type PublicFunderStat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PublicFunderStat_Avg_Fields = {
  __typename?: 'PublicFunderStat_avg_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PublicFunderStat". All fields are combined with a logical 'AND'. */
export type PublicFunderStat_Bool_Exp = {
  AccountYearJoined?: InputMaybe<Bigint_Comparison_Exp>;
  PlantersSupported?: InputMaybe<Bigint_Comparison_Exp>;
  ProjectSupported?: InputMaybe<Bigint_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  TreesFunded?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<PublicFunderStat_Bool_Exp>>;
  _not?: InputMaybe<PublicFunderStat_Bool_Exp>;
  _or?: InputMaybe<Array<PublicFunderStat_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "PublicFunderStat" */
export type PublicFunderStat_Inc_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "PublicFunderStat" */
export type PublicFunderStat_Insert_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PublicFunderStat_Max_Fields = {
  __typename?: 'PublicFunderStat_max_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PublicFunderStat_Min_Fields = {
  __typename?: 'PublicFunderStat_min_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "PublicFunderStat" */
export type PublicFunderStat_Mutation_Response = {
  __typename?: 'PublicFunderStat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicFunderStat>;
};

/** Ordering options when selecting data from "PublicFunderStat". */
export type PublicFunderStat_Order_By = {
  AccountYearJoined?: InputMaybe<Order_By>;
  PlantersSupported?: InputMaybe<Order_By>;
  ProjectSupported?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  TreesFunded?: InputMaybe<Order_By>;
};

/** select columns of table "PublicFunderStat" */
export enum PublicFunderStat_Select_Column {
  /** column name */
  AccountYearJoined = 'AccountYearJoined',
  /** column name */
  PlantersSupported = 'PlantersSupported',
  /** column name */
  ProjectSupported = 'ProjectSupported',
  /** column name */
  Rank = 'Rank',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  TreesFunded = 'TreesFunded'
}

/** input type for updating data in table "PublicFunderStat" */
export type PublicFunderStat_Set_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PublicFunderStat_Stddev_Fields = {
  __typename?: 'PublicFunderStat_stddev_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PublicFunderStat_Stddev_Pop_Fields = {
  __typename?: 'PublicFunderStat_stddev_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PublicFunderStat_Stddev_Samp_Fields = {
  __typename?: 'PublicFunderStat_stddev_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PublicFunderStat" */
export type PublicFunderStat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicFunderStat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicFunderStat_Stream_Cursor_Value_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  PlantersSupported?: InputMaybe<Scalars['bigint']>;
  ProjectSupported?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TreesFunded?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PublicFunderStat_Sum_Fields = {
  __typename?: 'PublicFunderStat_sum_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  PlantersSupported?: Maybe<Scalars['bigint']>;
  ProjectSupported?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  TreesFunded?: Maybe<Scalars['bigint']>;
};

export type PublicFunderStat_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicFunderStat_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicFunderStat_Set_Input>;
  where: PublicFunderStat_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicFunderStat_Var_Pop_Fields = {
  __typename?: 'PublicFunderStat_var_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PublicFunderStat_Var_Samp_Fields = {
  __typename?: 'PublicFunderStat_var_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PublicFunderStat_Variance_Fields = {
  __typename?: 'PublicFunderStat_variance_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  PlantersSupported?: Maybe<Scalars['Float']>;
  ProjectSupported?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TreesFunded?: Maybe<Scalars['Float']>;
};

export type PublicFunderStatsForAccount_Args = {
  AccountId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "PublicPlanterStat" */
export type PublicPlanterStat = {
  __typename?: 'PublicPlanterStat';
  AccountYearJoined: Scalars['bigint'];
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName: Scalars['String'];
  TotalApplications: Scalars['bigint'];
  TotalMonitorings: Scalars['bigint'];
  TotalProjects: Scalars['bigint'];
  TreesApproved: Scalars['bigint'];
  TressReceived: Scalars['bigint'];
};

/** aggregated selection of "PublicPlanterStat" */
export type PublicPlanterStat_Aggregate = {
  __typename?: 'PublicPlanterStat_aggregate';
  aggregate?: Maybe<PublicPlanterStat_Aggregate_Fields>;
  nodes: Array<PublicPlanterStat>;
};

/** aggregate fields of "PublicPlanterStat" */
export type PublicPlanterStat_Aggregate_Fields = {
  __typename?: 'PublicPlanterStat_aggregate_fields';
  avg?: Maybe<PublicPlanterStat_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PublicPlanterStat_Max_Fields>;
  min?: Maybe<PublicPlanterStat_Min_Fields>;
  stddev?: Maybe<PublicPlanterStat_Stddev_Fields>;
  stddev_pop?: Maybe<PublicPlanterStat_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PublicPlanterStat_Stddev_Samp_Fields>;
  sum?: Maybe<PublicPlanterStat_Sum_Fields>;
  var_pop?: Maybe<PublicPlanterStat_Var_Pop_Fields>;
  var_samp?: Maybe<PublicPlanterStat_Var_Samp_Fields>;
  variance?: Maybe<PublicPlanterStat_Variance_Fields>;
};


/** aggregate fields of "PublicPlanterStat" */
export type PublicPlanterStat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PublicPlanterStat_Avg_Fields = {
  __typename?: 'PublicPlanterStat_avg_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PublicPlanterStat". All fields are combined with a logical 'AND'. */
export type PublicPlanterStat_Bool_Exp = {
  AccountYearJoined?: InputMaybe<Bigint_Comparison_Exp>;
  MostPopularRegion?: InputMaybe<String_Comparison_Exp>;
  MostPopularSpecies?: InputMaybe<String_Comparison_Exp>;
  Rank?: InputMaybe<Bigint_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  TotalApplications?: InputMaybe<Bigint_Comparison_Exp>;
  TotalMonitorings?: InputMaybe<Bigint_Comparison_Exp>;
  TotalProjects?: InputMaybe<Bigint_Comparison_Exp>;
  TreesApproved?: InputMaybe<Bigint_Comparison_Exp>;
  TressReceived?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<PublicPlanterStat_Bool_Exp>>;
  _not?: InputMaybe<PublicPlanterStat_Bool_Exp>;
  _or?: InputMaybe<Array<PublicPlanterStat_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "PublicPlanterStat" */
export type PublicPlanterStat_Inc_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TressReceived?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "PublicPlanterStat" */
export type PublicPlanterStat_Insert_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TressReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PublicPlanterStat_Max_Fields = {
  __typename?: 'PublicPlanterStat_max_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TressReceived?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PublicPlanterStat_Min_Fields = {
  __typename?: 'PublicPlanterStat_min_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  MostPopularRegion?: Maybe<Scalars['String']>;
  MostPopularSpecies?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['bigint']>;
  SeasonName?: Maybe<Scalars['String']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TressReceived?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "PublicPlanterStat" */
export type PublicPlanterStat_Mutation_Response = {
  __typename?: 'PublicPlanterStat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicPlanterStat>;
};

/** Ordering options when selecting data from "PublicPlanterStat". */
export type PublicPlanterStat_Order_By = {
  AccountYearJoined?: InputMaybe<Order_By>;
  MostPopularRegion?: InputMaybe<Order_By>;
  MostPopularSpecies?: InputMaybe<Order_By>;
  Rank?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  TotalApplications?: InputMaybe<Order_By>;
  TotalMonitorings?: InputMaybe<Order_By>;
  TotalProjects?: InputMaybe<Order_By>;
  TreesApproved?: InputMaybe<Order_By>;
  TressReceived?: InputMaybe<Order_By>;
};

/** select columns of table "PublicPlanterStat" */
export enum PublicPlanterStat_Select_Column {
  /** column name */
  AccountYearJoined = 'AccountYearJoined',
  /** column name */
  MostPopularRegion = 'MostPopularRegion',
  /** column name */
  MostPopularSpecies = 'MostPopularSpecies',
  /** column name */
  Rank = 'Rank',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  TotalApplications = 'TotalApplications',
  /** column name */
  TotalMonitorings = 'TotalMonitorings',
  /** column name */
  TotalProjects = 'TotalProjects',
  /** column name */
  TreesApproved = 'TreesApproved',
  /** column name */
  TressReceived = 'TressReceived'
}

/** input type for updating data in table "PublicPlanterStat" */
export type PublicPlanterStat_Set_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TressReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PublicPlanterStat_Stddev_Fields = {
  __typename?: 'PublicPlanterStat_stddev_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PublicPlanterStat_Stddev_Pop_Fields = {
  __typename?: 'PublicPlanterStat_stddev_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PublicPlanterStat_Stddev_Samp_Fields = {
  __typename?: 'PublicPlanterStat_stddev_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PublicPlanterStat" */
export type PublicPlanterStat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PublicPlanterStat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PublicPlanterStat_Stream_Cursor_Value_Input = {
  AccountYearJoined?: InputMaybe<Scalars['bigint']>;
  MostPopularRegion?: InputMaybe<Scalars['String']>;
  MostPopularSpecies?: InputMaybe<Scalars['String']>;
  Rank?: InputMaybe<Scalars['bigint']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  TotalApplications?: InputMaybe<Scalars['bigint']>;
  TotalMonitorings?: InputMaybe<Scalars['bigint']>;
  TotalProjects?: InputMaybe<Scalars['bigint']>;
  TreesApproved?: InputMaybe<Scalars['bigint']>;
  TressReceived?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PublicPlanterStat_Sum_Fields = {
  __typename?: 'PublicPlanterStat_sum_fields';
  AccountYearJoined?: Maybe<Scalars['bigint']>;
  Rank?: Maybe<Scalars['bigint']>;
  TotalApplications?: Maybe<Scalars['bigint']>;
  TotalMonitorings?: Maybe<Scalars['bigint']>;
  TotalProjects?: Maybe<Scalars['bigint']>;
  TreesApproved?: Maybe<Scalars['bigint']>;
  TressReceived?: Maybe<Scalars['bigint']>;
};

export type PublicPlanterStat_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PublicPlanterStat_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublicPlanterStat_Set_Input>;
  where: PublicPlanterStat_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PublicPlanterStat_Var_Pop_Fields = {
  __typename?: 'PublicPlanterStat_var_pop_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PublicPlanterStat_Var_Samp_Fields = {
  __typename?: 'PublicPlanterStat_var_samp_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PublicPlanterStat_Variance_Fields = {
  __typename?: 'PublicPlanterStat_variance_fields';
  AccountYearJoined?: Maybe<Scalars['Float']>;
  Rank?: Maybe<Scalars['Float']>;
  TotalApplications?: Maybe<Scalars['Float']>;
  TotalMonitorings?: Maybe<Scalars['Float']>;
  TotalProjects?: Maybe<Scalars['Float']>;
  TreesApproved?: Maybe<Scalars['Float']>;
  TressReceived?: Maybe<Scalars['Float']>;
};

export type PublicPlanterStatsForAccount_Args = {
  AccountId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "Purchase" */
export type Purchase = {
  __typename?: 'Purchase';
  Amount: Scalars['numeric'];
  /** An array relationship */
  Attachment: Array<Attachment>;
  /** An aggregate relationship */
  Attachment_aggregate: Attachment_Aggregate;
  Code?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  District?: Maybe<District>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee: Scalars['numeric'];
  From?: Maybe<Scalars['String']>;
  /** An object relationship */
  Funder: Funder;
  FunderId: Scalars['uuid'];
  GiftMessage?: Maybe<Scalars['String']>;
  /** An object relationship */
  GiftTemplate?: Maybe<GiftTemplate>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id: Scalars['uuid'];
  /** An array relationship */
  Instructions: Array<Instruction>;
  /** An aggregate relationship */
  Instructions_aggregate: Instruction_Aggregate;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  IsReconciled: Scalars['Boolean'];
  PaymentError?: Maybe<Scalars['String']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod: Scalars['Int'];
  /** An object relationship */
  Product: Product;
  ProductId: Scalars['uuid'];
  Provider: Scalars['String'];
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  /** An array relationship */
  PurchaseEvents: Array<PurchaseEvent>;
  /** An aggregate relationship */
  PurchaseEvents_aggregate: PurchaseEvent_Aggregate;
  Quantity: Scalars['bigint'];
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType: Scalars['smallint'];
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference: Scalars['bigint'];
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Registry?: Maybe<Registry>;
  RegistryId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  RelatedPurchases: Array<Purchase>;
  /** An aggregate relationship */
  RelatedPurchases_aggregate: Purchase_Aggregate;
  /** An object relationship */
  Season: Season;
  SeasonId: Scalars['uuid'];
  State: Scalars['Int'];
  StripeInvoiceId?: Maybe<Scalars['String']>;
  SubTotal: Scalars['numeric'];
  /** An object relationship */
  Subscription?: Maybe<Subscription>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  SupporterId: Scalars['uuid'];
  Tax: Scalars['numeric'];
  Token: Scalars['String'];
  Total: Scalars['numeric'];
  Tracking: Scalars['String'];
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
  UserId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "Purchase" */
export type PurchaseAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchaseAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchaseData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "Purchase" */
export type PurchaseInstructionsArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchaseInstructions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchasePurchaseEventsArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchasePurchaseEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchaseRelatedPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


/** columns and relationships of "Purchase" */
export type PurchaseRelatedPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** columns and relationships of "PurchaseDashboardView" */
export type PurchaseDashboardView = {
  __typename?: 'PurchaseDashboardView';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  Funder?: Maybe<Funder>;
  FunderId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['numeric']>;
  State?: Maybe<Scalars['Int']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "PurchaseDashboardView" */
export type PurchaseDashboardView_Aggregate = {
  __typename?: 'PurchaseDashboardView_aggregate';
  aggregate?: Maybe<PurchaseDashboardView_Aggregate_Fields>;
  nodes: Array<PurchaseDashboardView>;
};

/** aggregate fields of "PurchaseDashboardView" */
export type PurchaseDashboardView_Aggregate_Fields = {
  __typename?: 'PurchaseDashboardView_aggregate_fields';
  avg?: Maybe<PurchaseDashboardView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PurchaseDashboardView_Max_Fields>;
  min?: Maybe<PurchaseDashboardView_Min_Fields>;
  stddev?: Maybe<PurchaseDashboardView_Stddev_Fields>;
  stddev_pop?: Maybe<PurchaseDashboardView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PurchaseDashboardView_Stddev_Samp_Fields>;
  sum?: Maybe<PurchaseDashboardView_Sum_Fields>;
  var_pop?: Maybe<PurchaseDashboardView_Var_Pop_Fields>;
  var_samp?: Maybe<PurchaseDashboardView_Var_Samp_Fields>;
  variance?: Maybe<PurchaseDashboardView_Variance_Fields>;
};


/** aggregate fields of "PurchaseDashboardView" */
export type PurchaseDashboardView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PurchaseDashboardView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PurchaseDashboardView_Avg_Fields = {
  __typename?: 'PurchaseDashboardView_avg_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PurchaseDashboardView". All fields are combined with a logical 'AND'. */
export type PurchaseDashboardView_Bool_Exp = {
  Amount?: InputMaybe<Numeric_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Numeric_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  SubscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Numeric_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<PurchaseDashboardView_Bool_Exp>>;
  _not?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
  _or?: InputMaybe<Array<PurchaseDashboardView_Bool_Exp>>;
};

/** aggregate max on columns */
export type PurchaseDashboardView_Max_Fields = {
  __typename?: 'PurchaseDashboardView_max_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['numeric']>;
  State?: Maybe<Scalars['Int']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type PurchaseDashboardView_Min_Fields = {
  __typename?: 'PurchaseDashboardView_min_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['numeric']>;
  State?: Maybe<Scalars['Int']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "PurchaseDashboardView". */
export type PurchaseDashboardView_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubscriptionId?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "PurchaseDashboardView" */
export enum PurchaseDashboardView_Select_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  State = 'State',
  /** column name */
  SubscriptionId = 'SubscriptionId',
  /** column name */
  Token = 'Token',
  /** column name */
  Total = 'Total',
  /** column name */
  Type = 'Type'
}

/** aggregate stddev on columns */
export type PurchaseDashboardView_Stddev_Fields = {
  __typename?: 'PurchaseDashboardView_stddev_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PurchaseDashboardView_Stddev_Pop_Fields = {
  __typename?: 'PurchaseDashboardView_stddev_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PurchaseDashboardView_Stddev_Samp_Fields = {
  __typename?: 'PurchaseDashboardView_stddev_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PurchaseDashboardView" */
export type PurchaseDashboardView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PurchaseDashboardView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PurchaseDashboardView_Stream_Cursor_Value_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['numeric']>;
  State?: InputMaybe<Scalars['Int']>;
  SubscriptionId?: InputMaybe<Scalars['uuid']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PurchaseDashboardView_Sum_Fields = {
  __typename?: 'PurchaseDashboardView_sum_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Quantity?: Maybe<Scalars['numeric']>;
  State?: Maybe<Scalars['Int']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type PurchaseDashboardView_Var_Pop_Fields = {
  __typename?: 'PurchaseDashboardView_var_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PurchaseDashboardView_Var_Samp_Fields = {
  __typename?: 'PurchaseDashboardView_var_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PurchaseDashboardView_Variance_Fields = {
  __typename?: 'PurchaseDashboardView_variance_fields';
  Amount?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "PurchaseEvent" */
export type PurchaseEvent = {
  __typename?: 'PurchaseEvent';
  Amount: Scalars['numeric'];
  CreatedOn: Scalars['timestamp'];
  Email: Scalars['String'];
  IPAddress: Scalars['String'];
  IPLocation: Scalars['String'];
  Id: Scalars['uuid'];
  /** An object relationship */
  Purchase?: Maybe<Purchase>;
  PurchaseId: Scalars['uuid'];
  State: Scalars['Int'];
  Token: Scalars['String'];
  Type: Scalars['Int'];
};

/** aggregated selection of "PurchaseEvent" */
export type PurchaseEvent_Aggregate = {
  __typename?: 'PurchaseEvent_aggregate';
  aggregate?: Maybe<PurchaseEvent_Aggregate_Fields>;
  nodes: Array<PurchaseEvent>;
};

export type PurchaseEvent_Aggregate_Bool_Exp = {
  count?: InputMaybe<PurchaseEvent_Aggregate_Bool_Exp_Count>;
};

export type PurchaseEvent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PurchaseEvent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "PurchaseEvent" */
export type PurchaseEvent_Aggregate_Fields = {
  __typename?: 'PurchaseEvent_aggregate_fields';
  avg?: Maybe<PurchaseEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PurchaseEvent_Max_Fields>;
  min?: Maybe<PurchaseEvent_Min_Fields>;
  stddev?: Maybe<PurchaseEvent_Stddev_Fields>;
  stddev_pop?: Maybe<PurchaseEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PurchaseEvent_Stddev_Samp_Fields>;
  sum?: Maybe<PurchaseEvent_Sum_Fields>;
  var_pop?: Maybe<PurchaseEvent_Var_Pop_Fields>;
  var_samp?: Maybe<PurchaseEvent_Var_Samp_Fields>;
  variance?: Maybe<PurchaseEvent_Variance_Fields>;
};


/** aggregate fields of "PurchaseEvent" */
export type PurchaseEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PurchaseEvent" */
export type PurchaseEvent_Aggregate_Order_By = {
  avg?: InputMaybe<PurchaseEvent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PurchaseEvent_Max_Order_By>;
  min?: InputMaybe<PurchaseEvent_Min_Order_By>;
  stddev?: InputMaybe<PurchaseEvent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PurchaseEvent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PurchaseEvent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PurchaseEvent_Sum_Order_By>;
  var_pop?: InputMaybe<PurchaseEvent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PurchaseEvent_Var_Samp_Order_By>;
  variance?: InputMaybe<PurchaseEvent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "PurchaseEvent" */
export type PurchaseEvent_Arr_Rel_Insert_Input = {
  data: Array<PurchaseEvent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PurchaseEvent_On_Conflict>;
};

/** aggregate avg on columns */
export type PurchaseEvent_Avg_Fields = {
  __typename?: 'PurchaseEvent_avg_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Avg_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "PurchaseEvent". All fields are combined with a logical 'AND'. */
export type PurchaseEvent_Bool_Exp = {
  Amount?: InputMaybe<Numeric_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  IPAddress?: InputMaybe<String_Comparison_Exp>;
  IPLocation?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Purchase?: InputMaybe<Purchase_Bool_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<PurchaseEvent_Bool_Exp>>;
  _not?: InputMaybe<PurchaseEvent_Bool_Exp>;
  _or?: InputMaybe<Array<PurchaseEvent_Bool_Exp>>;
};

/** unique or primary key constraints on table "PurchaseEvent" */
export enum PurchaseEvent_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PurchaseEventPkey = 'PurchaseEvent_pkey'
}

/** input type for incrementing numeric columns in table "PurchaseEvent" */
export type PurchaseEvent_Inc_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  State?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "PurchaseEvent" */
export type PurchaseEvent_Insert_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Purchase?: InputMaybe<Purchase_Obj_Rel_Insert_Input>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Token?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PurchaseEvent_Max_Fields = {
  __typename?: 'PurchaseEvent_max_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Email?: Maybe<Scalars['String']>;
  IPAddress?: Maybe<Scalars['String']>;
  IPLocation?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  Token?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Max_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  IPAddress?: InputMaybe<Order_By>;
  IPLocation?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PurchaseEvent_Min_Fields = {
  __typename?: 'PurchaseEvent_min_fields';
  Amount?: Maybe<Scalars['numeric']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Email?: Maybe<Scalars['String']>;
  IPAddress?: Maybe<Scalars['String']>;
  IPLocation?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  Token?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Min_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  IPAddress?: InputMaybe<Order_By>;
  IPLocation?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PurchaseEvent" */
export type PurchaseEvent_Mutation_Response = {
  __typename?: 'PurchaseEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PurchaseEvent>;
};

/** on_conflict condition type for table "PurchaseEvent" */
export type PurchaseEvent_On_Conflict = {
  constraint: PurchaseEvent_Constraint;
  update_columns?: Array<PurchaseEvent_Update_Column>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "PurchaseEvent". */
export type PurchaseEvent_Order_By = {
  Amount?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  IPAddress?: InputMaybe<Order_By>;
  IPLocation?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Purchase?: InputMaybe<Purchase_Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PurchaseEvent */
export type PurchaseEvent_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "PurchaseEvent" */
export enum PurchaseEvent_Select_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Email = 'Email',
  /** column name */
  IpAddress = 'IPAddress',
  /** column name */
  IpLocation = 'IPLocation',
  /** column name */
  Id = 'Id',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  State = 'State',
  /** column name */
  Token = 'Token',
  /** column name */
  Type = 'Type'
}

/** input type for updating data in table "PurchaseEvent" */
export type PurchaseEvent_Set_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Token?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PurchaseEvent_Stddev_Fields = {
  __typename?: 'PurchaseEvent_stddev_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Stddev_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type PurchaseEvent_Stddev_Pop_Fields = {
  __typename?: 'PurchaseEvent_stddev_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Stddev_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type PurchaseEvent_Stddev_Samp_Fields = {
  __typename?: 'PurchaseEvent_stddev_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Stddev_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "PurchaseEvent" */
export type PurchaseEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PurchaseEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PurchaseEvent_Stream_Cursor_Value_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  IPAddress?: InputMaybe<Scalars['String']>;
  IPLocation?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Token?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PurchaseEvent_Sum_Fields = {
  __typename?: 'PurchaseEvent_sum_fields';
  Amount?: Maybe<Scalars['numeric']>;
  State?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Sum_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** update columns of table "PurchaseEvent" */
export enum PurchaseEvent_Update_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Email = 'Email',
  /** column name */
  IpAddress = 'IPAddress',
  /** column name */
  IpLocation = 'IPLocation',
  /** column name */
  Id = 'Id',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  State = 'State',
  /** column name */
  Token = 'Token',
  /** column name */
  Type = 'Type'
}

export type PurchaseEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PurchaseEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PurchaseEvent_Set_Input>;
  where: PurchaseEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PurchaseEvent_Var_Pop_Fields = {
  __typename?: 'PurchaseEvent_var_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Var_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type PurchaseEvent_Var_Samp_Fields = {
  __typename?: 'PurchaseEvent_var_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Var_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type PurchaseEvent_Variance_Fields = {
  __typename?: 'PurchaseEvent_variance_fields';
  Amount?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "PurchaseEvent" */
export type PurchaseEvent_Variance_Order_By = {
  Amount?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

export enum PurchaseReportState {
  Abandoned = 'Abandoned',
  Dishonored = 'Dishonored',
  Error = 'Error',
  New = 'New',
  Pending = 'Pending',
  Processed = 'Processed',
  Processing = 'Processing',
  Refunded = 'Refunded',
  Valid = 'Valid',
  Voided = 'Voided'
}

export enum PurchaseReportType {
  BulkGifted = 'BulkGifted',
  FundedPlanting = 'FundedPlanting',
  FundedTree = 'FundedTree',
  GiftedTree = 'GiftedTree',
  RegistryGift = 'RegistryGift'
}

/** columns and relationships of "PurchaseView" */
export type PurchaseView = {
  __typename?: 'PurchaseView';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  Funder?: Maybe<Scalars['String']>;
  FunderType?: Maybe<Scalars['String']>;
  GiftType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  IsReconciled?: Maybe<Scalars['Boolean']>;
  Price?: Maybe<Scalars['numeric']>;
  Product?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegistryName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "PurchaseView" */
export type PurchaseView_Aggregate = {
  __typename?: 'PurchaseView_aggregate';
  aggregate?: Maybe<PurchaseView_Aggregate_Fields>;
  nodes: Array<PurchaseView>;
};

/** aggregate fields of "PurchaseView" */
export type PurchaseView_Aggregate_Fields = {
  __typename?: 'PurchaseView_aggregate_fields';
  avg?: Maybe<PurchaseView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PurchaseView_Max_Fields>;
  min?: Maybe<PurchaseView_Min_Fields>;
  stddev?: Maybe<PurchaseView_Stddev_Fields>;
  stddev_pop?: Maybe<PurchaseView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PurchaseView_Stddev_Samp_Fields>;
  sum?: Maybe<PurchaseView_Sum_Fields>;
  var_pop?: Maybe<PurchaseView_Var_Pop_Fields>;
  var_samp?: Maybe<PurchaseView_Var_Samp_Fields>;
  variance?: Maybe<PurchaseView_Variance_Fields>;
};


/** aggregate fields of "PurchaseView" */
export type PurchaseView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PurchaseView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PurchaseView_Avg_Fields = {
  __typename?: 'PurchaseView_avg_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "PurchaseView". All fields are combined with a logical 'AND'. */
export type PurchaseView_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Funder?: InputMaybe<String_Comparison_Exp>;
  FunderType?: InputMaybe<String_Comparison_Exp>;
  GiftType?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsReconciled?: InputMaybe<Boolean_Comparison_Exp>;
  Price?: InputMaybe<Numeric_Comparison_Exp>;
  Product?: InputMaybe<String_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegistryName?: InputMaybe<String_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  Tax?: InputMaybe<Numeric_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Numeric_Comparison_Exp>;
  Trees?: InputMaybe<Bigint_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  _and?: InputMaybe<Array<PurchaseView_Bool_Exp>>;
  _not?: InputMaybe<PurchaseView_Bool_Exp>;
  _or?: InputMaybe<Array<PurchaseView_Bool_Exp>>;
};

/** aggregate max on columns */
export type PurchaseView_Max_Fields = {
  __typename?: 'PurchaseView_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  Funder?: Maybe<Scalars['String']>;
  FunderType?: Maybe<Scalars['String']>;
  GiftType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Price?: Maybe<Scalars['numeric']>;
  Product?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegistryName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type PurchaseView_Min_Fields = {
  __typename?: 'PurchaseView_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  Funder?: Maybe<Scalars['String']>;
  FunderType?: Maybe<Scalars['String']>;
  GiftType?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Price?: Maybe<Scalars['numeric']>;
  Product?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegistryName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['Int']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "PurchaseView". */
export type PurchaseView_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Order_By>;
  FunderType?: InputMaybe<Order_By>;
  GiftType?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsReconciled?: InputMaybe<Order_By>;
  Price?: InputMaybe<Order_By>;
  Product?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegistryName?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** select columns of table "PurchaseView" */
export enum PurchaseView_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  Funder = 'Funder',
  /** column name */
  FunderType = 'FunderType',
  /** column name */
  GiftType = 'GiftType',
  /** column name */
  Id = 'Id',
  /** column name */
  IsReconciled = 'IsReconciled',
  /** column name */
  Price = 'Price',
  /** column name */
  Product = 'Product',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegistryName = 'RegistryName',
  /** column name */
  State = 'State',
  /** column name */
  Tax = 'Tax',
  /** column name */
  Token = 'Token',
  /** column name */
  Total = 'Total',
  /** column name */
  Trees = 'Trees',
  /** column name */
  Type = 'Type'
}

/** aggregate stddev on columns */
export type PurchaseView_Stddev_Fields = {
  __typename?: 'PurchaseView_stddev_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PurchaseView_Stddev_Pop_Fields = {
  __typename?: 'PurchaseView_stddev_pop_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PurchaseView_Stddev_Samp_Fields = {
  __typename?: 'PurchaseView_stddev_samp_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "PurchaseView" */
export type PurchaseView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PurchaseView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PurchaseView_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  Funder?: InputMaybe<Scalars['String']>;
  FunderType?: InputMaybe<Scalars['String']>;
  GiftType?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsReconciled?: InputMaybe<Scalars['Boolean']>;
  Price?: InputMaybe<Scalars['numeric']>;
  Product?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegistryName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['Int']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Trees?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PurchaseView_Sum_Fields = {
  __typename?: 'PurchaseView_sum_fields';
  Price?: Maybe<Scalars['numeric']>;
  Reference?: Maybe<Scalars['bigint']>;
  State?: Maybe<Scalars['Int']>;
  Tax?: Maybe<Scalars['numeric']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type PurchaseView_Var_Pop_Fields = {
  __typename?: 'PurchaseView_var_pop_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PurchaseView_Var_Samp_Fields = {
  __typename?: 'PurchaseView_var_samp_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PurchaseView_Variance_Fields = {
  __typename?: 'PurchaseView_variance_fields';
  Price?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Purchase" */
export type Purchase_Aggregate = {
  __typename?: 'Purchase_aggregate';
  aggregate?: Maybe<Purchase_Aggregate_Fields>;
  nodes: Array<Purchase>;
};

export type Purchase_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Purchase_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Purchase_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Purchase_Aggregate_Bool_Exp_Count>;
};

export type Purchase_Aggregate_Bool_Exp_Bool_And = {
  arguments: Purchase_Select_Column_Purchase_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Purchase_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Purchase_Select_Column_Purchase_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Purchase_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Purchase_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Purchase_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Purchase" */
export type Purchase_Aggregate_Fields = {
  __typename?: 'Purchase_aggregate_fields';
  avg?: Maybe<Purchase_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Purchase_Max_Fields>;
  min?: Maybe<Purchase_Min_Fields>;
  stddev?: Maybe<Purchase_Stddev_Fields>;
  stddev_pop?: Maybe<Purchase_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Purchase_Stddev_Samp_Fields>;
  sum?: Maybe<Purchase_Sum_Fields>;
  var_pop?: Maybe<Purchase_Var_Pop_Fields>;
  var_samp?: Maybe<Purchase_Var_Samp_Fields>;
  variance?: Maybe<Purchase_Variance_Fields>;
};


/** aggregate fields of "Purchase" */
export type Purchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Purchase" */
export type Purchase_Aggregate_Order_By = {
  avg?: InputMaybe<Purchase_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Purchase_Max_Order_By>;
  min?: InputMaybe<Purchase_Min_Order_By>;
  stddev?: InputMaybe<Purchase_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Purchase_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Purchase_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Purchase_Sum_Order_By>;
  var_pop?: InputMaybe<Purchase_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Purchase_Var_Samp_Order_By>;
  variance?: InputMaybe<Purchase_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Purchase_Append_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "Purchase" */
export type Purchase_Arr_Rel_Insert_Input = {
  data: Array<Purchase_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_On_Conflict>;
};

/** aggregate avg on columns */
export type Purchase_Avg_Fields = {
  __typename?: 'Purchase_avg_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Purchase" */
export type Purchase_Avg_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Purchase". All fields are combined with a logical 'AND'. */
export type Purchase_Bool_Exp = {
  Amount?: InputMaybe<Numeric_Comparison_Exp>;
  Attachment?: InputMaybe<Attachment_Bool_Exp>;
  Attachment_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp>;
  Code?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Fee?: InputMaybe<Numeric_Comparison_Exp>;
  From?: InputMaybe<String_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  GiftMessage?: InputMaybe<String_Comparison_Exp>;
  GiftTemplate?: InputMaybe<GiftTemplate_Bool_Exp>;
  GiftTemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Instructions?: InputMaybe<Instruction_Bool_Exp>;
  Instructions_aggregate?: InputMaybe<Instruction_Aggregate_Bool_Exp>;
  InvoiceAddress0?: InputMaybe<String_Comparison_Exp>;
  InvoiceAddress1?: InputMaybe<String_Comparison_Exp>;
  InvoiceCity?: InputMaybe<String_Comparison_Exp>;
  InvoiceCountry?: InputMaybe<String_Comparison_Exp>;
  InvoicePostCode?: InputMaybe<String_Comparison_Exp>;
  InvoiceState?: InputMaybe<String_Comparison_Exp>;
  IsReconciled?: InputMaybe<Boolean_Comparison_Exp>;
  PaymentError?: InputMaybe<String_Comparison_Exp>;
  PaymentIntentId?: InputMaybe<String_Comparison_Exp>;
  PaymentMethod?: InputMaybe<Int_Comparison_Exp>;
  Product?: InputMaybe<Product_Bool_Exp>;
  ProductId?: InputMaybe<Uuid_Comparison_Exp>;
  Provider?: InputMaybe<String_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  PurchaseEvents?: InputMaybe<PurchaseEvent_Bool_Exp>;
  PurchaseEvents_aggregate?: InputMaybe<PurchaseEvent_Aggregate_Bool_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  ReceiptingType?: InputMaybe<Smallint_Comparison_Exp>;
  RecipientEmail?: InputMaybe<String_Comparison_Exp>;
  RecipientName?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Registry?: InputMaybe<Registry_Bool_Exp>;
  RegistryId?: InputMaybe<Uuid_Comparison_Exp>;
  RelatedPurchases?: InputMaybe<Purchase_Bool_Exp>;
  RelatedPurchases_aggregate?: InputMaybe<Purchase_Aggregate_Bool_Exp>;
  Season?: InputMaybe<Season_Bool_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  StripeInvoiceId?: InputMaybe<String_Comparison_Exp>;
  SubTotal?: InputMaybe<Numeric_Comparison_Exp>;
  Subscription?: InputMaybe<Subscription_Bool_Exp>;
  SubscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  SupporterId?: InputMaybe<Uuid_Comparison_Exp>;
  Tax?: InputMaybe<Numeric_Comparison_Exp>;
  Token?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Numeric_Comparison_Exp>;
  Tracking?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Purchase_Bool_Exp>>;
  _not?: InputMaybe<Purchase_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_Bool_Exp>>;
};

/** unique or primary key constraints on table "Purchase" */
export enum Purchase_Constraint {
  /** unique or primary key constraint on columns "Id" */
  PurchasePkey = 'Purchase_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Purchase_Delete_At_Path_Input = {
  Data_jsonb?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * delete the array element with specified index (negative integers count from the
 * end). throws an error if top level container is not an array
 */
export type Purchase_Delete_Elem_Input = {
  Data_jsonb?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Purchase_Delete_Key_Input = {
  Data_jsonb?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "Purchase" */
export type Purchase_Inc_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  Fee?: InputMaybe<Scalars['numeric']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  State?: InputMaybe<Scalars['Int']>;
  SubTotal?: InputMaybe<Scalars['numeric']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Purchase" */
export type Purchase_Insert_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  Attachment?: InputMaybe<Attachment_Arr_Rel_Insert_Input>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Fee?: InputMaybe<Scalars['numeric']>;
  From?: InputMaybe<Scalars['String']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GiftMessage?: InputMaybe<Scalars['String']>;
  GiftTemplate?: InputMaybe<GiftTemplate_Obj_Rel_Insert_Input>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Instructions?: InputMaybe<Instruction_Arr_Rel_Insert_Input>;
  InvoiceAddress0?: InputMaybe<Scalars['String']>;
  InvoiceAddress1?: InputMaybe<Scalars['String']>;
  InvoiceCity?: InputMaybe<Scalars['String']>;
  InvoiceCountry?: InputMaybe<Scalars['String']>;
  InvoicePostCode?: InputMaybe<Scalars['String']>;
  InvoiceState?: InputMaybe<Scalars['String']>;
  IsReconciled?: InputMaybe<Scalars['Boolean']>;
  PaymentError?: InputMaybe<Scalars['String']>;
  PaymentIntentId?: InputMaybe<Scalars['String']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  Product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Provider?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  PurchaseEvents?: InputMaybe<PurchaseEvent_Arr_Rel_Insert_Input>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Registry?: InputMaybe<Registry_Obj_Rel_Insert_Input>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  RelatedPurchases?: InputMaybe<Purchase_Arr_Rel_Insert_Input>;
  Season?: InputMaybe<Season_Obj_Rel_Insert_Input>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  StripeInvoiceId?: InputMaybe<Scalars['String']>;
  SubTotal?: InputMaybe<Scalars['numeric']>;
  Subscription?: InputMaybe<Subscription_Obj_Rel_Insert_Input>;
  SubscriptionId?: InputMaybe<Scalars['uuid']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Tracking?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Purchase_Max_Fields = {
  __typename?: 'Purchase_max_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee?: Maybe<Scalars['numeric']>;
  From?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GiftMessage?: Maybe<Scalars['String']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  PaymentError?: Maybe<Scalars['String']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Provider?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  StripeInvoiceId?: Maybe<Scalars['String']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Tracking?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "Purchase" */
export type Purchase_Max_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  GiftMessage?: InputMaybe<Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InvoiceAddress0?: InputMaybe<Order_By>;
  InvoiceAddress1?: InputMaybe<Order_By>;
  InvoiceCity?: InputMaybe<Order_By>;
  InvoiceCountry?: InputMaybe<Order_By>;
  InvoicePostCode?: InputMaybe<Order_By>;
  InvoiceState?: InputMaybe<Order_By>;
  PaymentError?: InputMaybe<Order_By>;
  PaymentIntentId?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Provider?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  StripeInvoiceId?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  SubscriptionId?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Tracking?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Purchase_Min_Fields = {
  __typename?: 'Purchase_min_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Code?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Fee?: Maybe<Scalars['numeric']>;
  From?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  GiftMessage?: Maybe<Scalars['String']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  InvoiceAddress0?: Maybe<Scalars['String']>;
  InvoiceAddress1?: Maybe<Scalars['String']>;
  InvoiceCity?: Maybe<Scalars['String']>;
  InvoiceCountry?: Maybe<Scalars['String']>;
  InvoicePostCode?: Maybe<Scalars['String']>;
  InvoiceState?: Maybe<Scalars['String']>;
  PaymentError?: Maybe<Scalars['String']>;
  PaymentIntentId?: Maybe<Scalars['String']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Provider?: Maybe<Scalars['String']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  RecipientEmail?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  StripeInvoiceId?: Maybe<Scalars['String']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  SubscriptionId?: Maybe<Scalars['uuid']>;
  SupporterId?: Maybe<Scalars['uuid']>;
  Tax?: Maybe<Scalars['numeric']>;
  Token?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Tracking?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "Purchase" */
export type Purchase_Min_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  GiftMessage?: InputMaybe<Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  InvoiceAddress0?: InputMaybe<Order_By>;
  InvoiceAddress1?: InputMaybe<Order_By>;
  InvoiceCity?: InputMaybe<Order_By>;
  InvoiceCountry?: InputMaybe<Order_By>;
  InvoicePostCode?: InputMaybe<Order_By>;
  InvoiceState?: InputMaybe<Order_By>;
  PaymentError?: InputMaybe<Order_By>;
  PaymentIntentId?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Provider?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  StripeInvoiceId?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  SubscriptionId?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Tracking?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Purchase" */
export type Purchase_Mutation_Response = {
  __typename?: 'Purchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Purchase>;
};

/** input type for inserting object relation for remote table "Purchase" */
export type Purchase_Obj_Rel_Insert_Input = {
  data: Purchase_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_On_Conflict>;
};

/** on_conflict condition type for table "Purchase" */
export type Purchase_On_Conflict = {
  constraint: Purchase_Constraint;
  update_columns?: Array<Purchase_Update_Column>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** Ordering options when selecting data from "Purchase". */
export type Purchase_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Attachment_aggregate?: InputMaybe<Attachment_Aggregate_Order_By>;
  Code?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  From?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  GiftMessage?: InputMaybe<Order_By>;
  GiftTemplate?: InputMaybe<GiftTemplate_Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Instructions_aggregate?: InputMaybe<Instruction_Aggregate_Order_By>;
  InvoiceAddress0?: InputMaybe<Order_By>;
  InvoiceAddress1?: InputMaybe<Order_By>;
  InvoiceCity?: InputMaybe<Order_By>;
  InvoiceCountry?: InputMaybe<Order_By>;
  InvoicePostCode?: InputMaybe<Order_By>;
  InvoiceState?: InputMaybe<Order_By>;
  IsReconciled?: InputMaybe<Order_By>;
  PaymentError?: InputMaybe<Order_By>;
  PaymentIntentId?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Product?: InputMaybe<Product_Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Provider?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  PurchaseEvents_aggregate?: InputMaybe<PurchaseEvent_Aggregate_Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  RecipientEmail?: InputMaybe<Order_By>;
  RecipientName?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Registry?: InputMaybe<Registry_Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  RelatedPurchases_aggregate?: InputMaybe<Purchase_Aggregate_Order_By>;
  Season?: InputMaybe<Season_Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  StripeInvoiceId?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Subscription?: InputMaybe<Subscription_Order_By>;
  SubscriptionId?: InputMaybe<Order_By>;
  SupporterId?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Token?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Tracking?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Purchase */
export type Purchase_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Purchase_Prepend_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "Purchase" */
export enum Purchase_Select_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Fee = 'Fee',
  /** column name */
  From = 'From',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  GiftMessage = 'GiftMessage',
  /** column name */
  GiftTemplateId = 'GiftTemplateId',
  /** column name */
  Id = 'Id',
  /** column name */
  InvoiceAddress0 = 'InvoiceAddress0',
  /** column name */
  InvoiceAddress1 = 'InvoiceAddress1',
  /** column name */
  InvoiceCity = 'InvoiceCity',
  /** column name */
  InvoiceCountry = 'InvoiceCountry',
  /** column name */
  InvoicePostCode = 'InvoicePostCode',
  /** column name */
  InvoiceState = 'InvoiceState',
  /** column name */
  IsReconciled = 'IsReconciled',
  /** column name */
  PaymentError = 'PaymentError',
  /** column name */
  PaymentIntentId = 'PaymentIntentId',
  /** column name */
  PaymentMethod = 'PaymentMethod',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  Provider = 'Provider',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  ReceiptingType = 'ReceiptingType',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegistryId = 'RegistryId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  State = 'State',
  /** column name */
  StripeInvoiceId = 'StripeInvoiceId',
  /** column name */
  SubTotal = 'SubTotal',
  /** column name */
  SubscriptionId = 'SubscriptionId',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  Tax = 'Tax',
  /** column name */
  Token = 'Token',
  /** column name */
  Total = 'Total',
  /** column name */
  Tracking = 'Tracking',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

/** select "Purchase_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Purchase" */
export enum Purchase_Select_Column_Purchase_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsReconciled = 'IsReconciled'
}

/** select "Purchase_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Purchase" */
export enum Purchase_Select_Column_Purchase_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsReconciled = 'IsReconciled'
}

/** input type for updating data in table "Purchase" */
export type Purchase_Set_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Fee?: InputMaybe<Scalars['numeric']>;
  From?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GiftMessage?: InputMaybe<Scalars['String']>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InvoiceAddress0?: InputMaybe<Scalars['String']>;
  InvoiceAddress1?: InputMaybe<Scalars['String']>;
  InvoiceCity?: InputMaybe<Scalars['String']>;
  InvoiceCountry?: InputMaybe<Scalars['String']>;
  InvoicePostCode?: InputMaybe<Scalars['String']>;
  InvoiceState?: InputMaybe<Scalars['String']>;
  IsReconciled?: InputMaybe<Scalars['Boolean']>;
  PaymentError?: InputMaybe<Scalars['String']>;
  PaymentIntentId?: InputMaybe<Scalars['String']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Provider?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  StripeInvoiceId?: InputMaybe<Scalars['String']>;
  SubTotal?: InputMaybe<Scalars['numeric']>;
  SubscriptionId?: InputMaybe<Scalars['uuid']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Tracking?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Purchase_Stddev_Fields = {
  __typename?: 'Purchase_stddev_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Purchase" */
export type Purchase_Stddev_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Purchase_Stddev_Pop_Fields = {
  __typename?: 'Purchase_stddev_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Purchase" */
export type Purchase_Stddev_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Purchase_Stddev_Samp_Fields = {
  __typename?: 'Purchase_stddev_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Purchase" */
export type Purchase_Stddev_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Purchase" */
export type Purchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_Stream_Cursor_Value_Input = {
  Amount?: InputMaybe<Scalars['numeric']>;
  Code?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Fee?: InputMaybe<Scalars['numeric']>;
  From?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  GiftMessage?: InputMaybe<Scalars['String']>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  InvoiceAddress0?: InputMaybe<Scalars['String']>;
  InvoiceAddress1?: InputMaybe<Scalars['String']>;
  InvoiceCity?: InputMaybe<Scalars['String']>;
  InvoiceCountry?: InputMaybe<Scalars['String']>;
  InvoicePostCode?: InputMaybe<Scalars['String']>;
  InvoiceState?: InputMaybe<Scalars['String']>;
  IsReconciled?: InputMaybe<Scalars['Boolean']>;
  PaymentError?: InputMaybe<Scalars['String']>;
  PaymentIntentId?: InputMaybe<Scalars['String']>;
  PaymentMethod?: InputMaybe<Scalars['Int']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Provider?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  ReceiptingType?: InputMaybe<Scalars['smallint']>;
  RecipientEmail?: InputMaybe<Scalars['String']>;
  RecipientName?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  StripeInvoiceId?: InputMaybe<Scalars['String']>;
  SubTotal?: InputMaybe<Scalars['numeric']>;
  SubscriptionId?: InputMaybe<Scalars['uuid']>;
  SupporterId?: InputMaybe<Scalars['uuid']>;
  Tax?: InputMaybe<Scalars['numeric']>;
  Token?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Tracking?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Purchase_Sum_Fields = {
  __typename?: 'Purchase_sum_fields';
  Amount?: Maybe<Scalars['numeric']>;
  Fee?: Maybe<Scalars['numeric']>;
  PaymentMethod?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptingType?: Maybe<Scalars['smallint']>;
  Reference?: Maybe<Scalars['bigint']>;
  State?: Maybe<Scalars['Int']>;
  SubTotal?: Maybe<Scalars['numeric']>;
  Tax?: Maybe<Scalars['numeric']>;
  Total?: Maybe<Scalars['numeric']>;
  Type?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "Purchase" */
export type Purchase_Sum_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** update columns of table "Purchase" */
export enum Purchase_Update_Column {
  /** column name */
  Amount = 'Amount',
  /** column name */
  Code = 'Code',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Fee = 'Fee',
  /** column name */
  From = 'From',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  GiftMessage = 'GiftMessage',
  /** column name */
  GiftTemplateId = 'GiftTemplateId',
  /** column name */
  Id = 'Id',
  /** column name */
  InvoiceAddress0 = 'InvoiceAddress0',
  /** column name */
  InvoiceAddress1 = 'InvoiceAddress1',
  /** column name */
  InvoiceCity = 'InvoiceCity',
  /** column name */
  InvoiceCountry = 'InvoiceCountry',
  /** column name */
  InvoicePostCode = 'InvoicePostCode',
  /** column name */
  InvoiceState = 'InvoiceState',
  /** column name */
  IsReconciled = 'IsReconciled',
  /** column name */
  PaymentError = 'PaymentError',
  /** column name */
  PaymentIntentId = 'PaymentIntentId',
  /** column name */
  PaymentMethod = 'PaymentMethod',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  Provider = 'Provider',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  ReceiptingType = 'ReceiptingType',
  /** column name */
  RecipientEmail = 'RecipientEmail',
  /** column name */
  RecipientName = 'RecipientName',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegistryId = 'RegistryId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  State = 'State',
  /** column name */
  StripeInvoiceId = 'StripeInvoiceId',
  /** column name */
  SubTotal = 'SubTotal',
  /** column name */
  SubscriptionId = 'SubscriptionId',
  /** column name */
  SupporterId = 'SupporterId',
  /** column name */
  Tax = 'Tax',
  /** column name */
  Token = 'Token',
  /** column name */
  Total = 'Total',
  /** column name */
  Tracking = 'Tracking',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

export type Purchase_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Purchase_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Purchase_Delete_At_Path_Input>;
  /**
   * delete the array element with specified index (negative integers count from
   * the end). throws an error if top level container is not an array
   */
  _delete_elem?: InputMaybe<Purchase_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Purchase_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Purchase_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Purchase_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Purchase_Set_Input>;
  where: Purchase_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Purchase_Var_Pop_Fields = {
  __typename?: 'Purchase_var_pop_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Purchase" */
export type Purchase_Var_Pop_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Purchase_Var_Samp_Fields = {
  __typename?: 'Purchase_var_samp_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Purchase" */
export type Purchase_Var_Samp_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Purchase_Variance_Fields = {
  __typename?: 'Purchase_variance_fields';
  Amount?: Maybe<Scalars['Float']>;
  Fee?: Maybe<Scalars['Float']>;
  PaymentMethod?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReceiptingType?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
  SubTotal?: Maybe<Scalars['Float']>;
  Tax?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Purchase" */
export type Purchase_Variance_Order_By = {
  Amount?: InputMaybe<Order_By>;
  Fee?: InputMaybe<Order_By>;
  PaymentMethod?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptingType?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  SubTotal?: InputMaybe<Order_By>;
  Tax?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

export type RegeneratePdfInput = {
  AttachmentId: Scalars['uuid'];
};

export type RegeneratePdfOutput = {
  __typename?: 'RegeneratePdfOutput';
  PresignedUrl: Scalars['String'];
  S3Key: Scalars['String'];
};

/** columns and relationships of "Region" */
export type Region = {
  __typename?: 'Region';
  AltName?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Lat: Scalars['numeric'];
  Lng: Scalars['numeric'];
  Lookups?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  PlaceId?: Maybe<Scalars['String']>;
  ProperSpelling?: Maybe<Scalars['String']>;
  Reference: Scalars['Int'];
  /** An array relationship */
  RegionDistricts: Array<RegionDistrict>;
  /** An aggregate relationship */
  RegionDistricts_aggregate: RegionDistrict_Aggregate;
  Type: Scalars['String'];
};


/** columns and relationships of "Region" */
export type RegionRegionDistrictsArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


/** columns and relationships of "Region" */
export type RegionRegionDistricts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};

/** columns and relationships of "RegionDistrict" */
export type RegionDistrict = {
  __typename?: 'RegionDistrict';
  /** An object relationship */
  District: District;
  DistrictId: Scalars['uuid'];
  /** An object relationship */
  Region: Region;
  RegionId: Scalars['uuid'];
};

/** aggregated selection of "RegionDistrict" */
export type RegionDistrict_Aggregate = {
  __typename?: 'RegionDistrict_aggregate';
  aggregate?: Maybe<RegionDistrict_Aggregate_Fields>;
  nodes: Array<RegionDistrict>;
};

export type RegionDistrict_Aggregate_Bool_Exp = {
  count?: InputMaybe<RegionDistrict_Aggregate_Bool_Exp_Count>;
};

export type RegionDistrict_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RegionDistrict_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "RegionDistrict" */
export type RegionDistrict_Aggregate_Fields = {
  __typename?: 'RegionDistrict_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<RegionDistrict_Max_Fields>;
  min?: Maybe<RegionDistrict_Min_Fields>;
};


/** aggregate fields of "RegionDistrict" */
export type RegionDistrict_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "RegionDistrict" */
export type RegionDistrict_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RegionDistrict_Max_Order_By>;
  min?: InputMaybe<RegionDistrict_Min_Order_By>;
};

/** input type for inserting array relation for remote table "RegionDistrict" */
export type RegionDistrict_Arr_Rel_Insert_Input = {
  data: Array<RegionDistrict_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RegionDistrict_On_Conflict>;
};

/** Boolean expression to filter rows from the table "RegionDistrict". All fields are combined with a logical 'AND'. */
export type RegionDistrict_Bool_Exp = {
  District?: InputMaybe<District_Bool_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<RegionDistrict_Bool_Exp>>;
  _not?: InputMaybe<RegionDistrict_Bool_Exp>;
  _or?: InputMaybe<Array<RegionDistrict_Bool_Exp>>;
};

/** unique or primary key constraints on table "RegionDistrict" */
export enum RegionDistrict_Constraint {
  /** unique or primary key constraint on columns "RegionId", "DistrictId" */
  RegionDistrictPkey = 'RegionDistrict_pkey'
}

/** input type for inserting data into table "RegionDistrict" */
export type RegionDistrict_Insert_Input = {
  District?: InputMaybe<District_Obj_Rel_Insert_Input>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  RegionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RegionDistrict_Max_Fields = {
  __typename?: 'RegionDistrict_max_fields';
  DistrictId?: Maybe<Scalars['uuid']>;
  RegionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "RegionDistrict" */
export type RegionDistrict_Max_Order_By = {
  DistrictId?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RegionDistrict_Min_Fields = {
  __typename?: 'RegionDistrict_min_fields';
  DistrictId?: Maybe<Scalars['uuid']>;
  RegionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "RegionDistrict" */
export type RegionDistrict_Min_Order_By = {
  DistrictId?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "RegionDistrict" */
export type RegionDistrict_Mutation_Response = {
  __typename?: 'RegionDistrict_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RegionDistrict>;
};

/** on_conflict condition type for table "RegionDistrict" */
export type RegionDistrict_On_Conflict = {
  constraint: RegionDistrict_Constraint;
  update_columns?: Array<RegionDistrict_Update_Column>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};

/** Ordering options when selecting data from "RegionDistrict". */
export type RegionDistrict_Order_By = {
  District?: InputMaybe<District_Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: RegionDistrict */
export type RegionDistrict_Pk_Columns_Input = {
  DistrictId: Scalars['uuid'];
  RegionId: Scalars['uuid'];
};

/** select columns of table "RegionDistrict" */
export enum RegionDistrict_Select_Column {
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  RegionId = 'RegionId'
}

/** input type for updating data in table "RegionDistrict" */
export type RegionDistrict_Set_Input = {
  DistrictId?: InputMaybe<Scalars['uuid']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "RegionDistrict" */
export type RegionDistrict_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RegionDistrict_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RegionDistrict_Stream_Cursor_Value_Input = {
  DistrictId?: InputMaybe<Scalars['uuid']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "RegionDistrict" */
export enum RegionDistrict_Update_Column {
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  RegionId = 'RegionId'
}

export type RegionDistrict_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegionDistrict_Set_Input>;
  where: RegionDistrict_Bool_Exp;
};

/** aggregated selection of "Region" */
export type Region_Aggregate = {
  __typename?: 'Region_aggregate';
  aggregate?: Maybe<Region_Aggregate_Fields>;
  nodes: Array<Region>;
};

/** aggregate fields of "Region" */
export type Region_Aggregate_Fields = {
  __typename?: 'Region_aggregate_fields';
  avg?: Maybe<Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Region_Max_Fields>;
  min?: Maybe<Region_Min_Fields>;
  stddev?: Maybe<Region_Stddev_Fields>;
  stddev_pop?: Maybe<Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Region_Stddev_Samp_Fields>;
  sum?: Maybe<Region_Sum_Fields>;
  var_pop?: Maybe<Region_Var_Pop_Fields>;
  var_samp?: Maybe<Region_Var_Samp_Fields>;
  variance?: Maybe<Region_Variance_Fields>;
};


/** aggregate fields of "Region" */
export type Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Region_Avg_Fields = {
  __typename?: 'Region_avg_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp = {
  AltName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Lat?: InputMaybe<Numeric_Comparison_Exp>;
  Lng?: InputMaybe<Numeric_Comparison_Exp>;
  Lookups?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  PlaceId?: InputMaybe<String_Comparison_Exp>;
  ProperSpelling?: InputMaybe<String_Comparison_Exp>;
  Reference?: InputMaybe<Int_Comparison_Exp>;
  RegionDistricts?: InputMaybe<RegionDistrict_Bool_Exp>;
  RegionDistricts_aggregate?: InputMaybe<RegionDistrict_Aggregate_Bool_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
};

/** unique or primary key constraints on table "Region" */
export enum Region_Constraint {
  /** unique or primary key constraint on columns "Id" */
  RegionPkey = 'Region_pkey'
}

/** input type for incrementing numeric columns in table "Region" */
export type Region_Inc_Input = {
  Lat?: InputMaybe<Scalars['numeric']>;
  Lng?: InputMaybe<Scalars['numeric']>;
  Reference?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Region" */
export type Region_Insert_Input = {
  AltName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Lat?: InputMaybe<Scalars['numeric']>;
  Lng?: InputMaybe<Scalars['numeric']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  PlaceId?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['Int']>;
  RegionDistricts?: InputMaybe<RegionDistrict_Arr_Rel_Insert_Input>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Region_Max_Fields = {
  __typename?: 'Region_max_fields';
  AltName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Lat?: Maybe<Scalars['numeric']>;
  Lng?: Maybe<Scalars['numeric']>;
  Lookups?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  PlaceId?: Maybe<Scalars['String']>;
  ProperSpelling?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Region_Min_Fields = {
  __typename?: 'Region_min_fields';
  AltName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Lat?: Maybe<Scalars['numeric']>;
  Lng?: Maybe<Scalars['numeric']>;
  Lookups?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  PlaceId?: Maybe<Scalars['String']>;
  ProperSpelling?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Region" */
export type Region_Mutation_Response = {
  __typename?: 'Region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region>;
};

/** input type for inserting object relation for remote table "Region" */
export type Region_Obj_Rel_Insert_Input = {
  data: Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** on_conflict condition type for table "Region" */
export type Region_On_Conflict = {
  constraint: Region_Constraint;
  update_columns?: Array<Region_Update_Column>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** Ordering options when selecting data from "Region". */
export type Region_Order_By = {
  AltName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Lat?: InputMaybe<Order_By>;
  Lng?: InputMaybe<Order_By>;
  Lookups?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PlaceId?: InputMaybe<Order_By>;
  ProperSpelling?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionDistricts_aggregate?: InputMaybe<RegionDistrict_Aggregate_Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Region */
export type Region_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Region" */
export enum Region_Select_Column {
  /** column name */
  AltName = 'AltName',
  /** column name */
  Id = 'Id',
  /** column name */
  Lat = 'Lat',
  /** column name */
  Lng = 'Lng',
  /** column name */
  Lookups = 'Lookups',
  /** column name */
  Name = 'Name',
  /** column name */
  PlaceId = 'PlaceId',
  /** column name */
  ProperSpelling = 'ProperSpelling',
  /** column name */
  Reference = 'Reference',
  /** column name */
  Type = 'Type'
}

/** input type for updating data in table "Region" */
export type Region_Set_Input = {
  AltName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Lat?: InputMaybe<Scalars['numeric']>;
  Lng?: InputMaybe<Scalars['numeric']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  PlaceId?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Region_Stddev_Fields = {
  __typename?: 'Region_stddev_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Region_Stddev_Pop_Fields = {
  __typename?: 'Region_stddev_pop_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Region_Stddev_Samp_Fields = {
  __typename?: 'Region_stddev_samp_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Region" */
export type Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Stream_Cursor_Value_Input = {
  AltName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Lat?: InputMaybe<Scalars['numeric']>;
  Lng?: InputMaybe<Scalars['numeric']>;
  Lookups?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  PlaceId?: InputMaybe<Scalars['String']>;
  ProperSpelling?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Region_Sum_Fields = {
  __typename?: 'Region_sum_fields';
  Lat?: Maybe<Scalars['numeric']>;
  Lng?: Maybe<Scalars['numeric']>;
  Reference?: Maybe<Scalars['Int']>;
};

/** update columns of table "Region" */
export enum Region_Update_Column {
  /** column name */
  AltName = 'AltName',
  /** column name */
  Id = 'Id',
  /** column name */
  Lat = 'Lat',
  /** column name */
  Lng = 'Lng',
  /** column name */
  Lookups = 'Lookups',
  /** column name */
  Name = 'Name',
  /** column name */
  PlaceId = 'PlaceId',
  /** column name */
  ProperSpelling = 'ProperSpelling',
  /** column name */
  Reference = 'Reference',
  /** column name */
  Type = 'Type'
}

export type Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Region_Var_Pop_Fields = {
  __typename?: 'Region_var_pop_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Region_Var_Samp_Fields = {
  __typename?: 'Region_var_samp_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Region_Variance_Fields = {
  __typename?: 'Region_variance_fields';
  Lat?: Maybe<Scalars['Float']>;
  Lng?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Registry" */
export type Registry = {
  __typename?: 'Registry';
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  Funder: Funder;
  FunderId: Scalars['uuid'];
  Hero?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  IsCampaign?: Maybe<Scalars['Boolean']>;
  IsClosed: Scalars['Boolean'];
  IsFeatured: Scalars['Boolean'];
  IsHidden: Scalars['Boolean'];
  Name: Scalars['String'];
  ProductId: Scalars['uuid'];
  /** An array relationship */
  Purchases: Array<Purchase>;
  /** An aggregate relationship */
  Purchases_aggregate: Purchase_Aggregate;
  Reference: Scalars['bigint'];
  RegionId?: Maybe<Scalars['uuid']>;
  Summary?: Maybe<Scalars['String']>;
  UpdatedOn: Scalars['timestamp'];
  Uri?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Registry" */
export type RegistryPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


/** columns and relationships of "Registry" */
export type RegistryPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** columns and relationships of "RegistryView" */
export type RegistryView = {
  __typename?: 'RegistryView';
  /** An object relationship */
  Account?: Maybe<Account>;
  AccountId?: Maybe<Scalars['uuid']>;
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Gifts?: Maybe<Scalars['bigint']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  IsCampaign?: Maybe<Scalars['Boolean']>;
  IsClosed?: Maybe<Scalars['Boolean']>;
  IsFeatured?: Maybe<Scalars['Boolean']>;
  IsHidden?: Maybe<Scalars['Boolean']>;
  Name?: Maybe<Scalars['String']>;
  /** An array relationship */
  Purchases: Array<Purchase>;
  /** An aggregate relationship */
  Purchases_aggregate: Purchase_Aggregate;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  Summary?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['numeric']>;
  Uri?: Maybe<Scalars['String']>;
};


/** columns and relationships of "RegistryView" */
export type RegistryViewPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


/** columns and relationships of "RegistryView" */
export type RegistryViewPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** aggregated selection of "RegistryView" */
export type RegistryView_Aggregate = {
  __typename?: 'RegistryView_aggregate';
  aggregate?: Maybe<RegistryView_Aggregate_Fields>;
  nodes: Array<RegistryView>;
};

/** aggregate fields of "RegistryView" */
export type RegistryView_Aggregate_Fields = {
  __typename?: 'RegistryView_aggregate_fields';
  avg?: Maybe<RegistryView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RegistryView_Max_Fields>;
  min?: Maybe<RegistryView_Min_Fields>;
  stddev?: Maybe<RegistryView_Stddev_Fields>;
  stddev_pop?: Maybe<RegistryView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RegistryView_Stddev_Samp_Fields>;
  sum?: Maybe<RegistryView_Sum_Fields>;
  var_pop?: Maybe<RegistryView_Var_Pop_Fields>;
  var_samp?: Maybe<RegistryView_Var_Samp_Fields>;
  variance?: Maybe<RegistryView_Variance_Fields>;
};


/** aggregate fields of "RegistryView" */
export type RegistryView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RegistryView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RegistryView_Avg_Fields = {
  __typename?: 'RegistryView_avg_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "RegistryView". All fields are combined with a logical 'AND'. */
export type RegistryView_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  AccountId?: InputMaybe<Uuid_Comparison_Exp>;
  ClosesOn?: InputMaybe<Timestamp_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  DistrictName?: InputMaybe<String_Comparison_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Gifts?: InputMaybe<Bigint_Comparison_Exp>;
  Hero?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsCampaign?: InputMaybe<Boolean_Comparison_Exp>;
  IsClosed?: InputMaybe<Boolean_Comparison_Exp>;
  IsFeatured?: InputMaybe<Boolean_Comparison_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Purchases?: InputMaybe<Purchase_Bool_Exp>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Bool_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Numeric_Comparison_Exp>;
  Trees?: InputMaybe<Numeric_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<RegistryView_Bool_Exp>>;
  _not?: InputMaybe<RegistryView_Bool_Exp>;
  _or?: InputMaybe<Array<RegistryView_Bool_Exp>>;
};

/** aggregate max on columns */
export type RegistryView_Max_Fields = {
  __typename?: 'RegistryView_max_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Gifts?: Maybe<Scalars['bigint']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  Summary?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['numeric']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RegistryView_Min_Fields = {
  __typename?: 'RegistryView_min_fields';
  AccountId?: Maybe<Scalars['uuid']>;
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  DistrictName?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Gifts?: Maybe<Scalars['bigint']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  RegionName?: Maybe<Scalars['String']>;
  Summary?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['numeric']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "RegistryView". */
export type RegistryView_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  AccountId?: InputMaybe<Order_By>;
  ClosesOn?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  DistrictName?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Gifts?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsCampaign?: InputMaybe<Order_By>;
  IsClosed?: InputMaybe<Order_By>;
  IsFeatured?: InputMaybe<Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  Trees?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "RegistryView" */
export enum RegistryView_Select_Column {
  /** column name */
  AccountId = 'AccountId',
  /** column name */
  ClosesOn = 'ClosesOn',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  DistrictName = 'DistrictName',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Gifts = 'Gifts',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  IsCampaign = 'IsCampaign',
  /** column name */
  IsClosed = 'IsClosed',
  /** column name */
  IsFeatured = 'IsFeatured',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  Name = 'Name',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  Summary = 'Summary',
  /** column name */
  Total = 'Total',
  /** column name */
  Trees = 'Trees',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type RegistryView_Stddev_Fields = {
  __typename?: 'RegistryView_stddev_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RegistryView_Stddev_Pop_Fields = {
  __typename?: 'RegistryView_stddev_pop_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RegistryView_Stddev_Samp_Fields = {
  __typename?: 'RegistryView_stddev_samp_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "RegistryView" */
export type RegistryView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RegistryView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryView_Stream_Cursor_Value_Input = {
  AccountId?: InputMaybe<Scalars['uuid']>;
  ClosesOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  DistrictName?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Gifts?: InputMaybe<Scalars['bigint']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsCampaign?: InputMaybe<Scalars['Boolean']>;
  IsClosed?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  RegionName?: InputMaybe<Scalars['String']>;
  Summary?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['numeric']>;
  Trees?: InputMaybe<Scalars['numeric']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RegistryView_Sum_Fields = {
  __typename?: 'RegistryView_sum_fields';
  Gifts?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Total?: Maybe<Scalars['numeric']>;
  Trees?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type RegistryView_Var_Pop_Fields = {
  __typename?: 'RegistryView_var_pop_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RegistryView_Var_Samp_Fields = {
  __typename?: 'RegistryView_var_samp_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RegistryView_Variance_Fields = {
  __typename?: 'RegistryView_variance_fields';
  Gifts?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  Trees?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Registry" */
export type Registry_Aggregate = {
  __typename?: 'Registry_aggregate';
  aggregate?: Maybe<Registry_Aggregate_Fields>;
  nodes: Array<Registry>;
};

/** aggregate fields of "Registry" */
export type Registry_Aggregate_Fields = {
  __typename?: 'Registry_aggregate_fields';
  avg?: Maybe<Registry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Registry_Max_Fields>;
  min?: Maybe<Registry_Min_Fields>;
  stddev?: Maybe<Registry_Stddev_Fields>;
  stddev_pop?: Maybe<Registry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Registry_Stddev_Samp_Fields>;
  sum?: Maybe<Registry_Sum_Fields>;
  var_pop?: Maybe<Registry_Var_Pop_Fields>;
  var_samp?: Maybe<Registry_Var_Samp_Fields>;
  variance?: Maybe<Registry_Variance_Fields>;
};


/** aggregate fields of "Registry" */
export type Registry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Registry_Avg_Fields = {
  __typename?: 'Registry_avg_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Registry". All fields are combined with a logical 'AND'. */
export type Registry_Bool_Exp = {
  ClosesOn?: InputMaybe<Timestamp_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Hero?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  IsCampaign?: InputMaybe<Boolean_Comparison_Exp>;
  IsClosed?: InputMaybe<Boolean_Comparison_Exp>;
  IsFeatured?: InputMaybe<Boolean_Comparison_Exp>;
  IsHidden?: InputMaybe<Boolean_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  ProductId?: InputMaybe<Uuid_Comparison_Exp>;
  Purchases?: InputMaybe<Purchase_Bool_Exp>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Bool_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  Summary?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Registry_Bool_Exp>>;
  _not?: InputMaybe<Registry_Bool_Exp>;
  _or?: InputMaybe<Array<Registry_Bool_Exp>>;
};

/** unique or primary key constraints on table "Registry" */
export enum Registry_Constraint {
  /** unique or primary key constraint on columns "Id" */
  RegistryPkey = 'Registry_pkey'
}

/** input type for incrementing numeric columns in table "Registry" */
export type Registry_Inc_Input = {
  Reference?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Registry" */
export type Registry_Insert_Input = {
  ClosesOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsCampaign?: InputMaybe<Scalars['Boolean']>;
  IsClosed?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Purchases?: InputMaybe<Purchase_Arr_Rel_Insert_Input>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Summary?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Registry_Max_Fields = {
  __typename?: 'Registry_max_fields';
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Summary?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Registry_Min_Fields = {
  __typename?: 'Registry_min_fields';
  ClosesOn?: Maybe<Scalars['timestamp']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Hero?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  ProductId?: Maybe<Scalars['uuid']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  Summary?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Uri?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Registry" */
export type Registry_Mutation_Response = {
  __typename?: 'Registry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Registry>;
};

/** input type for inserting object relation for remote table "Registry" */
export type Registry_Obj_Rel_Insert_Input = {
  data: Registry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Registry_On_Conflict>;
};

/** on_conflict condition type for table "Registry" */
export type Registry_On_Conflict = {
  constraint: Registry_Constraint;
  update_columns?: Array<Registry_Update_Column>;
  where?: InputMaybe<Registry_Bool_Exp>;
};

/** Ordering options when selecting data from "Registry". */
export type Registry_Order_By = {
  ClosesOn?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  IsCampaign?: InputMaybe<Order_By>;
  IsClosed?: InputMaybe<Order_By>;
  IsFeatured?: InputMaybe<Order_By>;
  IsHidden?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ProductId?: InputMaybe<Order_By>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  Summary?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Registry */
export type Registry_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Registry" */
export enum Registry_Select_Column {
  /** column name */
  ClosesOn = 'ClosesOn',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  IsCampaign = 'IsCampaign',
  /** column name */
  IsClosed = 'IsClosed',
  /** column name */
  IsFeatured = 'IsFeatured',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  Name = 'Name',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  Summary = 'Summary',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

/** input type for updating data in table "Registry" */
export type Registry_Set_Input = {
  ClosesOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsCampaign?: InputMaybe<Scalars['Boolean']>;
  IsClosed?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Summary?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Registry_Stddev_Fields = {
  __typename?: 'Registry_stddev_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Registry_Stddev_Pop_Fields = {
  __typename?: 'Registry_stddev_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Registry_Stddev_Samp_Fields = {
  __typename?: 'Registry_stddev_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Registry" */
export type Registry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Registry_Stream_Cursor_Value_Input = {
  ClosesOn?: InputMaybe<Scalars['timestamp']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Description?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  IsCampaign?: InputMaybe<Scalars['Boolean']>;
  IsClosed?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['String']>;
  ProductId?: InputMaybe<Scalars['uuid']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  Summary?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Registry_Sum_Fields = {
  __typename?: 'Registry_sum_fields';
  Reference?: Maybe<Scalars['bigint']>;
};

/** update columns of table "Registry" */
export enum Registry_Update_Column {
  /** column name */
  ClosesOn = 'ClosesOn',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Description = 'Description',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Id = 'Id',
  /** column name */
  IsCampaign = 'IsCampaign',
  /** column name */
  IsClosed = 'IsClosed',
  /** column name */
  IsFeatured = 'IsFeatured',
  /** column name */
  IsHidden = 'IsHidden',
  /** column name */
  Name = 'Name',
  /** column name */
  ProductId = 'ProductId',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  Summary = 'Summary',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Uri = 'Uri'
}

export type Registry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Registry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registry_Set_Input>;
  where: Registry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Registry_Var_Pop_Fields = {
  __typename?: 'Registry_var_pop_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Registry_Var_Samp_Fields = {
  __typename?: 'Registry_var_samp_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Registry_Variance_Fields = {
  __typename?: 'Registry_variance_fields';
  Reference?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Report" */
export type Report = {
  __typename?: 'Report';
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Expires: Scalars['timestamp'];
  Filename: Scalars['String'];
  Id: Scalars['uuid'];
  State: Scalars['Int'];
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "Report" */
export type Report_Aggregate = {
  __typename?: 'Report_aggregate';
  aggregate?: Maybe<Report_Aggregate_Fields>;
  nodes: Array<Report>;
};

/** aggregate fields of "Report" */
export type Report_Aggregate_Fields = {
  __typename?: 'Report_aggregate_fields';
  avg?: Maybe<Report_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Report_Max_Fields>;
  min?: Maybe<Report_Min_Fields>;
  stddev?: Maybe<Report_Stddev_Fields>;
  stddev_pop?: Maybe<Report_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Report_Stddev_Samp_Fields>;
  sum?: Maybe<Report_Sum_Fields>;
  var_pop?: Maybe<Report_Var_Pop_Fields>;
  var_samp?: Maybe<Report_Var_Samp_Fields>;
  variance?: Maybe<Report_Variance_Fields>;
};


/** aggregate fields of "Report" */
export type Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Report_Avg_Fields = {
  __typename?: 'Report_avg_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Report". All fields are combined with a logical 'AND'. */
export type Report_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Expires?: InputMaybe<Timestamp_Comparison_Exp>;
  Filename?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  State?: InputMaybe<Int_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Report_Bool_Exp>>;
  _not?: InputMaybe<Report_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Bool_Exp>>;
};

/** unique or primary key constraints on table "Report" */
export enum Report_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ReportPkey = 'Report_pkey'
}

/** input type for incrementing numeric columns in table "Report" */
export type Report_Inc_Input = {
  State?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Report" */
export type Report_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Expires?: InputMaybe<Scalars['timestamp']>;
  Filename?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Report_Max_Fields = {
  __typename?: 'Report_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Expires?: Maybe<Scalars['timestamp']>;
  Filename?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Report_Min_Fields = {
  __typename?: 'Report_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Expires?: Maybe<Scalars['timestamp']>;
  Filename?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  State?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Report" */
export type Report_Mutation_Response = {
  __typename?: 'Report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report>;
};

/** on_conflict condition type for table "Report" */
export type Report_On_Conflict = {
  constraint: Report_Constraint;
  update_columns?: Array<Report_Update_Column>;
  where?: InputMaybe<Report_Bool_Exp>;
};

/** Ordering options when selecting data from "Report". */
export type Report_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Expires?: InputMaybe<Order_By>;
  Filename?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Report */
export type Report_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Report" */
export enum Report_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Expires = 'Expires',
  /** column name */
  Filename = 'Filename',
  /** column name */
  Id = 'Id',
  /** column name */
  State = 'State',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Report" */
export type Report_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Expires?: InputMaybe<Scalars['timestamp']>;
  Filename?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Report_Stddev_Fields = {
  __typename?: 'Report_stddev_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Report_Stddev_Pop_Fields = {
  __typename?: 'Report_stddev_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Report_Stddev_Samp_Fields = {
  __typename?: 'Report_stddev_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Report" */
export type Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Expires?: InputMaybe<Scalars['timestamp']>;
  Filename?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  State?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Report_Sum_Fields = {
  __typename?: 'Report_sum_fields';
  State?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
};

/** update columns of table "Report" */
export enum Report_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Expires = 'Expires',
  /** column name */
  Filename = 'Filename',
  /** column name */
  Id = 'Id',
  /** column name */
  State = 'State',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Report_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Report_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Set_Input>;
  where: Report_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Report_Var_Pop_Fields = {
  __typename?: 'Report_var_pop_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Report_Var_Samp_Fields = {
  __typename?: 'Report_var_samp_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Report_Variance_Fields = {
  __typename?: 'Report_variance_fields';
  State?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

export type ResendGiftCertificateInput = {
  PurchaseId: Scalars['String'];
};

export type ResendGiftCertificateOutput = {
  __typename?: 'ResendGiftCertificateOutput';
  PurchaseId: Scalars['String'];
};

/** columns and relationships of "Sample" */
export type Sample = {
  __typename?: 'Sample';
  Area: Scalars['float8'];
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id: Scalars['uuid'];
  Name?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlantingId: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  Reference: Scalars['bigint'];
  Spacing: Scalars['float8'];
  UpdatedOn: Scalars['timestamp'];
};

/** columns and relationships of "SampleLine" */
export type SampleLine = {
  __typename?: 'SampleLine';
  Id: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  Reference: Scalars['bigint'];
  SampleId: Scalars['uuid'];
  SpeciesId: Scalars['uuid'];
};

/** aggregated selection of "SampleLine" */
export type SampleLine_Aggregate = {
  __typename?: 'SampleLine_aggregate';
  aggregate?: Maybe<SampleLine_Aggregate_Fields>;
  nodes: Array<SampleLine>;
};

/** aggregate fields of "SampleLine" */
export type SampleLine_Aggregate_Fields = {
  __typename?: 'SampleLine_aggregate_fields';
  avg?: Maybe<SampleLine_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SampleLine_Max_Fields>;
  min?: Maybe<SampleLine_Min_Fields>;
  stddev?: Maybe<SampleLine_Stddev_Fields>;
  stddev_pop?: Maybe<SampleLine_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SampleLine_Stddev_Samp_Fields>;
  sum?: Maybe<SampleLine_Sum_Fields>;
  var_pop?: Maybe<SampleLine_Var_Pop_Fields>;
  var_samp?: Maybe<SampleLine_Var_Samp_Fields>;
  variance?: Maybe<SampleLine_Variance_Fields>;
};


/** aggregate fields of "SampleLine" */
export type SampleLine_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SampleLine_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SampleLine_Avg_Fields = {
  __typename?: 'SampleLine_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "SampleLine". All fields are combined with a logical 'AND'. */
export type SampleLine_Bool_Exp = {
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  SampleId?: InputMaybe<Uuid_Comparison_Exp>;
  SpeciesId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<SampleLine_Bool_Exp>>;
  _not?: InputMaybe<SampleLine_Bool_Exp>;
  _or?: InputMaybe<Array<SampleLine_Bool_Exp>>;
};

/** unique or primary key constraints on table "SampleLine" */
export enum SampleLine_Constraint {
  /** unique or primary key constraint on columns "Id" */
  SampleLinePkey = 'SampleLine_pkey'
}

/** input type for incrementing numeric columns in table "SampleLine" */
export type SampleLine_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "SampleLine" */
export type SampleLine_Insert_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SampleLine_Max_Fields = {
  __typename?: 'SampleLine_max_fields';
  Id?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  SampleId?: Maybe<Scalars['uuid']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type SampleLine_Min_Fields = {
  __typename?: 'SampleLine_min_fields';
  Id?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  SampleId?: Maybe<Scalars['uuid']>;
  SpeciesId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "SampleLine" */
export type SampleLine_Mutation_Response = {
  __typename?: 'SampleLine_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SampleLine>;
};

/** on_conflict condition type for table "SampleLine" */
export type SampleLine_On_Conflict = {
  constraint: SampleLine_Constraint;
  update_columns?: Array<SampleLine_Update_Column>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};

/** Ordering options when selecting data from "SampleLine". */
export type SampleLine_Order_By = {
  Id?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  SampleId?: InputMaybe<Order_By>;
  SpeciesId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: SampleLine */
export type SampleLine_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "SampleLine" */
export enum SampleLine_Select_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  SampleId = 'SampleId',
  /** column name */
  SpeciesId = 'SpeciesId'
}

/** input type for updating data in table "SampleLine" */
export type SampleLine_Set_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type SampleLine_Stddev_Fields = {
  __typename?: 'SampleLine_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SampleLine_Stddev_Pop_Fields = {
  __typename?: 'SampleLine_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SampleLine_Stddev_Samp_Fields = {
  __typename?: 'SampleLine_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "SampleLine" */
export type SampleLine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SampleLine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleLine_Stream_Cursor_Value_Input = {
  Id?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  SampleId?: InputMaybe<Scalars['uuid']>;
  SpeciesId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type SampleLine_Sum_Fields = {
  __typename?: 'SampleLine_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
};

/** update columns of table "SampleLine" */
export enum SampleLine_Update_Column {
  /** column name */
  Id = 'Id',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  SampleId = 'SampleId',
  /** column name */
  SpeciesId = 'SpeciesId'
}

export type SampleLine_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SampleLine_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SampleLine_Set_Input>;
  where: SampleLine_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SampleLine_Var_Pop_Fields = {
  __typename?: 'SampleLine_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SampleLine_Var_Samp_Fields = {
  __typename?: 'SampleLine_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SampleLine_Variance_Fields = {
  __typename?: 'SampleLine_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "Sample" */
export type Sample_Aggregate = {
  __typename?: 'Sample_aggregate';
  aggregate?: Maybe<Sample_Aggregate_Fields>;
  nodes: Array<Sample>;
};

/** aggregate fields of "Sample" */
export type Sample_Aggregate_Fields = {
  __typename?: 'Sample_aggregate_fields';
  avg?: Maybe<Sample_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sample_Max_Fields>;
  min?: Maybe<Sample_Min_Fields>;
  stddev?: Maybe<Sample_Stddev_Fields>;
  stddev_pop?: Maybe<Sample_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sample_Stddev_Samp_Fields>;
  sum?: Maybe<Sample_Sum_Fields>;
  var_pop?: Maybe<Sample_Var_Pop_Fields>;
  var_samp?: Maybe<Sample_Var_Samp_Fields>;
  variance?: Maybe<Sample_Variance_Fields>;
};


/** aggregate fields of "Sample" */
export type Sample_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sample_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sample_Avg_Fields = {
  __typename?: 'Sample_avg_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Sample". All fields are combined with a logical 'AND'. */
export type Sample_Bool_Exp = {
  Area?: InputMaybe<Float8_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Notes?: InputMaybe<String_Comparison_Exp>;
  Photo?: InputMaybe<String_Comparison_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  Spacing?: InputMaybe<Float8_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Sample_Bool_Exp>>;
  _not?: InputMaybe<Sample_Bool_Exp>;
  _or?: InputMaybe<Array<Sample_Bool_Exp>>;
};

/** unique or primary key constraints on table "Sample" */
export enum Sample_Constraint {
  /** unique or primary key constraint on columns "Id" */
  SamplePkey = 'Sample_pkey'
}

/** input type for incrementing numeric columns in table "Sample" */
export type Sample_Inc_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "Sample" */
export type Sample_Insert_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Notes?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Sample_Max_Fields = {
  __typename?: 'Sample_max_fields';
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Spacing?: Maybe<Scalars['float8']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Sample_Min_Fields = {
  __typename?: 'Sample_min_fields';
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Spacing?: Maybe<Scalars['float8']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Sample" */
export type Sample_Mutation_Response = {
  __typename?: 'Sample_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sample>;
};

/** on_conflict condition type for table "Sample" */
export type Sample_On_Conflict = {
  constraint: Sample_Constraint;
  update_columns?: Array<Sample_Update_Column>;
  where?: InputMaybe<Sample_Bool_Exp>;
};

/** Ordering options when selecting data from "Sample". */
export type Sample_Order_By = {
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Notes?: InputMaybe<Order_By>;
  Photo?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Sample */
export type Sample_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Sample" */
export enum Sample_Select_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Notes = 'Notes',
  /** column name */
  Photo = 'Photo',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  Spacing = 'Spacing',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "Sample" */
export type Sample_Set_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Notes?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Sample_Stddev_Fields = {
  __typename?: 'Sample_stddev_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sample_Stddev_Pop_Fields = {
  __typename?: 'Sample_stddev_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sample_Stddev_Samp_Fields = {
  __typename?: 'Sample_stddev_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Sample" */
export type Sample_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sample_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sample_Stream_Cursor_Value_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  Notes?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Sample_Sum_Fields = {
  __typename?: 'Sample_sum_fields';
  Area?: Maybe<Scalars['float8']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Spacing?: Maybe<Scalars['float8']>;
};

/** update columns of table "Sample" */
export enum Sample_Update_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  Notes = 'Notes',
  /** column name */
  Photo = 'Photo',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  Spacing = 'Spacing',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type Sample_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sample_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sample_Set_Input>;
  where: Sample_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sample_Var_Pop_Fields = {
  __typename?: 'Sample_var_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sample_Var_Samp_Fields = {
  __typename?: 'Sample_var_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sample_Variance_Fields = {
  __typename?: 'Sample_variance_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ScheduledEmail" */
export type ScheduledEmail = {
  __typename?: 'ScheduledEmail';
  Attempts?: Maybe<Scalars['bigint']>;
  CreatedOn: Scalars['timestamp'];
  DeliverOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Queued: Scalars['Boolean'];
  ReferenceId: Scalars['uuid'];
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "ScheduledEmail" */
export type ScheduledEmail_Aggregate = {
  __typename?: 'ScheduledEmail_aggregate';
  aggregate?: Maybe<ScheduledEmail_Aggregate_Fields>;
  nodes: Array<ScheduledEmail>;
};

/** aggregate fields of "ScheduledEmail" */
export type ScheduledEmail_Aggregate_Fields = {
  __typename?: 'ScheduledEmail_aggregate_fields';
  avg?: Maybe<ScheduledEmail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ScheduledEmail_Max_Fields>;
  min?: Maybe<ScheduledEmail_Min_Fields>;
  stddev?: Maybe<ScheduledEmail_Stddev_Fields>;
  stddev_pop?: Maybe<ScheduledEmail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ScheduledEmail_Stddev_Samp_Fields>;
  sum?: Maybe<ScheduledEmail_Sum_Fields>;
  var_pop?: Maybe<ScheduledEmail_Var_Pop_Fields>;
  var_samp?: Maybe<ScheduledEmail_Var_Samp_Fields>;
  variance?: Maybe<ScheduledEmail_Variance_Fields>;
};


/** aggregate fields of "ScheduledEmail" */
export type ScheduledEmail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ScheduledEmail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ScheduledEmail_Avg_Fields = {
  __typename?: 'ScheduledEmail_avg_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ScheduledEmail". All fields are combined with a logical 'AND'. */
export type ScheduledEmail_Bool_Exp = {
  Attempts?: InputMaybe<Bigint_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DeliverOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Queued?: InputMaybe<Boolean_Comparison_Exp>;
  ReferenceId?: InputMaybe<Uuid_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<ScheduledEmail_Bool_Exp>>;
  _not?: InputMaybe<ScheduledEmail_Bool_Exp>;
  _or?: InputMaybe<Array<ScheduledEmail_Bool_Exp>>;
};

/** unique or primary key constraints on table "ScheduledEmail" */
export enum ScheduledEmail_Constraint {
  /** unique or primary key constraint on columns "Id" */
  ScheduledEmailPkey = 'ScheduledEmail_pkey'
}

/** input type for incrementing numeric columns in table "ScheduledEmail" */
export type ScheduledEmail_Inc_Input = {
  Attempts?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ScheduledEmail" */
export type ScheduledEmail_Insert_Input = {
  Attempts?: InputMaybe<Scalars['bigint']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Queued?: InputMaybe<Scalars['Boolean']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type ScheduledEmail_Max_Fields = {
  __typename?: 'ScheduledEmail_max_fields';
  Attempts?: Maybe<Scalars['bigint']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type ScheduledEmail_Min_Fields = {
  __typename?: 'ScheduledEmail_min_fields';
  Attempts?: Maybe<Scalars['bigint']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DeliverOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "ScheduledEmail" */
export type ScheduledEmail_Mutation_Response = {
  __typename?: 'ScheduledEmail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScheduledEmail>;
};

/** on_conflict condition type for table "ScheduledEmail" */
export type ScheduledEmail_On_Conflict = {
  constraint: ScheduledEmail_Constraint;
  update_columns?: Array<ScheduledEmail_Update_Column>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};

/** Ordering options when selecting data from "ScheduledEmail". */
export type ScheduledEmail_Order_By = {
  Attempts?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  DeliverOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Queued?: InputMaybe<Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ScheduledEmail */
export type ScheduledEmail_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "ScheduledEmail" */
export enum ScheduledEmail_Select_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Queued = 'Queued',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "ScheduledEmail" */
export type ScheduledEmail_Set_Input = {
  Attempts?: InputMaybe<Scalars['bigint']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Queued?: InputMaybe<Scalars['Boolean']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type ScheduledEmail_Stddev_Fields = {
  __typename?: 'ScheduledEmail_stddev_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ScheduledEmail_Stddev_Pop_Fields = {
  __typename?: 'ScheduledEmail_stddev_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ScheduledEmail_Stddev_Samp_Fields = {
  __typename?: 'ScheduledEmail_stddev_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ScheduledEmail" */
export type ScheduledEmail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ScheduledEmail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ScheduledEmail_Stream_Cursor_Value_Input = {
  Attempts?: InputMaybe<Scalars['bigint']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DeliverOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Queued?: InputMaybe<Scalars['Boolean']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type ScheduledEmail_Sum_Fields = {
  __typename?: 'ScheduledEmail_sum_fields';
  Attempts?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['Int']>;
};

/** update columns of table "ScheduledEmail" */
export enum ScheduledEmail_Update_Column {
  /** column name */
  Attempts = 'Attempts',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DeliverOn = 'DeliverOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Queued = 'Queued',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type ScheduledEmail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScheduledEmail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScheduledEmail_Set_Input>;
  where: ScheduledEmail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ScheduledEmail_Var_Pop_Fields = {
  __typename?: 'ScheduledEmail_var_pop_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ScheduledEmail_Var_Samp_Fields = {
  __typename?: 'ScheduledEmail_var_samp_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ScheduledEmail_Variance_Fields = {
  __typename?: 'ScheduledEmail_variance_fields';
  Attempts?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Season" */
export type Season = {
  __typename?: 'Season';
  ApplicationsClosed: Scalars['Boolean'];
  FundingEnds: Scalars['timestamp'];
  FundingOpens: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Name: Scalars['String'];
  PlantingEnds: Scalars['timestamp'];
  PlantingOpens: Scalars['timestamp'];
};

/** aggregated selection of "Season" */
export type Season_Aggregate = {
  __typename?: 'Season_aggregate';
  aggregate?: Maybe<Season_Aggregate_Fields>;
  nodes: Array<Season>;
};

/** aggregate fields of "Season" */
export type Season_Aggregate_Fields = {
  __typename?: 'Season_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Season_Max_Fields>;
  min?: Maybe<Season_Min_Fields>;
};


/** aggregate fields of "Season" */
export type Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Season". All fields are combined with a logical 'AND'. */
export type Season_Bool_Exp = {
  ApplicationsClosed?: InputMaybe<Boolean_Comparison_Exp>;
  FundingEnds?: InputMaybe<Timestamp_Comparison_Exp>;
  FundingOpens?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  PlantingEnds?: InputMaybe<Timestamp_Comparison_Exp>;
  PlantingOpens?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<Season_Bool_Exp>>;
  _not?: InputMaybe<Season_Bool_Exp>;
  _or?: InputMaybe<Array<Season_Bool_Exp>>;
};

/** unique or primary key constraints on table "Season" */
export enum Season_Constraint {
  /** unique or primary key constraint on columns "Id" */
  SeasonPkey = 'Season_pkey'
}

/** input type for inserting data into table "Season" */
export type Season_Insert_Input = {
  ApplicationsClosed?: InputMaybe<Scalars['Boolean']>;
  FundingEnds?: InputMaybe<Scalars['timestamp']>;
  FundingOpens?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  PlantingEnds?: InputMaybe<Scalars['timestamp']>;
  PlantingOpens?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Season_Max_Fields = {
  __typename?: 'Season_max_fields';
  FundingEnds?: Maybe<Scalars['timestamp']>;
  FundingOpens?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  PlantingEnds?: Maybe<Scalars['timestamp']>;
  PlantingOpens?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Season_Min_Fields = {
  __typename?: 'Season_min_fields';
  FundingEnds?: Maybe<Scalars['timestamp']>;
  FundingOpens?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  PlantingEnds?: Maybe<Scalars['timestamp']>;
  PlantingOpens?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "Season" */
export type Season_Mutation_Response = {
  __typename?: 'Season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Season>;
};

/** input type for inserting object relation for remote table "Season" */
export type Season_Obj_Rel_Insert_Input = {
  data: Season_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Season_On_Conflict>;
};

/** on_conflict condition type for table "Season" */
export type Season_On_Conflict = {
  constraint: Season_Constraint;
  update_columns?: Array<Season_Update_Column>;
  where?: InputMaybe<Season_Bool_Exp>;
};

/** Ordering options when selecting data from "Season". */
export type Season_Order_By = {
  ApplicationsClosed?: InputMaybe<Order_By>;
  FundingEnds?: InputMaybe<Order_By>;
  FundingOpens?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  PlantingEnds?: InputMaybe<Order_By>;
  PlantingOpens?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Season */
export type Season_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Season" */
export enum Season_Select_Column {
  /** column name */
  ApplicationsClosed = 'ApplicationsClosed',
  /** column name */
  FundingEnds = 'FundingEnds',
  /** column name */
  FundingOpens = 'FundingOpens',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  PlantingEnds = 'PlantingEnds',
  /** column name */
  PlantingOpens = 'PlantingOpens'
}

/** input type for updating data in table "Season" */
export type Season_Set_Input = {
  ApplicationsClosed?: InputMaybe<Scalars['Boolean']>;
  FundingEnds?: InputMaybe<Scalars['timestamp']>;
  FundingOpens?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  PlantingEnds?: InputMaybe<Scalars['timestamp']>;
  PlantingOpens?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "Season" */
export type Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Season_Stream_Cursor_Value_Input = {
  ApplicationsClosed?: InputMaybe<Scalars['Boolean']>;
  FundingEnds?: InputMaybe<Scalars['timestamp']>;
  FundingOpens?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  PlantingEnds?: InputMaybe<Scalars['timestamp']>;
  PlantingOpens?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "Season" */
export enum Season_Update_Column {
  /** column name */
  ApplicationsClosed = 'ApplicationsClosed',
  /** column name */
  FundingEnds = 'FundingEnds',
  /** column name */
  FundingOpens = 'FundingOpens',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  PlantingEnds = 'PlantingEnds',
  /** column name */
  PlantingOpens = 'PlantingOpens'
}

export type Season_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Season_Set_Input>;
  where: Season_Bool_Exp;
};

/** columns and relationships of "Species" */
export type Species = {
  __typename?: 'Species';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Image?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Ordering: Scalars['Int'];
  Scientific: Scalars['String'];
  Type: Scalars['String'];
};

/** aggregated selection of "Species" */
export type Species_Aggregate = {
  __typename?: 'Species_aggregate';
  aggregate?: Maybe<Species_Aggregate_Fields>;
  nodes: Array<Species>;
};

/** aggregate fields of "Species" */
export type Species_Aggregate_Fields = {
  __typename?: 'Species_aggregate_fields';
  avg?: Maybe<Species_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Species_Max_Fields>;
  min?: Maybe<Species_Min_Fields>;
  stddev?: Maybe<Species_Stddev_Fields>;
  stddev_pop?: Maybe<Species_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Species_Stddev_Samp_Fields>;
  sum?: Maybe<Species_Sum_Fields>;
  var_pop?: Maybe<Species_Var_Pop_Fields>;
  var_samp?: Maybe<Species_Var_Samp_Fields>;
  variance?: Maybe<Species_Variance_Fields>;
};


/** aggregate fields of "Species" */
export type Species_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Species_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Species_Avg_Fields = {
  __typename?: 'Species_avg_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Species". All fields are combined with a logical 'AND'. */
export type Species_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Image?: InputMaybe<String_Comparison_Exp>;
  Link?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Ordering?: InputMaybe<Int_Comparison_Exp>;
  Scientific?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Species_Bool_Exp>>;
  _not?: InputMaybe<Species_Bool_Exp>;
  _or?: InputMaybe<Array<Species_Bool_Exp>>;
};

/** unique or primary key constraints on table "Species" */
export enum Species_Constraint {
  /** unique or primary key constraint on columns "Id" */
  SpeciesPkey = 'Species_pkey'
}

/** input type for incrementing numeric columns in table "Species" */
export type Species_Inc_Input = {
  Ordering?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Species" */
export type Species_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Image?: InputMaybe<Scalars['String']>;
  Link?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  Scientific?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Species_Max_Fields = {
  __typename?: 'Species_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Image?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
  Scientific?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Species_Min_Fields = {
  __typename?: 'Species_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Image?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Ordering?: Maybe<Scalars['Int']>;
  Scientific?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Species" */
export type Species_Mutation_Response = {
  __typename?: 'Species_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Species>;
};

/** input type for inserting object relation for remote table "Species" */
export type Species_Obj_Rel_Insert_Input = {
  data: Species_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Species_On_Conflict>;
};

/** on_conflict condition type for table "Species" */
export type Species_On_Conflict = {
  constraint: Species_Constraint;
  update_columns?: Array<Species_Update_Column>;
  where?: InputMaybe<Species_Bool_Exp>;
};

/** Ordering options when selecting data from "Species". */
export type Species_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Image?: InputMaybe<Order_By>;
  Link?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Ordering?: InputMaybe<Order_By>;
  Scientific?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Species */
export type Species_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Species" */
export enum Species_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Image = 'Image',
  /** column name */
  Link = 'Link',
  /** column name */
  Name = 'Name',
  /** column name */
  Ordering = 'Ordering',
  /** column name */
  Scientific = 'Scientific',
  /** column name */
  Type = 'Type'
}

/** input type for updating data in table "Species" */
export type Species_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Image?: InputMaybe<Scalars['String']>;
  Link?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  Scientific?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Species_Stddev_Fields = {
  __typename?: 'Species_stddev_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Species_Stddev_Pop_Fields = {
  __typename?: 'Species_stddev_pop_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Species_Stddev_Samp_Fields = {
  __typename?: 'Species_stddev_samp_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Species" */
export type Species_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Species_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Species_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Image?: InputMaybe<Scalars['String']>;
  Link?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Ordering?: InputMaybe<Scalars['Int']>;
  Scientific?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Species_Sum_Fields = {
  __typename?: 'Species_sum_fields';
  Ordering?: Maybe<Scalars['Int']>;
};

/** update columns of table "Species" */
export enum Species_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Image = 'Image',
  /** column name */
  Link = 'Link',
  /** column name */
  Name = 'Name',
  /** column name */
  Ordering = 'Ordering',
  /** column name */
  Scientific = 'Scientific',
  /** column name */
  Type = 'Type'
}

export type Species_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Species_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Species_Set_Input>;
  where: Species_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Species_Var_Pop_Fields = {
  __typename?: 'Species_var_pop_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Species_Var_Samp_Fields = {
  __typename?: 'Species_var_samp_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Species_Variance_Fields = {
  __typename?: 'Species_variance_fields';
  Ordering?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "StatisticsView" */
export type StatisticsView = {
  __typename?: 'StatisticsView';
  PlantingsSupported?: Maybe<Scalars['bigint']>;
  TotalOpenRegistries?: Maybe<Scalars['bigint']>;
  TotalPlantersAndFunders?: Maybe<Scalars['bigint']>;
  TotalTrees?: Maybe<Scalars['numeric']>;
  TotalTreesFunded?: Maybe<Scalars['numeric']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['numeric']>;
  TotalTreesGifted?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "StatisticsView" */
export type StatisticsView_Aggregate = {
  __typename?: 'StatisticsView_aggregate';
  aggregate?: Maybe<StatisticsView_Aggregate_Fields>;
  nodes: Array<StatisticsView>;
};

/** aggregate fields of "StatisticsView" */
export type StatisticsView_Aggregate_Fields = {
  __typename?: 'StatisticsView_aggregate_fields';
  avg?: Maybe<StatisticsView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<StatisticsView_Max_Fields>;
  min?: Maybe<StatisticsView_Min_Fields>;
  stddev?: Maybe<StatisticsView_Stddev_Fields>;
  stddev_pop?: Maybe<StatisticsView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StatisticsView_Stddev_Samp_Fields>;
  sum?: Maybe<StatisticsView_Sum_Fields>;
  var_pop?: Maybe<StatisticsView_Var_Pop_Fields>;
  var_samp?: Maybe<StatisticsView_Var_Samp_Fields>;
  variance?: Maybe<StatisticsView_Variance_Fields>;
};


/** aggregate fields of "StatisticsView" */
export type StatisticsView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StatisticsView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StatisticsView_Avg_Fields = {
  __typename?: 'StatisticsView_avg_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "StatisticsView". All fields are combined with a logical 'AND'. */
export type StatisticsView_Bool_Exp = {
  PlantingsSupported?: InputMaybe<Bigint_Comparison_Exp>;
  TotalOpenRegistries?: InputMaybe<Bigint_Comparison_Exp>;
  TotalPlantersAndFunders?: InputMaybe<Bigint_Comparison_Exp>;
  TotalTrees?: InputMaybe<Numeric_Comparison_Exp>;
  TotalTreesFunded?: InputMaybe<Numeric_Comparison_Exp>;
  TotalTreesFundedAndGifted?: InputMaybe<Numeric_Comparison_Exp>;
  TotalTreesGifted?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<StatisticsView_Bool_Exp>>;
  _not?: InputMaybe<StatisticsView_Bool_Exp>;
  _or?: InputMaybe<Array<StatisticsView_Bool_Exp>>;
};

/** aggregate max on columns */
export type StatisticsView_Max_Fields = {
  __typename?: 'StatisticsView_max_fields';
  PlantingsSupported?: Maybe<Scalars['bigint']>;
  TotalOpenRegistries?: Maybe<Scalars['bigint']>;
  TotalPlantersAndFunders?: Maybe<Scalars['bigint']>;
  TotalTrees?: Maybe<Scalars['numeric']>;
  TotalTreesFunded?: Maybe<Scalars['numeric']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['numeric']>;
  TotalTreesGifted?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type StatisticsView_Min_Fields = {
  __typename?: 'StatisticsView_min_fields';
  PlantingsSupported?: Maybe<Scalars['bigint']>;
  TotalOpenRegistries?: Maybe<Scalars['bigint']>;
  TotalPlantersAndFunders?: Maybe<Scalars['bigint']>;
  TotalTrees?: Maybe<Scalars['numeric']>;
  TotalTreesFunded?: Maybe<Scalars['numeric']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['numeric']>;
  TotalTreesGifted?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "StatisticsView". */
export type StatisticsView_Order_By = {
  PlantingsSupported?: InputMaybe<Order_By>;
  TotalOpenRegistries?: InputMaybe<Order_By>;
  TotalPlantersAndFunders?: InputMaybe<Order_By>;
  TotalTrees?: InputMaybe<Order_By>;
  TotalTreesFunded?: InputMaybe<Order_By>;
  TotalTreesFundedAndGifted?: InputMaybe<Order_By>;
  TotalTreesGifted?: InputMaybe<Order_By>;
};

/** select columns of table "StatisticsView" */
export enum StatisticsView_Select_Column {
  /** column name */
  PlantingsSupported = 'PlantingsSupported',
  /** column name */
  TotalOpenRegistries = 'TotalOpenRegistries',
  /** column name */
  TotalPlantersAndFunders = 'TotalPlantersAndFunders',
  /** column name */
  TotalTrees = 'TotalTrees',
  /** column name */
  TotalTreesFunded = 'TotalTreesFunded',
  /** column name */
  TotalTreesFundedAndGifted = 'TotalTreesFundedAndGifted',
  /** column name */
  TotalTreesGifted = 'TotalTreesGifted'
}

/** aggregate stddev on columns */
export type StatisticsView_Stddev_Fields = {
  __typename?: 'StatisticsView_stddev_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StatisticsView_Stddev_Pop_Fields = {
  __typename?: 'StatisticsView_stddev_pop_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StatisticsView_Stddev_Samp_Fields = {
  __typename?: 'StatisticsView_stddev_samp_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "StatisticsView" */
export type StatisticsView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StatisticsView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StatisticsView_Stream_Cursor_Value_Input = {
  PlantingsSupported?: InputMaybe<Scalars['bigint']>;
  TotalOpenRegistries?: InputMaybe<Scalars['bigint']>;
  TotalPlantersAndFunders?: InputMaybe<Scalars['bigint']>;
  TotalTrees?: InputMaybe<Scalars['numeric']>;
  TotalTreesFunded?: InputMaybe<Scalars['numeric']>;
  TotalTreesFundedAndGifted?: InputMaybe<Scalars['numeric']>;
  TotalTreesGifted?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type StatisticsView_Sum_Fields = {
  __typename?: 'StatisticsView_sum_fields';
  PlantingsSupported?: Maybe<Scalars['bigint']>;
  TotalOpenRegistries?: Maybe<Scalars['bigint']>;
  TotalPlantersAndFunders?: Maybe<Scalars['bigint']>;
  TotalTrees?: Maybe<Scalars['numeric']>;
  TotalTreesFunded?: Maybe<Scalars['numeric']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['numeric']>;
  TotalTreesGifted?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type StatisticsView_Var_Pop_Fields = {
  __typename?: 'StatisticsView_var_pop_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StatisticsView_Var_Samp_Fields = {
  __typename?: 'StatisticsView_var_samp_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StatisticsView_Variance_Fields = {
  __typename?: 'StatisticsView_variance_fields';
  PlantingsSupported?: Maybe<Scalars['Float']>;
  TotalOpenRegistries?: Maybe<Scalars['Float']>;
  TotalPlantersAndFunders?: Maybe<Scalars['Float']>;
  TotalTrees?: Maybe<Scalars['Float']>;
  TotalTreesFunded?: Maybe<Scalars['Float']>;
  TotalTreesFundedAndGifted?: Maybe<Scalars['Float']>;
  TotalTreesGifted?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  NextChargeDate?: Maybe<Scalars['timestamp']>;
  StartDate?: Maybe<Scalars['timestamp']>;
  TotalAmount?: Maybe<Scalars['float8']>;
  TotalQuantity?: Maybe<Scalars['Int']>;
};

export type StripeSummary = {
  __typename?: 'StripeSummary';
  CardLastFour?: Maybe<Scalars['String']>;
  Subscription?: Maybe<StripeSubscription>;
};

/** columns and relationships of "Subscription" */
export type Subscription = {
  __typename?: 'Subscription';
  /** An object relationship */
  Account?: Maybe<Account>;
  CancelDate?: Maybe<Scalars['timestamp']>;
  CancelReason?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  /** An object relationship */
  Funder: Funder;
  FunderId: Scalars['uuid'];
  Id: Scalars['uuid'];
  PlantingRegionId?: Maybe<Scalars['uuid']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  /** An array relationship */
  Purchases: Array<Purchase>;
  /** An aggregate relationship */
  Purchases_aggregate: Purchase_Aggregate;
  Quantity: Scalars['bigint'];
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  /** An object relationship */
  Region?: Maybe<Region>;
  State: Scalars['String'];
  StripeSubscriptionId?: Maybe<Scalars['String']>;
  UpdatedOn: Scalars['timestamp'];
  UserId: Scalars['uuid'];
};


/** columns and relationships of "Subscription" */
export type SubscriptionPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


/** columns and relationships of "Subscription" */
export type SubscriptionPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};

/** aggregated selection of "Subscription" */
export type Subscription_Aggregate = {
  __typename?: 'Subscription_aggregate';
  aggregate?: Maybe<Subscription_Aggregate_Fields>;
  nodes: Array<Subscription>;
};

export type Subscription_Aggregate_Bool_Exp = {
  count?: InputMaybe<Subscription_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "Subscription" */
export type Subscription_Aggregate_Fields = {
  __typename?: 'Subscription_aggregate_fields';
  avg?: Maybe<Subscription_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Max_Fields>;
  min?: Maybe<Subscription_Min_Fields>;
  stddev?: Maybe<Subscription_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Sum_Fields>;
  var_pop?: Maybe<Subscription_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Variance_Fields>;
};


/** aggregate fields of "Subscription" */
export type Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Subscription" */
export type Subscription_Aggregate_Order_By = {
  avg?: InputMaybe<Subscription_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscription_Max_Order_By>;
  min?: InputMaybe<Subscription_Min_Order_By>;
  stddev?: InputMaybe<Subscription_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscription_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscription_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscription_Sum_Order_By>;
  var_pop?: InputMaybe<Subscription_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscription_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscription_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Subscription" */
export type Subscription_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Avg_Fields = {
  __typename?: 'Subscription_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Subscription" */
export type Subscription_Avg_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Subscription". All fields are combined with a logical 'AND'. */
export type Subscription_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  CancelDate?: InputMaybe<Timestamp_Comparison_Exp>;
  CancelReason?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingRegionId?: InputMaybe<Uuid_Comparison_Exp>;
  PublicMessage?: InputMaybe<String_Comparison_Exp>;
  PublicName?: InputMaybe<String_Comparison_Exp>;
  Purchases?: InputMaybe<Purchase_Bool_Exp>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Bool_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  ReceiptEmail?: InputMaybe<String_Comparison_Exp>;
  ReceiptName?: InputMaybe<String_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  State?: InputMaybe<String_Comparison_Exp>;
  StripeSubscriptionId?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  UserId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<Subscription_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Bool_Exp>>;
};

/** unique or primary key constraints on table "Subscription" */
export enum Subscription_Constraint {
  /** unique or primary key constraint on columns "Id" */
  SubscriptionPkey = 'Subscription_pkey'
}

/** input type for incrementing numeric columns in table "Subscription" */
export type Subscription_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "Subscription" */
export type Subscription_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  CancelDate?: InputMaybe<Scalars['timestamp']>;
  CancelReason?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Funder?: InputMaybe<Funder_Obj_Rel_Insert_Input>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingRegionId?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Purchases?: InputMaybe<Purchase_Arr_Rel_Insert_Input>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  State?: InputMaybe<Scalars['String']>;
  StripeSubscriptionId?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Subscription_Max_Fields = {
  __typename?: 'Subscription_max_fields';
  CancelDate?: Maybe<Scalars['timestamp']>;
  CancelReason?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingRegionId?: Maybe<Scalars['uuid']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  StripeSubscriptionId?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "Subscription" */
export type Subscription_Max_Order_By = {
  CancelDate?: InputMaybe<Order_By>;
  CancelReason?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingRegionId?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  StripeSubscriptionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Min_Fields = {
  __typename?: 'Subscription_min_fields';
  CancelDate?: Maybe<Scalars['timestamp']>;
  CancelReason?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingRegionId?: Maybe<Scalars['uuid']>;
  PublicMessage?: Maybe<Scalars['String']>;
  PublicName?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['bigint']>;
  ReceiptEmail?: Maybe<Scalars['String']>;
  ReceiptName?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  StripeSubscriptionId?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  UserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "Subscription" */
export type Subscription_Min_Order_By = {
  CancelDate?: InputMaybe<Order_By>;
  CancelReason?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingRegionId?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  StripeSubscriptionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Subscription" */
export type Subscription_Mutation_Response = {
  __typename?: 'Subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription>;
};

/** input type for inserting object relation for remote table "Subscription" */
export type Subscription_Obj_Rel_Insert_Input = {
  data: Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};

/** on_conflict condition type for table "Subscription" */
export type Subscription_On_Conflict = {
  constraint: Subscription_Constraint;
  update_columns?: Array<Subscription_Update_Column>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "Subscription". */
export type Subscription_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  CancelDate?: InputMaybe<Order_By>;
  CancelReason?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingRegionId?: InputMaybe<Order_By>;
  PublicMessage?: InputMaybe<Order_By>;
  PublicName?: InputMaybe<Order_By>;
  Purchases_aggregate?: InputMaybe<Purchase_Aggregate_Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReceiptEmail?: InputMaybe<Order_By>;
  ReceiptName?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  State?: InputMaybe<Order_By>;
  StripeSubscriptionId?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  UserId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Subscription */
export type Subscription_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Subscription" */
export enum Subscription_Select_Column {
  /** column name */
  CancelDate = 'CancelDate',
  /** column name */
  CancelReason = 'CancelReason',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingRegionId = 'PlantingRegionId',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  State = 'State',
  /** column name */
  StripeSubscriptionId = 'StripeSubscriptionId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

/** input type for updating data in table "Subscription" */
export type Subscription_Set_Input = {
  CancelDate?: InputMaybe<Scalars['timestamp']>;
  CancelReason?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingRegionId?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  StripeSubscriptionId?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Subscription_Stddev_Fields = {
  __typename?: 'Subscription_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Subscription" */
export type Subscription_Stddev_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Stddev_Pop_Fields = {
  __typename?: 'Subscription_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Subscription" */
export type Subscription_Stddev_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Stddev_Samp_Fields = {
  __typename?: 'Subscription_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Subscription" */
export type Subscription_Stddev_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "Subscription" */
export type Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Stream_Cursor_Value_Input = {
  CancelDate?: InputMaybe<Scalars['timestamp']>;
  CancelReason?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingRegionId?: InputMaybe<Scalars['uuid']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  ReceiptEmail?: InputMaybe<Scalars['String']>;
  ReceiptName?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  StripeSubscriptionId?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  UserId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Subscription_Sum_Fields = {
  __typename?: 'Subscription_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "Subscription" */
export type Subscription_Sum_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** update columns of table "Subscription" */
export enum Subscription_Update_Column {
  /** column name */
  CancelDate = 'CancelDate',
  /** column name */
  CancelReason = 'CancelReason',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingRegionId = 'PlantingRegionId',
  /** column name */
  PublicMessage = 'PublicMessage',
  /** column name */
  PublicName = 'PublicName',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReceiptEmail = 'ReceiptEmail',
  /** column name */
  ReceiptName = 'ReceiptName',
  /** column name */
  State = 'State',
  /** column name */
  StripeSubscriptionId = 'StripeSubscriptionId',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  UserId = 'UserId'
}

export type Subscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Set_Input>;
  where: Subscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Var_Pop_Fields = {
  __typename?: 'Subscription_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Subscription" */
export type Subscription_Var_Pop_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Var_Samp_Fields = {
  __typename?: 'Subscription_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Subscription" */
export type Subscription_Var_Samp_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Variance_Fields = {
  __typename?: 'Subscription_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Subscription" */
export type Subscription_Variance_Order_By = {
  Quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "SupportedProjectsView" */
export type SupportedProjectsView = {
  __typename?: 'SupportedProjectsView';
  Area?: Maybe<Scalars['String']>;
  /** An object relationship */
  Funder?: Maybe<Funder>;
  FunderId?: Maybe<Scalars['uuid']>;
  Hero?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  PublicPage?: Maybe<Scalars['Boolean']>;
  Purpose?: Maybe<Scalars['jsonb']>;
  Quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  Region?: Maybe<Region>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SeasonName?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};


/** columns and relationships of "SupportedProjectsView" */
export type SupportedProjectsViewPurposeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "SupportedProjectsView" */
export type SupportedProjectsView_Aggregate = {
  __typename?: 'SupportedProjectsView_aggregate';
  aggregate?: Maybe<SupportedProjectsView_Aggregate_Fields>;
  nodes: Array<SupportedProjectsView>;
};

/** aggregate fields of "SupportedProjectsView" */
export type SupportedProjectsView_Aggregate_Fields = {
  __typename?: 'SupportedProjectsView_aggregate_fields';
  avg?: Maybe<SupportedProjectsView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SupportedProjectsView_Max_Fields>;
  min?: Maybe<SupportedProjectsView_Min_Fields>;
  stddev?: Maybe<SupportedProjectsView_Stddev_Fields>;
  stddev_pop?: Maybe<SupportedProjectsView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SupportedProjectsView_Stddev_Samp_Fields>;
  sum?: Maybe<SupportedProjectsView_Sum_Fields>;
  var_pop?: Maybe<SupportedProjectsView_Var_Pop_Fields>;
  var_samp?: Maybe<SupportedProjectsView_Var_Samp_Fields>;
  variance?: Maybe<SupportedProjectsView_Variance_Fields>;
};


/** aggregate fields of "SupportedProjectsView" */
export type SupportedProjectsView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SupportedProjectsView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SupportedProjectsView_Avg_Fields = {
  __typename?: 'SupportedProjectsView_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "SupportedProjectsView". All fields are combined with a logical 'AND'. */
export type SupportedProjectsView_Bool_Exp = {
  Area?: InputMaybe<String_Comparison_Exp>;
  Funder?: InputMaybe<Funder_Bool_Exp>;
  FunderId?: InputMaybe<Uuid_Comparison_Exp>;
  Hero?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  PublicPage?: InputMaybe<Boolean_Comparison_Exp>;
  Purpose?: InputMaybe<Jsonb_Comparison_Exp>;
  Quantity?: InputMaybe<Numeric_Comparison_Exp>;
  Region?: InputMaybe<Region_Bool_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  SeasonName?: InputMaybe<String_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<SupportedProjectsView_Bool_Exp>>;
  _not?: InputMaybe<SupportedProjectsView_Bool_Exp>;
  _or?: InputMaybe<Array<SupportedProjectsView_Bool_Exp>>;
};

/** aggregate max on columns */
export type SupportedProjectsView_Max_Fields = {
  __typename?: 'SupportedProjectsView_max_fields';
  Area?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Hero?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['numeric']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SeasonName?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SupportedProjectsView_Min_Fields = {
  __typename?: 'SupportedProjectsView_min_fields';
  Area?: Maybe<Scalars['String']>;
  FunderId?: Maybe<Scalars['uuid']>;
  Hero?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['numeric']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  SeasonName?: Maybe<Scalars['String']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "SupportedProjectsView". */
export type SupportedProjectsView_Order_By = {
  Area?: InputMaybe<Order_By>;
  Funder?: InputMaybe<Funder_Order_By>;
  FunderId?: InputMaybe<Order_By>;
  Hero?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  PublicPage?: InputMaybe<Order_By>;
  Purpose?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Region?: InputMaybe<Region_Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  SeasonName?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "SupportedProjectsView" */
export enum SupportedProjectsView_Select_Column {
  /** column name */
  Area = 'Area',
  /** column name */
  FunderId = 'FunderId',
  /** column name */
  Hero = 'Hero',
  /** column name */
  Name = 'Name',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  PublicPage = 'PublicPage',
  /** column name */
  Purpose = 'Purpose',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  SeasonName = 'SeasonName',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type SupportedProjectsView_Stddev_Fields = {
  __typename?: 'SupportedProjectsView_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SupportedProjectsView_Stddev_Pop_Fields = {
  __typename?: 'SupportedProjectsView_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SupportedProjectsView_Stddev_Samp_Fields = {
  __typename?: 'SupportedProjectsView_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "SupportedProjectsView" */
export type SupportedProjectsView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SupportedProjectsView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SupportedProjectsView_Stream_Cursor_Value_Input = {
  Area?: InputMaybe<Scalars['String']>;
  FunderId?: InputMaybe<Scalars['uuid']>;
  Hero?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  PublicPage?: InputMaybe<Scalars['Boolean']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  Quantity?: InputMaybe<Scalars['numeric']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  SeasonName?: InputMaybe<Scalars['String']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SupportedProjectsView_Sum_Fields = {
  __typename?: 'SupportedProjectsView_sum_fields';
  Quantity?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type SupportedProjectsView_Var_Pop_Fields = {
  __typename?: 'SupportedProjectsView_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SupportedProjectsView_Var_Samp_Fields = {
  __typename?: 'SupportedProjectsView_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SupportedProjectsView_Variance_Fields = {
  __typename?: 'SupportedProjectsView_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "TTCPlanting" */
export type TtcPlanting = {
  __typename?: 'TTCPlanting';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  Data_jsonb?: Maybe<Scalars['jsonb']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  Spacing?: Maybe<Scalars['float8']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "TTCPlanting" */
export type TtcPlantingData_JsonbArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "TTCPlanting" */
export type TtcPlanting_Aggregate = {
  __typename?: 'TTCPlanting_aggregate';
  aggregate?: Maybe<TtcPlanting_Aggregate_Fields>;
  nodes: Array<TtcPlanting>;
};

/** aggregate fields of "TTCPlanting" */
export type TtcPlanting_Aggregate_Fields = {
  __typename?: 'TTCPlanting_aggregate_fields';
  avg?: Maybe<TtcPlanting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TtcPlanting_Max_Fields>;
  min?: Maybe<TtcPlanting_Min_Fields>;
  stddev?: Maybe<TtcPlanting_Stddev_Fields>;
  stddev_pop?: Maybe<TtcPlanting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TtcPlanting_Stddev_Samp_Fields>;
  sum?: Maybe<TtcPlanting_Sum_Fields>;
  var_pop?: Maybe<TtcPlanting_Var_Pop_Fields>;
  var_samp?: Maybe<TtcPlanting_Var_Samp_Fields>;
  variance?: Maybe<TtcPlanting_Variance_Fields>;
};


/** aggregate fields of "TTCPlanting" */
export type TtcPlanting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TtcPlanting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TtcPlanting_Append_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type TtcPlanting_Avg_Fields = {
  __typename?: 'TTCPlanting_avg_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "TTCPlanting". All fields are combined with a logical 'AND'. */
export type TtcPlanting_Bool_Exp = {
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  Area?: InputMaybe<Float8_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  Data_jsonb?: InputMaybe<Jsonb_Comparison_Exp>;
  DistrictId?: InputMaybe<Uuid_Comparison_Exp>;
  Geo?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  LandOwnership?: InputMaybe<String_Comparison_Exp>;
  LandUse?: InputMaybe<String_Comparison_Exp>;
  Location?: InputMaybe<String_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Photo?: InputMaybe<String_Comparison_Exp>;
  PlanterId?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingFrom?: InputMaybe<Timestamp_Comparison_Exp>;
  PlantingTo?: InputMaybe<Timestamp_Comparison_Exp>;
  ProjectId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Reference?: InputMaybe<Bigint_Comparison_Exp>;
  RegionId?: InputMaybe<Uuid_Comparison_Exp>;
  SeasonId?: InputMaybe<Uuid_Comparison_Exp>;
  Spacing?: InputMaybe<Float8_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<TtcPlanting_Bool_Exp>>;
  _not?: InputMaybe<TtcPlanting_Bool_Exp>;
  _or?: InputMaybe<Array<TtcPlanting_Bool_Exp>>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TtcPlanting_Delete_At_Path_Input = {
  Data_jsonb?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * delete the array element with specified index (negative integers count from the
 * end). throws an error if top level container is not an array
 */
export type TtcPlanting_Delete_Elem_Input = {
  Data_jsonb?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TtcPlanting_Delete_Key_Input = {
  Data_jsonb?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "TTCPlanting" */
export type TtcPlanting_Inc_Input = {
  Area?: InputMaybe<Scalars['float8']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "TTCPlanting" */
export type TtcPlanting_Insert_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type TtcPlanting_Max_Fields = {
  __typename?: 'TTCPlanting_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  Spacing?: Maybe<Scalars['float8']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type TtcPlanting_Min_Fields = {
  __typename?: 'TTCPlanting_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  Area?: Maybe<Scalars['float8']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DistrictId?: Maybe<Scalars['uuid']>;
  Geo?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  LandOwnership?: Maybe<Scalars['String']>;
  LandUse?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Photo?: Maybe<Scalars['String']>;
  PlanterId?: Maybe<Scalars['uuid']>;
  PlantingFrom?: Maybe<Scalars['timestamp']>;
  PlantingTo?: Maybe<Scalars['timestamp']>;
  ProjectId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  RegionId?: Maybe<Scalars['uuid']>;
  SeasonId?: Maybe<Scalars['uuid']>;
  Spacing?: Maybe<Scalars['float8']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "TTCPlanting" */
export type TtcPlanting_Mutation_Response = {
  __typename?: 'TTCPlanting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TtcPlanting>;
};

/** Ordering options when selecting data from "TTCPlanting". */
export type TtcPlanting_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  Area?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  Data_jsonb?: InputMaybe<Order_By>;
  DistrictId?: InputMaybe<Order_By>;
  Geo?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  LandOwnership?: InputMaybe<Order_By>;
  LandUse?: InputMaybe<Order_By>;
  Location?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Photo?: InputMaybe<Order_By>;
  PlanterId?: InputMaybe<Order_By>;
  PlantingFrom?: InputMaybe<Order_By>;
  PlantingTo?: InputMaybe<Order_By>;
  ProjectId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Reference?: InputMaybe<Order_By>;
  RegionId?: InputMaybe<Order_By>;
  SeasonId?: InputMaybe<Order_By>;
  Spacing?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TtcPlanting_Prepend_Input = {
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "TTCPlanting" */
export enum TtcPlanting_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  Area = 'Area',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DataJsonb = 'Data_jsonb',
  /** column name */
  DistrictId = 'DistrictId',
  /** column name */
  Geo = 'Geo',
  /** column name */
  Id = 'Id',
  /** column name */
  LandOwnership = 'LandOwnership',
  /** column name */
  LandUse = 'LandUse',
  /** column name */
  Location = 'Location',
  /** column name */
  Name = 'Name',
  /** column name */
  Photo = 'Photo',
  /** column name */
  PlanterId = 'PlanterId',
  /** column name */
  PlantingFrom = 'PlantingFrom',
  /** column name */
  PlantingTo = 'PlantingTo',
  /** column name */
  ProjectId = 'ProjectId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Reference = 'Reference',
  /** column name */
  RegionId = 'RegionId',
  /** column name */
  SeasonId = 'SeasonId',
  /** column name */
  Spacing = 'Spacing',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "TTCPlanting" */
export type TtcPlanting_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type TtcPlanting_Stddev_Fields = {
  __typename?: 'TTCPlanting_stddev_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TtcPlanting_Stddev_Pop_Fields = {
  __typename?: 'TTCPlanting_stddev_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TtcPlanting_Stddev_Samp_Fields = {
  __typename?: 'TTCPlanting_stddev_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TTCPlanting" */
export type TtcPlanting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TtcPlanting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TtcPlanting_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  Area?: InputMaybe<Scalars['float8']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  Data_jsonb?: InputMaybe<Scalars['jsonb']>;
  DistrictId?: InputMaybe<Scalars['uuid']>;
  Geo?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  Photo?: InputMaybe<Scalars['String']>;
  PlanterId?: InputMaybe<Scalars['uuid']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  ProjectId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Reference?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['uuid']>;
  SeasonId?: InputMaybe<Scalars['uuid']>;
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type TtcPlanting_Sum_Fields = {
  __typename?: 'TTCPlanting_sum_fields';
  Area?: Maybe<Scalars['float8']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Reference?: Maybe<Scalars['bigint']>;
  Spacing?: Maybe<Scalars['float8']>;
  Type?: Maybe<Scalars['smallint']>;
};

export type TtcPlanting_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TtcPlanting_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TtcPlanting_Delete_At_Path_Input>;
  /**
   * delete the array element with specified index (negative integers count from
   * the end). throws an error if top level container is not an array
   */
  _delete_elem?: InputMaybe<TtcPlanting_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TtcPlanting_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TtcPlanting_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TtcPlanting_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TtcPlanting_Set_Input>;
  where: TtcPlanting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TtcPlanting_Var_Pop_Fields = {
  __typename?: 'TTCPlanting_var_pop_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TtcPlanting_Var_Samp_Fields = {
  __typename?: 'TTCPlanting_var_samp_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TtcPlanting_Variance_Fields = {
  __typename?: 'TTCPlanting_variance_fields';
  Area?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  Reference?: Maybe<Scalars['Float']>;
  Spacing?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "TemplateCategory" */
export type TemplateCategory = {
  __typename?: 'TemplateCategory';
  /** An object relationship */
  GiftCategory: GiftCategory;
  GiftCategoryId: Scalars['uuid'];
  /** An object relationship */
  GiftTemplate: GiftTemplate;
  GiftTemplateId: Scalars['uuid'];
};

/** aggregated selection of "TemplateCategory" */
export type TemplateCategory_Aggregate = {
  __typename?: 'TemplateCategory_aggregate';
  aggregate?: Maybe<TemplateCategory_Aggregate_Fields>;
  nodes: Array<TemplateCategory>;
};

export type TemplateCategory_Aggregate_Bool_Exp = {
  count?: InputMaybe<TemplateCategory_Aggregate_Bool_Exp_Count>;
};

export type TemplateCategory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TemplateCategory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "TemplateCategory" */
export type TemplateCategory_Aggregate_Fields = {
  __typename?: 'TemplateCategory_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TemplateCategory_Max_Fields>;
  min?: Maybe<TemplateCategory_Min_Fields>;
};


/** aggregate fields of "TemplateCategory" */
export type TemplateCategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "TemplateCategory" */
export type TemplateCategory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TemplateCategory_Max_Order_By>;
  min?: InputMaybe<TemplateCategory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "TemplateCategory" */
export type TemplateCategory_Arr_Rel_Insert_Input = {
  data: Array<TemplateCategory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TemplateCategory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "TemplateCategory". All fields are combined with a logical 'AND'. */
export type TemplateCategory_Bool_Exp = {
  GiftCategory?: InputMaybe<GiftCategory_Bool_Exp>;
  GiftCategoryId?: InputMaybe<Uuid_Comparison_Exp>;
  GiftTemplate?: InputMaybe<GiftTemplate_Bool_Exp>;
  GiftTemplateId?: InputMaybe<Uuid_Comparison_Exp>;
  _and?: InputMaybe<Array<TemplateCategory_Bool_Exp>>;
  _not?: InputMaybe<TemplateCategory_Bool_Exp>;
  _or?: InputMaybe<Array<TemplateCategory_Bool_Exp>>;
};

/** unique or primary key constraints on table "TemplateCategory" */
export enum TemplateCategory_Constraint {
  /** unique or primary key constraint on columns "GiftTemplateId", "GiftCategoryId" */
  TemplateCategoryPkey = 'TemplateCategory_pkey'
}

/** input type for inserting data into table "TemplateCategory" */
export type TemplateCategory_Insert_Input = {
  GiftCategory?: InputMaybe<GiftCategory_Obj_Rel_Insert_Input>;
  GiftCategoryId?: InputMaybe<Scalars['uuid']>;
  GiftTemplate?: InputMaybe<GiftTemplate_Obj_Rel_Insert_Input>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TemplateCategory_Max_Fields = {
  __typename?: 'TemplateCategory_max_fields';
  GiftCategoryId?: Maybe<Scalars['uuid']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "TemplateCategory" */
export type TemplateCategory_Max_Order_By = {
  GiftCategoryId?: InputMaybe<Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TemplateCategory_Min_Fields = {
  __typename?: 'TemplateCategory_min_fields';
  GiftCategoryId?: Maybe<Scalars['uuid']>;
  GiftTemplateId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "TemplateCategory" */
export type TemplateCategory_Min_Order_By = {
  GiftCategoryId?: InputMaybe<Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "TemplateCategory" */
export type TemplateCategory_Mutation_Response = {
  __typename?: 'TemplateCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TemplateCategory>;
};

/** on_conflict condition type for table "TemplateCategory" */
export type TemplateCategory_On_Conflict = {
  constraint: TemplateCategory_Constraint;
  update_columns?: Array<TemplateCategory_Update_Column>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};

/** Ordering options when selecting data from "TemplateCategory". */
export type TemplateCategory_Order_By = {
  GiftCategory?: InputMaybe<GiftCategory_Order_By>;
  GiftCategoryId?: InputMaybe<Order_By>;
  GiftTemplate?: InputMaybe<GiftTemplate_Order_By>;
  GiftTemplateId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: TemplateCategory */
export type TemplateCategory_Pk_Columns_Input = {
  GiftCategoryId: Scalars['uuid'];
  GiftTemplateId: Scalars['uuid'];
};

/** select columns of table "TemplateCategory" */
export enum TemplateCategory_Select_Column {
  /** column name */
  GiftCategoryId = 'GiftCategoryId',
  /** column name */
  GiftTemplateId = 'GiftTemplateId'
}

/** input type for updating data in table "TemplateCategory" */
export type TemplateCategory_Set_Input = {
  GiftCategoryId?: InputMaybe<Scalars['uuid']>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "TemplateCategory" */
export type TemplateCategory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TemplateCategory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TemplateCategory_Stream_Cursor_Value_Input = {
  GiftCategoryId?: InputMaybe<Scalars['uuid']>;
  GiftTemplateId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "TemplateCategory" */
export enum TemplateCategory_Update_Column {
  /** column name */
  GiftCategoryId = 'GiftCategoryId',
  /** column name */
  GiftTemplateId = 'GiftTemplateId'
}

export type TemplateCategory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TemplateCategory_Set_Input>;
  where: TemplateCategory_Bool_Exp;
};

/** columns and relationships of "TreeEvent" */
export type TreeEvent = {
  __typename?: 'TreeEvent';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  PlantingId?: Maybe<Scalars['uuid']>;
  PurchaseId: Scalars['uuid'];
  Quantity: Scalars['bigint'];
  Type: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
};

/** aggregated selection of "TreeEvent" */
export type TreeEvent_Aggregate = {
  __typename?: 'TreeEvent_aggregate';
  aggregate?: Maybe<TreeEvent_Aggregate_Fields>;
  nodes: Array<TreeEvent>;
};

/** aggregate fields of "TreeEvent" */
export type TreeEvent_Aggregate_Fields = {
  __typename?: 'TreeEvent_aggregate_fields';
  avg?: Maybe<TreeEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TreeEvent_Max_Fields>;
  min?: Maybe<TreeEvent_Min_Fields>;
  stddev?: Maybe<TreeEvent_Stddev_Fields>;
  stddev_pop?: Maybe<TreeEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TreeEvent_Stddev_Samp_Fields>;
  sum?: Maybe<TreeEvent_Sum_Fields>;
  var_pop?: Maybe<TreeEvent_Var_Pop_Fields>;
  var_samp?: Maybe<TreeEvent_Var_Samp_Fields>;
  variance?: Maybe<TreeEvent_Variance_Fields>;
};


/** aggregate fields of "TreeEvent" */
export type TreeEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TreeEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TreeEvent_Avg_Fields = {
  __typename?: 'TreeEvent_avg_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "TreeEvent". All fields are combined with a logical 'AND'. */
export type TreeEvent_Bool_Exp = {
  ApplicationId?: InputMaybe<Uuid_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  PlantingId?: InputMaybe<Uuid_Comparison_Exp>;
  PurchaseId?: InputMaybe<Uuid_Comparison_Exp>;
  Quantity?: InputMaybe<Bigint_Comparison_Exp>;
  Type?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<TreeEvent_Bool_Exp>>;
  _not?: InputMaybe<TreeEvent_Bool_Exp>;
  _or?: InputMaybe<Array<TreeEvent_Bool_Exp>>;
};

/** unique or primary key constraints on table "TreeEvent" */
export enum TreeEvent_Constraint {
  /** unique or primary key constraint on columns "Id" */
  TreeEventPkey = 'TreeEvent_pkey'
}

/** input type for incrementing numeric columns in table "TreeEvent" */
export type TreeEvent_Inc_Input = {
  Quantity?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "TreeEvent" */
export type TreeEvent_Insert_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type TreeEvent_Max_Fields = {
  __typename?: 'TreeEvent_max_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type TreeEvent_Min_Fields = {
  __typename?: 'TreeEvent_min_fields';
  ApplicationId?: Maybe<Scalars['uuid']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  PlantingId?: Maybe<Scalars['uuid']>;
  PurchaseId?: Maybe<Scalars['uuid']>;
  Quantity?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "TreeEvent" */
export type TreeEvent_Mutation_Response = {
  __typename?: 'TreeEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TreeEvent>;
};

/** on_conflict condition type for table "TreeEvent" */
export type TreeEvent_On_Conflict = {
  constraint: TreeEvent_Constraint;
  update_columns?: Array<TreeEvent_Update_Column>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "TreeEvent". */
export type TreeEvent_Order_By = {
  ApplicationId?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  PlantingId?: InputMaybe<Order_By>;
  PurchaseId?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: TreeEvent */
export type TreeEvent_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "TreeEvent" */
export enum TreeEvent_Select_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "TreeEvent" */
export type TreeEvent_Set_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type TreeEvent_Stddev_Fields = {
  __typename?: 'TreeEvent_stddev_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TreeEvent_Stddev_Pop_Fields = {
  __typename?: 'TreeEvent_stddev_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TreeEvent_Stddev_Samp_Fields = {
  __typename?: 'TreeEvent_stddev_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TreeEvent" */
export type TreeEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TreeEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TreeEvent_Stream_Cursor_Value_Input = {
  ApplicationId?: InputMaybe<Scalars['uuid']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  PlantingId?: InputMaybe<Scalars['uuid']>;
  PurchaseId?: InputMaybe<Scalars['uuid']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  Type?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type TreeEvent_Sum_Fields = {
  __typename?: 'TreeEvent_sum_fields';
  Quantity?: Maybe<Scalars['bigint']>;
  Type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "TreeEvent" */
export enum TreeEvent_Update_Column {
  /** column name */
  ApplicationId = 'ApplicationId',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  PlantingId = 'PlantingId',
  /** column name */
  PurchaseId = 'PurchaseId',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type TreeEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TreeEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TreeEvent_Set_Input>;
  where: TreeEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TreeEvent_Var_Pop_Fields = {
  __typename?: 'TreeEvent_var_pop_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TreeEvent_Var_Samp_Fields = {
  __typename?: 'TreeEvent_var_samp_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TreeEvent_Variance_Fields = {
  __typename?: 'TreeEvent_variance_fields';
  Quantity?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

export enum TreePoolReportState {
  Matched = 'Matched',
  Unmatched = 'Unmatched'
}

export enum TreePoolReportType {
  Application = 'Application',
  Purchase = 'Purchase'
}

/** columns and relationships of "TreePoolStatsView" */
export type TreePoolStatsView = {
  __typename?: 'TreePoolStatsView';
  Applications?: Maybe<Scalars['bigint']>;
  ApplicationsApproved?: Maybe<Scalars['bigint']>;
  Approved?: Maybe<Scalars['bigint']>;
  Funders?: Maybe<Scalars['bigint']>;
  Id?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['bigint']>;
  Name?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['bigint']>;
  TreesMatched?: Maybe<Scalars['bigint']>;
  TreesUnmatched?: Maybe<Scalars['bigint']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "TreePoolStatsView" */
export type TreePoolStatsView_Aggregate = {
  __typename?: 'TreePoolStatsView_aggregate';
  aggregate?: Maybe<TreePoolStatsView_Aggregate_Fields>;
  nodes: Array<TreePoolStatsView>;
};

/** aggregate fields of "TreePoolStatsView" */
export type TreePoolStatsView_Aggregate_Fields = {
  __typename?: 'TreePoolStatsView_aggregate_fields';
  avg?: Maybe<TreePoolStatsView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TreePoolStatsView_Max_Fields>;
  min?: Maybe<TreePoolStatsView_Min_Fields>;
  stddev?: Maybe<TreePoolStatsView_Stddev_Fields>;
  stddev_pop?: Maybe<TreePoolStatsView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TreePoolStatsView_Stddev_Samp_Fields>;
  sum?: Maybe<TreePoolStatsView_Sum_Fields>;
  var_pop?: Maybe<TreePoolStatsView_Var_Pop_Fields>;
  var_samp?: Maybe<TreePoolStatsView_Var_Samp_Fields>;
  variance?: Maybe<TreePoolStatsView_Variance_Fields>;
};


/** aggregate fields of "TreePoolStatsView" */
export type TreePoolStatsView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TreePoolStatsView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TreePoolStatsView_Avg_Fields = {
  __typename?: 'TreePoolStatsView_avg_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "TreePoolStatsView". All fields are combined with a logical 'AND'. */
export type TreePoolStatsView_Bool_Exp = {
  Applications?: InputMaybe<Bigint_Comparison_Exp>;
  ApplicationsApproved?: InputMaybe<Bigint_Comparison_Exp>;
  Approved?: InputMaybe<Bigint_Comparison_Exp>;
  Funders?: InputMaybe<Bigint_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Matched?: InputMaybe<Bigint_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  Total?: InputMaybe<Bigint_Comparison_Exp>;
  TreesMatched?: InputMaybe<Bigint_Comparison_Exp>;
  TreesUnmatched?: InputMaybe<Bigint_Comparison_Exp>;
  Unmatched?: InputMaybe<Bigint_Comparison_Exp>;
  _and?: InputMaybe<Array<TreePoolStatsView_Bool_Exp>>;
  _not?: InputMaybe<TreePoolStatsView_Bool_Exp>;
  _or?: InputMaybe<Array<TreePoolStatsView_Bool_Exp>>;
};

/** aggregate max on columns */
export type TreePoolStatsView_Max_Fields = {
  __typename?: 'TreePoolStatsView_max_fields';
  Applications?: Maybe<Scalars['bigint']>;
  ApplicationsApproved?: Maybe<Scalars['bigint']>;
  Approved?: Maybe<Scalars['bigint']>;
  Funders?: Maybe<Scalars['bigint']>;
  Id?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['bigint']>;
  Name?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['bigint']>;
  TreesMatched?: Maybe<Scalars['bigint']>;
  TreesUnmatched?: Maybe<Scalars['bigint']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TreePoolStatsView_Min_Fields = {
  __typename?: 'TreePoolStatsView_min_fields';
  Applications?: Maybe<Scalars['bigint']>;
  ApplicationsApproved?: Maybe<Scalars['bigint']>;
  Approved?: Maybe<Scalars['bigint']>;
  Funders?: Maybe<Scalars['bigint']>;
  Id?: Maybe<Scalars['uuid']>;
  Matched?: Maybe<Scalars['bigint']>;
  Name?: Maybe<Scalars['String']>;
  Total?: Maybe<Scalars['bigint']>;
  TreesMatched?: Maybe<Scalars['bigint']>;
  TreesUnmatched?: Maybe<Scalars['bigint']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "TreePoolStatsView". */
export type TreePoolStatsView_Order_By = {
  Applications?: InputMaybe<Order_By>;
  ApplicationsApproved?: InputMaybe<Order_By>;
  Approved?: InputMaybe<Order_By>;
  Funders?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Matched?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  Total?: InputMaybe<Order_By>;
  TreesMatched?: InputMaybe<Order_By>;
  TreesUnmatched?: InputMaybe<Order_By>;
  Unmatched?: InputMaybe<Order_By>;
};

/** select columns of table "TreePoolStatsView" */
export enum TreePoolStatsView_Select_Column {
  /** column name */
  Applications = 'Applications',
  /** column name */
  ApplicationsApproved = 'ApplicationsApproved',
  /** column name */
  Approved = 'Approved',
  /** column name */
  Funders = 'Funders',
  /** column name */
  Id = 'Id',
  /** column name */
  Matched = 'Matched',
  /** column name */
  Name = 'Name',
  /** column name */
  Total = 'Total',
  /** column name */
  TreesMatched = 'TreesMatched',
  /** column name */
  TreesUnmatched = 'TreesUnmatched',
  /** column name */
  Unmatched = 'Unmatched'
}

/** aggregate stddev on columns */
export type TreePoolStatsView_Stddev_Fields = {
  __typename?: 'TreePoolStatsView_stddev_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TreePoolStatsView_Stddev_Pop_Fields = {
  __typename?: 'TreePoolStatsView_stddev_pop_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TreePoolStatsView_Stddev_Samp_Fields = {
  __typename?: 'TreePoolStatsView_stddev_samp_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "TreePoolStatsView" */
export type TreePoolStatsView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TreePoolStatsView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TreePoolStatsView_Stream_Cursor_Value_Input = {
  Applications?: InputMaybe<Scalars['bigint']>;
  ApplicationsApproved?: InputMaybe<Scalars['bigint']>;
  Approved?: InputMaybe<Scalars['bigint']>;
  Funders?: InputMaybe<Scalars['bigint']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Matched?: InputMaybe<Scalars['bigint']>;
  Name?: InputMaybe<Scalars['String']>;
  Total?: InputMaybe<Scalars['bigint']>;
  TreesMatched?: InputMaybe<Scalars['bigint']>;
  TreesUnmatched?: InputMaybe<Scalars['bigint']>;
  Unmatched?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TreePoolStatsView_Sum_Fields = {
  __typename?: 'TreePoolStatsView_sum_fields';
  Applications?: Maybe<Scalars['bigint']>;
  ApplicationsApproved?: Maybe<Scalars['bigint']>;
  Approved?: Maybe<Scalars['bigint']>;
  Funders?: Maybe<Scalars['bigint']>;
  Matched?: Maybe<Scalars['bigint']>;
  Total?: Maybe<Scalars['bigint']>;
  TreesMatched?: Maybe<Scalars['bigint']>;
  TreesUnmatched?: Maybe<Scalars['bigint']>;
  Unmatched?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TreePoolStatsView_Var_Pop_Fields = {
  __typename?: 'TreePoolStatsView_var_pop_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TreePoolStatsView_Var_Samp_Fields = {
  __typename?: 'TreePoolStatsView_var_samp_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TreePoolStatsView_Variance_Fields = {
  __typename?: 'TreePoolStatsView_variance_fields';
  Applications?: Maybe<Scalars['Float']>;
  ApplicationsApproved?: Maybe<Scalars['Float']>;
  Approved?: Maybe<Scalars['Float']>;
  Funders?: Maybe<Scalars['Float']>;
  Matched?: Maybe<Scalars['Float']>;
  Total?: Maybe<Scalars['Float']>;
  TreesMatched?: Maybe<Scalars['Float']>;
  TreesUnmatched?: Maybe<Scalars['Float']>;
  Unmatched?: Maybe<Scalars['Float']>;
};

export type UpdateAccountPaymentMethodInput = {
  Id: Scalars['String'];
  PaymentMethodId?: InputMaybe<Scalars['String']>;
  SubscriptionId?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountPaymentMethodOutput = {
  __typename?: 'UpdateAccountPaymentMethodOutput';
  Id: Scalars['String'];
};

export type UpdateAccountSubscriptionInput = {
  Id: Scalars['String'];
  PaymentMethodId?: InputMaybe<Scalars['String']>;
  PlantingRegionId?: InputMaybe<Scalars['String']>;
  PublicMessage?: InputMaybe<Scalars['String']>;
  PublicName?: InputMaybe<Scalars['String']>;
  Quantity?: InputMaybe<Scalars['Int']>;
  ReceiptEmail: Scalars['String'];
  ReceiptName: Scalars['String'];
};

export type UpdateAccountSubscriptionOutput = {
  __typename?: 'UpdateAccountSubscriptionOutput';
  Id: Scalars['String'];
};

export type UpdateApplicationCountsInput = {
  ApplicationId: Scalars['uuid'];
  Approved?: InputMaybe<Scalars['bigint']>;
  Required?: InputMaybe<Scalars['bigint']>;
};

export type UpdateApplicationCountsOutput = {
  __typename?: 'UpdateApplicationCountsOutput';
  Application?: Maybe<Application>;
  ApplicationId: Scalars['uuid'];
};

export type UpdateApplicationSeasonInput = {
  ApplicationId: Scalars['uuid'];
  Season: Scalars['uuid'];
};

export type UpdateApplicationSeasonOutput = {
  __typename?: 'UpdateApplicationSeasonOutput';
  Application?: Maybe<Application>;
  ApplicationId: Scalars['uuid'];
};

export type UpdatePlanterProjectInput = {
  Area: Scalars['String'];
  Description: Scalars['String'];
  DistrictId?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  Hero?: InputMaybe<Scalars['String']>;
  Id: Scalars['String'];
  IsDraft?: InputMaybe<Scalars['Boolean']>;
  LandUse?: InputMaybe<Scalars['jsonb']>;
  LandUseOther?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  NumberOfProperties?: InputMaybe<Scalars['String']>;
  OtherLandArea?: InputMaybe<Scalars['String']>;
  PlantingTimeframes?: InputMaybe<Scalars['String']>;
  Purpose?: InputMaybe<Scalars['jsonb']>;
  RegionId?: InputMaybe<Scalars['String']>;
  WebsiteLinks?: InputMaybe<Scalars['jsonb']>;
};

export type UpdatePlanterProjectOutput = {
  __typename?: 'UpdatePlanterProjectOutput';
  Id: Scalars['String'];
};

export type UpdatePlantingInput = {
  Area?: InputMaybe<Scalars['float8']>;
  Data?: InputMaybe<Scalars['String']>;
  DistrictId?: InputMaybe<Scalars['String']>;
  Geo?: InputMaybe<Scalars['String']>;
  LandOwnership?: InputMaybe<Scalars['String']>;
  LandUse?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<Scalars['String']>;
  Name: Scalars['String'];
  Photo?: InputMaybe<Scalars['String']>;
  PlantingFrom?: InputMaybe<Scalars['timestamp']>;
  PlantingId: Scalars['String'];
  PlantingLines?: InputMaybe<UpdatePlantingPlantinglineArrRelInsertInput>;
  PlantingTo?: InputMaybe<Scalars['timestamp']>;
  Quantity?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['String']>;
  SeasonId: Scalars['String'];
  Spacing?: InputMaybe<Scalars['float8']>;
  Type?: InputMaybe<Scalars['smallint']>;
  VolunteerCount?: InputMaybe<Scalars['bigint']>;
  WorkflowState: Scalars['String'];
};

export type UpdatePlantingOutput = {
  __typename?: 'UpdatePlantingOutput';
  Id: Scalars['String'];
};

export type UpdatePlantingPlantinglineArrRelInsertInput = {
  data: Array<UpdatePlantingPlantinglineInsertInput>;
};

export type UpdatePlantingPlantinglineInsertInput = {
  Id?: InputMaybe<Scalars['String']>;
  OtherSpeciesName?: InputMaybe<Scalars['String']>;
  PlantingId?: InputMaybe<Scalars['String']>;
  Quantity: Scalars['bigint'];
  SpeciesId: Scalars['String'];
};

export type UpdatePurchaseErrorInput = {
  Error: Scalars['String'];
  PurchaseId: Scalars['String'];
  SubscriptionId?: InputMaybe<Scalars['String']>;
};

export type UpdatePurchaseErrorOutput = {
  __typename?: 'UpdatePurchaseErrorOutput';
  PurchaseId: Scalars['String'];
};

export type UpdatePurchasePublicMessageInput = {
  Hash: Scalars['String'];
  Message?: InputMaybe<Scalars['String']>;
  Name?: InputMaybe<Scalars['String']>;
  PurchaseId: Scalars['String'];
};

export type UpdatePurchasePublicMessageOutput = {
  __typename?: 'UpdatePurchasePublicMessageOutput';
  UserEventId?: Maybe<Scalars['String']>;
};

export type UpdatePurchaseRecipientEmailInput = {
  Email: Scalars['String'];
  Id: Scalars['uuid'];
};

export type UpdatePurchaseRecipientEmailOutput = {
  __typename?: 'UpdatePurchaseRecipientEmailOutput';
  Email: Scalars['String'];
  Id: Scalars['uuid'];
};

export type UpsertApplicationInput = {
  AgreeAssetUsage?: InputMaybe<Scalars['Boolean']>;
  DistrictId?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['String']>;
  MainenancePlan?: InputMaybe<Scalars['String']>;
  NumberOfSites?: InputMaybe<Scalars['bigint']>;
  OtherFunding?: InputMaybe<Scalars['String']>;
  PreparationPlan?: InputMaybe<Scalars['String']>;
  ProjectId: Scalars['String'];
  QuantityPlanned?: InputMaybe<Scalars['bigint']>;
  QuantityRequired?: InputMaybe<Scalars['bigint']>;
  RegionId?: InputMaybe<Scalars['String']>;
  ReportMonitoring?: InputMaybe<Scalars['Boolean']>;
  ReportPlanting?: InputMaybe<Scalars['Boolean']>;
  Sites?: InputMaybe<Array<InputMaybe<ApplicationSiteInput>>>;
  TermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  WorkflowState: Scalars['String'];
};

export type UpsertApplicationOutput = {
  __typename?: 'UpsertApplicationOutput';
  Application?: Maybe<Application>;
  Id: Scalars['String'];
};

/** columns and relationships of "User" */
export type User = {
  __typename?: 'User';
  /** An object relationship */
  Account?: Maybe<Account>;
  ActiveAccountId?: Maybe<Scalars['uuid']>;
  ActiveProfileType?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Email: Scalars['String'];
  FirstName: Scalars['String'];
  Id: Scalars['uuid'];
  Identifier?: Maybe<Scalars['String']>;
  LastName: Scalars['String'];
  /** An array relationship */
  Memberships: Array<Membership>;
  /** An aggregate relationship */
  Memberships_aggregate: Membership_Aggregate;
  PrimaryId?: Maybe<Scalars['uuid']>;
  Role: Scalars['smallint'];
  State: Scalars['smallint'];
  UpdatedOn: Scalars['timestamp'];
};


/** columns and relationships of "User" */
export type UserMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


/** columns and relationships of "User" */
export type UserMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};

/** columns and relationships of "UserEvent" */
export type UserEvent = {
  __typename?: 'UserEvent';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn: Scalars['timestamp'];
  Data?: Maybe<Scalars['String']>;
  DefaultAvatarIndex: Scalars['smallint'];
  Description: Scalars['String'];
  Id: Scalars['uuid'];
  Name?: Maybe<Scalars['String']>;
  OwnerId: Scalars['uuid'];
  OwnerType: Scalars['smallint'];
  ReferenceId: Scalars['uuid'];
  ReferenceType: Scalars['Int'];
  Type: Scalars['Int'];
  UpdatedOn: Scalars['timestamp'];
};

/** columns and relationships of "UserEventView" */
export type UserEventView = {
  __typename?: 'UserEventView';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  Description?: Maybe<Scalars['String']>;
  HasSubscriptionId?: Maybe<Scalars['Boolean']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  ProjectName?: Maybe<Scalars['String']>;
  ProjectUri?: Maybe<Scalars['String']>;
  PurchaseType?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['numeric']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  RegistryUri?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregated selection of "UserEventView" */
export type UserEventView_Aggregate = {
  __typename?: 'UserEventView_aggregate';
  aggregate?: Maybe<UserEventView_Aggregate_Fields>;
  nodes: Array<UserEventView>;
};

/** aggregate fields of "UserEventView" */
export type UserEventView_Aggregate_Fields = {
  __typename?: 'UserEventView_aggregate_fields';
  avg?: Maybe<UserEventView_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UserEventView_Max_Fields>;
  min?: Maybe<UserEventView_Min_Fields>;
  stddev?: Maybe<UserEventView_Stddev_Fields>;
  stddev_pop?: Maybe<UserEventView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserEventView_Stddev_Samp_Fields>;
  sum?: Maybe<UserEventView_Sum_Fields>;
  var_pop?: Maybe<UserEventView_Var_Pop_Fields>;
  var_samp?: Maybe<UserEventView_Var_Samp_Fields>;
  variance?: Maybe<UserEventView_Variance_Fields>;
};


/** aggregate fields of "UserEventView" */
export type UserEventView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserEventView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserEventView_Avg_Fields = {
  __typename?: 'UserEventView_avg_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "UserEventView". All fields are combined with a logical 'AND'. */
export type UserEventView_Bool_Exp = {
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Comment?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  DefaultAvatarIndex?: InputMaybe<Smallint_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  HasSubscriptionId?: InputMaybe<Boolean_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerId?: InputMaybe<Uuid_Comparison_Exp>;
  ProjectName?: InputMaybe<String_Comparison_Exp>;
  ProjectUri?: InputMaybe<String_Comparison_Exp>;
  PurchaseType?: InputMaybe<Int_Comparison_Exp>;
  Quantity?: InputMaybe<Numeric_Comparison_Exp>;
  ReferenceId?: InputMaybe<Uuid_Comparison_Exp>;
  ReferenceType?: InputMaybe<Int_Comparison_Exp>;
  RegionName?: InputMaybe<String_Comparison_Exp>;
  RegistryId?: InputMaybe<Uuid_Comparison_Exp>;
  RegistryName?: InputMaybe<String_Comparison_Exp>;
  RegistryUri?: InputMaybe<String_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  Uri?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<UserEventView_Bool_Exp>>;
  _not?: InputMaybe<UserEventView_Bool_Exp>;
  _or?: InputMaybe<Array<UserEventView_Bool_Exp>>;
};

/** aggregate max on columns */
export type UserEventView_Max_Fields = {
  __typename?: 'UserEventView_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  ProjectName?: Maybe<Scalars['String']>;
  ProjectUri?: Maybe<Scalars['String']>;
  PurchaseType?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['numeric']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  RegistryUri?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  Uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserEventView_Min_Fields = {
  __typename?: 'UserEventView_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  ProjectName?: Maybe<Scalars['String']>;
  ProjectUri?: Maybe<Scalars['String']>;
  PurchaseType?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['numeric']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  RegionName?: Maybe<Scalars['String']>;
  RegistryId?: Maybe<Scalars['uuid']>;
  RegistryName?: Maybe<Scalars['String']>;
  RegistryUri?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['Int']>;
  Uri?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "UserEventView". */
export type UserEventView_Order_By = {
  Avatar?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  DefaultAvatarIndex?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  HasSubscriptionId?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerId?: InputMaybe<Order_By>;
  ProjectName?: InputMaybe<Order_By>;
  ProjectUri?: InputMaybe<Order_By>;
  PurchaseType?: InputMaybe<Order_By>;
  Quantity?: InputMaybe<Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  ReferenceType?: InputMaybe<Order_By>;
  RegionName?: InputMaybe<Order_By>;
  RegistryId?: InputMaybe<Order_By>;
  RegistryName?: InputMaybe<Order_By>;
  RegistryUri?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  Uri?: InputMaybe<Order_By>;
};

/** select columns of table "UserEventView" */
export enum UserEventView_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Comment = 'Comment',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  DefaultAvatarIndex = 'DefaultAvatarIndex',
  /** column name */
  Description = 'Description',
  /** column name */
  HasSubscriptionId = 'HasSubscriptionId',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  ProjectName = 'ProjectName',
  /** column name */
  ProjectUri = 'ProjectUri',
  /** column name */
  PurchaseType = 'PurchaseType',
  /** column name */
  Quantity = 'Quantity',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  ReferenceType = 'ReferenceType',
  /** column name */
  RegionName = 'RegionName',
  /** column name */
  RegistryId = 'RegistryId',
  /** column name */
  RegistryName = 'RegistryName',
  /** column name */
  RegistryUri = 'RegistryUri',
  /** column name */
  Type = 'Type',
  /** column name */
  Uri = 'Uri'
}

/** aggregate stddev on columns */
export type UserEventView_Stddev_Fields = {
  __typename?: 'UserEventView_stddev_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserEventView_Stddev_Pop_Fields = {
  __typename?: 'UserEventView_stddev_pop_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserEventView_Stddev_Samp_Fields = {
  __typename?: 'UserEventView_stddev_samp_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "UserEventView" */
export type UserEventView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserEventView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserEventView_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Comment?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  DefaultAvatarIndex?: InputMaybe<Scalars['smallint']>;
  Description?: InputMaybe<Scalars['String']>;
  HasSubscriptionId?: InputMaybe<Scalars['Boolean']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  ProjectName?: InputMaybe<Scalars['String']>;
  ProjectUri?: InputMaybe<Scalars['String']>;
  PurchaseType?: InputMaybe<Scalars['Int']>;
  Quantity?: InputMaybe<Scalars['numeric']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  ReferenceType?: InputMaybe<Scalars['Int']>;
  RegionName?: InputMaybe<Scalars['String']>;
  RegistryId?: InputMaybe<Scalars['uuid']>;
  RegistryName?: InputMaybe<Scalars['String']>;
  RegistryUri?: InputMaybe<Scalars['String']>;
  Type?: InputMaybe<Scalars['Int']>;
  Uri?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserEventView_Sum_Fields = {
  __typename?: 'UserEventView_sum_fields';
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  PurchaseType?: Maybe<Scalars['Int']>;
  Quantity?: Maybe<Scalars['numeric']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type UserEventView_Var_Pop_Fields = {
  __typename?: 'UserEventView_var_pop_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserEventView_Var_Samp_Fields = {
  __typename?: 'UserEventView_var_samp_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserEventView_Variance_Fields = {
  __typename?: 'UserEventView_variance_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  PurchaseType?: Maybe<Scalars['Float']>;
  Quantity?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "UserEvent" */
export type UserEvent_Aggregate = {
  __typename?: 'UserEvent_aggregate';
  aggregate?: Maybe<UserEvent_Aggregate_Fields>;
  nodes: Array<UserEvent>;
};

/** aggregate fields of "UserEvent" */
export type UserEvent_Aggregate_Fields = {
  __typename?: 'UserEvent_aggregate_fields';
  avg?: Maybe<UserEvent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UserEvent_Max_Fields>;
  min?: Maybe<UserEvent_Min_Fields>;
  stddev?: Maybe<UserEvent_Stddev_Fields>;
  stddev_pop?: Maybe<UserEvent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserEvent_Stddev_Samp_Fields>;
  sum?: Maybe<UserEvent_Sum_Fields>;
  var_pop?: Maybe<UserEvent_Var_Pop_Fields>;
  var_samp?: Maybe<UserEvent_Var_Samp_Fields>;
  variance?: Maybe<UserEvent_Variance_Fields>;
};


/** aggregate fields of "UserEvent" */
export type UserEvent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserEvent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserEvent_Avg_Fields = {
  __typename?: 'UserEvent_avg_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "UserEvent". All fields are combined with a logical 'AND'. */
export type UserEvent_Bool_Exp = {
  Avatar?: InputMaybe<String_Comparison_Exp>;
  Comment?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Data?: InputMaybe<String_Comparison_Exp>;
  DefaultAvatarIndex?: InputMaybe<Smallint_Comparison_Exp>;
  Description?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Name?: InputMaybe<String_Comparison_Exp>;
  OwnerId?: InputMaybe<Uuid_Comparison_Exp>;
  OwnerType?: InputMaybe<Smallint_Comparison_Exp>;
  ReferenceId?: InputMaybe<Uuid_Comparison_Exp>;
  ReferenceType?: InputMaybe<Int_Comparison_Exp>;
  Type?: InputMaybe<Int_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<UserEvent_Bool_Exp>>;
  _not?: InputMaybe<UserEvent_Bool_Exp>;
  _or?: InputMaybe<Array<UserEvent_Bool_Exp>>;
};

/** unique or primary key constraints on table "UserEvent" */
export enum UserEvent_Constraint {
  /** unique or primary key constraint on columns "Id" */
  UserEventPkey = 'UserEvent_pkey'
}

/** input type for incrementing numeric columns in table "UserEvent" */
export type UserEvent_Inc_Input = {
  DefaultAvatarIndex?: InputMaybe<Scalars['smallint']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  ReferenceType?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "UserEvent" */
export type UserEvent_Insert_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Comment?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DefaultAvatarIndex?: InputMaybe<Scalars['smallint']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  ReferenceType?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type UserEvent_Max_Fields = {
  __typename?: 'UserEvent_max_fields';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type UserEvent_Min_Fields = {
  __typename?: 'UserEvent_min_fields';
  Avatar?: Maybe<Scalars['String']>;
  Comment?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Data?: Maybe<Scalars['String']>;
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Name?: Maybe<Scalars['String']>;
  OwnerId?: Maybe<Scalars['uuid']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  ReferenceId?: Maybe<Scalars['uuid']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "UserEvent" */
export type UserEvent_Mutation_Response = {
  __typename?: 'UserEvent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserEvent>;
};

/** on_conflict condition type for table "UserEvent" */
export type UserEvent_On_Conflict = {
  constraint: UserEvent_Constraint;
  update_columns?: Array<UserEvent_Update_Column>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};

/** Ordering options when selecting data from "UserEvent". */
export type UserEvent_Order_By = {
  Avatar?: InputMaybe<Order_By>;
  Comment?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Data?: InputMaybe<Order_By>;
  DefaultAvatarIndex?: InputMaybe<Order_By>;
  Description?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Name?: InputMaybe<Order_By>;
  OwnerId?: InputMaybe<Order_By>;
  OwnerType?: InputMaybe<Order_By>;
  ReferenceId?: InputMaybe<Order_By>;
  ReferenceType?: InputMaybe<Order_By>;
  Type?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UserEvent */
export type UserEvent_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "UserEvent" */
export enum UserEvent_Select_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Comment = 'Comment',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DefaultAvatarIndex = 'DefaultAvatarIndex',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  ReferenceType = 'ReferenceType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "UserEvent" */
export type UserEvent_Set_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Comment?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DefaultAvatarIndex?: InputMaybe<Scalars['smallint']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  ReferenceType?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type UserEvent_Stddev_Fields = {
  __typename?: 'UserEvent_stddev_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserEvent_Stddev_Pop_Fields = {
  __typename?: 'UserEvent_stddev_pop_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserEvent_Stddev_Samp_Fields = {
  __typename?: 'UserEvent_stddev_samp_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "UserEvent" */
export type UserEvent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserEvent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserEvent_Stream_Cursor_Value_Input = {
  Avatar?: InputMaybe<Scalars['String']>;
  Comment?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Data?: InputMaybe<Scalars['String']>;
  DefaultAvatarIndex?: InputMaybe<Scalars['smallint']>;
  Description?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Name?: InputMaybe<Scalars['String']>;
  OwnerId?: InputMaybe<Scalars['uuid']>;
  OwnerType?: InputMaybe<Scalars['smallint']>;
  ReferenceId?: InputMaybe<Scalars['uuid']>;
  ReferenceType?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['Int']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type UserEvent_Sum_Fields = {
  __typename?: 'UserEvent_sum_fields';
  DefaultAvatarIndex?: Maybe<Scalars['smallint']>;
  OwnerType?: Maybe<Scalars['smallint']>;
  ReferenceType?: Maybe<Scalars['Int']>;
  Type?: Maybe<Scalars['Int']>;
};

/** update columns of table "UserEvent" */
export enum UserEvent_Update_Column {
  /** column name */
  Avatar = 'Avatar',
  /** column name */
  Comment = 'Comment',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Data = 'Data',
  /** column name */
  DefaultAvatarIndex = 'DefaultAvatarIndex',
  /** column name */
  Description = 'Description',
  /** column name */
  Id = 'Id',
  /** column name */
  Name = 'Name',
  /** column name */
  OwnerId = 'OwnerId',
  /** column name */
  OwnerType = 'OwnerType',
  /** column name */
  ReferenceId = 'ReferenceId',
  /** column name */
  ReferenceType = 'ReferenceType',
  /** column name */
  Type = 'Type',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type UserEvent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserEvent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserEvent_Set_Input>;
  where: UserEvent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserEvent_Var_Pop_Fields = {
  __typename?: 'UserEvent_var_pop_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserEvent_Var_Samp_Fields = {
  __typename?: 'UserEvent_var_samp_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserEvent_Variance_Fields = {
  __typename?: 'UserEvent_variance_fields';
  DefaultAvatarIndex?: Maybe<Scalars['Float']>;
  OwnerType?: Maybe<Scalars['Float']>;
  ReferenceType?: Maybe<Scalars['Float']>;
  Type?: Maybe<Scalars['Float']>;
};

export type UserUpdateInput = {
  FirstName: Scalars['String'];
  LastName: Scalars['String'];
};

/** aggregated selection of "User" */
export type User_Aggregate = {
  __typename?: 'User_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "User" */
export type User_Aggregate_Fields = {
  __typename?: 'User_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "User" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'User_avg_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "User". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  Account?: InputMaybe<Account_Bool_Exp>;
  ActiveAccountId?: InputMaybe<Uuid_Comparison_Exp>;
  ActiveProfileType?: InputMaybe<String_Comparison_Exp>;
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Email?: InputMaybe<String_Comparison_Exp>;
  FirstName?: InputMaybe<String_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Identifier?: InputMaybe<String_Comparison_Exp>;
  LastName?: InputMaybe<String_Comparison_Exp>;
  Memberships?: InputMaybe<Membership_Bool_Exp>;
  Memberships_aggregate?: InputMaybe<Membership_Aggregate_Bool_Exp>;
  PrimaryId?: InputMaybe<Uuid_Comparison_Exp>;
  Role?: InputMaybe<Smallint_Comparison_Exp>;
  State?: InputMaybe<Smallint_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
};

/** unique or primary key constraints on table "User" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "Id" */
  UserPkey = 'User_pkey'
}

/** input type for incrementing numeric columns in table "User" */
export type User_Inc_Input = {
  Role?: InputMaybe<Scalars['smallint']>;
  State?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "User" */
export type User_Insert_Input = {
  Account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  ActiveAccountId?: InputMaybe<Scalars['uuid']>;
  ActiveProfileType?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Memberships?: InputMaybe<Membership_Arr_Rel_Insert_Input>;
  PrimaryId?: InputMaybe<Scalars['uuid']>;
  Role?: InputMaybe<Scalars['smallint']>;
  State?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'User_max_fields';
  ActiveAccountId?: Maybe<Scalars['uuid']>;
  ActiveProfileType?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Email?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Identifier?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  PrimaryId?: Maybe<Scalars['uuid']>;
  Role?: Maybe<Scalars['smallint']>;
  State?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'User_min_fields';
  ActiveAccountId?: Maybe<Scalars['uuid']>;
  ActiveProfileType?: Maybe<Scalars['String']>;
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Email?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['uuid']>;
  Identifier?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  PrimaryId?: Maybe<Scalars['uuid']>;
  Role?: Maybe<Scalars['smallint']>;
  State?: Maybe<Scalars['smallint']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "User" */
export type User_Mutation_Response = {
  __typename?: 'User_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "User" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "User" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "User". */
export type User_Order_By = {
  Account?: InputMaybe<Account_Order_By>;
  ActiveAccountId?: InputMaybe<Order_By>;
  ActiveProfileType?: InputMaybe<Order_By>;
  CreatedOn?: InputMaybe<Order_By>;
  Email?: InputMaybe<Order_By>;
  FirstName?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Identifier?: InputMaybe<Order_By>;
  LastName?: InputMaybe<Order_By>;
  Memberships_aggregate?: InputMaybe<Membership_Aggregate_Order_By>;
  PrimaryId?: InputMaybe<Order_By>;
  Role?: InputMaybe<Order_By>;
  State?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: User */
export type User_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "User" */
export enum User_Select_Column {
  /** column name */
  ActiveAccountId = 'ActiveAccountId',
  /** column name */
  ActiveProfileType = 'ActiveProfileType',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Email = 'Email',
  /** column name */
  FirstName = 'FirstName',
  /** column name */
  Id = 'Id',
  /** column name */
  Identifier = 'Identifier',
  /** column name */
  LastName = 'LastName',
  /** column name */
  PrimaryId = 'PrimaryId',
  /** column name */
  Role = 'Role',
  /** column name */
  State = 'State',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

/** input type for updating data in table "User" */
export type User_Set_Input = {
  ActiveAccountId?: InputMaybe<Scalars['uuid']>;
  ActiveProfileType?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  PrimaryId?: InputMaybe<Scalars['uuid']>;
  Role?: InputMaybe<Scalars['smallint']>;
  State?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'User_stddev_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'User_stddev_pop_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'User_stddev_samp_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "User" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  ActiveAccountId?: InputMaybe<Scalars['uuid']>;
  ActiveProfileType?: InputMaybe<Scalars['String']>;
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Email?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Identifier?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  PrimaryId?: InputMaybe<Scalars['uuid']>;
  Role?: InputMaybe<Scalars['smallint']>;
  State?: InputMaybe<Scalars['smallint']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'User_sum_fields';
  Role?: Maybe<Scalars['smallint']>;
  State?: Maybe<Scalars['smallint']>;
};

/** update columns of table "User" */
export enum User_Update_Column {
  /** column name */
  ActiveAccountId = 'ActiveAccountId',
  /** column name */
  ActiveProfileType = 'ActiveProfileType',
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Email = 'Email',
  /** column name */
  FirstName = 'FirstName',
  /** column name */
  Id = 'Id',
  /** column name */
  Identifier = 'Identifier',
  /** column name */
  LastName = 'LastName',
  /** column name */
  PrimaryId = 'PrimaryId',
  /** column name */
  Role = 'Role',
  /** column name */
  State = 'State',
  /** column name */
  UpdatedOn = 'UpdatedOn'
}

export type User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'User_var_pop_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'User_var_samp_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'User_variance_fields';
  Role?: Maybe<Scalars['Float']>;
  State?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Variable" */
export type Variable = {
  __typename?: 'Variable';
  CreatedOn: Scalars['timestamp'];
  Id: Scalars['uuid'];
  Key: Scalars['String'];
  UpdatedOn: Scalars['timestamp'];
  Value: Scalars['String'];
};

/** aggregated selection of "Variable" */
export type Variable_Aggregate = {
  __typename?: 'Variable_aggregate';
  aggregate?: Maybe<Variable_Aggregate_Fields>;
  nodes: Array<Variable>;
};

/** aggregate fields of "Variable" */
export type Variable_Aggregate_Fields = {
  __typename?: 'Variable_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Variable_Max_Fields>;
  min?: Maybe<Variable_Min_Fields>;
};


/** aggregate fields of "Variable" */
export type Variable_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variable_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Variable". All fields are combined with a logical 'AND'. */
export type Variable_Bool_Exp = {
  CreatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Id?: InputMaybe<Uuid_Comparison_Exp>;
  Key?: InputMaybe<String_Comparison_Exp>;
  UpdatedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  Value?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Variable_Bool_Exp>>;
  _not?: InputMaybe<Variable_Bool_Exp>;
  _or?: InputMaybe<Array<Variable_Bool_Exp>>;
};

/** unique or primary key constraints on table "Variable" */
export enum Variable_Constraint {
  /** unique or primary key constraint on columns "Id" */
  VariablePkey = 'Variable_pkey'
}

/** input type for inserting data into table "Variable" */
export type Variable_Insert_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Key?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Variable_Max_Fields = {
  __typename?: 'Variable_max_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Key?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Variable_Min_Fields = {
  __typename?: 'Variable_min_fields';
  CreatedOn?: Maybe<Scalars['timestamp']>;
  Id?: Maybe<Scalars['uuid']>;
  Key?: Maybe<Scalars['String']>;
  UpdatedOn?: Maybe<Scalars['timestamp']>;
  Value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Variable" */
export type Variable_Mutation_Response = {
  __typename?: 'Variable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variable>;
};

/** on_conflict condition type for table "Variable" */
export type Variable_On_Conflict = {
  constraint: Variable_Constraint;
  update_columns?: Array<Variable_Update_Column>;
  where?: InputMaybe<Variable_Bool_Exp>;
};

/** Ordering options when selecting data from "Variable". */
export type Variable_Order_By = {
  CreatedOn?: InputMaybe<Order_By>;
  Id?: InputMaybe<Order_By>;
  Key?: InputMaybe<Order_By>;
  UpdatedOn?: InputMaybe<Order_By>;
  Value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Variable */
export type Variable_Pk_Columns_Input = {
  Id: Scalars['uuid'];
};

/** select columns of table "Variable" */
export enum Variable_Select_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Key = 'Key',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Value = 'Value'
}

/** input type for updating data in table "Variable" */
export type Variable_Set_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Key?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "Variable" */
export type Variable_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variable_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variable_Stream_Cursor_Value_Input = {
  CreatedOn?: InputMaybe<Scalars['timestamp']>;
  Id?: InputMaybe<Scalars['uuid']>;
  Key?: InputMaybe<Scalars['String']>;
  UpdatedOn?: InputMaybe<Scalars['timestamp']>;
  Value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Variable" */
export enum Variable_Update_Column {
  /** column name */
  CreatedOn = 'CreatedOn',
  /** column name */
  Id = 'Id',
  /** column name */
  Key = 'Key',
  /** column name */
  UpdatedOn = 'UpdatedOn',
  /** column name */
  Value = 'Value'
}

export type Variable_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variable_Set_Input>;
  where: Variable_Bool_Exp;
};

export type VoidPurchaseInput = {
  PurchaseId: Scalars['String'];
};

export type VoidPurchaseOutput = {
  __typename?: 'VoidPurchaseOutput';
  MatchIds: Array<Scalars['String']>;
  Purchase?: Maybe<Purchase>;
  PurchaseId: Scalars['String'];
  TreeEventIds: Array<Scalars['String']>;
};

/** Boolean expression to compare columns of type "_jsonb". All fields are combined with logical 'AND'. */
export type _Jsonb_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_jsonb']>;
  _gt?: InputMaybe<Scalars['_jsonb']>;
  _gte?: InputMaybe<Scalars['_jsonb']>;
  _in?: InputMaybe<Array<Scalars['_jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_jsonb']>;
  _lte?: InputMaybe<Scalars['_jsonb']>;
  _neq?: InputMaybe<Scalars['_jsonb']>;
  _nin?: InputMaybe<Array<Scalars['_jsonb']>>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type GetAccountSupporters_Args = {
  accountId?: InputMaybe<Scalars['uuid']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  accept_invite?: Maybe<AcceptInviteOutput>;
  /** cancel_subscription */
  cancel_subscription?: Maybe<CancelSubscriptionOutput>;
  /** change_user_membership_type */
  change_user_membership_type?: Maybe<ChangeUserMembershipOutput>;
  /** createAccountProfile */
  createAccountProfile?: Maybe<CreateAccountProfileOutput>;
  create_account?: Maybe<CreateAccountOutput>;
  /** Allows for a presigned upload url to be generated to upload publicly accessible assets to S3 */
  create_account_asset: CreateAccountAsset;
  create_accounts_report: CreateAccountsReportOutput;
  create_admin_payment?: Maybe<CreateAdminPaymentOutput>;
  create_application_asset: CreateApplicationAssetOutput;
  create_gift_guest_payment: CreateGiftGuestPaymentOutput;
  /** create_gift_payment */
  create_gift_payment: CreateGiftPaymentOutput;
  create_guest_payment: CreateGuestPaymentOutput;
  /** Creates matches from an application to a set of instructions */
  create_match_from_application: CreateMatchFromApplicationOutput;
  /** Creates matches from an instruction to a set of approved applications */
  create_match_from_instruction: CreateMatchFromInstructionOutput;
  create_monitoring_asset: CreateMonitoringAssetOutput;
  create_payment?: Maybe<CreatePaymentOutput>;
  create_planter_registration?: Maybe<CreatePlanterRegistrationOutput>;
  create_planter_registration_asset?: Maybe<CreatePlanterRegistrationAssetOutput>;
  create_planting?: Maybe<CreatePlantingOutput>;
  create_planting_asset: CreatePlantingAssetOutput;
  create_planting_site_asset: CreatePlantingSiteAssetOutput;
  create_project?: Maybe<CreateProjectOutput>;
  create_project_asset: CreateProjectAssetOutput;
  create_project_hero?: Maybe<CreateProjectHeroOutput>;
  create_project_note_asset: CreateProjectNoteAssetOutput;
  create_purchases_report: CreatePurchasesReportOutput;
  create_registry?: Maybe<CreateRegistryOutput>;
  create_tree_pool_report?: Maybe<CreateTreePoolReportOutput>;
  decline_invite?: Maybe<DeclineInviteOutput>;
  /** delete data from the table: "Account" */
  delete_Account?: Maybe<Account_Mutation_Response>;
  /** delete data from the table: "AccountSupporters" */
  delete_AccountSupporters?: Maybe<AccountSupporters_Mutation_Response>;
  /** delete single row from the table: "Account" */
  delete_Account_by_pk?: Maybe<Account>;
  /** delete data from the table: "ActionNotes" */
  delete_ActionNotes?: Maybe<ActionNotes_Mutation_Response>;
  /** delete single row from the table: "ActionNotes" */
  delete_ActionNotes_by_pk?: Maybe<ActionNotes>;
  /** delete data from the table: "Actual" */
  delete_Actual?: Maybe<Actual_Mutation_Response>;
  /** delete data from the table: "ActualLine" */
  delete_ActualLine?: Maybe<ActualLine_Mutation_Response>;
  /** delete single row from the table: "ActualLine" */
  delete_ActualLine_by_pk?: Maybe<ActualLine>;
  /** delete single row from the table: "Actual" */
  delete_Actual_by_pk?: Maybe<Actual>;
  /** delete data from the table: "Address" */
  delete_Address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "Address" */
  delete_Address_by_pk?: Maybe<Address>;
  /** delete data from the table: "Application" */
  delete_Application?: Maybe<Application_Mutation_Response>;
  /** delete data from the table: "ApplicationAsset" */
  delete_ApplicationAsset?: Maybe<ApplicationAsset_Mutation_Response>;
  /** delete single row from the table: "ApplicationAsset" */
  delete_ApplicationAsset_by_pk?: Maybe<ApplicationAsset>;
  /** delete single row from the table: "Application" */
  delete_Application_by_pk?: Maybe<Application>;
  /** delete data from the table: "Attachment" */
  delete_Attachment?: Maybe<Attachment_Mutation_Response>;
  /** delete single row from the table: "Attachment" */
  delete_Attachment_by_pk?: Maybe<Attachment>;
  /** delete data from the table: "BulkRequest" */
  delete_BulkRequest?: Maybe<BulkRequest_Mutation_Response>;
  /** delete data from the table: "BulkRequestLines" */
  delete_BulkRequestLines?: Maybe<BulkRequestLines_Mutation_Response>;
  /** delete single row from the table: "BulkRequestLines" */
  delete_BulkRequestLines_by_pk?: Maybe<BulkRequestLines>;
  /** delete single row from the table: "BulkRequest" */
  delete_BulkRequest_by_pk?: Maybe<BulkRequest>;
  /** delete data from the table: "ConfigAsset" */
  delete_ConfigAsset?: Maybe<ConfigAsset_Mutation_Response>;
  /** delete single row from the table: "ConfigAsset" */
  delete_ConfigAsset_by_pk?: Maybe<ConfigAsset>;
  /** delete data from the table: "ConfigRedirect" */
  delete_ConfigRedirect?: Maybe<ConfigRedirect_Mutation_Response>;
  /** delete single row from the table: "ConfigRedirect" */
  delete_ConfigRedirect_by_pk?: Maybe<ConfigRedirect>;
  /** delete data from the table: "District" */
  delete_District?: Maybe<District_Mutation_Response>;
  /** delete single row from the table: "District" */
  delete_District_by_pk?: Maybe<District>;
  /** delete data from the table: "Email" */
  delete_Email?: Maybe<Email_Mutation_Response>;
  /** delete single row from the table: "Email" */
  delete_Email_by_pk?: Maybe<Email>;
  /** delete data from the table: "EventPermission" */
  delete_EventPermission?: Maybe<EventPermission_Mutation_Response>;
  /** delete single row from the table: "EventPermission" */
  delete_EventPermission_by_pk?: Maybe<EventPermission>;
  /** delete data from the table: "FundedTree" */
  delete_FundedTree?: Maybe<FundedTree_Mutation_Response>;
  /** delete single row from the table: "FundedTree" */
  delete_FundedTree_by_pk?: Maybe<FundedTree>;
  /** delete data from the table: "Funder" */
  delete_Funder?: Maybe<Funder_Mutation_Response>;
  /** delete data from the table: "FunderStat" */
  delete_FunderStat?: Maybe<FunderStat_Mutation_Response>;
  /** delete single row from the table: "Funder" */
  delete_Funder_by_pk?: Maybe<Funder>;
  /** delete data from the table: "GiftCategory" */
  delete_GiftCategory?: Maybe<GiftCategory_Mutation_Response>;
  /** delete single row from the table: "GiftCategory" */
  delete_GiftCategory_by_pk?: Maybe<GiftCategory>;
  /** delete data from the table: "GiftTemplate" */
  delete_GiftTemplate?: Maybe<GiftTemplate_Mutation_Response>;
  /** delete single row from the table: "GiftTemplate" */
  delete_GiftTemplate_by_pk?: Maybe<GiftTemplate>;
  /** delete data from the table: "GiftedTree" */
  delete_GiftedTree?: Maybe<GiftedTree_Mutation_Response>;
  /** delete single row from the table: "GiftedTree" */
  delete_GiftedTree_by_pk?: Maybe<GiftedTree>;
  /** delete data from the table: "IPLocation" */
  delete_IPLocation?: Maybe<IpLocation_Mutation_Response>;
  /** delete single row from the table: "IPLocation" */
  delete_IPLocation_by_pk?: Maybe<IpLocation>;
  /** delete data from the table: "Instruction" */
  delete_Instruction?: Maybe<Instruction_Mutation_Response>;
  /** delete single row from the table: "Instruction" */
  delete_Instruction_by_pk?: Maybe<Instruction>;
  /** delete data from the table: "Invite" */
  delete_Invite?: Maybe<Invite_Mutation_Response>;
  /** delete single row from the table: "Invite" */
  delete_Invite_by_pk?: Maybe<Invite>;
  /** delete data from the table: "LoginEvent" */
  delete_LoginEvent?: Maybe<LoginEvent_Mutation_Response>;
  /** delete single row from the table: "LoginEvent" */
  delete_LoginEvent_by_pk?: Maybe<LoginEvent>;
  /** delete data from the table: "Match" */
  delete_Match?: Maybe<Match_Mutation_Response>;
  /** delete single row from the table: "Match" */
  delete_Match_by_pk?: Maybe<Match>;
  /** delete data from the table: "Membership" */
  delete_Membership?: Maybe<Membership_Mutation_Response>;
  /** delete single row from the table: "Membership" */
  delete_Membership_by_pk?: Maybe<Membership>;
  /** delete data from the table: "MonitoringAsset" */
  delete_MonitoringAsset?: Maybe<MonitoringAsset_Mutation_Response>;
  /** delete single row from the table: "MonitoringAsset" */
  delete_MonitoringAsset_by_pk?: Maybe<MonitoringAsset>;
  /** delete data from the table: "MonitoringEvent" */
  delete_MonitoringEvent?: Maybe<MonitoringEvent_Mutation_Response>;
  /** delete single row from the table: "MonitoringEvent" */
  delete_MonitoringEvent_by_pk?: Maybe<MonitoringEvent>;
  /** delete data from the table: "MonitoringLine" */
  delete_MonitoringLine?: Maybe<MonitoringLine_Mutation_Response>;
  /** delete single row from the table: "MonitoringLine" */
  delete_MonitoringLine_by_pk?: Maybe<MonitoringLine>;
  /** delete data from the table: "Plan" */
  delete_Plan?: Maybe<Plan_Mutation_Response>;
  /** delete data from the table: "PlanLine" */
  delete_PlanLine?: Maybe<PlanLine_Mutation_Response>;
  /** delete single row from the table: "PlanLine" */
  delete_PlanLine_by_pk?: Maybe<PlanLine>;
  /** delete single row from the table: "Plan" */
  delete_Plan_by_pk?: Maybe<Plan>;
  /** delete data from the table: "Planter" */
  delete_Planter?: Maybe<Planter_Mutation_Response>;
  /** delete data from the table: "PlanterRegistration" */
  delete_PlanterRegistration?: Maybe<PlanterRegistration_Mutation_Response>;
  /** delete data from the table: "PlanterRegistrationAsset" */
  delete_PlanterRegistrationAsset?: Maybe<PlanterRegistrationAsset_Mutation_Response>;
  /** delete single row from the table: "PlanterRegistrationAsset" */
  delete_PlanterRegistrationAsset_by_pk?: Maybe<PlanterRegistrationAsset>;
  /** delete single row from the table: "PlanterRegistration" */
  delete_PlanterRegistration_by_pk?: Maybe<PlanterRegistration>;
  /** delete data from the table: "PlanterStat" */
  delete_PlanterStat?: Maybe<PlanterStat_Mutation_Response>;
  /** delete single row from the table: "Planter" */
  delete_Planter_by_pk?: Maybe<Planter>;
  /** delete data from the table: "Planting" */
  delete_Planting?: Maybe<Planting_Mutation_Response>;
  /** delete data from the table: "PlantingAsset" */
  delete_PlantingAsset?: Maybe<PlantingAsset_Mutation_Response>;
  /** delete single row from the table: "PlantingAsset" */
  delete_PlantingAsset_by_pk?: Maybe<PlantingAsset>;
  /** delete data from the table: "PlantingLine" */
  delete_PlantingLine?: Maybe<PlantingLine_Mutation_Response>;
  /** delete single row from the table: "PlantingLine" */
  delete_PlantingLine_by_pk?: Maybe<PlantingLine>;
  /** delete data from the table: "PlantingSite" */
  delete_PlantingSite?: Maybe<PlantingSite_Mutation_Response>;
  /** delete data from the table: "PlantingSiteAsset" */
  delete_PlantingSiteAsset?: Maybe<PlantingSiteAsset_Mutation_Response>;
  /** delete single row from the table: "PlantingSiteAsset" */
  delete_PlantingSiteAsset_by_pk?: Maybe<PlantingSiteAsset>;
  /** delete single row from the table: "PlantingSite" */
  delete_PlantingSite_by_pk?: Maybe<PlantingSite>;
  /** delete single row from the table: "Planting" */
  delete_Planting_by_pk?: Maybe<Planting>;
  /** delete data from the table: "Product" */
  delete_Product?: Maybe<Product_Mutation_Response>;
  /** delete data from the table: "ProductPrice" */
  delete_ProductPrice?: Maybe<ProductPrice_Mutation_Response>;
  /** delete single row from the table: "ProductPrice" */
  delete_ProductPrice_by_pk?: Maybe<ProductPrice>;
  /** delete single row from the table: "Product" */
  delete_Product_by_pk?: Maybe<Product>;
  /** delete data from the table: "Project" */
  delete_Project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "ProjectAsset" */
  delete_ProjectAsset?: Maybe<ProjectAsset_Mutation_Response>;
  /** delete single row from the table: "ProjectAsset" */
  delete_ProjectAsset_by_pk?: Maybe<ProjectAsset>;
  /** delete data from the table: "ProjectNote" */
  delete_ProjectNote?: Maybe<ProjectNote_Mutation_Response>;
  /** delete data from the table: "ProjectNoteApplication" */
  delete_ProjectNoteApplication?: Maybe<ProjectNoteApplication_Mutation_Response>;
  /** delete single row from the table: "ProjectNoteApplication" */
  delete_ProjectNoteApplication_by_pk?: Maybe<ProjectNoteApplication>;
  /** delete data from the table: "ProjectNoteAsset" */
  delete_ProjectNoteAsset?: Maybe<ProjectNoteAsset_Mutation_Response>;
  /** delete single row from the table: "ProjectNoteAsset" */
  delete_ProjectNoteAsset_by_pk?: Maybe<ProjectNoteAsset>;
  /** delete single row from the table: "ProjectNote" */
  delete_ProjectNote_by_pk?: Maybe<ProjectNote>;
  /** delete single row from the table: "Project" */
  delete_Project_by_pk?: Maybe<Project>;
  /** delete data from the table: "PublicFunderStat" */
  delete_PublicFunderStat?: Maybe<PublicFunderStat_Mutation_Response>;
  /** delete data from the table: "PublicPlanterStat" */
  delete_PublicPlanterStat?: Maybe<PublicPlanterStat_Mutation_Response>;
  /** delete data from the table: "Purchase" */
  delete_Purchase?: Maybe<Purchase_Mutation_Response>;
  /** delete data from the table: "PurchaseEvent" */
  delete_PurchaseEvent?: Maybe<PurchaseEvent_Mutation_Response>;
  /** delete single row from the table: "PurchaseEvent" */
  delete_PurchaseEvent_by_pk?: Maybe<PurchaseEvent>;
  /** delete single row from the table: "Purchase" */
  delete_Purchase_by_pk?: Maybe<Purchase>;
  /** delete data from the table: "Region" */
  delete_Region?: Maybe<Region_Mutation_Response>;
  /** delete data from the table: "RegionDistrict" */
  delete_RegionDistrict?: Maybe<RegionDistrict_Mutation_Response>;
  /** delete single row from the table: "RegionDistrict" */
  delete_RegionDistrict_by_pk?: Maybe<RegionDistrict>;
  /** delete single row from the table: "Region" */
  delete_Region_by_pk?: Maybe<Region>;
  /** delete data from the table: "Registry" */
  delete_Registry?: Maybe<Registry_Mutation_Response>;
  /** delete single row from the table: "Registry" */
  delete_Registry_by_pk?: Maybe<Registry>;
  /** delete data from the table: "Report" */
  delete_Report?: Maybe<Report_Mutation_Response>;
  /** delete single row from the table: "Report" */
  delete_Report_by_pk?: Maybe<Report>;
  /** delete data from the table: "Sample" */
  delete_Sample?: Maybe<Sample_Mutation_Response>;
  /** delete data from the table: "SampleLine" */
  delete_SampleLine?: Maybe<SampleLine_Mutation_Response>;
  /** delete single row from the table: "SampleLine" */
  delete_SampleLine_by_pk?: Maybe<SampleLine>;
  /** delete single row from the table: "Sample" */
  delete_Sample_by_pk?: Maybe<Sample>;
  /** delete data from the table: "ScheduledEmail" */
  delete_ScheduledEmail?: Maybe<ScheduledEmail_Mutation_Response>;
  /** delete single row from the table: "ScheduledEmail" */
  delete_ScheduledEmail_by_pk?: Maybe<ScheduledEmail>;
  /** delete data from the table: "Season" */
  delete_Season?: Maybe<Season_Mutation_Response>;
  /** delete single row from the table: "Season" */
  delete_Season_by_pk?: Maybe<Season>;
  /** delete data from the table: "Species" */
  delete_Species?: Maybe<Species_Mutation_Response>;
  /** delete single row from the table: "Species" */
  delete_Species_by_pk?: Maybe<Species>;
  /** delete data from the table: "Subscription" */
  delete_Subscription?: Maybe<Subscription_Mutation_Response>;
  /** delete single row from the table: "Subscription" */
  delete_Subscription_by_pk?: Maybe<Subscription>;
  /** delete data from the table: "TTCPlanting" */
  delete_TTCPlanting?: Maybe<TtcPlanting_Mutation_Response>;
  /** delete data from the table: "TemplateCategory" */
  delete_TemplateCategory?: Maybe<TemplateCategory_Mutation_Response>;
  /** delete single row from the table: "TemplateCategory" */
  delete_TemplateCategory_by_pk?: Maybe<TemplateCategory>;
  /** delete data from the table: "TreeEvent" */
  delete_TreeEvent?: Maybe<TreeEvent_Mutation_Response>;
  /** delete single row from the table: "TreeEvent" */
  delete_TreeEvent_by_pk?: Maybe<TreeEvent>;
  /** delete data from the table: "User" */
  delete_User?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "UserEvent" */
  delete_UserEvent?: Maybe<UserEvent_Mutation_Response>;
  /** delete single row from the table: "UserEvent" */
  delete_UserEvent_by_pk?: Maybe<UserEvent>;
  /** delete single row from the table: "User" */
  delete_User_by_pk?: Maybe<User>;
  /** delete data from the table: "Variable" */
  delete_Variable?: Maybe<Variable_Mutation_Response>;
  /** delete single row from the table: "Variable" */
  delete_Variable_by_pk?: Maybe<Variable>;
  /** Executes business logic around deleting a match (or matches) */
  delete_matches?: Maybe<DeleteMatchesOutput>;
  /** delete_project */
  delete_project_by_id?: Maybe<DeleteProjectByIdOutput>;
  /** delete_registry_with_no_gifts */
  delete_registry_with_no_gifts: DeleteRegistryWithNoGiftsOutput;
  delete_user_membership?: Maybe<DeleteUserMembershipOutput>;
  generate_put_object_presigned_url?: Maybe<GeneratePutObjectPresignedUrlOutput>;
  import_bulk_gift?: Maybe<ImportBulkGiftOutput>;
  /** insert data into the table: "Account" */
  insert_Account?: Maybe<Account_Mutation_Response>;
  /** insert data into the table: "AccountSupporters" */
  insert_AccountSupporters?: Maybe<AccountSupporters_Mutation_Response>;
  /** insert a single row into the table: "AccountSupporters" */
  insert_AccountSupporters_one?: Maybe<AccountSupporters>;
  /** insert a single row into the table: "Account" */
  insert_Account_one?: Maybe<Account>;
  /** insert data into the table: "ActionNotes" */
  insert_ActionNotes?: Maybe<ActionNotes_Mutation_Response>;
  /** insert a single row into the table: "ActionNotes" */
  insert_ActionNotes_one?: Maybe<ActionNotes>;
  /** insert data into the table: "Actual" */
  insert_Actual?: Maybe<Actual_Mutation_Response>;
  /** insert data into the table: "ActualLine" */
  insert_ActualLine?: Maybe<ActualLine_Mutation_Response>;
  /** insert a single row into the table: "ActualLine" */
  insert_ActualLine_one?: Maybe<ActualLine>;
  /** insert a single row into the table: "Actual" */
  insert_Actual_one?: Maybe<Actual>;
  /** insert data into the table: "Address" */
  insert_Address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "Address" */
  insert_Address_one?: Maybe<Address>;
  /** insert data into the table: "Application" */
  insert_Application?: Maybe<Application_Mutation_Response>;
  /** insert data into the table: "ApplicationAsset" */
  insert_ApplicationAsset?: Maybe<ApplicationAsset_Mutation_Response>;
  /** insert a single row into the table: "ApplicationAsset" */
  insert_ApplicationAsset_one?: Maybe<ApplicationAsset>;
  /** insert a single row into the table: "Application" */
  insert_Application_one?: Maybe<Application>;
  /** insert data into the table: "Attachment" */
  insert_Attachment?: Maybe<Attachment_Mutation_Response>;
  /** insert a single row into the table: "Attachment" */
  insert_Attachment_one?: Maybe<Attachment>;
  /** insert data into the table: "BulkRequest" */
  insert_BulkRequest?: Maybe<BulkRequest_Mutation_Response>;
  /** insert data into the table: "BulkRequestLines" */
  insert_BulkRequestLines?: Maybe<BulkRequestLines_Mutation_Response>;
  /** insert a single row into the table: "BulkRequestLines" */
  insert_BulkRequestLines_one?: Maybe<BulkRequestLines>;
  /** insert a single row into the table: "BulkRequest" */
  insert_BulkRequest_one?: Maybe<BulkRequest>;
  /** insert data into the table: "ConfigAsset" */
  insert_ConfigAsset?: Maybe<ConfigAsset_Mutation_Response>;
  /** insert a single row into the table: "ConfigAsset" */
  insert_ConfigAsset_one?: Maybe<ConfigAsset>;
  /** insert data into the table: "ConfigRedirect" */
  insert_ConfigRedirect?: Maybe<ConfigRedirect_Mutation_Response>;
  /** insert a single row into the table: "ConfigRedirect" */
  insert_ConfigRedirect_one?: Maybe<ConfigRedirect>;
  /** insert data into the table: "District" */
  insert_District?: Maybe<District_Mutation_Response>;
  /** insert a single row into the table: "District" */
  insert_District_one?: Maybe<District>;
  /** insert data into the table: "Email" */
  insert_Email?: Maybe<Email_Mutation_Response>;
  /** insert a single row into the table: "Email" */
  insert_Email_one?: Maybe<Email>;
  /** insert data into the table: "EventPermission" */
  insert_EventPermission?: Maybe<EventPermission_Mutation_Response>;
  /** insert a single row into the table: "EventPermission" */
  insert_EventPermission_one?: Maybe<EventPermission>;
  /** insert data into the table: "FundedTree" */
  insert_FundedTree?: Maybe<FundedTree_Mutation_Response>;
  /** insert a single row into the table: "FundedTree" */
  insert_FundedTree_one?: Maybe<FundedTree>;
  /** insert data into the table: "Funder" */
  insert_Funder?: Maybe<Funder_Mutation_Response>;
  /** insert data into the table: "FunderStat" */
  insert_FunderStat?: Maybe<FunderStat_Mutation_Response>;
  /** insert a single row into the table: "FunderStat" */
  insert_FunderStat_one?: Maybe<FunderStat>;
  /** insert a single row into the table: "Funder" */
  insert_Funder_one?: Maybe<Funder>;
  /** insert data into the table: "GiftCategory" */
  insert_GiftCategory?: Maybe<GiftCategory_Mutation_Response>;
  /** insert a single row into the table: "GiftCategory" */
  insert_GiftCategory_one?: Maybe<GiftCategory>;
  /** insert data into the table: "GiftTemplate" */
  insert_GiftTemplate?: Maybe<GiftTemplate_Mutation_Response>;
  /** insert a single row into the table: "GiftTemplate" */
  insert_GiftTemplate_one?: Maybe<GiftTemplate>;
  /** insert data into the table: "GiftedTree" */
  insert_GiftedTree?: Maybe<GiftedTree_Mutation_Response>;
  /** insert a single row into the table: "GiftedTree" */
  insert_GiftedTree_one?: Maybe<GiftedTree>;
  /** insert data into the table: "IPLocation" */
  insert_IPLocation?: Maybe<IpLocation_Mutation_Response>;
  /** insert a single row into the table: "IPLocation" */
  insert_IPLocation_one?: Maybe<IpLocation>;
  /** insert data into the table: "Instruction" */
  insert_Instruction?: Maybe<Instruction_Mutation_Response>;
  /** insert a single row into the table: "Instruction" */
  insert_Instruction_one?: Maybe<Instruction>;
  /** insert data into the table: "Invite" */
  insert_Invite?: Maybe<Invite_Mutation_Response>;
  /** insert a single row into the table: "Invite" */
  insert_Invite_one?: Maybe<Invite>;
  /** insert data into the table: "LoginEvent" */
  insert_LoginEvent?: Maybe<LoginEvent_Mutation_Response>;
  /** insert a single row into the table: "LoginEvent" */
  insert_LoginEvent_one?: Maybe<LoginEvent>;
  /** insert data into the table: "Match" */
  insert_Match?: Maybe<Match_Mutation_Response>;
  /** insert a single row into the table: "Match" */
  insert_Match_one?: Maybe<Match>;
  /** insert data into the table: "Membership" */
  insert_Membership?: Maybe<Membership_Mutation_Response>;
  /** insert a single row into the table: "Membership" */
  insert_Membership_one?: Maybe<Membership>;
  /** insert data into the table: "MonitoringAsset" */
  insert_MonitoringAsset?: Maybe<MonitoringAsset_Mutation_Response>;
  /** insert a single row into the table: "MonitoringAsset" */
  insert_MonitoringAsset_one?: Maybe<MonitoringAsset>;
  /** insert data into the table: "MonitoringEvent" */
  insert_MonitoringEvent?: Maybe<MonitoringEvent_Mutation_Response>;
  /** insert a single row into the table: "MonitoringEvent" */
  insert_MonitoringEvent_one?: Maybe<MonitoringEvent>;
  /** insert data into the table: "MonitoringLine" */
  insert_MonitoringLine?: Maybe<MonitoringLine_Mutation_Response>;
  /** insert a single row into the table: "MonitoringLine" */
  insert_MonitoringLine_one?: Maybe<MonitoringLine>;
  /** insert data into the table: "Plan" */
  insert_Plan?: Maybe<Plan_Mutation_Response>;
  /** insert data into the table: "PlanLine" */
  insert_PlanLine?: Maybe<PlanLine_Mutation_Response>;
  /** insert a single row into the table: "PlanLine" */
  insert_PlanLine_one?: Maybe<PlanLine>;
  /** insert a single row into the table: "Plan" */
  insert_Plan_one?: Maybe<Plan>;
  /** insert data into the table: "Planter" */
  insert_Planter?: Maybe<Planter_Mutation_Response>;
  /** insert data into the table: "PlanterRegistration" */
  insert_PlanterRegistration?: Maybe<PlanterRegistration_Mutation_Response>;
  /** insert data into the table: "PlanterRegistrationAsset" */
  insert_PlanterRegistrationAsset?: Maybe<PlanterRegistrationAsset_Mutation_Response>;
  /** insert a single row into the table: "PlanterRegistrationAsset" */
  insert_PlanterRegistrationAsset_one?: Maybe<PlanterRegistrationAsset>;
  /** insert a single row into the table: "PlanterRegistration" */
  insert_PlanterRegistration_one?: Maybe<PlanterRegistration>;
  /** insert data into the table: "PlanterStat" */
  insert_PlanterStat?: Maybe<PlanterStat_Mutation_Response>;
  /** insert a single row into the table: "PlanterStat" */
  insert_PlanterStat_one?: Maybe<PlanterStat>;
  /** insert a single row into the table: "Planter" */
  insert_Planter_one?: Maybe<Planter>;
  /** insert data into the table: "Planting" */
  insert_Planting?: Maybe<Planting_Mutation_Response>;
  /** insert data into the table: "PlantingAsset" */
  insert_PlantingAsset?: Maybe<PlantingAsset_Mutation_Response>;
  /** insert a single row into the table: "PlantingAsset" */
  insert_PlantingAsset_one?: Maybe<PlantingAsset>;
  /** insert data into the table: "PlantingLine" */
  insert_PlantingLine?: Maybe<PlantingLine_Mutation_Response>;
  /** insert a single row into the table: "PlantingLine" */
  insert_PlantingLine_one?: Maybe<PlantingLine>;
  /** insert data into the table: "PlantingSite" */
  insert_PlantingSite?: Maybe<PlantingSite_Mutation_Response>;
  /** insert data into the table: "PlantingSiteAsset" */
  insert_PlantingSiteAsset?: Maybe<PlantingSiteAsset_Mutation_Response>;
  /** insert a single row into the table: "PlantingSiteAsset" */
  insert_PlantingSiteAsset_one?: Maybe<PlantingSiteAsset>;
  /** insert a single row into the table: "PlantingSite" */
  insert_PlantingSite_one?: Maybe<PlantingSite>;
  /** insert a single row into the table: "Planting" */
  insert_Planting_one?: Maybe<Planting>;
  /** insert data into the table: "Product" */
  insert_Product?: Maybe<Product_Mutation_Response>;
  /** insert data into the table: "ProductPrice" */
  insert_ProductPrice?: Maybe<ProductPrice_Mutation_Response>;
  /** insert a single row into the table: "ProductPrice" */
  insert_ProductPrice_one?: Maybe<ProductPrice>;
  /** insert a single row into the table: "Product" */
  insert_Product_one?: Maybe<Product>;
  /** insert data into the table: "Project" */
  insert_Project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "ProjectAsset" */
  insert_ProjectAsset?: Maybe<ProjectAsset_Mutation_Response>;
  /** insert a single row into the table: "ProjectAsset" */
  insert_ProjectAsset_one?: Maybe<ProjectAsset>;
  /** insert data into the table: "ProjectNote" */
  insert_ProjectNote?: Maybe<ProjectNote_Mutation_Response>;
  /** insert data into the table: "ProjectNoteApplication" */
  insert_ProjectNoteApplication?: Maybe<ProjectNoteApplication_Mutation_Response>;
  /** insert a single row into the table: "ProjectNoteApplication" */
  insert_ProjectNoteApplication_one?: Maybe<ProjectNoteApplication>;
  /** insert data into the table: "ProjectNoteAsset" */
  insert_ProjectNoteAsset?: Maybe<ProjectNoteAsset_Mutation_Response>;
  /** insert a single row into the table: "ProjectNoteAsset" */
  insert_ProjectNoteAsset_one?: Maybe<ProjectNoteAsset>;
  /** insert a single row into the table: "ProjectNote" */
  insert_ProjectNote_one?: Maybe<ProjectNote>;
  /** insert a single row into the table: "Project" */
  insert_Project_one?: Maybe<Project>;
  /** insert data into the table: "PublicFunderStat" */
  insert_PublicFunderStat?: Maybe<PublicFunderStat_Mutation_Response>;
  /** insert a single row into the table: "PublicFunderStat" */
  insert_PublicFunderStat_one?: Maybe<PublicFunderStat>;
  /** insert data into the table: "PublicPlanterStat" */
  insert_PublicPlanterStat?: Maybe<PublicPlanterStat_Mutation_Response>;
  /** insert a single row into the table: "PublicPlanterStat" */
  insert_PublicPlanterStat_one?: Maybe<PublicPlanterStat>;
  /** insert data into the table: "Purchase" */
  insert_Purchase?: Maybe<Purchase_Mutation_Response>;
  /** insert data into the table: "PurchaseEvent" */
  insert_PurchaseEvent?: Maybe<PurchaseEvent_Mutation_Response>;
  /** insert a single row into the table: "PurchaseEvent" */
  insert_PurchaseEvent_one?: Maybe<PurchaseEvent>;
  /** insert a single row into the table: "Purchase" */
  insert_Purchase_one?: Maybe<Purchase>;
  /** insert data into the table: "Region" */
  insert_Region?: Maybe<Region_Mutation_Response>;
  /** insert data into the table: "RegionDistrict" */
  insert_RegionDistrict?: Maybe<RegionDistrict_Mutation_Response>;
  /** insert a single row into the table: "RegionDistrict" */
  insert_RegionDistrict_one?: Maybe<RegionDistrict>;
  /** insert a single row into the table: "Region" */
  insert_Region_one?: Maybe<Region>;
  /** insert data into the table: "Registry" */
  insert_Registry?: Maybe<Registry_Mutation_Response>;
  /** insert a single row into the table: "Registry" */
  insert_Registry_one?: Maybe<Registry>;
  /** insert data into the table: "Report" */
  insert_Report?: Maybe<Report_Mutation_Response>;
  /** insert a single row into the table: "Report" */
  insert_Report_one?: Maybe<Report>;
  /** insert data into the table: "Sample" */
  insert_Sample?: Maybe<Sample_Mutation_Response>;
  /** insert data into the table: "SampleLine" */
  insert_SampleLine?: Maybe<SampleLine_Mutation_Response>;
  /** insert a single row into the table: "SampleLine" */
  insert_SampleLine_one?: Maybe<SampleLine>;
  /** insert a single row into the table: "Sample" */
  insert_Sample_one?: Maybe<Sample>;
  /** insert data into the table: "ScheduledEmail" */
  insert_ScheduledEmail?: Maybe<ScheduledEmail_Mutation_Response>;
  /** insert a single row into the table: "ScheduledEmail" */
  insert_ScheduledEmail_one?: Maybe<ScheduledEmail>;
  /** insert data into the table: "Season" */
  insert_Season?: Maybe<Season_Mutation_Response>;
  /** insert a single row into the table: "Season" */
  insert_Season_one?: Maybe<Season>;
  /** insert data into the table: "Species" */
  insert_Species?: Maybe<Species_Mutation_Response>;
  /** insert a single row into the table: "Species" */
  insert_Species_one?: Maybe<Species>;
  /** insert data into the table: "Subscription" */
  insert_Subscription?: Maybe<Subscription_Mutation_Response>;
  /** insert a single row into the table: "Subscription" */
  insert_Subscription_one?: Maybe<Subscription>;
  /** insert data into the table: "TTCPlanting" */
  insert_TTCPlanting?: Maybe<TtcPlanting_Mutation_Response>;
  /** insert a single row into the table: "TTCPlanting" */
  insert_TTCPlanting_one?: Maybe<TtcPlanting>;
  /** insert data into the table: "TemplateCategory" */
  insert_TemplateCategory?: Maybe<TemplateCategory_Mutation_Response>;
  /** insert a single row into the table: "TemplateCategory" */
  insert_TemplateCategory_one?: Maybe<TemplateCategory>;
  /** insert data into the table: "TreeEvent" */
  insert_TreeEvent?: Maybe<TreeEvent_Mutation_Response>;
  /** insert a single row into the table: "TreeEvent" */
  insert_TreeEvent_one?: Maybe<TreeEvent>;
  /** insert data into the table: "User" */
  insert_User?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "UserEvent" */
  insert_UserEvent?: Maybe<UserEvent_Mutation_Response>;
  /** insert a single row into the table: "UserEvent" */
  insert_UserEvent_one?: Maybe<UserEvent>;
  /** insert a single row into the table: "User" */
  insert_User_one?: Maybe<User>;
  /** insert data into the table: "Variable" */
  insert_Variable?: Maybe<Variable_Mutation_Response>;
  /** insert a single row into the table: "Variable" */
  insert_Variable_one?: Maybe<Variable>;
  process_purchase?: Maybe<ProcessPurchaseOutput>;
  regenerate_pdf: RegeneratePdfOutput;
  resend_gift_certificate?: Maybe<ResendGiftCertificateOutput>;
  /** update data of the table: "Account" */
  update_Account?: Maybe<Account_Mutation_Response>;
  /** update data of the table: "AccountSupporters" */
  update_AccountSupporters?: Maybe<AccountSupporters_Mutation_Response>;
  /** update multiples rows of table: "AccountSupporters" */
  update_AccountSupporters_many?: Maybe<Array<Maybe<AccountSupporters_Mutation_Response>>>;
  /** update single row of the table: "Account" */
  update_Account_by_pk?: Maybe<Account>;
  /** update multiples rows of table: "Account" */
  update_Account_many?: Maybe<Array<Maybe<Account_Mutation_Response>>>;
  /** update data of the table: "ActionNotes" */
  update_ActionNotes?: Maybe<ActionNotes_Mutation_Response>;
  /** update single row of the table: "ActionNotes" */
  update_ActionNotes_by_pk?: Maybe<ActionNotes>;
  /** update multiples rows of table: "ActionNotes" */
  update_ActionNotes_many?: Maybe<Array<Maybe<ActionNotes_Mutation_Response>>>;
  /** update data of the table: "Actual" */
  update_Actual?: Maybe<Actual_Mutation_Response>;
  /** update data of the table: "ActualLine" */
  update_ActualLine?: Maybe<ActualLine_Mutation_Response>;
  /** update single row of the table: "ActualLine" */
  update_ActualLine_by_pk?: Maybe<ActualLine>;
  /** update multiples rows of table: "ActualLine" */
  update_ActualLine_many?: Maybe<Array<Maybe<ActualLine_Mutation_Response>>>;
  /** update single row of the table: "Actual" */
  update_Actual_by_pk?: Maybe<Actual>;
  /** update multiples rows of table: "Actual" */
  update_Actual_many?: Maybe<Array<Maybe<Actual_Mutation_Response>>>;
  /** update data of the table: "Address" */
  update_Address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "Address" */
  update_Address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "Address" */
  update_Address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "Application" */
  update_Application?: Maybe<Application_Mutation_Response>;
  /** update data of the table: "ApplicationAsset" */
  update_ApplicationAsset?: Maybe<ApplicationAsset_Mutation_Response>;
  /** update single row of the table: "ApplicationAsset" */
  update_ApplicationAsset_by_pk?: Maybe<ApplicationAsset>;
  /** update multiples rows of table: "ApplicationAsset" */
  update_ApplicationAsset_many?: Maybe<Array<Maybe<ApplicationAsset_Mutation_Response>>>;
  /** update single row of the table: "Application" */
  update_Application_by_pk?: Maybe<Application>;
  /** update multiples rows of table: "Application" */
  update_Application_many?: Maybe<Array<Maybe<Application_Mutation_Response>>>;
  /** update data of the table: "Attachment" */
  update_Attachment?: Maybe<Attachment_Mutation_Response>;
  /** update single row of the table: "Attachment" */
  update_Attachment_by_pk?: Maybe<Attachment>;
  /** update multiples rows of table: "Attachment" */
  update_Attachment_many?: Maybe<Array<Maybe<Attachment_Mutation_Response>>>;
  /** update data of the table: "BulkRequest" */
  update_BulkRequest?: Maybe<BulkRequest_Mutation_Response>;
  /** update data of the table: "BulkRequestLines" */
  update_BulkRequestLines?: Maybe<BulkRequestLines_Mutation_Response>;
  /** update single row of the table: "BulkRequestLines" */
  update_BulkRequestLines_by_pk?: Maybe<BulkRequestLines>;
  /** update multiples rows of table: "BulkRequestLines" */
  update_BulkRequestLines_many?: Maybe<Array<Maybe<BulkRequestLines_Mutation_Response>>>;
  /** update single row of the table: "BulkRequest" */
  update_BulkRequest_by_pk?: Maybe<BulkRequest>;
  /** update multiples rows of table: "BulkRequest" */
  update_BulkRequest_many?: Maybe<Array<Maybe<BulkRequest_Mutation_Response>>>;
  /** update data of the table: "ConfigAsset" */
  update_ConfigAsset?: Maybe<ConfigAsset_Mutation_Response>;
  /** update single row of the table: "ConfigAsset" */
  update_ConfigAsset_by_pk?: Maybe<ConfigAsset>;
  /** update multiples rows of table: "ConfigAsset" */
  update_ConfigAsset_many?: Maybe<Array<Maybe<ConfigAsset_Mutation_Response>>>;
  /** update data of the table: "ConfigRedirect" */
  update_ConfigRedirect?: Maybe<ConfigRedirect_Mutation_Response>;
  /** update single row of the table: "ConfigRedirect" */
  update_ConfigRedirect_by_pk?: Maybe<ConfigRedirect>;
  /** update multiples rows of table: "ConfigRedirect" */
  update_ConfigRedirect_many?: Maybe<Array<Maybe<ConfigRedirect_Mutation_Response>>>;
  /** update data of the table: "District" */
  update_District?: Maybe<District_Mutation_Response>;
  /** update single row of the table: "District" */
  update_District_by_pk?: Maybe<District>;
  /** update multiples rows of table: "District" */
  update_District_many?: Maybe<Array<Maybe<District_Mutation_Response>>>;
  /** update data of the table: "Email" */
  update_Email?: Maybe<Email_Mutation_Response>;
  /** update single row of the table: "Email" */
  update_Email_by_pk?: Maybe<Email>;
  /** update multiples rows of table: "Email" */
  update_Email_many?: Maybe<Array<Maybe<Email_Mutation_Response>>>;
  /** update data of the table: "EventPermission" */
  update_EventPermission?: Maybe<EventPermission_Mutation_Response>;
  /** update single row of the table: "EventPermission" */
  update_EventPermission_by_pk?: Maybe<EventPermission>;
  /** update multiples rows of table: "EventPermission" */
  update_EventPermission_many?: Maybe<Array<Maybe<EventPermission_Mutation_Response>>>;
  /** update data of the table: "FundedTree" */
  update_FundedTree?: Maybe<FundedTree_Mutation_Response>;
  /** update single row of the table: "FundedTree" */
  update_FundedTree_by_pk?: Maybe<FundedTree>;
  /** update multiples rows of table: "FundedTree" */
  update_FundedTree_many?: Maybe<Array<Maybe<FundedTree_Mutation_Response>>>;
  /** update data of the table: "Funder" */
  update_Funder?: Maybe<Funder_Mutation_Response>;
  /** update data of the table: "FunderStat" */
  update_FunderStat?: Maybe<FunderStat_Mutation_Response>;
  /** update multiples rows of table: "FunderStat" */
  update_FunderStat_many?: Maybe<Array<Maybe<FunderStat_Mutation_Response>>>;
  /** update single row of the table: "Funder" */
  update_Funder_by_pk?: Maybe<Funder>;
  /** update multiples rows of table: "Funder" */
  update_Funder_many?: Maybe<Array<Maybe<Funder_Mutation_Response>>>;
  /** update data of the table: "GiftCategory" */
  update_GiftCategory?: Maybe<GiftCategory_Mutation_Response>;
  /** update single row of the table: "GiftCategory" */
  update_GiftCategory_by_pk?: Maybe<GiftCategory>;
  /** update multiples rows of table: "GiftCategory" */
  update_GiftCategory_many?: Maybe<Array<Maybe<GiftCategory_Mutation_Response>>>;
  /** update data of the table: "GiftTemplate" */
  update_GiftTemplate?: Maybe<GiftTemplate_Mutation_Response>;
  /** update single row of the table: "GiftTemplate" */
  update_GiftTemplate_by_pk?: Maybe<GiftTemplate>;
  /** update multiples rows of table: "GiftTemplate" */
  update_GiftTemplate_many?: Maybe<Array<Maybe<GiftTemplate_Mutation_Response>>>;
  /** update data of the table: "GiftedTree" */
  update_GiftedTree?: Maybe<GiftedTree_Mutation_Response>;
  /** update single row of the table: "GiftedTree" */
  update_GiftedTree_by_pk?: Maybe<GiftedTree>;
  /** update multiples rows of table: "GiftedTree" */
  update_GiftedTree_many?: Maybe<Array<Maybe<GiftedTree_Mutation_Response>>>;
  /** update data of the table: "IPLocation" */
  update_IPLocation?: Maybe<IpLocation_Mutation_Response>;
  /** update single row of the table: "IPLocation" */
  update_IPLocation_by_pk?: Maybe<IpLocation>;
  /** update multiples rows of table: "IPLocation" */
  update_IPLocation_many?: Maybe<Array<Maybe<IpLocation_Mutation_Response>>>;
  /** update data of the table: "Instruction" */
  update_Instruction?: Maybe<Instruction_Mutation_Response>;
  /** update single row of the table: "Instruction" */
  update_Instruction_by_pk?: Maybe<Instruction>;
  /** update multiples rows of table: "Instruction" */
  update_Instruction_many?: Maybe<Array<Maybe<Instruction_Mutation_Response>>>;
  /** update data of the table: "Invite" */
  update_Invite?: Maybe<Invite_Mutation_Response>;
  /** update single row of the table: "Invite" */
  update_Invite_by_pk?: Maybe<Invite>;
  /** update multiples rows of table: "Invite" */
  update_Invite_many?: Maybe<Array<Maybe<Invite_Mutation_Response>>>;
  /** update data of the table: "LoginEvent" */
  update_LoginEvent?: Maybe<LoginEvent_Mutation_Response>;
  /** update single row of the table: "LoginEvent" */
  update_LoginEvent_by_pk?: Maybe<LoginEvent>;
  /** update multiples rows of table: "LoginEvent" */
  update_LoginEvent_many?: Maybe<Array<Maybe<LoginEvent_Mutation_Response>>>;
  /** update data of the table: "Match" */
  update_Match?: Maybe<Match_Mutation_Response>;
  /** update single row of the table: "Match" */
  update_Match_by_pk?: Maybe<Match>;
  /** update multiples rows of table: "Match" */
  update_Match_many?: Maybe<Array<Maybe<Match_Mutation_Response>>>;
  /** update data of the table: "Membership" */
  update_Membership?: Maybe<Membership_Mutation_Response>;
  /** update single row of the table: "Membership" */
  update_Membership_by_pk?: Maybe<Membership>;
  /** update multiples rows of table: "Membership" */
  update_Membership_many?: Maybe<Array<Maybe<Membership_Mutation_Response>>>;
  /** update data of the table: "MonitoringAsset" */
  update_MonitoringAsset?: Maybe<MonitoringAsset_Mutation_Response>;
  /** update single row of the table: "MonitoringAsset" */
  update_MonitoringAsset_by_pk?: Maybe<MonitoringAsset>;
  /** update multiples rows of table: "MonitoringAsset" */
  update_MonitoringAsset_many?: Maybe<Array<Maybe<MonitoringAsset_Mutation_Response>>>;
  /** update data of the table: "MonitoringEvent" */
  update_MonitoringEvent?: Maybe<MonitoringEvent_Mutation_Response>;
  /** update single row of the table: "MonitoringEvent" */
  update_MonitoringEvent_by_pk?: Maybe<MonitoringEvent>;
  /** update multiples rows of table: "MonitoringEvent" */
  update_MonitoringEvent_many?: Maybe<Array<Maybe<MonitoringEvent_Mutation_Response>>>;
  /** update data of the table: "MonitoringLine" */
  update_MonitoringLine?: Maybe<MonitoringLine_Mutation_Response>;
  /** update single row of the table: "MonitoringLine" */
  update_MonitoringLine_by_pk?: Maybe<MonitoringLine>;
  /** update multiples rows of table: "MonitoringLine" */
  update_MonitoringLine_many?: Maybe<Array<Maybe<MonitoringLine_Mutation_Response>>>;
  /** update data of the table: "Plan" */
  update_Plan?: Maybe<Plan_Mutation_Response>;
  /** update data of the table: "PlanLine" */
  update_PlanLine?: Maybe<PlanLine_Mutation_Response>;
  /** update single row of the table: "PlanLine" */
  update_PlanLine_by_pk?: Maybe<PlanLine>;
  /** update multiples rows of table: "PlanLine" */
  update_PlanLine_many?: Maybe<Array<Maybe<PlanLine_Mutation_Response>>>;
  /** update single row of the table: "Plan" */
  update_Plan_by_pk?: Maybe<Plan>;
  /** update multiples rows of table: "Plan" */
  update_Plan_many?: Maybe<Array<Maybe<Plan_Mutation_Response>>>;
  /** update data of the table: "Planter" */
  update_Planter?: Maybe<Planter_Mutation_Response>;
  /** update data of the table: "PlanterRegistration" */
  update_PlanterRegistration?: Maybe<PlanterRegistration_Mutation_Response>;
  /** update data of the table: "PlanterRegistrationAsset" */
  update_PlanterRegistrationAsset?: Maybe<PlanterRegistrationAsset_Mutation_Response>;
  /** update single row of the table: "PlanterRegistrationAsset" */
  update_PlanterRegistrationAsset_by_pk?: Maybe<PlanterRegistrationAsset>;
  /** update multiples rows of table: "PlanterRegistrationAsset" */
  update_PlanterRegistrationAsset_many?: Maybe<Array<Maybe<PlanterRegistrationAsset_Mutation_Response>>>;
  /** update single row of the table: "PlanterRegistration" */
  update_PlanterRegistration_by_pk?: Maybe<PlanterRegistration>;
  /** update multiples rows of table: "PlanterRegistration" */
  update_PlanterRegistration_many?: Maybe<Array<Maybe<PlanterRegistration_Mutation_Response>>>;
  /** update data of the table: "PlanterStat" */
  update_PlanterStat?: Maybe<PlanterStat_Mutation_Response>;
  /** update multiples rows of table: "PlanterStat" */
  update_PlanterStat_many?: Maybe<Array<Maybe<PlanterStat_Mutation_Response>>>;
  /** update single row of the table: "Planter" */
  update_Planter_by_pk?: Maybe<Planter>;
  /** update multiples rows of table: "Planter" */
  update_Planter_many?: Maybe<Array<Maybe<Planter_Mutation_Response>>>;
  /** update data of the table: "Planting" */
  update_Planting?: Maybe<Planting_Mutation_Response>;
  /** update data of the table: "PlantingAsset" */
  update_PlantingAsset?: Maybe<PlantingAsset_Mutation_Response>;
  /** update single row of the table: "PlantingAsset" */
  update_PlantingAsset_by_pk?: Maybe<PlantingAsset>;
  /** update multiples rows of table: "PlantingAsset" */
  update_PlantingAsset_many?: Maybe<Array<Maybe<PlantingAsset_Mutation_Response>>>;
  /** update data of the table: "PlantingLine" */
  update_PlantingLine?: Maybe<PlantingLine_Mutation_Response>;
  /** update single row of the table: "PlantingLine" */
  update_PlantingLine_by_pk?: Maybe<PlantingLine>;
  /** update multiples rows of table: "PlantingLine" */
  update_PlantingLine_many?: Maybe<Array<Maybe<PlantingLine_Mutation_Response>>>;
  /** update data of the table: "PlantingSite" */
  update_PlantingSite?: Maybe<PlantingSite_Mutation_Response>;
  /** update data of the table: "PlantingSiteAsset" */
  update_PlantingSiteAsset?: Maybe<PlantingSiteAsset_Mutation_Response>;
  /** update single row of the table: "PlantingSiteAsset" */
  update_PlantingSiteAsset_by_pk?: Maybe<PlantingSiteAsset>;
  /** update multiples rows of table: "PlantingSiteAsset" */
  update_PlantingSiteAsset_many?: Maybe<Array<Maybe<PlantingSiteAsset_Mutation_Response>>>;
  /** update single row of the table: "PlantingSite" */
  update_PlantingSite_by_pk?: Maybe<PlantingSite>;
  /** update multiples rows of table: "PlantingSite" */
  update_PlantingSite_many?: Maybe<Array<Maybe<PlantingSite_Mutation_Response>>>;
  /** update single row of the table: "Planting" */
  update_Planting_by_pk?: Maybe<Planting>;
  /** update multiples rows of table: "Planting" */
  update_Planting_many?: Maybe<Array<Maybe<Planting_Mutation_Response>>>;
  /** update data of the table: "Product" */
  update_Product?: Maybe<Product_Mutation_Response>;
  /** update data of the table: "ProductPrice" */
  update_ProductPrice?: Maybe<ProductPrice_Mutation_Response>;
  /** update single row of the table: "ProductPrice" */
  update_ProductPrice_by_pk?: Maybe<ProductPrice>;
  /** update multiples rows of table: "ProductPrice" */
  update_ProductPrice_many?: Maybe<Array<Maybe<ProductPrice_Mutation_Response>>>;
  /** update single row of the table: "Product" */
  update_Product_by_pk?: Maybe<Product>;
  /** update multiples rows of table: "Product" */
  update_Product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "Project" */
  update_Project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "ProjectAsset" */
  update_ProjectAsset?: Maybe<ProjectAsset_Mutation_Response>;
  /** update single row of the table: "ProjectAsset" */
  update_ProjectAsset_by_pk?: Maybe<ProjectAsset>;
  /** update multiples rows of table: "ProjectAsset" */
  update_ProjectAsset_many?: Maybe<Array<Maybe<ProjectAsset_Mutation_Response>>>;
  /** update data of the table: "ProjectNote" */
  update_ProjectNote?: Maybe<ProjectNote_Mutation_Response>;
  /** update data of the table: "ProjectNoteApplication" */
  update_ProjectNoteApplication?: Maybe<ProjectNoteApplication_Mutation_Response>;
  /** update single row of the table: "ProjectNoteApplication" */
  update_ProjectNoteApplication_by_pk?: Maybe<ProjectNoteApplication>;
  /** update multiples rows of table: "ProjectNoteApplication" */
  update_ProjectNoteApplication_many?: Maybe<Array<Maybe<ProjectNoteApplication_Mutation_Response>>>;
  /** update data of the table: "ProjectNoteAsset" */
  update_ProjectNoteAsset?: Maybe<ProjectNoteAsset_Mutation_Response>;
  /** update single row of the table: "ProjectNoteAsset" */
  update_ProjectNoteAsset_by_pk?: Maybe<ProjectNoteAsset>;
  /** update multiples rows of table: "ProjectNoteAsset" */
  update_ProjectNoteAsset_many?: Maybe<Array<Maybe<ProjectNoteAsset_Mutation_Response>>>;
  /** update single row of the table: "ProjectNote" */
  update_ProjectNote_by_pk?: Maybe<ProjectNote>;
  /** update multiples rows of table: "ProjectNote" */
  update_ProjectNote_many?: Maybe<Array<Maybe<ProjectNote_Mutation_Response>>>;
  /** update single row of the table: "Project" */
  update_Project_by_pk?: Maybe<Project>;
  /** update multiples rows of table: "Project" */
  update_Project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "PublicFunderStat" */
  update_PublicFunderStat?: Maybe<PublicFunderStat_Mutation_Response>;
  /** update multiples rows of table: "PublicFunderStat" */
  update_PublicFunderStat_many?: Maybe<Array<Maybe<PublicFunderStat_Mutation_Response>>>;
  /** update data of the table: "PublicPlanterStat" */
  update_PublicPlanterStat?: Maybe<PublicPlanterStat_Mutation_Response>;
  /** update multiples rows of table: "PublicPlanterStat" */
  update_PublicPlanterStat_many?: Maybe<Array<Maybe<PublicPlanterStat_Mutation_Response>>>;
  /** update data of the table: "Purchase" */
  update_Purchase?: Maybe<Purchase_Mutation_Response>;
  /** update data of the table: "PurchaseEvent" */
  update_PurchaseEvent?: Maybe<PurchaseEvent_Mutation_Response>;
  /** update single row of the table: "PurchaseEvent" */
  update_PurchaseEvent_by_pk?: Maybe<PurchaseEvent>;
  /** update multiples rows of table: "PurchaseEvent" */
  update_PurchaseEvent_many?: Maybe<Array<Maybe<PurchaseEvent_Mutation_Response>>>;
  /** update single row of the table: "Purchase" */
  update_Purchase_by_pk?: Maybe<Purchase>;
  /** update multiples rows of table: "Purchase" */
  update_Purchase_many?: Maybe<Array<Maybe<Purchase_Mutation_Response>>>;
  /** update data of the table: "Region" */
  update_Region?: Maybe<Region_Mutation_Response>;
  /** update data of the table: "RegionDistrict" */
  update_RegionDistrict?: Maybe<RegionDistrict_Mutation_Response>;
  /** update single row of the table: "RegionDistrict" */
  update_RegionDistrict_by_pk?: Maybe<RegionDistrict>;
  /** update multiples rows of table: "RegionDistrict" */
  update_RegionDistrict_many?: Maybe<Array<Maybe<RegionDistrict_Mutation_Response>>>;
  /** update single row of the table: "Region" */
  update_Region_by_pk?: Maybe<Region>;
  /** update multiples rows of table: "Region" */
  update_Region_many?: Maybe<Array<Maybe<Region_Mutation_Response>>>;
  /** update data of the table: "Registry" */
  update_Registry?: Maybe<Registry_Mutation_Response>;
  /** update single row of the table: "Registry" */
  update_Registry_by_pk?: Maybe<Registry>;
  /** update multiples rows of table: "Registry" */
  update_Registry_many?: Maybe<Array<Maybe<Registry_Mutation_Response>>>;
  /** update data of the table: "Report" */
  update_Report?: Maybe<Report_Mutation_Response>;
  /** update single row of the table: "Report" */
  update_Report_by_pk?: Maybe<Report>;
  /** update multiples rows of table: "Report" */
  update_Report_many?: Maybe<Array<Maybe<Report_Mutation_Response>>>;
  /** update data of the table: "Sample" */
  update_Sample?: Maybe<Sample_Mutation_Response>;
  /** update data of the table: "SampleLine" */
  update_SampleLine?: Maybe<SampleLine_Mutation_Response>;
  /** update single row of the table: "SampleLine" */
  update_SampleLine_by_pk?: Maybe<SampleLine>;
  /** update multiples rows of table: "SampleLine" */
  update_SampleLine_many?: Maybe<Array<Maybe<SampleLine_Mutation_Response>>>;
  /** update single row of the table: "Sample" */
  update_Sample_by_pk?: Maybe<Sample>;
  /** update multiples rows of table: "Sample" */
  update_Sample_many?: Maybe<Array<Maybe<Sample_Mutation_Response>>>;
  /** update data of the table: "ScheduledEmail" */
  update_ScheduledEmail?: Maybe<ScheduledEmail_Mutation_Response>;
  /** update single row of the table: "ScheduledEmail" */
  update_ScheduledEmail_by_pk?: Maybe<ScheduledEmail>;
  /** update multiples rows of table: "ScheduledEmail" */
  update_ScheduledEmail_many?: Maybe<Array<Maybe<ScheduledEmail_Mutation_Response>>>;
  /** update data of the table: "Season" */
  update_Season?: Maybe<Season_Mutation_Response>;
  /** update single row of the table: "Season" */
  update_Season_by_pk?: Maybe<Season>;
  /** update multiples rows of table: "Season" */
  update_Season_many?: Maybe<Array<Maybe<Season_Mutation_Response>>>;
  /** update data of the table: "Species" */
  update_Species?: Maybe<Species_Mutation_Response>;
  /** update single row of the table: "Species" */
  update_Species_by_pk?: Maybe<Species>;
  /** update multiples rows of table: "Species" */
  update_Species_many?: Maybe<Array<Maybe<Species_Mutation_Response>>>;
  /** update data of the table: "Subscription" */
  update_Subscription?: Maybe<Subscription_Mutation_Response>;
  /** update single row of the table: "Subscription" */
  update_Subscription_by_pk?: Maybe<Subscription>;
  /** update multiples rows of table: "Subscription" */
  update_Subscription_many?: Maybe<Array<Maybe<Subscription_Mutation_Response>>>;
  /** update data of the table: "TTCPlanting" */
  update_TTCPlanting?: Maybe<TtcPlanting_Mutation_Response>;
  /** update multiples rows of table: "TTCPlanting" */
  update_TTCPlanting_many?: Maybe<Array<Maybe<TtcPlanting_Mutation_Response>>>;
  /** update data of the table: "TemplateCategory" */
  update_TemplateCategory?: Maybe<TemplateCategory_Mutation_Response>;
  /** update single row of the table: "TemplateCategory" */
  update_TemplateCategory_by_pk?: Maybe<TemplateCategory>;
  /** update multiples rows of table: "TemplateCategory" */
  update_TemplateCategory_many?: Maybe<Array<Maybe<TemplateCategory_Mutation_Response>>>;
  /** update data of the table: "TreeEvent" */
  update_TreeEvent?: Maybe<TreeEvent_Mutation_Response>;
  /** update single row of the table: "TreeEvent" */
  update_TreeEvent_by_pk?: Maybe<TreeEvent>;
  /** update multiples rows of table: "TreeEvent" */
  update_TreeEvent_many?: Maybe<Array<Maybe<TreeEvent_Mutation_Response>>>;
  /** update data of the table: "User" */
  update_User?: Maybe<User_Mutation_Response>;
  /** update data of the table: "UserEvent" */
  update_UserEvent?: Maybe<UserEvent_Mutation_Response>;
  /** update single row of the table: "UserEvent" */
  update_UserEvent_by_pk?: Maybe<UserEvent>;
  /** update multiples rows of table: "UserEvent" */
  update_UserEvent_many?: Maybe<Array<Maybe<UserEvent_Mutation_Response>>>;
  /** update single row of the table: "User" */
  update_User_by_pk?: Maybe<User>;
  /** update multiples rows of table: "User" */
  update_User_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "Variable" */
  update_Variable?: Maybe<Variable_Mutation_Response>;
  /** update single row of the table: "Variable" */
  update_Variable_by_pk?: Maybe<Variable>;
  /** update multiples rows of table: "Variable" */
  update_Variable_many?: Maybe<Array<Maybe<Variable_Mutation_Response>>>;
  /** update_account_payment_method */
  update_account_payment_method?: Maybe<UpdateAccountPaymentMethodOutput>;
  /** update_account_subscription */
  update_account_subscription?: Maybe<UpdateAccountSubscriptionOutput>;
  update_application_counts: UpdateApplicationCountsOutput;
  /** update_application_season */
  update_application_season: UpdateApplicationSeasonOutput;
  /** update_project */
  update_planter_project?: Maybe<UpdatePlanterProjectOutput>;
  /** update_purchase_error */
  update_purchase_error?: Maybe<UpdatePurchaseErrorOutput>;
  /** update_purchase_event_message */
  update_purchase_public_message?: Maybe<UpdatePurchasePublicMessageOutput>;
  update_purchase_recipient_email?: Maybe<UpdatePurchaseRecipientEmailOutput>;
  /** upsert_application */
  upsert_application?: Maybe<UpsertApplicationOutput>;
  validate_and_update_planting?: Maybe<UpdatePlantingOutput>;
  /** Marks a purchase as "Voided" and removes any matches, tree events associated to it */
  void_purchase?: Maybe<VoidPurchaseOutput>;
};


/** mutation root */
export type Mutation_RootAccept_InviteArgs = {
  input: AcceptInviteInput;
};


/** mutation root */
export type Mutation_RootCancel_SubscriptionArgs = {
  input: CancelSubscriptionInput;
};


/** mutation root */
export type Mutation_RootChange_User_Membership_TypeArgs = {
  input: ChangeUserMembershipTypeInput;
};


/** mutation root */
export type Mutation_RootCreateAccountProfileArgs = {
  input: CreateAccountProfileInput;
};


/** mutation root */
export type Mutation_RootCreate_AccountArgs = {
  input: CreateAccountInsertInput;
};


/** mutation root */
export type Mutation_RootCreate_Account_AssetArgs = {
  input: CreateAccountAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_Accounts_ReportArgs = {
  input: CreateAccountsReportInput;
};


/** mutation root */
export type Mutation_RootCreate_Admin_PaymentArgs = {
  input: CreateAdminPaymentInput;
};


/** mutation root */
export type Mutation_RootCreate_Application_AssetArgs = {
  input: CreateApplicationAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_Gift_Guest_PaymentArgs = {
  input: CreateGiftGuestPaymentInput;
};


/** mutation root */
export type Mutation_RootCreate_Gift_PaymentArgs = {
  input: CreateGiftPaymentInput;
};


/** mutation root */
export type Mutation_RootCreate_Guest_PaymentArgs = {
  input: CreateGuestPaymentInput;
};


/** mutation root */
export type Mutation_RootCreate_Match_From_ApplicationArgs = {
  input: CreateMatchFromApplicationInput;
};


/** mutation root */
export type Mutation_RootCreate_Match_From_InstructionArgs = {
  input: CreateMatchFromInstructionInput;
};


/** mutation root */
export type Mutation_RootCreate_Monitoring_AssetArgs = {
  input: CreateMonitoringAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_PaymentArgs = {
  input: CreatePaymentInput;
};


/** mutation root */
export type Mutation_RootCreate_Planter_RegistrationArgs = {
  input: CreatePlanterRegistrationInsertInput;
};


/** mutation root */
export type Mutation_RootCreate_Planter_Registration_AssetArgs = {
  input?: InputMaybe<CreatePlanterRegistrationAssetInput>;
};


/** mutation root */
export type Mutation_RootCreate_PlantingArgs = {
  input: CreatePlantingInput;
};


/** mutation root */
export type Mutation_RootCreate_Planting_AssetArgs = {
  input: CreatePlantingAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_Planting_Site_AssetArgs = {
  input: CreatePlantingSiteAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_ProjectArgs = {
  input: CreateProjectInput;
};


/** mutation root */
export type Mutation_RootCreate_Project_AssetArgs = {
  input: CreateProjectAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_Project_HeroArgs = {
  input: CreateProjectHeroInput;
};


/** mutation root */
export type Mutation_RootCreate_Project_Note_AssetArgs = {
  input: CreateProjectNoteAssetInput;
};


/** mutation root */
export type Mutation_RootCreate_Purchases_ReportArgs = {
  input: CreatePurchasesReportInput;
};


/** mutation root */
export type Mutation_RootCreate_RegistryArgs = {
  input: CreateRegistryInput;
};


/** mutation root */
export type Mutation_RootCreate_Tree_Pool_ReportArgs = {
  input: CreateTreePoolReportInput;
};


/** mutation root */
export type Mutation_RootDecline_InviteArgs = {
  input: DeclineInviteInput;
};


/** mutation root */
export type Mutation_RootDelete_AccountArgs = {
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AccountSupportersArgs = {
  where: AccountSupporters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ActionNotesArgs = {
  where: ActionNotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ActionNotes_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ActualArgs = {
  where: Actual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ActualLineArgs = {
  where: ActualLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ActualLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Actual_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ApplicationArgs = {
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ApplicationAssetArgs = {
  where: ApplicationAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ApplicationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Application_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AttachmentArgs = {
  where: Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attachment_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BulkRequestArgs = {
  where: BulkRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BulkRequestLinesArgs = {
  where: BulkRequestLines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BulkRequestLines_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BulkRequest_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ConfigAssetArgs = {
  where: ConfigAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConfigAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ConfigRedirectArgs = {
  where: ConfigRedirect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConfigRedirect_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DistrictArgs = {
  where: District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_District_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EmailArgs = {
  where: Email_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventPermissionArgs = {
  where: EventPermission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventPermission_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FundedTreeArgs = {
  where: FundedTree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FundedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FunderArgs = {
  where: Funder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FunderStatArgs = {
  where: FunderStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Funder_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GiftCategoryArgs = {
  where: GiftCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GiftCategory_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GiftTemplateArgs = {
  where: GiftTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GiftTemplate_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GiftedTreeArgs = {
  where: GiftedTree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GiftedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_IpLocationArgs = {
  where: IpLocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_IpLocation_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InstructionArgs = {
  where: Instruction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Instruction_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InviteArgs = {
  where: Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invite_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LoginEventArgs = {
  where: LoginEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LoginEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MatchArgs = {
  where: Match_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Match_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MembershipArgs = {
  where: Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Membership_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MonitoringAssetArgs = {
  where: MonitoringAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MonitoringAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MonitoringEventArgs = {
  where: MonitoringEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MonitoringEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MonitoringLineArgs = {
  where: MonitoringLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MonitoringLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlanArgs = {
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlanLineArgs = {
  where: PlanLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlanLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Plan_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlanterArgs = {
  where: Planter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlanterRegistrationArgs = {
  where: PlanterRegistration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlanterRegistrationAssetArgs = {
  where: PlanterRegistrationAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlanterRegistrationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlanterRegistration_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlanterStatArgs = {
  where: PlanterStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Planter_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlantingArgs = {
  where: Planting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlantingAssetArgs = {
  where: PlantingAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlantingAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlantingLineArgs = {
  where: PlantingLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlantingLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlantingSiteArgs = {
  where: PlantingSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlantingSiteAssetArgs = {
  where: PlantingSiteAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PlantingSiteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlantingSite_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Planting_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProductPriceArgs = {
  where: ProductPrice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProductPrice_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectAssetArgs = {
  where: ProjectAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectNoteArgs = {
  where: ProjectNote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectNoteApplicationArgs = {
  where: ProjectNoteApplication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectNoteApplication_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectNoteAssetArgs = {
  where: ProjectNoteAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ProjectNoteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectNote_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PublicFunderStatArgs = {
  where: PublicFunderStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicPlanterStatArgs = {
  where: PublicPlanterStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PurchaseArgs = {
  where: Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PurchaseEventArgs = {
  where: PurchaseEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PurchaseEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Purchase_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RegionArgs = {
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RegionDistrictArgs = {
  where: RegionDistrict_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RegionDistrict_By_PkArgs = {
  DistrictId: Scalars['uuid'];
  RegionId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Region_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RegistryArgs = {
  where: Registry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registry_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReportArgs = {
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SampleArgs = {
  where: Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SampleLineArgs = {
  where: SampleLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SampleLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sample_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ScheduledEmailArgs = {
  where: ScheduledEmail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ScheduledEmail_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SeasonArgs = {
  where: Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Season_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SpeciesArgs = {
  where: Species_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Species_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionArgs = {
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TtcPlantingArgs = {
  where: TtcPlanting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TemplateCategoryArgs = {
  where: TemplateCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TemplateCategory_By_PkArgs = {
  GiftCategoryId: Scalars['uuid'];
  GiftTemplateId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TreeEventArgs = {
  where: TreeEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TreeEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserEventArgs = {
  where: UserEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_VariableArgs = {
  where: Variable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variable_By_PkArgs = {
  Id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MatchesArgs = {
  input: DeleteMatchesInput;
};


/** mutation root */
export type Mutation_RootDelete_Project_By_IdArgs = {
  input: DeleteProjectByIdInput;
};


/** mutation root */
export type Mutation_RootDelete_Registry_With_No_GiftsArgs = {
  input: DeleteRegistryWithNoGiftsInput;
};


/** mutation root */
export type Mutation_RootDelete_User_MembershipArgs = {
  input: DeleteUserMembershipInput;
};


/** mutation root */
export type Mutation_RootGenerate_Put_Object_Presigned_UrlArgs = {
  input: GeneratePutObjectPresignedUrlInput;
};


/** mutation root */
export type Mutation_RootImport_Bulk_GiftArgs = {
  input: ImportBulkGiftInput;
};


/** mutation root */
export type Mutation_RootInsert_AccountArgs = {
  objects: Array<Account_Insert_Input>;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AccountSupportersArgs = {
  objects: Array<AccountSupporters_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_AccountSupporters_OneArgs = {
  object: AccountSupporters_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Account_OneArgs = {
  object: Account_Insert_Input;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ActionNotesArgs = {
  objects: Array<ActionNotes_Insert_Input>;
  on_conflict?: InputMaybe<ActionNotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ActionNotes_OneArgs = {
  object: ActionNotes_Insert_Input;
  on_conflict?: InputMaybe<ActionNotes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ActualArgs = {
  objects: Array<Actual_Insert_Input>;
  on_conflict?: InputMaybe<Actual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ActualLineArgs = {
  objects: Array<ActualLine_Insert_Input>;
  on_conflict?: InputMaybe<ActualLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ActualLine_OneArgs = {
  object: ActualLine_Insert_Input;
  on_conflict?: InputMaybe<ActualLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Actual_OneArgs = {
  object: Actual_Insert_Input;
  on_conflict?: InputMaybe<Actual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationArgs = {
  objects: Array<Application_Insert_Input>;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationAssetArgs = {
  objects: Array<ApplicationAsset_Insert_Input>;
  on_conflict?: InputMaybe<ApplicationAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationAsset_OneArgs = {
  object: ApplicationAsset_Insert_Input;
  on_conflict?: InputMaybe<ApplicationAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_OneArgs = {
  object: Application_Insert_Input;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttachmentArgs = {
  objects: Array<Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attachment_OneArgs = {
  object: Attachment_Insert_Input;
  on_conflict?: InputMaybe<Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BulkRequestArgs = {
  objects: Array<BulkRequest_Insert_Input>;
  on_conflict?: InputMaybe<BulkRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BulkRequestLinesArgs = {
  objects: Array<BulkRequestLines_Insert_Input>;
  on_conflict?: InputMaybe<BulkRequestLines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BulkRequestLines_OneArgs = {
  object: BulkRequestLines_Insert_Input;
  on_conflict?: InputMaybe<BulkRequestLines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BulkRequest_OneArgs = {
  object: BulkRequest_Insert_Input;
  on_conflict?: InputMaybe<BulkRequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConfigAssetArgs = {
  objects: Array<ConfigAsset_Insert_Input>;
  on_conflict?: InputMaybe<ConfigAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConfigAsset_OneArgs = {
  object: ConfigAsset_Insert_Input;
  on_conflict?: InputMaybe<ConfigAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConfigRedirectArgs = {
  objects: Array<ConfigRedirect_Insert_Input>;
  on_conflict?: InputMaybe<ConfigRedirect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConfigRedirect_OneArgs = {
  object: ConfigRedirect_Insert_Input;
  on_conflict?: InputMaybe<ConfigRedirect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DistrictArgs = {
  objects: Array<District_Insert_Input>;
  on_conflict?: InputMaybe<District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_District_OneArgs = {
  object: District_Insert_Input;
  on_conflict?: InputMaybe<District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmailArgs = {
  objects: Array<Email_Insert_Input>;
  on_conflict?: InputMaybe<Email_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_OneArgs = {
  object: Email_Insert_Input;
  on_conflict?: InputMaybe<Email_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventPermissionArgs = {
  objects: Array<EventPermission_Insert_Input>;
  on_conflict?: InputMaybe<EventPermission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventPermission_OneArgs = {
  object: EventPermission_Insert_Input;
  on_conflict?: InputMaybe<EventPermission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FundedTreeArgs = {
  objects: Array<FundedTree_Insert_Input>;
  on_conflict?: InputMaybe<FundedTree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FundedTree_OneArgs = {
  object: FundedTree_Insert_Input;
  on_conflict?: InputMaybe<FundedTree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FunderArgs = {
  objects: Array<Funder_Insert_Input>;
  on_conflict?: InputMaybe<Funder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FunderStatArgs = {
  objects: Array<FunderStat_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_FunderStat_OneArgs = {
  object: FunderStat_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Funder_OneArgs = {
  object: Funder_Insert_Input;
  on_conflict?: InputMaybe<Funder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftCategoryArgs = {
  objects: Array<GiftCategory_Insert_Input>;
  on_conflict?: InputMaybe<GiftCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftCategory_OneArgs = {
  object: GiftCategory_Insert_Input;
  on_conflict?: InputMaybe<GiftCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftTemplateArgs = {
  objects: Array<GiftTemplate_Insert_Input>;
  on_conflict?: InputMaybe<GiftTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftTemplate_OneArgs = {
  object: GiftTemplate_Insert_Input;
  on_conflict?: InputMaybe<GiftTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftedTreeArgs = {
  objects: Array<GiftedTree_Insert_Input>;
  on_conflict?: InputMaybe<GiftedTree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GiftedTree_OneArgs = {
  object: GiftedTree_Insert_Input;
  on_conflict?: InputMaybe<GiftedTree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IpLocationArgs = {
  objects: Array<IpLocation_Insert_Input>;
  on_conflict?: InputMaybe<IpLocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IpLocation_OneArgs = {
  object: IpLocation_Insert_Input;
  on_conflict?: InputMaybe<IpLocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstructionArgs = {
  objects: Array<Instruction_Insert_Input>;
  on_conflict?: InputMaybe<Instruction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instruction_OneArgs = {
  object: Instruction_Insert_Input;
  on_conflict?: InputMaybe<Instruction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InviteArgs = {
  objects: Array<Invite_Insert_Input>;
  on_conflict?: InputMaybe<Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_OneArgs = {
  object: Invite_Insert_Input;
  on_conflict?: InputMaybe<Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LoginEventArgs = {
  objects: Array<LoginEvent_Insert_Input>;
  on_conflict?: InputMaybe<LoginEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LoginEvent_OneArgs = {
  object: LoginEvent_Insert_Input;
  on_conflict?: InputMaybe<LoginEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MatchArgs = {
  objects: Array<Match_Insert_Input>;
  on_conflict?: InputMaybe<Match_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_OneArgs = {
  object: Match_Insert_Input;
  on_conflict?: InputMaybe<Match_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MembershipArgs = {
  objects: Array<Membership_Insert_Input>;
  on_conflict?: InputMaybe<Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Membership_OneArgs = {
  object: Membership_Insert_Input;
  on_conflict?: InputMaybe<Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringAssetArgs = {
  objects: Array<MonitoringAsset_Insert_Input>;
  on_conflict?: InputMaybe<MonitoringAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringAsset_OneArgs = {
  object: MonitoringAsset_Insert_Input;
  on_conflict?: InputMaybe<MonitoringAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringEventArgs = {
  objects: Array<MonitoringEvent_Insert_Input>;
  on_conflict?: InputMaybe<MonitoringEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringEvent_OneArgs = {
  object: MonitoringEvent_Insert_Input;
  on_conflict?: InputMaybe<MonitoringEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringLineArgs = {
  objects: Array<MonitoringLine_Insert_Input>;
  on_conflict?: InputMaybe<MonitoringLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitoringLine_OneArgs = {
  object: MonitoringLine_Insert_Input;
  on_conflict?: InputMaybe<MonitoringLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanArgs = {
  objects: Array<Plan_Insert_Input>;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanLineArgs = {
  objects: Array<PlanLine_Insert_Input>;
  on_conflict?: InputMaybe<PlanLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanLine_OneArgs = {
  object: PlanLine_Insert_Input;
  on_conflict?: InputMaybe<PlanLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_OneArgs = {
  object: Plan_Insert_Input;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterArgs = {
  objects: Array<Planter_Insert_Input>;
  on_conflict?: InputMaybe<Planter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterRegistrationArgs = {
  objects: Array<PlanterRegistration_Insert_Input>;
  on_conflict?: InputMaybe<PlanterRegistration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterRegistrationAssetArgs = {
  objects: Array<PlanterRegistrationAsset_Insert_Input>;
  on_conflict?: InputMaybe<PlanterRegistrationAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterRegistrationAsset_OneArgs = {
  object: PlanterRegistrationAsset_Insert_Input;
  on_conflict?: InputMaybe<PlanterRegistrationAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterRegistration_OneArgs = {
  object: PlanterRegistration_Insert_Input;
  on_conflict?: InputMaybe<PlanterRegistration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterStatArgs = {
  objects: Array<PlanterStat_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_PlanterStat_OneArgs = {
  object: PlanterStat_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Planter_OneArgs = {
  object: Planter_Insert_Input;
  on_conflict?: InputMaybe<Planter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingArgs = {
  objects: Array<Planting_Insert_Input>;
  on_conflict?: InputMaybe<Planting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingAssetArgs = {
  objects: Array<PlantingAsset_Insert_Input>;
  on_conflict?: InputMaybe<PlantingAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingAsset_OneArgs = {
  object: PlantingAsset_Insert_Input;
  on_conflict?: InputMaybe<PlantingAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingLineArgs = {
  objects: Array<PlantingLine_Insert_Input>;
  on_conflict?: InputMaybe<PlantingLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingLine_OneArgs = {
  object: PlantingLine_Insert_Input;
  on_conflict?: InputMaybe<PlantingLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingSiteArgs = {
  objects: Array<PlantingSite_Insert_Input>;
  on_conflict?: InputMaybe<PlantingSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingSiteAssetArgs = {
  objects: Array<PlantingSiteAsset_Insert_Input>;
  on_conflict?: InputMaybe<PlantingSiteAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingSiteAsset_OneArgs = {
  object: PlantingSiteAsset_Insert_Input;
  on_conflict?: InputMaybe<PlantingSiteAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlantingSite_OneArgs = {
  object: PlantingSite_Insert_Input;
  on_conflict?: InputMaybe<PlantingSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planting_OneArgs = {
  object: Planting_Insert_Input;
  on_conflict?: InputMaybe<Planting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductPriceArgs = {
  objects: Array<ProductPrice_Insert_Input>;
  on_conflict?: InputMaybe<ProductPrice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductPrice_OneArgs = {
  object: ProductPrice_Insert_Input;
  on_conflict?: InputMaybe<ProductPrice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectAssetArgs = {
  objects: Array<ProjectAsset_Insert_Input>;
  on_conflict?: InputMaybe<ProjectAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectAsset_OneArgs = {
  object: ProjectAsset_Insert_Input;
  on_conflict?: InputMaybe<ProjectAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNoteArgs = {
  objects: Array<ProjectNote_Insert_Input>;
  on_conflict?: InputMaybe<ProjectNote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNoteApplicationArgs = {
  objects: Array<ProjectNoteApplication_Insert_Input>;
  on_conflict?: InputMaybe<ProjectNoteApplication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNoteApplication_OneArgs = {
  object: ProjectNoteApplication_Insert_Input;
  on_conflict?: InputMaybe<ProjectNoteApplication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNoteAssetArgs = {
  objects: Array<ProjectNoteAsset_Insert_Input>;
  on_conflict?: InputMaybe<ProjectNoteAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNoteAsset_OneArgs = {
  object: ProjectNoteAsset_Insert_Input;
  on_conflict?: InputMaybe<ProjectNoteAsset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectNote_OneArgs = {
  object: ProjectNote_Insert_Input;
  on_conflict?: InputMaybe<ProjectNote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicFunderStatArgs = {
  objects: Array<PublicFunderStat_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_PublicFunderStat_OneArgs = {
  object: PublicFunderStat_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_PublicPlanterStatArgs = {
  objects: Array<PublicPlanterStat_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_PublicPlanterStat_OneArgs = {
  object: PublicPlanterStat_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_PurchaseArgs = {
  objects: Array<Purchase_Insert_Input>;
  on_conflict?: InputMaybe<Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PurchaseEventArgs = {
  objects: Array<PurchaseEvent_Insert_Input>;
  on_conflict?: InputMaybe<PurchaseEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PurchaseEvent_OneArgs = {
  object: PurchaseEvent_Insert_Input;
  on_conflict?: InputMaybe<PurchaseEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_OneArgs = {
  object: Purchase_Insert_Input;
  on_conflict?: InputMaybe<Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionArgs = {
  objects: Array<Region_Insert_Input>;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionDistrictArgs = {
  objects: Array<RegionDistrict_Insert_Input>;
  on_conflict?: InputMaybe<RegionDistrict_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionDistrict_OneArgs = {
  object: RegionDistrict_Insert_Input;
  on_conflict?: InputMaybe<RegionDistrict_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_OneArgs = {
  object: Region_Insert_Input;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegistryArgs = {
  objects: Array<Registry_Insert_Input>;
  on_conflict?: InputMaybe<Registry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registry_OneArgs = {
  object: Registry_Insert_Input;
  on_conflict?: InputMaybe<Registry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportArgs = {
  objects: Array<Report_Insert_Input>;
  on_conflict?: InputMaybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_OneArgs = {
  object: Report_Insert_Input;
  on_conflict?: InputMaybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleArgs = {
  objects: Array<Sample_Insert_Input>;
  on_conflict?: InputMaybe<Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleLineArgs = {
  objects: Array<SampleLine_Insert_Input>;
  on_conflict?: InputMaybe<SampleLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleLine_OneArgs = {
  object: SampleLine_Insert_Input;
  on_conflict?: InputMaybe<SampleLine_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_OneArgs = {
  object: Sample_Insert_Input;
  on_conflict?: InputMaybe<Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScheduledEmailArgs = {
  objects: Array<ScheduledEmail_Insert_Input>;
  on_conflict?: InputMaybe<ScheduledEmail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScheduledEmail_OneArgs = {
  object: ScheduledEmail_Insert_Input;
  on_conflict?: InputMaybe<ScheduledEmail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SeasonArgs = {
  objects: Array<Season_Insert_Input>;
  on_conflict?: InputMaybe<Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Season_OneArgs = {
  object: Season_Insert_Input;
  on_conflict?: InputMaybe<Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpeciesArgs = {
  objects: Array<Species_Insert_Input>;
  on_conflict?: InputMaybe<Species_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Species_OneArgs = {
  object: Species_Insert_Input;
  on_conflict?: InputMaybe<Species_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionArgs = {
  objects: Array<Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_OneArgs = {
  object: Subscription_Insert_Input;
  on_conflict?: InputMaybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TtcPlantingArgs = {
  objects: Array<TtcPlanting_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_TtcPlanting_OneArgs = {
  object: TtcPlanting_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_TemplateCategoryArgs = {
  objects: Array<TemplateCategory_Insert_Input>;
  on_conflict?: InputMaybe<TemplateCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TemplateCategory_OneArgs = {
  object: TemplateCategory_Insert_Input;
  on_conflict?: InputMaybe<TemplateCategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TreeEventArgs = {
  objects: Array<TreeEvent_Insert_Input>;
  on_conflict?: InputMaybe<TreeEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TreeEvent_OneArgs = {
  object: TreeEvent_Insert_Input;
  on_conflict?: InputMaybe<TreeEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserEventArgs = {
  objects: Array<UserEvent_Insert_Input>;
  on_conflict?: InputMaybe<UserEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserEvent_OneArgs = {
  object: UserEvent_Insert_Input;
  on_conflict?: InputMaybe<UserEvent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VariableArgs = {
  objects: Array<Variable_Insert_Input>;
  on_conflict?: InputMaybe<Variable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variable_OneArgs = {
  object: Variable_Insert_Input;
  on_conflict?: InputMaybe<Variable_On_Conflict>;
};


/** mutation root */
export type Mutation_RootProcess_PurchaseArgs = {
  input: ProcessPurchaseInput;
};


/** mutation root */
export type Mutation_RootRegenerate_PdfArgs = {
  input: RegeneratePdfInput;
};


/** mutation root */
export type Mutation_RootResend_Gift_CertificateArgs = {
  input: ResendGiftCertificateInput;
};


/** mutation root */
export type Mutation_RootUpdate_AccountArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AccountSupportersArgs = {
  _inc?: InputMaybe<AccountSupporters_Inc_Input>;
  _set?: InputMaybe<AccountSupporters_Set_Input>;
  where: AccountSupporters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AccountSupporters_ManyArgs = {
  updates: Array<AccountSupporters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_By_PkArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  pk_columns: Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_ManyArgs = {
  updates: Array<Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ActionNotesArgs = {
  _set?: InputMaybe<ActionNotes_Set_Input>;
  where: ActionNotes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ActionNotes_By_PkArgs = {
  _set?: InputMaybe<ActionNotes_Set_Input>;
  pk_columns: ActionNotes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ActionNotes_ManyArgs = {
  updates: Array<ActionNotes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ActualArgs = {
  _set?: InputMaybe<Actual_Set_Input>;
  where: Actual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ActualLineArgs = {
  _inc?: InputMaybe<ActualLine_Inc_Input>;
  _set?: InputMaybe<ActualLine_Set_Input>;
  where: ActualLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ActualLine_By_PkArgs = {
  _inc?: InputMaybe<ActualLine_Inc_Input>;
  _set?: InputMaybe<ActualLine_Set_Input>;
  pk_columns: ActualLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ActualLine_ManyArgs = {
  updates: Array<ActualLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Actual_By_PkArgs = {
  _set?: InputMaybe<Actual_Set_Input>;
  pk_columns: Actual_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Actual_ManyArgs = {
  updates: Array<Actual_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationAssetArgs = {
  _set?: InputMaybe<ApplicationAsset_Set_Input>;
  where: ApplicationAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationAsset_By_PkArgs = {
  _set?: InputMaybe<ApplicationAsset_Set_Input>;
  pk_columns: ApplicationAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationAsset_ManyArgs = {
  updates: Array<ApplicationAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_By_PkArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  pk_columns: Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_ManyArgs = {
  updates: Array<Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttachmentArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>;
  _set?: InputMaybe<Attachment_Set_Input>;
  where: Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>;
  _set?: InputMaybe<Attachment_Set_Input>;
  pk_columns: Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attachment_ManyArgs = {
  updates: Array<Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequestArgs = {
  _inc?: InputMaybe<BulkRequest_Inc_Input>;
  _set?: InputMaybe<BulkRequest_Set_Input>;
  where: BulkRequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequestLinesArgs = {
  _inc?: InputMaybe<BulkRequestLines_Inc_Input>;
  _set?: InputMaybe<BulkRequestLines_Set_Input>;
  where: BulkRequestLines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequestLines_By_PkArgs = {
  _inc?: InputMaybe<BulkRequestLines_Inc_Input>;
  _set?: InputMaybe<BulkRequestLines_Set_Input>;
  pk_columns: BulkRequestLines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequestLines_ManyArgs = {
  updates: Array<BulkRequestLines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequest_By_PkArgs = {
  _inc?: InputMaybe<BulkRequest_Inc_Input>;
  _set?: InputMaybe<BulkRequest_Set_Input>;
  pk_columns: BulkRequest_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BulkRequest_ManyArgs = {
  updates: Array<BulkRequest_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigAssetArgs = {
  _inc?: InputMaybe<ConfigAsset_Inc_Input>;
  _set?: InputMaybe<ConfigAsset_Set_Input>;
  where: ConfigAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigAsset_By_PkArgs = {
  _inc?: InputMaybe<ConfigAsset_Inc_Input>;
  _set?: InputMaybe<ConfigAsset_Set_Input>;
  pk_columns: ConfigAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigAsset_ManyArgs = {
  updates: Array<ConfigAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigRedirectArgs = {
  _set?: InputMaybe<ConfigRedirect_Set_Input>;
  where: ConfigRedirect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigRedirect_By_PkArgs = {
  _set?: InputMaybe<ConfigRedirect_Set_Input>;
  pk_columns: ConfigRedirect_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigRedirect_ManyArgs = {
  updates: Array<ConfigRedirect_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DistrictArgs = {
  _set?: InputMaybe<District_Set_Input>;
  where: District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_District_By_PkArgs = {
  _set?: InputMaybe<District_Set_Input>;
  pk_columns: District_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_District_ManyArgs = {
  updates: Array<District_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmailArgs = {
  _inc?: InputMaybe<Email_Inc_Input>;
  _set?: InputMaybe<Email_Set_Input>;
  where: Email_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_By_PkArgs = {
  _inc?: InputMaybe<Email_Inc_Input>;
  _set?: InputMaybe<Email_Set_Input>;
  pk_columns: Email_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_ManyArgs = {
  updates: Array<Email_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventPermissionArgs = {
  _inc?: InputMaybe<EventPermission_Inc_Input>;
  _set?: InputMaybe<EventPermission_Set_Input>;
  where: EventPermission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventPermission_By_PkArgs = {
  _inc?: InputMaybe<EventPermission_Inc_Input>;
  _set?: InputMaybe<EventPermission_Set_Input>;
  pk_columns: EventPermission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventPermission_ManyArgs = {
  updates: Array<EventPermission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FundedTreeArgs = {
  _inc?: InputMaybe<FundedTree_Inc_Input>;
  _set?: InputMaybe<FundedTree_Set_Input>;
  where: FundedTree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FundedTree_By_PkArgs = {
  _inc?: InputMaybe<FundedTree_Inc_Input>;
  _set?: InputMaybe<FundedTree_Set_Input>;
  pk_columns: FundedTree_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FundedTree_ManyArgs = {
  updates: Array<FundedTree_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FunderArgs = {
  _inc?: InputMaybe<Funder_Inc_Input>;
  _set?: InputMaybe<Funder_Set_Input>;
  where: Funder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FunderStatArgs = {
  _inc?: InputMaybe<FunderStat_Inc_Input>;
  _set?: InputMaybe<FunderStat_Set_Input>;
  where: FunderStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FunderStat_ManyArgs = {
  updates: Array<FunderStat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Funder_By_PkArgs = {
  _inc?: InputMaybe<Funder_Inc_Input>;
  _set?: InputMaybe<Funder_Set_Input>;
  pk_columns: Funder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Funder_ManyArgs = {
  updates: Array<Funder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GiftCategoryArgs = {
  _inc?: InputMaybe<GiftCategory_Inc_Input>;
  _set?: InputMaybe<GiftCategory_Set_Input>;
  where: GiftCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GiftCategory_By_PkArgs = {
  _inc?: InputMaybe<GiftCategory_Inc_Input>;
  _set?: InputMaybe<GiftCategory_Set_Input>;
  pk_columns: GiftCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GiftCategory_ManyArgs = {
  updates: Array<GiftCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GiftTemplateArgs = {
  _inc?: InputMaybe<GiftTemplate_Inc_Input>;
  _set?: InputMaybe<GiftTemplate_Set_Input>;
  where: GiftTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GiftTemplate_By_PkArgs = {
  _inc?: InputMaybe<GiftTemplate_Inc_Input>;
  _set?: InputMaybe<GiftTemplate_Set_Input>;
  pk_columns: GiftTemplate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GiftTemplate_ManyArgs = {
  updates: Array<GiftTemplate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GiftedTreeArgs = {
  _inc?: InputMaybe<GiftedTree_Inc_Input>;
  _set?: InputMaybe<GiftedTree_Set_Input>;
  where: GiftedTree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GiftedTree_By_PkArgs = {
  _inc?: InputMaybe<GiftedTree_Inc_Input>;
  _set?: InputMaybe<GiftedTree_Set_Input>;
  pk_columns: GiftedTree_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GiftedTree_ManyArgs = {
  updates: Array<GiftedTree_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IpLocationArgs = {
  _set?: InputMaybe<IpLocation_Set_Input>;
  where: IpLocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_IpLocation_By_PkArgs = {
  _set?: InputMaybe<IpLocation_Set_Input>;
  pk_columns: IpLocation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_IpLocation_ManyArgs = {
  updates: Array<IpLocation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InstructionArgs = {
  _inc?: InputMaybe<Instruction_Inc_Input>;
  _set?: InputMaybe<Instruction_Set_Input>;
  where: Instruction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Instruction_By_PkArgs = {
  _inc?: InputMaybe<Instruction_Inc_Input>;
  _set?: InputMaybe<Instruction_Set_Input>;
  pk_columns: Instruction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Instruction_ManyArgs = {
  updates: Array<Instruction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InviteArgs = {
  _set?: InputMaybe<Invite_Set_Input>;
  where: Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_By_PkArgs = {
  _set?: InputMaybe<Invite_Set_Input>;
  pk_columns: Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_ManyArgs = {
  updates: Array<Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LoginEventArgs = {
  _inc?: InputMaybe<LoginEvent_Inc_Input>;
  _set?: InputMaybe<LoginEvent_Set_Input>;
  where: LoginEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LoginEvent_By_PkArgs = {
  _inc?: InputMaybe<LoginEvent_Inc_Input>;
  _set?: InputMaybe<LoginEvent_Set_Input>;
  pk_columns: LoginEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LoginEvent_ManyArgs = {
  updates: Array<LoginEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MatchArgs = {
  _inc?: InputMaybe<Match_Inc_Input>;
  _set?: InputMaybe<Match_Set_Input>;
  where: Match_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Match_By_PkArgs = {
  _inc?: InputMaybe<Match_Inc_Input>;
  _set?: InputMaybe<Match_Set_Input>;
  pk_columns: Match_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Match_ManyArgs = {
  updates: Array<Match_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MembershipArgs = {
  _inc?: InputMaybe<Membership_Inc_Input>;
  _set?: InputMaybe<Membership_Set_Input>;
  where: Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Membership_By_PkArgs = {
  _inc?: InputMaybe<Membership_Inc_Input>;
  _set?: InputMaybe<Membership_Set_Input>;
  pk_columns: Membership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Membership_ManyArgs = {
  updates: Array<Membership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringAssetArgs = {
  _set?: InputMaybe<MonitoringAsset_Set_Input>;
  where: MonitoringAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringAsset_By_PkArgs = {
  _set?: InputMaybe<MonitoringAsset_Set_Input>;
  pk_columns: MonitoringAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringAsset_ManyArgs = {
  updates: Array<MonitoringAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringEventArgs = {
  _inc?: InputMaybe<MonitoringEvent_Inc_Input>;
  _set?: InputMaybe<MonitoringEvent_Set_Input>;
  where: MonitoringEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringEvent_By_PkArgs = {
  _inc?: InputMaybe<MonitoringEvent_Inc_Input>;
  _set?: InputMaybe<MonitoringEvent_Set_Input>;
  pk_columns: MonitoringEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringEvent_ManyArgs = {
  updates: Array<MonitoringEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringLineArgs = {
  _inc?: InputMaybe<MonitoringLine_Inc_Input>;
  _set?: InputMaybe<MonitoringLine_Set_Input>;
  where: MonitoringLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringLine_By_PkArgs = {
  _inc?: InputMaybe<MonitoringLine_Inc_Input>;
  _set?: InputMaybe<MonitoringLine_Set_Input>;
  pk_columns: MonitoringLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MonitoringLine_ManyArgs = {
  updates: Array<MonitoringLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanLineArgs = {
  _inc?: InputMaybe<PlanLine_Inc_Input>;
  _set?: InputMaybe<PlanLine_Set_Input>;
  where: PlanLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanLine_By_PkArgs = {
  _inc?: InputMaybe<PlanLine_Inc_Input>;
  _set?: InputMaybe<PlanLine_Set_Input>;
  pk_columns: PlanLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlanLine_ManyArgs = {
  updates: Array<PlanLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_By_PkArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  pk_columns: Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_ManyArgs = {
  updates: Array<Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterArgs = {
  _inc?: InputMaybe<Planter_Inc_Input>;
  _set?: InputMaybe<Planter_Set_Input>;
  where: Planter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistrationArgs = {
  _inc?: InputMaybe<PlanterRegistration_Inc_Input>;
  _set?: InputMaybe<PlanterRegistration_Set_Input>;
  where: PlanterRegistration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistrationAssetArgs = {
  _set?: InputMaybe<PlanterRegistrationAsset_Set_Input>;
  where: PlanterRegistrationAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistrationAsset_By_PkArgs = {
  _set?: InputMaybe<PlanterRegistrationAsset_Set_Input>;
  pk_columns: PlanterRegistrationAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistrationAsset_ManyArgs = {
  updates: Array<PlanterRegistrationAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistration_By_PkArgs = {
  _inc?: InputMaybe<PlanterRegistration_Inc_Input>;
  _set?: InputMaybe<PlanterRegistration_Set_Input>;
  pk_columns: PlanterRegistration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterRegistration_ManyArgs = {
  updates: Array<PlanterRegistration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterStatArgs = {
  _inc?: InputMaybe<PlanterStat_Inc_Input>;
  _set?: InputMaybe<PlanterStat_Set_Input>;
  where: PlanterStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlanterStat_ManyArgs = {
  updates: Array<PlanterStat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Planter_By_PkArgs = {
  _inc?: InputMaybe<Planter_Inc_Input>;
  _set?: InputMaybe<Planter_Set_Input>;
  pk_columns: Planter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Planter_ManyArgs = {
  updates: Array<Planter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingArgs = {
  _append?: InputMaybe<Planting_Append_Input>;
  _delete_at_path?: InputMaybe<Planting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Planting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Planting_Delete_Key_Input>;
  _inc?: InputMaybe<Planting_Inc_Input>;
  _prepend?: InputMaybe<Planting_Prepend_Input>;
  _set?: InputMaybe<Planting_Set_Input>;
  where: Planting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingAssetArgs = {
  _set?: InputMaybe<PlantingAsset_Set_Input>;
  where: PlantingAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingAsset_By_PkArgs = {
  _set?: InputMaybe<PlantingAsset_Set_Input>;
  pk_columns: PlantingAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingAsset_ManyArgs = {
  updates: Array<PlantingAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingLineArgs = {
  _inc?: InputMaybe<PlantingLine_Inc_Input>;
  _set?: InputMaybe<PlantingLine_Set_Input>;
  where: PlantingLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingLine_By_PkArgs = {
  _inc?: InputMaybe<PlantingLine_Inc_Input>;
  _set?: InputMaybe<PlantingLine_Set_Input>;
  pk_columns: PlantingLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingLine_ManyArgs = {
  updates: Array<PlantingLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSiteArgs = {
  _set?: InputMaybe<PlantingSite_Set_Input>;
  where: PlantingSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSiteAssetArgs = {
  _set?: InputMaybe<PlantingSiteAsset_Set_Input>;
  where: PlantingSiteAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSiteAsset_By_PkArgs = {
  _set?: InputMaybe<PlantingSiteAsset_Set_Input>;
  pk_columns: PlantingSiteAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSiteAsset_ManyArgs = {
  updates: Array<PlantingSiteAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSite_By_PkArgs = {
  _set?: InputMaybe<PlantingSite_Set_Input>;
  pk_columns: PlantingSite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PlantingSite_ManyArgs = {
  updates: Array<PlantingSite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Planting_By_PkArgs = {
  _append?: InputMaybe<Planting_Append_Input>;
  _delete_at_path?: InputMaybe<Planting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Planting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Planting_Delete_Key_Input>;
  _inc?: InputMaybe<Planting_Inc_Input>;
  _prepend?: InputMaybe<Planting_Prepend_Input>;
  _set?: InputMaybe<Planting_Set_Input>;
  pk_columns: Planting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Planting_ManyArgs = {
  updates: Array<Planting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProductPriceArgs = {
  _inc?: InputMaybe<ProductPrice_Inc_Input>;
  _set?: InputMaybe<ProductPrice_Set_Input>;
  where: ProductPrice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProductPrice_By_PkArgs = {
  _inc?: InputMaybe<ProductPrice_Inc_Input>;
  _set?: InputMaybe<ProductPrice_Set_Input>;
  pk_columns: ProductPrice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProductPrice_ManyArgs = {
  updates: Array<ProductPrice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _append?: InputMaybe<Project_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Inc_Input>;
  _prepend?: InputMaybe<Project_Prepend_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectAssetArgs = {
  _set?: InputMaybe<ProjectAsset_Set_Input>;
  where: ProjectAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectAsset_By_PkArgs = {
  _set?: InputMaybe<ProjectAsset_Set_Input>;
  pk_columns: ProjectAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectAsset_ManyArgs = {
  updates: Array<ProjectAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteArgs = {
  _inc?: InputMaybe<ProjectNote_Inc_Input>;
  _set?: InputMaybe<ProjectNote_Set_Input>;
  where: ProjectNote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteApplicationArgs = {
  _set?: InputMaybe<ProjectNoteApplication_Set_Input>;
  where: ProjectNoteApplication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteApplication_By_PkArgs = {
  _set?: InputMaybe<ProjectNoteApplication_Set_Input>;
  pk_columns: ProjectNoteApplication_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteApplication_ManyArgs = {
  updates: Array<ProjectNoteApplication_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteAssetArgs = {
  _set?: InputMaybe<ProjectNoteAsset_Set_Input>;
  where: ProjectNoteAsset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteAsset_By_PkArgs = {
  _set?: InputMaybe<ProjectNoteAsset_Set_Input>;
  pk_columns: ProjectNoteAsset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNoteAsset_ManyArgs = {
  updates: Array<ProjectNoteAsset_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNote_By_PkArgs = {
  _inc?: InputMaybe<ProjectNote_Inc_Input>;
  _set?: InputMaybe<ProjectNote_Set_Input>;
  pk_columns: ProjectNote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectNote_ManyArgs = {
  updates: Array<ProjectNote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _append?: InputMaybe<Project_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Inc_Input>;
  _prepend?: InputMaybe<Project_Prepend_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicFunderStatArgs = {
  _inc?: InputMaybe<PublicFunderStat_Inc_Input>;
  _set?: InputMaybe<PublicFunderStat_Set_Input>;
  where: PublicFunderStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicFunderStat_ManyArgs = {
  updates: Array<PublicFunderStat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PublicPlanterStatArgs = {
  _inc?: InputMaybe<PublicPlanterStat_Inc_Input>;
  _set?: InputMaybe<PublicPlanterStat_Set_Input>;
  where: PublicPlanterStat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicPlanterStat_ManyArgs = {
  updates: Array<PublicPlanterStat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PurchaseArgs = {
  _append?: InputMaybe<Purchase_Append_Input>;
  _delete_at_path?: InputMaybe<Purchase_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Purchase_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Purchase_Delete_Key_Input>;
  _inc?: InputMaybe<Purchase_Inc_Input>;
  _prepend?: InputMaybe<Purchase_Prepend_Input>;
  _set?: InputMaybe<Purchase_Set_Input>;
  where: Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PurchaseEventArgs = {
  _inc?: InputMaybe<PurchaseEvent_Inc_Input>;
  _set?: InputMaybe<PurchaseEvent_Set_Input>;
  where: PurchaseEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PurchaseEvent_By_PkArgs = {
  _inc?: InputMaybe<PurchaseEvent_Inc_Input>;
  _set?: InputMaybe<PurchaseEvent_Set_Input>;
  pk_columns: PurchaseEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PurchaseEvent_ManyArgs = {
  updates: Array<PurchaseEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_By_PkArgs = {
  _append?: InputMaybe<Purchase_Append_Input>;
  _delete_at_path?: InputMaybe<Purchase_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Purchase_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Purchase_Delete_Key_Input>;
  _inc?: InputMaybe<Purchase_Inc_Input>;
  _prepend?: InputMaybe<Purchase_Prepend_Input>;
  _set?: InputMaybe<Purchase_Set_Input>;
  pk_columns: Purchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_ManyArgs = {
  updates: Array<Purchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegionArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RegionDistrictArgs = {
  _set?: InputMaybe<RegionDistrict_Set_Input>;
  where: RegionDistrict_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RegionDistrict_By_PkArgs = {
  _set?: InputMaybe<RegionDistrict_Set_Input>;
  pk_columns: RegionDistrict_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RegionDistrict_ManyArgs = {
  updates: Array<RegionDistrict_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Region_By_PkArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  pk_columns: Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Region_ManyArgs = {
  updates: Array<Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegistryArgs = {
  _inc?: InputMaybe<Registry_Inc_Input>;
  _set?: InputMaybe<Registry_Set_Input>;
  where: Registry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registry_By_PkArgs = {
  _inc?: InputMaybe<Registry_Inc_Input>;
  _set?: InputMaybe<Registry_Set_Input>;
  pk_columns: Registry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registry_ManyArgs = {
  updates: Array<Registry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportArgs = {
  _inc?: InputMaybe<Report_Inc_Input>;
  _set?: InputMaybe<Report_Set_Input>;
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_By_PkArgs = {
  _inc?: InputMaybe<Report_Inc_Input>;
  _set?: InputMaybe<Report_Set_Input>;
  pk_columns: Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_ManyArgs = {
  updates: Array<Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SampleArgs = {
  _inc?: InputMaybe<Sample_Inc_Input>;
  _set?: InputMaybe<Sample_Set_Input>;
  where: Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLineArgs = {
  _inc?: InputMaybe<SampleLine_Inc_Input>;
  _set?: InputMaybe<SampleLine_Set_Input>;
  where: SampleLine_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLine_By_PkArgs = {
  _inc?: InputMaybe<SampleLine_Inc_Input>;
  _set?: InputMaybe<SampleLine_Set_Input>;
  pk_columns: SampleLine_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLine_ManyArgs = {
  updates: Array<SampleLine_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_By_PkArgs = {
  _inc?: InputMaybe<Sample_Inc_Input>;
  _set?: InputMaybe<Sample_Set_Input>;
  pk_columns: Sample_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_ManyArgs = {
  updates: Array<Sample_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScheduledEmailArgs = {
  _inc?: InputMaybe<ScheduledEmail_Inc_Input>;
  _set?: InputMaybe<ScheduledEmail_Set_Input>;
  where: ScheduledEmail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ScheduledEmail_By_PkArgs = {
  _inc?: InputMaybe<ScheduledEmail_Inc_Input>;
  _set?: InputMaybe<ScheduledEmail_Set_Input>;
  pk_columns: ScheduledEmail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ScheduledEmail_ManyArgs = {
  updates: Array<ScheduledEmail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SeasonArgs = {
  _set?: InputMaybe<Season_Set_Input>;
  where: Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Season_By_PkArgs = {
  _set?: InputMaybe<Season_Set_Input>;
  pk_columns: Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Season_ManyArgs = {
  updates: Array<Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpeciesArgs = {
  _inc?: InputMaybe<Species_Inc_Input>;
  _set?: InputMaybe<Species_Set_Input>;
  where: Species_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Species_By_PkArgs = {
  _inc?: InputMaybe<Species_Inc_Input>;
  _set?: InputMaybe<Species_Set_Input>;
  pk_columns: Species_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Species_ManyArgs = {
  updates: Array<Species_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionArgs = {
  _inc?: InputMaybe<Subscription_Inc_Input>;
  _set?: InputMaybe<Subscription_Set_Input>;
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_By_PkArgs = {
  _inc?: InputMaybe<Subscription_Inc_Input>;
  _set?: InputMaybe<Subscription_Set_Input>;
  pk_columns: Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_ManyArgs = {
  updates: Array<Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TtcPlantingArgs = {
  _append?: InputMaybe<TtcPlanting_Append_Input>;
  _delete_at_path?: InputMaybe<TtcPlanting_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<TtcPlanting_Delete_Elem_Input>;
  _delete_key?: InputMaybe<TtcPlanting_Delete_Key_Input>;
  _inc?: InputMaybe<TtcPlanting_Inc_Input>;
  _prepend?: InputMaybe<TtcPlanting_Prepend_Input>;
  _set?: InputMaybe<TtcPlanting_Set_Input>;
  where: TtcPlanting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TtcPlanting_ManyArgs = {
  updates: Array<TtcPlanting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TemplateCategoryArgs = {
  _set?: InputMaybe<TemplateCategory_Set_Input>;
  where: TemplateCategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TemplateCategory_By_PkArgs = {
  _set?: InputMaybe<TemplateCategory_Set_Input>;
  pk_columns: TemplateCategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TemplateCategory_ManyArgs = {
  updates: Array<TemplateCategory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TreeEventArgs = {
  _inc?: InputMaybe<TreeEvent_Inc_Input>;
  _set?: InputMaybe<TreeEvent_Set_Input>;
  where: TreeEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TreeEvent_By_PkArgs = {
  _inc?: InputMaybe<TreeEvent_Inc_Input>;
  _set?: InputMaybe<TreeEvent_Set_Input>;
  pk_columns: TreeEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TreeEvent_ManyArgs = {
  updates: Array<TreeEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserEventArgs = {
  _inc?: InputMaybe<UserEvent_Inc_Input>;
  _set?: InputMaybe<UserEvent_Set_Input>;
  where: UserEvent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserEvent_By_PkArgs = {
  _inc?: InputMaybe<UserEvent_Inc_Input>;
  _set?: InputMaybe<UserEvent_Set_Input>;
  pk_columns: UserEvent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserEvent_ManyArgs = {
  updates: Array<UserEvent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VariableArgs = {
  _set?: InputMaybe<Variable_Set_Input>;
  where: Variable_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variable_By_PkArgs = {
  _set?: InputMaybe<Variable_Set_Input>;
  pk_columns: Variable_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variable_ManyArgs = {
  updates: Array<Variable_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Payment_MethodArgs = {
  input: UpdateAccountPaymentMethodInput;
};


/** mutation root */
export type Mutation_RootUpdate_Account_SubscriptionArgs = {
  input: UpdateAccountSubscriptionInput;
};


/** mutation root */
export type Mutation_RootUpdate_Application_CountsArgs = {
  input: UpdateApplicationCountsInput;
};


/** mutation root */
export type Mutation_RootUpdate_Application_SeasonArgs = {
  input: UpdateApplicationSeasonInput;
};


/** mutation root */
export type Mutation_RootUpdate_Planter_ProjectArgs = {
  input: UpdatePlanterProjectInput;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_ErrorArgs = {
  input: UpdatePurchaseErrorInput;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Public_MessageArgs = {
  input: UpdatePurchasePublicMessageInput;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Recipient_EmailArgs = {
  input: UpdatePurchaseRecipientEmailInput;
};


/** mutation root */
export type Mutation_RootUpsert_ApplicationArgs = {
  input: UpsertApplicationInput;
};


/** mutation root */
export type Mutation_RootValidate_And_Update_PlantingArgs = {
  input: UpdatePlantingInput;
};


/** mutation root */
export type Mutation_RootVoid_PurchaseArgs = {
  input: VoidPurchaseInput;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "Account" */
  Account: Array<Account>;
  /** fetch data from the table: "AccountSupporters" */
  AccountSupporters: Array<AccountSupporters>;
  /** fetch aggregated fields from the table: "AccountSupporters" */
  AccountSupporters_aggregate: AccountSupporters_Aggregate;
  /** fetch data from the table: "AccountView" */
  AccountView: Array<AccountView>;
  /** fetch aggregated fields from the table: "AccountView" */
  AccountView_aggregate: AccountView_Aggregate;
  /** fetch aggregated fields from the table: "Account" */
  Account_aggregate: Account_Aggregate;
  /** fetch data from the table: "Account" using primary key columns */
  Account_by_pk?: Maybe<Account>;
  /** fetch data from the table: "ActionNotes" */
  ActionNotes: Array<ActionNotes>;
  /** fetch aggregated fields from the table: "ActionNotes" */
  ActionNotes_aggregate: ActionNotes_Aggregate;
  /** fetch data from the table: "ActionNotes" using primary key columns */
  ActionNotes_by_pk?: Maybe<ActionNotes>;
  /** fetch data from the table: "Actual" */
  Actual: Array<Actual>;
  /** fetch data from the table: "ActualLine" */
  ActualLine: Array<ActualLine>;
  /** fetch aggregated fields from the table: "ActualLine" */
  ActualLine_aggregate: ActualLine_Aggregate;
  /** fetch data from the table: "ActualLine" using primary key columns */
  ActualLine_by_pk?: Maybe<ActualLine>;
  /** fetch aggregated fields from the table: "Actual" */
  Actual_aggregate: Actual_Aggregate;
  /** fetch data from the table: "Actual" using primary key columns */
  Actual_by_pk?: Maybe<Actual>;
  /** fetch data from the table: "Address" */
  Address: Array<Address>;
  /** fetch aggregated fields from the table: "Address" */
  Address_aggregate: Address_Aggregate;
  /** fetch data from the table: "Address" using primary key columns */
  Address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "AdminBulkGiftView" */
  AdminBulkGiftView: Array<AdminBulkGiftView>;
  /** fetch aggregated fields from the table: "AdminBulkGiftView" */
  AdminBulkGiftView_aggregate: AdminBulkGiftView_Aggregate;
  /** fetch data from the table: "AdminPurchaseView" */
  AdminPurchaseView: Array<AdminPurchaseView>;
  /** fetch aggregated fields from the table: "AdminPurchaseView" */
  AdminPurchaseView_aggregate: AdminPurchaseView_Aggregate;
  /** An array relationship */
  Application: Array<Application>;
  /** fetch data from the table: "ApplicationAsset" */
  ApplicationAsset: Array<ApplicationAsset>;
  /** fetch aggregated fields from the table: "ApplicationAsset" */
  ApplicationAsset_aggregate: ApplicationAsset_Aggregate;
  /** fetch data from the table: "ApplicationAsset" using primary key columns */
  ApplicationAsset_by_pk?: Maybe<ApplicationAsset>;
  /** fetch data from the table: "ApplicationView" */
  ApplicationView: Array<ApplicationView>;
  /** fetch aggregated fields from the table: "ApplicationView" */
  ApplicationView_aggregate: ApplicationView_Aggregate;
  /** An aggregate relationship */
  Application_aggregate: Application_Aggregate;
  /** fetch data from the table: "Application" using primary key columns */
  Application_by_pk?: Maybe<Application>;
  /** fetch data from the table: "ApprovedTreesView" */
  ApprovedTreesView: Array<ApprovedTreesView>;
  /** fetch aggregated fields from the table: "ApprovedTreesView" */
  ApprovedTreesView_aggregate: ApprovedTreesView_Aggregate;
  /** An array relationship */
  Attachment: Array<Attachment>;
  /** An aggregate relationship */
  Attachment_aggregate: Attachment_Aggregate;
  /** fetch data from the table: "Attachment" using primary key columns */
  Attachment_by_pk?: Maybe<Attachment>;
  /** fetch data from the table: "BulkRequest" */
  BulkRequest: Array<BulkRequest>;
  /** fetch data from the table: "BulkRequestLines" */
  BulkRequestLines: Array<BulkRequestLines>;
  /** fetch aggregated fields from the table: "BulkRequestLines" */
  BulkRequestLines_aggregate: BulkRequestLines_Aggregate;
  /** fetch data from the table: "BulkRequestLines" using primary key columns */
  BulkRequestLines_by_pk?: Maybe<BulkRequestLines>;
  /** fetch aggregated fields from the table: "BulkRequest" */
  BulkRequest_aggregate: BulkRequest_Aggregate;
  /** fetch data from the table: "BulkRequest" using primary key columns */
  BulkRequest_by_pk?: Maybe<BulkRequest>;
  /** fetch data from the table: "ConfigAsset" */
  ConfigAsset: Array<ConfigAsset>;
  /** fetch aggregated fields from the table: "ConfigAsset" */
  ConfigAsset_aggregate: ConfigAsset_Aggregate;
  /** fetch data from the table: "ConfigAsset" using primary key columns */
  ConfigAsset_by_pk?: Maybe<ConfigAsset>;
  /** fetch data from the table: "ConfigRedirect" */
  ConfigRedirect: Array<ConfigRedirect>;
  /** fetch aggregated fields from the table: "ConfigRedirect" */
  ConfigRedirect_aggregate: ConfigRedirect_Aggregate;
  /** fetch data from the table: "ConfigRedirect" using primary key columns */
  ConfigRedirect_by_pk?: Maybe<ConfigRedirect>;
  /** fetch data from the table: "District" */
  District: Array<District>;
  /** fetch aggregated fields from the table: "District" */
  District_aggregate: District_Aggregate;
  /** fetch data from the table: "District" using primary key columns */
  District_by_pk?: Maybe<District>;
  /** fetch data from the table: "Email" */
  Email: Array<Email>;
  /** fetch aggregated fields from the table: "Email" */
  Email_aggregate: Email_Aggregate;
  /** fetch data from the table: "Email" using primary key columns */
  Email_by_pk?: Maybe<Email>;
  /** fetch data from the table: "EventPermission" */
  EventPermission: Array<EventPermission>;
  /** fetch aggregated fields from the table: "EventPermission" */
  EventPermission_aggregate: EventPermission_Aggregate;
  /** fetch data from the table: "EventPermission" using primary key columns */
  EventPermission_by_pk?: Maybe<EventPermission>;
  /** fetch data from the table: "FundedTree" */
  FundedTree: Array<FundedTree>;
  /** fetch aggregated fields from the table: "FundedTree" */
  FundedTree_aggregate: FundedTree_Aggregate;
  /** fetch data from the table: "FundedTree" using primary key columns */
  FundedTree_by_pk?: Maybe<FundedTree>;
  /** fetch data from the table: "Funder" */
  Funder: Array<Funder>;
  /** fetch data from the table: "FunderStat" */
  FunderStat: Array<FunderStat>;
  /** fetch aggregated fields from the table: "FunderStat" */
  FunderStat_aggregate: FunderStat_Aggregate;
  /** execute function "FunderStatsForUser" which returns "FunderStat" */
  FunderStatsForUser: Array<FunderStat>;
  /** execute function "FunderStatsForUser" and query aggregates on result of table type "FunderStat" */
  FunderStatsForUser_aggregate: FunderStat_Aggregate;
  /** fetch data from the table: "FunderView" */
  FunderView: Array<FunderView>;
  /** fetch aggregated fields from the table: "FunderView" */
  FunderView_aggregate: FunderView_Aggregate;
  /** fetch aggregated fields from the table: "Funder" */
  Funder_aggregate: Funder_Aggregate;
  /** fetch data from the table: "Funder" using primary key columns */
  Funder_by_pk?: Maybe<Funder>;
  /** fetch data from the table: "GiftCategory" */
  GiftCategory: Array<GiftCategory>;
  /** fetch aggregated fields from the table: "GiftCategory" */
  GiftCategory_aggregate: GiftCategory_Aggregate;
  /** fetch data from the table: "GiftCategory" using primary key columns */
  GiftCategory_by_pk?: Maybe<GiftCategory>;
  /** fetch data from the table: "GiftTemplate" */
  GiftTemplate: Array<GiftTemplate>;
  /** fetch aggregated fields from the table: "GiftTemplate" */
  GiftTemplate_aggregate: GiftTemplate_Aggregate;
  /** fetch data from the table: "GiftTemplate" using primary key columns */
  GiftTemplate_by_pk?: Maybe<GiftTemplate>;
  /** fetch data from the table: "GiftedTree" */
  GiftedTree: Array<GiftedTree>;
  /** fetch aggregated fields from the table: "GiftedTree" */
  GiftedTree_aggregate: GiftedTree_Aggregate;
  /** fetch data from the table: "GiftedTree" using primary key columns */
  GiftedTree_by_pk?: Maybe<GiftedTree>;
  /** fetch data from the table: "IPLocation" */
  IPLocation: Array<IpLocation>;
  /** fetch aggregated fields from the table: "IPLocation" */
  IPLocation_aggregate: IpLocation_Aggregate;
  /** fetch data from the table: "IPLocation" using primary key columns */
  IPLocation_by_pk?: Maybe<IpLocation>;
  /** An array relationship */
  Instruction: Array<Instruction>;
  /** fetch data from the table: "InstructionView" */
  InstructionView: Array<InstructionView>;
  /** fetch aggregated fields from the table: "InstructionView" */
  InstructionView_aggregate: InstructionView_Aggregate;
  /** An aggregate relationship */
  Instruction_aggregate: Instruction_Aggregate;
  /** fetch data from the table: "Instruction" using primary key columns */
  Instruction_by_pk?: Maybe<Instruction>;
  /** fetch data from the table: "Invite" */
  Invite: Array<Invite>;
  /** fetch aggregated fields from the table: "Invite" */
  Invite_aggregate: Invite_Aggregate;
  /** fetch data from the table: "Invite" using primary key columns */
  Invite_by_pk?: Maybe<Invite>;
  /** fetch data from the table: "LoginEvent" */
  LoginEvent: Array<LoginEvent>;
  /** fetch aggregated fields from the table: "LoginEvent" */
  LoginEvent_aggregate: LoginEvent_Aggregate;
  /** fetch data from the table: "LoginEvent" using primary key columns */
  LoginEvent_by_pk?: Maybe<LoginEvent>;
  /** fetch data from the table: "Match" */
  Match: Array<Match>;
  /** fetch aggregated fields from the table: "Match" */
  Match_aggregate: Match_Aggregate;
  /** fetch data from the table: "Match" using primary key columns */
  Match_by_pk?: Maybe<Match>;
  /** fetch data from the table: "Membership" */
  Membership: Array<Membership>;
  /** fetch aggregated fields from the table: "Membership" */
  Membership_aggregate: Membership_Aggregate;
  /** fetch data from the table: "Membership" using primary key columns */
  Membership_by_pk?: Maybe<Membership>;
  /** fetch data from the table: "MonitoringAsset" */
  MonitoringAsset: Array<MonitoringAsset>;
  /** fetch aggregated fields from the table: "MonitoringAsset" */
  MonitoringAsset_aggregate: MonitoringAsset_Aggregate;
  /** fetch data from the table: "MonitoringAsset" using primary key columns */
  MonitoringAsset_by_pk?: Maybe<MonitoringAsset>;
  /** fetch data from the table: "MonitoringEvent" */
  MonitoringEvent: Array<MonitoringEvent>;
  /** fetch aggregated fields from the table: "MonitoringEvent" */
  MonitoringEvent_aggregate: MonitoringEvent_Aggregate;
  /** fetch data from the table: "MonitoringEvent" using primary key columns */
  MonitoringEvent_by_pk?: Maybe<MonitoringEvent>;
  /** fetch data from the table: "MonitoringLine" */
  MonitoringLine: Array<MonitoringLine>;
  /** fetch aggregated fields from the table: "MonitoringLine" */
  MonitoringLine_aggregate: MonitoringLine_Aggregate;
  /** fetch data from the table: "MonitoringLine" using primary key columns */
  MonitoringLine_by_pk?: Maybe<MonitoringLine>;
  /** fetch data from the table: "Plan" */
  Plan: Array<Plan>;
  /** fetch data from the table: "PlanLine" */
  PlanLine: Array<PlanLine>;
  /** fetch aggregated fields from the table: "PlanLine" */
  PlanLine_aggregate: PlanLine_Aggregate;
  /** fetch data from the table: "PlanLine" using primary key columns */
  PlanLine_by_pk?: Maybe<PlanLine>;
  /** fetch aggregated fields from the table: "Plan" */
  Plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "Plan" using primary key columns */
  Plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table: "Planter" */
  Planter: Array<Planter>;
  /** fetch data from the table: "PlanterRegistration" */
  PlanterRegistration: Array<PlanterRegistration>;
  /** fetch data from the table: "PlanterRegistrationAsset" */
  PlanterRegistrationAsset: Array<PlanterRegistrationAsset>;
  /** fetch aggregated fields from the table: "PlanterRegistrationAsset" */
  PlanterRegistrationAsset_aggregate: PlanterRegistrationAsset_Aggregate;
  /** fetch data from the table: "PlanterRegistrationAsset" using primary key columns */
  PlanterRegistrationAsset_by_pk?: Maybe<PlanterRegistrationAsset>;
  /** fetch aggregated fields from the table: "PlanterRegistration" */
  PlanterRegistration_aggregate: PlanterRegistration_Aggregate;
  /** fetch data from the table: "PlanterRegistration" using primary key columns */
  PlanterRegistration_by_pk?: Maybe<PlanterRegistration>;
  /** fetch data from the table: "PlanterStat" */
  PlanterStat: Array<PlanterStat>;
  /** fetch aggregated fields from the table: "PlanterStat" */
  PlanterStat_aggregate: PlanterStat_Aggregate;
  /** execute function "PlanterStatsForUser" which returns "PlanterStat" */
  PlanterStatsForUser: Array<PlanterStat>;
  /** execute function "PlanterStatsForUser" and query aggregates on result of table type "PlanterStat" */
  PlanterStatsForUser_aggregate: PlanterStat_Aggregate;
  /** fetch data from the table: "PlanterView" */
  PlanterView: Array<PlanterView>;
  /** fetch aggregated fields from the table: "PlanterView" */
  PlanterView_aggregate: PlanterView_Aggregate;
  /** fetch aggregated fields from the table: "Planter" */
  Planter_aggregate: Planter_Aggregate;
  /** fetch data from the table: "Planter" using primary key columns */
  Planter_by_pk?: Maybe<Planter>;
  /** fetch data from the table: "Planting" */
  Planting: Array<Planting>;
  /** fetch data from the table: "PlantingAsset" */
  PlantingAsset: Array<PlantingAsset>;
  /** fetch aggregated fields from the table: "PlantingAsset" */
  PlantingAsset_aggregate: PlantingAsset_Aggregate;
  /** fetch data from the table: "PlantingAsset" using primary key columns */
  PlantingAsset_by_pk?: Maybe<PlantingAsset>;
  /** fetch data from the table: "PlantingLine" */
  PlantingLine: Array<PlantingLine>;
  /** fetch aggregated fields from the table: "PlantingLine" */
  PlantingLine_aggregate: PlantingLine_Aggregate;
  /** fetch data from the table: "PlantingLine" using primary key columns */
  PlantingLine_by_pk?: Maybe<PlantingLine>;
  /** fetch data from the table: "PlantingSite" */
  PlantingSite: Array<PlantingSite>;
  /** fetch data from the table: "PlantingSiteAsset" */
  PlantingSiteAsset: Array<PlantingSiteAsset>;
  /** fetch aggregated fields from the table: "PlantingSiteAsset" */
  PlantingSiteAsset_aggregate: PlantingSiteAsset_Aggregate;
  /** fetch data from the table: "PlantingSiteAsset" using primary key columns */
  PlantingSiteAsset_by_pk?: Maybe<PlantingSiteAsset>;
  /** fetch aggregated fields from the table: "PlantingSite" */
  PlantingSite_aggregate: PlantingSite_Aggregate;
  /** fetch data from the table: "PlantingSite" using primary key columns */
  PlantingSite_by_pk?: Maybe<PlantingSite>;
  /** fetch aggregated fields from the table: "Planting" */
  Planting_aggregate: Planting_Aggregate;
  /** fetch data from the table: "Planting" using primary key columns */
  Planting_by_pk?: Maybe<Planting>;
  /** fetch data from the table: "Product" */
  Product: Array<Product>;
  /** fetch data from the table: "ProductPrice" */
  ProductPrice: Array<ProductPrice>;
  /** fetch aggregated fields from the table: "ProductPrice" */
  ProductPrice_aggregate: ProductPrice_Aggregate;
  /** fetch data from the table: "ProductPrice" using primary key columns */
  ProductPrice_by_pk?: Maybe<ProductPrice>;
  /** fetch aggregated fields from the table: "Product" */
  Product_aggregate: Product_Aggregate;
  /** fetch data from the table: "Product" using primary key columns */
  Product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "Project" */
  Project: Array<Project>;
  /** fetch data from the table: "ProjectAsset" */
  ProjectAsset: Array<ProjectAsset>;
  /** fetch aggregated fields from the table: "ProjectAsset" */
  ProjectAsset_aggregate: ProjectAsset_Aggregate;
  /** fetch data from the table: "ProjectAsset" using primary key columns */
  ProjectAsset_by_pk?: Maybe<ProjectAsset>;
  /** fetch data from the table: "ProjectNote" */
  ProjectNote: Array<ProjectNote>;
  /** fetch data from the table: "ProjectNoteApplication" */
  ProjectNoteApplication: Array<ProjectNoteApplication>;
  /** fetch aggregated fields from the table: "ProjectNoteApplication" */
  ProjectNoteApplication_aggregate: ProjectNoteApplication_Aggregate;
  /** fetch data from the table: "ProjectNoteApplication" using primary key columns */
  ProjectNoteApplication_by_pk?: Maybe<ProjectNoteApplication>;
  /** fetch data from the table: "ProjectNoteAsset" */
  ProjectNoteAsset: Array<ProjectNoteAsset>;
  /** fetch aggregated fields from the table: "ProjectNoteAsset" */
  ProjectNoteAsset_aggregate: ProjectNoteAsset_Aggregate;
  /** fetch data from the table: "ProjectNoteAsset" using primary key columns */
  ProjectNoteAsset_by_pk?: Maybe<ProjectNoteAsset>;
  /** fetch aggregated fields from the table: "ProjectNote" */
  ProjectNote_aggregate: ProjectNote_Aggregate;
  /** fetch data from the table: "ProjectNote" using primary key columns */
  ProjectNote_by_pk?: Maybe<ProjectNote>;
  /** fetch data from the table: "ProjectStats" */
  ProjectStats: Array<ProjectStats>;
  /** fetch aggregated fields from the table: "ProjectStats" */
  ProjectStats_aggregate: ProjectStats_Aggregate;
  /** fetch data from the table: "ProjectView" */
  ProjectView: Array<ProjectView>;
  /** fetch aggregated fields from the table: "ProjectView" */
  ProjectView_aggregate: ProjectView_Aggregate;
  /** fetch aggregated fields from the table: "Project" */
  Project_aggregate: Project_Aggregate;
  /** fetch data from the table: "Project" using primary key columns */
  Project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "PublicFunderStat" */
  PublicFunderStat: Array<PublicFunderStat>;
  /** fetch aggregated fields from the table: "PublicFunderStat" */
  PublicFunderStat_aggregate: PublicFunderStat_Aggregate;
  /** execute function "PublicFunderStatsForAccount" which returns "PublicFunderStat" */
  PublicFunderStatsForAccount: Array<PublicFunderStat>;
  /** execute function "PublicFunderStatsForAccount" and query aggregates on result of table type "PublicFunderStat" */
  PublicFunderStatsForAccount_aggregate: PublicFunderStat_Aggregate;
  /** fetch data from the table: "PublicPlanterStat" */
  PublicPlanterStat: Array<PublicPlanterStat>;
  /** fetch aggregated fields from the table: "PublicPlanterStat" */
  PublicPlanterStat_aggregate: PublicPlanterStat_Aggregate;
  /** execute function "PublicPlanterStatsForAccount" which returns "PublicPlanterStat" */
  PublicPlanterStatsForAccount: Array<PublicPlanterStat>;
  /** execute function "PublicPlanterStatsForAccount" and query aggregates on result of table type "PublicPlanterStat" */
  PublicPlanterStatsForAccount_aggregate: PublicPlanterStat_Aggregate;
  /** An array relationship */
  Purchase: Array<Purchase>;
  /** fetch data from the table: "PurchaseDashboardView" */
  PurchaseDashboardView: Array<PurchaseDashboardView>;
  /** fetch aggregated fields from the table: "PurchaseDashboardView" */
  PurchaseDashboardView_aggregate: PurchaseDashboardView_Aggregate;
  /** fetch data from the table: "PurchaseEvent" */
  PurchaseEvent: Array<PurchaseEvent>;
  /** fetch aggregated fields from the table: "PurchaseEvent" */
  PurchaseEvent_aggregate: PurchaseEvent_Aggregate;
  /** fetch data from the table: "PurchaseEvent" using primary key columns */
  PurchaseEvent_by_pk?: Maybe<PurchaseEvent>;
  /** fetch data from the table: "PurchaseView" */
  PurchaseView: Array<PurchaseView>;
  /** fetch aggregated fields from the table: "PurchaseView" */
  PurchaseView_aggregate: PurchaseView_Aggregate;
  /** An aggregate relationship */
  Purchase_aggregate: Purchase_Aggregate;
  /** fetch data from the table: "Purchase" using primary key columns */
  Purchase_by_pk?: Maybe<Purchase>;
  /** fetch data from the table: "Region" */
  Region: Array<Region>;
  /** fetch data from the table: "RegionDistrict" */
  RegionDistrict: Array<RegionDistrict>;
  /** fetch aggregated fields from the table: "RegionDistrict" */
  RegionDistrict_aggregate: RegionDistrict_Aggregate;
  /** fetch data from the table: "RegionDistrict" using primary key columns */
  RegionDistrict_by_pk?: Maybe<RegionDistrict>;
  /** fetch aggregated fields from the table: "Region" */
  Region_aggregate: Region_Aggregate;
  /** fetch data from the table: "Region" using primary key columns */
  Region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "Registry" */
  Registry: Array<Registry>;
  /** fetch data from the table: "RegistryView" */
  RegistryView: Array<RegistryView>;
  /** fetch aggregated fields from the table: "RegistryView" */
  RegistryView_aggregate: RegistryView_Aggregate;
  /** fetch aggregated fields from the table: "Registry" */
  Registry_aggregate: Registry_Aggregate;
  /** fetch data from the table: "Registry" using primary key columns */
  Registry_by_pk?: Maybe<Registry>;
  /** fetch data from the table: "Report" */
  Report: Array<Report>;
  /** fetch aggregated fields from the table: "Report" */
  Report_aggregate: Report_Aggregate;
  /** fetch data from the table: "Report" using primary key columns */
  Report_by_pk?: Maybe<Report>;
  /** fetch data from the table: "Sample" */
  Sample: Array<Sample>;
  /** fetch data from the table: "SampleLine" */
  SampleLine: Array<SampleLine>;
  /** fetch aggregated fields from the table: "SampleLine" */
  SampleLine_aggregate: SampleLine_Aggregate;
  /** fetch data from the table: "SampleLine" using primary key columns */
  SampleLine_by_pk?: Maybe<SampleLine>;
  /** fetch aggregated fields from the table: "Sample" */
  Sample_aggregate: Sample_Aggregate;
  /** fetch data from the table: "Sample" using primary key columns */
  Sample_by_pk?: Maybe<Sample>;
  /** fetch data from the table: "ScheduledEmail" */
  ScheduledEmail: Array<ScheduledEmail>;
  /** fetch aggregated fields from the table: "ScheduledEmail" */
  ScheduledEmail_aggregate: ScheduledEmail_Aggregate;
  /** fetch data from the table: "ScheduledEmail" using primary key columns */
  ScheduledEmail_by_pk?: Maybe<ScheduledEmail>;
  /** fetch data from the table: "Season" */
  Season: Array<Season>;
  /** fetch aggregated fields from the table: "Season" */
  Season_aggregate: Season_Aggregate;
  /** fetch data from the table: "Season" using primary key columns */
  Season_by_pk?: Maybe<Season>;
  /** fetch data from the table: "Species" */
  Species: Array<Species>;
  /** fetch aggregated fields from the table: "Species" */
  Species_aggregate: Species_Aggregate;
  /** fetch data from the table: "Species" using primary key columns */
  Species_by_pk?: Maybe<Species>;
  /** fetch data from the table: "StatisticsView" */
  StatisticsView: Array<StatisticsView>;
  /** fetch aggregated fields from the table: "StatisticsView" */
  StatisticsView_aggregate: StatisticsView_Aggregate;
  /** fetch data from the table: "Subscription" */
  Subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "Subscription" */
  Subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "Subscription" using primary key columns */
  Subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table: "SupportedProjectsView" */
  SupportedProjectsView: Array<SupportedProjectsView>;
  /** fetch aggregated fields from the table: "SupportedProjectsView" */
  SupportedProjectsView_aggregate: SupportedProjectsView_Aggregate;
  /** fetch data from the table: "TTCPlanting" */
  TTCPlanting: Array<TtcPlanting>;
  /** fetch aggregated fields from the table: "TTCPlanting" */
  TTCPlanting_aggregate: TtcPlanting_Aggregate;
  /** fetch data from the table: "TemplateCategory" */
  TemplateCategory: Array<TemplateCategory>;
  /** fetch aggregated fields from the table: "TemplateCategory" */
  TemplateCategory_aggregate: TemplateCategory_Aggregate;
  /** fetch data from the table: "TemplateCategory" using primary key columns */
  TemplateCategory_by_pk?: Maybe<TemplateCategory>;
  /** fetch data from the table: "TreeEvent" */
  TreeEvent: Array<TreeEvent>;
  /** fetch aggregated fields from the table: "TreeEvent" */
  TreeEvent_aggregate: TreeEvent_Aggregate;
  /** fetch data from the table: "TreeEvent" using primary key columns */
  TreeEvent_by_pk?: Maybe<TreeEvent>;
  /** fetch data from the table: "TreePoolStatsView" */
  TreePoolStatsView: Array<TreePoolStatsView>;
  /** fetch aggregated fields from the table: "TreePoolStatsView" */
  TreePoolStatsView_aggregate: TreePoolStatsView_Aggregate;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserEvent" */
  UserEvent: Array<UserEvent>;
  /** fetch data from the table: "UserEventView" */
  UserEventView: Array<UserEventView>;
  /** fetch aggregated fields from the table: "UserEventView" */
  UserEventView_aggregate: UserEventView_Aggregate;
  /** fetch aggregated fields from the table: "UserEvent" */
  UserEvent_aggregate: UserEvent_Aggregate;
  /** fetch data from the table: "UserEvent" using primary key columns */
  UserEvent_by_pk?: Maybe<UserEvent>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_Aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table: "Variable" */
  Variable: Array<Variable>;
  /** fetch aggregated fields from the table: "Variable" */
  Variable_aggregate: Variable_Aggregate;
  /** fetch data from the table: "Variable" using primary key columns */
  Variable_by_pk?: Maybe<Variable>;
  generate_presigned_url: Scalars['String'];
  /** execute function "getAccountSupporters" which returns "AccountSupporters" */
  getAccountSupporters: Array<AccountSupporters>;
  /** execute function "getAccountSupporters" and query aggregates on result of table type "AccountSupporters" */
  getAccountSupporters_aggregate: AccountSupporters_Aggregate;
  /** Get preview image */
  get_gift_preview?: Maybe<GiftPreviewOutput>;
  /** get_subscription */
  get_subscription?: Maybe<StripeSummary>;
  /** get_user_account_intercom_data */
  get_user_account_intercom_data?: Maybe<GetUserIntercomDataOutput>;
  list_account_supporters: ListAccountSupportersOutput;
  list_bulk_gift_recipients?: Maybe<GetBulkGiftRecipientsOutput>;
  list_certifications: ListCertificationsOutput;
  /** Plan */
  plan: PlanOutput;
};


export type Query_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccountSupportersArgs = {
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Query_RootAccountSupporters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Query_RootAccountViewArgs = {
  distinct_on?: InputMaybe<Array<AccountView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountView_Order_By>>;
  where?: InputMaybe<AccountView_Bool_Exp>;
};


export type Query_RootAccountView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountView_Order_By>>;
  where?: InputMaybe<AccountView_Bool_Exp>;
};


export type Query_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootActionNotesArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


export type Query_RootActionNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


export type Query_RootActionNotes_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootActualArgs = {
  distinct_on?: InputMaybe<Array<Actual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Order_By>>;
  where?: InputMaybe<Actual_Bool_Exp>;
};


export type Query_RootActualLineArgs = {
  distinct_on?: InputMaybe<Array<ActualLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActualLine_Order_By>>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};


export type Query_RootActualLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActualLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActualLine_Order_By>>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};


export type Query_RootActualLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootActual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Order_By>>;
  where?: InputMaybe<Actual_Bool_Exp>;
};


export type Query_RootActual_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootAdminBulkGiftViewArgs = {
  distinct_on?: InputMaybe<Array<AdminBulkGiftView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminBulkGiftView_Order_By>>;
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
};


export type Query_RootAdminBulkGiftView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdminBulkGiftView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminBulkGiftView_Order_By>>;
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
};


export type Query_RootAdminPurchaseViewArgs = {
  distinct_on?: InputMaybe<Array<AdminPurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By>>;
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
};


export type Query_RootAdminPurchaseView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdminPurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By>>;
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
};


export type Query_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplicationAssetArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


export type Query_RootApplicationAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


export type Query_RootApplicationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootApplicationViewArgs = {
  distinct_on?: InputMaybe<Array<ApplicationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationView_Order_By>>;
  where?: InputMaybe<ApplicationView_Bool_Exp>;
};


export type Query_RootApplicationView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationView_Order_By>>;
  where?: InputMaybe<ApplicationView_Bool_Exp>;
};


export type Query_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplication_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootApprovedTreesViewArgs = {
  distinct_on?: InputMaybe<Array<ApprovedTreesView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovedTreesView_Order_By>>;
  where?: InputMaybe<ApprovedTreesView_Bool_Exp>;
};


export type Query_RootApprovedTreesView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovedTreesView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovedTreesView_Order_By>>;
  where?: InputMaybe<ApprovedTreesView_Bool_Exp>;
};


export type Query_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


export type Query_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


export type Query_RootAttachment_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootBulkRequestArgs = {
  distinct_on?: InputMaybe<Array<BulkRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequest_Order_By>>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};


export type Query_RootBulkRequestLinesArgs = {
  distinct_on?: InputMaybe<Array<BulkRequestLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequestLines_Order_By>>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};


export type Query_RootBulkRequestLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BulkRequestLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequestLines_Order_By>>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};


export type Query_RootBulkRequestLines_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootBulkRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BulkRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequest_Order_By>>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};


export type Query_RootBulkRequest_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootConfigAssetArgs = {
  distinct_on?: InputMaybe<Array<ConfigAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigAsset_Order_By>>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};


export type Query_RootConfigAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigAsset_Order_By>>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};


export type Query_RootConfigAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootConfigRedirectArgs = {
  distinct_on?: InputMaybe<Array<ConfigRedirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigRedirect_Order_By>>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};


export type Query_RootConfigRedirect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigRedirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigRedirect_Order_By>>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};


export type Query_RootConfigRedirect_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootDistrictArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Query_RootDistrict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Query_RootDistrict_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootEmailArgs = {
  distinct_on?: InputMaybe<Array<Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Order_By>>;
  where?: InputMaybe<Email_Bool_Exp>;
};


export type Query_RootEmail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Order_By>>;
  where?: InputMaybe<Email_Bool_Exp>;
};


export type Query_RootEmail_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootEventPermissionArgs = {
  distinct_on?: InputMaybe<Array<EventPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPermission_Order_By>>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};


export type Query_RootEventPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPermission_Order_By>>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};


export type Query_RootEventPermission_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootFundedTreeArgs = {
  distinct_on?: InputMaybe<Array<FundedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FundedTree_Order_By>>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};


export type Query_RootFundedTree_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FundedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FundedTree_Order_By>>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};


export type Query_RootFundedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootFunderArgs = {
  distinct_on?: InputMaybe<Array<Funder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Funder_Order_By>>;
  where?: InputMaybe<Funder_Bool_Exp>;
};


export type Query_RootFunderStatArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Query_RootFunderStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Query_RootFunderStatsForUserArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Query_RootFunderStatsForUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Query_RootFunderViewArgs = {
  distinct_on?: InputMaybe<Array<FunderView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderView_Order_By>>;
  where?: InputMaybe<FunderView_Bool_Exp>;
};


export type Query_RootFunderView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderView_Order_By>>;
  where?: InputMaybe<FunderView_Bool_Exp>;
};


export type Query_RootFunder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Funder_Order_By>>;
  where?: InputMaybe<Funder_Bool_Exp>;
};


export type Query_RootFunder_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootGiftCategoryArgs = {
  distinct_on?: InputMaybe<Array<GiftCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftCategory_Order_By>>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};


export type Query_RootGiftCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftCategory_Order_By>>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};


export type Query_RootGiftCategory_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootGiftTemplateArgs = {
  distinct_on?: InputMaybe<Array<GiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftTemplate_Order_By>>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};


export type Query_RootGiftTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftTemplate_Order_By>>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};


export type Query_RootGiftTemplate_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootGiftedTreeArgs = {
  distinct_on?: InputMaybe<Array<GiftedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftedTree_Order_By>>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};


export type Query_RootGiftedTree_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftedTree_Order_By>>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};


export type Query_RootGiftedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootIpLocationArgs = {
  distinct_on?: InputMaybe<Array<IpLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IpLocation_Order_By>>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};


export type Query_RootIpLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IpLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IpLocation_Order_By>>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};


export type Query_RootIpLocation_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootInstructionArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


export type Query_RootInstructionViewArgs = {
  distinct_on?: InputMaybe<Array<InstructionView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InstructionView_Order_By>>;
  where?: InputMaybe<InstructionView_Bool_Exp>;
};


export type Query_RootInstructionView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InstructionView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InstructionView_Order_By>>;
  where?: InputMaybe<InstructionView_Bool_Exp>;
};


export type Query_RootInstruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


export type Query_RootInstruction_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootInviteArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


export type Query_RootInvite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


export type Query_RootInvite_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootLoginEventArgs = {
  distinct_on?: InputMaybe<Array<LoginEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoginEvent_Order_By>>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};


export type Query_RootLoginEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoginEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoginEvent_Order_By>>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};


export type Query_RootLoginEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootMatchArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


export type Query_RootMatch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


export type Query_RootMatch_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootMembershipArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


export type Query_RootMembership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


export type Query_RootMembership_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootMonitoringAssetArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


export type Query_RootMonitoringAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


export type Query_RootMonitoringAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootMonitoringEventArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


export type Query_RootMonitoringEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


export type Query_RootMonitoringEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootMonitoringLineArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


export type Query_RootMonitoringLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


export type Query_RootMonitoringLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlanLineArgs = {
  distinct_on?: InputMaybe<Array<PlanLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanLine_Order_By>>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};


export type Query_RootPlanLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanLine_Order_By>>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};


export type Query_RootPlanLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlan_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlanterArgs = {
  distinct_on?: InputMaybe<Array<Planter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planter_Order_By>>;
  where?: InputMaybe<Planter_Bool_Exp>;
};


export type Query_RootPlanterRegistrationArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


export type Query_RootPlanterRegistrationAssetArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


export type Query_RootPlanterRegistrationAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


export type Query_RootPlanterRegistrationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlanterRegistration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


export type Query_RootPlanterRegistration_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlanterStatArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Query_RootPlanterStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Query_RootPlanterStatsForUserArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Query_RootPlanterStatsForUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Query_RootPlanterViewArgs = {
  distinct_on?: InputMaybe<Array<PlanterView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterView_Order_By>>;
  where?: InputMaybe<PlanterView_Bool_Exp>;
};


export type Query_RootPlanterView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterView_Order_By>>;
  where?: InputMaybe<PlanterView_Bool_Exp>;
};


export type Query_RootPlanter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planter_Order_By>>;
  where?: InputMaybe<Planter_Bool_Exp>;
};


export type Query_RootPlanter_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlantingArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


export type Query_RootPlantingAssetArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


export type Query_RootPlantingAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


export type Query_RootPlantingAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlantingLineArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


export type Query_RootPlantingLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


export type Query_RootPlantingLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlantingSiteArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


export type Query_RootPlantingSiteAssetArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


export type Query_RootPlantingSiteAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


export type Query_RootPlantingSiteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlantingSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


export type Query_RootPlantingSite_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPlanting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


export type Query_RootPlanting_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProductPriceArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


export type Query_RootProductPrice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


export type Query_RootProductPrice_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProjectAssetArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


export type Query_RootProjectAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


export type Query_RootProjectAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProjectNoteArgs = {
  distinct_on?: InputMaybe<Array<ProjectNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNote_Order_By>>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};


export type Query_RootProjectNoteApplicationArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


export type Query_RootProjectNoteApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


export type Query_RootProjectNoteApplication_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProjectNoteAssetArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


export type Query_RootProjectNoteAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


export type Query_RootProjectNoteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProjectNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNote_Order_By>>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};


export type Query_RootProjectNote_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootProjectStatsArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


export type Query_RootProjectStats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


export type Query_RootProjectViewArgs = {
  distinct_on?: InputMaybe<Array<ProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectView_Order_By>>;
  where?: InputMaybe<ProjectView_Bool_Exp>;
};


export type Query_RootProjectView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectView_Order_By>>;
  where?: InputMaybe<ProjectView_Bool_Exp>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPublicFunderStatArgs = {
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Query_RootPublicFunderStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Query_RootPublicFunderStatsForAccountArgs = {
  args: PublicFunderStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Query_RootPublicFunderStatsForAccount_AggregateArgs = {
  args: PublicFunderStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Query_RootPublicPlanterStatArgs = {
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Query_RootPublicPlanterStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Query_RootPublicPlanterStatsForAccountArgs = {
  args: PublicPlanterStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Query_RootPublicPlanterStatsForAccount_AggregateArgs = {
  args: PublicPlanterStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Query_RootPurchaseArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


export type Query_RootPurchaseDashboardViewArgs = {
  distinct_on?: InputMaybe<Array<PurchaseDashboardView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseDashboardView_Order_By>>;
  where?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
};


export type Query_RootPurchaseDashboardView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseDashboardView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseDashboardView_Order_By>>;
  where?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
};


export type Query_RootPurchaseEventArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


export type Query_RootPurchaseEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


export type Query_RootPurchaseEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootPurchaseViewArgs = {
  distinct_on?: InputMaybe<Array<PurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseView_Order_By>>;
  where?: InputMaybe<PurchaseView_Bool_Exp>;
};


export type Query_RootPurchaseView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseView_Order_By>>;
  where?: InputMaybe<PurchaseView_Bool_Exp>;
};


export type Query_RootPurchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


export type Query_RootPurchase_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegionDistrictArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


export type Query_RootRegionDistrict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


export type Query_RootRegionDistrict_By_PkArgs = {
  DistrictId: Scalars['uuid'];
  RegionId: Scalars['uuid'];
};


export type Query_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegion_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootRegistryArgs = {
  distinct_on?: InputMaybe<Array<Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registry_Order_By>>;
  where?: InputMaybe<Registry_Bool_Exp>;
};


export type Query_RootRegistryViewArgs = {
  distinct_on?: InputMaybe<Array<RegistryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistryView_Order_By>>;
  where?: InputMaybe<RegistryView_Bool_Exp>;
};


export type Query_RootRegistryView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistryView_Order_By>>;
  where?: InputMaybe<RegistryView_Bool_Exp>;
};


export type Query_RootRegistry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registry_Order_By>>;
  where?: InputMaybe<Registry_Bool_Exp>;
};


export type Query_RootRegistry_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootSampleArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Query_RootSampleLineArgs = {
  distinct_on?: InputMaybe<Array<SampleLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLine_Order_By>>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};


export type Query_RootSampleLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLine_Order_By>>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};


export type Query_RootSampleLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootSample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Query_RootSample_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootScheduledEmailArgs = {
  distinct_on?: InputMaybe<Array<ScheduledEmail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScheduledEmail_Order_By>>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};


export type Query_RootScheduledEmail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ScheduledEmail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScheduledEmail_Order_By>>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};


export type Query_RootScheduledEmail_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootSeasonArgs = {
  distinct_on?: InputMaybe<Array<Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Season_Order_By>>;
  where?: InputMaybe<Season_Bool_Exp>;
};


export type Query_RootSeason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Season_Order_By>>;
  where?: InputMaybe<Season_Bool_Exp>;
};


export type Query_RootSeason_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootSpeciesArgs = {
  distinct_on?: InputMaybe<Array<Species_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Species_Order_By>>;
  where?: InputMaybe<Species_Bool_Exp>;
};


export type Query_RootSpecies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Species_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Species_Order_By>>;
  where?: InputMaybe<Species_Bool_Exp>;
};


export type Query_RootSpecies_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootStatisticsViewArgs = {
  distinct_on?: InputMaybe<Array<StatisticsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StatisticsView_Order_By>>;
  where?: InputMaybe<StatisticsView_Bool_Exp>;
};


export type Query_RootStatisticsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StatisticsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StatisticsView_Order_By>>;
  where?: InputMaybe<StatisticsView_Bool_Exp>;
};


export type Query_RootSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootSupportedProjectsViewArgs = {
  distinct_on?: InputMaybe<Array<SupportedProjectsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportedProjectsView_Order_By>>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
};


export type Query_RootSupportedProjectsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SupportedProjectsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportedProjectsView_Order_By>>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
};


export type Query_RootTtcPlantingArgs = {
  distinct_on?: InputMaybe<Array<TtcPlanting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TtcPlanting_Order_By>>;
  where?: InputMaybe<TtcPlanting_Bool_Exp>;
};


export type Query_RootTtcPlanting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TtcPlanting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TtcPlanting_Order_By>>;
  where?: InputMaybe<TtcPlanting_Bool_Exp>;
};


export type Query_RootTemplateCategoryArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


export type Query_RootTemplateCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


export type Query_RootTemplateCategory_By_PkArgs = {
  GiftCategoryId: Scalars['uuid'];
  GiftTemplateId: Scalars['uuid'];
};


export type Query_RootTreeEventArgs = {
  distinct_on?: InputMaybe<Array<TreeEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreeEvent_Order_By>>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};


export type Query_RootTreeEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TreeEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreeEvent_Order_By>>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};


export type Query_RootTreeEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootTreePoolStatsViewArgs = {
  distinct_on?: InputMaybe<Array<TreePoolStatsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreePoolStatsView_Order_By>>;
  where?: InputMaybe<TreePoolStatsView_Bool_Exp>;
};


export type Query_RootTreePoolStatsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TreePoolStatsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreePoolStatsView_Order_By>>;
  where?: InputMaybe<TreePoolStatsView_Bool_Exp>;
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUserEventArgs = {
  distinct_on?: InputMaybe<Array<UserEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEvent_Order_By>>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};


export type Query_RootUserEventViewArgs = {
  distinct_on?: InputMaybe<Array<UserEventView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEventView_Order_By>>;
  where?: InputMaybe<UserEventView_Bool_Exp>;
};


export type Query_RootUserEventView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEventView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEventView_Order_By>>;
  where?: InputMaybe<UserEventView_Bool_Exp>;
};


export type Query_RootUserEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEvent_Order_By>>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};


export type Query_RootUserEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootVariableArgs = {
  distinct_on?: InputMaybe<Array<Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variable_Order_By>>;
  where?: InputMaybe<Variable_Bool_Exp>;
};


export type Query_RootVariable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variable_Order_By>>;
  where?: InputMaybe<Variable_Bool_Exp>;
};


export type Query_RootVariable_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Query_RootGenerate_Presigned_UrlArgs = {
  S3Path: Scalars['String'];
};


export type Query_RootGetAccountSupportersArgs = {
  args: GetAccountSupporters_Args;
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Query_RootGetAccountSupporters_AggregateArgs = {
  args: GetAccountSupporters_Args;
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Query_RootGet_Gift_PreviewArgs = {
  input?: InputMaybe<GetGiftPreviewInput>;
};


export type Query_RootGet_SubscriptionArgs = {
  input?: InputMaybe<GetStripeSubscriptionInput>;
};


export type Query_RootList_Account_SupportersArgs = {
  input: ListAccountSupportersInput;
};


export type Query_RootList_Bulk_Gift_RecipientsArgs = {
  input: GetBulkGiftRecipientsInput;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "Account" */
  Account: Array<Account>;
  /** fetch data from the table: "AccountSupporters" */
  AccountSupporters: Array<AccountSupporters>;
  /** fetch aggregated fields from the table: "AccountSupporters" */
  AccountSupporters_aggregate: AccountSupporters_Aggregate;
  /** fetch data from the table in a streaming manner: "AccountSupporters" */
  AccountSupporters_stream: Array<AccountSupporters>;
  /** fetch data from the table: "AccountView" */
  AccountView: Array<AccountView>;
  /** fetch aggregated fields from the table: "AccountView" */
  AccountView_aggregate: AccountView_Aggregate;
  /** fetch data from the table in a streaming manner: "AccountView" */
  AccountView_stream: Array<AccountView>;
  /** fetch aggregated fields from the table: "Account" */
  Account_aggregate: Account_Aggregate;
  /** fetch data from the table: "Account" using primary key columns */
  Account_by_pk?: Maybe<Account>;
  /** fetch data from the table in a streaming manner: "Account" */
  Account_stream: Array<Account>;
  /** fetch data from the table: "ActionNotes" */
  ActionNotes: Array<ActionNotes>;
  /** fetch aggregated fields from the table: "ActionNotes" */
  ActionNotes_aggregate: ActionNotes_Aggregate;
  /** fetch data from the table: "ActionNotes" using primary key columns */
  ActionNotes_by_pk?: Maybe<ActionNotes>;
  /** fetch data from the table in a streaming manner: "ActionNotes" */
  ActionNotes_stream: Array<ActionNotes>;
  /** fetch data from the table: "Actual" */
  Actual: Array<Actual>;
  /** fetch data from the table: "ActualLine" */
  ActualLine: Array<ActualLine>;
  /** fetch aggregated fields from the table: "ActualLine" */
  ActualLine_aggregate: ActualLine_Aggregate;
  /** fetch data from the table: "ActualLine" using primary key columns */
  ActualLine_by_pk?: Maybe<ActualLine>;
  /** fetch data from the table in a streaming manner: "ActualLine" */
  ActualLine_stream: Array<ActualLine>;
  /** fetch aggregated fields from the table: "Actual" */
  Actual_aggregate: Actual_Aggregate;
  /** fetch data from the table: "Actual" using primary key columns */
  Actual_by_pk?: Maybe<Actual>;
  /** fetch data from the table in a streaming manner: "Actual" */
  Actual_stream: Array<Actual>;
  /** fetch data from the table: "Address" */
  Address: Array<Address>;
  /** fetch aggregated fields from the table: "Address" */
  Address_aggregate: Address_Aggregate;
  /** fetch data from the table: "Address" using primary key columns */
  Address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "Address" */
  Address_stream: Array<Address>;
  /** fetch data from the table: "AdminBulkGiftView" */
  AdminBulkGiftView: Array<AdminBulkGiftView>;
  /** fetch aggregated fields from the table: "AdminBulkGiftView" */
  AdminBulkGiftView_aggregate: AdminBulkGiftView_Aggregate;
  /** fetch data from the table in a streaming manner: "AdminBulkGiftView" */
  AdminBulkGiftView_stream: Array<AdminBulkGiftView>;
  /** fetch data from the table: "AdminPurchaseView" */
  AdminPurchaseView: Array<AdminPurchaseView>;
  /** fetch aggregated fields from the table: "AdminPurchaseView" */
  AdminPurchaseView_aggregate: AdminPurchaseView_Aggregate;
  /** fetch data from the table in a streaming manner: "AdminPurchaseView" */
  AdminPurchaseView_stream: Array<AdminPurchaseView>;
  /** An array relationship */
  Application: Array<Application>;
  /** fetch data from the table: "ApplicationAsset" */
  ApplicationAsset: Array<ApplicationAsset>;
  /** fetch aggregated fields from the table: "ApplicationAsset" */
  ApplicationAsset_aggregate: ApplicationAsset_Aggregate;
  /** fetch data from the table: "ApplicationAsset" using primary key columns */
  ApplicationAsset_by_pk?: Maybe<ApplicationAsset>;
  /** fetch data from the table in a streaming manner: "ApplicationAsset" */
  ApplicationAsset_stream: Array<ApplicationAsset>;
  /** fetch data from the table: "ApplicationView" */
  ApplicationView: Array<ApplicationView>;
  /** fetch aggregated fields from the table: "ApplicationView" */
  ApplicationView_aggregate: ApplicationView_Aggregate;
  /** fetch data from the table in a streaming manner: "ApplicationView" */
  ApplicationView_stream: Array<ApplicationView>;
  /** An aggregate relationship */
  Application_aggregate: Application_Aggregate;
  /** fetch data from the table: "Application" using primary key columns */
  Application_by_pk?: Maybe<Application>;
  /** fetch data from the table in a streaming manner: "Application" */
  Application_stream: Array<Application>;
  /** fetch data from the table: "ApprovedTreesView" */
  ApprovedTreesView: Array<ApprovedTreesView>;
  /** fetch aggregated fields from the table: "ApprovedTreesView" */
  ApprovedTreesView_aggregate: ApprovedTreesView_Aggregate;
  /** fetch data from the table in a streaming manner: "ApprovedTreesView" */
  ApprovedTreesView_stream: Array<ApprovedTreesView>;
  /** An array relationship */
  Attachment: Array<Attachment>;
  /** An aggregate relationship */
  Attachment_aggregate: Attachment_Aggregate;
  /** fetch data from the table: "Attachment" using primary key columns */
  Attachment_by_pk?: Maybe<Attachment>;
  /** fetch data from the table in a streaming manner: "Attachment" */
  Attachment_stream: Array<Attachment>;
  /** fetch data from the table: "BulkRequest" */
  BulkRequest: Array<BulkRequest>;
  /** fetch data from the table: "BulkRequestLines" */
  BulkRequestLines: Array<BulkRequestLines>;
  /** fetch aggregated fields from the table: "BulkRequestLines" */
  BulkRequestLines_aggregate: BulkRequestLines_Aggregate;
  /** fetch data from the table: "BulkRequestLines" using primary key columns */
  BulkRequestLines_by_pk?: Maybe<BulkRequestLines>;
  /** fetch data from the table in a streaming manner: "BulkRequestLines" */
  BulkRequestLines_stream: Array<BulkRequestLines>;
  /** fetch aggregated fields from the table: "BulkRequest" */
  BulkRequest_aggregate: BulkRequest_Aggregate;
  /** fetch data from the table: "BulkRequest" using primary key columns */
  BulkRequest_by_pk?: Maybe<BulkRequest>;
  /** fetch data from the table in a streaming manner: "BulkRequest" */
  BulkRequest_stream: Array<BulkRequest>;
  /** fetch data from the table: "ConfigAsset" */
  ConfigAsset: Array<ConfigAsset>;
  /** fetch aggregated fields from the table: "ConfigAsset" */
  ConfigAsset_aggregate: ConfigAsset_Aggregate;
  /** fetch data from the table: "ConfigAsset" using primary key columns */
  ConfigAsset_by_pk?: Maybe<ConfigAsset>;
  /** fetch data from the table in a streaming manner: "ConfigAsset" */
  ConfigAsset_stream: Array<ConfigAsset>;
  /** fetch data from the table: "ConfigRedirect" */
  ConfigRedirect: Array<ConfigRedirect>;
  /** fetch aggregated fields from the table: "ConfigRedirect" */
  ConfigRedirect_aggregate: ConfigRedirect_Aggregate;
  /** fetch data from the table: "ConfigRedirect" using primary key columns */
  ConfigRedirect_by_pk?: Maybe<ConfigRedirect>;
  /** fetch data from the table in a streaming manner: "ConfigRedirect" */
  ConfigRedirect_stream: Array<ConfigRedirect>;
  /** fetch data from the table: "District" */
  District: Array<District>;
  /** fetch aggregated fields from the table: "District" */
  District_aggregate: District_Aggregate;
  /** fetch data from the table: "District" using primary key columns */
  District_by_pk?: Maybe<District>;
  /** fetch data from the table in a streaming manner: "District" */
  District_stream: Array<District>;
  /** fetch data from the table: "Email" */
  Email: Array<Email>;
  /** fetch aggregated fields from the table: "Email" */
  Email_aggregate: Email_Aggregate;
  /** fetch data from the table: "Email" using primary key columns */
  Email_by_pk?: Maybe<Email>;
  /** fetch data from the table in a streaming manner: "Email" */
  Email_stream: Array<Email>;
  /** fetch data from the table: "EventPermission" */
  EventPermission: Array<EventPermission>;
  /** fetch aggregated fields from the table: "EventPermission" */
  EventPermission_aggregate: EventPermission_Aggregate;
  /** fetch data from the table: "EventPermission" using primary key columns */
  EventPermission_by_pk?: Maybe<EventPermission>;
  /** fetch data from the table in a streaming manner: "EventPermission" */
  EventPermission_stream: Array<EventPermission>;
  /** fetch data from the table: "FundedTree" */
  FundedTree: Array<FundedTree>;
  /** fetch aggregated fields from the table: "FundedTree" */
  FundedTree_aggregate: FundedTree_Aggregate;
  /** fetch data from the table: "FundedTree" using primary key columns */
  FundedTree_by_pk?: Maybe<FundedTree>;
  /** fetch data from the table in a streaming manner: "FundedTree" */
  FundedTree_stream: Array<FundedTree>;
  /** fetch data from the table: "Funder" */
  Funder: Array<Funder>;
  /** fetch data from the table: "FunderStat" */
  FunderStat: Array<FunderStat>;
  /** fetch aggregated fields from the table: "FunderStat" */
  FunderStat_aggregate: FunderStat_Aggregate;
  /** fetch data from the table in a streaming manner: "FunderStat" */
  FunderStat_stream: Array<FunderStat>;
  /** execute function "FunderStatsForUser" which returns "FunderStat" */
  FunderStatsForUser: Array<FunderStat>;
  /** execute function "FunderStatsForUser" and query aggregates on result of table type "FunderStat" */
  FunderStatsForUser_aggregate: FunderStat_Aggregate;
  /** fetch data from the table: "FunderView" */
  FunderView: Array<FunderView>;
  /** fetch aggregated fields from the table: "FunderView" */
  FunderView_aggregate: FunderView_Aggregate;
  /** fetch data from the table in a streaming manner: "FunderView" */
  FunderView_stream: Array<FunderView>;
  /** fetch aggregated fields from the table: "Funder" */
  Funder_aggregate: Funder_Aggregate;
  /** fetch data from the table: "Funder" using primary key columns */
  Funder_by_pk?: Maybe<Funder>;
  /** fetch data from the table in a streaming manner: "Funder" */
  Funder_stream: Array<Funder>;
  /** fetch data from the table: "GiftCategory" */
  GiftCategory: Array<GiftCategory>;
  /** fetch aggregated fields from the table: "GiftCategory" */
  GiftCategory_aggregate: GiftCategory_Aggregate;
  /** fetch data from the table: "GiftCategory" using primary key columns */
  GiftCategory_by_pk?: Maybe<GiftCategory>;
  /** fetch data from the table in a streaming manner: "GiftCategory" */
  GiftCategory_stream: Array<GiftCategory>;
  /** fetch data from the table: "GiftTemplate" */
  GiftTemplate: Array<GiftTemplate>;
  /** fetch aggregated fields from the table: "GiftTemplate" */
  GiftTemplate_aggregate: GiftTemplate_Aggregate;
  /** fetch data from the table: "GiftTemplate" using primary key columns */
  GiftTemplate_by_pk?: Maybe<GiftTemplate>;
  /** fetch data from the table in a streaming manner: "GiftTemplate" */
  GiftTemplate_stream: Array<GiftTemplate>;
  /** fetch data from the table: "GiftedTree" */
  GiftedTree: Array<GiftedTree>;
  /** fetch aggregated fields from the table: "GiftedTree" */
  GiftedTree_aggregate: GiftedTree_Aggregate;
  /** fetch data from the table: "GiftedTree" using primary key columns */
  GiftedTree_by_pk?: Maybe<GiftedTree>;
  /** fetch data from the table in a streaming manner: "GiftedTree" */
  GiftedTree_stream: Array<GiftedTree>;
  /** fetch data from the table: "IPLocation" */
  IPLocation: Array<IpLocation>;
  /** fetch aggregated fields from the table: "IPLocation" */
  IPLocation_aggregate: IpLocation_Aggregate;
  /** fetch data from the table: "IPLocation" using primary key columns */
  IPLocation_by_pk?: Maybe<IpLocation>;
  /** fetch data from the table in a streaming manner: "IPLocation" */
  IPLocation_stream: Array<IpLocation>;
  /** An array relationship */
  Instruction: Array<Instruction>;
  /** fetch data from the table: "InstructionView" */
  InstructionView: Array<InstructionView>;
  /** fetch aggregated fields from the table: "InstructionView" */
  InstructionView_aggregate: InstructionView_Aggregate;
  /** fetch data from the table in a streaming manner: "InstructionView" */
  InstructionView_stream: Array<InstructionView>;
  /** An aggregate relationship */
  Instruction_aggregate: Instruction_Aggregate;
  /** fetch data from the table: "Instruction" using primary key columns */
  Instruction_by_pk?: Maybe<Instruction>;
  /** fetch data from the table in a streaming manner: "Instruction" */
  Instruction_stream: Array<Instruction>;
  /** fetch data from the table: "Invite" */
  Invite: Array<Invite>;
  /** fetch aggregated fields from the table: "Invite" */
  Invite_aggregate: Invite_Aggregate;
  /** fetch data from the table: "Invite" using primary key columns */
  Invite_by_pk?: Maybe<Invite>;
  /** fetch data from the table in a streaming manner: "Invite" */
  Invite_stream: Array<Invite>;
  /** fetch data from the table: "LoginEvent" */
  LoginEvent: Array<LoginEvent>;
  /** fetch aggregated fields from the table: "LoginEvent" */
  LoginEvent_aggregate: LoginEvent_Aggregate;
  /** fetch data from the table: "LoginEvent" using primary key columns */
  LoginEvent_by_pk?: Maybe<LoginEvent>;
  /** fetch data from the table in a streaming manner: "LoginEvent" */
  LoginEvent_stream: Array<LoginEvent>;
  /** fetch data from the table: "Match" */
  Match: Array<Match>;
  /** fetch aggregated fields from the table: "Match" */
  Match_aggregate: Match_Aggregate;
  /** fetch data from the table: "Match" using primary key columns */
  Match_by_pk?: Maybe<Match>;
  /** fetch data from the table in a streaming manner: "Match" */
  Match_stream: Array<Match>;
  /** fetch data from the table: "Membership" */
  Membership: Array<Membership>;
  /** fetch aggregated fields from the table: "Membership" */
  Membership_aggregate: Membership_Aggregate;
  /** fetch data from the table: "Membership" using primary key columns */
  Membership_by_pk?: Maybe<Membership>;
  /** fetch data from the table in a streaming manner: "Membership" */
  Membership_stream: Array<Membership>;
  /** fetch data from the table: "MonitoringAsset" */
  MonitoringAsset: Array<MonitoringAsset>;
  /** fetch aggregated fields from the table: "MonitoringAsset" */
  MonitoringAsset_aggregate: MonitoringAsset_Aggregate;
  /** fetch data from the table: "MonitoringAsset" using primary key columns */
  MonitoringAsset_by_pk?: Maybe<MonitoringAsset>;
  /** fetch data from the table in a streaming manner: "MonitoringAsset" */
  MonitoringAsset_stream: Array<MonitoringAsset>;
  /** fetch data from the table: "MonitoringEvent" */
  MonitoringEvent: Array<MonitoringEvent>;
  /** fetch aggregated fields from the table: "MonitoringEvent" */
  MonitoringEvent_aggregate: MonitoringEvent_Aggregate;
  /** fetch data from the table: "MonitoringEvent" using primary key columns */
  MonitoringEvent_by_pk?: Maybe<MonitoringEvent>;
  /** fetch data from the table in a streaming manner: "MonitoringEvent" */
  MonitoringEvent_stream: Array<MonitoringEvent>;
  /** fetch data from the table: "MonitoringLine" */
  MonitoringLine: Array<MonitoringLine>;
  /** fetch aggregated fields from the table: "MonitoringLine" */
  MonitoringLine_aggregate: MonitoringLine_Aggregate;
  /** fetch data from the table: "MonitoringLine" using primary key columns */
  MonitoringLine_by_pk?: Maybe<MonitoringLine>;
  /** fetch data from the table in a streaming manner: "MonitoringLine" */
  MonitoringLine_stream: Array<MonitoringLine>;
  /** fetch data from the table: "Plan" */
  Plan: Array<Plan>;
  /** fetch data from the table: "PlanLine" */
  PlanLine: Array<PlanLine>;
  /** fetch aggregated fields from the table: "PlanLine" */
  PlanLine_aggregate: PlanLine_Aggregate;
  /** fetch data from the table: "PlanLine" using primary key columns */
  PlanLine_by_pk?: Maybe<PlanLine>;
  /** fetch data from the table in a streaming manner: "PlanLine" */
  PlanLine_stream: Array<PlanLine>;
  /** fetch aggregated fields from the table: "Plan" */
  Plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "Plan" using primary key columns */
  Plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table in a streaming manner: "Plan" */
  Plan_stream: Array<Plan>;
  /** fetch data from the table: "Planter" */
  Planter: Array<Planter>;
  /** fetch data from the table: "PlanterRegistration" */
  PlanterRegistration: Array<PlanterRegistration>;
  /** fetch data from the table: "PlanterRegistrationAsset" */
  PlanterRegistrationAsset: Array<PlanterRegistrationAsset>;
  /** fetch aggregated fields from the table: "PlanterRegistrationAsset" */
  PlanterRegistrationAsset_aggregate: PlanterRegistrationAsset_Aggregate;
  /** fetch data from the table: "PlanterRegistrationAsset" using primary key columns */
  PlanterRegistrationAsset_by_pk?: Maybe<PlanterRegistrationAsset>;
  /** fetch data from the table in a streaming manner: "PlanterRegistrationAsset" */
  PlanterRegistrationAsset_stream: Array<PlanterRegistrationAsset>;
  /** fetch aggregated fields from the table: "PlanterRegistration" */
  PlanterRegistration_aggregate: PlanterRegistration_Aggregate;
  /** fetch data from the table: "PlanterRegistration" using primary key columns */
  PlanterRegistration_by_pk?: Maybe<PlanterRegistration>;
  /** fetch data from the table in a streaming manner: "PlanterRegistration" */
  PlanterRegistration_stream: Array<PlanterRegistration>;
  /** fetch data from the table: "PlanterStat" */
  PlanterStat: Array<PlanterStat>;
  /** fetch aggregated fields from the table: "PlanterStat" */
  PlanterStat_aggregate: PlanterStat_Aggregate;
  /** fetch data from the table in a streaming manner: "PlanterStat" */
  PlanterStat_stream: Array<PlanterStat>;
  /** execute function "PlanterStatsForUser" which returns "PlanterStat" */
  PlanterStatsForUser: Array<PlanterStat>;
  /** execute function "PlanterStatsForUser" and query aggregates on result of table type "PlanterStat" */
  PlanterStatsForUser_aggregate: PlanterStat_Aggregate;
  /** fetch data from the table: "PlanterView" */
  PlanterView: Array<PlanterView>;
  /** fetch aggregated fields from the table: "PlanterView" */
  PlanterView_aggregate: PlanterView_Aggregate;
  /** fetch data from the table in a streaming manner: "PlanterView" */
  PlanterView_stream: Array<PlanterView>;
  /** fetch aggregated fields from the table: "Planter" */
  Planter_aggregate: Planter_Aggregate;
  /** fetch data from the table: "Planter" using primary key columns */
  Planter_by_pk?: Maybe<Planter>;
  /** fetch data from the table in a streaming manner: "Planter" */
  Planter_stream: Array<Planter>;
  /** fetch data from the table: "Planting" */
  Planting: Array<Planting>;
  /** fetch data from the table: "PlantingAsset" */
  PlantingAsset: Array<PlantingAsset>;
  /** fetch aggregated fields from the table: "PlantingAsset" */
  PlantingAsset_aggregate: PlantingAsset_Aggregate;
  /** fetch data from the table: "PlantingAsset" using primary key columns */
  PlantingAsset_by_pk?: Maybe<PlantingAsset>;
  /** fetch data from the table in a streaming manner: "PlantingAsset" */
  PlantingAsset_stream: Array<PlantingAsset>;
  /** fetch data from the table: "PlantingLine" */
  PlantingLine: Array<PlantingLine>;
  /** fetch aggregated fields from the table: "PlantingLine" */
  PlantingLine_aggregate: PlantingLine_Aggregate;
  /** fetch data from the table: "PlantingLine" using primary key columns */
  PlantingLine_by_pk?: Maybe<PlantingLine>;
  /** fetch data from the table in a streaming manner: "PlantingLine" */
  PlantingLine_stream: Array<PlantingLine>;
  /** fetch data from the table: "PlantingSite" */
  PlantingSite: Array<PlantingSite>;
  /** fetch data from the table: "PlantingSiteAsset" */
  PlantingSiteAsset: Array<PlantingSiteAsset>;
  /** fetch aggregated fields from the table: "PlantingSiteAsset" */
  PlantingSiteAsset_aggregate: PlantingSiteAsset_Aggregate;
  /** fetch data from the table: "PlantingSiteAsset" using primary key columns */
  PlantingSiteAsset_by_pk?: Maybe<PlantingSiteAsset>;
  /** fetch data from the table in a streaming manner: "PlantingSiteAsset" */
  PlantingSiteAsset_stream: Array<PlantingSiteAsset>;
  /** fetch aggregated fields from the table: "PlantingSite" */
  PlantingSite_aggregate: PlantingSite_Aggregate;
  /** fetch data from the table: "PlantingSite" using primary key columns */
  PlantingSite_by_pk?: Maybe<PlantingSite>;
  /** fetch data from the table in a streaming manner: "PlantingSite" */
  PlantingSite_stream: Array<PlantingSite>;
  /** fetch aggregated fields from the table: "Planting" */
  Planting_aggregate: Planting_Aggregate;
  /** fetch data from the table: "Planting" using primary key columns */
  Planting_by_pk?: Maybe<Planting>;
  /** fetch data from the table in a streaming manner: "Planting" */
  Planting_stream: Array<Planting>;
  /** fetch data from the table: "Product" */
  Product: Array<Product>;
  /** fetch data from the table: "ProductPrice" */
  ProductPrice: Array<ProductPrice>;
  /** fetch aggregated fields from the table: "ProductPrice" */
  ProductPrice_aggregate: ProductPrice_Aggregate;
  /** fetch data from the table: "ProductPrice" using primary key columns */
  ProductPrice_by_pk?: Maybe<ProductPrice>;
  /** fetch data from the table in a streaming manner: "ProductPrice" */
  ProductPrice_stream: Array<ProductPrice>;
  /** fetch aggregated fields from the table: "Product" */
  Product_aggregate: Product_Aggregate;
  /** fetch data from the table: "Product" using primary key columns */
  Product_by_pk?: Maybe<Product>;
  /** fetch data from the table in a streaming manner: "Product" */
  Product_stream: Array<Product>;
  /** fetch data from the table: "Project" */
  Project: Array<Project>;
  /** fetch data from the table: "ProjectAsset" */
  ProjectAsset: Array<ProjectAsset>;
  /** fetch aggregated fields from the table: "ProjectAsset" */
  ProjectAsset_aggregate: ProjectAsset_Aggregate;
  /** fetch data from the table: "ProjectAsset" using primary key columns */
  ProjectAsset_by_pk?: Maybe<ProjectAsset>;
  /** fetch data from the table in a streaming manner: "ProjectAsset" */
  ProjectAsset_stream: Array<ProjectAsset>;
  /** fetch data from the table: "ProjectNote" */
  ProjectNote: Array<ProjectNote>;
  /** fetch data from the table: "ProjectNoteApplication" */
  ProjectNoteApplication: Array<ProjectNoteApplication>;
  /** fetch aggregated fields from the table: "ProjectNoteApplication" */
  ProjectNoteApplication_aggregate: ProjectNoteApplication_Aggregate;
  /** fetch data from the table: "ProjectNoteApplication" using primary key columns */
  ProjectNoteApplication_by_pk?: Maybe<ProjectNoteApplication>;
  /** fetch data from the table in a streaming manner: "ProjectNoteApplication" */
  ProjectNoteApplication_stream: Array<ProjectNoteApplication>;
  /** fetch data from the table: "ProjectNoteAsset" */
  ProjectNoteAsset: Array<ProjectNoteAsset>;
  /** fetch aggregated fields from the table: "ProjectNoteAsset" */
  ProjectNoteAsset_aggregate: ProjectNoteAsset_Aggregate;
  /** fetch data from the table: "ProjectNoteAsset" using primary key columns */
  ProjectNoteAsset_by_pk?: Maybe<ProjectNoteAsset>;
  /** fetch data from the table in a streaming manner: "ProjectNoteAsset" */
  ProjectNoteAsset_stream: Array<ProjectNoteAsset>;
  /** fetch aggregated fields from the table: "ProjectNote" */
  ProjectNote_aggregate: ProjectNote_Aggregate;
  /** fetch data from the table: "ProjectNote" using primary key columns */
  ProjectNote_by_pk?: Maybe<ProjectNote>;
  /** fetch data from the table in a streaming manner: "ProjectNote" */
  ProjectNote_stream: Array<ProjectNote>;
  /** fetch data from the table: "ProjectStats" */
  ProjectStats: Array<ProjectStats>;
  /** fetch aggregated fields from the table: "ProjectStats" */
  ProjectStats_aggregate: ProjectStats_Aggregate;
  /** fetch data from the table in a streaming manner: "ProjectStats" */
  ProjectStats_stream: Array<ProjectStats>;
  /** fetch data from the table: "ProjectView" */
  ProjectView: Array<ProjectView>;
  /** fetch aggregated fields from the table: "ProjectView" */
  ProjectView_aggregate: ProjectView_Aggregate;
  /** fetch data from the table in a streaming manner: "ProjectView" */
  ProjectView_stream: Array<ProjectView>;
  /** fetch aggregated fields from the table: "Project" */
  Project_aggregate: Project_Aggregate;
  /** fetch data from the table: "Project" using primary key columns */
  Project_by_pk?: Maybe<Project>;
  /** fetch data from the table in a streaming manner: "Project" */
  Project_stream: Array<Project>;
  /** fetch data from the table: "PublicFunderStat" */
  PublicFunderStat: Array<PublicFunderStat>;
  /** fetch aggregated fields from the table: "PublicFunderStat" */
  PublicFunderStat_aggregate: PublicFunderStat_Aggregate;
  /** fetch data from the table in a streaming manner: "PublicFunderStat" */
  PublicFunderStat_stream: Array<PublicFunderStat>;
  /** execute function "PublicFunderStatsForAccount" which returns "PublicFunderStat" */
  PublicFunderStatsForAccount: Array<PublicFunderStat>;
  /** execute function "PublicFunderStatsForAccount" and query aggregates on result of table type "PublicFunderStat" */
  PublicFunderStatsForAccount_aggregate: PublicFunderStat_Aggregate;
  /** fetch data from the table: "PublicPlanterStat" */
  PublicPlanterStat: Array<PublicPlanterStat>;
  /** fetch aggregated fields from the table: "PublicPlanterStat" */
  PublicPlanterStat_aggregate: PublicPlanterStat_Aggregate;
  /** fetch data from the table in a streaming manner: "PublicPlanterStat" */
  PublicPlanterStat_stream: Array<PublicPlanterStat>;
  /** execute function "PublicPlanterStatsForAccount" which returns "PublicPlanterStat" */
  PublicPlanterStatsForAccount: Array<PublicPlanterStat>;
  /** execute function "PublicPlanterStatsForAccount" and query aggregates on result of table type "PublicPlanterStat" */
  PublicPlanterStatsForAccount_aggregate: PublicPlanterStat_Aggregate;
  /** An array relationship */
  Purchase: Array<Purchase>;
  /** fetch data from the table: "PurchaseDashboardView" */
  PurchaseDashboardView: Array<PurchaseDashboardView>;
  /** fetch aggregated fields from the table: "PurchaseDashboardView" */
  PurchaseDashboardView_aggregate: PurchaseDashboardView_Aggregate;
  /** fetch data from the table in a streaming manner: "PurchaseDashboardView" */
  PurchaseDashboardView_stream: Array<PurchaseDashboardView>;
  /** fetch data from the table: "PurchaseEvent" */
  PurchaseEvent: Array<PurchaseEvent>;
  /** fetch aggregated fields from the table: "PurchaseEvent" */
  PurchaseEvent_aggregate: PurchaseEvent_Aggregate;
  /** fetch data from the table: "PurchaseEvent" using primary key columns */
  PurchaseEvent_by_pk?: Maybe<PurchaseEvent>;
  /** fetch data from the table in a streaming manner: "PurchaseEvent" */
  PurchaseEvent_stream: Array<PurchaseEvent>;
  /** fetch data from the table: "PurchaseView" */
  PurchaseView: Array<PurchaseView>;
  /** fetch aggregated fields from the table: "PurchaseView" */
  PurchaseView_aggregate: PurchaseView_Aggregate;
  /** fetch data from the table in a streaming manner: "PurchaseView" */
  PurchaseView_stream: Array<PurchaseView>;
  /** An aggregate relationship */
  Purchase_aggregate: Purchase_Aggregate;
  /** fetch data from the table: "Purchase" using primary key columns */
  Purchase_by_pk?: Maybe<Purchase>;
  /** fetch data from the table in a streaming manner: "Purchase" */
  Purchase_stream: Array<Purchase>;
  /** fetch data from the table: "Region" */
  Region: Array<Region>;
  /** fetch data from the table: "RegionDistrict" */
  RegionDistrict: Array<RegionDistrict>;
  /** fetch aggregated fields from the table: "RegionDistrict" */
  RegionDistrict_aggregate: RegionDistrict_Aggregate;
  /** fetch data from the table: "RegionDistrict" using primary key columns */
  RegionDistrict_by_pk?: Maybe<RegionDistrict>;
  /** fetch data from the table in a streaming manner: "RegionDistrict" */
  RegionDistrict_stream: Array<RegionDistrict>;
  /** fetch aggregated fields from the table: "Region" */
  Region_aggregate: Region_Aggregate;
  /** fetch data from the table: "Region" using primary key columns */
  Region_by_pk?: Maybe<Region>;
  /** fetch data from the table in a streaming manner: "Region" */
  Region_stream: Array<Region>;
  /** fetch data from the table: "Registry" */
  Registry: Array<Registry>;
  /** fetch data from the table: "RegistryView" */
  RegistryView: Array<RegistryView>;
  /** fetch aggregated fields from the table: "RegistryView" */
  RegistryView_aggregate: RegistryView_Aggregate;
  /** fetch data from the table in a streaming manner: "RegistryView" */
  RegistryView_stream: Array<RegistryView>;
  /** fetch aggregated fields from the table: "Registry" */
  Registry_aggregate: Registry_Aggregate;
  /** fetch data from the table: "Registry" using primary key columns */
  Registry_by_pk?: Maybe<Registry>;
  /** fetch data from the table in a streaming manner: "Registry" */
  Registry_stream: Array<Registry>;
  /** fetch data from the table: "Report" */
  Report: Array<Report>;
  /** fetch aggregated fields from the table: "Report" */
  Report_aggregate: Report_Aggregate;
  /** fetch data from the table: "Report" using primary key columns */
  Report_by_pk?: Maybe<Report>;
  /** fetch data from the table in a streaming manner: "Report" */
  Report_stream: Array<Report>;
  /** fetch data from the table: "Sample" */
  Sample: Array<Sample>;
  /** fetch data from the table: "SampleLine" */
  SampleLine: Array<SampleLine>;
  /** fetch aggregated fields from the table: "SampleLine" */
  SampleLine_aggregate: SampleLine_Aggregate;
  /** fetch data from the table: "SampleLine" using primary key columns */
  SampleLine_by_pk?: Maybe<SampleLine>;
  /** fetch data from the table in a streaming manner: "SampleLine" */
  SampleLine_stream: Array<SampleLine>;
  /** fetch aggregated fields from the table: "Sample" */
  Sample_aggregate: Sample_Aggregate;
  /** fetch data from the table: "Sample" using primary key columns */
  Sample_by_pk?: Maybe<Sample>;
  /** fetch data from the table in a streaming manner: "Sample" */
  Sample_stream: Array<Sample>;
  /** fetch data from the table: "ScheduledEmail" */
  ScheduledEmail: Array<ScheduledEmail>;
  /** fetch aggregated fields from the table: "ScheduledEmail" */
  ScheduledEmail_aggregate: ScheduledEmail_Aggregate;
  /** fetch data from the table: "ScheduledEmail" using primary key columns */
  ScheduledEmail_by_pk?: Maybe<ScheduledEmail>;
  /** fetch data from the table in a streaming manner: "ScheduledEmail" */
  ScheduledEmail_stream: Array<ScheduledEmail>;
  /** fetch data from the table: "Season" */
  Season: Array<Season>;
  /** fetch aggregated fields from the table: "Season" */
  Season_aggregate: Season_Aggregate;
  /** fetch data from the table: "Season" using primary key columns */
  Season_by_pk?: Maybe<Season>;
  /** fetch data from the table in a streaming manner: "Season" */
  Season_stream: Array<Season>;
  /** fetch data from the table: "Species" */
  Species: Array<Species>;
  /** fetch aggregated fields from the table: "Species" */
  Species_aggregate: Species_Aggregate;
  /** fetch data from the table: "Species" using primary key columns */
  Species_by_pk?: Maybe<Species>;
  /** fetch data from the table in a streaming manner: "Species" */
  Species_stream: Array<Species>;
  /** fetch data from the table: "StatisticsView" */
  StatisticsView: Array<StatisticsView>;
  /** fetch aggregated fields from the table: "StatisticsView" */
  StatisticsView_aggregate: StatisticsView_Aggregate;
  /** fetch data from the table in a streaming manner: "StatisticsView" */
  StatisticsView_stream: Array<StatisticsView>;
  /** fetch data from the table: "Subscription" */
  Subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "Subscription" */
  Subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "Subscription" using primary key columns */
  Subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table in a streaming manner: "Subscription" */
  Subscription_stream: Array<Subscription>;
  /** fetch data from the table: "SupportedProjectsView" */
  SupportedProjectsView: Array<SupportedProjectsView>;
  /** fetch aggregated fields from the table: "SupportedProjectsView" */
  SupportedProjectsView_aggregate: SupportedProjectsView_Aggregate;
  /** fetch data from the table in a streaming manner: "SupportedProjectsView" */
  SupportedProjectsView_stream: Array<SupportedProjectsView>;
  /** fetch data from the table: "TTCPlanting" */
  TTCPlanting: Array<TtcPlanting>;
  /** fetch aggregated fields from the table: "TTCPlanting" */
  TTCPlanting_aggregate: TtcPlanting_Aggregate;
  /** fetch data from the table in a streaming manner: "TTCPlanting" */
  TTCPlanting_stream: Array<TtcPlanting>;
  /** fetch data from the table: "TemplateCategory" */
  TemplateCategory: Array<TemplateCategory>;
  /** fetch aggregated fields from the table: "TemplateCategory" */
  TemplateCategory_aggregate: TemplateCategory_Aggregate;
  /** fetch data from the table: "TemplateCategory" using primary key columns */
  TemplateCategory_by_pk?: Maybe<TemplateCategory>;
  /** fetch data from the table in a streaming manner: "TemplateCategory" */
  TemplateCategory_stream: Array<TemplateCategory>;
  /** fetch data from the table: "TreeEvent" */
  TreeEvent: Array<TreeEvent>;
  /** fetch aggregated fields from the table: "TreeEvent" */
  TreeEvent_aggregate: TreeEvent_Aggregate;
  /** fetch data from the table: "TreeEvent" using primary key columns */
  TreeEvent_by_pk?: Maybe<TreeEvent>;
  /** fetch data from the table in a streaming manner: "TreeEvent" */
  TreeEvent_stream: Array<TreeEvent>;
  /** fetch data from the table: "TreePoolStatsView" */
  TreePoolStatsView: Array<TreePoolStatsView>;
  /** fetch aggregated fields from the table: "TreePoolStatsView" */
  TreePoolStatsView_aggregate: TreePoolStatsView_Aggregate;
  /** fetch data from the table in a streaming manner: "TreePoolStatsView" */
  TreePoolStatsView_stream: Array<TreePoolStatsView>;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserEvent" */
  UserEvent: Array<UserEvent>;
  /** fetch data from the table: "UserEventView" */
  UserEventView: Array<UserEventView>;
  /** fetch aggregated fields from the table: "UserEventView" */
  UserEventView_aggregate: UserEventView_Aggregate;
  /** fetch data from the table in a streaming manner: "UserEventView" */
  UserEventView_stream: Array<UserEventView>;
  /** fetch aggregated fields from the table: "UserEvent" */
  UserEvent_aggregate: UserEvent_Aggregate;
  /** fetch data from the table: "UserEvent" using primary key columns */
  UserEvent_by_pk?: Maybe<UserEvent>;
  /** fetch data from the table in a streaming manner: "UserEvent" */
  UserEvent_stream: Array<UserEvent>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_Aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "User" */
  User_stream: Array<User>;
  /** fetch data from the table: "Variable" */
  Variable: Array<Variable>;
  /** fetch aggregated fields from the table: "Variable" */
  Variable_aggregate: Variable_Aggregate;
  /** fetch data from the table: "Variable" using primary key columns */
  Variable_by_pk?: Maybe<Variable>;
  /** fetch data from the table in a streaming manner: "Variable" */
  Variable_stream: Array<Variable>;
  /** execute function "getAccountSupporters" which returns "AccountSupporters" */
  getAccountSupporters: Array<AccountSupporters>;
  /** execute function "getAccountSupporters" and query aggregates on result of table type "AccountSupporters" */
  getAccountSupporters_aggregate: AccountSupporters_Aggregate;
};


export type Subscription_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccountSupportersArgs = {
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Subscription_RootAccountSupporters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Subscription_RootAccountSupporters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountSupporters_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Subscription_RootAccountViewArgs = {
  distinct_on?: InputMaybe<Array<AccountView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountView_Order_By>>;
  where?: InputMaybe<AccountView_Bool_Exp>;
};


export type Subscription_RootAccountView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AccountView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountView_Order_By>>;
  where?: InputMaybe<AccountView_Bool_Exp>;
};


export type Subscription_RootAccountView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccountView_Stream_Cursor_Input>>;
  where?: InputMaybe<AccountView_Bool_Exp>;
};


export type Subscription_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootAccount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootActionNotesArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


export type Subscription_RootActionNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActionNotes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActionNotes_Order_By>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


export type Subscription_RootActionNotes_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootActionNotes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ActionNotes_Stream_Cursor_Input>>;
  where?: InputMaybe<ActionNotes_Bool_Exp>;
};


export type Subscription_RootActualArgs = {
  distinct_on?: InputMaybe<Array<Actual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Order_By>>;
  where?: InputMaybe<Actual_Bool_Exp>;
};


export type Subscription_RootActualLineArgs = {
  distinct_on?: InputMaybe<Array<ActualLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActualLine_Order_By>>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};


export type Subscription_RootActualLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActualLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ActualLine_Order_By>>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};


export type Subscription_RootActualLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootActualLine_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ActualLine_Stream_Cursor_Input>>;
  where?: InputMaybe<ActualLine_Bool_Exp>;
};


export type Subscription_RootActual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Actual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Actual_Order_By>>;
  where?: InputMaybe<Actual_Bool_Exp>;
};


export type Subscription_RootActual_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootActual_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Actual_Stream_Cursor_Input>>;
  where?: InputMaybe<Actual_Bool_Exp>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAdminBulkGiftViewArgs = {
  distinct_on?: InputMaybe<Array<AdminBulkGiftView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminBulkGiftView_Order_By>>;
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
};


export type Subscription_RootAdminBulkGiftView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdminBulkGiftView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminBulkGiftView_Order_By>>;
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
};


export type Subscription_RootAdminBulkGiftView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdminBulkGiftView_Stream_Cursor_Input>>;
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
};


export type Subscription_RootAdminPurchaseViewArgs = {
  distinct_on?: InputMaybe<Array<AdminPurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By>>;
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
};


export type Subscription_RootAdminPurchaseView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AdminPurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By>>;
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
};


export type Subscription_RootAdminPurchaseView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdminPurchaseView_Stream_Cursor_Input>>;
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
};


export type Subscription_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplicationAssetArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


export type Subscription_RootApplicationAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationAsset_Order_By>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


export type Subscription_RootApplicationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootApplicationAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<ApplicationAsset_Bool_Exp>;
};


export type Subscription_RootApplicationViewArgs = {
  distinct_on?: InputMaybe<Array<ApplicationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationView_Order_By>>;
  where?: InputMaybe<ApplicationView_Bool_Exp>;
};


export type Subscription_RootApplicationView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationView_Order_By>>;
  where?: InputMaybe<ApplicationView_Bool_Exp>;
};


export type Subscription_RootApplicationView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationView_Stream_Cursor_Input>>;
  where?: InputMaybe<ApplicationView_Bool_Exp>;
};


export type Subscription_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootApplication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Application_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApprovedTreesViewArgs = {
  distinct_on?: InputMaybe<Array<ApprovedTreesView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovedTreesView_Order_By>>;
  where?: InputMaybe<ApprovedTreesView_Bool_Exp>;
};


export type Subscription_RootApprovedTreesView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ApprovedTreesView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApprovedTreesView_Order_By>>;
  where?: InputMaybe<ApprovedTreesView_Bool_Exp>;
};


export type Subscription_RootApprovedTreesView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApprovedTreesView_Stream_Cursor_Input>>;
  where?: InputMaybe<ApprovedTreesView_Bool_Exp>;
};


export type Subscription_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


export type Subscription_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Attachment_Order_By>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


export type Subscription_RootAttachment_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootAttachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Attachment_Bool_Exp>;
};


export type Subscription_RootBulkRequestArgs = {
  distinct_on?: InputMaybe<Array<BulkRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequest_Order_By>>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};


export type Subscription_RootBulkRequestLinesArgs = {
  distinct_on?: InputMaybe<Array<BulkRequestLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequestLines_Order_By>>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};


export type Subscription_RootBulkRequestLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BulkRequestLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequestLines_Order_By>>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};


export type Subscription_RootBulkRequestLines_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootBulkRequestLines_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BulkRequestLines_Stream_Cursor_Input>>;
  where?: InputMaybe<BulkRequestLines_Bool_Exp>;
};


export type Subscription_RootBulkRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BulkRequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BulkRequest_Order_By>>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};


export type Subscription_RootBulkRequest_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootBulkRequest_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BulkRequest_Stream_Cursor_Input>>;
  where?: InputMaybe<BulkRequest_Bool_Exp>;
};


export type Subscription_RootConfigAssetArgs = {
  distinct_on?: InputMaybe<Array<ConfigAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigAsset_Order_By>>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};


export type Subscription_RootConfigAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigAsset_Order_By>>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};


export type Subscription_RootConfigAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootConfigAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<ConfigAsset_Bool_Exp>;
};


export type Subscription_RootConfigRedirectArgs = {
  distinct_on?: InputMaybe<Array<ConfigRedirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigRedirect_Order_By>>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};


export type Subscription_RootConfigRedirect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConfigRedirect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConfigRedirect_Order_By>>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};


export type Subscription_RootConfigRedirect_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootConfigRedirect_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConfigRedirect_Stream_Cursor_Input>>;
  where?: InputMaybe<ConfigRedirect_Bool_Exp>;
};


export type Subscription_RootDistrictArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Subscription_RootDistrict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Subscription_RootDistrict_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootDistrict_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<District_Stream_Cursor_Input>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Subscription_RootEmailArgs = {
  distinct_on?: InputMaybe<Array<Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Order_By>>;
  where?: InputMaybe<Email_Bool_Exp>;
};


export type Subscription_RootEmail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Order_By>>;
  where?: InputMaybe<Email_Bool_Exp>;
};


export type Subscription_RootEmail_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootEmail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Bool_Exp>;
};


export type Subscription_RootEventPermissionArgs = {
  distinct_on?: InputMaybe<Array<EventPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPermission_Order_By>>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};


export type Subscription_RootEventPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPermission_Order_By>>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};


export type Subscription_RootEventPermission_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootEventPermission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventPermission_Stream_Cursor_Input>>;
  where?: InputMaybe<EventPermission_Bool_Exp>;
};


export type Subscription_RootFundedTreeArgs = {
  distinct_on?: InputMaybe<Array<FundedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FundedTree_Order_By>>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};


export type Subscription_RootFundedTree_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FundedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FundedTree_Order_By>>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};


export type Subscription_RootFundedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootFundedTree_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FundedTree_Stream_Cursor_Input>>;
  where?: InputMaybe<FundedTree_Bool_Exp>;
};


export type Subscription_RootFunderArgs = {
  distinct_on?: InputMaybe<Array<Funder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Funder_Order_By>>;
  where?: InputMaybe<Funder_Bool_Exp>;
};


export type Subscription_RootFunderStatArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Subscription_RootFunderStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Subscription_RootFunderStat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunderStat_Stream_Cursor_Input>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Subscription_RootFunderStatsForUserArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Subscription_RootFunderStatsForUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderStat_Order_By>>;
  where?: InputMaybe<FunderStat_Bool_Exp>;
};


export type Subscription_RootFunderViewArgs = {
  distinct_on?: InputMaybe<Array<FunderView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderView_Order_By>>;
  where?: InputMaybe<FunderView_Bool_Exp>;
};


export type Subscription_RootFunderView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FunderView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunderView_Order_By>>;
  where?: InputMaybe<FunderView_Bool_Exp>;
};


export type Subscription_RootFunderView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunderView_Stream_Cursor_Input>>;
  where?: InputMaybe<FunderView_Bool_Exp>;
};


export type Subscription_RootFunder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Funder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Funder_Order_By>>;
  where?: InputMaybe<Funder_Bool_Exp>;
};


export type Subscription_RootFunder_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootFunder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Funder_Stream_Cursor_Input>>;
  where?: InputMaybe<Funder_Bool_Exp>;
};


export type Subscription_RootGiftCategoryArgs = {
  distinct_on?: InputMaybe<Array<GiftCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftCategory_Order_By>>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};


export type Subscription_RootGiftCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftCategory_Order_By>>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};


export type Subscription_RootGiftCategory_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootGiftCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GiftCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<GiftCategory_Bool_Exp>;
};


export type Subscription_RootGiftTemplateArgs = {
  distinct_on?: InputMaybe<Array<GiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftTemplate_Order_By>>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};


export type Subscription_RootGiftTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftTemplate_Order_By>>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};


export type Subscription_RootGiftTemplate_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootGiftTemplate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GiftTemplate_Stream_Cursor_Input>>;
  where?: InputMaybe<GiftTemplate_Bool_Exp>;
};


export type Subscription_RootGiftedTreeArgs = {
  distinct_on?: InputMaybe<Array<GiftedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftedTree_Order_By>>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};


export type Subscription_RootGiftedTree_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GiftedTree_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GiftedTree_Order_By>>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};


export type Subscription_RootGiftedTree_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootGiftedTree_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GiftedTree_Stream_Cursor_Input>>;
  where?: InputMaybe<GiftedTree_Bool_Exp>;
};


export type Subscription_RootIpLocationArgs = {
  distinct_on?: InputMaybe<Array<IpLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IpLocation_Order_By>>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};


export type Subscription_RootIpLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<IpLocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IpLocation_Order_By>>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};


export type Subscription_RootIpLocation_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootIpLocation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IpLocation_Stream_Cursor_Input>>;
  where?: InputMaybe<IpLocation_Bool_Exp>;
};


export type Subscription_RootInstructionArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


export type Subscription_RootInstructionViewArgs = {
  distinct_on?: InputMaybe<Array<InstructionView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InstructionView_Order_By>>;
  where?: InputMaybe<InstructionView_Bool_Exp>;
};


export type Subscription_RootInstructionView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InstructionView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InstructionView_Order_By>>;
  where?: InputMaybe<InstructionView_Bool_Exp>;
};


export type Subscription_RootInstructionView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InstructionView_Stream_Cursor_Input>>;
  where?: InputMaybe<InstructionView_Bool_Exp>;
};


export type Subscription_RootInstruction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instruction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instruction_Order_By>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


export type Subscription_RootInstruction_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootInstruction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Instruction_Stream_Cursor_Input>>;
  where?: InputMaybe<Instruction_Bool_Exp>;
};


export type Subscription_RootInviteArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


export type Subscription_RootInvite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Order_By>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


export type Subscription_RootInvite_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootInvite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Invite_Bool_Exp>;
};


export type Subscription_RootLoginEventArgs = {
  distinct_on?: InputMaybe<Array<LoginEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoginEvent_Order_By>>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};


export type Subscription_RootLoginEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LoginEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LoginEvent_Order_By>>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};


export type Subscription_RootLoginEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootLoginEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LoginEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<LoginEvent_Bool_Exp>;
};


export type Subscription_RootMatchArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


export type Subscription_RootMatch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Order_By>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


export type Subscription_RootMatch_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootMatch_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Match_Stream_Cursor_Input>>;
  where?: InputMaybe<Match_Bool_Exp>;
};


export type Subscription_RootMembershipArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


export type Subscription_RootMembership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Membership_Order_By>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


export type Subscription_RootMembership_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootMembership_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Membership_Stream_Cursor_Input>>;
  where?: InputMaybe<Membership_Bool_Exp>;
};


export type Subscription_RootMonitoringAssetArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


export type Subscription_RootMonitoringAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringAsset_Order_By>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


export type Subscription_RootMonitoringAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootMonitoringAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonitoringAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<MonitoringAsset_Bool_Exp>;
};


export type Subscription_RootMonitoringEventArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


export type Subscription_RootMonitoringEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringEvent_Order_By>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


export type Subscription_RootMonitoringEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootMonitoringEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonitoringEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<MonitoringEvent_Bool_Exp>;
};


export type Subscription_RootMonitoringLineArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


export type Subscription_RootMonitoringLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MonitoringLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitoringLine_Order_By>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


export type Subscription_RootMonitoringLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootMonitoringLine_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonitoringLine_Stream_Cursor_Input>>;
  where?: InputMaybe<MonitoringLine_Bool_Exp>;
};


export type Subscription_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlanLineArgs = {
  distinct_on?: InputMaybe<Array<PlanLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanLine_Order_By>>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};


export type Subscription_RootPlanLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanLine_Order_By>>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};


export type Subscription_RootPlanLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlanLine_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlanLine_Stream_Cursor_Input>>;
  where?: InputMaybe<PlanLine_Bool_Exp>;
};


export type Subscription_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlanterArgs = {
  distinct_on?: InputMaybe<Array<Planter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planter_Order_By>>;
  where?: InputMaybe<Planter_Bool_Exp>;
};


export type Subscription_RootPlanterRegistrationArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


export type Subscription_RootPlanterRegistrationAssetArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


export type Subscription_RootPlanterRegistrationAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistrationAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistrationAsset_Order_By>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


export type Subscription_RootPlanterRegistrationAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlanterRegistrationAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlanterRegistrationAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<PlanterRegistrationAsset_Bool_Exp>;
};


export type Subscription_RootPlanterRegistration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterRegistration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterRegistration_Order_By>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


export type Subscription_RootPlanterRegistration_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlanterRegistration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlanterRegistration_Stream_Cursor_Input>>;
  where?: InputMaybe<PlanterRegistration_Bool_Exp>;
};


export type Subscription_RootPlanterStatArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Subscription_RootPlanterStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Subscription_RootPlanterStat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlanterStat_Stream_Cursor_Input>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Subscription_RootPlanterStatsForUserArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Subscription_RootPlanterStatsForUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterStat_Order_By>>;
  where?: InputMaybe<PlanterStat_Bool_Exp>;
};


export type Subscription_RootPlanterViewArgs = {
  distinct_on?: InputMaybe<Array<PlanterView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterView_Order_By>>;
  where?: InputMaybe<PlanterView_Bool_Exp>;
};


export type Subscription_RootPlanterView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlanterView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlanterView_Order_By>>;
  where?: InputMaybe<PlanterView_Bool_Exp>;
};


export type Subscription_RootPlanterView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlanterView_Stream_Cursor_Input>>;
  where?: InputMaybe<PlanterView_Bool_Exp>;
};


export type Subscription_RootPlanter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planter_Order_By>>;
  where?: InputMaybe<Planter_Bool_Exp>;
};


export type Subscription_RootPlanter_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlanter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Planter_Stream_Cursor_Input>>;
  where?: InputMaybe<Planter_Bool_Exp>;
};


export type Subscription_RootPlantingArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


export type Subscription_RootPlantingAssetArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


export type Subscription_RootPlantingAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingAsset_Order_By>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


export type Subscription_RootPlantingAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlantingAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlantingAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<PlantingAsset_Bool_Exp>;
};


export type Subscription_RootPlantingLineArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


export type Subscription_RootPlantingLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingLine_Order_By>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


export type Subscription_RootPlantingLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlantingLine_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlantingLine_Stream_Cursor_Input>>;
  where?: InputMaybe<PlantingLine_Bool_Exp>;
};


export type Subscription_RootPlantingSiteArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


export type Subscription_RootPlantingSiteAssetArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


export type Subscription_RootPlantingSiteAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSiteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSiteAsset_Order_By>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


export type Subscription_RootPlantingSiteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlantingSiteAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlantingSiteAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<PlantingSiteAsset_Bool_Exp>;
};


export type Subscription_RootPlantingSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PlantingSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PlantingSite_Order_By>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


export type Subscription_RootPlantingSite_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlantingSite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PlantingSite_Stream_Cursor_Input>>;
  where?: InputMaybe<PlantingSite_Bool_Exp>;
};


export type Subscription_RootPlanting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Planting_Order_By>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


export type Subscription_RootPlanting_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPlanting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Planting_Stream_Cursor_Input>>;
  where?: InputMaybe<Planting_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProductPriceArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


export type Subscription_RootProductPrice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProductPrice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProductPrice_Order_By>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


export type Subscription_RootProductPrice_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProductPrice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProductPrice_Stream_Cursor_Input>>;
  where?: InputMaybe<ProductPrice_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProjectAssetArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


export type Subscription_RootProjectAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectAsset_Order_By>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


export type Subscription_RootProjectAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProjectAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectAsset_Bool_Exp>;
};


export type Subscription_RootProjectNoteArgs = {
  distinct_on?: InputMaybe<Array<ProjectNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNote_Order_By>>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};


export type Subscription_RootProjectNoteApplicationArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


export type Subscription_RootProjectNoteApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteApplication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteApplication_Order_By>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


export type Subscription_RootProjectNoteApplication_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProjectNoteApplication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectNoteApplication_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectNoteApplication_Bool_Exp>;
};


export type Subscription_RootProjectNoteAssetArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


export type Subscription_RootProjectNoteAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNoteAsset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNoteAsset_Order_By>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


export type Subscription_RootProjectNoteAsset_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProjectNoteAsset_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectNoteAsset_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectNoteAsset_Bool_Exp>;
};


export type Subscription_RootProjectNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectNote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectNote_Order_By>>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};


export type Subscription_RootProjectNote_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProjectNote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectNote_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectNote_Bool_Exp>;
};


export type Subscription_RootProjectStatsArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


export type Subscription_RootProjectStats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectStats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectStats_Order_By>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


export type Subscription_RootProjectStats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectStats_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectStats_Bool_Exp>;
};


export type Subscription_RootProjectViewArgs = {
  distinct_on?: InputMaybe<Array<ProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectView_Order_By>>;
  where?: InputMaybe<ProjectView_Bool_Exp>;
};


export type Subscription_RootProjectView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProjectView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProjectView_Order_By>>;
  where?: InputMaybe<ProjectView_Bool_Exp>;
};


export type Subscription_RootProjectView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProjectView_Stream_Cursor_Input>>;
  where?: InputMaybe<ProjectView_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootPublicFunderStatArgs = {
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Subscription_RootPublicFunderStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Subscription_RootPublicFunderStat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PublicFunderStat_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Subscription_RootPublicFunderStatsForAccountArgs = {
  args: PublicFunderStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Subscription_RootPublicFunderStatsForAccount_AggregateArgs = {
  args: PublicFunderStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicFunderStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicFunderStat_Order_By>>;
  where?: InputMaybe<PublicFunderStat_Bool_Exp>;
};


export type Subscription_RootPublicPlanterStatArgs = {
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Subscription_RootPublicPlanterStat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Subscription_RootPublicPlanterStat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PublicPlanterStat_Stream_Cursor_Input>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Subscription_RootPublicPlanterStatsForAccountArgs = {
  args: PublicPlanterStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Subscription_RootPublicPlanterStatsForAccount_AggregateArgs = {
  args: PublicPlanterStatsForAccount_Args;
  distinct_on?: InputMaybe<Array<PublicPlanterStat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicPlanterStat_Order_By>>;
  where?: InputMaybe<PublicPlanterStat_Bool_Exp>;
};


export type Subscription_RootPurchaseArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


export type Subscription_RootPurchaseDashboardViewArgs = {
  distinct_on?: InputMaybe<Array<PurchaseDashboardView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseDashboardView_Order_By>>;
  where?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
};


export type Subscription_RootPurchaseDashboardView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseDashboardView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseDashboardView_Order_By>>;
  where?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
};


export type Subscription_RootPurchaseDashboardView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PurchaseDashboardView_Stream_Cursor_Input>>;
  where?: InputMaybe<PurchaseDashboardView_Bool_Exp>;
};


export type Subscription_RootPurchaseEventArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


export type Subscription_RootPurchaseEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseEvent_Order_By>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


export type Subscription_RootPurchaseEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPurchaseEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PurchaseEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<PurchaseEvent_Bool_Exp>;
};


export type Subscription_RootPurchaseViewArgs = {
  distinct_on?: InputMaybe<Array<PurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseView_Order_By>>;
  where?: InputMaybe<PurchaseView_Bool_Exp>;
};


export type Subscription_RootPurchaseView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PurchaseView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PurchaseView_Order_By>>;
  where?: InputMaybe<PurchaseView_Bool_Exp>;
};


export type Subscription_RootPurchaseView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PurchaseView_Stream_Cursor_Input>>;
  where?: InputMaybe<PurchaseView_Bool_Exp>;
};


export type Subscription_RootPurchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Order_By>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


export type Subscription_RootPurchase_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootPurchase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Purchase_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_Bool_Exp>;
};


export type Subscription_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegionDistrictArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


export type Subscription_RootRegionDistrict_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegionDistrict_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegionDistrict_Order_By>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


export type Subscription_RootRegionDistrict_By_PkArgs = {
  DistrictId: Scalars['uuid'];
  RegionId: Scalars['uuid'];
};


export type Subscription_RootRegionDistrict_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RegionDistrict_Stream_Cursor_Input>>;
  where?: InputMaybe<RegionDistrict_Bool_Exp>;
};


export type Subscription_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootRegion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegistryArgs = {
  distinct_on?: InputMaybe<Array<Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registry_Order_By>>;
  where?: InputMaybe<Registry_Bool_Exp>;
};


export type Subscription_RootRegistryViewArgs = {
  distinct_on?: InputMaybe<Array<RegistryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistryView_Order_By>>;
  where?: InputMaybe<RegistryView_Bool_Exp>;
};


export type Subscription_RootRegistryView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RegistryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RegistryView_Order_By>>;
  where?: InputMaybe<RegistryView_Bool_Exp>;
};


export type Subscription_RootRegistryView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RegistryView_Stream_Cursor_Input>>;
  where?: InputMaybe<RegistryView_Bool_Exp>;
};


export type Subscription_RootRegistry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registry_Order_By>>;
  where?: InputMaybe<Registry_Bool_Exp>;
};


export type Subscription_RootRegistry_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootRegistry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Registry_Stream_Cursor_Input>>;
  where?: InputMaybe<Registry_Bool_Exp>;
};


export type Subscription_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootReport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootSampleArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootSampleLineArgs = {
  distinct_on?: InputMaybe<Array<SampleLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLine_Order_By>>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};


export type Subscription_RootSampleLine_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleLine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLine_Order_By>>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};


export type Subscription_RootSampleLine_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootSampleLine_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampleLine_Stream_Cursor_Input>>;
  where?: InputMaybe<SampleLine_Bool_Exp>;
};


export type Subscription_RootSample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootSample_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootSample_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sample_Stream_Cursor_Input>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootScheduledEmailArgs = {
  distinct_on?: InputMaybe<Array<ScheduledEmail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScheduledEmail_Order_By>>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};


export type Subscription_RootScheduledEmail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ScheduledEmail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScheduledEmail_Order_By>>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};


export type Subscription_RootScheduledEmail_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootScheduledEmail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ScheduledEmail_Stream_Cursor_Input>>;
  where?: InputMaybe<ScheduledEmail_Bool_Exp>;
};


export type Subscription_RootSeasonArgs = {
  distinct_on?: InputMaybe<Array<Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Season_Order_By>>;
  where?: InputMaybe<Season_Bool_Exp>;
};


export type Subscription_RootSeason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Season_Order_By>>;
  where?: InputMaybe<Season_Bool_Exp>;
};


export type Subscription_RootSeason_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootSeason_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Season_Bool_Exp>;
};


export type Subscription_RootSpeciesArgs = {
  distinct_on?: InputMaybe<Array<Species_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Species_Order_By>>;
  where?: InputMaybe<Species_Bool_Exp>;
};


export type Subscription_RootSpecies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Species_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Species_Order_By>>;
  where?: InputMaybe<Species_Bool_Exp>;
};


export type Subscription_RootSpecies_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootSpecies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Species_Stream_Cursor_Input>>;
  where?: InputMaybe<Species_Bool_Exp>;
};


export type Subscription_RootStatisticsViewArgs = {
  distinct_on?: InputMaybe<Array<StatisticsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StatisticsView_Order_By>>;
  where?: InputMaybe<StatisticsView_Bool_Exp>;
};


export type Subscription_RootStatisticsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<StatisticsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StatisticsView_Order_By>>;
  where?: InputMaybe<StatisticsView_Bool_Exp>;
};


export type Subscription_RootStatisticsView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StatisticsView_Stream_Cursor_Input>>;
  where?: InputMaybe<StatisticsView_Bool_Exp>;
};


export type Subscription_RootSubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Order_By>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootSubscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSupportedProjectsViewArgs = {
  distinct_on?: InputMaybe<Array<SupportedProjectsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportedProjectsView_Order_By>>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
};


export type Subscription_RootSupportedProjectsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SupportedProjectsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportedProjectsView_Order_By>>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
};


export type Subscription_RootSupportedProjectsView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupportedProjectsView_Stream_Cursor_Input>>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
};


export type Subscription_RootTtcPlantingArgs = {
  distinct_on?: InputMaybe<Array<TtcPlanting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TtcPlanting_Order_By>>;
  where?: InputMaybe<TtcPlanting_Bool_Exp>;
};


export type Subscription_RootTtcPlanting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TtcPlanting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TtcPlanting_Order_By>>;
  where?: InputMaybe<TtcPlanting_Bool_Exp>;
};


export type Subscription_RootTtcPlanting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TtcPlanting_Stream_Cursor_Input>>;
  where?: InputMaybe<TtcPlanting_Bool_Exp>;
};


export type Subscription_RootTemplateCategoryArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


export type Subscription_RootTemplateCategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TemplateCategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TemplateCategory_Order_By>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


export type Subscription_RootTemplateCategory_By_PkArgs = {
  GiftCategoryId: Scalars['uuid'];
  GiftTemplateId: Scalars['uuid'];
};


export type Subscription_RootTemplateCategory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TemplateCategory_Stream_Cursor_Input>>;
  where?: InputMaybe<TemplateCategory_Bool_Exp>;
};


export type Subscription_RootTreeEventArgs = {
  distinct_on?: InputMaybe<Array<TreeEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreeEvent_Order_By>>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};


export type Subscription_RootTreeEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TreeEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreeEvent_Order_By>>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};


export type Subscription_RootTreeEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootTreeEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TreeEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<TreeEvent_Bool_Exp>;
};


export type Subscription_RootTreePoolStatsViewArgs = {
  distinct_on?: InputMaybe<Array<TreePoolStatsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreePoolStatsView_Order_By>>;
  where?: InputMaybe<TreePoolStatsView_Bool_Exp>;
};


export type Subscription_RootTreePoolStatsView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TreePoolStatsView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TreePoolStatsView_Order_By>>;
  where?: InputMaybe<TreePoolStatsView_Bool_Exp>;
};


export type Subscription_RootTreePoolStatsView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TreePoolStatsView_Stream_Cursor_Input>>;
  where?: InputMaybe<TreePoolStatsView_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUserEventArgs = {
  distinct_on?: InputMaybe<Array<UserEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEvent_Order_By>>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};


export type Subscription_RootUserEventViewArgs = {
  distinct_on?: InputMaybe<Array<UserEventView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEventView_Order_By>>;
  where?: InputMaybe<UserEventView_Bool_Exp>;
};


export type Subscription_RootUserEventView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEventView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEventView_Order_By>>;
  where?: InputMaybe<UserEventView_Bool_Exp>;
};


export type Subscription_RootUserEventView_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserEventView_Stream_Cursor_Input>>;
  where?: InputMaybe<UserEventView_Bool_Exp>;
};


export type Subscription_RootUserEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserEvent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserEvent_Order_By>>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};


export type Subscription_RootUserEvent_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootUserEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserEvent_Stream_Cursor_Input>>;
  where?: InputMaybe<UserEvent_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootVariableArgs = {
  distinct_on?: InputMaybe<Array<Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variable_Order_By>>;
  where?: InputMaybe<Variable_Bool_Exp>;
};


export type Subscription_RootVariable_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variable_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variable_Order_By>>;
  where?: InputMaybe<Variable_Bool_Exp>;
};


export type Subscription_RootVariable_By_PkArgs = {
  Id: Scalars['uuid'];
};


export type Subscription_RootVariable_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variable_Stream_Cursor_Input>>;
  where?: InputMaybe<Variable_Bool_Exp>;
};


export type Subscription_RootGetAccountSupportersArgs = {
  args: GetAccountSupporters_Args;
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};


export type Subscription_RootGetAccountSupporters_AggregateArgs = {
  args: GetAccountSupporters_Args;
  distinct_on?: InputMaybe<Array<AccountSupporters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccountSupporters_Order_By>>;
  where?: InputMaybe<AccountSupporters_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInsertInput;
}>;


export type CreateAccountMutation = { __typename?: 'mutation_root', account?: { __typename?: 'CreateAccountOutput', Id: string } | null };

export type UpdatePaymentMethodMutationVariables = Exact<{
  input: UpdateAccountPaymentMethodInput;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'mutation_root', update_account_payment_method?: { __typename?: 'UpdateAccountPaymentMethodOutput', Id: string } | null };

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['uuid'];
  attrs: Account_Set_Input;
  planterIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  funderIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  funderAttrs?: InputMaybe<Funder_Set_Input>;
  planterAttrs?: InputMaybe<Planter_Set_Input>;
}>;


export type UpdateAccountMutation = { __typename?: 'mutation_root', account?: { __typename?: 'Account', Id: any } | null, funder?: { __typename?: 'Funder_mutation_response', returning: Array<{ __typename?: 'Funder', Id: any }> } | null, planter?: { __typename?: 'Planter_mutation_response', returning: Array<{ __typename?: 'Planter', Id: any }> } | null };

export type ListAdminAccountsQueryVariables = Exact<{
  offset: Scalars['Int'];
  where?: InputMaybe<Account_Bool_Exp>;
  sort?: InputMaybe<Array<Account_Order_By> | Account_Order_By>;
}>;


export type ListAdminAccountsQuery = { __typename?: 'query_root', Account: Array<{ __typename?: 'Account', Id: any, CreatedOn: string, Email?: string | null, Name: string, Reference: number, Type: string, Memberships: Array<{ __typename?: 'Membership', Id: any }>, Planter?: { __typename?: 'Planter', Id: any, IsHidden: boolean } | null, Funder?: { __typename?: 'Funder', Id: any, IsHidden: boolean } | null }>, Account_aggregate: { __typename?: 'Account_aggregate', aggregate?: { __typename?: 'Account_aggregate_fields', count: number } | null } };

export type GetAdminAccountQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminAccountQuery = { __typename?: 'query_root', Account?: { __typename?: 'Account', Id: any, Reference: number, Name: string, Email?: string | null, Type: string, BusinessType?: string | null, BusinessSize?: string | null, OrgType?: string | null, GovType?: string | null, SchoolType?: string | null, Sector?: string | null, DistrictName?: string | null, Uri: string, PaymentMethodDescriptor?: string | null, StripeCustomerId?: string | null, RegionName?: string | null, PlanterId?: any | null, FunderId?: any | null, Avatar?: string | null, Banner?: string | null, Description?: string | null, Phone?: string | null, Mobile?: string | null, CreatedOn: string, Memberships: Array<{ __typename?: 'Membership', Id: any, Type: number, User: { __typename?: 'User', Id: any, Email: string, Role: number, FirstName: string, LastName: string } }>, Attachments: Array<{ __typename?: 'Attachment', Id: any, Type: number, Generated: boolean, Filename?: string | null, Year?: number | null }>, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, IsHidden: boolean } | null, Funder?: { __typename?: 'Funder', Id: any, Name?: string | null, IsHidden: boolean, Subscriptions: Array<{ __typename?: 'Subscription', Id: any, CreatedOn: string, CancelDate?: string | null, State: string, CancelReason?: string | null, Quantity: number, PublicMessage?: string | null, PublicName?: string | null, ReceiptName?: string | null, ReceiptEmail?: string | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null }> } | null, Addresses: Array<{ __typename?: 'Address', Id: any, StreetNumber?: string | null, StreetName?: string | null, City?: string | null, District?: string | null, Region?: string | null, Country?: string | null, PostalCode?: string | null, Place?: string | null, Geo?: string | null }> } | null };

export type GetAccountAndProductQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type GetAccountAndProductQuery = { __typename?: 'query_root', account?: { __typename?: 'Account', Id: any, FunderId?: any | null, PlanterId?: any | null, Avatar?: string | null, Banner?: string | null, Type: string, Name: string, Email?: string | null } | null, product: Array<{ __typename?: 'Product', Id: any }> };

export type GetAdminAccountRegistriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<RegistryView_Order_By> | RegistryView_Order_By>;
}>;


export type GetAdminAccountRegistriesQuery = { __typename?: 'query_root', RegistryView_aggregate: { __typename?: 'RegistryView_aggregate', aggregate?: { __typename?: 'RegistryView_aggregate_fields', count: number } | null }, RegistryView: Array<{ __typename?: 'RegistryView', Id?: any | null, Name?: string | null, Trees?: number | null, Total?: number | null, RegionName?: string | null, Reference?: number | null, IsClosed?: boolean | null, IsHidden?: boolean | null, IsFeatured?: boolean | null, Hero?: string | null, Gifts?: number | null, DistrictName?: string | null, Description?: string | null, CreatedOn?: string | null, ClosesOn?: string | null, Account?: { __typename?: 'Account', Id: any, Name: string } | null }> };

export type GetAdminAccountApplicationsViewQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<ApplicationView_Order_By> | ApplicationView_Order_By>;
}>;


export type GetAdminAccountApplicationsViewQuery = { __typename?: 'query_root', ApplicationView_aggregate: { __typename?: 'ApplicationView_aggregate', aggregate?: { __typename?: 'ApplicationView_aggregate_fields', count: number } | null }, ApplicationView: Array<{ __typename?: 'ApplicationView', Id?: any | null, Approved?: number | null, CreatedOn?: string | null, HoldOnMatch?: boolean | null, IsMatched?: boolean | null, Matched?: number | null, Name?: string | null, Planned?: number | null, PlanterRegistrationPlantingId?: any | null, Reference?: number | null, Required?: number | null, Unmatched?: number | null, WorkflowState?: string | null, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Project?: { __typename?: 'Project', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type GetAdminAccountPurchasesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Array<AdminPurchaseView_Bool_Exp> | AdminPurchaseView_Bool_Exp>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By> | AdminPurchaseView_Order_By>;
  accountId: Scalars['uuid'];
}>;


export type GetAdminAccountPurchasesQuery = { __typename?: 'query_root', AdminPurchaseView_aggregate: { __typename?: 'AdminPurchaseView_aggregate', aggregate?: { __typename?: 'AdminPurchaseView_aggregate_fields', count: number } | null }, AdminPurchaseView: Array<{ __typename?: 'AdminPurchaseView', Id?: any | null, CreatedOn?: string | null, FilterState?: string | null, FunderName?: string | null, FunderRegionName?: string | null, HoldOnMatch?: boolean | null, InstructionId?: any | null, Matched?: number | null, AccountId?: any | null, ReceiptEmail?: string | null, Reference?: string | null, RegionId?: any | null, RegionName?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null, PurchasePrice?: number | null, PurchaseTotal?: number | null, SubscriptionId?: any | null }> };

export type ListAccountSupportersQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ListAccountSupportersQuery = { __typename?: 'query_root', list_account_supporters: { __typename?: 'ListAccountSupportersOutput', Funder?: Array<{ __typename?: 'ListAccountSupportersSupporter', Id: any, Avatar?: string | null, Name: string, Uri: string, Type: string, Trees: number, Region: string }> | null, Funder_aggregate?: { __typename?: 'ListAccountSupportersAggregate', aggregate?: { __typename?: 'ListAccountSupportersAggregateAggregate', count: number } | null } | null, Planter?: Array<{ __typename?: 'ListAccountSupportersSupporter', Id: any, Avatar?: string | null, Name: string, Uri: string, Type: string, Trees: number, Region: string }> | null, Planter_aggregate?: { __typename?: 'ListAccountSupportersAggregate', aggregate?: { __typename?: 'ListAccountSupportersAggregateAggregate', count: number } | null } | null } };

export type GetAccountByUriQueryVariables = Exact<{
  uri: Scalars['String'];
}>;


export type GetAccountByUriQuery = { __typename?: 'query_root', Account: Array<{ __typename?: 'Account', Id: any, Avatar?: string | null, Banner?: string | null, Name: string, Description?: string | null, FunderId?: any | null, PlanterId?: any | null, RegionName?: string | null, Type: string, Facebook?: string | null, Website?: string | null, Planter?: { __typename?: 'Planter', Projects: Array<{ __typename?: 'Project', Id: any, Uri?: string | null }> } | null }> };

export type CreateFunderMutationVariables = Exact<{
  input: Funder_Insert_Input;
}>;


export type CreateFunderMutation = { __typename?: 'mutation_root', funder?: { __typename?: 'Funder', Id: any } | null };

export type CreatePlanterMutationVariables = Exact<{
  input: Planter_Insert_Input;
}>;


export type CreatePlanterMutation = { __typename?: 'mutation_root', planter?: { __typename?: 'Planter', Id: any } | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAccountQuery = { __typename?: 'query_root', account?: { __typename?: 'Account', Id: any, Avatar?: string | null, Banner?: string | null, BusinessType?: string | null, Description?: string | null, DistrictId?: any | null, ContactFirstname?: string | null, ContactLastname?: string | null, BusinessSize?: string | null, Email?: string | null, Facebook?: string | null, FocusArea?: string | null, GovType?: string | null, Mobile?: string | null, Name: string, OrgType?: string | null, Phone?: string | null, RegionId?: any | null, SchoolType?: string | null, Sector?: string | null, Type: string, Uri: string, Website?: string | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, IsHidden: boolean } | null, Funder?: { __typename?: 'Funder', Id: any, Name?: string | null, IsHidden: boolean } | null, Addresses: Array<{ __typename?: 'Address', Id: any, StreetNumber?: string | null, StreetName?: string | null, City?: string | null, District?: string | null, Region?: string | null, Country?: string | null, PostalCode?: string | null, Place?: string | null, Geo?: string | null }> } | null };

export type UpdateAddressMutationVariables = Exact<{
  input: Address_Insert_Input;
}>;


export type UpdateAddressMutation = { __typename?: 'mutation_root', insert_Address_one?: { __typename?: 'Address', Id: any } | null };

export type GetAccountSupportersQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAccountSupportersQuery = { __typename?: 'query_root', Planter_aggregate: { __typename?: 'AccountSupporters_aggregate', aggregate?: { __typename?: 'AccountSupporters_aggregate_fields', count: number } | null }, Planter: Array<{ __typename?: 'AccountSupporters', Id?: any | null, Avatar: string, Name: string, SupportType: string, Trees?: number | null, Type: string, Uri: string, Region?: string | null }>, Funder_aggregate: { __typename?: 'AccountSupporters_aggregate', aggregate?: { __typename?: 'AccountSupporters_aggregate_fields', count: number } | null }, Funder: Array<{ __typename?: 'AccountSupporters', Id?: any | null, Avatar: string, Name: string, SupportType: string, Trees?: number | null, Type: string, Uri: string, Region?: string | null }> };

export type UpdateAdminAccountByStripeIdMutationVariables = Exact<{
  stripeId: Scalars['String'];
  input?: InputMaybe<Account_Set_Input>;
}>;


export type UpdateAdminAccountByStripeIdMutation = { __typename?: 'mutation_root', subscriptions?: { __typename?: 'Account_mutation_response', returning: Array<{ __typename?: 'Account', Id: any }> } | null };

export type GetAccountAndPlanterRegistrationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAccountAndPlanterRegistrationQuery = { __typename?: 'query_root', Account_by_pk?: { __typename?: 'Account', Id: any, Name: string, Planter?: { __typename?: 'Planter', PlanterRegistrations: Array<{ __typename?: 'PlanterRegistration', Id: any, WorkflowState: string }>, Projects: Array<{ __typename?: 'Project', Id: any, Name: string, Applications: Array<{ __typename?: 'Application', Id: any, WorkflowState: string, Reference: number, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> }> } | null } | null };

export type CreateAccountProfileMutationVariables = Exact<{
  input: CreateAccountProfileInput;
}>;


export type CreateAccountProfileMutation = { __typename?: 'mutation_root', createAccountProfile?: { __typename?: 'CreateAccountProfileOutput', accountId: string, profileType: string } | null };

export type GetApplicationQueryVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type GetApplicationQuery = { __typename?: 'query_root', Application: Array<{ __typename?: 'Application', Id: any, AccessToPublic?: boolean | null, AddingToCount: boolean, AgreeToMonitor: boolean, AgreeToReport: boolean, AgreeAssetUsage: boolean, Approved: number, ApprovedAt?: string | null, AvailableActivities?: string | null, CreatedOn: string, DeclinedAt?: string | null, EmploymentOpportunities?: boolean | null, EmploymentOpportunitiesDesc?: string | null, Geo: string, Goal?: string | null, HasOtherFunding?: boolean | null, HelpWithPlanting?: boolean | null, LandCondition?: string | null, LandOwnership?: string | null, LandPermission?: boolean | null, LandUse?: string | null, LegalObligation?: boolean | null, LocalBodies?: boolean | null, LocalBodiesDesc?: string | null, MaintainPlanting?: string | null, Matched?: number | null, Name: string, NumberOfSites: number, OtherFunding?: string | null, OtherGroups?: boolean | null, OtherGroupsDesc?: string | null, OtherLand?: boolean | null, OtherLandArea?: string | null, Planned: number, PlanterId: any, PlanterRegistrationPlantingId?: any | null, PlantingPlan?: string | null, Reference: number, Required: number, SpeciesKnown?: boolean | null, StockAccess?: boolean | null, SubmittedAt?: string | null, TermsAndConditions: boolean, WorkflowState: string, ApplicationAssets: Array<{ __typename?: 'ApplicationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null, FileName?: string | null }>, ApplicationNotes: Array<{ __typename?: 'ActionNotes', Action: string, Id: any, TimeStamp: string, Notes: string }>, PlantingSites: Array<{ __typename?: 'PlantingSite', Id: any, Name: string, LandPermission: boolean, NativeTreeConsent: boolean, SiteLandCondition: string, SiteLandscape: string, Species?: string | null, StockAccess: boolean, Geo: string, CovenantProtected: boolean, PlantingSiteAssets: Array<{ __typename?: 'PlantingSiteAsset', Id: any, FileName?: string | null, Uri: string, Type: string }> }>, District?: { __typename?: 'District', Id: any, Name: string } | null, Plantings: Array<{ __typename?: 'Planting', Id: any, Area: number, ApplicationId?: any | null, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Reference: number, Quantity: number, Spacing: number, VolunteerCount?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }>, Planter: { __typename?: 'Planter', Name?: string | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, OtherSpeciesName?: string | null, Species: { __typename?: 'Species', Id: any, Name: string } }>, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season: { __typename?: 'Season', Id: any, Name: string } }>, Project?: { __typename?: 'Project', Id: any, Area: string, CreatedOn: string, Data?: string | null, Description?: string | null, Hero?: string | null, Name: string, Uri?: string | null, NumberOfTreesFundedPreviously: number, PlantingTimeframes: string, ReceivedFundingPreviously?: boolean | null, Applications: Array<{ __typename?: 'Application', Id: any, Approved: number, CreatedOn: string, Name: string, Planned: number, Reference: number, Required: number, WorkflowState: string, ApplicationAssets: Array<{ __typename?: 'ApplicationAsset', Id: any, Type: string, Uri?: string | null }>, Project?: { __typename?: 'Project', Id: any, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, Type: string, Uri?: string | null }> } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }>, District?: { __typename?: 'District', Id: any, Name: string } | null, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type ListApplicationsQueryVariables = Exact<{
  planterId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Application_Order_By> | Application_Order_By>;
}>;


export type ListApplicationsQuery = { __typename?: 'query_root', Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', count: number } | null }, Application: Array<{ __typename?: 'Application', Id: any, Reference: number, Approved: number, ApprovedAt?: string | null, CreatedOn: string, DeclinedAt?: string | null, Name: string, Planned: number, Required: number, SubmittedAt?: string | null, WorkflowState: string, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type GetApplicationCountForPlanterRegistrationQueryVariables = Exact<{
  workflowStates: Array<Scalars['String']> | Scalars['String'];
  planterId: Scalars['uuid'];
}>;


export type GetApplicationCountForPlanterRegistrationQuery = { __typename?: 'query_root', Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', count: number } | null } };

export type CreateApplicationMutationVariables = Exact<{
  input: UpsertApplicationInput;
}>;


export type CreateApplicationMutation = { __typename?: 'mutation_root', application?: { __typename?: 'UpsertApplicationOutput', Id: string, Application?: { __typename?: 'Application', Project?: { __typename?: 'Project', Id: any } | null } | null } | null };

export type CreateAdminApplicationMutationVariables = Exact<{
  input: Application_Insert_Input;
}>;


export type CreateAdminApplicationMutation = { __typename?: 'mutation_root', application?: { __typename?: 'Application', Id: any } | null };

export type DeleteDraftApplicationMutationVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type DeleteDraftApplicationMutation = { __typename?: 'mutation_root', delete_PlantingSiteAsset?: { __typename?: 'PlantingSiteAsset_mutation_response', affected_rows: number } | null, delete_PlantingSite?: { __typename?: 'PlantingSite_mutation_response', affected_rows: number } | null, delete_ApplicationAsset?: { __typename?: 'ApplicationAsset_mutation_response', affected_rows: number } | null, delete_Application?: { __typename?: 'Application_mutation_response', affected_rows: number } | null };

export type GetAdminApplicationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminApplicationQuery = { __typename?: 'query_root', Application?: { __typename?: 'Application', Id: any, AccessToPublic?: boolean | null, AddingToCount: boolean, AgreeToMonitor: boolean, AgreeToReport: boolean, AgreeAssetUsage: boolean, Approved: number, ApprovedAt?: string | null, AvailableActivities?: string | null, CreatedOn: string, DeclinedAt?: string | null, EmploymentOpportunities?: boolean | null, EmploymentOpportunitiesDesc?: string | null, Goal?: string | null, HasOtherFunding?: boolean | null, HelpWithPlanting?: boolean | null, Geo: string, HoldOnMatch: boolean, IsMatched?: boolean | null, LandCondition?: string | null, LandOwnership?: string | null, LandPermission?: boolean | null, LandUse?: string | null, LegalObligation?: boolean | null, LocalBodies?: boolean | null, LocalBodiesDesc?: string | null, MaintainPlanting?: string | null, Name: string, NumberOfSites: number, Matched?: number | null, OtherFunding?: string | null, OtherGroups?: boolean | null, OtherGroupsDesc?: string | null, OtherLand?: boolean | null, OtherLandArea?: string | null, Planned: number, PlantingPlan?: string | null, PlanterId: any, PlanterRegistrationPlantingId?: any | null, Reference: number, Required: number, SpeciesKnown?: boolean | null, StockAccess?: boolean | null, SubmittedAt?: string | null, TermsAndConditions: boolean, WorkflowState: string, ApplicationAssets: Array<{ __typename?: 'ApplicationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null, FileName?: string | null }>, ApplicationNotes: Array<{ __typename?: 'ActionNotes', Action: string, Id: any, TimeStamp: string, Notes: string }>, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any } | null } | null, Plantings: Array<{ __typename?: 'Planting', Id: any, Area: number, ApplicationId?: any | null, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Reference: number, Quantity: number, Spacing: number, VolunteerCount?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }>, Planter: { __typename?: 'Planter', Name?: string | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, OtherSpeciesName?: string | null, Species: { __typename?: 'Species', Id: any, Name: string } }>, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season: { __typename?: 'Season', Id: any, Name: string } }>, PlantingSites: Array<{ __typename?: 'PlantingSite', Id: any, Name: string, LandPermission: boolean, NativeTreeConsent: boolean, SiteLandCondition: string, SiteLandscape: string, Species?: string | null, StockAccess: boolean, Geo: string, CovenantProtected: boolean, PlantingSiteAssets: Array<{ __typename?: 'PlantingSiteAsset', Id: any, FileName?: string | null, Uri: string, Type: string }> }>, Project?: { __typename?: 'Project', Id: any, Name: string, Area: string, CreatedOn: string, Data?: string | null, Description?: string | null, Hero?: string | null, NumberOfTreesFundedPreviously: number, PlantingTimeframes: string, ReceivedFundingPreviously?: boolean | null, Applications: Array<{ __typename?: 'Application', Id: any, Approved: number, CreatedOn: string, HoldOnMatch: boolean, IsMatched?: boolean | null, Matched?: number | null, Name: string, Planned: number, PlanterRegistrationPlantingId?: any | null, Reference: number, Required: number, Unmatched?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Project?: { __typename?: 'Project', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }>, District?: { __typename?: 'District', Id: any, Name: string } | null, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null } | null };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['uuid'];
  set?: InputMaybe<Application_Set_Input>;
}>;


export type UpdateApplicationMutation = { __typename?: 'mutation_root', update_Application_by_pk?: { __typename?: 'Application', Id: any } | null };

export type UpdateProjectApplicationsRegionDistrictMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  districtId?: InputMaybe<Scalars['uuid']>;
  regionId?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateProjectApplicationsRegionDistrictMutation = { __typename?: 'mutation_root', update_Application?: { __typename?: 'Application_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Application', Id: any, DistrictId?: any | null, RegionId?: any | null }> } | null };

export type GetAdminApplicationByPlanterRegistrationIdQueryVariables = Exact<{
  planterRegistrationId: Scalars['uuid'];
}>;


export type GetAdminApplicationByPlanterRegistrationIdQuery = { __typename?: 'query_root', Application: Array<{ __typename?: 'Application', Id: any, AccessToPublic?: boolean | null, AddingToCount: boolean, AgreeToMonitor: boolean, AgreeToReport: boolean, AgreeAssetUsage: boolean, NumberOfSites: number, Approved: number, ApprovedAt?: string | null, AvailableActivities?: string | null, CreatedOn: string, DeclinedAt?: string | null, EmploymentOpportunities?: boolean | null, EmploymentOpportunitiesDesc?: string | null, Goal?: string | null, HasOtherFunding?: boolean | null, HelpWithPlanting?: boolean | null, Geo: string, HoldOnMatch: boolean, IsMatched?: boolean | null, LandCondition?: string | null, LandOwnership?: string | null, LandPermission?: boolean | null, LandUse?: string | null, LegalObligation?: boolean | null, LocalBodies?: boolean | null, LocalBodiesDesc?: string | null, MaintainPlanting?: string | null, Name: string, Matched?: number | null, OtherFunding?: string | null, OtherGroups?: boolean | null, OtherGroupsDesc?: string | null, OtherLand?: boolean | null, OtherLandArea?: string | null, Planned: number, PlantingPlan?: string | null, PlanterId: any, PlanterRegistrationPlantingId?: any | null, Reference: number, Required: number, SpeciesKnown?: boolean | null, StockAccess?: boolean | null, SubmittedAt?: string | null, TermsAndConditions: boolean, WorkflowState: string, PlantingSites: Array<{ __typename?: 'PlantingSite', Id: any, Name: string, LandPermission: boolean, NativeTreeConsent: boolean, SiteLandCondition: string, SiteLandscape: string, Species?: string | null, StockAccess: boolean, Geo: string, CovenantProtected: boolean, PlantingSiteAssets: Array<{ __typename?: 'PlantingSiteAsset', Id: any, FileName?: string | null, Uri: string, Type: string }> }>, ApplicationAssets: Array<{ __typename?: 'ApplicationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, ApplicationNotes: Array<{ __typename?: 'ActionNotes', Action: string, Id: any, TimeStamp: string, Notes: string }>, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any } | null } | null, Plantings: Array<{ __typename?: 'Planting', Id: any, Area: number, ApplicationId?: any | null, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Reference: number, Quantity: number, Spacing: number, VolunteerCount?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }>, Planter: { __typename?: 'Planter', Id: any, Name?: string | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, Species: { __typename?: 'Species', Id: any, Name: string } }>, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season: { __typename?: 'Season', Id: any, Name: string } }>, Project?: { __typename?: 'Project', Id: any, Name: string, Area: string, CreatedOn: string, Data?: string | null, Description?: string | null, Hero?: string | null, NumberOfTreesFundedPreviously: number, PlantingTimeframes: string, ReceivedFundingPreviously?: boolean | null, Applications: Array<{ __typename?: 'Application', Id: any, Approved: number, CreatedOn: string, HoldOnMatch: boolean, IsMatched?: boolean | null, Matched?: number | null, Name: string, Planned: number, PlanterRegistrationPlantingId?: any | null, Reference: number, Required: number, Unmatched?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Project?: { __typename?: 'Project', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }>, District?: { __typename?: 'District', Id: any, Name: string } | null, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type ListAdminApplicationsViewQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  where?: InputMaybe<ApplicationView_Bool_Exp>;
  order_by?: InputMaybe<Array<ApplicationView_Order_By> | ApplicationView_Order_By>;
}>;


export type ListAdminApplicationsViewQuery = { __typename?: 'query_root', ApplicationView_aggregate: { __typename?: 'ApplicationView_aggregate', aggregate?: { __typename?: 'ApplicationView_aggregate_fields', count: number } | null }, ApplicationView: Array<{ __typename?: 'ApplicationView', Id?: any | null, Approved?: number | null, ApprovedAt?: string | null, CreatedOn?: string | null, DeclinedAt?: string | null, HoldOnMatch?: boolean | null, IsMatched?: boolean | null, Matched?: number | null, Name?: string | null, Planned?: number | null, PlanterRegistrationPlantingId?: any | null, Reference?: number | null, Required?: number | null, SubmittedAt?: string | null, Unmatched?: number | null, WorkflowState?: string | null, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, CreatedOn: string, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Project?: { __typename?: 'Project', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type GetAdminApplicationMatchesQueryVariables = Exact<{
  id: Scalars['uuid'];
  orderBy?: InputMaybe<Array<Match_Order_By> | Match_Order_By>;
}>;


export type GetAdminApplicationMatchesQuery = { __typename?: 'query_root', Application_by_pk?: { __typename?: 'Application', Id: any, Matches: Array<{ __typename?: 'Match', Id: any, Quantity: number, Instruction: { __typename?: 'Instruction', Id: any, PurchaseId: any, Purchase?: { __typename?: 'Purchase', Id: any, Reference: number, Quantity: number, CreatedOn: string, Type: number, Season: { __typename?: 'Season', Id: any, Name: string }, Funder: { __typename?: 'Funder', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null }, District?: { __typename?: 'District', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null } }> } | null };

export type UpdateApplicationCountsMutationVariables = Exact<{
  input: UpdateApplicationCountsInput;
}>;


export type UpdateApplicationCountsMutation = { __typename?: 'mutation_root', update_application_counts: { __typename?: 'UpdateApplicationCountsOutput', Application?: { __typename?: 'Application', Id: any } | null } };

export type UpdateApplicationHoldOnMatchMutationVariables = Exact<{
  id: Scalars['uuid'];
  holdOnMatch: Scalars['Boolean'];
}>;


export type UpdateApplicationHoldOnMatchMutation = { __typename?: 'mutation_root', update_Application_by_pk?: { __typename?: 'Application', Id: any } | null };

export type UpdateApplicationSeasonMutationVariables = Exact<{
  input: UpdateApplicationSeasonInput;
}>;


export type UpdateApplicationSeasonMutation = { __typename?: 'mutation_root', update_application_season: { __typename?: 'UpdateApplicationSeasonOutput', Application?: { __typename?: 'Application', Id: any } | null } };

export type GetAdminApplicationProjectQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminApplicationProjectQuery = { __typename?: 'query_root', Application?: { __typename?: 'Application', Project?: { __typename?: 'Project', Id: any, Area: string, CreatedOn: string, Description?: string | null, Name: string, Reference: number, Applications: Array<{ __typename?: 'Application', Id: any }> } | null } | null };

export type ListAdminApplicationsForProjectQueryVariables = Exact<{
  where?: InputMaybe<Application_Bool_Exp>;
}>;


export type ListAdminApplicationsForProjectQuery = { __typename?: 'query_root', Application: Array<{ __typename?: 'Application', Id: any, Approved: number, ApprovedAt?: string | null, CreatedOn: string, DeclinedAt?: string | null, HoldOnMatch: boolean, Matched?: number | null, Name: string, Planned: number, ProjectId?: any | null, Reference: number, Required: number, SubmittedAt?: string | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> };

export type GetApplicationForWorkflowStateTransitionQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetApplicationForWorkflowStateTransitionQuery = { __typename?: 'query_root', Application?: { __typename?: 'Application', Id: any, Name: string, WorkflowState: string, Matched?: number | null, Approved: number, IsMatched?: boolean | null, Planter?: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Id: any, Name: string, Email?: string | null } | null } | null } | null };

export type GetApplicationNavStateQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetApplicationNavStateQuery = { __typename?: 'query_root', Application?: { __typename?: 'Application', Id: any, Name: string, Reference: number, PlanterRegistrationPlantingId?: any | null, Matched?: number | null, Unmatched?: number | null, WorkflowState: string, IsMatched?: boolean | null, HoldOnMatch: boolean, Planter?: { __typename?: 'Planter', Id: any } | null, Plantings: Array<{ __typename?: 'Planting', Id: any, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any }> }>, Project?: { __typename?: 'Project', Id: any } | null, Region?: { __typename?: 'Region', Id: any } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null } | null };

export type CreateMatchFromApplicationMutationVariables = Exact<{
  input: CreateMatchFromApplicationInput;
}>;


export type CreateMatchFromApplicationMutation = { __typename?: 'mutation_root', create_match_from_application: { __typename?: 'CreateMatchFromApplicationOutput', ApplicationId: string } };

export type CreateActionNoteMutationVariables = Exact<{
  input: ActionNotes_Insert_Input;
}>;


export type CreateActionNoteMutation = { __typename?: 'mutation_root', insert_ActionNotes_one?: { __typename?: 'ActionNotes', Id: any } | null };

export type ListAdminApplicationsByProjectIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<Application_Order_By> | Application_Order_By>;
}>;


export type ListAdminApplicationsByProjectIdQuery = { __typename?: 'query_root', Application: Array<{ __typename?: 'Application', Id: any, Name: string, Reference: number, Required: number, Approved: number, Planned: number, WorkflowState: string, Geo: string, PlanterRegistrationPlantingId?: any | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null, Plantings_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', sum?: { __typename?: 'Planting_sum_fields', Quantity?: number | null } | null } | null }, Plantings: Array<{ __typename?: 'Planting', Id: any, Name: string, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, UpdatedOn: string, Uri?: string | null, Type: string }> }> }> }> };

export type CreateApplicationAssetMutationVariables = Exact<{
  input: CreateApplicationAssetInput;
}>;


export type CreateApplicationAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreateApplicationAssetOutput', SignedUrl: string } };

export type CreateProjectAssetMutationVariables = Exact<{
  input: CreateProjectAssetInput;
}>;


export type CreateProjectAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreateProjectAssetOutput', SignedUrl: string } };

export type CreateProjectHeroMutationVariables = Exact<{
  input: CreateProjectHeroInput;
}>;


export type CreateProjectHeroMutation = { __typename?: 'mutation_root', asset?: { __typename?: 'CreateProjectHeroOutput', SignedUrl: string } | null };

export type CreatePlanterRegistrationAssetMutationVariables = Exact<{
  input: CreatePlanterRegistrationAssetInput;
}>;


export type CreatePlanterRegistrationAssetMutation = { __typename?: 'mutation_root', asset?: { __typename?: 'CreatePlanterRegistrationAssetOutput', SignedUrl: string } | null };

export type CreatePlantingAssetMutationVariables = Exact<{
  input: CreatePlantingAssetInput;
}>;


export type CreatePlantingAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreatePlantingAssetOutput', SignedUrl: string } };

export type DeleteApplicationAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type DeleteApplicationAssetMutation = { __typename?: 'mutation_root', delete_ApplicationAsset?: { __typename?: 'ApplicationAsset_mutation_response', affected_rows: number } | null };

export type DeleteProjectAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteProjectAssetMutation = { __typename?: 'mutation_root', delete_ProjectAsset?: { __typename?: 'ProjectAsset_mutation_response', affected_rows: number } | null };

export type DeletePlanterRegistrationAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  planterRegistrationId: Scalars['uuid'];
}>;


export type DeletePlanterRegistrationAssetMutation = { __typename?: 'mutation_root', delete_PlanterRegistrationAsset?: { __typename?: 'PlanterRegistrationAsset_mutation_response', affected_rows: number } | null };

export type DeletePlantingAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type DeletePlantingAssetMutation = { __typename?: 'mutation_root', delete_PlantingAsset?: { __typename?: 'PlantingAsset_mutation_response', affected_rows: number } | null };

export type CreateMonitoringAssetMutationVariables = Exact<{
  input: CreateMonitoringAssetInput;
}>;


export type CreateMonitoringAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreateMonitoringAssetOutput', SignedUrl: string } };

export type CreateAccountAssetMutationVariables = Exact<{
  input: CreateAccountAssetInput;
}>;


export type CreateAccountAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreateAccountAsset', SignedUrl: string } };

export type CreatePlantingSiteAssetMutationVariables = Exact<{
  input: CreatePlantingSiteAssetInput;
}>;


export type CreatePlantingSiteAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreatePlantingSiteAssetOutput', SignedUrl: string } };

export type DeletePlantingSiteAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type DeletePlantingSiteAssetMutation = { __typename?: 'mutation_root', delete_PlantingSiteAsset?: { __typename?: 'PlantingSiteAsset_mutation_response', affected_rows: number } | null };

export type RegeneratePdfMutationVariables = Exact<{
  input: RegeneratePdfInput;
}>;


export type RegeneratePdfMutation = { __typename?: 'mutation_root', regenerate_pdf: { __typename?: 'RegeneratePdfOutput', S3Key: string, PresignedUrl: string } };

export type ListAccountPurchaseReceiptsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<Purchase_Order_By> | Purchase_Order_By>;
}>;


export type ListAccountPurchaseReceiptsQuery = { __typename?: 'query_root', Purchase_aggregate: { __typename?: 'Purchase_aggregate', aggregate?: { __typename?: 'Purchase_aggregate_fields', count: number } | null }, Purchase: Array<{ __typename?: 'Purchase', Id: any, Reference: number, CreatedOn: string, PaymentMethod: number, Type: number, Total: number, State: number, ReceiptEmail?: string | null, SubscriptionId?: any | null, PaymentError?: string | null, Attachment: Array<{ __typename?: 'Attachment', Id: any, Type: number }> }>, LatestPurchase: Array<{ __typename?: 'Purchase', Id: any, PaymentError?: string | null }> };

export type ListAttachmentsQueryVariables = Exact<{
  referenceId: Scalars['uuid'];
  type: Scalars['Int'];
}>;


export type ListAttachmentsQuery = { __typename?: 'query_root', attachments: Array<{ __typename?: 'Attachment', Id: any, Type: number, Year?: number | null }> };

export type CreateAttachmentMutationVariables = Exact<{
  input: Attachment_Insert_Input;
}>;


export type CreateAttachmentMutation = { __typename?: 'mutation_root', insert_Attachment_one?: { __typename?: 'Attachment', Id: any } | null };

export type GetAttachmentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAttachmentQuery = { __typename?: 'query_root', attachment?: { __typename?: 'Attachment', Id: any, Filename?: string | null, Generated: boolean, Failed: boolean } | null };

export type GetPurchaseAttachmentStatusQueryVariables = Exact<{
  purchaseId: Scalars['uuid'];
  types: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetPurchaseAttachmentStatusQuery = { __typename?: 'query_root', attachmentStatus?: { __typename?: 'Purchase', Id: any, RelatedPurchases: Array<{ __typename?: 'Purchase', Id: any, Attachment: Array<{ __typename?: 'Attachment', Id: any, Filename?: string | null, Generated: boolean, Failed: boolean }> }> } | null };

export type ListCertificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCertificationsQuery = { __typename?: 'query_root', list_certifications: { __typename?: 'ListCertificationsOutput', result: { __typename?: 'ListCertificationsResult', data?: { __typename?: 'ListCertificationsResultData', json: Array<{ __typename?: 'Certification', CertificateType: number, Description: string, DownloadFilePath: string, Image: string, SeasonName: string, Awarded: boolean, Name: string }> } | null } } };

export type GetDashboardProjectsSupportedCountQueryVariables = Exact<{
  funderId: Scalars['uuid'];
}>;


export type GetDashboardProjectsSupportedCountQuery = { __typename?: 'query_root', SupportedProjectsView_aggregate: { __typename?: 'SupportedProjectsView_aggregate', aggregate?: { __typename?: 'SupportedProjectsView_aggregate_fields', count: number } | null } };

export type GetDashboardTabsDataQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetDashboardTabsDataQuery = { __typename?: 'query_root', Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', count: number } | null }, Application: Array<{ __typename?: 'Application', Approved: number, ApprovedAt?: string | null, CreatedOn: string, DeclinedAt?: string | null, Id: any, Name: string, Planned: number, Reference: number, Required: number, SubmittedAt?: string | null, WorkflowState: string, Project?: { __typename?: 'Project', Id: any, Name: string } | null, Plantings: Array<{ __typename?: 'Planting', Id: any, CreatedOn: string, Quantity: number, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, CreatedOn: string }> }>, Season?: { __typename?: 'Season', Id: any, Name: string } | null }>, PurchaseDashboardView: Array<{ __typename?: 'PurchaseDashboardView', Token?: string | null, Quantity?: number | null, CreatedOn?: string | null, Amount?: number | null, Total?: number | null, Type?: number | null, State?: number | null, SubscriptionId?: any | null, Funder?: { __typename?: 'Funder', Account?: { __typename?: 'Account', Id: any, Name: string } | null } | null }> };

export type GetFunderStatsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type GetFunderStatsQuery = { __typename?: 'query_root', PublicFunderStatsForAccount: Array<{ __typename?: 'PublicFunderStat', PlantersSupported: number, Rank?: number | null, SeasonName: string, TreesFunded: number }> };

export type GetFunderSupportStatsQueryVariables = Exact<{
  funderId: Scalars['uuid'];
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetFunderSupportStatsQuery = { __typename?: 'query_root', Planter_aggregate: { __typename?: 'Planter_aggregate', aggregate?: { __typename?: 'Planter_aggregate_fields', count: number } | null }, Planter: Array<{ __typename?: 'Planter', Account?: { __typename?: 'Account', Id: any, Avatar?: string | null, Name: string, Uri: string } | null }> };

export type FunderSupportedProjectTreeCountQueryVariables = Exact<{
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
}>;


export type FunderSupportedProjectTreeCountQuery = { __typename?: 'query_root', SupportedProjectsView: Array<{ __typename?: 'SupportedProjectsView', Quantity?: number | null }> };

export type ListGiftCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGiftCategoriesQuery = { __typename?: 'query_root', GiftCategory: Array<{ __typename?: 'GiftCategory', Id: any, Name: string, TemplateCategories_aggregate: { __typename?: 'TemplateCategory_aggregate', aggregate?: { __typename?: 'TemplateCategory_aggregate_fields', count: number } | null } }>, GiftTemplate_aggregate: { __typename?: 'GiftTemplate_aggregate', aggregate?: { __typename?: 'GiftTemplate_aggregate_fields', count: number } | null } };

export type ListGiftTemplatesQueryVariables = Exact<{
  offset: Scalars['Int'];
  where: GiftTemplate_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ListGiftTemplatesQuery = { __typename?: 'query_root', GiftTemplate_aggregate: { __typename?: 'GiftTemplate_aggregate', aggregate?: { __typename?: 'GiftTemplate_aggregate_fields', count: number } | null }, GiftTemplate: Array<{ __typename?: 'GiftTemplate', Id: any, BackgroundImage?: string | null, Description: string, Preview: string, Title: string, TemplateCategories: Array<{ __typename?: 'TemplateCategory', GiftCategoryId: any }> }> };

export type CreateGiftPaymentMutationVariables = Exact<{
  input: CreateGiftPaymentInput;
}>;


export type CreateGiftPaymentMutation = { __typename?: 'mutation_root', create_gift_payment: { __typename?: 'CreateGiftPaymentOutput', PaymentIntentClientSecret?: string | null, PurchaseId?: string | null, Hash?: string | null, Token?: string | null } };

export type CreateGiftGuestPaymentMutationVariables = Exact<{
  input: CreateGiftGuestPaymentInput;
}>;


export type CreateGiftGuestPaymentMutation = { __typename?: 'mutation_root', create_gift_guest_payment: { __typename?: 'CreateGiftGuestPaymentOutput', PaymentIntentClientSecret?: string | null, PurchaseId?: string | null, Hash?: string | null, Token?: string | null } };

export type GetBulkGiftAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBulkGiftAttributesQuery = { __typename?: 'query_root', Product: Array<{ __typename?: 'Product', Id: any, Name: string, ProductPrices: Array<{ __typename?: 'ProductPrice', Id: any, Amount: number, VolumeMin?: number | null, VolumeMax?: number | null }> }>, GiftTemplate: Array<{ __typename?: 'GiftTemplate', Id: any, Name: string, Title: string, Description: string, Preview: string }> };

export type ImportBulkGiftMutationVariables = Exact<{
  input: ImportBulkGiftInput;
}>;


export type ImportBulkGiftMutation = { __typename?: 'mutation_root', import_bulk_gift?: { __typename?: 'ImportBulkGiftOutput', PurchaseIds: Array<string> } | null };

export type ListBulkGiftRecipientsQueryVariables = Exact<{
  s3Key: Scalars['String'];
}>;


export type ListBulkGiftRecipientsQuery = { __typename?: 'query_root', list_bulk_gift_recipients?: { __typename?: 'GetBulkGiftRecipientsOutput', Gifts?: Array<{ __typename?: 'Gifts', Trees: number, FromName: string, ToName: string, ToEmail: string, Message?: string | null } | null> | null } | null };

export type GetGiftPreviewQueryVariables = Exact<{
  input?: InputMaybe<GetGiftPreviewInput>;
}>;


export type GetGiftPreviewQuery = { __typename?: 'query_root', get_gift_preview?: { __typename?: 'GiftPreviewOutput', base64Data: string } | null };

export type ListAdminInstructionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  where?: InputMaybe<InstructionView_Bool_Exp>;
  order_by?: InputMaybe<Array<InstructionView_Order_By> | InstructionView_Order_By>;
}>;


export type ListAdminInstructionsQuery = { __typename?: 'query_root', InstructionView_aggregate: { __typename?: 'InstructionView_aggregate', aggregate?: { __typename?: 'InstructionView_aggregate_fields', count: number } | null }, InstructionView: Array<{ __typename?: 'InstructionView', Id?: any | null, FunderName?: string | null, PurchaseId?: any | null, ReceiptEmail?: string | null, RegionName?: string | null, Reference?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null }> };

export type GetActiveInviteByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetActiveInviteByEmailQuery = { __typename?: 'query_root', Invite: Array<{ __typename?: 'Invite', Id: any, Code: string, ExpiresAt: string, Account: { __typename?: 'Account', Id: any, Name: string } }> };

export type GetInviteByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetInviteByIdQuery = { __typename?: 'query_root', Invite_by_pk?: { __typename?: 'Invite', Id: any, RecipientFirstname?: string | null, RecipientLastname?: string | null, RecipientEmail: string, Message?: string | null, Account: { __typename?: 'Account', Id: any, Name: string } } | null };

export type GetActiveInviteAccountByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetActiveInviteAccountByCodeQuery = { __typename?: 'query_root', Invite: Array<{ __typename?: 'Invite', Id: any, Code: string, RecipientFirstname?: string | null, RecipientLastname?: string | null, RecipientEmail: string, ExpiresAt: string, Status?: string | null, Account: { __typename?: 'Account', Id: any, Name: string } }> };

export type GetInviteByCodeWithUserQueryVariables = Exact<{
  code: Scalars['String'];
  userId: Scalars['uuid'];
}>;


export type GetInviteByCodeWithUserQuery = { __typename?: 'query_root', invite: Array<{ __typename?: 'Invite', Id: any, Code: string, ExpiresAt: string, RecipientEmail: string, RecipientFirstname?: string | null, RecipientLastname?: string | null, Account: { __typename?: 'Account', Id: any, Email?: string | null } }>, user?: { __typename?: 'User', Id: any, Identifier?: string | null, Email: string, Memberships: Array<{ __typename?: 'Membership', Id: any, Account: { __typename?: 'Account', Id: any, Email?: string | null } }> } | null };

export type CreateAccountUserInviteMutationVariables = Exact<{
  email: Scalars['String'];
  recipientFirstname: Scalars['String'];
  recipientLastname: Scalars['String'];
  message: Scalars['String'];
  accountId: Scalars['uuid'];
  expiresAt: Scalars['timestamp'];
  code: Scalars['String'];
}>;


export type CreateAccountUserInviteMutation = { __typename?: 'mutation_root', update_Invite?: { __typename?: 'Invite_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Invite', Id: any, Status?: string | null }> } | null, insert_Invite_one?: { __typename?: 'Invite', Id: any, Code: string } | null };

export type AcceptAccountInviteMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type AcceptAccountInviteMutation = { __typename?: 'mutation_root', accept_invite?: { __typename?: 'AcceptInviteOutput', MembershipId: any } | null };

export type DeclineAccountInviteMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type DeclineAccountInviteMutation = { __typename?: 'mutation_root', decline_invite?: { __typename?: 'DeclineInviteOutput', Status: string } | null };

export type DeleteAccountInviteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteAccountInviteMutation = { __typename?: 'mutation_root', delete_Invite_by_pk?: { __typename?: 'Invite', Id: any } | null };

export type UpdateAccountInviteStatusMutationVariables = Exact<{
  code: Scalars['String'];
  status: Scalars['String'];
}>;


export type UpdateAccountInviteStatusMutation = { __typename?: 'mutation_root', update_Invite?: { __typename?: 'Invite_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Invite', Id: any, Code: string, Status?: string | null }> } | null };

export type UpdateExpiredInvitesMutationVariables = Exact<{
  expiresAt: Scalars['timestamp'];
}>;


export type UpdateExpiredInvitesMutation = { __typename?: 'mutation_root', update_Invite?: { __typename?: 'Invite_mutation_response', affected_rows: number } | null };

export type CreateMembershipMutationVariables = Exact<{
  input: Membership_Insert_Input;
}>;


export type CreateMembershipMutation = { __typename?: 'mutation_root', insert_Membership_one?: { __typename?: 'Membership', Id: any } | null };

export type UpdateMembershipRoleMutationVariables = Exact<{
  id: Scalars['uuid'];
  role: Scalars['smallint'];
}>;


export type UpdateMembershipRoleMutation = { __typename?: 'mutation_root', update_Membership_by_pk?: { __typename?: 'Membership', Id: any, Type: number, User: { __typename?: 'User', Id: any, FirstName: string, LastName: string } } | null };

export type ChangeUserMembershipTypeMutationVariables = Exact<{
  input: ChangeUserMembershipTypeInput;
}>;


export type ChangeUserMembershipTypeMutation = { __typename?: 'mutation_root', change_user_membership_type?: { __typename?: 'ChangeUserMembershipOutput', MembershipId: any, UserEmail: string, Role: number } | null };

export type GetMembershipAndAccountsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetMembershipAndAccountsQuery = { __typename?: 'query_root', membership?: { __typename?: 'Membership', Id: any, Type: number, User: { __typename?: 'User', Id: any, Email: string, ActiveAccountId?: any | null }, Account: { __typename?: 'Account', Id: any, Name: string, Memberships: Array<{ __typename?: 'Membership', Id: any, Type: number, User: { __typename?: 'User', Id: any, Email: string } }> } } | null };

export type ListAccountMembershipsAndInvitesQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  inviteExpiry: Scalars['timestamp'];
}>;


export type ListAccountMembershipsAndInvitesQuery = { __typename?: 'query_root', Invite: Array<{ __typename?: 'Invite', Id: any, CreatedOn: string, RecipientFirstname?: string | null, RecipientLastname?: string | null, RecipientEmail: string, ExpiresAt: string, Status?: string | null }>, Membership: Array<{ __typename?: 'Membership', Id: any, Type: number, Account: { __typename?: 'Account', Id: any, Memberships: Array<{ __typename?: 'Membership', Id: any, Type: number, UserId: any }> }, User: { __typename?: 'User', Id: any, CreatedOn: string, FirstName: string, LastName: string, Email: string } }> };

export type ListAccountMembershipsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type ListAccountMembershipsQuery = { __typename?: 'query_root', Membership: Array<{ __typename?: 'Membership', Id: any, Type: number, User: { __typename?: 'User', Id: any, CreatedOn: string, FirstName: string, LastName: string, Email: string } }> };

export type DeleteMembershipMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMembershipMutation = { __typename?: 'mutation_root', delete_Membership_by_pk?: { __typename?: 'Membership', Id: any, User: { __typename?: 'User', Id: any, FirstName: string, LastName: string } } | null };

export type DeleteUserMembershipMutationVariables = Exact<{
  input: DeleteUserMembershipInput;
}>;


export type DeleteUserMembershipMutation = { __typename?: 'mutation_root', delete_user_membership?: { __typename?: 'DeleteUserMembershipOutput', MembershipId: any } | null };

export type CreateMonitoringEventMutationVariables = Exact<{
  input: MonitoringEvent_Insert_Input;
}>;


export type CreateMonitoringEventMutation = { __typename?: 'mutation_root', monitoring?: { __typename?: 'MonitoringEvent', Id: any } | null };

export type GetMonitoringForApplicationWorkflowStateTransitionQueryVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type GetMonitoringForApplicationWorkflowStateTransitionQuery = { __typename?: 'query_root', MonitoringEvent: Array<{ __typename?: 'MonitoringEvent', Id: any, Planting: { __typename?: 'Planting', Id: any, Name: string, Planter: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Email?: string | null, Name: string } | null }, Application?: { __typename?: 'Application', Id: any, Name: string, WorkflowState: string } | null } }> };

export type GetMonitoringsQueryVariables = Exact<{
  plantingId: Scalars['uuid'];
}>;


export type GetMonitoringsQuery = { __typename?: 'query_root', Planting_by_pk?: { __typename?: 'Planting', Id: any, Name: string, ApplicationId?: any | null, Quantity: number, WorkflowState: string } | null, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, CreatedOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any, PlantingLine?: { __typename?: 'PlantingLine', Id: any, OtherSpeciesName?: string | null } | null }>, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }> }> };

export type GetMonitoringEventQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetMonitoringEventQuery = { __typename?: 'query_root', MonitoringEvent: Array<{ __typename?: 'MonitoringEvent', Notes?: string | null, CreatedOn: string, MonitoredOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, HeightAverage: number, SurvivingPercent: number, SurvivingTrees: number, Species: { __typename?: 'Species', Name: string }, PlantingLine?: { __typename?: 'PlantingLine', Id: any, OtherSpeciesName?: string | null } | null }>, MonitoringLines_aggregate: { __typename?: 'MonitoringLine_aggregate', aggregate?: { __typename?: 'MonitoringLine_aggregate_fields', sum?: { __typename?: 'MonitoringLine_sum_fields', SurvivingTrees?: number | null } | null } | null }, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, Uri?: string | null }> }> };

export type CreatePlanterRegistrationMutationVariables = Exact<{
  input: CreatePlanterRegistrationInsertInput;
}>;


export type CreatePlanterRegistrationMutation = { __typename?: 'mutation_root', create_planter_registration?: { __typename?: 'CreatePlanterRegistrationOutput', Id: any, PlanterRegistration?: { __typename?: 'PlanterRegistration', Id: any, Planter: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Id: any } | null } } | null } | null };

export type UpdatePlanterRegistrationMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: InputMaybe<PlanterRegistration_Set_Input>;
}>;


export type UpdatePlanterRegistrationMutation = { __typename?: 'mutation_root', update_PlanterRegistration_by_pk?: { __typename?: 'PlanterRegistration', Id: any, Planter: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Id: any } | null } } | null };

export type InsertPlanterRegistrationMutationVariables = Exact<{
  input: PlanterRegistration_Insert_Input;
}>;


export type InsertPlanterRegistrationMutation = { __typename?: 'mutation_root', insert_PlanterRegistration_one?: { __typename?: 'PlanterRegistration', Id: any, Planter: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Id: any } | null } } | null };

export type GetPlanterRegistrationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPlanterRegistrationQuery = { __typename?: 'query_root', planterRegistration?: { __typename?: 'PlanterRegistration', Id: any, CreatedOn: string, NumberOfYears?: number | null, NumberOfTrees?: string | null, Description?: string | null, Locations?: string | null, MonitoringDescription?: string | null, WorkflowState: string, PlanterRegistrationAssets: Array<{ __typename?: 'PlanterRegistrationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null, FileName?: string | null }> } | null };

export type GetAccountPlanterRegistrationQueryVariables = Exact<{
  planterId: Scalars['uuid'];
}>;


export type GetAccountPlanterRegistrationQuery = { __typename?: 'query_root', planterRegistration: Array<{ __typename?: 'PlanterRegistration', Id: any, CreatedOn: string, NumberOfYears?: number | null, NumberOfTrees?: string | null, Description?: string | null, Locations?: string | null, MonitoringDescription?: string | null, WorkflowState: string, PlanterRegistrationAssets: Array<{ __typename?: 'PlanterRegistrationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null, FileName?: string | null }> }> };

export type GetPlanterStatsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type GetPlanterStatsQuery = { __typename?: 'query_root', PublicPlanterStatsForAccount: Array<{ __typename?: 'PublicPlanterStat', Rank?: number | null, SeasonName: string, TreesApproved: number }> };

export type GetPlanterSupportStatsQueryVariables = Exact<{
  planterId: Scalars['uuid'];
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPlanterSupportStatsQuery = { __typename?: 'query_root', Funder_aggregate: { __typename?: 'Funder_aggregate', aggregate?: { __typename?: 'Funder_aggregate_fields', count: number } | null }, Funder: Array<{ __typename?: 'Funder', Account?: { __typename?: 'Account', Id: any, Avatar?: string | null, Name: string, Uri: string } | null }> };

export type GetAdminPlanterRegistrationQueryVariables = Exact<{
  Id: Scalars['uuid'];
}>;


export type GetAdminPlanterRegistrationQuery = { __typename?: 'query_root', Account_by_pk?: { __typename?: 'Account', Id: any, Name: string, Uri: string, Planter?: { __typename?: 'Planter', PlanterRegistrations: Array<{ __typename?: 'PlanterRegistration', Id: any, NumberOfTrees?: string | null, NumberOfYears?: number | null, Description?: string | null, MonitoringDescription?: string | null, Locations?: string | null, CreatedOn: string, WorkflowState: string, PlanterRegistrationAssets: Array<{ __typename?: 'PlanterRegistrationAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null, FileName?: string | null }> }> } | null } | null };

export type CreatePlantingSiteMutationVariables = Exact<{
  object: PlantingSite_Insert_Input;
}>;


export type CreatePlantingSiteMutation = { __typename?: 'mutation_root', insert_PlantingSite_one?: { __typename?: 'PlantingSite', Id: any } | null };

export type UpdatePlantingSiteMutationVariables = Exact<{
  pkColumns: PlantingSite_Pk_Columns_Input;
  set?: InputMaybe<PlantingSite_Set_Input>;
}>;


export type UpdatePlantingSiteMutation = { __typename?: 'mutation_root', update_PlantingSite_by_pk?: { __typename?: 'PlantingSite', Id: any } | null };

export type GetPlantingQueryVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type GetPlantingQuery = { __typename?: 'query_root', Planting: Array<{ __typename?: 'Planting', Id: any, ApplicationId?: any | null, Area: number, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Quantity: number, Spacing: number, Reference: number, DistrictId?: any | null, RegionId?: any | null, SeasonId: any, SubmittedOn?: string | null, WorkflowState: string, VolunteerCount?: number | null, Application?: { __typename?: 'Application', Id: any, Reference: number } | null, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, District?: { __typename?: 'District', Name: string } | null, Planter: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any } | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, SpeciesId: any, OtherSpeciesName?: string | null, Species: { __typename?: 'Species', Id: any, Name: string } }>, Region?: { __typename?: 'Region', Name: string } | null, Season: { __typename?: 'Season', Name: string }, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, UpdatedOn: string, Uri?: string | null, Type: string }>, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }> }> };

export type ListOrphanedPlantingsQueryVariables = Exact<{
  planterId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ListOrphanedPlantingsQuery = { __typename?: 'query_root', Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', count: number } | null }, Planting_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', count: number } | null }, Planting: Array<{ __typename?: 'Planting', Id: any, CreatedOn: string, Name: string, Reference: number, Quantity: number, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season: { __typename?: 'Season', Id: any, Name: string }, District?: { __typename?: 'District', Id: any, Name: string } | null }> };

export type CreatePlantingMutationVariables = Exact<{
  input: CreatePlantingInput;
}>;


export type CreatePlantingMutation = { __typename?: 'mutation_root', planting?: { __typename?: 'CreatePlantingOutput', Planting?: { __typename?: 'Planting', Id: any } | null } | null };

export type UpdatePlantingMutationVariables = Exact<{
  input: UpdatePlantingInput;
}>;


export type UpdatePlantingMutation = { __typename?: 'mutation_root', planting?: { __typename?: 'UpdatePlantingOutput', Id: string } | null };

export type GetAdminPlantingQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminPlantingQuery = { __typename?: 'query_root', Planting?: { __typename?: 'Planting', Id: any, ApplicationId?: any | null, Area: number, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Quantity: number, Spacing: number, SubmittedOn?: string | null, WorkflowState: string, Reference: number, DistrictId?: any | null, RegionId?: any | null, SeasonId: any, VolunteerCount?: number | null, Application?: { __typename?: 'Application', Id: any, Reference: number } | null, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, District?: { __typename?: 'District', Name: string } | null, Planter: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any } | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, SpeciesId: any, OtherSpeciesName?: string | null, Species: { __typename?: 'Species', Id: any, Name: string } }>, Region?: { __typename?: 'Region', Name: string } | null, Season: { __typename?: 'Season', Name: string }, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Action: number, CreatedOn: string, Id: any, MonitoredOn: string, Notes?: string | null, PlanterId: any, PlantingId: any, SampleId?: any | null, Type: number, UpdatedOn: string, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, UpdatedOn: string, Uri?: string | null, Type: string }>, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }> } | null };

export type GetPlantingForApplicationWorkflowStateTransitionQueryVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type GetPlantingForApplicationWorkflowStateTransitionQuery = { __typename?: 'query_root', Planting: Array<{ __typename?: 'Planting', Id: any, WorkflowState: string, Quantity: number, Name: string, Planter: { __typename?: 'Planter', Account?: { __typename?: 'Account', Email?: string | null, Name: string } | null }, Application?: { __typename?: 'Application', Id: any, WorkflowState: string } | null }> };

export type DeletePlantingMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeletePlantingMutation = { __typename?: 'mutation_root', delete_PlantingAsset?: { __typename?: 'PlantingAsset_mutation_response', affected_rows: number } | null, delete_PlantingLine?: { __typename?: 'PlantingLine_mutation_response', affected_rows: number } | null, delete_Planting_by_pk?: { __typename?: 'Planting', Id: any } | null };

export type ListProjectPlantingsQueryVariables = Exact<{
  projectId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<Planting_Order_By> | Planting_Order_By>;
}>;


export type ListProjectPlantingsQuery = { __typename?: 'query_root', plantings: Array<{ __typename?: 'Planting', Id: any, SubmittedOn?: string | null, WorkflowState: string, Name: string, Quantity: number, Application?: { __typename?: 'Application', Id: any, Reference: number, Name: string } | null, MonitoringEvents_aggregate: { __typename?: 'MonitoringEvent_aggregate', aggregate?: { __typename?: 'MonitoringEvent_aggregate_fields', count: number } | null }, Season: { __typename?: 'Season', Name: string } }> };

export type GetAdminApplicationPlantingReportsQueryVariables = Exact<{
  applicationId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Planting_Order_By> | Planting_Order_By>;
}>;


export type GetAdminApplicationPlantingReportsQuery = { __typename?: 'query_root', Planting: Array<{ __typename?: 'Planting', Id: any, Area: number, ApplicationId?: any | null, CreatedOn: string, Geo: string, LandOwnership?: string | null, LandUse?: string | null, Location?: string | null, Name: string, Reference: number, Quantity: number, Spacing: number, VolunteerCount?: number | null, WorkflowState: string, District?: { __typename?: 'District', Id: any, Name: string } | null, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringLines: Array<{ __typename?: 'MonitoringLine', Id: any, SurvivingTrees: number, SurvivingPercent: number, PlantingLineId?: any | null, SpeciesId: any }> }>, Planter: { __typename?: 'Planter', Name?: string | null }, PlantingLines: Array<{ __typename?: 'PlantingLine', Id: any, Quantity: number, OtherSpeciesName?: string | null, Species: { __typename?: 'Species', Id: any, Name: string } }>, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season: { __typename?: 'Season', Id: any, Name: string } }> };

export type GetProductAndPricesQueryVariables = Exact<{
  quantity: Scalars['bigint'];
}>;


export type GetProductAndPricesQuery = { __typename?: 'query_root', Product: Array<{ __typename?: 'Product', Id: any, Name: string, ProductPrices: Array<{ __typename?: 'ProductPrice', Id: any, Amount: number }> }> };

export type GetAllProductAndPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductAndPricesQuery = { __typename?: 'query_root', Product: Array<{ __typename?: 'Product', Id: any, Name: string, ProductPrices: Array<{ __typename?: 'ProductPrice', Id: any, Amount: number, VolumeMin?: number | null, VolumeMax?: number | null }> }> };

export type GetAccountProjectsQueryVariables = Exact<{
  planterId: Scalars['uuid'];
}>;


export type GetAccountProjectsQuery = { __typename?: 'query_root', Project: Array<{ __typename?: 'Project', Name: string, Id: any, Description?: string | null, Area: string, PlantingTimeframes: string, ReceivedFundingPreviously?: boolean | null, NumberOfTreesFundedPreviously: number, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Uri?: string | null, Type: string, UpdatedOn: string, CreatedOn: string, Id: any }> }> };

export type GetSupportedProjectsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SupportedProjectsView_Order_By> | SupportedProjectsView_Order_By>;
  where?: InputMaybe<SupportedProjectsView_Bool_Exp>;
}>;


export type GetSupportedProjectsQuery = { __typename?: 'query_root', SupportedProjectsView_aggregate: { __typename?: 'SupportedProjectsView_aggregate', aggregate?: { __typename?: 'SupportedProjectsView_aggregate_fields', count: number } | null }, SupportedProjectsView: Array<{ __typename?: 'SupportedProjectsView', FunderId?: any | null, ProjectId?: any | null, SeasonId?: any | null, Quantity?: number | null, Name?: string | null, Uri?: string | null, Hero?: string | null, Area?: string | null, Purpose?: any | null, PublicPage?: boolean | null, SeasonName?: string | null, Region?: { __typename?: 'Region', Name: string, AltName?: string | null, Lat: number } | null }> };

export type UpdateAdminProjectMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  input: Project_Set_Input;
}>;


export type UpdateAdminProjectMutation = { __typename?: 'mutation_root', project?: { __typename?: 'Project', Id: any } | null };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdatePlanterProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'mutation_root', update_planter_project?: { __typename?: 'UpdatePlanterProjectOutput', Id: string } | null };

export type CreateAdminProjectMutationVariables = Exact<{
  input: Project_Insert_Input;
}>;


export type CreateAdminProjectMutation = { __typename?: 'mutation_root', project?: { __typename?: 'Project', Id: any } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'mutation_root', create_project?: { __typename?: 'CreateProjectOutput', Id: string } | null };

export type GetProjectsByUrisQueryVariables = Exact<{
  uris: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetProjectsByUrisQuery = { __typename?: 'query_root', Project: Array<{ __typename?: 'Project', Id: any, Name: string, Uri?: string | null, Area: string, Description?: string | null, Hero?: string | null, OpenFrom?: string | null, OpenTo?: string | null, WebsiteLinks?: any | null, NumberOfProperties: string, LandUse: any, LandUseOther?: string | null, OtherLandArea?: string | null, CreatedOn: string, District?: { __typename?: 'District', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Planter: { __typename?: 'Planter', Account?: { __typename?: 'Account', Avatar?: string | null, Id: any, Name: string } | null } }> };

export type GetProjectByUriQueryVariables = Exact<{
  uri: Scalars['String'];
}>;


export type GetProjectByUriQuery = { __typename?: 'query_root', Project: Array<{ __typename?: 'Project', Id: any, Name: string, Uri?: string | null, Area: string, PlantingTimeframes: string, Description?: string | null, PublicPage?: boolean | null, Geo?: string | null, Hero?: string | null, OpenFrom?: string | null, OpenTo?: string | null, Purpose?: any | null, WebsiteLinks?: any | null, NumberOfProperties: string, LandUse: any, LandUseOther?: string | null, OtherLandArea?: string | null, CreatedOn: string, FeaturedOn?: string | null, Applications_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', min?: { __typename?: 'Application_min_fields', CreatedOn?: string | null } | null, sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null } | null }, District?: { __typename?: 'District', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Applications: Array<{ __typename?: 'Application', Id: any, Name: string, Geo: string, Plantings_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', sum?: { __typename?: 'Planting_sum_fields', Quantity?: number | null } | null } | null } }>, Planter: { __typename?: 'Planter', Id: any, IsHidden: boolean, Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null, min?: { __typename?: 'Application_min_fields', CreatedOn?: string | null } | null } | null }, Account?: { __typename?: 'Account', Avatar?: string | null, Id: any, Name: string, Uri: string, Type: string, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null }, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, Type: string, Uri?: string | null }> }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type GetProjectQuery = { __typename?: 'query_root', Project: Array<{ __typename?: 'Project', Id: any, Reference: number, Area: string, Name: string, Uri?: string | null, Description?: string | null, Geo?: string | null, NumberOfTreesFundedPreviously: number, ReceivedFundingPreviously?: boolean | null, PublicPage?: boolean | null, Hero?: string | null, OpenFrom?: string | null, OpenTo?: string | null, PlantingTimeframes: string, WebsiteLinks?: any | null, NumberOfProperties: string, LandUse: any, LandUseOther?: string | null, OtherLandArea?: string | null, Purpose?: any | null, CreatedOn: string, UpdatedOn: string, WorkflowState: string, Applications_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null } | null }, Applications: Array<{ __typename?: 'Application', Id: any, Name: string, Reference: number, Required: number, Approved: number, Planned: number, WorkflowState: string, Geo: string, PlanterRegistrationPlantingId?: any | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null, Plantings_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', sum?: { __typename?: 'Planting_sum_fields', Quantity?: number | null } | null } | null }, Plantings: Array<{ __typename?: 'Planting', Id: any, Name: string, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Season: { __typename?: 'Season', Id: any, Name: string }, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, UpdatedOn: string, Uri?: string | null, Type: string }> }> }> }>, District?: { __typename?: 'District', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, CreatedOn: string, Type: string, Uri?: string | null }>, Planter: { __typename?: 'Planter', IsHidden: boolean, Account?: { __typename?: 'Account', Id: any, Uri: string, Name: string, Website?: string | null, Facebook?: string | null } | null } }> };

export type GetAdminProjectQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminProjectQuery = { __typename?: 'query_root', Project: Array<{ __typename?: 'Project', Id: any, Reference: number, Area: string, Name: string, Uri?: string | null, Description?: string | null, Geo?: string | null, NumberOfTreesFundedPreviously: number, ReceivedFundingPreviously?: boolean | null, PublicPage?: boolean | null, Hero?: string | null, OpenFrom?: string | null, OpenTo?: string | null, PlantingTimeframes: string, WebsiteLinks?: any | null, NumberOfProperties: string, LandUse: any, LandUseOther?: string | null, OtherLandArea?: string | null, Purpose?: any | null, CreatedOn: string, UpdatedOn: string, WorkflowState: string, Applications_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', min?: { __typename?: 'Application_min_fields', CreatedOn?: string | null } | null, sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null } | null }, Applications: Array<{ __typename?: 'Application', Id: any, Name: string, Reference: number, Required: number, Approved: number, Planned: number, WorkflowState: string, Geo: string, PlanterRegistrationPlantingId?: any | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null, Plantings_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', sum?: { __typename?: 'Planting_sum_fields', Quantity?: number | null } | null } | null }, Plantings: Array<{ __typename?: 'Planting', Id: any, Name: string, PlantingAssets: Array<{ __typename?: 'PlantingAsset', Id: any, Type: string, UpdatedOn: string, Uri?: string | null }>, Season: { __typename?: 'Season', Id: any, Name: string }, MonitoringEvents: Array<{ __typename?: 'MonitoringEvent', Id: any, MonitoredOn: string, MonitoringAssets: Array<{ __typename?: 'MonitoringAsset', Id: any, UpdatedOn: string, Uri?: string | null, Type: string }> }> }> }>, District?: { __typename?: 'District', Id: any, Name: string } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, ProjectAssets: Array<{ __typename?: 'ProjectAsset', Id: any, CreatedOn: string, Type: string, Uri?: string | null }>, Planter: { __typename?: 'Planter', IsHidden: boolean, Account?: { __typename?: 'Account', Id: any, Type: string, Uri: string, Name: string, Website?: string | null, Facebook?: string | null, Avatar?: string | null } | null, Application_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null, min?: { __typename?: 'Application_min_fields', CreatedOn?: string | null } | null } | null } } }> };

export type ListProjectsQueryVariables = Exact<{
  planterId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<ProjectView_Order_By> | ProjectView_Order_By>;
}>;


export type ListProjectsQuery = { __typename?: 'query_root', ProjectView_aggregate: { __typename?: 'ProjectView_aggregate', aggregate?: { __typename?: 'ProjectView_aggregate_fields', count: number } | null }, ProjectView: Array<{ __typename?: 'ProjectView', Area?: string | null, Id?: any | null, MonitoringEvents?: number | null, Name?: string | null, PlanterId?: any | null, PlantingTimeframes?: string | null, Plantings?: number | null, TreesPlanted?: number | null, TreesApproved?: number | null, PublicPage?: boolean | null, WorkflowState?: string | null, Hero?: string | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Applications: Array<{ __typename?: 'Application', Id: any, WorkflowState: string, Season?: { __typename?: 'Season', Id: any, Name: string } | null }> }> };

export type ListAdminProjectsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<ProjectView_Bool_Exp>;
  orderBy?: InputMaybe<Array<ProjectView_Order_By> | ProjectView_Order_By>;
}>;


export type ListAdminProjectsQuery = { __typename?: 'query_root', ProjectView_aggregate: { __typename?: 'ProjectView_aggregate', aggregate?: { __typename?: 'ProjectView_aggregate_fields', count: number } | null }, ProjectView: Array<{ __typename?: 'ProjectView', Area?: string | null, Id?: any | null, MonitoringEvents?: number | null, Name?: string | null, FeaturedOn?: string | null, PlanterId?: any | null, PlantingTimeframes?: string | null, Plantings?: number | null, TreesApproved?: number | null, TreesPlanted?: number | null, CreatedOn?: string | null, Reference?: number | null, PublicPage?: boolean | null, ProjectStats: Array<{ __typename?: 'ProjectStats', Season?: string | null, TreesApproved?: number | null }>, Planter?: { __typename?: 'Planter', Id: any, Account?: { __typename?: 'Account', Id: any, Name: string } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null }> };

export type GetProjectNavStateQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectNavStateQuery = { __typename?: 'query_root', Project?: { __typename?: 'Project', Id: any, Name: string, Uri?: string | null, PublicPage?: boolean | null, FeaturedOn?: string | null, WorkflowState: string, Applications: Array<{ __typename?: 'Application', Id: any, WorkflowState: string, Season?: { __typename?: 'Season', Id: any, Name: string } | null }>, Applications_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', count: number } | null } } | null };

export type ListProjectSupportersQueryVariables = Exact<{
  id: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ListProjectSupportersQuery = { __typename?: 'query_root', Funder_aggregate: { __typename?: 'Funder_aggregate', aggregate?: { __typename?: 'Funder_aggregate_fields', count: number } | null }, Funder: Array<{ __typename?: 'Funder', Account?: { __typename?: 'Account', Id: any, Name: string, Avatar?: string | null, Type: string, Uri: string, Region?: { __typename?: 'Region', Id: any, Name: string } | null } | null, Instruction: Array<{ __typename?: 'Instruction', Purchase?: { __typename?: 'Purchase', Total: number } | null, Matches_aggregate: { __typename?: 'Match_aggregate', aggregate?: { __typename?: 'Match_aggregate_fields', sum?: { __typename?: 'Match_sum_fields', Quantity?: number | null } | null } | null } }> }> };

export type GetProjectStatsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectStatsQuery = { __typename?: 'query_root', ProjectStats: Array<{ __typename?: 'ProjectStats', Season?: string | null, TreesApproved?: number | null }> };

export type GetProjectListingQueryVariables = Exact<{
  where?: InputMaybe<Project_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Project_Order_By> | Project_Order_By>;
}>;


export type GetProjectListingQuery = { __typename?: 'query_root', Count: { __typename?: 'Project_aggregate', aggregate?: { __typename?: 'Project_aggregate_fields', count: number } | null }, Projects: Array<{ __typename?: 'Project', Id: any, Name: string, Description?: string | null, CreatedOn: string, Area: string, Geo?: string | null, Hero?: string | null, Uri?: string | null, Purpose?: any | null, FeaturedOn?: string | null, Region?: { __typename?: 'Region', Id: any, Name: string, Lat: number } | null, District?: { __typename?: 'District', Id: any, Name: string } | null, Applications_aggregate: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', sum?: { __typename?: 'Application_sum_fields', Approved?: number | null } | null } | null } }> };

export type DeleteProjectMutationVariables = Exact<{
  input: DeleteProjectByIdInput;
}>;


export type DeleteProjectMutation = { __typename?: 'mutation_root', delete_project_by_id?: { __typename?: 'DeleteProjectByIdOutput', ProjectId: string } | null };

export type DeleteAdminProjectByIdMutationVariables = Exact<{
  projectId: Scalars['uuid'];
  planterId: Scalars['uuid'];
}>;


export type DeleteAdminProjectByIdMutation = { __typename?: 'mutation_root', delete_PlantingSiteAsset?: { __typename?: 'PlantingSiteAsset_mutation_response', affected_rows: number } | null, delete_PlantingSite?: { __typename?: 'PlantingSite_mutation_response', affected_rows: number } | null, delete_ApplicationAsset?: { __typename?: 'ApplicationAsset_mutation_response', affected_rows: number } | null, delete_Application?: { __typename?: 'Application_mutation_response', affected_rows: number } | null, delete_ProjectAsset?: { __typename?: 'ProjectAsset_mutation_response', affected_rows: number } | null, delete_Project?: { __typename?: 'Project_mutation_response', affected_rows: number } | null };

export type ListProjectNotesByIdQueryVariables = Exact<{
  projectId: Scalars['uuid'];
}>;


export type ListProjectNotesByIdQuery = { __typename?: 'query_root', ProjectNote: Array<{ __typename?: 'ProjectNote', Id: any, ProjectId: any, Reference: number, Notes: string, CreatedOn: string, VisitedOn: string, Purpose: string, User?: { __typename?: 'User', Id: any, FirstName: string, LastName: string } | null }> };

export type CreateProjectNoteMutationVariables = Exact<{
  object: ProjectNote_Insert_Input;
}>;


export type CreateProjectNoteMutation = { __typename?: 'mutation_root', insert_ProjectNote_one?: { __typename?: 'ProjectNote', Id: any } | null };

export type CreateProjectNoteAssetMutationVariables = Exact<{
  input: CreateProjectNoteAssetInput;
}>;


export type CreateProjectNoteAssetMutation = { __typename?: 'mutation_root', asset: { __typename?: 'CreateProjectNoteAssetOutput', SignedUrl: string } };

export type DeleteProjectNoteAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteProjectNoteAssetMutation = { __typename?: 'mutation_root', delete_ProjectNoteAsset?: { __typename?: 'ProjectNoteAsset_mutation_response', affected_rows: number } | null };

export type UpdateProjectNoteMutationVariables = Exact<{
  id: Scalars['uuid'];
  set?: InputMaybe<ProjectNote_Set_Input>;
}>;


export type UpdateProjectNoteMutation = { __typename?: 'mutation_root', update_ProjectNote_by_pk?: { __typename?: 'ProjectNote', Id: any } | null };

export type GetProjectNoteByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectNoteByIdQuery = { __typename?: 'query_root', ProjectNote_by_pk?: { __typename?: 'ProjectNote', CreatedOn: string, Id: any, Notes: string, Participants: string, ProjectId: any, Purpose: string, Reference: number, UpdatedOn: string, UserId: any, VisitedOn: string, User?: { __typename?: 'User', Id: any, FirstName: string, LastName: string } | null, ProjectNoteApplications: Array<{ __typename?: 'ProjectNoteApplication', Id: any, Application?: { __typename?: 'Application', Id: any, Reference: number, WorkflowState: string, Season?: { __typename?: 'Season', Id: any, Name: string } | null } | null }>, ProjectNoteAssets: Array<{ __typename?: 'ProjectNoteAsset', Id: any, Uri: string, FileName?: string | null }>, Project?: { __typename?: 'Project', Id: any, Name: string, Geo?: string | null, Planter: { __typename?: 'Planter', Id: any, Name?: string | null } } | null } | null };

export type DeleteProjectNoteApplicationMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteProjectNoteApplicationMutation = { __typename?: 'mutation_root', delete_ProjectNoteApplication_by_pk?: { __typename?: 'ProjectNoteApplication', Id: any } | null };

export type CreateProjectNoteApplicationMutationVariables = Exact<{
  objects: Array<ProjectNoteApplication_Insert_Input> | ProjectNoteApplication_Insert_Input;
}>;


export type CreateProjectNoteApplicationMutation = { __typename?: 'mutation_root', insert_ProjectNoteApplication?: { __typename?: 'ProjectNoteApplication_mutation_response', affected_rows: number } | null };

export type GetAdminPurchaseQueryVariables = Exact<{
  purchaseId: Scalars['uuid'];
}>;


export type GetAdminPurchaseQuery = { __typename?: 'query_root', AdminPurchaseView: Array<{ __typename?: 'AdminPurchaseView', Id?: any | null, PaymentMethod?: number | null, CreatedOn?: string | null, DistrictName?: string | null, FilterState?: string | null, FunderId?: any | null, FunderName?: string | null, FunderRegionName?: string | null, GiftDeliveryDate?: string | null, HoldOnMatch?: boolean | null, InstructionId?: any | null, Matched?: number | null, ProductName?: string | null, AccountId?: any | null, PurchaseState?: number | null, PurchaseTotal?: number | null, PurchasePrice?: number | null, ReceiptEmail?: string | null, ReceiptName?: string | null, RecipientEmail?: string | null, RecipientName?: string | null, Reference?: string | null, RegionId?: any | null, RegionName?: string | null, RegistryId?: any | null, RegistryName?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null, SubscriptionId?: any | null, Attachments: Array<{ __typename?: 'Attachment', Id: any, Type: number, Generated: boolean, Filename?: string | null }> }> };

export type GetInstructionViewQueryVariables = Exact<{
  purchaseId: Scalars['uuid'];
}>;


export type GetInstructionViewQuery = { __typename?: 'query_root', InstructionView: Array<{ __typename?: 'InstructionView', Id?: any | null, Matched?: number | null, Unmatched?: number | null, Trees?: number | null, HoldOnMatch?: boolean | null, AdminPurchaseView?: { __typename?: 'AdminPurchaseView', Id?: any | null, CreatedOn?: string | null, DistrictName?: string | null, FilterState?: string | null, FunderId?: any | null, FunderName?: string | null, FunderRegionName?: string | null, GiftDeliveryDate?: string | null, HoldOnMatch?: boolean | null, InstructionId?: any | null, Matched?: number | null, ProductName?: string | null, PurchaseState?: number | null, ReceiptEmail?: string | null, ReceiptName?: string | null, Reference?: string | null, RegionId?: any | null, RegionName?: string | null, RegistryName?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null, Attachments: Array<{ __typename?: 'Attachment', Id: any, Type: number, Generated: boolean, Filename?: string | null }> } | null }> };

export type GetInstructionViewWithMatchesQueryVariables = Exact<{
  purchaseId: Scalars['uuid'];
}>;


export type GetInstructionViewWithMatchesQuery = { __typename?: 'query_root', InstructionView: Array<{ __typename?: 'InstructionView', Id?: any | null, Matched?: number | null, Unmatched?: number | null, Trees?: number | null, PurchaseId?: any | null, Reference?: string | null, AdminPurchaseView?: { __typename?: 'AdminPurchaseView', Id?: any | null, CreatedOn?: string | null, DistrictName?: string | null, FilterState?: string | null, FunderId?: any | null, FunderName?: string | null, FunderRegionName?: string | null, GiftDeliveryDate?: string | null, HoldOnMatch?: boolean | null, InstructionId?: any | null, Matched?: number | null, ProductName?: string | null, PurchaseState?: number | null, ReceiptEmail?: string | null, ReceiptName?: string | null, Reference?: string | null, RegionId?: any | null, RegionName?: string | null, RegistryName?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null, Attachments: Array<{ __typename?: 'Attachment', Id: any, Type: number, Generated: boolean, Filename?: string | null }> } | null, Matches: Array<{ __typename?: 'Match', Id: any, Quantity: number, Application: { __typename?: 'Application', Id: any, CreatedOn: string, Name: string, Reference: number, District?: { __typename?: 'District', Id: any, Name: string } | null, Planter?: { __typename?: 'Planter', Id: any, Name?: string | null, Account?: { __typename?: 'Account', Id: any, Email?: string | null } | null } | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Season?: { __typename?: 'Season', Id: any, Name: string } | null } }> }> };

export type ListAdminPurchasesQueryVariables = Exact<{
  offset: Scalars['Int'];
  where?: InputMaybe<AdminPurchaseView_Bool_Exp>;
  order_by?: InputMaybe<Array<AdminPurchaseView_Order_By> | AdminPurchaseView_Order_By>;
}>;


export type ListAdminPurchasesQuery = { __typename?: 'query_root', AdminPurchaseView_aggregate: { __typename?: 'AdminPurchaseView_aggregate', aggregate?: { __typename?: 'AdminPurchaseView_aggregate_fields', count: number } | null }, AdminPurchaseView: Array<{ __typename?: 'AdminPurchaseView', Id?: any | null, CreatedOn?: string | null, FilterState?: string | null, FunderName?: string | null, FunderRegionName?: string | null, HoldOnMatch?: boolean | null, InstructionId?: any | null, Matched?: number | null, AccountId?: any | null, ReceiptEmail?: string | null, Reference?: string | null, RegionId?: any | null, RegionName?: string | null, SeasonName?: string | null, Trees?: number | null, TypeName?: number | null, Unmatched?: number | null, PurchasePrice?: number | null, PurchaseTotal?: number | null, SubscriptionId?: any | null, Account?: { __typename?: 'Account', Id: any, Memberships: Array<{ __typename?: 'Membership', Id: any, UserId: any }> } | null }> };

export type DeleteMatchesMutationVariables = Exact<{
  input: DeleteMatchesInput;
}>;


export type DeleteMatchesMutation = { __typename?: 'mutation_root', delete_matches?: { __typename?: 'DeleteMatchesOutput', MatchIds: Array<string> } | null };

export type CreateMatchFromInstructionMutationVariables = Exact<{
  input: CreateMatchFromInstructionInput;
}>;


export type CreateMatchFromInstructionMutation = { __typename?: 'mutation_root', create_match_from_instruction: { __typename?: 'CreateMatchFromInstructionOutput', InstructionId: string } };

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'mutation_root', create_payment?: { __typename?: 'CreatePaymentOutput', PaymentIntentClientSecret?: string | null, PurchaseId?: string | null, SubscriptionId?: string | null, Hash?: string | null, Token?: string | null } | null };

export type CreateGuestPaymentMutationVariables = Exact<{
  input: CreateGuestPaymentInput;
}>;


export type CreateGuestPaymentMutation = { __typename?: 'mutation_root', create_guest_payment: { __typename?: 'CreateGuestPaymentOutput', PaymentIntentClientSecret?: string | null, PurchaseId?: string | null, SubscriptionId?: string | null, Hash?: string | null, Token?: string | null } };

export type UpdateInstructionHoldStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  holdStatus: Scalars['Boolean'];
}>;


export type UpdateInstructionHoldStatusMutation = { __typename?: 'mutation_root', update_Instruction_by_pk?: { __typename?: 'Instruction', Id: any } | null };

export type ProcessPurchaseMutationVariables = Exact<{
  purchaseId: Scalars['String'];
}>;


export type ProcessPurchaseMutation = { __typename?: 'mutation_root', process_purchase?: { __typename?: 'ProcessPurchaseOutput', PurchaseId: string } | null };

export type VoidPurchaseMutationVariables = Exact<{
  purchaseId: Scalars['String'];
}>;


export type VoidPurchaseMutation = { __typename?: 'mutation_root', void_purchase?: { __typename?: 'VoidPurchaseOutput', PurchaseId: string } | null };

export type CreateAdminPaymentMutationVariables = Exact<{
  input: CreateAdminPaymentInput;
}>;


export type CreateAdminPaymentMutation = { __typename?: 'mutation_root', create_admin_payment?: { __typename?: 'CreateAdminPaymentOutput', PurchaseId: string } | null };

export type GetPurchasesForAccountQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['uuid'];
  orderBy?: InputMaybe<Array<PurchaseDashboardView_Order_By> | PurchaseDashboardView_Order_By>;
}>;


export type GetPurchasesForAccountQuery = { __typename?: 'query_root', PurchaseDashboardView: Array<{ __typename?: 'PurchaseDashboardView', Token?: string | null, Quantity?: number | null, CreatedOn?: string | null, Amount?: number | null, Total?: number | null, SubscriptionId?: any | null, Type?: number | null, State?: number | null, Funder?: { __typename?: 'Funder', Account?: { __typename?: 'Account', Id: any, Name: string } | null } | null }>, PurchaseDashboardView_aggregate: { __typename?: 'PurchaseDashboardView_aggregate', aggregate?: { __typename?: 'PurchaseDashboardView_aggregate_fields', count: number, sum?: { __typename?: 'PurchaseDashboardView_sum_fields', Quantity?: number | null } | null } | null } };

export type ListFunderPurchasesQueryVariables = Exact<{
  funderId: Scalars['uuid'];
}>;


export type ListFunderPurchasesQuery = { __typename?: 'query_root', purchases: Array<{ __typename?: 'Purchase', Id: any, CreatedOn: string }> };

export type ListAdminBulkGiftsQueryVariables = Exact<{
  offset: Scalars['Int'];
  where?: InputMaybe<AdminBulkGiftView_Bool_Exp>;
  order_by?: InputMaybe<Array<AdminBulkGiftView_Order_By> | AdminBulkGiftView_Order_By>;
}>;


export type ListAdminBulkGiftsQuery = { __typename?: 'query_root', AdminBulkGiftView: Array<{ __typename?: 'AdminBulkGiftView', Id?: any | null, CreatedOn?: string | null, Funder?: string | null, ReceiptEmail?: string | null, ReceiptName?: string | null, State?: number | null, RecipientCount?: number | null, User?: { __typename?: 'User', Id: any, FirstName: string, LastName: string } | null }>, AdminBulkGiftView_aggregate: { __typename?: 'AdminBulkGiftView_aggregate', aggregate?: { __typename?: 'AdminBulkGiftView_aggregate_fields', count: number } | null } };

export type GetAdminBulkGiftsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminBulkGiftsQuery = { __typename?: 'query_root', Purchase_by_pk?: { __typename?: 'Purchase', Id: any, State: number, CreatedOn: string, ReceiptEmail?: string | null, ReceiptName?: string | null, DeliverOn?: string | null, Token: string, Funder: { __typename?: 'Funder', Id: any, Account?: { __typename?: 'Account', Id: any, Name: string } | null }, RelatedPurchases: Array<{ __typename?: 'Purchase', Id: any, RecipientName?: string | null, RecipientEmail?: string | null, Quantity: number, GiftMessage?: string | null, State: number, Attachment: Array<{ __typename?: 'Attachment', Id: any, Type: number, Generated: boolean, Filename?: string | null }> }>, RelatedPurchases_aggregate: { __typename?: 'Purchase_aggregate', aggregate?: { __typename?: 'Purchase_aggregate_fields', count: number } | null } } | null };

export type GetAdminPurchaseByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminPurchaseByIdQuery = { __typename?: 'query_root', Purchase_by_pk?: { __typename?: 'Purchase', Id: any, Token: string, CreatedOn: string, RecipientEmail?: string | null, PublicName?: string | null, PublicMessage?: string | null, SubscriptionId?: any | null } | null };

export type UpdateAdminPurchaseRecipientEmailMutationVariables = Exact<{
  id: Scalars['uuid'];
  email: Scalars['String'];
}>;


export type UpdateAdminPurchaseRecipientEmailMutation = { __typename?: 'mutation_root', update_Purchase_by_pk?: { __typename?: 'Purchase', Id: any, RecipientEmail?: string | null } | null };

export type UpdatePurchaseRecipientEmailMutationVariables = Exact<{
  input: UpdatePurchaseRecipientEmailInput;
}>;


export type UpdatePurchaseRecipientEmailMutation = { __typename?: 'mutation_root', update_purchase_recipient_email?: { __typename?: 'UpdatePurchaseRecipientEmailOutput', Id: any, Email: string } | null };

export type ResendGiftCertificateMutationVariables = Exact<{
  input: ResendGiftCertificateInput;
}>;


export type ResendGiftCertificateMutation = { __typename?: 'mutation_root', resend_gift_certificate?: { __typename?: 'ResendGiftCertificateOutput', PurchaseId: string } | null };

export type AdminUpdatePurchaseErrorMutationVariables = Exact<{
  token: Scalars['String'];
  paymentError: Scalars['String'];
}>;


export type AdminUpdatePurchaseErrorMutation = { __typename?: 'mutation_root', update_Purchase?: { __typename?: 'Purchase_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Purchase', Id: any }> } | null };

export type UpdatePurchaseErrorMutationVariables = Exact<{
  input: UpdatePurchaseErrorInput;
}>;


export type UpdatePurchaseErrorMutation = { __typename?: 'mutation_root', update_purchase_error?: { __typename?: 'UpdatePurchaseErrorOutput', PurchaseId: string } | null };

export type UpdateAdminPurchasePublicMessageMutationVariables = Exact<{
  purchaseId: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAdminPurchasePublicMessageMutation = { __typename?: 'mutation_root', update_Purchase_by_pk?: { __typename?: 'Purchase', Id: any } | null, update_UserEvent?: { __typename?: 'UserEvent_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserEvent', Id: any }> } | null };

export type UpdatePurchasePublicMessageMutationVariables = Exact<{
  input: UpdatePurchasePublicMessageInput;
}>;


export type UpdatePurchasePublicMessageMutation = { __typename?: 'mutation_root', update_purchase_public_message?: { __typename?: 'UpdatePurchasePublicMessageOutput', UserEventId?: string | null } | null };

export type GetPurchaseDetailByTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetPurchaseDetailByTokenQuery = { __typename?: 'query_root', Purchase: Array<{ __typename?: 'Purchase', Id: any, CreatedOn: string, PaymentMethod: number, State: number, Type: number, Amount: number, PublicMessage?: string | null, ReceiptEmail?: string | null, ReceiptName?: string | null, Reference: number, RecipientEmail?: string | null, RecipientName?: string | null, From?: string | null, DeliverOn?: string | null, GiftMessage?: string | null, SubscriptionId?: any | null, Quantity: number, RegistryId?: any | null, Region?: { __typename?: 'Region', Id: any, Name: string, AltName?: string | null } | null, GiftTemplate?: { __typename?: 'GiftTemplate', Id: any, Preview: string, Name: string } | null, Registry?: { __typename?: 'Registry', Id: any, Uri?: string | null, Name: string } | null, Attachment: Array<{ __typename?: 'Attachment', Id: any, Generated: boolean, Type: number }> }>, Purchase_aggregate: { __typename?: 'Purchase_aggregate', aggregate?: { __typename?: 'Purchase_aggregate_fields', sum?: { __typename?: 'Purchase_sum_fields', Quantity?: number | null, Total?: number | null } | null } | null } };

export type GetRegistryViewQueryVariables = Exact<{
  id: Scalars['uuid'];
  funderId: Scalars['uuid'];
}>;


export type GetRegistryViewQuery = { __typename?: 'query_root', RegistryView: Array<{ __typename?: 'RegistryView', Id?: any | null, Reference?: number | null, Name?: string | null, ClosesOn?: string | null, CreatedOn?: string | null, IsClosed?: boolean | null, IsCampaign?: boolean | null, Summary?: string | null, Uri?: string | null, Description?: string | null, Hero?: string | null, Trees?: number | null, Gifts?: number | null, RegionName?: string | null, IsHidden?: boolean | null, RegionId?: any | null, Account?: { __typename?: 'Account', Id: any, Name: string } | null }> };

export type ListRegistriesQueryVariables = Exact<{
  funderId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ListRegistriesQuery = { __typename?: 'query_root', registriesAggregate: { __typename?: 'RegistryView_aggregate', aggregate?: { __typename?: 'RegistryView_aggregate_fields', count: number } | null }, registries: Array<{ __typename?: 'RegistryView', Id?: any | null, ClosesOn?: string | null, CreatedOn?: string | null, Description?: string | null, Gifts?: number | null, Hero?: string | null, IsClosed?: boolean | null, Name?: string | null, RegionName?: string | null, Trees?: number | null, Uri?: string | null, Purchases_aggregate: { __typename?: 'Purchase_aggregate', aggregate?: { __typename?: 'Purchase_aggregate_fields', count: number } | null } }> };

export type GetAdminRegistryViewQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAdminRegistryViewQuery = { __typename?: 'query_root', RegistryView: Array<{ __typename?: 'RegistryView', Id?: any | null, Reference?: number | null, Name?: string | null, ClosesOn?: string | null, CreatedOn?: string | null, IsClosed?: boolean | null, IsCampaign?: boolean | null, Summary?: string | null, Uri?: string | null, Description?: string | null, Hero?: string | null, Trees?: number | null, Gifts?: number | null, RegionName?: string | null, IsHidden?: boolean | null, RegionId?: any | null, Account?: { __typename?: 'Account', Id: any, Name: string, Email?: string | null } | null }> };

export type ListAdminRegistriesQueryVariables = Exact<{
  offset: Scalars['Int'];
  where?: InputMaybe<Registry_Bool_Exp>;
  order?: InputMaybe<Array<Registry_Order_By> | Registry_Order_By>;
}>;


export type ListAdminRegistriesQuery = { __typename?: 'query_root', Registry: Array<{ __typename?: 'Registry', Id: any, Reference: number, Name: string, Uri?: string | null, IsClosed: boolean, CreatedOn: string, ClosesOn?: string | null, Funder: { __typename?: 'Funder', Account?: { __typename?: 'Account', Id: any, Name: string, Email?: string | null } | null } }>, Registry_aggregate: { __typename?: 'Registry_aggregate', aggregate?: { __typename?: 'Registry_aggregate_fields', count: number } | null } };

export type GetRegistryByUriQueryVariables = Exact<{
  uri: Scalars['String'];
}>;


export type GetRegistryByUriQuery = { __typename?: 'query_root', Registry: Array<{ __typename?: 'Registry', Id: any, Name: string }> };

export type GetRegistryByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetRegistryByIdQuery = { __typename?: 'query_root', Registry_by_pk?: { __typename?: 'Registry', Id: any, Uri?: string | null, Name: string, IsCampaign?: boolean | null, CreatedOn: string, ClosesOn?: string | null, RegionId?: any | null, Funder: { __typename?: 'Funder', Id: any, Account?: { __typename?: 'Account', Id: any, Name: string } | null } } | null };

export type GetRegistryViewByUriQueryVariables = Exact<{
  uri: Scalars['String'];
  isClosed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRegistryViewByUriQuery = { __typename?: 'query_root', registries: Array<{ __typename?: 'RegistryView', Id?: any | null, ClosesOn?: string | null, CreatedOn?: string | null, Name?: string | null, Uri?: string | null, Description?: string | null, Hero?: string | null, Trees?: number | null, Gifts?: number | null, IsCampaign?: boolean | null, Summary?: string | null, Account?: { __typename?: 'Account', Id: any, Name: string, Type: string, Uri: string, Email?: string | null, Funder?: { __typename?: 'Funder', Id: any, IsHidden: boolean } | null, Planter?: { __typename?: 'Planter', Id: any, IsHidden: boolean } | null } | null }> };

export type GetRegistriesQueryVariables = Exact<{
  offset: Scalars['Int'];
  orderBy: Array<RegistryView_Order_By> | RegistryView_Order_By;
}>;


export type GetRegistriesQuery = { __typename?: 'query_root', registriesAggregate: { __typename?: 'RegistryView_aggregate', aggregate?: { __typename?: 'RegistryView_aggregate_fields', count: number } | null }, registries: Array<{ __typename?: 'RegistryView', Id?: any | null, ClosesOn?: string | null, CreatedOn?: string | null, Name?: string | null, Uri?: string | null, Description?: string | null, Hero?: string | null, Trees?: number | null, Gifts?: number | null, IsCampaign?: boolean | null, Summary?: string | null }> };

export type UpdateRegistryMutationVariables = Exact<{
  id: Scalars['uuid'];
  input: Registry_Set_Input;
}>;


export type UpdateRegistryMutation = { __typename?: 'mutation_root', update_Registry_by_pk?: { __typename?: 'Registry', Id: any } | null };

export type CreateRegistryMutationVariables = Exact<{
  input: CreateRegistryInput;
}>;


export type CreateRegistryMutation = { __typename?: 'mutation_root', create_registry?: { __typename?: 'CreateRegistryOutput', Id: string } | null };

export type InsertRegistryMutationVariables = Exact<{
  input: Registry_Insert_Input;
}>;


export type InsertRegistryMutation = { __typename?: 'mutation_root', insert_Registry_one?: { __typename?: 'Registry', Id: any } | null };

export type UpdateAdminRegistriesForClosureMutationVariables = Exact<{
  now: Scalars['timestamp'];
}>;


export type UpdateAdminRegistriesForClosureMutation = { __typename?: 'mutation_root', closedRegistries?: { __typename?: 'Registry_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Registry', Id: any, Name: string, IsClosed: boolean, ClosesOn?: string | null }> } | null };

export type DeleteRegistryMutationVariables = Exact<{
  input: DeleteRegistryWithNoGiftsInput;
}>;


export type DeleteRegistryMutation = { __typename?: 'mutation_root', delete_registry_with_no_gifts: { __typename?: 'DeleteRegistryWithNoGiftsOutput', afffectedRows: number } };

export type DeleteAdminRegistryMutationVariables = Exact<{
  id: Scalars['uuid'];
  funderId: Scalars['uuid'];
}>;


export type DeleteAdminRegistryMutation = { __typename?: 'mutation_root', delete_Registry?: { __typename?: 'Registry_mutation_response', affected_rows: number } | null };

export type CreatePurchasesReportMutationVariables = Exact<{
  input: CreatePurchasesReportInput;
}>;


export type CreatePurchasesReportMutation = { __typename?: 'mutation_root', report: { __typename?: 'CreatePurchasesReportOutput', Report?: { __typename?: 'Report', Id: any, Filename: string, Expires: string, State: number, Type: number, CreatedOn: string, UpdatedOn: string } | null } };

export type CreateTreePoolReportMutationVariables = Exact<{
  input: CreateTreePoolReportInput;
}>;


export type CreateTreePoolReportMutation = { __typename?: 'mutation_root', report?: { __typename?: 'CreateTreePoolReportOutput', Report?: { __typename?: 'Report', Id: any, Filename: string, Expires: string, State: number, Type: number, CreatedOn: string, UpdatedOn: string } | null } | null };

export type CreateAccountsReportMutationVariables = Exact<{
  input: CreateAccountsReportInput;
}>;


export type CreateAccountsReportMutation = { __typename?: 'mutation_root', report: { __typename?: 'CreateAccountsReportOutput', Report?: { __typename?: 'Report', Id: any, Filename: string, Expires: string, State: number, Type: number, CreatedOn: string, UpdatedOn: string } | null } };

export type GetReportQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetReportQuery = { __typename?: 'query_root', report?: { __typename?: 'Report', Id: any, Filename: string, Expires: string, State: number, Type: number, CreatedOn: string, UpdatedOn: string } | null };

export type GeneratePresignedUrlQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type GeneratePresignedUrlQuery = { __typename?: 'query_root', presignedUrl: string };

export type GeneratePutObjectPresignedUrlMutationVariables = Exact<{
  input: GeneratePutObjectPresignedUrlInput;
}>;


export type GeneratePutObjectPresignedUrlMutation = { __typename?: 'mutation_root', generate_put_object_presigned_url?: { __typename?: 'GeneratePutObjectPresignedUrlOutput', S3Key: string, SignedUrl: string } | null };

export type ListOpenSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOpenSeasonsQuery = { __typename?: 'query_root', Season: Array<{ __typename?: 'Season', Id: any, Name: string }> };

export type ListSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSeasonsQuery = { __typename?: 'query_root', Season: Array<{ __typename?: 'Season', Id: any, Name: string, ApplicationsClosed: boolean }> };

export type GetRegionByIdQueryVariables = Exact<{
  regionId: Scalars['uuid'];
}>;


export type GetRegionByIdQuery = { __typename?: 'query_root', Region: Array<{ __typename?: 'Region', Id: any, Name: string, AltName?: string | null }> };

export type ListRegionsForFormQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRegionsForFormQuery = { __typename?: 'query_root', Region: Array<{ __typename?: 'Region', Id: any, Lookups?: string | null, Name: string, ProperSpelling?: string | null, AltName?: string | null, Type: string }> };

export type ListRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRegionsQuery = { __typename?: 'query_root', Region: Array<{ __typename?: 'Region', Id: any, Lookups?: string | null, Name: string }> };

export type ListDistrictsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDistrictsQuery = { __typename?: 'query_root', District: Array<{ __typename?: 'District', Id: any, Lookups?: string | null, Name: string }> };

export type ListSeasonsAndSpeciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSeasonsAndSpeciesQuery = { __typename?: 'query_root', Season: Array<{ __typename?: 'Season', Id: any, Name: string }>, Species: Array<{ __typename?: 'Species', Id: any, Name: string, Scientific: string, Type: string }> };

export type ListRegionsAndDistrictsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRegionsAndDistrictsQuery = { __typename?: 'query_root', District: Array<{ __typename?: 'District', Id: any, Lookups?: string | null, Name: string, ProperSpelling?: string | null, RegionDistricts: Array<{ __typename?: 'RegionDistrict', RegionId: any }> }>, Region: Array<{ __typename?: 'Region', Id: any, AltName?: string | null, Lookups?: string | null, Name: string, ProperSpelling?: string | null, Reference: number }> };

export type ListRegionsForSearchApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRegionsForSearchApplicationsQuery = { __typename?: 'query_root', Region: Array<{ __typename?: 'Region', Id: any, Name: string }> };

export type GetDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardDataQuery = { __typename?: 'query_root', PlanterStatsForUser: Array<{ __typename?: 'PlanterStat', MostPopularRegion?: string | null, MostPopularSpecies?: string | null, Rank?: number | null, SeasonName: string, TotalMonitorings: number, TotalApplications: number, TotalProjects: number, TreesApproved: number, AccountYearJoined: number }>, FunderStatsForUser: Array<{ __typename?: 'FunderStat', PlantersSupported: number, ProjectSupported: number, Rank?: number | null, SeasonName: string, TreesFunded: number, AccountYearJoined: number }> };

export type GetPlanterViewQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<PlanterView_Bool_Exp>;
  order_by?: InputMaybe<Array<PlanterView_Order_By> | PlanterView_Order_By>;
}>;


export type GetPlanterViewQuery = { __typename?: 'query_root', PlanterView_aggregate: { __typename?: 'PlanterView_aggregate', aggregate?: { __typename?: 'PlanterView_aggregate_fields', count: number } | null }, PlanterView: Array<{ __typename?: 'PlanterView', TotalTreesApproved?: number | null, Avatar?: string | null, CurrentSeason?: number | null, BeforeLastSeason?: number | null, Id?: any | null, LastSeason?: number | null, Name?: string | null, ApplicationCount?: number | null, Rank?: number | null, RegionId?: any | null, RegionName?: string | null, Type?: string | null, Uri?: string | null }> };

export type GetFunderViewQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where?: InputMaybe<FunderView_Bool_Exp>;
  order_by?: InputMaybe<Array<FunderView_Order_By> | FunderView_Order_By>;
}>;


export type GetFunderViewQuery = { __typename?: 'query_root', FunderView_aggregate: { __typename?: 'FunderView_aggregate', aggregate?: { __typename?: 'FunderView_aggregate_fields', count: number } | null }, FunderView: Array<{ __typename?: 'FunderView', Avatar?: string | null, BeforeLastSeason?: number | null, CurrentSeason?: number | null, Id?: any | null, LastSeason?: number | null, Name?: string | null, PlanterCount?: number | null, Rank?: number | null, RegionId?: any | null, RegionName?: string | null, TotalCount?: number | null, Type?: string | null, Uri?: string | null }> };

export type GetTreePoolStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreePoolStatsQuery = { __typename?: 'query_root', statistics: Array<{ __typename?: 'TreePoolStatsView', Applications?: number | null, Approved?: number | null, ApplicationsApproved?: number | null, Funders?: number | null, Id?: any | null, Matched?: number | null, Name?: string | null, Total?: number | null, TreesMatched?: number | null, TreesUnmatched?: number | null, Unmatched?: number | null }> };

export type GetTreesFundedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreesFundedQuery = { __typename?: 'query_root', funderStats: Array<{ __typename?: 'FunderStat', SeasonName: string, TreesFunded: number }> };

export type GetStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticsQuery = { __typename?: 'query_root', statistics: Array<{ __typename?: 'StatisticsView', PlantingsSupported?: number | null, TotalPlantersAndFunders?: number | null, TotalTrees?: number | null, TotalTreesFundedAndGifted?: number | null, TotalTreesFunded?: number | null, TotalTreesGifted?: number | null, TotalOpenRegistries?: number | null }> };

export type GetAccountSubscriptionDetailsQueryVariables = Exact<{
  funderId: Scalars['uuid'];
}>;


export type GetAccountSubscriptionDetailsQuery = { __typename?: 'query_root', Subscription: Array<{ __typename?: 'Subscription', Id: any, CreatedOn: string, FunderId: any, PlantingRegionId?: any | null, PublicMessage?: string | null, PublicName?: string | null, Quantity: number, ReceiptEmail?: string | null, ReceiptName?: string | null, UpdatedOn: string, UserId: any, StripeSubscriptionId?: string | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, Funder: { __typename?: 'Funder', Account?: { __typename?: 'Account', StripeCustomerId?: string | null, PaymentMethodDescriptor?: string | null } | null } }> };

export type GetSubscriptionQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type GetSubscriptionQuery = { __typename?: 'query_root', subscription?: { __typename?: 'StripeSummary', CardLastFour?: string | null, Subscription?: { __typename?: 'StripeSubscription', TotalQuantity?: number | null, TotalAmount?: number | null, StartDate?: string | null, NextChargeDate?: string | null } | null } | null };

export type UpdateAdminSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: InputMaybe<Subscription_Set_Input>;
}>;


export type UpdateAdminSubscriptionMutation = { __typename?: 'mutation_root', subscription?: { __typename?: 'Subscription', CreatedOn: string, FunderId: any, Id: any, PlantingRegionId?: any | null, PublicMessage?: string | null, PublicName?: string | null, Quantity: number, ReceiptEmail?: string | null, ReceiptName?: string | null, UpdatedOn: string, UserId: any } | null };

export type UpdateAdminSubscriptionByStripeIdMutationVariables = Exact<{
  stripeId: Scalars['String'];
  input?: InputMaybe<Subscription_Set_Input>;
}>;


export type UpdateAdminSubscriptionByStripeIdMutation = { __typename?: 'mutation_root', subscriptions?: { __typename?: 'Subscription_mutation_response', returning: Array<{ __typename?: 'Subscription', Id: any, ReceiptEmail?: string | null, ReceiptName?: string | null }> } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateAccountSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'mutation_root', update_account_subscription?: { __typename?: 'UpdateAccountSubscriptionOutput', Id: string } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'mutation_root', subscription?: { __typename?: 'CancelSubscriptionOutput', Id: string } | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserByEmailQuery = { __typename?: 'query_root', User: Array<{ __typename?: 'User', Id: any, Email: string, FirstName: string, LastName: string }> };

export type UpdateUserFirstAndLastNameMutationVariables = Exact<{
  id: Scalars['uuid'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserFirstAndLastNameMutation = { __typename?: 'mutation_root', update_User_by_pk?: { __typename?: 'User', Id: any, FirstName: string, LastName: string } | null };

export type GetUserAndMembershipsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserAndMembershipsQuery = { __typename?: 'query_root', User?: { __typename?: 'User', Id: any, Identifier?: string | null, Email: string, FirstName: string, LastName: string, ActiveAccountId?: any | null, ActiveProfileType?: string | null, Account?: { __typename?: 'Account', Id: any, CreatedOn: string, FunderId?: any | null, PlanterId?: any | null, Avatar?: string | null, Banner?: string | null, Type: string, Name: string, Email?: string | null, Uri: string, StripeCustomerId?: string | null, PaymentMethodDescriptor?: string | null, Funder?: { __typename?: 'Funder', Id: any, Name?: string | null, IsHidden: boolean } | null, Planter?: { __typename?: 'Planter', Id: any, IsHidden: boolean, ProjectsCount?: number | null } | null } | null } | null, Membership: Array<{ __typename?: 'Membership', Id: any, AccountId: any, Type: number, Account: { __typename?: 'Account', Id: any, Name: string, Avatar?: string | null, FunderId?: any | null, PlanterId?: any | null } }> };

export type UpdateActiveAccountIdMutationVariables = Exact<{
  ActiveAccountId: Scalars['uuid'];
  id: Scalars['uuid'];
  ActiveProfileType: Scalars['String'];
}>;


export type UpdateActiveAccountIdMutation = { __typename?: 'mutation_root', update_User_by_pk?: { __typename?: 'User', ActiveAccountId?: any | null, ActiveProfileType?: string | null } | null };

export type GetUserAndProductQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserAndProductQuery = { __typename?: 'query_root', user?: { __typename?: 'User', Id: any, Identifier?: string | null, Email: string, FirstName: string, LastName: string, Account?: { __typename?: 'Account', Id: any, FunderId?: any | null, PlanterId?: any | null, Avatar?: string | null, Banner?: string | null, Type: string, Name: string, Email?: string | null } | null } | null, product: Array<{ __typename?: 'Product', Id: any }> };

export type ListUserEventsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: Scalars['Int'];
  types?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ListUserEventsQuery = { __typename?: 'query_root', userEvents: Array<{ __typename?: 'UserEventView', Id?: any | null, Type?: number | null, Comment?: string | null, CreatedOn?: string | null, Name?: string | null, Uri?: string | null, Description?: string | null, Avatar?: string | null, RegistryUri?: string | null, RegistryName?: string | null, Quantity?: number | null, RegionName?: string | null, ProjectUri?: string | null, ProjectName?: string | null, PurchaseType?: number | null, HasSubscriptionId?: boolean | null }> };

export type CountUserEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountUserEventsQuery = { __typename?: 'query_root', userEventsAggregate: { __typename?: 'UserEventView_aggregate', aggregate?: { __typename?: 'UserEventView_aggregate_fields', count: number } | null } };

export type GetAdminUserQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetAdminUserQuery = { __typename?: 'query_root', User_by_pk?: { __typename?: 'User', Id: any, CreatedOn: string, Email: string, FirstName: string, LastName: string, Account?: { __typename?: 'Account', Id: any, CreatedOn: string, Name: string, Email?: string | null, Reference: number, Type: string, PlanterId?: any | null, FunderId?: any | null } | null, Memberships: Array<{ __typename?: 'Membership', Id: any, Account: { __typename?: 'Account', Id: any, CreatedOn: string, Name: string, Email?: string | null, Reference: number, Type: string, Memberships: Array<{ __typename?: 'Membership', Id: any }> } }> } | null };

export type GetUserAccountIntercomDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountIntercomDataQuery = { __typename?: 'query_root', get_user_account_intercom_data?: { __typename?: 'GetUserIntercomDataOutput', AdminProfileLink?: string | null, ApplicationDate?: string | null, Avatar?: string | null, CreatedOn?: string | null, Email?: string | null, FirstName?: string | null, IdType?: string | null, IsProfileHidden?: boolean | null, LastName?: string | null, ProfileLink?: string | null, ProfileId?: string | null, ProfileName?: string | null, District?: string | null, FundedAmount?: string | null, FundedQuantity?: string | null, PhoneNumber?: string | null, PrimaryCategory?: string | null, SecondaryCategory?: string | null, Region?: string | null, TreesAppliedFor?: string | null, TreesApproved?: string | null, LastFunded?: string | null, LastApplied?: string | null, TreesPlanted?: string | null, HasSubscriptions?: boolean | null, SubscriptionCreatedOn?: string | null, SubscriptionState?: string | null, SubscriptionQuantity?: number | null, SubscriptionCancelledOn?: string | null, Hash?: string | null, Profiles?: Array<{ __typename?: 'LinkedUserProfile', Name?: string | null, ProfileLink?: string | null, ProfileType?: string | null } | null> | null } | null };

export type GetAdminUserIntercomDataQueryVariables = Exact<{
  userId: Scalars['uuid'];
  currentSeason: Scalars['uuid'];
  lastSeason: Scalars['uuid'];
  yearStart: Scalars['timestamp'];
}>;


export type GetAdminUserIntercomDataQuery = { __typename?: 'query_root', UserData?: { __typename?: 'User', Id: any, FirstName: string, LastName: string, Email: string, CreatedOn: string, Account?: { __typename?: 'Account', Id: any, Name: string, Email?: string | null, Phone?: string | null, Uri: string, Avatar?: string | null, Type: string, BusinessType?: string | null, OrgType?: string | null, GovType?: string | null, SchoolType?: string | null, Sector?: string | null, Region?: { __typename?: 'Region', Id: any, Name: string } | null, District?: { __typename?: 'District', Id: any, Name: string } | null, Funder?: { __typename?: 'Funder', Id: any, IsHidden: boolean, Subscriptions: Array<{ __typename?: 'Subscription', CancelDate?: string | null, CreatedOn: string, Quantity: number, State: string }>, LastFunded: { __typename?: 'Instruction_aggregate', aggregate?: { __typename?: 'Instruction_aggregate_fields', max?: { __typename?: 'Instruction_max_fields', CreatedOn?: string | null } | null } | null }, TreesFunded: { __typename?: 'Instruction_aggregate', nodes: Array<{ __typename?: 'Instruction', Purchase?: { __typename?: 'Purchase', Total: number, Quantity: number } | null }> } } | null, Planter?: { __typename?: 'Planter', Id: any, IsHidden: boolean, PlantingData: Array<{ __typename?: 'Application', Plantings_aggregate: { __typename?: 'Planting_aggregate', aggregate?: { __typename?: 'Planting_aggregate_fields', sum?: { __typename?: 'Planting_sum_fields', Quantity?: number | null } | null } | null } }>, TreeData: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', sum?: { __typename?: 'Application_sum_fields', Approved?: number | null, Required?: number | null } | null } | null }, ApplicationData: { __typename?: 'Application_aggregate', aggregate?: { __typename?: 'Application_aggregate_fields', min?: { __typename?: 'Application_min_fields', CreatedOn?: string | null } | null, max?: { __typename?: 'Application_max_fields', CreatedOn?: string | null } | null } | null } } | null } | null, Memberships: Array<{ __typename?: 'Membership', Account: { __typename?: 'Account', Id: any, Name: string, Uri: string, Type: string } }> } | null };

export type GetUserEventViewsForRegistryQueryVariables = Exact<{
  offset: Scalars['Int'];
  registryId: Scalars['uuid'];
}>;


export type GetUserEventViewsForRegistryQuery = { __typename?: 'query_root', UserEventView_aggregate: { __typename?: 'UserEventView_aggregate', aggregate?: { __typename?: 'UserEventView_aggregate_fields', count: number } | null }, UserEventView: Array<{ __typename?: 'UserEventView', Id?: any | null, Avatar?: string | null, Comment?: string | null, CreatedOn?: string | null, Description?: string | null, Name?: string | null }> };

export type GetLatestUserEventQueryVariables = Exact<{
  where?: InputMaybe<UserEventView_Bool_Exp>;
}>;


export type GetLatestUserEventQuery = { __typename?: 'query_root', UserEventView: Array<{ __typename?: 'UserEventView', CreatedOn?: string | null, Comment?: string | null, Name?: string | null, Quantity?: number | null, Type?: number | null, PurchaseType?: number | null, HasSubscriptionId?: boolean | null }> };


export const CreateAccountDocument = gql`
    mutation createAccount($input: CreateAccountInsertInput!) {
  account: create_account(input: $input) {
    Id
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation updatePaymentMethod($input: UpdateAccountPaymentMethodInput!) {
  update_account_payment_method(input: $input) {
    Id
  }
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($id: uuid!, $attrs: Account_set_input!, $planterIds: [uuid!] = [], $funderIds: [uuid!] = [], $funderAttrs: Funder_set_input = {}, $planterAttrs: Planter_set_input = {}) {
  account: update_Account_by_pk(pk_columns: {Id: $id}, _set: $attrs) {
    Id
  }
  funder: update_Funder(where: {Id: {_in: $funderIds}}, _set: $funderAttrs) {
    returning {
      Id
    }
  }
  planter: update_Planter(where: {Id: {_in: $planterIds}}, _set: $planterAttrs) {
    returning {
      Id
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attrs: // value for 'attrs'
 *      planterIds: // value for 'planterIds'
 *      funderIds: // value for 'funderIds'
 *      funderAttrs: // value for 'funderAttrs'
 *      planterAttrs: // value for 'planterAttrs'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const ListAdminAccountsDocument = gql`
    query listAdminAccounts($offset: Int!, $where: Account_bool_exp, $sort: [Account_order_by!]) {
  Account(offset: $offset, limit: 10, where: $where, order_by: $sort) {
    Id
    CreatedOn
    Email
    Name
    Reference
    Type
    Memberships {
      Id
    }
    Planter {
      Id
      IsHidden
    }
    Funder {
      Id
      IsHidden
    }
  }
  Account_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useListAdminAccountsQuery__
 *
 * To run a query within a React component, call `useListAdminAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminAccountsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListAdminAccountsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminAccountsQuery, ListAdminAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminAccountsQuery, ListAdminAccountsQueryVariables>(ListAdminAccountsDocument, options);
      }
export function useListAdminAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminAccountsQuery, ListAdminAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminAccountsQuery, ListAdminAccountsQueryVariables>(ListAdminAccountsDocument, options);
        }
export type ListAdminAccountsQueryHookResult = ReturnType<typeof useListAdminAccountsQuery>;
export type ListAdminAccountsLazyQueryHookResult = ReturnType<typeof useListAdminAccountsLazyQuery>;
export type ListAdminAccountsQueryResult = Apollo.QueryResult<ListAdminAccountsQuery, ListAdminAccountsQueryVariables>;
export const GetAdminAccountDocument = gql`
    query getAdminAccount($id: uuid!) {
  Account: Account_by_pk(Id: $id) {
    Id
    Reference
    Name
    Email
    Type
    BusinessType
    BusinessSize
    OrgType
    GovType
    SchoolType
    Sector
    DistrictName
    Uri
    PaymentMethodDescriptor
    StripeCustomerId
    Memberships {
      Id
      Type
      User {
        Id
        Email
        Role
        FirstName
        LastName
      }
    }
    RegionName
    PlanterId
    FunderId
    Avatar
    Banner
    Description
    Phone
    Mobile
    CreatedOn
    Attachments(where: {Generated: {_eq: true}}) {
      Id
      Type
      Generated
      Filename
      Year
    }
    Planter {
      Id
      Name
      IsHidden
    }
    Funder {
      Id
      Name
      IsHidden
      Subscriptions(order_by: {CreatedOn: desc}) {
        Id
        CreatedOn
        CancelDate
        State
        CancelReason
        Quantity
        PublicMessage
        PublicName
        ReceiptName
        ReceiptEmail
        Region {
          Id
          Name
        }
      }
    }
    Addresses {
      Id
      StreetNumber
      StreetName
      City
      District
      Region
      Country
      PostalCode
      Place
      Geo
    }
  }
}
    `;

/**
 * __useGetAdminAccountQuery__
 *
 * To run a query within a React component, call `useGetAdminAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAdminAccountQuery, GetAdminAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAccountQuery, GetAdminAccountQueryVariables>(GetAdminAccountDocument, options);
      }
export function useGetAdminAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAccountQuery, GetAdminAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAccountQuery, GetAdminAccountQueryVariables>(GetAdminAccountDocument, options);
        }
export type GetAdminAccountQueryHookResult = ReturnType<typeof useGetAdminAccountQuery>;
export type GetAdminAccountLazyQueryHookResult = ReturnType<typeof useGetAdminAccountLazyQuery>;
export type GetAdminAccountQueryResult = Apollo.QueryResult<GetAdminAccountQuery, GetAdminAccountQueryVariables>;
export const GetAccountAndProductDocument = gql`
    query getAccountAndProduct($accountId: uuid!) {
  account: Account_by_pk(Id: $accountId) {
    Id
    FunderId
    PlanterId
    Avatar
    Banner
    Type
    Name
    Email
  }
  product: Product(where: {IsArchived: {_eq: false}}, limit: 1) {
    Id
  }
}
    `;

/**
 * __useGetAccountAndProductQuery__
 *
 * To run a query within a React component, call `useGetAccountAndProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountAndProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountAndProductQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountAndProductQuery(baseOptions: Apollo.QueryHookOptions<GetAccountAndProductQuery, GetAccountAndProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountAndProductQuery, GetAccountAndProductQueryVariables>(GetAccountAndProductDocument, options);
      }
export function useGetAccountAndProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountAndProductQuery, GetAccountAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountAndProductQuery, GetAccountAndProductQueryVariables>(GetAccountAndProductDocument, options);
        }
export type GetAccountAndProductQueryHookResult = ReturnType<typeof useGetAccountAndProductQuery>;
export type GetAccountAndProductLazyQueryHookResult = ReturnType<typeof useGetAccountAndProductLazyQuery>;
export type GetAccountAndProductQueryResult = Apollo.QueryResult<GetAccountAndProductQuery, GetAccountAndProductQueryVariables>;
export const GetAdminAccountRegistriesDocument = gql`
    query getAdminAccountRegistries($limit: Int = 10, $offset: Int = 0, $accountId: uuid!, $orderBy: [RegistryView_order_by!]) {
  RegistryView_aggregate(where: {AccountId: {_eq: $accountId}}) {
    aggregate {
      count
    }
  }
  RegistryView(
    limit: $limit
    offset: $offset
    where: {AccountId: {_eq: $accountId}}
    order_by: $orderBy
  ) {
    Id
    Name
    Trees
    Total
    RegionName
    Reference
    Account {
      Id
      Name
    }
    IsClosed
    IsHidden
    IsFeatured
    Hero
    Gifts
    DistrictName
    Description
    CreatedOn
    ClosesOn
  }
}
    `;

/**
 * __useGetAdminAccountRegistriesQuery__
 *
 * To run a query within a React component, call `useGetAdminAccountRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAccountRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAccountRegistriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAdminAccountRegistriesQuery(baseOptions: Apollo.QueryHookOptions<GetAdminAccountRegistriesQuery, GetAdminAccountRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAccountRegistriesQuery, GetAdminAccountRegistriesQueryVariables>(GetAdminAccountRegistriesDocument, options);
      }
export function useGetAdminAccountRegistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAccountRegistriesQuery, GetAdminAccountRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAccountRegistriesQuery, GetAdminAccountRegistriesQueryVariables>(GetAdminAccountRegistriesDocument, options);
        }
export type GetAdminAccountRegistriesQueryHookResult = ReturnType<typeof useGetAdminAccountRegistriesQuery>;
export type GetAdminAccountRegistriesLazyQueryHookResult = ReturnType<typeof useGetAdminAccountRegistriesLazyQuery>;
export type GetAdminAccountRegistriesQueryResult = Apollo.QueryResult<GetAdminAccountRegistriesQuery, GetAdminAccountRegistriesQueryVariables>;
export const GetAdminAccountApplicationsViewDocument = gql`
    query getAdminAccountApplicationsView($limit: Int = 10, $offset: Int = 0, $accountId: uuid!, $orderBy: [ApplicationView_order_by!]) {
  ApplicationView_aggregate(where: {Planter: {Account: {Id: {_eq: $accountId}}}}) {
    aggregate {
      count
    }
  }
  ApplicationView(
    limit: $limit
    offset: $offset
    where: {Planter: {Account: {Id: {_eq: $accountId}}}}
    order_by: $orderBy
  ) {
    Id
    Approved
    CreatedOn
    District {
      Id
      Name
    }
    HoldOnMatch
    IsMatched
    Matched
    Name
    Planned
    Planter {
      Id
      Name
      Account {
        Id
        Email
      }
    }
    Project {
      Id
      Name
    }
    PlanterRegistrationPlantingId
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    Unmatched
    WorkflowState
  }
}
    `;

/**
 * __useGetAdminAccountApplicationsViewQuery__
 *
 * To run a query within a React component, call `useGetAdminAccountApplicationsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAccountApplicationsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAccountApplicationsViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAdminAccountApplicationsViewQuery(baseOptions: Apollo.QueryHookOptions<GetAdminAccountApplicationsViewQuery, GetAdminAccountApplicationsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAccountApplicationsViewQuery, GetAdminAccountApplicationsViewQueryVariables>(GetAdminAccountApplicationsViewDocument, options);
      }
export function useGetAdminAccountApplicationsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAccountApplicationsViewQuery, GetAdminAccountApplicationsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAccountApplicationsViewQuery, GetAdminAccountApplicationsViewQueryVariables>(GetAdminAccountApplicationsViewDocument, options);
        }
export type GetAdminAccountApplicationsViewQueryHookResult = ReturnType<typeof useGetAdminAccountApplicationsViewQuery>;
export type GetAdminAccountApplicationsViewLazyQueryHookResult = ReturnType<typeof useGetAdminAccountApplicationsViewLazyQuery>;
export type GetAdminAccountApplicationsViewQueryResult = Apollo.QueryResult<GetAdminAccountApplicationsViewQuery, GetAdminAccountApplicationsViewQueryVariables>;
export const GetAdminAccountPurchasesDocument = gql`
    query getAdminAccountPurchases($limit: Int = 10, $offset: Int = 0, $where: [AdminPurchaseView_bool_exp!] = {}, $order_by: [AdminPurchaseView_order_by!], $accountId: uuid!) {
  AdminPurchaseView_aggregate(where: {AccountId: {_eq: $accountId}, _and: $where}) {
    aggregate {
      count
    }
  }
  AdminPurchaseView(
    limit: 10
    offset: $offset
    where: {AccountId: {_eq: $accountId}, _and: $where}
    order_by: $order_by
  ) {
    Id
    CreatedOn
    FilterState
    FunderName
    FunderRegionName
    HoldOnMatch
    InstructionId
    Matched
    AccountId
    ReceiptEmail
    Reference
    RegionId
    RegionName
    SeasonName
    Trees
    TypeName
    Unmatched
    PurchasePrice
    PurchaseTotal
    SubscriptionId
  }
}
    `;

/**
 * __useGetAdminAccountPurchasesQuery__
 *
 * To run a query within a React component, call `useGetAdminAccountPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAccountPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAccountPurchasesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAdminAccountPurchasesQuery(baseOptions: Apollo.QueryHookOptions<GetAdminAccountPurchasesQuery, GetAdminAccountPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAccountPurchasesQuery, GetAdminAccountPurchasesQueryVariables>(GetAdminAccountPurchasesDocument, options);
      }
export function useGetAdminAccountPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAccountPurchasesQuery, GetAdminAccountPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAccountPurchasesQuery, GetAdminAccountPurchasesQueryVariables>(GetAdminAccountPurchasesDocument, options);
        }
export type GetAdminAccountPurchasesQueryHookResult = ReturnType<typeof useGetAdminAccountPurchasesQuery>;
export type GetAdminAccountPurchasesLazyQueryHookResult = ReturnType<typeof useGetAdminAccountPurchasesLazyQuery>;
export type GetAdminAccountPurchasesQueryResult = Apollo.QueryResult<GetAdminAccountPurchasesQuery, GetAdminAccountPurchasesQueryVariables>;
export const ListAccountSupportersDocument = gql`
    query listAccountSupporters($accountId: uuid!, $offset: Int) {
  list_account_supporters(input: {AccountId: $accountId, Offset: $offset}) {
    Funder {
      Id
      Avatar
      Name
      Uri
      Type
      Trees
      Region
    }
    Funder_aggregate {
      aggregate {
        count
      }
    }
    Planter {
      Id
      Avatar
      Name
      Uri
      Type
      Trees
      Region
    }
    Planter_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useListAccountSupportersQuery__
 *
 * To run a query within a React component, call `useListAccountSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountSupportersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountSupportersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListAccountSupportersQuery(baseOptions: Apollo.QueryHookOptions<ListAccountSupportersQuery, ListAccountSupportersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountSupportersQuery, ListAccountSupportersQueryVariables>(ListAccountSupportersDocument, options);
      }
export function useListAccountSupportersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountSupportersQuery, ListAccountSupportersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountSupportersQuery, ListAccountSupportersQueryVariables>(ListAccountSupportersDocument, options);
        }
export type ListAccountSupportersQueryHookResult = ReturnType<typeof useListAccountSupportersQuery>;
export type ListAccountSupportersLazyQueryHookResult = ReturnType<typeof useListAccountSupportersLazyQuery>;
export type ListAccountSupportersQueryResult = Apollo.QueryResult<ListAccountSupportersQuery, ListAccountSupportersQueryVariables>;
export const GetAccountByUriDocument = gql`
    query getAccountByUri($uri: String!) {
  Account(where: {Uri: {_eq: $uri}}) {
    Id
    Avatar
    Banner
    Name
    Description
    FunderId
    PlanterId
    RegionName
    Type
    Facebook
    Website
    Planter {
      Projects(where: {PublicPage: {_eq: true}}) {
        Id
        Uri
      }
    }
  }
}
    `;

/**
 * __useGetAccountByUriQuery__
 *
 * To run a query within a React component, call `useGetAccountByUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountByUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountByUriQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *   },
 * });
 */
export function useGetAccountByUriQuery(baseOptions: Apollo.QueryHookOptions<GetAccountByUriQuery, GetAccountByUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountByUriQuery, GetAccountByUriQueryVariables>(GetAccountByUriDocument, options);
      }
export function useGetAccountByUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountByUriQuery, GetAccountByUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountByUriQuery, GetAccountByUriQueryVariables>(GetAccountByUriDocument, options);
        }
export type GetAccountByUriQueryHookResult = ReturnType<typeof useGetAccountByUriQuery>;
export type GetAccountByUriLazyQueryHookResult = ReturnType<typeof useGetAccountByUriLazyQuery>;
export type GetAccountByUriQueryResult = Apollo.QueryResult<GetAccountByUriQuery, GetAccountByUriQueryVariables>;
export const CreateFunderDocument = gql`
    mutation createFunder($input: Funder_insert_input!) {
  funder: insert_Funder_one(object: $input) {
    Id
  }
}
    `;
export type CreateFunderMutationFn = Apollo.MutationFunction<CreateFunderMutation, CreateFunderMutationVariables>;

/**
 * __useCreateFunderMutation__
 *
 * To run a mutation, you first call `useCreateFunderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFunderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFunderMutation, { data, loading, error }] = useCreateFunderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFunderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFunderMutation, CreateFunderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFunderMutation, CreateFunderMutationVariables>(CreateFunderDocument, options);
      }
export type CreateFunderMutationHookResult = ReturnType<typeof useCreateFunderMutation>;
export type CreateFunderMutationResult = Apollo.MutationResult<CreateFunderMutation>;
export type CreateFunderMutationOptions = Apollo.BaseMutationOptions<CreateFunderMutation, CreateFunderMutationVariables>;
export const CreatePlanterDocument = gql`
    mutation createPlanter($input: Planter_insert_input!) {
  planter: insert_Planter_one(object: $input) {
    Id
  }
}
    `;
export type CreatePlanterMutationFn = Apollo.MutationFunction<CreatePlanterMutation, CreatePlanterMutationVariables>;

/**
 * __useCreatePlanterMutation__
 *
 * To run a mutation, you first call `useCreatePlanterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanterMutation, { data, loading, error }] = useCreatePlanterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanterMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanterMutation, CreatePlanterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanterMutation, CreatePlanterMutationVariables>(CreatePlanterDocument, options);
      }
export type CreatePlanterMutationHookResult = ReturnType<typeof useCreatePlanterMutation>;
export type CreatePlanterMutationResult = Apollo.MutationResult<CreatePlanterMutation>;
export type CreatePlanterMutationOptions = Apollo.BaseMutationOptions<CreatePlanterMutation, CreatePlanterMutationVariables>;
export const GetAccountDocument = gql`
    query getAccount($id: uuid!) {
  account: Account_by_pk(Id: $id) {
    Id
    Avatar
    Banner
    BusinessType
    Description
    DistrictId
    ContactFirstname
    ContactLastname
    BusinessSize
    Email
    Facebook
    FocusArea
    GovType
    Mobile
    Name
    OrgType
    Phone
    RegionId
    SchoolType
    Sector
    Type
    Uri
    Website
    Planter {
      Id
      Name
      IsHidden
    }
    Funder {
      Id
      Name
      IsHidden
    }
    Addresses {
      Id
      StreetNumber
      StreetName
      City
      District
      Region
      Country
      PostalCode
      Place
      Geo
    }
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const UpdateAddressDocument = gql`
    mutation updateAddress($input: Address_insert_input!) {
  insert_Address_one(
    object: $input
    on_conflict: {constraint: Address_pkey, update_columns: [City, Country, Region, District, Geo, Place, PostalCode, StreetName, StreetNumber, Suburb]}
  ) {
    Id
  }
}
    `;
export type UpdateAddressMutationFn = Apollo.MutationFunction<UpdateAddressMutation, UpdateAddressMutationVariables>;

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutation, UpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(UpdateAddressDocument, options);
      }
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>;
export type UpdateAddressMutationResult = Apollo.MutationResult<UpdateAddressMutation>;
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const GetAccountSupportersDocument = gql`
    query getAccountSupporters($accountId: uuid!, $offset: Int!, $limit: Int = 12) {
  Planter_aggregate: getAccountSupporters_aggregate(
    args: {accountId: $accountId}
    where: {SupportType: {_eq: "SupportGiven"}}
  ) {
    aggregate {
      count
    }
  }
  Planter: getAccountSupporters(
    args: {accountId: $accountId}
    where: {SupportType: {_eq: "SupportGiven"}}
    offset: $offset
    limit: $limit
    order_by: {Trees: desc, Id: desc}
  ) {
    Id
    Avatar
    Name
    SupportType
    Trees
    Type
    Uri
    Region
  }
  Funder_aggregate: getAccountSupporters_aggregate(
    args: {accountId: $accountId}
    where: {SupportType: {_eq: "SupportReceived"}}
  ) {
    aggregate {
      count
    }
  }
  Funder: getAccountSupporters(
    args: {accountId: $accountId}
    where: {SupportType: {_eq: "SupportReceived"}}
    offset: $offset
    limit: $limit
    order_by: {Trees: desc, Id: desc}
  ) {
    Id
    Avatar
    Name
    SupportType
    Trees
    Type
    Uri
    Region
  }
}
    `;

/**
 * __useGetAccountSupportersQuery__
 *
 * To run a query within a React component, call `useGetAccountSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSupportersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSupportersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccountSupportersQuery(baseOptions: Apollo.QueryHookOptions<GetAccountSupportersQuery, GetAccountSupportersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSupportersQuery, GetAccountSupportersQueryVariables>(GetAccountSupportersDocument, options);
      }
export function useGetAccountSupportersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSupportersQuery, GetAccountSupportersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSupportersQuery, GetAccountSupportersQueryVariables>(GetAccountSupportersDocument, options);
        }
export type GetAccountSupportersQueryHookResult = ReturnType<typeof useGetAccountSupportersQuery>;
export type GetAccountSupportersLazyQueryHookResult = ReturnType<typeof useGetAccountSupportersLazyQuery>;
export type GetAccountSupportersQueryResult = Apollo.QueryResult<GetAccountSupportersQuery, GetAccountSupportersQueryVariables>;
export const UpdateAdminAccountByStripeIdDocument = gql`
    mutation updateAdminAccountByStripeId($stripeId: String!, $input: Account_set_input) {
  subscriptions: update_Account(
    where: {StripeCustomerId: {_eq: $stripeId}}
    _set: $input
  ) {
    returning {
      Id
    }
  }
}
    `;
export type UpdateAdminAccountByStripeIdMutationFn = Apollo.MutationFunction<UpdateAdminAccountByStripeIdMutation, UpdateAdminAccountByStripeIdMutationVariables>;

/**
 * __useUpdateAdminAccountByStripeIdMutation__
 *
 * To run a mutation, you first call `useUpdateAdminAccountByStripeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminAccountByStripeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminAccountByStripeIdMutation, { data, loading, error }] = useUpdateAdminAccountByStripeIdMutation({
 *   variables: {
 *      stripeId: // value for 'stripeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminAccountByStripeIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminAccountByStripeIdMutation, UpdateAdminAccountByStripeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminAccountByStripeIdMutation, UpdateAdminAccountByStripeIdMutationVariables>(UpdateAdminAccountByStripeIdDocument, options);
      }
export type UpdateAdminAccountByStripeIdMutationHookResult = ReturnType<typeof useUpdateAdminAccountByStripeIdMutation>;
export type UpdateAdminAccountByStripeIdMutationResult = Apollo.MutationResult<UpdateAdminAccountByStripeIdMutation>;
export type UpdateAdminAccountByStripeIdMutationOptions = Apollo.BaseMutationOptions<UpdateAdminAccountByStripeIdMutation, UpdateAdminAccountByStripeIdMutationVariables>;
export const GetAccountAndPlanterRegistrationDocument = gql`
    query getAccountAndPlanterRegistration($id: uuid!) {
  Account_by_pk(Id: $id) {
    Id
    Name
    Planter {
      PlanterRegistrations {
        Id
        WorkflowState
      }
      Projects {
        Id
        Name
        Applications {
          Id
          WorkflowState
          Reference
          Season {
            Id
            Name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountAndPlanterRegistrationQuery__
 *
 * To run a query within a React component, call `useGetAccountAndPlanterRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountAndPlanterRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountAndPlanterRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountAndPlanterRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetAccountAndPlanterRegistrationQuery, GetAccountAndPlanterRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountAndPlanterRegistrationQuery, GetAccountAndPlanterRegistrationQueryVariables>(GetAccountAndPlanterRegistrationDocument, options);
      }
export function useGetAccountAndPlanterRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountAndPlanterRegistrationQuery, GetAccountAndPlanterRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountAndPlanterRegistrationQuery, GetAccountAndPlanterRegistrationQueryVariables>(GetAccountAndPlanterRegistrationDocument, options);
        }
export type GetAccountAndPlanterRegistrationQueryHookResult = ReturnType<typeof useGetAccountAndPlanterRegistrationQuery>;
export type GetAccountAndPlanterRegistrationLazyQueryHookResult = ReturnType<typeof useGetAccountAndPlanterRegistrationLazyQuery>;
export type GetAccountAndPlanterRegistrationQueryResult = Apollo.QueryResult<GetAccountAndPlanterRegistrationQuery, GetAccountAndPlanterRegistrationQueryVariables>;
export const CreateAccountProfileDocument = gql`
    mutation createAccountProfile($input: CreateAccountProfileInput!) {
  createAccountProfile(input: $input) {
    accountId
    profileType
  }
}
    `;
export type CreateAccountProfileMutationFn = Apollo.MutationFunction<CreateAccountProfileMutation, CreateAccountProfileMutationVariables>;

/**
 * __useCreateAccountProfileMutation__
 *
 * To run a mutation, you first call `useCreateAccountProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountProfileMutation, { data, loading, error }] = useCreateAccountProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountProfileMutation, CreateAccountProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountProfileMutation, CreateAccountProfileMutationVariables>(CreateAccountProfileDocument, options);
      }
export type CreateAccountProfileMutationHookResult = ReturnType<typeof useCreateAccountProfileMutation>;
export type CreateAccountProfileMutationResult = Apollo.MutationResult<CreateAccountProfileMutation>;
export type CreateAccountProfileMutationOptions = Apollo.BaseMutationOptions<CreateAccountProfileMutation, CreateAccountProfileMutationVariables>;
export const GetApplicationDocument = gql`
    query getApplication($id: uuid!, $planterId: uuid!) {
  Application(where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}}) {
    Id
    AccessToPublic
    AddingToCount
    AgreeToMonitor
    AgreeToReport
    AgreeAssetUsage
    ApplicationAssets {
      Id
      Type
      UpdatedOn
      Uri
      FileName
    }
    ApplicationNotes(order_by: {TimeStamp: desc}) {
      Action
      Id
      TimeStamp
      Notes
    }
    PlantingSites(order_by: {CreatedOn: asc}) {
      Id
      Name
      LandPermission
      NativeTreeConsent
      SiteLandCondition
      SiteLandscape
      Species
      StockAccess
      Geo
      CovenantProtected
      PlantingSiteAssets {
        Id
        FileName
        Uri
        Type
      }
    }
    Approved
    ApprovedAt
    AvailableActivities
    CreatedOn
    DeclinedAt
    District {
      Id
      Name
    }
    EmploymentOpportunities
    EmploymentOpportunitiesDesc
    Geo
    Goal
    HasOtherFunding
    HelpWithPlanting
    LandCondition
    LandOwnership
    LandPermission
    LandUse
    LegalObligation
    LocalBodies
    LocalBodiesDesc
    MaintainPlanting
    Matched
    Name
    NumberOfSites
    OtherFunding
    OtherGroups
    OtherGroupsDesc
    OtherLand
    OtherLandArea
    Planned
    PlanterId
    PlanterRegistrationPlantingId
    PlantingPlan
    Plantings {
      Id
      Area
      ApplicationId
      CreatedOn
      District {
        Id
        Name
      }
      Geo
      LandOwnership
      LandUse
      Location
      Name
      MonitoringEvents(order_by: {MonitoredOn: desc}) {
        Id
        MonitoredOn
        MonitoringLines(order_by: {SurvivingTrees: desc}) {
          Id
          SurvivingTrees
          SurvivingPercent
          PlantingLineId
          SpeciesId
        }
      }
      Reference
      Planter {
        Name
      }
      PlantingLines(order_by: {Quantity: desc}) {
        Id
        Quantity
        OtherSpeciesName
        Species {
          Id
          Name
        }
      }
      PlantingAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      Quantity
      Reference
      Region {
        Id
        Name
      }
      Season {
        Id
        Name
      }
      Spacing
      VolunteerCount
      WorkflowState
    }
    Project {
      Id
      Applications {
        Id
        ApplicationAssets {
          Id
          Type
          Uri
        }
        Approved
        CreatedOn
        Name
        Planned
        Project {
          Id
          ProjectAssets {
            Id
            Type
            Uri
          }
        }
        Reference
        Region {
          Id
          Name
        }
        Required
        Season {
          Id
          Name
        }
        WorkflowState
      }
      Area
      CreatedOn
      Data
      Description
      District {
        Id
        Name
      }
      Hero
      Name
      Uri
      NumberOfTreesFundedPreviously
      PlantingTimeframes
      ProjectAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      ReceivedFundingPreviously
      Region {
        Id
        Name
      }
    }
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SpeciesKnown
    StockAccess
    SubmittedAt
    TermsAndConditions
    WorkflowState
  }
}
    `;

/**
 * __useGetApplicationQuery__
 *
 * To run a query within a React component, call `useGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
      }
export function useGetApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
        }
export type GetApplicationQueryHookResult = ReturnType<typeof useGetApplicationQuery>;
export type GetApplicationLazyQueryHookResult = ReturnType<typeof useGetApplicationLazyQuery>;
export type GetApplicationQueryResult = Apollo.QueryResult<GetApplicationQuery, GetApplicationQueryVariables>;
export const ListApplicationsDocument = gql`
    query listApplications($planterId: uuid!, $limit: Int!, $offset: Int!, $orderBy: [Application_order_by!]) {
  Application_aggregate(where: {PlanterId: {_eq: $planterId}}) {
    aggregate {
      count
    }
  }
  Application(
    limit: $limit
    offset: $offset
    where: {PlanterId: {_eq: $planterId}}
    order_by: $orderBy
  ) {
    Id
    Reference
    Approved
    ApprovedAt
    CreatedOn
    DeclinedAt
    Name
    Planned
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SubmittedAt
    WorkflowState
  }
}
    `;

/**
 * __useListApplicationsQuery__
 *
 * To run a query within a React component, call `useListApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationsQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationsQuery, ListApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationsQuery, ListApplicationsQueryVariables>(ListApplicationsDocument, options);
      }
export function useListApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationsQuery, ListApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationsQuery, ListApplicationsQueryVariables>(ListApplicationsDocument, options);
        }
export type ListApplicationsQueryHookResult = ReturnType<typeof useListApplicationsQuery>;
export type ListApplicationsLazyQueryHookResult = ReturnType<typeof useListApplicationsLazyQuery>;
export type ListApplicationsQueryResult = Apollo.QueryResult<ListApplicationsQuery, ListApplicationsQueryVariables>;
export const GetApplicationCountForPlanterRegistrationDocument = gql`
    query getApplicationCountForPlanterRegistration($workflowStates: [String!]!, $planterId: uuid!) {
  Application_aggregate(
    where: {WorkflowState: {_in: $workflowStates}, PlanterId: {_eq: $planterId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetApplicationCountForPlanterRegistrationQuery__
 *
 * To run a query within a React component, call `useGetApplicationCountForPlanterRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationCountForPlanterRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationCountForPlanterRegistrationQuery({
 *   variables: {
 *      workflowStates: // value for 'workflowStates'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetApplicationCountForPlanterRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationCountForPlanterRegistrationQuery, GetApplicationCountForPlanterRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationCountForPlanterRegistrationQuery, GetApplicationCountForPlanterRegistrationQueryVariables>(GetApplicationCountForPlanterRegistrationDocument, options);
      }
export function useGetApplicationCountForPlanterRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationCountForPlanterRegistrationQuery, GetApplicationCountForPlanterRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationCountForPlanterRegistrationQuery, GetApplicationCountForPlanterRegistrationQueryVariables>(GetApplicationCountForPlanterRegistrationDocument, options);
        }
export type GetApplicationCountForPlanterRegistrationQueryHookResult = ReturnType<typeof useGetApplicationCountForPlanterRegistrationQuery>;
export type GetApplicationCountForPlanterRegistrationLazyQueryHookResult = ReturnType<typeof useGetApplicationCountForPlanterRegistrationLazyQuery>;
export type GetApplicationCountForPlanterRegistrationQueryResult = Apollo.QueryResult<GetApplicationCountForPlanterRegistrationQuery, GetApplicationCountForPlanterRegistrationQueryVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($input: UpsertApplicationInput!) {
  application: upsert_application(input: $input) {
    Id
    Application {
      Project {
        Id
      }
    }
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const CreateAdminApplicationDocument = gql`
    mutation createAdminApplication($input: Application_insert_input!) {
  application: insert_Application_one(object: $input) {
    Id
  }
}
    `;
export type CreateAdminApplicationMutationFn = Apollo.MutationFunction<CreateAdminApplicationMutation, CreateAdminApplicationMutationVariables>;

/**
 * __useCreateAdminApplicationMutation__
 *
 * To run a mutation, you first call `useCreateAdminApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminApplicationMutation, { data, loading, error }] = useCreateAdminApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminApplicationMutation, CreateAdminApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminApplicationMutation, CreateAdminApplicationMutationVariables>(CreateAdminApplicationDocument, options);
      }
export type CreateAdminApplicationMutationHookResult = ReturnType<typeof useCreateAdminApplicationMutation>;
export type CreateAdminApplicationMutationResult = Apollo.MutationResult<CreateAdminApplicationMutation>;
export type CreateAdminApplicationMutationOptions = Apollo.BaseMutationOptions<CreateAdminApplicationMutation, CreateAdminApplicationMutationVariables>;
export const DeleteDraftApplicationDocument = gql`
    mutation deleteDraftApplication($id: uuid!, $planterId: uuid!) {
  delete_PlantingSiteAsset(where: {PlantingSite: {ApplicationId: {_eq: $id}}}) {
    affected_rows
  }
  delete_PlantingSite(where: {ApplicationId: {_eq: $id}}) {
    affected_rows
  }
  delete_ApplicationAsset(where: {Application_Id: {_eq: $id}}) {
    affected_rows
  }
  delete_Application(
    where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}, WorkflowState: {_in: ["Draft", "Withdrawn"]}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteDraftApplicationMutationFn = Apollo.MutationFunction<DeleteDraftApplicationMutation, DeleteDraftApplicationMutationVariables>;

/**
 * __useDeleteDraftApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteDraftApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftApplicationMutation, { data, loading, error }] = useDeleteDraftApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useDeleteDraftApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftApplicationMutation, DeleteDraftApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftApplicationMutation, DeleteDraftApplicationMutationVariables>(DeleteDraftApplicationDocument, options);
      }
export type DeleteDraftApplicationMutationHookResult = ReturnType<typeof useDeleteDraftApplicationMutation>;
export type DeleteDraftApplicationMutationResult = Apollo.MutationResult<DeleteDraftApplicationMutation>;
export type DeleteDraftApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteDraftApplicationMutation, DeleteDraftApplicationMutationVariables>;
export const GetAdminApplicationDocument = gql`
    query getAdminApplication($id: uuid!) {
  Application: Application_by_pk(Id: $id) {
    Id
    AccessToPublic
    AddingToCount
    AgreeToMonitor
    AgreeToReport
    AgreeAssetUsage
    ApplicationAssets {
      Id
      Type
      UpdatedOn
      Uri
      FileName
    }
    ApplicationNotes(order_by: {TimeStamp: desc}) {
      Action
      Id
      TimeStamp
      Notes
    }
    Approved
    ApprovedAt
    AvailableActivities
    CreatedOn
    District {
      Id
      Name
    }
    DeclinedAt
    EmploymentOpportunities
    EmploymentOpportunitiesDesc
    Goal
    HasOtherFunding
    HelpWithPlanting
    Geo
    HoldOnMatch
    IsMatched
    LandCondition
    LandOwnership
    LandPermission
    LandUse
    LegalObligation
    LocalBodies
    LocalBodiesDesc
    MaintainPlanting
    Name
    NumberOfSites
    Matched
    OtherFunding
    OtherGroups
    OtherGroupsDesc
    OtherLand
    OtherLandArea
    Planned
    PlantingPlan
    PlanterId
    PlanterRegistrationPlantingId
    Planter {
      Id
      Name
      Account {
        Id
      }
    }
    Plantings {
      Id
      Area
      ApplicationId
      CreatedOn
      District {
        Id
        Name
      }
      Geo
      LandOwnership
      LandUse
      Location
      Name
      MonitoringEvents(order_by: {MonitoredOn: desc}) {
        Id
        MonitoredOn
        MonitoringLines(order_by: {SurvivingTrees: desc}) {
          Id
          SurvivingTrees
          SurvivingPercent
          PlantingLineId
          SpeciesId
        }
      }
      Reference
      Planter {
        Name
      }
      PlantingLines(order_by: {Quantity: desc}) {
        Id
        Quantity
        OtherSpeciesName
        Species {
          Id
          Name
        }
      }
      PlantingAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      Quantity
      Reference
      Region {
        Id
        Name
      }
      Season {
        Id
        Name
      }
      Spacing
      VolunteerCount
      WorkflowState
    }
    PlantingSites {
      Id
      Name
      LandPermission
      NativeTreeConsent
      SiteLandCondition
      SiteLandscape
      Species
      StockAccess
      Geo
      CovenantProtected
      PlantingSiteAssets {
        Id
        FileName
        Uri
        Type
      }
    }
    Project {
      Id
      Name
      Applications {
        Id
        Approved
        CreatedOn
        District {
          Id
          Name
        }
        HoldOnMatch
        IsMatched
        Matched
        Name
        Planned
        Planter {
          Id
          Name
          Account {
            Id
            Email
          }
        }
        Project {
          Id
          Name
        }
        PlanterRegistrationPlantingId
        Reference
        Region {
          Id
          Name
        }
        Required
        Season {
          Id
          Name
        }
        Unmatched
        WorkflowState
      }
      Area
      CreatedOn
      Data
      Description
      District {
        Id
        Name
      }
      Hero
      NumberOfTreesFundedPreviously
      PlantingTimeframes
      ProjectAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      ReceivedFundingPreviously
      Region {
        Id
        Name
      }
    }
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SpeciesKnown
    StockAccess
    SubmittedAt
    TermsAndConditions
    WorkflowState
  }
}
    `;

/**
 * __useGetAdminApplicationQuery__
 *
 * To run a query within a React component, call `useGetAdminApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetAdminApplicationQuery, GetAdminApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminApplicationQuery, GetAdminApplicationQueryVariables>(GetAdminApplicationDocument, options);
      }
export function useGetAdminApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminApplicationQuery, GetAdminApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminApplicationQuery, GetAdminApplicationQueryVariables>(GetAdminApplicationDocument, options);
        }
export type GetAdminApplicationQueryHookResult = ReturnType<typeof useGetAdminApplicationQuery>;
export type GetAdminApplicationLazyQueryHookResult = ReturnType<typeof useGetAdminApplicationLazyQuery>;
export type GetAdminApplicationQueryResult = Apollo.QueryResult<GetAdminApplicationQuery, GetAdminApplicationQueryVariables>;
export const UpdateApplicationDocument = gql`
    mutation updateApplication($id: uuid!, $set: Application_set_input) {
  update_Application_by_pk(pk_columns: {Id: $id}, _set: $set) {
    Id
  }
}
    `;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const UpdateProjectApplicationsRegionDistrictDocument = gql`
    mutation updateProjectApplicationsRegionDistrict($projectId: uuid!, $districtId: uuid, $regionId: uuid) {
  update_Application(
    where: {ProjectId: {_eq: $projectId}}
    _set: {DistrictId: $districtId, RegionId: $regionId}
  ) {
    returning {
      Id
      DistrictId
      RegionId
    }
    affected_rows
  }
}
    `;
export type UpdateProjectApplicationsRegionDistrictMutationFn = Apollo.MutationFunction<UpdateProjectApplicationsRegionDistrictMutation, UpdateProjectApplicationsRegionDistrictMutationVariables>;

/**
 * __useUpdateProjectApplicationsRegionDistrictMutation__
 *
 * To run a mutation, you first call `useUpdateProjectApplicationsRegionDistrictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectApplicationsRegionDistrictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectApplicationsRegionDistrictMutation, { data, loading, error }] = useUpdateProjectApplicationsRegionDistrictMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      districtId: // value for 'districtId'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useUpdateProjectApplicationsRegionDistrictMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectApplicationsRegionDistrictMutation, UpdateProjectApplicationsRegionDistrictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectApplicationsRegionDistrictMutation, UpdateProjectApplicationsRegionDistrictMutationVariables>(UpdateProjectApplicationsRegionDistrictDocument, options);
      }
export type UpdateProjectApplicationsRegionDistrictMutationHookResult = ReturnType<typeof useUpdateProjectApplicationsRegionDistrictMutation>;
export type UpdateProjectApplicationsRegionDistrictMutationResult = Apollo.MutationResult<UpdateProjectApplicationsRegionDistrictMutation>;
export type UpdateProjectApplicationsRegionDistrictMutationOptions = Apollo.BaseMutationOptions<UpdateProjectApplicationsRegionDistrictMutation, UpdateProjectApplicationsRegionDistrictMutationVariables>;
export const GetAdminApplicationByPlanterRegistrationIdDocument = gql`
    query getAdminApplicationByPlanterRegistrationId($planterRegistrationId: uuid!) {
  Application(
    where: {PlanterRegistrationPlantingId: {_eq: $planterRegistrationId}}
  ) {
    Id
    AccessToPublic
    AddingToCount
    AgreeToMonitor
    AgreeToReport
    AgreeAssetUsage
    NumberOfSites
    PlantingSites {
      Id
      Name
      LandPermission
      NativeTreeConsent
      SiteLandCondition
      SiteLandscape
      Species
      StockAccess
      Geo
      CovenantProtected
      PlantingSiteAssets {
        Id
        FileName
        Uri
        Type
      }
    }
    ApplicationAssets {
      Id
      Type
      UpdatedOn
      Uri
    }
    ApplicationNotes(order_by: {TimeStamp: desc}) {
      Action
      Id
      TimeStamp
      Notes
    }
    Approved
    ApprovedAt
    AvailableActivities
    CreatedOn
    District {
      Id
      Name
    }
    DeclinedAt
    EmploymentOpportunities
    EmploymentOpportunitiesDesc
    Goal
    HasOtherFunding
    HelpWithPlanting
    Geo
    HoldOnMatch
    IsMatched
    LandCondition
    LandOwnership
    LandPermission
    LandUse
    LegalObligation
    LocalBodies
    LocalBodiesDesc
    MaintainPlanting
    Name
    Matched
    OtherFunding
    OtherGroups
    OtherGroupsDesc
    OtherLand
    OtherLandArea
    Planned
    PlantingPlan
    PlanterId
    PlanterRegistrationPlantingId
    Planter {
      Id
      Name
      Account {
        Id
      }
    }
    Plantings {
      Id
      Area
      ApplicationId
      CreatedOn
      District {
        Id
        Name
      }
      Geo
      LandOwnership
      LandUse
      Location
      Name
      MonitoringEvents(order_by: {MonitoredOn: desc}) {
        Id
        MonitoredOn
        MonitoringLines(order_by: {SurvivingTrees: desc}) {
          Id
          SurvivingTrees
          SurvivingPercent
          PlantingLineId
          SpeciesId
        }
      }
      Reference
      Planter {
        Id
        Name
      }
      PlantingLines {
        Id
        Quantity
        Species {
          Id
          Name
        }
      }
      PlantingAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      Quantity
      Reference
      Region {
        Id
        Name
      }
      Season {
        Id
        Name
      }
      Spacing
      VolunteerCount
      WorkflowState
    }
    PlantingSites {
      Id
      Name
      LandPermission
      NativeTreeConsent
      SiteLandCondition
      SiteLandscape
      Species
      StockAccess
      Geo
      CovenantProtected
    }
    Project {
      Id
      Name
      Applications {
        Id
        Approved
        CreatedOn
        District {
          Id
          Name
        }
        HoldOnMatch
        IsMatched
        Matched
        Name
        Planned
        Planter {
          Id
          Name
          Account {
            Id
            Email
          }
        }
        Project {
          Id
          Name
        }
        PlanterRegistrationPlantingId
        Reference
        Region {
          Id
          Name
        }
        Required
        Season {
          Id
          Name
        }
        Unmatched
        WorkflowState
      }
      Area
      CreatedOn
      Data
      Description
      District {
        Id
        Name
      }
      Hero
      NumberOfTreesFundedPreviously
      PlantingTimeframes
      ProjectAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      ReceivedFundingPreviously
      Region {
        Id
        Name
      }
    }
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SpeciesKnown
    StockAccess
    SubmittedAt
    TermsAndConditions
    WorkflowState
  }
}
    `;

/**
 * __useGetAdminApplicationByPlanterRegistrationIdQuery__
 *
 * To run a query within a React component, call `useGetAdminApplicationByPlanterRegistrationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminApplicationByPlanterRegistrationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminApplicationByPlanterRegistrationIdQuery({
 *   variables: {
 *      planterRegistrationId: // value for 'planterRegistrationId'
 *   },
 * });
 */
export function useGetAdminApplicationByPlanterRegistrationIdQuery(baseOptions: Apollo.QueryHookOptions<GetAdminApplicationByPlanterRegistrationIdQuery, GetAdminApplicationByPlanterRegistrationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminApplicationByPlanterRegistrationIdQuery, GetAdminApplicationByPlanterRegistrationIdQueryVariables>(GetAdminApplicationByPlanterRegistrationIdDocument, options);
      }
export function useGetAdminApplicationByPlanterRegistrationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminApplicationByPlanterRegistrationIdQuery, GetAdminApplicationByPlanterRegistrationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminApplicationByPlanterRegistrationIdQuery, GetAdminApplicationByPlanterRegistrationIdQueryVariables>(GetAdminApplicationByPlanterRegistrationIdDocument, options);
        }
export type GetAdminApplicationByPlanterRegistrationIdQueryHookResult = ReturnType<typeof useGetAdminApplicationByPlanterRegistrationIdQuery>;
export type GetAdminApplicationByPlanterRegistrationIdLazyQueryHookResult = ReturnType<typeof useGetAdminApplicationByPlanterRegistrationIdLazyQuery>;
export type GetAdminApplicationByPlanterRegistrationIdQueryResult = Apollo.QueryResult<GetAdminApplicationByPlanterRegistrationIdQuery, GetAdminApplicationByPlanterRegistrationIdQueryVariables>;
export const ListAdminApplicationsViewDocument = gql`
    query listAdminApplicationsView($limit: Int = 10, $offset: Int!, $where: ApplicationView_bool_exp, $order_by: [ApplicationView_order_by!]) {
  ApplicationView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  ApplicationView(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    Id
    Approved
    ApprovedAt
    CreatedOn
    District {
      Id
      Name
    }
    DeclinedAt
    HoldOnMatch
    IsMatched
    Matched
    Name
    Planned
    Planter {
      Id
      Name
      CreatedOn
      Account {
        Id
        Email
      }
    }
    Project {
      Id
      Name
    }
    PlanterRegistrationPlantingId
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SubmittedAt
    Unmatched
    WorkflowState
  }
}
    `;

/**
 * __useListAdminApplicationsViewQuery__
 *
 * To run a query within a React component, call `useListAdminApplicationsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminApplicationsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminApplicationsViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useListAdminApplicationsViewQuery(baseOptions: Apollo.QueryHookOptions<ListAdminApplicationsViewQuery, ListAdminApplicationsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminApplicationsViewQuery, ListAdminApplicationsViewQueryVariables>(ListAdminApplicationsViewDocument, options);
      }
export function useListAdminApplicationsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminApplicationsViewQuery, ListAdminApplicationsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminApplicationsViewQuery, ListAdminApplicationsViewQueryVariables>(ListAdminApplicationsViewDocument, options);
        }
export type ListAdminApplicationsViewQueryHookResult = ReturnType<typeof useListAdminApplicationsViewQuery>;
export type ListAdminApplicationsViewLazyQueryHookResult = ReturnType<typeof useListAdminApplicationsViewLazyQuery>;
export type ListAdminApplicationsViewQueryResult = Apollo.QueryResult<ListAdminApplicationsViewQuery, ListAdminApplicationsViewQueryVariables>;
export const GetAdminApplicationMatchesDocument = gql`
    query getAdminApplicationMatches($id: uuid!, $orderBy: [Match_order_by!]) {
  Application_by_pk(Id: $id) {
    Id
    Matches(order_by: $orderBy) {
      Id
      Quantity
      Instruction {
        Id
        PurchaseId
        Purchase {
          Id
          Reference
          Season {
            Id
            Name
          }
          Funder {
            Id
            Account {
              Id
              Email
            }
            Name
          }
          District {
            Id
            Name
          }
          Region {
            Id
            Name
          }
          Quantity
          CreatedOn
          Type
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdminApplicationMatchesQuery__
 *
 * To run a query within a React component, call `useGetAdminApplicationMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminApplicationMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminApplicationMatchesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAdminApplicationMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetAdminApplicationMatchesQuery, GetAdminApplicationMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminApplicationMatchesQuery, GetAdminApplicationMatchesQueryVariables>(GetAdminApplicationMatchesDocument, options);
      }
export function useGetAdminApplicationMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminApplicationMatchesQuery, GetAdminApplicationMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminApplicationMatchesQuery, GetAdminApplicationMatchesQueryVariables>(GetAdminApplicationMatchesDocument, options);
        }
export type GetAdminApplicationMatchesQueryHookResult = ReturnType<typeof useGetAdminApplicationMatchesQuery>;
export type GetAdminApplicationMatchesLazyQueryHookResult = ReturnType<typeof useGetAdminApplicationMatchesLazyQuery>;
export type GetAdminApplicationMatchesQueryResult = Apollo.QueryResult<GetAdminApplicationMatchesQuery, GetAdminApplicationMatchesQueryVariables>;
export const UpdateApplicationCountsDocument = gql`
    mutation updateApplicationCounts($input: UpdateApplicationCountsInput!) {
  update_application_counts(input: $input) {
    Application {
      Id
    }
  }
}
    `;
export type UpdateApplicationCountsMutationFn = Apollo.MutationFunction<UpdateApplicationCountsMutation, UpdateApplicationCountsMutationVariables>;

/**
 * __useUpdateApplicationCountsMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationCountsMutation, { data, loading, error }] = useUpdateApplicationCountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationCountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationCountsMutation, UpdateApplicationCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationCountsMutation, UpdateApplicationCountsMutationVariables>(UpdateApplicationCountsDocument, options);
      }
export type UpdateApplicationCountsMutationHookResult = ReturnType<typeof useUpdateApplicationCountsMutation>;
export type UpdateApplicationCountsMutationResult = Apollo.MutationResult<UpdateApplicationCountsMutation>;
export type UpdateApplicationCountsMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationCountsMutation, UpdateApplicationCountsMutationVariables>;
export const UpdateApplicationHoldOnMatchDocument = gql`
    mutation updateApplicationHoldOnMatch($id: uuid!, $holdOnMatch: Boolean!) {
  update_Application_by_pk(
    pk_columns: {Id: $id}
    _set: {HoldOnMatch: $holdOnMatch}
  ) {
    Id
  }
}
    `;
export type UpdateApplicationHoldOnMatchMutationFn = Apollo.MutationFunction<UpdateApplicationHoldOnMatchMutation, UpdateApplicationHoldOnMatchMutationVariables>;

/**
 * __useUpdateApplicationHoldOnMatchMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationHoldOnMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationHoldOnMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationHoldOnMatchMutation, { data, loading, error }] = useUpdateApplicationHoldOnMatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      holdOnMatch: // value for 'holdOnMatch'
 *   },
 * });
 */
export function useUpdateApplicationHoldOnMatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationHoldOnMatchMutation, UpdateApplicationHoldOnMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationHoldOnMatchMutation, UpdateApplicationHoldOnMatchMutationVariables>(UpdateApplicationHoldOnMatchDocument, options);
      }
export type UpdateApplicationHoldOnMatchMutationHookResult = ReturnType<typeof useUpdateApplicationHoldOnMatchMutation>;
export type UpdateApplicationHoldOnMatchMutationResult = Apollo.MutationResult<UpdateApplicationHoldOnMatchMutation>;
export type UpdateApplicationHoldOnMatchMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationHoldOnMatchMutation, UpdateApplicationHoldOnMatchMutationVariables>;
export const UpdateApplicationSeasonDocument = gql`
    mutation updateApplicationSeason($input: UpdateApplicationSeasonInput!) {
  update_application_season(input: $input) {
    Application {
      Id
    }
  }
}
    `;
export type UpdateApplicationSeasonMutationFn = Apollo.MutationFunction<UpdateApplicationSeasonMutation, UpdateApplicationSeasonMutationVariables>;

/**
 * __useUpdateApplicationSeasonMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationSeasonMutation, { data, loading, error }] = useUpdateApplicationSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationSeasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationSeasonMutation, UpdateApplicationSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationSeasonMutation, UpdateApplicationSeasonMutationVariables>(UpdateApplicationSeasonDocument, options);
      }
export type UpdateApplicationSeasonMutationHookResult = ReturnType<typeof useUpdateApplicationSeasonMutation>;
export type UpdateApplicationSeasonMutationResult = Apollo.MutationResult<UpdateApplicationSeasonMutation>;
export type UpdateApplicationSeasonMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationSeasonMutation, UpdateApplicationSeasonMutationVariables>;
export const GetAdminApplicationProjectDocument = gql`
    query getAdminApplicationProject($id: uuid!) {
  Application: Application_by_pk(Id: $id) {
    Project {
      Id
      Area
      Applications {
        Id
      }
      CreatedOn
      Description
      Name
      Reference
    }
  }
}
    `;

/**
 * __useGetAdminApplicationProjectQuery__
 *
 * To run a query within a React component, call `useGetAdminApplicationProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminApplicationProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminApplicationProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminApplicationProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAdminApplicationProjectQuery, GetAdminApplicationProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminApplicationProjectQuery, GetAdminApplicationProjectQueryVariables>(GetAdminApplicationProjectDocument, options);
      }
export function useGetAdminApplicationProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminApplicationProjectQuery, GetAdminApplicationProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminApplicationProjectQuery, GetAdminApplicationProjectQueryVariables>(GetAdminApplicationProjectDocument, options);
        }
export type GetAdminApplicationProjectQueryHookResult = ReturnType<typeof useGetAdminApplicationProjectQuery>;
export type GetAdminApplicationProjectLazyQueryHookResult = ReturnType<typeof useGetAdminApplicationProjectLazyQuery>;
export type GetAdminApplicationProjectQueryResult = Apollo.QueryResult<GetAdminApplicationProjectQuery, GetAdminApplicationProjectQueryVariables>;
export const ListAdminApplicationsForProjectDocument = gql`
    query listAdminApplicationsForProject($where: Application_bool_exp) {
  Application(where: $where, order_by: {CreatedOn: desc}) {
    Id
    Approved
    ApprovedAt
    CreatedOn
    DeclinedAt
    District {
      Id
      Name
    }
    HoldOnMatch
    Matched
    Name
    Planned
    Planter {
      Id
      Name
      Account {
        Id
        Email
      }
    }
    ProjectId
    Reference
    Region {
      Id
      Name
    }
    Required
    Season {
      Id
      Name
    }
    SubmittedAt
    WorkflowState
  }
}
    `;

/**
 * __useListAdminApplicationsForProjectQuery__
 *
 * To run a query within a React component, call `useListAdminApplicationsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminApplicationsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminApplicationsForProjectQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListAdminApplicationsForProjectQuery(baseOptions?: Apollo.QueryHookOptions<ListAdminApplicationsForProjectQuery, ListAdminApplicationsForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminApplicationsForProjectQuery, ListAdminApplicationsForProjectQueryVariables>(ListAdminApplicationsForProjectDocument, options);
      }
export function useListAdminApplicationsForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminApplicationsForProjectQuery, ListAdminApplicationsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminApplicationsForProjectQuery, ListAdminApplicationsForProjectQueryVariables>(ListAdminApplicationsForProjectDocument, options);
        }
export type ListAdminApplicationsForProjectQueryHookResult = ReturnType<typeof useListAdminApplicationsForProjectQuery>;
export type ListAdminApplicationsForProjectLazyQueryHookResult = ReturnType<typeof useListAdminApplicationsForProjectLazyQuery>;
export type ListAdminApplicationsForProjectQueryResult = Apollo.QueryResult<ListAdminApplicationsForProjectQuery, ListAdminApplicationsForProjectQueryVariables>;
export const GetApplicationForWorkflowStateTransitionDocument = gql`
    query getApplicationForWorkflowStateTransition($id: uuid!) {
  Application: Application_by_pk(Id: $id) {
    Id
    Name
    WorkflowState
    Matched
    Approved
    IsMatched
    Planter {
      Id
      Account {
        Id
        Name
        Email
      }
    }
  }
}
    `;

/**
 * __useGetApplicationForWorkflowStateTransitionQuery__
 *
 * To run a query within a React component, call `useGetApplicationForWorkflowStateTransitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationForWorkflowStateTransitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationForWorkflowStateTransitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationForWorkflowStateTransitionQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationForWorkflowStateTransitionQuery, GetApplicationForWorkflowStateTransitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationForWorkflowStateTransitionQuery, GetApplicationForWorkflowStateTransitionQueryVariables>(GetApplicationForWorkflowStateTransitionDocument, options);
      }
export function useGetApplicationForWorkflowStateTransitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationForWorkflowStateTransitionQuery, GetApplicationForWorkflowStateTransitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationForWorkflowStateTransitionQuery, GetApplicationForWorkflowStateTransitionQueryVariables>(GetApplicationForWorkflowStateTransitionDocument, options);
        }
export type GetApplicationForWorkflowStateTransitionQueryHookResult = ReturnType<typeof useGetApplicationForWorkflowStateTransitionQuery>;
export type GetApplicationForWorkflowStateTransitionLazyQueryHookResult = ReturnType<typeof useGetApplicationForWorkflowStateTransitionLazyQuery>;
export type GetApplicationForWorkflowStateTransitionQueryResult = Apollo.QueryResult<GetApplicationForWorkflowStateTransitionQuery, GetApplicationForWorkflowStateTransitionQueryVariables>;
export const GetApplicationNavStateDocument = gql`
    query getApplicationNavState($id: uuid!) {
  Application: Application_by_pk(Id: $id) {
    Id
    Name
    Reference
    PlanterRegistrationPlantingId
    Planter {
      Id
    }
    Plantings {
      Id
      MonitoringEvents(order_by: {MonitoredOn: desc}) {
        Id
      }
    }
    Project {
      Id
    }
    Region {
      Id
    }
    Season {
      Id
      Name
    }
    Matched
    Unmatched
    WorkflowState
    IsMatched
    HoldOnMatch
  }
}
    `;

/**
 * __useGetApplicationNavStateQuery__
 *
 * To run a query within a React component, call `useGetApplicationNavStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationNavStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationNavStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationNavStateQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationNavStateQuery, GetApplicationNavStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationNavStateQuery, GetApplicationNavStateQueryVariables>(GetApplicationNavStateDocument, options);
      }
export function useGetApplicationNavStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationNavStateQuery, GetApplicationNavStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationNavStateQuery, GetApplicationNavStateQueryVariables>(GetApplicationNavStateDocument, options);
        }
export type GetApplicationNavStateQueryHookResult = ReturnType<typeof useGetApplicationNavStateQuery>;
export type GetApplicationNavStateLazyQueryHookResult = ReturnType<typeof useGetApplicationNavStateLazyQuery>;
export type GetApplicationNavStateQueryResult = Apollo.QueryResult<GetApplicationNavStateQuery, GetApplicationNavStateQueryVariables>;
export const CreateMatchFromApplicationDocument = gql`
    mutation createMatchFromApplication($input: CreateMatchFromApplicationInput!) {
  create_match_from_application(input: $input) {
    ApplicationId
  }
}
    `;
export type CreateMatchFromApplicationMutationFn = Apollo.MutationFunction<CreateMatchFromApplicationMutation, CreateMatchFromApplicationMutationVariables>;

/**
 * __useCreateMatchFromApplicationMutation__
 *
 * To run a mutation, you first call `useCreateMatchFromApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchFromApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchFromApplicationMutation, { data, loading, error }] = useCreateMatchFromApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchFromApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchFromApplicationMutation, CreateMatchFromApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchFromApplicationMutation, CreateMatchFromApplicationMutationVariables>(CreateMatchFromApplicationDocument, options);
      }
export type CreateMatchFromApplicationMutationHookResult = ReturnType<typeof useCreateMatchFromApplicationMutation>;
export type CreateMatchFromApplicationMutationResult = Apollo.MutationResult<CreateMatchFromApplicationMutation>;
export type CreateMatchFromApplicationMutationOptions = Apollo.BaseMutationOptions<CreateMatchFromApplicationMutation, CreateMatchFromApplicationMutationVariables>;
export const CreateActionNoteDocument = gql`
    mutation createActionNote($input: ActionNotes_insert_input!) {
  insert_ActionNotes_one(object: $input) {
    Id
  }
}
    `;
export type CreateActionNoteMutationFn = Apollo.MutationFunction<CreateActionNoteMutation, CreateActionNoteMutationVariables>;

/**
 * __useCreateActionNoteMutation__
 *
 * To run a mutation, you first call `useCreateActionNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionNoteMutation, { data, loading, error }] = useCreateActionNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActionNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionNoteMutation, CreateActionNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionNoteMutation, CreateActionNoteMutationVariables>(CreateActionNoteDocument, options);
      }
export type CreateActionNoteMutationHookResult = ReturnType<typeof useCreateActionNoteMutation>;
export type CreateActionNoteMutationResult = Apollo.MutationResult<CreateActionNoteMutation>;
export type CreateActionNoteMutationOptions = Apollo.BaseMutationOptions<CreateActionNoteMutation, CreateActionNoteMutationVariables>;
export const ListAdminApplicationsByProjectIdDocument = gql`
    query listAdminApplicationsByProjectId($projectId: uuid!, $orderBy: [Application_order_by!]) {
  Application(where: {ProjectId: {_eq: $projectId}}, order_by: $orderBy) {
    Id
    Name
    Season {
      Id
      Name
    }
    Reference
    Required
    Approved
    Planned
    WorkflowState
    Geo
    PlanterRegistrationPlantingId
    Plantings_aggregate {
      aggregate {
        sum {
          Quantity
        }
      }
    }
    Plantings {
      Id
      Name
      PlantingAssets {
        Id
        Type
        UpdatedOn
        Uri
      }
      MonitoringEvents {
        Id
        MonitoredOn
        MonitoringAssets {
          Id
          UpdatedOn
          Uri
          Type
        }
      }
    }
  }
}
    `;

/**
 * __useListAdminApplicationsByProjectIdQuery__
 *
 * To run a query within a React component, call `useListAdminApplicationsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminApplicationsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminApplicationsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListAdminApplicationsByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<ListAdminApplicationsByProjectIdQuery, ListAdminApplicationsByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminApplicationsByProjectIdQuery, ListAdminApplicationsByProjectIdQueryVariables>(ListAdminApplicationsByProjectIdDocument, options);
      }
export function useListAdminApplicationsByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminApplicationsByProjectIdQuery, ListAdminApplicationsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminApplicationsByProjectIdQuery, ListAdminApplicationsByProjectIdQueryVariables>(ListAdminApplicationsByProjectIdDocument, options);
        }
export type ListAdminApplicationsByProjectIdQueryHookResult = ReturnType<typeof useListAdminApplicationsByProjectIdQuery>;
export type ListAdminApplicationsByProjectIdLazyQueryHookResult = ReturnType<typeof useListAdminApplicationsByProjectIdLazyQuery>;
export type ListAdminApplicationsByProjectIdQueryResult = Apollo.QueryResult<ListAdminApplicationsByProjectIdQuery, ListAdminApplicationsByProjectIdQueryVariables>;
export const CreateApplicationAssetDocument = gql`
    mutation createApplicationAsset($input: CreateApplicationAssetInput!) {
  asset: create_application_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateApplicationAssetMutationFn = Apollo.MutationFunction<CreateApplicationAssetMutation, CreateApplicationAssetMutationVariables>;

/**
 * __useCreateApplicationAssetMutation__
 *
 * To run a mutation, you first call `useCreateApplicationAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationAssetMutation, { data, loading, error }] = useCreateApplicationAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationAssetMutation, CreateApplicationAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationAssetMutation, CreateApplicationAssetMutationVariables>(CreateApplicationAssetDocument, options);
      }
export type CreateApplicationAssetMutationHookResult = ReturnType<typeof useCreateApplicationAssetMutation>;
export type CreateApplicationAssetMutationResult = Apollo.MutationResult<CreateApplicationAssetMutation>;
export type CreateApplicationAssetMutationOptions = Apollo.BaseMutationOptions<CreateApplicationAssetMutation, CreateApplicationAssetMutationVariables>;
export const CreateProjectAssetDocument = gql`
    mutation createProjectAsset($input: CreateProjectAssetInput!) {
  asset: create_project_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateProjectAssetMutationFn = Apollo.MutationFunction<CreateProjectAssetMutation, CreateProjectAssetMutationVariables>;

/**
 * __useCreateProjectAssetMutation__
 *
 * To run a mutation, you first call `useCreateProjectAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAssetMutation, { data, loading, error }] = useCreateProjectAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAssetMutation, CreateProjectAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAssetMutation, CreateProjectAssetMutationVariables>(CreateProjectAssetDocument, options);
      }
export type CreateProjectAssetMutationHookResult = ReturnType<typeof useCreateProjectAssetMutation>;
export type CreateProjectAssetMutationResult = Apollo.MutationResult<CreateProjectAssetMutation>;
export type CreateProjectAssetMutationOptions = Apollo.BaseMutationOptions<CreateProjectAssetMutation, CreateProjectAssetMutationVariables>;
export const CreateProjectHeroDocument = gql`
    mutation createProjectHero($input: CreateProjectHeroInput!) {
  asset: create_project_hero(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateProjectHeroMutationFn = Apollo.MutationFunction<CreateProjectHeroMutation, CreateProjectHeroMutationVariables>;

/**
 * __useCreateProjectHeroMutation__
 *
 * To run a mutation, you first call `useCreateProjectHeroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectHeroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectHeroMutation, { data, loading, error }] = useCreateProjectHeroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectHeroMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectHeroMutation, CreateProjectHeroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectHeroMutation, CreateProjectHeroMutationVariables>(CreateProjectHeroDocument, options);
      }
export type CreateProjectHeroMutationHookResult = ReturnType<typeof useCreateProjectHeroMutation>;
export type CreateProjectHeroMutationResult = Apollo.MutationResult<CreateProjectHeroMutation>;
export type CreateProjectHeroMutationOptions = Apollo.BaseMutationOptions<CreateProjectHeroMutation, CreateProjectHeroMutationVariables>;
export const CreatePlanterRegistrationAssetDocument = gql`
    mutation createPlanterRegistrationAsset($input: CreatePlanterRegistrationAssetInput!) {
  asset: create_planter_registration_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreatePlanterRegistrationAssetMutationFn = Apollo.MutationFunction<CreatePlanterRegistrationAssetMutation, CreatePlanterRegistrationAssetMutationVariables>;

/**
 * __useCreatePlanterRegistrationAssetMutation__
 *
 * To run a mutation, you first call `useCreatePlanterRegistrationAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanterRegistrationAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanterRegistrationAssetMutation, { data, loading, error }] = useCreatePlanterRegistrationAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanterRegistrationAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanterRegistrationAssetMutation, CreatePlanterRegistrationAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanterRegistrationAssetMutation, CreatePlanterRegistrationAssetMutationVariables>(CreatePlanterRegistrationAssetDocument, options);
      }
export type CreatePlanterRegistrationAssetMutationHookResult = ReturnType<typeof useCreatePlanterRegistrationAssetMutation>;
export type CreatePlanterRegistrationAssetMutationResult = Apollo.MutationResult<CreatePlanterRegistrationAssetMutation>;
export type CreatePlanterRegistrationAssetMutationOptions = Apollo.BaseMutationOptions<CreatePlanterRegistrationAssetMutation, CreatePlanterRegistrationAssetMutationVariables>;
export const CreatePlantingAssetDocument = gql`
    mutation createPlantingAsset($input: CreatePlantingAssetInput!) {
  asset: create_planting_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreatePlantingAssetMutationFn = Apollo.MutationFunction<CreatePlantingAssetMutation, CreatePlantingAssetMutationVariables>;

/**
 * __useCreatePlantingAssetMutation__
 *
 * To run a mutation, you first call `useCreatePlantingAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantingAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantingAssetMutation, { data, loading, error }] = useCreatePlantingAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlantingAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantingAssetMutation, CreatePlantingAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantingAssetMutation, CreatePlantingAssetMutationVariables>(CreatePlantingAssetDocument, options);
      }
export type CreatePlantingAssetMutationHookResult = ReturnType<typeof useCreatePlantingAssetMutation>;
export type CreatePlantingAssetMutationResult = Apollo.MutationResult<CreatePlantingAssetMutation>;
export type CreatePlantingAssetMutationOptions = Apollo.BaseMutationOptions<CreatePlantingAssetMutation, CreatePlantingAssetMutationVariables>;
export const DeleteApplicationAssetDocument = gql`
    mutation deleteApplicationAsset($id: uuid!, $planterId: uuid!) {
  delete_ApplicationAsset(
    where: {Id: {_eq: $id}, Application: {PlanterId: {_eq: $planterId}}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteApplicationAssetMutationFn = Apollo.MutationFunction<DeleteApplicationAssetMutation, DeleteApplicationAssetMutationVariables>;

/**
 * __useDeleteApplicationAssetMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicationAssetMutation, { data, loading, error }] = useDeleteApplicationAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useDeleteApplicationAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicationAssetMutation, DeleteApplicationAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicationAssetMutation, DeleteApplicationAssetMutationVariables>(DeleteApplicationAssetDocument, options);
      }
export type DeleteApplicationAssetMutationHookResult = ReturnType<typeof useDeleteApplicationAssetMutation>;
export type DeleteApplicationAssetMutationResult = Apollo.MutationResult<DeleteApplicationAssetMutation>;
export type DeleteApplicationAssetMutationOptions = Apollo.BaseMutationOptions<DeleteApplicationAssetMutation, DeleteApplicationAssetMutationVariables>;
export const DeleteProjectAssetDocument = gql`
    mutation deleteProjectAsset($id: uuid!) {
  delete_ProjectAsset(where: {Id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteProjectAssetMutationFn = Apollo.MutationFunction<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>;

/**
 * __useDeleteProjectAssetMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAssetMutation, { data, loading, error }] = useDeleteProjectAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>(DeleteProjectAssetDocument, options);
      }
export type DeleteProjectAssetMutationHookResult = ReturnType<typeof useDeleteProjectAssetMutation>;
export type DeleteProjectAssetMutationResult = Apollo.MutationResult<DeleteProjectAssetMutation>;
export type DeleteProjectAssetMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>;
export const DeletePlanterRegistrationAssetDocument = gql`
    mutation deletePlanterRegistrationAsset($id: uuid!, $planterRegistrationId: uuid!) {
  delete_PlanterRegistrationAsset(
    where: {Id: {_eq: $id}, PlanterRegistrationId: {_eq: $planterRegistrationId}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePlanterRegistrationAssetMutationFn = Apollo.MutationFunction<DeletePlanterRegistrationAssetMutation, DeletePlanterRegistrationAssetMutationVariables>;

/**
 * __useDeletePlanterRegistrationAssetMutation__
 *
 * To run a mutation, you first call `useDeletePlanterRegistrationAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanterRegistrationAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanterRegistrationAssetMutation, { data, loading, error }] = useDeletePlanterRegistrationAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planterRegistrationId: // value for 'planterRegistrationId'
 *   },
 * });
 */
export function useDeletePlanterRegistrationAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanterRegistrationAssetMutation, DeletePlanterRegistrationAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanterRegistrationAssetMutation, DeletePlanterRegistrationAssetMutationVariables>(DeletePlanterRegistrationAssetDocument, options);
      }
export type DeletePlanterRegistrationAssetMutationHookResult = ReturnType<typeof useDeletePlanterRegistrationAssetMutation>;
export type DeletePlanterRegistrationAssetMutationResult = Apollo.MutationResult<DeletePlanterRegistrationAssetMutation>;
export type DeletePlanterRegistrationAssetMutationOptions = Apollo.BaseMutationOptions<DeletePlanterRegistrationAssetMutation, DeletePlanterRegistrationAssetMutationVariables>;
export const DeletePlantingAssetDocument = gql`
    mutation deletePlantingAsset($id: uuid!, $planterId: uuid!) {
  delete_PlantingAsset(
    where: {Id: {_eq: $id}, Planting: {PlanterId: {_eq: $planterId}}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePlantingAssetMutationFn = Apollo.MutationFunction<DeletePlantingAssetMutation, DeletePlantingAssetMutationVariables>;

/**
 * __useDeletePlantingAssetMutation__
 *
 * To run a mutation, you first call `useDeletePlantingAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlantingAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlantingAssetMutation, { data, loading, error }] = useDeletePlantingAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useDeletePlantingAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlantingAssetMutation, DeletePlantingAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlantingAssetMutation, DeletePlantingAssetMutationVariables>(DeletePlantingAssetDocument, options);
      }
export type DeletePlantingAssetMutationHookResult = ReturnType<typeof useDeletePlantingAssetMutation>;
export type DeletePlantingAssetMutationResult = Apollo.MutationResult<DeletePlantingAssetMutation>;
export type DeletePlantingAssetMutationOptions = Apollo.BaseMutationOptions<DeletePlantingAssetMutation, DeletePlantingAssetMutationVariables>;
export const CreateMonitoringAssetDocument = gql`
    mutation createMonitoringAsset($input: CreateMonitoringAssetInput!) {
  asset: create_monitoring_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateMonitoringAssetMutationFn = Apollo.MutationFunction<CreateMonitoringAssetMutation, CreateMonitoringAssetMutationVariables>;

/**
 * __useCreateMonitoringAssetMutation__
 *
 * To run a mutation, you first call `useCreateMonitoringAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitoringAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitoringAssetMutation, { data, loading, error }] = useCreateMonitoringAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMonitoringAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMonitoringAssetMutation, CreateMonitoringAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMonitoringAssetMutation, CreateMonitoringAssetMutationVariables>(CreateMonitoringAssetDocument, options);
      }
export type CreateMonitoringAssetMutationHookResult = ReturnType<typeof useCreateMonitoringAssetMutation>;
export type CreateMonitoringAssetMutationResult = Apollo.MutationResult<CreateMonitoringAssetMutation>;
export type CreateMonitoringAssetMutationOptions = Apollo.BaseMutationOptions<CreateMonitoringAssetMutation, CreateMonitoringAssetMutationVariables>;
export const CreateAccountAssetDocument = gql`
    mutation createAccountAsset($input: CreateAccountAssetInput!) {
  asset: create_account_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateAccountAssetMutationFn = Apollo.MutationFunction<CreateAccountAssetMutation, CreateAccountAssetMutationVariables>;

/**
 * __useCreateAccountAssetMutation__
 *
 * To run a mutation, you first call `useCreateAccountAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountAssetMutation, { data, loading, error }] = useCreateAccountAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountAssetMutation, CreateAccountAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountAssetMutation, CreateAccountAssetMutationVariables>(CreateAccountAssetDocument, options);
      }
export type CreateAccountAssetMutationHookResult = ReturnType<typeof useCreateAccountAssetMutation>;
export type CreateAccountAssetMutationResult = Apollo.MutationResult<CreateAccountAssetMutation>;
export type CreateAccountAssetMutationOptions = Apollo.BaseMutationOptions<CreateAccountAssetMutation, CreateAccountAssetMutationVariables>;
export const CreatePlantingSiteAssetDocument = gql`
    mutation createPlantingSiteAsset($input: CreatePlantingSiteAssetInput!) {
  asset: create_planting_site_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreatePlantingSiteAssetMutationFn = Apollo.MutationFunction<CreatePlantingSiteAssetMutation, CreatePlantingSiteAssetMutationVariables>;

/**
 * __useCreatePlantingSiteAssetMutation__
 *
 * To run a mutation, you first call `useCreatePlantingSiteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantingSiteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantingSiteAssetMutation, { data, loading, error }] = useCreatePlantingSiteAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlantingSiteAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantingSiteAssetMutation, CreatePlantingSiteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantingSiteAssetMutation, CreatePlantingSiteAssetMutationVariables>(CreatePlantingSiteAssetDocument, options);
      }
export type CreatePlantingSiteAssetMutationHookResult = ReturnType<typeof useCreatePlantingSiteAssetMutation>;
export type CreatePlantingSiteAssetMutationResult = Apollo.MutationResult<CreatePlantingSiteAssetMutation>;
export type CreatePlantingSiteAssetMutationOptions = Apollo.BaseMutationOptions<CreatePlantingSiteAssetMutation, CreatePlantingSiteAssetMutationVariables>;
export const DeletePlantingSiteAssetDocument = gql`
    mutation deletePlantingSiteAsset($id: uuid!, $planterId: uuid!) {
  delete_PlantingSiteAsset(
    where: {Id: {_eq: $id}, PlantingSite: {Application: {PlanterId: {_eq: $planterId}}}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePlantingSiteAssetMutationFn = Apollo.MutationFunction<DeletePlantingSiteAssetMutation, DeletePlantingSiteAssetMutationVariables>;

/**
 * __useDeletePlantingSiteAssetMutation__
 *
 * To run a mutation, you first call `useDeletePlantingSiteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlantingSiteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlantingSiteAssetMutation, { data, loading, error }] = useDeletePlantingSiteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useDeletePlantingSiteAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlantingSiteAssetMutation, DeletePlantingSiteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlantingSiteAssetMutation, DeletePlantingSiteAssetMutationVariables>(DeletePlantingSiteAssetDocument, options);
      }
export type DeletePlantingSiteAssetMutationHookResult = ReturnType<typeof useDeletePlantingSiteAssetMutation>;
export type DeletePlantingSiteAssetMutationResult = Apollo.MutationResult<DeletePlantingSiteAssetMutation>;
export type DeletePlantingSiteAssetMutationOptions = Apollo.BaseMutationOptions<DeletePlantingSiteAssetMutation, DeletePlantingSiteAssetMutationVariables>;
export const RegeneratePdfDocument = gql`
    mutation regeneratePdf($input: RegeneratePdfInput!) {
  regenerate_pdf(input: $input) {
    S3Key
    PresignedUrl
  }
}
    `;
export type RegeneratePdfMutationFn = Apollo.MutationFunction<RegeneratePdfMutation, RegeneratePdfMutationVariables>;

/**
 * __useRegeneratePdfMutation__
 *
 * To run a mutation, you first call `useRegeneratePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegeneratePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regeneratePdfMutation, { data, loading, error }] = useRegeneratePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegeneratePdfMutation(baseOptions?: Apollo.MutationHookOptions<RegeneratePdfMutation, RegeneratePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegeneratePdfMutation, RegeneratePdfMutationVariables>(RegeneratePdfDocument, options);
      }
export type RegeneratePdfMutationHookResult = ReturnType<typeof useRegeneratePdfMutation>;
export type RegeneratePdfMutationResult = Apollo.MutationResult<RegeneratePdfMutation>;
export type RegeneratePdfMutationOptions = Apollo.BaseMutationOptions<RegeneratePdfMutation, RegeneratePdfMutationVariables>;
export const ListAccountPurchaseReceiptsDocument = gql`
    query ListAccountPurchaseReceipts($limit: Int, $offset: Int, $accountId: uuid!, $orderBy: [Purchase_order_by!]) {
  Purchase_aggregate(where: {Funder: {Account: {Id: {_eq: $accountId}}}}) {
    aggregate {
      count
    }
  }
  Purchase(
    where: {Funder: {Account: {Id: {_eq: $accountId}}}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    Id
    Reference
    CreatedOn
    PaymentMethod
    Type
    Total
    State
    ReceiptEmail
    SubscriptionId
    PaymentError
    Attachment {
      Id
      Type
    }
  }
  LatestPurchase: Purchase(
    where: {Funder: {Account: {Id: {_eq: $accountId}}}, SubscriptionId: {_is_null: false}}
    limit: 1
    order_by: {CreatedOn: desc}
  ) {
    Id
    PaymentError
  }
}
    `;

/**
 * __useListAccountPurchaseReceiptsQuery__
 *
 * To run a query within a React component, call `useListAccountPurchaseReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountPurchaseReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountPurchaseReceiptsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListAccountPurchaseReceiptsQuery(baseOptions: Apollo.QueryHookOptions<ListAccountPurchaseReceiptsQuery, ListAccountPurchaseReceiptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountPurchaseReceiptsQuery, ListAccountPurchaseReceiptsQueryVariables>(ListAccountPurchaseReceiptsDocument, options);
      }
export function useListAccountPurchaseReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountPurchaseReceiptsQuery, ListAccountPurchaseReceiptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountPurchaseReceiptsQuery, ListAccountPurchaseReceiptsQueryVariables>(ListAccountPurchaseReceiptsDocument, options);
        }
export type ListAccountPurchaseReceiptsQueryHookResult = ReturnType<typeof useListAccountPurchaseReceiptsQuery>;
export type ListAccountPurchaseReceiptsLazyQueryHookResult = ReturnType<typeof useListAccountPurchaseReceiptsLazyQuery>;
export type ListAccountPurchaseReceiptsQueryResult = Apollo.QueryResult<ListAccountPurchaseReceiptsQuery, ListAccountPurchaseReceiptsQueryVariables>;
export const ListAttachmentsDocument = gql`
    query listAttachments($referenceId: uuid!, $type: Int!) {
  attachments: Attachment(
    where: {ReferenceId: {_eq: $referenceId}, Type: {_eq: $type}, Generated: {_eq: true}}
  ) {
    Id
    Type
    Year
  }
}
    `;

/**
 * __useListAttachmentsQuery__
 *
 * To run a query within a React component, call `useListAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAttachmentsQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useListAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<ListAttachmentsQuery, ListAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAttachmentsQuery, ListAttachmentsQueryVariables>(ListAttachmentsDocument, options);
      }
export function useListAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAttachmentsQuery, ListAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAttachmentsQuery, ListAttachmentsQueryVariables>(ListAttachmentsDocument, options);
        }
export type ListAttachmentsQueryHookResult = ReturnType<typeof useListAttachmentsQuery>;
export type ListAttachmentsLazyQueryHookResult = ReturnType<typeof useListAttachmentsLazyQuery>;
export type ListAttachmentsQueryResult = Apollo.QueryResult<ListAttachmentsQuery, ListAttachmentsQueryVariables>;
export const CreateAttachmentDocument = gql`
    mutation createAttachment($input: Attachment_insert_input!) {
  insert_Attachment_one(object: $input) {
    Id
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const GetAttachmentDocument = gql`
    query getAttachment($id: uuid!) {
  attachment: Attachment_by_pk(Id: $id) {
    Id
    Filename
    Generated
    Failed
  }
}
    `;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const GetPurchaseAttachmentStatusDocument = gql`
    query getPurchaseAttachmentStatus($purchaseId: uuid!, $types: [Int!]!) {
  attachmentStatus: Purchase_by_pk(Id: $purchaseId) {
    Id
    RelatedPurchases {
      Id
      Attachment(where: {Type: {_in: $types}}) {
        Id
        Filename
        Generated
        Failed
      }
    }
  }
}
    `;

/**
 * __useGetPurchaseAttachmentStatusQuery__
 *
 * To run a query within a React component, call `useGetPurchaseAttachmentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseAttachmentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseAttachmentStatusQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetPurchaseAttachmentStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseAttachmentStatusQuery, GetPurchaseAttachmentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseAttachmentStatusQuery, GetPurchaseAttachmentStatusQueryVariables>(GetPurchaseAttachmentStatusDocument, options);
      }
export function useGetPurchaseAttachmentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseAttachmentStatusQuery, GetPurchaseAttachmentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseAttachmentStatusQuery, GetPurchaseAttachmentStatusQueryVariables>(GetPurchaseAttachmentStatusDocument, options);
        }
export type GetPurchaseAttachmentStatusQueryHookResult = ReturnType<typeof useGetPurchaseAttachmentStatusQuery>;
export type GetPurchaseAttachmentStatusLazyQueryHookResult = ReturnType<typeof useGetPurchaseAttachmentStatusLazyQuery>;
export type GetPurchaseAttachmentStatusQueryResult = Apollo.QueryResult<GetPurchaseAttachmentStatusQuery, GetPurchaseAttachmentStatusQueryVariables>;
export const ListCertificationsDocument = gql`
    query listCertifications {
  list_certifications {
    result {
      data {
        json {
          CertificateType
          Description
          DownloadFilePath
          Image
          SeasonName
          Awarded
          Name
        }
      }
    }
  }
}
    `;

/**
 * __useListCertificationsQuery__
 *
 * To run a query within a React component, call `useListCertificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCertificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCertificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCertificationsQuery(baseOptions?: Apollo.QueryHookOptions<ListCertificationsQuery, ListCertificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCertificationsQuery, ListCertificationsQueryVariables>(ListCertificationsDocument, options);
      }
export function useListCertificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCertificationsQuery, ListCertificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCertificationsQuery, ListCertificationsQueryVariables>(ListCertificationsDocument, options);
        }
export type ListCertificationsQueryHookResult = ReturnType<typeof useListCertificationsQuery>;
export type ListCertificationsLazyQueryHookResult = ReturnType<typeof useListCertificationsLazyQuery>;
export type ListCertificationsQueryResult = Apollo.QueryResult<ListCertificationsQuery, ListCertificationsQueryVariables>;
export const GetDashboardProjectsSupportedCountDocument = gql`
    query getDashboardProjectsSupportedCount($funderId: uuid!) {
  SupportedProjectsView_aggregate(
    where: {FunderId: {_eq: $funderId}}
    distinct_on: ProjectId
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDashboardProjectsSupportedCountQuery__
 *
 * To run a query within a React component, call `useGetDashboardProjectsSupportedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardProjectsSupportedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardProjectsSupportedCountQuery({
 *   variables: {
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useGetDashboardProjectsSupportedCountQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardProjectsSupportedCountQuery, GetDashboardProjectsSupportedCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardProjectsSupportedCountQuery, GetDashboardProjectsSupportedCountQueryVariables>(GetDashboardProjectsSupportedCountDocument, options);
      }
export function useGetDashboardProjectsSupportedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardProjectsSupportedCountQuery, GetDashboardProjectsSupportedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardProjectsSupportedCountQuery, GetDashboardProjectsSupportedCountQueryVariables>(GetDashboardProjectsSupportedCountDocument, options);
        }
export type GetDashboardProjectsSupportedCountQueryHookResult = ReturnType<typeof useGetDashboardProjectsSupportedCountQuery>;
export type GetDashboardProjectsSupportedCountLazyQueryHookResult = ReturnType<typeof useGetDashboardProjectsSupportedCountLazyQuery>;
export type GetDashboardProjectsSupportedCountQueryResult = Apollo.QueryResult<GetDashboardProjectsSupportedCountQuery, GetDashboardProjectsSupportedCountQueryVariables>;
export const GetDashboardTabsDataDocument = gql`
    query getDashboardTabsData($limit: Int = 5, $accountId: uuid!, $offset: Int) {
  Application_aggregate(where: {Planter: {Account: {Id: {_eq: $accountId}}}}) {
    aggregate {
      count
    }
  }
  Application(
    limit: $limit
    offset: $offset
    order_by: {CreatedOn: desc}
    where: {Planter: {Account: {Id: {_eq: $accountId}}}}
  ) {
    Approved
    ApprovedAt
    CreatedOn
    DeclinedAt
    Id
    Name
    Planned
    Project {
      Id
      Name
    }
    Plantings {
      Id
      CreatedOn
      Quantity
      MonitoringEvents {
        Id
        CreatedOn
      }
    }
    Reference
    Required
    Season {
      Id
      Name
    }
    SubmittedAt
    WorkflowState
  }
  PurchaseDashboardView(
    limit: $limit
    where: {State: {_nin: [6, 8]}, Funder: {Account: {Id: {_eq: $accountId}}}}
    order_by: {CreatedOn: desc}
  ) {
    Token
    Quantity
    CreatedOn
    Amount
    Total
    Funder {
      Account {
        Id
        Name
      }
    }
    Type
    State
    SubscriptionId
  }
}
    `;

/**
 * __useGetDashboardTabsDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardTabsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardTabsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardTabsDataQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDashboardTabsDataQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardTabsDataQuery, GetDashboardTabsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardTabsDataQuery, GetDashboardTabsDataQueryVariables>(GetDashboardTabsDataDocument, options);
      }
export function useGetDashboardTabsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardTabsDataQuery, GetDashboardTabsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardTabsDataQuery, GetDashboardTabsDataQueryVariables>(GetDashboardTabsDataDocument, options);
        }
export type GetDashboardTabsDataQueryHookResult = ReturnType<typeof useGetDashboardTabsDataQuery>;
export type GetDashboardTabsDataLazyQueryHookResult = ReturnType<typeof useGetDashboardTabsDataLazyQuery>;
export type GetDashboardTabsDataQueryResult = Apollo.QueryResult<GetDashboardTabsDataQuery, GetDashboardTabsDataQueryVariables>;
export const GetFunderStatsDocument = gql`
    query GetFunderStats($accountId: uuid!) {
  PublicFunderStatsForAccount(
    args: {AccountId: $accountId}
    order_by: {SeasonName: asc}
  ) {
    PlantersSupported
    Rank
    SeasonName
    TreesFunded
  }
}
    `;

/**
 * __useGetFunderStatsQuery__
 *
 * To run a query within a React component, call `useGetFunderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderStatsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetFunderStatsQuery(baseOptions: Apollo.QueryHookOptions<GetFunderStatsQuery, GetFunderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderStatsQuery, GetFunderStatsQueryVariables>(GetFunderStatsDocument, options);
      }
export function useGetFunderStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderStatsQuery, GetFunderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderStatsQuery, GetFunderStatsQueryVariables>(GetFunderStatsDocument, options);
        }
export type GetFunderStatsQueryHookResult = ReturnType<typeof useGetFunderStatsQuery>;
export type GetFunderStatsLazyQueryHookResult = ReturnType<typeof useGetFunderStatsLazyQuery>;
export type GetFunderStatsQueryResult = Apollo.QueryResult<GetFunderStatsQuery, GetFunderStatsQueryVariables>;
export const GetFunderSupportStatsDocument = gql`
    query GetFunderSupportStats($funderId: uuid!, $offset: Int!, $limit: Int = 12) {
  Planter_aggregate(
    where: {Application: {Matches: {Instruction: {FunderId: {_eq: $funderId}}}}}
    distinct_on: Id
  ) {
    aggregate {
      count
    }
  }
  Planter(
    distinct_on: Id
    where: {Application: {Matches: {Instruction: {FunderId: {_eq: $funderId}}}}}
    offset: $offset
    limit: $limit
  ) {
    Account {
      Id
      Avatar
      Name
      Uri
    }
  }
}
    `;

/**
 * __useGetFunderSupportStatsQuery__
 *
 * To run a query within a React component, call `useGetFunderSupportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderSupportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderSupportStatsQuery({
 *   variables: {
 *      funderId: // value for 'funderId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFunderSupportStatsQuery(baseOptions: Apollo.QueryHookOptions<GetFunderSupportStatsQuery, GetFunderSupportStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderSupportStatsQuery, GetFunderSupportStatsQueryVariables>(GetFunderSupportStatsDocument, options);
      }
export function useGetFunderSupportStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderSupportStatsQuery, GetFunderSupportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderSupportStatsQuery, GetFunderSupportStatsQueryVariables>(GetFunderSupportStatsDocument, options);
        }
export type GetFunderSupportStatsQueryHookResult = ReturnType<typeof useGetFunderSupportStatsQuery>;
export type GetFunderSupportStatsLazyQueryHookResult = ReturnType<typeof useGetFunderSupportStatsLazyQuery>;
export type GetFunderSupportStatsQueryResult = Apollo.QueryResult<GetFunderSupportStatsQuery, GetFunderSupportStatsQueryVariables>;
export const FunderSupportedProjectTreeCountDocument = gql`
    query FunderSupportedProjectTreeCount($where: SupportedProjectsView_bool_exp) {
  SupportedProjectsView(where: $where) {
    Quantity
  }
}
    `;

/**
 * __useFunderSupportedProjectTreeCountQuery__
 *
 * To run a query within a React component, call `useFunderSupportedProjectTreeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunderSupportedProjectTreeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunderSupportedProjectTreeCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFunderSupportedProjectTreeCountQuery(baseOptions?: Apollo.QueryHookOptions<FunderSupportedProjectTreeCountQuery, FunderSupportedProjectTreeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunderSupportedProjectTreeCountQuery, FunderSupportedProjectTreeCountQueryVariables>(FunderSupportedProjectTreeCountDocument, options);
      }
export function useFunderSupportedProjectTreeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunderSupportedProjectTreeCountQuery, FunderSupportedProjectTreeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunderSupportedProjectTreeCountQuery, FunderSupportedProjectTreeCountQueryVariables>(FunderSupportedProjectTreeCountDocument, options);
        }
export type FunderSupportedProjectTreeCountQueryHookResult = ReturnType<typeof useFunderSupportedProjectTreeCountQuery>;
export type FunderSupportedProjectTreeCountLazyQueryHookResult = ReturnType<typeof useFunderSupportedProjectTreeCountLazyQuery>;
export type FunderSupportedProjectTreeCountQueryResult = Apollo.QueryResult<FunderSupportedProjectTreeCountQuery, FunderSupportedProjectTreeCountQueryVariables>;
export const ListGiftCategoriesDocument = gql`
    query listGiftCategories {
  GiftCategory(order_by: {Order: asc}) {
    Id
    Name
    TemplateCategories_aggregate {
      aggregate {
        count
      }
    }
  }
  GiftTemplate_aggregate(
    where: {IsBulkOnly: {_eq: false}, IsAvailable: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useListGiftCategoriesQuery__
 *
 * To run a query within a React component, call `useListGiftCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGiftCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGiftCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGiftCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ListGiftCategoriesQuery, ListGiftCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGiftCategoriesQuery, ListGiftCategoriesQueryVariables>(ListGiftCategoriesDocument, options);
      }
export function useListGiftCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGiftCategoriesQuery, ListGiftCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGiftCategoriesQuery, ListGiftCategoriesQueryVariables>(ListGiftCategoriesDocument, options);
        }
export type ListGiftCategoriesQueryHookResult = ReturnType<typeof useListGiftCategoriesQuery>;
export type ListGiftCategoriesLazyQueryHookResult = ReturnType<typeof useListGiftCategoriesLazyQuery>;
export type ListGiftCategoriesQueryResult = Apollo.QueryResult<ListGiftCategoriesQuery, ListGiftCategoriesQueryVariables>;
export const ListGiftTemplatesDocument = gql`
    query listGiftTemplates($offset: Int!, $where: GiftTemplate_bool_exp!, $limit: Int = null) {
  GiftTemplate_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  GiftTemplate(
    limit: $limit
    offset: $offset
    order_by: {IsFeatured: desc, Order: asc}
    where: $where
  ) {
    Id
    BackgroundImage
    Description
    Preview
    Title
    TemplateCategories {
      GiftCategoryId
    }
  }
}
    `;

/**
 * __useListGiftTemplatesQuery__
 *
 * To run a query within a React component, call `useListGiftTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGiftTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGiftTemplatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListGiftTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListGiftTemplatesQuery, ListGiftTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGiftTemplatesQuery, ListGiftTemplatesQueryVariables>(ListGiftTemplatesDocument, options);
      }
export function useListGiftTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGiftTemplatesQuery, ListGiftTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGiftTemplatesQuery, ListGiftTemplatesQueryVariables>(ListGiftTemplatesDocument, options);
        }
export type ListGiftTemplatesQueryHookResult = ReturnType<typeof useListGiftTemplatesQuery>;
export type ListGiftTemplatesLazyQueryHookResult = ReturnType<typeof useListGiftTemplatesLazyQuery>;
export type ListGiftTemplatesQueryResult = Apollo.QueryResult<ListGiftTemplatesQuery, ListGiftTemplatesQueryVariables>;
export const CreateGiftPaymentDocument = gql`
    mutation createGiftPayment($input: CreateGiftPaymentInput!) {
  create_gift_payment(input: $input) {
    PaymentIntentClientSecret
    PurchaseId
    Hash
    Token
  }
}
    `;
export type CreateGiftPaymentMutationFn = Apollo.MutationFunction<CreateGiftPaymentMutation, CreateGiftPaymentMutationVariables>;

/**
 * __useCreateGiftPaymentMutation__
 *
 * To run a mutation, you first call `useCreateGiftPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftPaymentMutation, { data, loading, error }] = useCreateGiftPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftPaymentMutation, CreateGiftPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftPaymentMutation, CreateGiftPaymentMutationVariables>(CreateGiftPaymentDocument, options);
      }
export type CreateGiftPaymentMutationHookResult = ReturnType<typeof useCreateGiftPaymentMutation>;
export type CreateGiftPaymentMutationResult = Apollo.MutationResult<CreateGiftPaymentMutation>;
export type CreateGiftPaymentMutationOptions = Apollo.BaseMutationOptions<CreateGiftPaymentMutation, CreateGiftPaymentMutationVariables>;
export const CreateGiftGuestPaymentDocument = gql`
    mutation createGiftGuestPayment($input: CreateGiftGuestPaymentInput!) {
  create_gift_guest_payment(input: $input) {
    PaymentIntentClientSecret
    PurchaseId
    Hash
    Token
  }
}
    `;
export type CreateGiftGuestPaymentMutationFn = Apollo.MutationFunction<CreateGiftGuestPaymentMutation, CreateGiftGuestPaymentMutationVariables>;

/**
 * __useCreateGiftGuestPaymentMutation__
 *
 * To run a mutation, you first call `useCreateGiftGuestPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftGuestPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftGuestPaymentMutation, { data, loading, error }] = useCreateGiftGuestPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftGuestPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftGuestPaymentMutation, CreateGiftGuestPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftGuestPaymentMutation, CreateGiftGuestPaymentMutationVariables>(CreateGiftGuestPaymentDocument, options);
      }
export type CreateGiftGuestPaymentMutationHookResult = ReturnType<typeof useCreateGiftGuestPaymentMutation>;
export type CreateGiftGuestPaymentMutationResult = Apollo.MutationResult<CreateGiftGuestPaymentMutation>;
export type CreateGiftGuestPaymentMutationOptions = Apollo.BaseMutationOptions<CreateGiftGuestPaymentMutation, CreateGiftGuestPaymentMutationVariables>;
export const GetBulkGiftAttributesDocument = gql`
    query getBulkGiftAttributes {
  Product(where: {IsArchived: {_eq: false}}, limit: 1) {
    Id
    Name
    ProductPrices(where: {IsArchived: {_eq: false}, VolumeMin: {_eq: 1}}) {
      Id
      Amount
      VolumeMin
      VolumeMax
    }
  }
  GiftTemplate {
    Id
    Name
    Title
    Description
    Preview
  }
}
    `;

/**
 * __useGetBulkGiftAttributesQuery__
 *
 * To run a query within a React component, call `useGetBulkGiftAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkGiftAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkGiftAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkGiftAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GetBulkGiftAttributesQuery, GetBulkGiftAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkGiftAttributesQuery, GetBulkGiftAttributesQueryVariables>(GetBulkGiftAttributesDocument, options);
      }
export function useGetBulkGiftAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkGiftAttributesQuery, GetBulkGiftAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkGiftAttributesQuery, GetBulkGiftAttributesQueryVariables>(GetBulkGiftAttributesDocument, options);
        }
export type GetBulkGiftAttributesQueryHookResult = ReturnType<typeof useGetBulkGiftAttributesQuery>;
export type GetBulkGiftAttributesLazyQueryHookResult = ReturnType<typeof useGetBulkGiftAttributesLazyQuery>;
export type GetBulkGiftAttributesQueryResult = Apollo.QueryResult<GetBulkGiftAttributesQuery, GetBulkGiftAttributesQueryVariables>;
export const ImportBulkGiftDocument = gql`
    mutation importBulkGift($input: ImportBulkGiftInput!) {
  import_bulk_gift(input: $input) {
    PurchaseIds
  }
}
    `;
export type ImportBulkGiftMutationFn = Apollo.MutationFunction<ImportBulkGiftMutation, ImportBulkGiftMutationVariables>;

/**
 * __useImportBulkGiftMutation__
 *
 * To run a mutation, you first call `useImportBulkGiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportBulkGiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importBulkGiftMutation, { data, loading, error }] = useImportBulkGiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportBulkGiftMutation(baseOptions?: Apollo.MutationHookOptions<ImportBulkGiftMutation, ImportBulkGiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportBulkGiftMutation, ImportBulkGiftMutationVariables>(ImportBulkGiftDocument, options);
      }
export type ImportBulkGiftMutationHookResult = ReturnType<typeof useImportBulkGiftMutation>;
export type ImportBulkGiftMutationResult = Apollo.MutationResult<ImportBulkGiftMutation>;
export type ImportBulkGiftMutationOptions = Apollo.BaseMutationOptions<ImportBulkGiftMutation, ImportBulkGiftMutationVariables>;
export const ListBulkGiftRecipientsDocument = gql`
    query listBulkGiftRecipients($s3Key: String!) {
  list_bulk_gift_recipients(input: {S3Key: $s3Key}) {
    Gifts {
      Trees
      FromName
      ToName
      ToEmail
      Message
    }
  }
}
    `;

/**
 * __useListBulkGiftRecipientsQuery__
 *
 * To run a query within a React component, call `useListBulkGiftRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBulkGiftRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBulkGiftRecipientsQuery({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useListBulkGiftRecipientsQuery(baseOptions: Apollo.QueryHookOptions<ListBulkGiftRecipientsQuery, ListBulkGiftRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBulkGiftRecipientsQuery, ListBulkGiftRecipientsQueryVariables>(ListBulkGiftRecipientsDocument, options);
      }
export function useListBulkGiftRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBulkGiftRecipientsQuery, ListBulkGiftRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBulkGiftRecipientsQuery, ListBulkGiftRecipientsQueryVariables>(ListBulkGiftRecipientsDocument, options);
        }
export type ListBulkGiftRecipientsQueryHookResult = ReturnType<typeof useListBulkGiftRecipientsQuery>;
export type ListBulkGiftRecipientsLazyQueryHookResult = ReturnType<typeof useListBulkGiftRecipientsLazyQuery>;
export type ListBulkGiftRecipientsQueryResult = Apollo.QueryResult<ListBulkGiftRecipientsQuery, ListBulkGiftRecipientsQueryVariables>;
export const GetGiftPreviewDocument = gql`
    query getGiftPreview($input: GetGiftPreviewInput) {
  get_gift_preview(input: $input) {
    base64Data
  }
}
    `;

/**
 * __useGetGiftPreviewQuery__
 *
 * To run a query within a React component, call `useGetGiftPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGiftPreviewQuery(baseOptions?: Apollo.QueryHookOptions<GetGiftPreviewQuery, GetGiftPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftPreviewQuery, GetGiftPreviewQueryVariables>(GetGiftPreviewDocument, options);
      }
export function useGetGiftPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftPreviewQuery, GetGiftPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftPreviewQuery, GetGiftPreviewQueryVariables>(GetGiftPreviewDocument, options);
        }
export type GetGiftPreviewQueryHookResult = ReturnType<typeof useGetGiftPreviewQuery>;
export type GetGiftPreviewLazyQueryHookResult = ReturnType<typeof useGetGiftPreviewLazyQuery>;
export type GetGiftPreviewQueryResult = Apollo.QueryResult<GetGiftPreviewQuery, GetGiftPreviewQueryVariables>;
export const ListAdminInstructionsDocument = gql`
    query listAdminInstructions($limit: Int = 10, $offset: Int!, $where: InstructionView_bool_exp, $order_by: [InstructionView_order_by!]) {
  InstructionView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  InstructionView(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    Id
    FunderName
    PurchaseId
    ReceiptEmail
    RegionName
    Reference
    SeasonName
    Trees
    TypeName
    Unmatched
  }
}
    `;

/**
 * __useListAdminInstructionsQuery__
 *
 * To run a query within a React component, call `useListAdminInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminInstructionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useListAdminInstructionsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminInstructionsQuery, ListAdminInstructionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminInstructionsQuery, ListAdminInstructionsQueryVariables>(ListAdminInstructionsDocument, options);
      }
export function useListAdminInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminInstructionsQuery, ListAdminInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminInstructionsQuery, ListAdminInstructionsQueryVariables>(ListAdminInstructionsDocument, options);
        }
export type ListAdminInstructionsQueryHookResult = ReturnType<typeof useListAdminInstructionsQuery>;
export type ListAdminInstructionsLazyQueryHookResult = ReturnType<typeof useListAdminInstructionsLazyQuery>;
export type ListAdminInstructionsQueryResult = Apollo.QueryResult<ListAdminInstructionsQuery, ListAdminInstructionsQueryVariables>;
export const GetActiveInviteByEmailDocument = gql`
    query getActiveInviteByEmail($email: String!) {
  Invite(
    where: {RecipientEmail: {_eq: $email}, Status: {_is_null: true}}
    order_by: {CreatedOn: desc}
    limit: 1
  ) {
    Id
    Code
    ExpiresAt
    Account {
      Id
      Name
    }
  }
}
    `;

/**
 * __useGetActiveInviteByEmailQuery__
 *
 * To run a query within a React component, call `useGetActiveInviteByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveInviteByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveInviteByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetActiveInviteByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetActiveInviteByEmailQuery, GetActiveInviteByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveInviteByEmailQuery, GetActiveInviteByEmailQueryVariables>(GetActiveInviteByEmailDocument, options);
      }
export function useGetActiveInviteByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveInviteByEmailQuery, GetActiveInviteByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveInviteByEmailQuery, GetActiveInviteByEmailQueryVariables>(GetActiveInviteByEmailDocument, options);
        }
export type GetActiveInviteByEmailQueryHookResult = ReturnType<typeof useGetActiveInviteByEmailQuery>;
export type GetActiveInviteByEmailLazyQueryHookResult = ReturnType<typeof useGetActiveInviteByEmailLazyQuery>;
export type GetActiveInviteByEmailQueryResult = Apollo.QueryResult<GetActiveInviteByEmailQuery, GetActiveInviteByEmailQueryVariables>;
export const GetInviteByIdDocument = gql`
    query getInviteById($id: uuid!) {
  Invite_by_pk(Id: $id) {
    Id
    Account {
      Id
      Name
    }
    RecipientFirstname
    RecipientLastname
    RecipientEmail
    Message
  }
}
    `;

/**
 * __useGetInviteByIdQuery__
 *
 * To run a query within a React component, call `useGetInviteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInviteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInviteByIdQuery, GetInviteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteByIdQuery, GetInviteByIdQueryVariables>(GetInviteByIdDocument, options);
      }
export function useGetInviteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteByIdQuery, GetInviteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteByIdQuery, GetInviteByIdQueryVariables>(GetInviteByIdDocument, options);
        }
export type GetInviteByIdQueryHookResult = ReturnType<typeof useGetInviteByIdQuery>;
export type GetInviteByIdLazyQueryHookResult = ReturnType<typeof useGetInviteByIdLazyQuery>;
export type GetInviteByIdQueryResult = Apollo.QueryResult<GetInviteByIdQuery, GetInviteByIdQueryVariables>;
export const GetActiveInviteAccountByCodeDocument = gql`
    query getActiveInviteAccountByCode($code: String!) {
  Invite(where: {Code: {_eq: $code}}) {
    Id
    Code
    RecipientFirstname
    RecipientLastname
    RecipientEmail
    ExpiresAt
    Status
    Account {
      Id
      Name
    }
  }
}
    `;

/**
 * __useGetActiveInviteAccountByCodeQuery__
 *
 * To run a query within a React component, call `useGetActiveInviteAccountByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveInviteAccountByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveInviteAccountByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetActiveInviteAccountByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetActiveInviteAccountByCodeQuery, GetActiveInviteAccountByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveInviteAccountByCodeQuery, GetActiveInviteAccountByCodeQueryVariables>(GetActiveInviteAccountByCodeDocument, options);
      }
export function useGetActiveInviteAccountByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveInviteAccountByCodeQuery, GetActiveInviteAccountByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveInviteAccountByCodeQuery, GetActiveInviteAccountByCodeQueryVariables>(GetActiveInviteAccountByCodeDocument, options);
        }
export type GetActiveInviteAccountByCodeQueryHookResult = ReturnType<typeof useGetActiveInviteAccountByCodeQuery>;
export type GetActiveInviteAccountByCodeLazyQueryHookResult = ReturnType<typeof useGetActiveInviteAccountByCodeLazyQuery>;
export type GetActiveInviteAccountByCodeQueryResult = Apollo.QueryResult<GetActiveInviteAccountByCodeQuery, GetActiveInviteAccountByCodeQueryVariables>;
export const GetInviteByCodeWithUserDocument = gql`
    query GetInviteByCodeWithUser($code: String!, $userId: uuid!) {
  invite: Invite(where: {Code: {_eq: $code}}) {
    Id
    Code
    ExpiresAt
    RecipientEmail
    RecipientFirstname
    RecipientLastname
    Account {
      Id
      Email
    }
  }
  user: User_by_pk(Id: $userId) {
    Id
    Identifier
    Email
    Memberships {
      Id
      Account {
        Id
        Email
      }
    }
  }
}
    `;

/**
 * __useGetInviteByCodeWithUserQuery__
 *
 * To run a query within a React component, call `useGetInviteByCodeWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteByCodeWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteByCodeWithUserQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetInviteByCodeWithUserQuery(baseOptions: Apollo.QueryHookOptions<GetInviteByCodeWithUserQuery, GetInviteByCodeWithUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteByCodeWithUserQuery, GetInviteByCodeWithUserQueryVariables>(GetInviteByCodeWithUserDocument, options);
      }
export function useGetInviteByCodeWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteByCodeWithUserQuery, GetInviteByCodeWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteByCodeWithUserQuery, GetInviteByCodeWithUserQueryVariables>(GetInviteByCodeWithUserDocument, options);
        }
export type GetInviteByCodeWithUserQueryHookResult = ReturnType<typeof useGetInviteByCodeWithUserQuery>;
export type GetInviteByCodeWithUserLazyQueryHookResult = ReturnType<typeof useGetInviteByCodeWithUserLazyQuery>;
export type GetInviteByCodeWithUserQueryResult = Apollo.QueryResult<GetInviteByCodeWithUserQuery, GetInviteByCodeWithUserQueryVariables>;
export const CreateAccountUserInviteDocument = gql`
    mutation CreateAccountUserInvite($email: String!, $recipientFirstname: String!, $recipientLastname: String!, $message: String!, $accountId: uuid!, $expiresAt: timestamp!, $code: String!) {
  update_Invite(
    where: {RecipientEmail: {_ilike: $email}, Status: {_is_null: true}, AccountId: {_eq: $accountId}}
    _set: {Status: "expired"}
  ) {
    affected_rows
    returning {
      Id
      Status
    }
  }
  insert_Invite_one(
    object: {RecipientEmail: $email, RecipientFirstname: $recipientFirstname, RecipientLastname: $recipientLastname, Message: $message, AccountId: $accountId, ExpiresAt: $expiresAt, Code: $code}
  ) {
    Id
    Code
  }
}
    `;
export type CreateAccountUserInviteMutationFn = Apollo.MutationFunction<CreateAccountUserInviteMutation, CreateAccountUserInviteMutationVariables>;

/**
 * __useCreateAccountUserInviteMutation__
 *
 * To run a mutation, you first call `useCreateAccountUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountUserInviteMutation, { data, loading, error }] = useCreateAccountUserInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recipientFirstname: // value for 'recipientFirstname'
 *      recipientLastname: // value for 'recipientLastname'
 *      message: // value for 'message'
 *      accountId: // value for 'accountId'
 *      expiresAt: // value for 'expiresAt'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCreateAccountUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountUserInviteMutation, CreateAccountUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountUserInviteMutation, CreateAccountUserInviteMutationVariables>(CreateAccountUserInviteDocument, options);
      }
export type CreateAccountUserInviteMutationHookResult = ReturnType<typeof useCreateAccountUserInviteMutation>;
export type CreateAccountUserInviteMutationResult = Apollo.MutationResult<CreateAccountUserInviteMutation>;
export type CreateAccountUserInviteMutationOptions = Apollo.BaseMutationOptions<CreateAccountUserInviteMutation, CreateAccountUserInviteMutationVariables>;
export const AcceptAccountInviteDocument = gql`
    mutation acceptAccountInvite($code: String!) {
  accept_invite(input: {Code: $code}) {
    MembershipId
  }
}
    `;
export type AcceptAccountInviteMutationFn = Apollo.MutationFunction<AcceptAccountInviteMutation, AcceptAccountInviteMutationVariables>;

/**
 * __useAcceptAccountInviteMutation__
 *
 * To run a mutation, you first call `useAcceptAccountInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAccountInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAccountInviteMutation, { data, loading, error }] = useAcceptAccountInviteMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAcceptAccountInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAccountInviteMutation, AcceptAccountInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAccountInviteMutation, AcceptAccountInviteMutationVariables>(AcceptAccountInviteDocument, options);
      }
export type AcceptAccountInviteMutationHookResult = ReturnType<typeof useAcceptAccountInviteMutation>;
export type AcceptAccountInviteMutationResult = Apollo.MutationResult<AcceptAccountInviteMutation>;
export type AcceptAccountInviteMutationOptions = Apollo.BaseMutationOptions<AcceptAccountInviteMutation, AcceptAccountInviteMutationVariables>;
export const DeclineAccountInviteDocument = gql`
    mutation declineAccountInvite($code: String!) {
  decline_invite(input: {Code: $code}) {
    Status
  }
}
    `;
export type DeclineAccountInviteMutationFn = Apollo.MutationFunction<DeclineAccountInviteMutation, DeclineAccountInviteMutationVariables>;

/**
 * __useDeclineAccountInviteMutation__
 *
 * To run a mutation, you first call `useDeclineAccountInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAccountInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAccountInviteMutation, { data, loading, error }] = useDeclineAccountInviteMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useDeclineAccountInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAccountInviteMutation, DeclineAccountInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAccountInviteMutation, DeclineAccountInviteMutationVariables>(DeclineAccountInviteDocument, options);
      }
export type DeclineAccountInviteMutationHookResult = ReturnType<typeof useDeclineAccountInviteMutation>;
export type DeclineAccountInviteMutationResult = Apollo.MutationResult<DeclineAccountInviteMutation>;
export type DeclineAccountInviteMutationOptions = Apollo.BaseMutationOptions<DeclineAccountInviteMutation, DeclineAccountInviteMutationVariables>;
export const DeleteAccountInviteDocument = gql`
    mutation deleteAccountInvite($id: uuid!) {
  delete_Invite_by_pk(Id: $id) {
    Id
  }
}
    `;
export type DeleteAccountInviteMutationFn = Apollo.MutationFunction<DeleteAccountInviteMutation, DeleteAccountInviteMutationVariables>;

/**
 * __useDeleteAccountInviteMutation__
 *
 * To run a mutation, you first call `useDeleteAccountInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountInviteMutation, { data, loading, error }] = useDeleteAccountInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountInviteMutation, DeleteAccountInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountInviteMutation, DeleteAccountInviteMutationVariables>(DeleteAccountInviteDocument, options);
      }
export type DeleteAccountInviteMutationHookResult = ReturnType<typeof useDeleteAccountInviteMutation>;
export type DeleteAccountInviteMutationResult = Apollo.MutationResult<DeleteAccountInviteMutation>;
export type DeleteAccountInviteMutationOptions = Apollo.BaseMutationOptions<DeleteAccountInviteMutation, DeleteAccountInviteMutationVariables>;
export const UpdateAccountInviteStatusDocument = gql`
    mutation updateAccountInviteStatus($code: String!, $status: String!) {
  update_Invite(where: {Code: {_eq: $code}}, _set: {Status: $status}) {
    affected_rows
    returning {
      Id
      Code
      Status
    }
  }
}
    `;
export type UpdateAccountInviteStatusMutationFn = Apollo.MutationFunction<UpdateAccountInviteStatusMutation, UpdateAccountInviteStatusMutationVariables>;

/**
 * __useUpdateAccountInviteStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAccountInviteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountInviteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountInviteStatusMutation, { data, loading, error }] = useUpdateAccountInviteStatusMutation({
 *   variables: {
 *      code: // value for 'code'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAccountInviteStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountInviteStatusMutation, UpdateAccountInviteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountInviteStatusMutation, UpdateAccountInviteStatusMutationVariables>(UpdateAccountInviteStatusDocument, options);
      }
export type UpdateAccountInviteStatusMutationHookResult = ReturnType<typeof useUpdateAccountInviteStatusMutation>;
export type UpdateAccountInviteStatusMutationResult = Apollo.MutationResult<UpdateAccountInviteStatusMutation>;
export type UpdateAccountInviteStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAccountInviteStatusMutation, UpdateAccountInviteStatusMutationVariables>;
export const UpdateExpiredInvitesDocument = gql`
    mutation updateExpiredInvites($expiresAt: timestamp!) {
  update_Invite(
    where: {ExpiresAt: {_lt: $expiresAt}, Status: {_is_null: true}}
    _set: {Status: "expired"}
  ) {
    affected_rows
  }
}
    `;
export type UpdateExpiredInvitesMutationFn = Apollo.MutationFunction<UpdateExpiredInvitesMutation, UpdateExpiredInvitesMutationVariables>;

/**
 * __useUpdateExpiredInvitesMutation__
 *
 * To run a mutation, you first call `useUpdateExpiredInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpiredInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpiredInvitesMutation, { data, loading, error }] = useUpdateExpiredInvitesMutation({
 *   variables: {
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useUpdateExpiredInvitesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpiredInvitesMutation, UpdateExpiredInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpiredInvitesMutation, UpdateExpiredInvitesMutationVariables>(UpdateExpiredInvitesDocument, options);
      }
export type UpdateExpiredInvitesMutationHookResult = ReturnType<typeof useUpdateExpiredInvitesMutation>;
export type UpdateExpiredInvitesMutationResult = Apollo.MutationResult<UpdateExpiredInvitesMutation>;
export type UpdateExpiredInvitesMutationOptions = Apollo.BaseMutationOptions<UpdateExpiredInvitesMutation, UpdateExpiredInvitesMutationVariables>;
export const CreateMembershipDocument = gql`
    mutation CreateMembership($input: Membership_insert_input!) {
  insert_Membership_one(object: $input) {
    Id
  }
}
    `;
export type CreateMembershipMutationFn = Apollo.MutationFunction<CreateMembershipMutation, CreateMembershipMutationVariables>;

/**
 * __useCreateMembershipMutation__
 *
 * To run a mutation, you first call `useCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipMutation, { data, loading, error }] = useCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateMembershipMutation, CreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMembershipMutation, CreateMembershipMutationVariables>(CreateMembershipDocument, options);
      }
export type CreateMembershipMutationHookResult = ReturnType<typeof useCreateMembershipMutation>;
export type CreateMembershipMutationResult = Apollo.MutationResult<CreateMembershipMutation>;
export type CreateMembershipMutationOptions = Apollo.BaseMutationOptions<CreateMembershipMutation, CreateMembershipMutationVariables>;
export const UpdateMembershipRoleDocument = gql`
    mutation UpdateMembershipRole($id: uuid!, $role: smallint!) {
  update_Membership_by_pk(pk_columns: {Id: $id}, _set: {Type: $role}) {
    Id
    Type
    User {
      Id
      FirstName
      LastName
    }
  }
}
    `;
export type UpdateMembershipRoleMutationFn = Apollo.MutationFunction<UpdateMembershipRoleMutation, UpdateMembershipRoleMutationVariables>;

/**
 * __useUpdateMembershipRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipRoleMutation, { data, loading, error }] = useUpdateMembershipRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateMembershipRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMembershipRoleMutation, UpdateMembershipRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMembershipRoleMutation, UpdateMembershipRoleMutationVariables>(UpdateMembershipRoleDocument, options);
      }
export type UpdateMembershipRoleMutationHookResult = ReturnType<typeof useUpdateMembershipRoleMutation>;
export type UpdateMembershipRoleMutationResult = Apollo.MutationResult<UpdateMembershipRoleMutation>;
export type UpdateMembershipRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMembershipRoleMutation, UpdateMembershipRoleMutationVariables>;
export const ChangeUserMembershipTypeDocument = gql`
    mutation changeUserMembershipType($input: ChangeUserMembershipTypeInput!) {
  change_user_membership_type(input: $input) {
    MembershipId
    UserEmail
    Role
  }
}
    `;
export type ChangeUserMembershipTypeMutationFn = Apollo.MutationFunction<ChangeUserMembershipTypeMutation, ChangeUserMembershipTypeMutationVariables>;

/**
 * __useChangeUserMembershipTypeMutation__
 *
 * To run a mutation, you first call `useChangeUserMembershipTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserMembershipTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserMembershipTypeMutation, { data, loading, error }] = useChangeUserMembershipTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUserMembershipTypeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserMembershipTypeMutation, ChangeUserMembershipTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserMembershipTypeMutation, ChangeUserMembershipTypeMutationVariables>(ChangeUserMembershipTypeDocument, options);
      }
export type ChangeUserMembershipTypeMutationHookResult = ReturnType<typeof useChangeUserMembershipTypeMutation>;
export type ChangeUserMembershipTypeMutationResult = Apollo.MutationResult<ChangeUserMembershipTypeMutation>;
export type ChangeUserMembershipTypeMutationOptions = Apollo.BaseMutationOptions<ChangeUserMembershipTypeMutation, ChangeUserMembershipTypeMutationVariables>;
export const GetMembershipAndAccountsDocument = gql`
    query GetMembershipAndAccounts($id: uuid!) {
  membership: Membership_by_pk(Id: $id) {
    Id
    Type
    User {
      Id
      Email
      ActiveAccountId
    }
    Account {
      Id
      Name
      Memberships {
        Id
        Type
        User {
          Id
          Email
        }
      }
    }
  }
}
    `;

/**
 * __useGetMembershipAndAccountsQuery__
 *
 * To run a query within a React component, call `useGetMembershipAndAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipAndAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipAndAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipAndAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipAndAccountsQuery, GetMembershipAndAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipAndAccountsQuery, GetMembershipAndAccountsQueryVariables>(GetMembershipAndAccountsDocument, options);
      }
export function useGetMembershipAndAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipAndAccountsQuery, GetMembershipAndAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipAndAccountsQuery, GetMembershipAndAccountsQueryVariables>(GetMembershipAndAccountsDocument, options);
        }
export type GetMembershipAndAccountsQueryHookResult = ReturnType<typeof useGetMembershipAndAccountsQuery>;
export type GetMembershipAndAccountsLazyQueryHookResult = ReturnType<typeof useGetMembershipAndAccountsLazyQuery>;
export type GetMembershipAndAccountsQueryResult = Apollo.QueryResult<GetMembershipAndAccountsQuery, GetMembershipAndAccountsQueryVariables>;
export const ListAccountMembershipsAndInvitesDocument = gql`
    query listAccountMembershipsAndInvites($accountId: uuid!, $inviteExpiry: timestamp!) {
  Invite(
    where: {AccountId: {_eq: $accountId}, ExpiresAt: {_gt: $inviteExpiry}, Status: {_is_null: true}}
    order_by: [{RecipientEmail: asc}, {CreatedOn: desc}]
    distinct_on: [RecipientEmail]
  ) {
    Id
    CreatedOn
    RecipientFirstname
    RecipientLastname
    RecipientEmail
    ExpiresAt
    Status
  }
  Membership(where: {AccountId: {_eq: $accountId}}) {
    Id
    Type
    Account {
      Id
      Memberships {
        Id
        Type
        UserId
      }
    }
    User {
      Id
      CreatedOn
      FirstName
      LastName
      Email
    }
  }
}
    `;

/**
 * __useListAccountMembershipsAndInvitesQuery__
 *
 * To run a query within a React component, call `useListAccountMembershipsAndInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountMembershipsAndInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountMembershipsAndInvitesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      inviteExpiry: // value for 'inviteExpiry'
 *   },
 * });
 */
export function useListAccountMembershipsAndInvitesQuery(baseOptions: Apollo.QueryHookOptions<ListAccountMembershipsAndInvitesQuery, ListAccountMembershipsAndInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountMembershipsAndInvitesQuery, ListAccountMembershipsAndInvitesQueryVariables>(ListAccountMembershipsAndInvitesDocument, options);
      }
export function useListAccountMembershipsAndInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountMembershipsAndInvitesQuery, ListAccountMembershipsAndInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountMembershipsAndInvitesQuery, ListAccountMembershipsAndInvitesQueryVariables>(ListAccountMembershipsAndInvitesDocument, options);
        }
export type ListAccountMembershipsAndInvitesQueryHookResult = ReturnType<typeof useListAccountMembershipsAndInvitesQuery>;
export type ListAccountMembershipsAndInvitesLazyQueryHookResult = ReturnType<typeof useListAccountMembershipsAndInvitesLazyQuery>;
export type ListAccountMembershipsAndInvitesQueryResult = Apollo.QueryResult<ListAccountMembershipsAndInvitesQuery, ListAccountMembershipsAndInvitesQueryVariables>;
export const ListAccountMembershipsDocument = gql`
    query listAccountMemberships($accountId: uuid!) {
  Membership(where: {AccountId: {_eq: $accountId}}) {
    Id
    Type
    User {
      Id
      CreatedOn
      FirstName
      LastName
      Email
    }
  }
}
    `;

/**
 * __useListAccountMembershipsQuery__
 *
 * To run a query within a React component, call `useListAccountMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountMembershipsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useListAccountMembershipsQuery(baseOptions: Apollo.QueryHookOptions<ListAccountMembershipsQuery, ListAccountMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountMembershipsQuery, ListAccountMembershipsQueryVariables>(ListAccountMembershipsDocument, options);
      }
export function useListAccountMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountMembershipsQuery, ListAccountMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountMembershipsQuery, ListAccountMembershipsQueryVariables>(ListAccountMembershipsDocument, options);
        }
export type ListAccountMembershipsQueryHookResult = ReturnType<typeof useListAccountMembershipsQuery>;
export type ListAccountMembershipsLazyQueryHookResult = ReturnType<typeof useListAccountMembershipsLazyQuery>;
export type ListAccountMembershipsQueryResult = Apollo.QueryResult<ListAccountMembershipsQuery, ListAccountMembershipsQueryVariables>;
export const DeleteMembershipDocument = gql`
    mutation DeleteMembership($id: uuid!) {
  delete_Membership_by_pk(Id: $id) {
    Id
    User {
      Id
      FirstName
      LastName
    }
  }
}
    `;
export type DeleteMembershipMutationFn = Apollo.MutationFunction<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMembershipMutation, DeleteMembershipMutationVariables>(DeleteMembershipDocument, options);
      }
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<DeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>;
export const DeleteUserMembershipDocument = gql`
    mutation deleteUserMembership($input: DeleteUserMembershipInput!) {
  delete_user_membership(input: $input) {
    MembershipId
  }
}
    `;
export type DeleteUserMembershipMutationFn = Apollo.MutationFunction<DeleteUserMembershipMutation, DeleteUserMembershipMutationVariables>;

/**
 * __useDeleteUserMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteUserMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMembershipMutation, { data, loading, error }] = useDeleteUserMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMembershipMutation, DeleteUserMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMembershipMutation, DeleteUserMembershipMutationVariables>(DeleteUserMembershipDocument, options);
      }
export type DeleteUserMembershipMutationHookResult = ReturnType<typeof useDeleteUserMembershipMutation>;
export type DeleteUserMembershipMutationResult = Apollo.MutationResult<DeleteUserMembershipMutation>;
export type DeleteUserMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteUserMembershipMutation, DeleteUserMembershipMutationVariables>;
export const CreateMonitoringEventDocument = gql`
    mutation createMonitoringEvent($input: MonitoringEvent_insert_input!) {
  monitoring: insert_MonitoringEvent_one(object: $input) {
    Id
  }
}
    `;
export type CreateMonitoringEventMutationFn = Apollo.MutationFunction<CreateMonitoringEventMutation, CreateMonitoringEventMutationVariables>;

/**
 * __useCreateMonitoringEventMutation__
 *
 * To run a mutation, you first call `useCreateMonitoringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitoringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitoringEventMutation, { data, loading, error }] = useCreateMonitoringEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMonitoringEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateMonitoringEventMutation, CreateMonitoringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMonitoringEventMutation, CreateMonitoringEventMutationVariables>(CreateMonitoringEventDocument, options);
      }
export type CreateMonitoringEventMutationHookResult = ReturnType<typeof useCreateMonitoringEventMutation>;
export type CreateMonitoringEventMutationResult = Apollo.MutationResult<CreateMonitoringEventMutation>;
export type CreateMonitoringEventMutationOptions = Apollo.BaseMutationOptions<CreateMonitoringEventMutation, CreateMonitoringEventMutationVariables>;
export const GetMonitoringForApplicationWorkflowStateTransitionDocument = gql`
    query getMonitoringForApplicationWorkflowStateTransition($id: uuid!, $planterId: uuid!) {
  MonitoringEvent(where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}}) {
    Id
    Planting {
      Id
      Name
      Planter {
        Id
        Account {
          Email
          Name
        }
      }
      Application {
        Id
        Name
        WorkflowState
      }
    }
  }
}
    `;

/**
 * __useGetMonitoringForApplicationWorkflowStateTransitionQuery__
 *
 * To run a query within a React component, call `useGetMonitoringForApplicationWorkflowStateTransitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonitoringForApplicationWorkflowStateTransitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonitoringForApplicationWorkflowStateTransitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetMonitoringForApplicationWorkflowStateTransitionQuery(baseOptions: Apollo.QueryHookOptions<GetMonitoringForApplicationWorkflowStateTransitionQuery, GetMonitoringForApplicationWorkflowStateTransitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonitoringForApplicationWorkflowStateTransitionQuery, GetMonitoringForApplicationWorkflowStateTransitionQueryVariables>(GetMonitoringForApplicationWorkflowStateTransitionDocument, options);
      }
export function useGetMonitoringForApplicationWorkflowStateTransitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonitoringForApplicationWorkflowStateTransitionQuery, GetMonitoringForApplicationWorkflowStateTransitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonitoringForApplicationWorkflowStateTransitionQuery, GetMonitoringForApplicationWorkflowStateTransitionQueryVariables>(GetMonitoringForApplicationWorkflowStateTransitionDocument, options);
        }
export type GetMonitoringForApplicationWorkflowStateTransitionQueryHookResult = ReturnType<typeof useGetMonitoringForApplicationWorkflowStateTransitionQuery>;
export type GetMonitoringForApplicationWorkflowStateTransitionLazyQueryHookResult = ReturnType<typeof useGetMonitoringForApplicationWorkflowStateTransitionLazyQuery>;
export type GetMonitoringForApplicationWorkflowStateTransitionQueryResult = Apollo.QueryResult<GetMonitoringForApplicationWorkflowStateTransitionQuery, GetMonitoringForApplicationWorkflowStateTransitionQueryVariables>;
export const GetMonitoringsDocument = gql`
    query getMonitorings($plantingId: uuid!) {
  Planting_by_pk(Id: $plantingId) {
    Id
    Name
    ApplicationId
    Quantity
    WorkflowState
  }
  MonitoringEvents: MonitoringEvent(
    where: {PlantingId: {_eq: $plantingId}}
    order_by: {MonitoredOn: desc}
  ) {
    Id
    MonitoredOn
    CreatedOn
    MonitoringLines(order_by: {SurvivingTrees: desc}) {
      Id
      SurvivingTrees
      SurvivingPercent
      PlantingLineId
      SpeciesId
      PlantingLine {
        Id
        OtherSpeciesName
      }
    }
    MonitoringAssets {
      Id
      Type
      UpdatedOn
      Uri
    }
  }
}
    `;

/**
 * __useGetMonitoringsQuery__
 *
 * To run a query within a React component, call `useGetMonitoringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonitoringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonitoringsQuery({
 *   variables: {
 *      plantingId: // value for 'plantingId'
 *   },
 * });
 */
export function useGetMonitoringsQuery(baseOptions: Apollo.QueryHookOptions<GetMonitoringsQuery, GetMonitoringsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonitoringsQuery, GetMonitoringsQueryVariables>(GetMonitoringsDocument, options);
      }
export function useGetMonitoringsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonitoringsQuery, GetMonitoringsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonitoringsQuery, GetMonitoringsQueryVariables>(GetMonitoringsDocument, options);
        }
export type GetMonitoringsQueryHookResult = ReturnType<typeof useGetMonitoringsQuery>;
export type GetMonitoringsLazyQueryHookResult = ReturnType<typeof useGetMonitoringsLazyQuery>;
export type GetMonitoringsQueryResult = Apollo.QueryResult<GetMonitoringsQuery, GetMonitoringsQueryVariables>;
export const GetMonitoringEventDocument = gql`
    query getMonitoringEvent($id: uuid!) {
  MonitoringEvent(where: {Id: {_eq: $id}}) {
    Notes
    CreatedOn
    MonitoredOn
    MonitoringLines {
      Id
      HeightAverage
      Species {
        Name
      }
      SurvivingPercent
      SurvivingTrees
      PlantingLine {
        Id
        OtherSpeciesName
      }
    }
    MonitoringLines_aggregate {
      aggregate {
        sum {
          SurvivingTrees
        }
      }
    }
    MonitoringAssets {
      Id
      Uri
    }
  }
}
    `;

/**
 * __useGetMonitoringEventQuery__
 *
 * To run a query within a React component, call `useGetMonitoringEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonitoringEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonitoringEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMonitoringEventQuery(baseOptions: Apollo.QueryHookOptions<GetMonitoringEventQuery, GetMonitoringEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonitoringEventQuery, GetMonitoringEventQueryVariables>(GetMonitoringEventDocument, options);
      }
export function useGetMonitoringEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonitoringEventQuery, GetMonitoringEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonitoringEventQuery, GetMonitoringEventQueryVariables>(GetMonitoringEventDocument, options);
        }
export type GetMonitoringEventQueryHookResult = ReturnType<typeof useGetMonitoringEventQuery>;
export type GetMonitoringEventLazyQueryHookResult = ReturnType<typeof useGetMonitoringEventLazyQuery>;
export type GetMonitoringEventQueryResult = Apollo.QueryResult<GetMonitoringEventQuery, GetMonitoringEventQueryVariables>;
export const CreatePlanterRegistrationDocument = gql`
    mutation createPlanterRegistration($input: CreatePlanterRegistrationInsertInput!) {
  create_planter_registration(input: $input) {
    Id
    PlanterRegistration {
      Id
      Planter {
        Id
        Account {
          Id
        }
      }
    }
  }
}
    `;
export type CreatePlanterRegistrationMutationFn = Apollo.MutationFunction<CreatePlanterRegistrationMutation, CreatePlanterRegistrationMutationVariables>;

/**
 * __useCreatePlanterRegistrationMutation__
 *
 * To run a mutation, you first call `useCreatePlanterRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanterRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanterRegistrationMutation, { data, loading, error }] = useCreatePlanterRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanterRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanterRegistrationMutation, CreatePlanterRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanterRegistrationMutation, CreatePlanterRegistrationMutationVariables>(CreatePlanterRegistrationDocument, options);
      }
export type CreatePlanterRegistrationMutationHookResult = ReturnType<typeof useCreatePlanterRegistrationMutation>;
export type CreatePlanterRegistrationMutationResult = Apollo.MutationResult<CreatePlanterRegistrationMutation>;
export type CreatePlanterRegistrationMutationOptions = Apollo.BaseMutationOptions<CreatePlanterRegistrationMutation, CreatePlanterRegistrationMutationVariables>;
export const UpdatePlanterRegistrationDocument = gql`
    mutation updatePlanterRegistration($id: uuid!, $input: PlanterRegistration_set_input) {
  update_PlanterRegistration_by_pk(pk_columns: {Id: $id}, _set: $input) {
    Id
    Planter {
      Id
      Account {
        Id
      }
    }
  }
}
    `;
export type UpdatePlanterRegistrationMutationFn = Apollo.MutationFunction<UpdatePlanterRegistrationMutation, UpdatePlanterRegistrationMutationVariables>;

/**
 * __useUpdatePlanterRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdatePlanterRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanterRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanterRegistrationMutation, { data, loading, error }] = useUpdatePlanterRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanterRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanterRegistrationMutation, UpdatePlanterRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanterRegistrationMutation, UpdatePlanterRegistrationMutationVariables>(UpdatePlanterRegistrationDocument, options);
      }
export type UpdatePlanterRegistrationMutationHookResult = ReturnType<typeof useUpdatePlanterRegistrationMutation>;
export type UpdatePlanterRegistrationMutationResult = Apollo.MutationResult<UpdatePlanterRegistrationMutation>;
export type UpdatePlanterRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdatePlanterRegistrationMutation, UpdatePlanterRegistrationMutationVariables>;
export const InsertPlanterRegistrationDocument = gql`
    mutation insertPlanterRegistration($input: PlanterRegistration_insert_input!) {
  insert_PlanterRegistration_one(object: $input) {
    Id
    Planter {
      Id
      Account {
        Id
      }
    }
  }
}
    `;
export type InsertPlanterRegistrationMutationFn = Apollo.MutationFunction<InsertPlanterRegistrationMutation, InsertPlanterRegistrationMutationVariables>;

/**
 * __useInsertPlanterRegistrationMutation__
 *
 * To run a mutation, you first call `useInsertPlanterRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlanterRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlanterRegistrationMutation, { data, loading, error }] = useInsertPlanterRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertPlanterRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlanterRegistrationMutation, InsertPlanterRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlanterRegistrationMutation, InsertPlanterRegistrationMutationVariables>(InsertPlanterRegistrationDocument, options);
      }
export type InsertPlanterRegistrationMutationHookResult = ReturnType<typeof useInsertPlanterRegistrationMutation>;
export type InsertPlanterRegistrationMutationResult = Apollo.MutationResult<InsertPlanterRegistrationMutation>;
export type InsertPlanterRegistrationMutationOptions = Apollo.BaseMutationOptions<InsertPlanterRegistrationMutation, InsertPlanterRegistrationMutationVariables>;
export const GetPlanterRegistrationDocument = gql`
    query getPlanterRegistration($id: uuid!) {
  planterRegistration: PlanterRegistration_by_pk(Id: $id) {
    Id
    CreatedOn
    PlanterRegistrationAssets {
      Id
      Type
      UpdatedOn
      Uri
      FileName
    }
    NumberOfYears
    NumberOfTrees
    Description
    Locations
    MonitoringDescription
    WorkflowState
  }
}
    `;

/**
 * __useGetPlanterRegistrationQuery__
 *
 * To run a query within a React component, call `useGetPlanterRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanterRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanterRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanterRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetPlanterRegistrationQuery, GetPlanterRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanterRegistrationQuery, GetPlanterRegistrationQueryVariables>(GetPlanterRegistrationDocument, options);
      }
export function useGetPlanterRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanterRegistrationQuery, GetPlanterRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanterRegistrationQuery, GetPlanterRegistrationQueryVariables>(GetPlanterRegistrationDocument, options);
        }
export type GetPlanterRegistrationQueryHookResult = ReturnType<typeof useGetPlanterRegistrationQuery>;
export type GetPlanterRegistrationLazyQueryHookResult = ReturnType<typeof useGetPlanterRegistrationLazyQuery>;
export type GetPlanterRegistrationQueryResult = Apollo.QueryResult<GetPlanterRegistrationQuery, GetPlanterRegistrationQueryVariables>;
export const GetAccountPlanterRegistrationDocument = gql`
    query getAccountPlanterRegistration($planterId: uuid!) {
  planterRegistration: PlanterRegistration(where: {PlanterId: {_eq: $planterId}}) {
    Id
    CreatedOn
    PlanterRegistrationAssets {
      Id
      Type
      UpdatedOn
      Uri
      FileName
    }
    NumberOfYears
    NumberOfTrees
    Description
    Locations
    MonitoringDescription
    WorkflowState
  }
}
    `;

/**
 * __useGetAccountPlanterRegistrationQuery__
 *
 * To run a query within a React component, call `useGetAccountPlanterRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPlanterRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPlanterRegistrationQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetAccountPlanterRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetAccountPlanterRegistrationQuery, GetAccountPlanterRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountPlanterRegistrationQuery, GetAccountPlanterRegistrationQueryVariables>(GetAccountPlanterRegistrationDocument, options);
      }
export function useGetAccountPlanterRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountPlanterRegistrationQuery, GetAccountPlanterRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountPlanterRegistrationQuery, GetAccountPlanterRegistrationQueryVariables>(GetAccountPlanterRegistrationDocument, options);
        }
export type GetAccountPlanterRegistrationQueryHookResult = ReturnType<typeof useGetAccountPlanterRegistrationQuery>;
export type GetAccountPlanterRegistrationLazyQueryHookResult = ReturnType<typeof useGetAccountPlanterRegistrationLazyQuery>;
export type GetAccountPlanterRegistrationQueryResult = Apollo.QueryResult<GetAccountPlanterRegistrationQuery, GetAccountPlanterRegistrationQueryVariables>;
export const GetPlanterStatsDocument = gql`
    query GetPlanterStats($accountId: uuid!) {
  PublicPlanterStatsForAccount(
    args: {AccountId: $accountId}
    order_by: {SeasonName: asc}
  ) {
    Rank
    SeasonName
    TreesApproved
  }
}
    `;

/**
 * __useGetPlanterStatsQuery__
 *
 * To run a query within a React component, call `useGetPlanterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanterStatsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetPlanterStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlanterStatsQuery, GetPlanterStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanterStatsQuery, GetPlanterStatsQueryVariables>(GetPlanterStatsDocument, options);
      }
export function useGetPlanterStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanterStatsQuery, GetPlanterStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanterStatsQuery, GetPlanterStatsQueryVariables>(GetPlanterStatsDocument, options);
        }
export type GetPlanterStatsQueryHookResult = ReturnType<typeof useGetPlanterStatsQuery>;
export type GetPlanterStatsLazyQueryHookResult = ReturnType<typeof useGetPlanterStatsLazyQuery>;
export type GetPlanterStatsQueryResult = Apollo.QueryResult<GetPlanterStatsQuery, GetPlanterStatsQueryVariables>;
export const GetPlanterSupportStatsDocument = gql`
    query GetPlanterSupportStats($planterId: uuid!, $offset: Int!, $limit: Int = 12) {
  Funder_aggregate(
    where: {Instruction: {Matches: {Application: {PlanterId: {_eq: $planterId}}}}}
    distinct_on: Id
  ) {
    aggregate {
      count
    }
  }
  Funder(
    where: {Instruction: {Matches: {Application: {PlanterId: {_eq: $planterId}}}}}
    offset: $offset
    limit: $limit
    distinct_on: Id
  ) {
    Account {
      Id
      Avatar
      Name
      Uri
    }
  }
}
    `;

/**
 * __useGetPlanterSupportStatsQuery__
 *
 * To run a query within a React component, call `useGetPlanterSupportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanterSupportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanterSupportStatsQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPlanterSupportStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlanterSupportStatsQuery, GetPlanterSupportStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanterSupportStatsQuery, GetPlanterSupportStatsQueryVariables>(GetPlanterSupportStatsDocument, options);
      }
export function useGetPlanterSupportStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanterSupportStatsQuery, GetPlanterSupportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanterSupportStatsQuery, GetPlanterSupportStatsQueryVariables>(GetPlanterSupportStatsDocument, options);
        }
export type GetPlanterSupportStatsQueryHookResult = ReturnType<typeof useGetPlanterSupportStatsQuery>;
export type GetPlanterSupportStatsLazyQueryHookResult = ReturnType<typeof useGetPlanterSupportStatsLazyQuery>;
export type GetPlanterSupportStatsQueryResult = Apollo.QueryResult<GetPlanterSupportStatsQuery, GetPlanterSupportStatsQueryVariables>;
export const GetAdminPlanterRegistrationDocument = gql`
    query getAdminPlanterRegistration($Id: uuid!) {
  Account_by_pk(Id: $Id) {
    Id
    Name
    Uri
    Planter {
      PlanterRegistrations {
        Id
        NumberOfTrees
        NumberOfYears
        Description
        MonitoringDescription
        Locations
        CreatedOn
        WorkflowState
        PlanterRegistrationAssets {
          Id
          Type
          UpdatedOn
          Uri
          FileName
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdminPlanterRegistrationQuery__
 *
 * To run a query within a React component, call `useGetAdminPlanterRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPlanterRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPlanterRegistrationQuery({
 *   variables: {
 *      Id: // value for 'Id'
 *   },
 * });
 */
export function useGetAdminPlanterRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetAdminPlanterRegistrationQuery, GetAdminPlanterRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminPlanterRegistrationQuery, GetAdminPlanterRegistrationQueryVariables>(GetAdminPlanterRegistrationDocument, options);
      }
export function useGetAdminPlanterRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPlanterRegistrationQuery, GetAdminPlanterRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminPlanterRegistrationQuery, GetAdminPlanterRegistrationQueryVariables>(GetAdminPlanterRegistrationDocument, options);
        }
export type GetAdminPlanterRegistrationQueryHookResult = ReturnType<typeof useGetAdminPlanterRegistrationQuery>;
export type GetAdminPlanterRegistrationLazyQueryHookResult = ReturnType<typeof useGetAdminPlanterRegistrationLazyQuery>;
export type GetAdminPlanterRegistrationQueryResult = Apollo.QueryResult<GetAdminPlanterRegistrationQuery, GetAdminPlanterRegistrationQueryVariables>;
export const CreatePlantingSiteDocument = gql`
    mutation createPlantingSite($object: PlantingSite_insert_input!) {
  insert_PlantingSite_one(object: $object) {
    Id
  }
}
    `;
export type CreatePlantingSiteMutationFn = Apollo.MutationFunction<CreatePlantingSiteMutation, CreatePlantingSiteMutationVariables>;

/**
 * __useCreatePlantingSiteMutation__
 *
 * To run a mutation, you first call `useCreatePlantingSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantingSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantingSiteMutation, { data, loading, error }] = useCreatePlantingSiteMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreatePlantingSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantingSiteMutation, CreatePlantingSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantingSiteMutation, CreatePlantingSiteMutationVariables>(CreatePlantingSiteDocument, options);
      }
export type CreatePlantingSiteMutationHookResult = ReturnType<typeof useCreatePlantingSiteMutation>;
export type CreatePlantingSiteMutationResult = Apollo.MutationResult<CreatePlantingSiteMutation>;
export type CreatePlantingSiteMutationOptions = Apollo.BaseMutationOptions<CreatePlantingSiteMutation, CreatePlantingSiteMutationVariables>;
export const UpdatePlantingSiteDocument = gql`
    mutation updatePlantingSite($pkColumns: PlantingSite_pk_columns_input!, $set: PlantingSite_set_input) {
  update_PlantingSite_by_pk(pk_columns: $pkColumns, _set: $set) {
    Id
  }
}
    `;
export type UpdatePlantingSiteMutationFn = Apollo.MutationFunction<UpdatePlantingSiteMutation, UpdatePlantingSiteMutationVariables>;

/**
 * __useUpdatePlantingSiteMutation__
 *
 * To run a mutation, you first call `useUpdatePlantingSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlantingSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlantingSiteMutation, { data, loading, error }] = useUpdatePlantingSiteMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePlantingSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlantingSiteMutation, UpdatePlantingSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlantingSiteMutation, UpdatePlantingSiteMutationVariables>(UpdatePlantingSiteDocument, options);
      }
export type UpdatePlantingSiteMutationHookResult = ReturnType<typeof useUpdatePlantingSiteMutation>;
export type UpdatePlantingSiteMutationResult = Apollo.MutationResult<UpdatePlantingSiteMutation>;
export type UpdatePlantingSiteMutationOptions = Apollo.BaseMutationOptions<UpdatePlantingSiteMutation, UpdatePlantingSiteMutationVariables>;
export const GetPlantingDocument = gql`
    query getPlanting($id: uuid!, $planterId: uuid!) {
  Planting(where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}}) {
    Id
    ApplicationId
    Application {
      Id
      Reference
    }
    Area
    CreatedOn
    Geo
    LandOwnership
    LandUse
    Location
    Name
    Quantity
    Spacing
    PlantingAssets {
      Id
      Type
      UpdatedOn
      Uri
    }
    Reference
    DistrictId
    District {
      Name
    }
    Planter {
      Id
      Name
      Account {
        Id
      }
    }
    PlantingLines {
      Id
      Quantity
      SpeciesId
      OtherSpeciesName
      Species {
        Id
        Name
      }
    }
    RegionId
    Region {
      Name
    }
    SeasonId
    Season {
      Name
    }
    SubmittedOn
    WorkflowState
    VolunteerCount
    MonitoringEvents(order_by: {MonitoredOn: desc}) {
      Id
      MonitoredOn
      MonitoringAssets {
        Id
        UpdatedOn
        Uri
        Type
      }
      MonitoringLines(order_by: {SurvivingTrees: desc}) {
        Id
        SurvivingTrees
        SurvivingPercent
        PlantingLineId
        SpeciesId
      }
    }
  }
}
    `;

/**
 * __useGetPlantingQuery__
 *
 * To run a query within a React component, call `useGetPlantingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetPlantingQuery(baseOptions: Apollo.QueryHookOptions<GetPlantingQuery, GetPlantingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantingQuery, GetPlantingQueryVariables>(GetPlantingDocument, options);
      }
export function useGetPlantingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantingQuery, GetPlantingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantingQuery, GetPlantingQueryVariables>(GetPlantingDocument, options);
        }
export type GetPlantingQueryHookResult = ReturnType<typeof useGetPlantingQuery>;
export type GetPlantingLazyQueryHookResult = ReturnType<typeof useGetPlantingLazyQuery>;
export type GetPlantingQueryResult = Apollo.QueryResult<GetPlantingQuery, GetPlantingQueryVariables>;
export const ListOrphanedPlantingsDocument = gql`
    query listOrphanedPlantings($planterId: uuid!, $limit: Int!, $offset: Int!) {
  Application_aggregate {
    aggregate {
      count
    }
  }
  Planting_aggregate(
    where: {ApplicationId: {_is_null: true}, PlanterId: {_eq: $planterId}}
  ) {
    aggregate {
      count
    }
  }
  Planting(
    limit: $limit
    offset: $offset
    order_by: {CreatedOn: desc}
    where: {ApplicationId: {_is_null: true}, PlanterId: {_eq: $planterId}}
  ) {
    Id
    CreatedOn
    Name
    Reference
    Region {
      Id
      Name
    }
    Season {
      Id
      Name
    }
    District {
      Id
      Name
    }
    Quantity
  }
}
    `;

/**
 * __useListOrphanedPlantingsQuery__
 *
 * To run a query within a React component, call `useListOrphanedPlantingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrphanedPlantingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrphanedPlantingsQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListOrphanedPlantingsQuery(baseOptions: Apollo.QueryHookOptions<ListOrphanedPlantingsQuery, ListOrphanedPlantingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrphanedPlantingsQuery, ListOrphanedPlantingsQueryVariables>(ListOrphanedPlantingsDocument, options);
      }
export function useListOrphanedPlantingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrphanedPlantingsQuery, ListOrphanedPlantingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrphanedPlantingsQuery, ListOrphanedPlantingsQueryVariables>(ListOrphanedPlantingsDocument, options);
        }
export type ListOrphanedPlantingsQueryHookResult = ReturnType<typeof useListOrphanedPlantingsQuery>;
export type ListOrphanedPlantingsLazyQueryHookResult = ReturnType<typeof useListOrphanedPlantingsLazyQuery>;
export type ListOrphanedPlantingsQueryResult = Apollo.QueryResult<ListOrphanedPlantingsQuery, ListOrphanedPlantingsQueryVariables>;
export const CreatePlantingDocument = gql`
    mutation createPlanting($input: CreatePlantingInput!) {
  planting: create_planting(input: $input) {
    Planting {
      Id
    }
  }
}
    `;
export type CreatePlantingMutationFn = Apollo.MutationFunction<CreatePlantingMutation, CreatePlantingMutationVariables>;

/**
 * __useCreatePlantingMutation__
 *
 * To run a mutation, you first call `useCreatePlantingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantingMutation, { data, loading, error }] = useCreatePlantingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlantingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantingMutation, CreatePlantingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantingMutation, CreatePlantingMutationVariables>(CreatePlantingDocument, options);
      }
export type CreatePlantingMutationHookResult = ReturnType<typeof useCreatePlantingMutation>;
export type CreatePlantingMutationResult = Apollo.MutationResult<CreatePlantingMutation>;
export type CreatePlantingMutationOptions = Apollo.BaseMutationOptions<CreatePlantingMutation, CreatePlantingMutationVariables>;
export const UpdatePlantingDocument = gql`
    mutation updatePlanting($input: UpdatePlantingInput!) {
  planting: validate_and_update_planting(input: $input) {
    Id
  }
}
    `;
export type UpdatePlantingMutationFn = Apollo.MutationFunction<UpdatePlantingMutation, UpdatePlantingMutationVariables>;

/**
 * __useUpdatePlantingMutation__
 *
 * To run a mutation, you first call `useUpdatePlantingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlantingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlantingMutation, { data, loading, error }] = useUpdatePlantingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlantingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlantingMutation, UpdatePlantingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlantingMutation, UpdatePlantingMutationVariables>(UpdatePlantingDocument, options);
      }
export type UpdatePlantingMutationHookResult = ReturnType<typeof useUpdatePlantingMutation>;
export type UpdatePlantingMutationResult = Apollo.MutationResult<UpdatePlantingMutation>;
export type UpdatePlantingMutationOptions = Apollo.BaseMutationOptions<UpdatePlantingMutation, UpdatePlantingMutationVariables>;
export const GetAdminPlantingDocument = gql`
    query getAdminPlanting($id: uuid!) {
  Planting: Planting_by_pk(Id: $id) {
    Id
    ApplicationId
    Application {
      Id
      Reference
    }
    Area
    CreatedOn
    Geo
    LandOwnership
    LandUse
    Location
    Name
    Quantity
    Spacing
    SubmittedOn
    WorkflowState
    PlantingAssets {
      Id
      Type
      UpdatedOn
      Uri
    }
    Reference
    DistrictId
    District {
      Name
    }
    Planter {
      Id
      Name
      Account {
        Id
      }
    }
    PlantingLines {
      Id
      Quantity
      SpeciesId
      OtherSpeciesName
      Species {
        Id
        Name
      }
    }
    RegionId
    Region {
      Name
    }
    SeasonId
    Season {
      Name
    }
    MonitoringEvents(order_by: {MonitoredOn: desc}) {
      Action
      CreatedOn
      Id
      MonitoredOn
      Notes
      PlanterId
      PlantingId
      SampleId
      Type
      UpdatedOn
      MonitoringAssets {
        Id
        UpdatedOn
        Uri
        Type
      }
      MonitoringLines(order_by: {SurvivingTrees: desc}) {
        Id
        SurvivingTrees
        SurvivingPercent
        PlantingLineId
        SpeciesId
      }
    }
    VolunteerCount
  }
}
    `;

/**
 * __useGetAdminPlantingQuery__
 *
 * To run a query within a React component, call `useGetAdminPlantingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPlantingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPlantingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminPlantingQuery(baseOptions: Apollo.QueryHookOptions<GetAdminPlantingQuery, GetAdminPlantingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminPlantingQuery, GetAdminPlantingQueryVariables>(GetAdminPlantingDocument, options);
      }
export function useGetAdminPlantingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPlantingQuery, GetAdminPlantingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminPlantingQuery, GetAdminPlantingQueryVariables>(GetAdminPlantingDocument, options);
        }
export type GetAdminPlantingQueryHookResult = ReturnType<typeof useGetAdminPlantingQuery>;
export type GetAdminPlantingLazyQueryHookResult = ReturnType<typeof useGetAdminPlantingLazyQuery>;
export type GetAdminPlantingQueryResult = Apollo.QueryResult<GetAdminPlantingQuery, GetAdminPlantingQueryVariables>;
export const GetPlantingForApplicationWorkflowStateTransitionDocument = gql`
    query getPlantingForApplicationWorkflowStateTransition($id: uuid!, $planterId: uuid!) {
  Planting(where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}}) {
    Id
    WorkflowState
    Quantity
    Name
    Planter {
      Account {
        Email
        Name
      }
    }
    Application {
      Id
      WorkflowState
    }
  }
}
    `;

/**
 * __useGetPlantingForApplicationWorkflowStateTransitionQuery__
 *
 * To run a query within a React component, call `useGetPlantingForApplicationWorkflowStateTransitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantingForApplicationWorkflowStateTransitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantingForApplicationWorkflowStateTransitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetPlantingForApplicationWorkflowStateTransitionQuery(baseOptions: Apollo.QueryHookOptions<GetPlantingForApplicationWorkflowStateTransitionQuery, GetPlantingForApplicationWorkflowStateTransitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantingForApplicationWorkflowStateTransitionQuery, GetPlantingForApplicationWorkflowStateTransitionQueryVariables>(GetPlantingForApplicationWorkflowStateTransitionDocument, options);
      }
export function useGetPlantingForApplicationWorkflowStateTransitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantingForApplicationWorkflowStateTransitionQuery, GetPlantingForApplicationWorkflowStateTransitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantingForApplicationWorkflowStateTransitionQuery, GetPlantingForApplicationWorkflowStateTransitionQueryVariables>(GetPlantingForApplicationWorkflowStateTransitionDocument, options);
        }
export type GetPlantingForApplicationWorkflowStateTransitionQueryHookResult = ReturnType<typeof useGetPlantingForApplicationWorkflowStateTransitionQuery>;
export type GetPlantingForApplicationWorkflowStateTransitionLazyQueryHookResult = ReturnType<typeof useGetPlantingForApplicationWorkflowStateTransitionLazyQuery>;
export type GetPlantingForApplicationWorkflowStateTransitionQueryResult = Apollo.QueryResult<GetPlantingForApplicationWorkflowStateTransitionQuery, GetPlantingForApplicationWorkflowStateTransitionQueryVariables>;
export const DeletePlantingDocument = gql`
    mutation deletePlanting($id: uuid!) {
  delete_PlantingAsset(where: {PlantingId: {_eq: $id}}) {
    affected_rows
  }
  delete_PlantingLine(where: {PlantingId: {_eq: $id}}) {
    affected_rows
  }
  delete_Planting_by_pk(Id: $id) {
    Id
  }
}
    `;
export type DeletePlantingMutationFn = Apollo.MutationFunction<DeletePlantingMutation, DeletePlantingMutationVariables>;

/**
 * __useDeletePlantingMutation__
 *
 * To run a mutation, you first call `useDeletePlantingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlantingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlantingMutation, { data, loading, error }] = useDeletePlantingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlantingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlantingMutation, DeletePlantingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlantingMutation, DeletePlantingMutationVariables>(DeletePlantingDocument, options);
      }
export type DeletePlantingMutationHookResult = ReturnType<typeof useDeletePlantingMutation>;
export type DeletePlantingMutationResult = Apollo.MutationResult<DeletePlantingMutation>;
export type DeletePlantingMutationOptions = Apollo.BaseMutationOptions<DeletePlantingMutation, DeletePlantingMutationVariables>;
export const ListProjectPlantingsDocument = gql`
    query listProjectPlantings($projectId: uuid!, $orderBy: [Planting_order_by!]) {
  plantings: Planting(
    where: {Application: {ProjectId: {_eq: $projectId}}}
    order_by: $orderBy
  ) {
    Id
    SubmittedOn
    WorkflowState
    Name
    Application {
      Id
      Reference
      Name
    }
    MonitoringEvents_aggregate {
      aggregate {
        count
      }
    }
    Quantity
    Season {
      Name
    }
  }
}
    `;

/**
 * __useListProjectPlantingsQuery__
 *
 * To run a query within a React component, call `useListProjectPlantingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectPlantingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectPlantingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListProjectPlantingsQuery(baseOptions: Apollo.QueryHookOptions<ListProjectPlantingsQuery, ListProjectPlantingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectPlantingsQuery, ListProjectPlantingsQueryVariables>(ListProjectPlantingsDocument, options);
      }
export function useListProjectPlantingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectPlantingsQuery, ListProjectPlantingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectPlantingsQuery, ListProjectPlantingsQueryVariables>(ListProjectPlantingsDocument, options);
        }
export type ListProjectPlantingsQueryHookResult = ReturnType<typeof useListProjectPlantingsQuery>;
export type ListProjectPlantingsLazyQueryHookResult = ReturnType<typeof useListProjectPlantingsLazyQuery>;
export type ListProjectPlantingsQueryResult = Apollo.QueryResult<ListProjectPlantingsQuery, ListProjectPlantingsQueryVariables>;
export const GetAdminApplicationPlantingReportsDocument = gql`
    query getAdminApplicationPlantingReports($applicationId: uuid!, $limit: Int, $offset: Int, $orderBy: [Planting_order_by!]) {
  Planting(
    where: {ApplicationId: {_eq: $applicationId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    Id
    Area
    ApplicationId
    CreatedOn
    District {
      Id
      Name
    }
    Geo
    LandOwnership
    LandUse
    Location
    Name
    MonitoringEvents(order_by: {MonitoredOn: desc}) {
      Id
      MonitoredOn
      MonitoringLines(order_by: {SurvivingTrees: desc}) {
        Id
        SurvivingTrees
        SurvivingPercent
        PlantingLineId
        SpeciesId
      }
    }
    Reference
    Planter {
      Name
    }
    PlantingLines(order_by: {Quantity: desc}) {
      Id
      Quantity
      OtherSpeciesName
      Species {
        Id
        Name
      }
    }
    PlantingAssets {
      Id
      Type
      UpdatedOn
      Uri
    }
    Quantity
    Reference
    Region {
      Id
      Name
    }
    Season {
      Id
      Name
    }
    Spacing
    VolunteerCount
    WorkflowState
  }
}
    `;

/**
 * __useGetAdminApplicationPlantingReportsQuery__
 *
 * To run a query within a React component, call `useGetAdminApplicationPlantingReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminApplicationPlantingReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminApplicationPlantingReportsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAdminApplicationPlantingReportsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminApplicationPlantingReportsQuery, GetAdminApplicationPlantingReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminApplicationPlantingReportsQuery, GetAdminApplicationPlantingReportsQueryVariables>(GetAdminApplicationPlantingReportsDocument, options);
      }
export function useGetAdminApplicationPlantingReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminApplicationPlantingReportsQuery, GetAdminApplicationPlantingReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminApplicationPlantingReportsQuery, GetAdminApplicationPlantingReportsQueryVariables>(GetAdminApplicationPlantingReportsDocument, options);
        }
export type GetAdminApplicationPlantingReportsQueryHookResult = ReturnType<typeof useGetAdminApplicationPlantingReportsQuery>;
export type GetAdminApplicationPlantingReportsLazyQueryHookResult = ReturnType<typeof useGetAdminApplicationPlantingReportsLazyQuery>;
export type GetAdminApplicationPlantingReportsQueryResult = Apollo.QueryResult<GetAdminApplicationPlantingReportsQuery, GetAdminApplicationPlantingReportsQueryVariables>;
export const GetProductAndPricesDocument = gql`
    query getProductAndPrices($quantity: bigint!) {
  Product(where: {IsArchived: {_eq: false}}, limit: 1) {
    Id
    Name
    ProductPrices(
      limit: 1
      where: {_and: [{IsArchived: {_eq: false}}, {VolumeMin: {_lte: $quantity}}, {_or: [{VolumeMax: {_gte: $quantity}}, {VolumeMax: {_is_null: true}}]}]}
    ) {
      Id
      Amount
    }
  }
}
    `;

/**
 * __useGetProductAndPricesQuery__
 *
 * To run a query within a React component, call `useGetProductAndPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAndPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAndPricesQuery({
 *   variables: {
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useGetProductAndPricesQuery(baseOptions: Apollo.QueryHookOptions<GetProductAndPricesQuery, GetProductAndPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAndPricesQuery, GetProductAndPricesQueryVariables>(GetProductAndPricesDocument, options);
      }
export function useGetProductAndPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAndPricesQuery, GetProductAndPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAndPricesQuery, GetProductAndPricesQueryVariables>(GetProductAndPricesDocument, options);
        }
export type GetProductAndPricesQueryHookResult = ReturnType<typeof useGetProductAndPricesQuery>;
export type GetProductAndPricesLazyQueryHookResult = ReturnType<typeof useGetProductAndPricesLazyQuery>;
export type GetProductAndPricesQueryResult = Apollo.QueryResult<GetProductAndPricesQuery, GetProductAndPricesQueryVariables>;
export const GetAllProductAndPricesDocument = gql`
    query getAllProductAndPrices {
  Product(where: {IsArchived: {_eq: false}}, limit: 1) {
    Id
    Name
    ProductPrices(where: {IsArchived: {_eq: false}}) {
      Id
      Amount
      VolumeMin
      VolumeMax
    }
  }
}
    `;

/**
 * __useGetAllProductAndPricesQuery__
 *
 * To run a query within a React component, call `useGetAllProductAndPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductAndPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductAndPricesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductAndPricesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductAndPricesQuery, GetAllProductAndPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductAndPricesQuery, GetAllProductAndPricesQueryVariables>(GetAllProductAndPricesDocument, options);
      }
export function useGetAllProductAndPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductAndPricesQuery, GetAllProductAndPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductAndPricesQuery, GetAllProductAndPricesQueryVariables>(GetAllProductAndPricesDocument, options);
        }
export type GetAllProductAndPricesQueryHookResult = ReturnType<typeof useGetAllProductAndPricesQuery>;
export type GetAllProductAndPricesLazyQueryHookResult = ReturnType<typeof useGetAllProductAndPricesLazyQuery>;
export type GetAllProductAndPricesQueryResult = Apollo.QueryResult<GetAllProductAndPricesQuery, GetAllProductAndPricesQueryVariables>;
export const GetAccountProjectsDocument = gql`
    query getAccountProjects($planterId: uuid!) {
  Project(where: {PlanterId: {_eq: $planterId}}) {
    Name
    Id
    Description
    Area
    PlantingTimeframes
    ReceivedFundingPreviously
    NumberOfTreesFundedPreviously
    ProjectAssets {
      Uri
      Type
      UpdatedOn
      CreatedOn
      Id
    }
  }
}
    `;

/**
 * __useGetAccountProjectsQuery__
 *
 * To run a query within a React component, call `useGetAccountProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountProjectsQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetAccountProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>(GetAccountProjectsDocument, options);
      }
export function useGetAccountProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>(GetAccountProjectsDocument, options);
        }
export type GetAccountProjectsQueryHookResult = ReturnType<typeof useGetAccountProjectsQuery>;
export type GetAccountProjectsLazyQueryHookResult = ReturnType<typeof useGetAccountProjectsLazyQuery>;
export type GetAccountProjectsQueryResult = Apollo.QueryResult<GetAccountProjectsQuery, GetAccountProjectsQueryVariables>;
export const GetSupportedProjectsDocument = gql`
    query getSupportedProjects($offset: Int!, $limit: Int = 10, $orderBy: [SupportedProjectsView_order_by!], $where: SupportedProjectsView_bool_exp) {
  SupportedProjectsView_aggregate(where: $where, distinct_on: ProjectId) {
    aggregate {
      count
    }
  }
  SupportedProjectsView(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    FunderId
    ProjectId
    SeasonId
    Quantity
    Name
    Uri
    Hero
    Area
    Purpose
    PublicPage
    SeasonName
    Region {
      Name
      AltName
      Lat
    }
  }
}
    `;

/**
 * __useGetSupportedProjectsQuery__
 *
 * To run a query within a React component, call `useGetSupportedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedProjectsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSupportedProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetSupportedProjectsQuery, GetSupportedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedProjectsQuery, GetSupportedProjectsQueryVariables>(GetSupportedProjectsDocument, options);
      }
export function useGetSupportedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedProjectsQuery, GetSupportedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedProjectsQuery, GetSupportedProjectsQueryVariables>(GetSupportedProjectsDocument, options);
        }
export type GetSupportedProjectsQueryHookResult = ReturnType<typeof useGetSupportedProjectsQuery>;
export type GetSupportedProjectsLazyQueryHookResult = ReturnType<typeof useGetSupportedProjectsLazyQuery>;
export type GetSupportedProjectsQueryResult = Apollo.QueryResult<GetSupportedProjectsQuery, GetSupportedProjectsQueryVariables>;
export const UpdateAdminProjectDocument = gql`
    mutation updateAdminProject($projectId: uuid!, $input: Project_set_input!) {
  project: update_Project_by_pk(pk_columns: {Id: $projectId}, _set: $input) {
    Id
  }
}
    `;
export type UpdateAdminProjectMutationFn = Apollo.MutationFunction<UpdateAdminProjectMutation, UpdateAdminProjectMutationVariables>;

/**
 * __useUpdateAdminProjectMutation__
 *
 * To run a mutation, you first call `useUpdateAdminProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminProjectMutation, { data, loading, error }] = useUpdateAdminProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminProjectMutation, UpdateAdminProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminProjectMutation, UpdateAdminProjectMutationVariables>(UpdateAdminProjectDocument, options);
      }
export type UpdateAdminProjectMutationHookResult = ReturnType<typeof useUpdateAdminProjectMutation>;
export type UpdateAdminProjectMutationResult = Apollo.MutationResult<UpdateAdminProjectMutation>;
export type UpdateAdminProjectMutationOptions = Apollo.BaseMutationOptions<UpdateAdminProjectMutation, UpdateAdminProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($input: UpdatePlanterProjectInput!) {
  update_planter_project(input: $input) {
    Id
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateAdminProjectDocument = gql`
    mutation createAdminProject($input: Project_insert_input!) {
  project: insert_Project_one(object: $input) {
    Id
  }
}
    `;
export type CreateAdminProjectMutationFn = Apollo.MutationFunction<CreateAdminProjectMutation, CreateAdminProjectMutationVariables>;

/**
 * __useCreateAdminProjectMutation__
 *
 * To run a mutation, you first call `useCreateAdminProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminProjectMutation, { data, loading, error }] = useCreateAdminProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminProjectMutation, CreateAdminProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminProjectMutation, CreateAdminProjectMutationVariables>(CreateAdminProjectDocument, options);
      }
export type CreateAdminProjectMutationHookResult = ReturnType<typeof useCreateAdminProjectMutation>;
export type CreateAdminProjectMutationResult = Apollo.MutationResult<CreateAdminProjectMutation>;
export type CreateAdminProjectMutationOptions = Apollo.BaseMutationOptions<CreateAdminProjectMutation, CreateAdminProjectMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($input: CreateProjectInput!) {
  create_project(input: $input) {
    Id
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const GetProjectsByUrisDocument = gql`
    query getProjectsByUris($uris: [String!]!) {
  Project(where: {Uri: {_in: $uris}, IsPublic: {_eq: true}}) {
    Id
    Name
    Uri
    Area
    Description
    District {
      Id
      Name
    }
    Region {
      Id
      Name
    }
    Hero
    OpenFrom
    OpenTo
    Planter {
      Account {
        Avatar
        Id
        Name
      }
    }
    WebsiteLinks
    NumberOfProperties
    LandUse
    LandUseOther
    OtherLandArea
    CreatedOn
  }
}
    `;

/**
 * __useGetProjectsByUrisQuery__
 *
 * To run a query within a React component, call `useGetProjectsByUrisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByUrisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByUrisQuery({
 *   variables: {
 *      uris: // value for 'uris'
 *   },
 * });
 */
export function useGetProjectsByUrisQuery(baseOptions: Apollo.QueryHookOptions<GetProjectsByUrisQuery, GetProjectsByUrisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsByUrisQuery, GetProjectsByUrisQueryVariables>(GetProjectsByUrisDocument, options);
      }
export function useGetProjectsByUrisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsByUrisQuery, GetProjectsByUrisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsByUrisQuery, GetProjectsByUrisQueryVariables>(GetProjectsByUrisDocument, options);
        }
export type GetProjectsByUrisQueryHookResult = ReturnType<typeof useGetProjectsByUrisQuery>;
export type GetProjectsByUrisLazyQueryHookResult = ReturnType<typeof useGetProjectsByUrisLazyQuery>;
export type GetProjectsByUrisQueryResult = Apollo.QueryResult<GetProjectsByUrisQuery, GetProjectsByUrisQueryVariables>;
export const GetProjectByUriDocument = gql`
    query getProjectByUri($uri: String!) {
  Project(where: {Uri: {_eq: $uri}, PublicPage: {_eq: true}}) {
    Id
    Name
    Uri
    Area
    PlantingTimeframes
    Applications_aggregate(
      where: {WorkflowState: {_in: ["Approved", "Monitoring", "Planted"]}}
    ) {
      aggregate {
        min {
          CreatedOn
        }
        sum {
          Approved
        }
      }
    }
    Description
    PublicPage
    District {
      Id
      Name
    }
    Region {
      Id
      Name
    }
    Geo
    Hero
    OpenFrom
    OpenTo
    Applications(
      where: {WorkflowState: {_in: ["Approved", "Monitoring", "Planted"]}}
    ) {
      Id
      Name
      Geo
      Plantings_aggregate {
        aggregate {
          sum {
            Quantity
          }
        }
      }
    }
    Planter {
      Id
      IsHidden
      Application_aggregate(
        where: {WorkflowState: {_in: ["Approved", "Monitoring", "Planted"]}}
      ) {
        aggregate {
          sum {
            Approved
          }
          min {
            CreatedOn
          }
        }
      }
      Account {
        Avatar
        Id
        Name
        Uri
        Type
        Region {
          Id
          Name
        }
      }
    }
    ProjectAssets {
      Id
      Type
      Uri
    }
    Purpose
    WebsiteLinks
    NumberOfProperties
    LandUse
    LandUseOther
    OtherLandArea
    CreatedOn
    FeaturedOn
  }
}
    `;

/**
 * __useGetProjectByUriQuery__
 *
 * To run a query within a React component, call `useGetProjectByUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByUriQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *   },
 * });
 */
export function useGetProjectByUriQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByUriQuery, GetProjectByUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByUriQuery, GetProjectByUriQueryVariables>(GetProjectByUriDocument, options);
      }
export function useGetProjectByUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByUriQuery, GetProjectByUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByUriQuery, GetProjectByUriQueryVariables>(GetProjectByUriDocument, options);
        }
export type GetProjectByUriQueryHookResult = ReturnType<typeof useGetProjectByUriQuery>;
export type GetProjectByUriLazyQueryHookResult = ReturnType<typeof useGetProjectByUriLazyQuery>;
export type GetProjectByUriQueryResult = Apollo.QueryResult<GetProjectByUriQuery, GetProjectByUriQueryVariables>;
export const GetProjectDocument = gql`
    query getProject($id: uuid!, $planterId: uuid!) {
  Project(where: {Id: {_eq: $id}, PlanterId: {_eq: $planterId}}) {
    Id
    Reference
    Area
    Name
    Uri
    Description
    Geo
    NumberOfTreesFundedPreviously
    ReceivedFundingPreviously
    PublicPage
    Applications_aggregate {
      aggregate {
        sum {
          Approved
        }
      }
    }
    Applications(order_by: {CreatedOn: desc}) {
      Id
      Name
      Season {
        Id
        Name
      }
      Reference
      Required
      Approved
      Planned
      WorkflowState
      Geo
      PlanterRegistrationPlantingId
      Plantings_aggregate {
        aggregate {
          sum {
            Quantity
          }
        }
      }
      Plantings {
        Id
        Name
        PlantingAssets {
          Id
          Type
          UpdatedOn
          Uri
        }
        Season {
          Id
          Name
        }
        MonitoringEvents {
          Id
          MonitoredOn
          MonitoringAssets {
            Id
            UpdatedOn
            Uri
            Type
          }
        }
      }
    }
    District {
      Id
      Name
    }
    Region {
      Id
      Name
    }
    Hero
    OpenFrom
    OpenTo
    PlantingTimeframes
    ProjectAssets {
      Id
      CreatedOn
      Type
      Uri
    }
    Planter {
      Account {
        Id
        Uri
        Name
        Website
        Facebook
      }
      IsHidden
    }
    WebsiteLinks
    NumberOfProperties
    LandUse
    LandUseOther
    OtherLandArea
    Purpose
    CreatedOn
    UpdatedOn
    WorkflowState
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetAdminProjectDocument = gql`
    query getAdminProject($id: uuid!) {
  Project(where: {Id: {_eq: $id}}) {
    Id
    Reference
    Area
    Name
    Uri
    Description
    Geo
    NumberOfTreesFundedPreviously
    ReceivedFundingPreviously
    PublicPage
    Applications_aggregate(
      where: {WorkflowState: {_in: ["Approved", "Monitoring", "Planted"]}}
    ) {
      aggregate {
        min {
          CreatedOn
        }
        sum {
          Approved
        }
      }
    }
    Applications(order_by: {CreatedOn: desc}) {
      Id
      Name
      Season {
        Id
        Name
      }
      Reference
      Required
      Approved
      Planned
      WorkflowState
      Geo
      PlanterRegistrationPlantingId
      Plantings_aggregate {
        aggregate {
          sum {
            Quantity
          }
        }
      }
      Plantings {
        Id
        Name
        PlantingAssets {
          Id
          Type
          UpdatedOn
          Uri
        }
        Season {
          Id
          Name
        }
        MonitoringEvents {
          Id
          MonitoredOn
          MonitoringAssets {
            Id
            UpdatedOn
            Uri
            Type
          }
        }
      }
    }
    District {
      Id
      Name
    }
    Region {
      Id
      Name
    }
    Hero
    OpenFrom
    OpenTo
    PlantingTimeframes
    ProjectAssets {
      Id
      CreatedOn
      Type
      Uri
    }
    Planter {
      Account {
        Id
        Type
        Uri
        Name
        Website
        Facebook
        Avatar
      }
      IsHidden
      Application_aggregate(
        where: {WorkflowState: {_in: ["Approved", "Monitoring", "Planted"]}}
      ) {
        aggregate {
          sum {
            Approved
          }
          min {
            CreatedOn
          }
        }
      }
    }
    WebsiteLinks
    NumberOfProperties
    LandUse
    LandUseOther
    OtherLandArea
    Purpose
    CreatedOn
    UpdatedOn
    WorkflowState
  }
}
    `;

/**
 * __useGetAdminProjectQuery__
 *
 * To run a query within a React component, call `useGetAdminProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAdminProjectQuery, GetAdminProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminProjectQuery, GetAdminProjectQueryVariables>(GetAdminProjectDocument, options);
      }
export function useGetAdminProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminProjectQuery, GetAdminProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminProjectQuery, GetAdminProjectQueryVariables>(GetAdminProjectDocument, options);
        }
export type GetAdminProjectQueryHookResult = ReturnType<typeof useGetAdminProjectQuery>;
export type GetAdminProjectLazyQueryHookResult = ReturnType<typeof useGetAdminProjectLazyQuery>;
export type GetAdminProjectQueryResult = Apollo.QueryResult<GetAdminProjectQuery, GetAdminProjectQueryVariables>;
export const ListProjectsDocument = gql`
    query listProjects($planterId: uuid!, $limit: Int!, $offset: Int!, $orderBy: [ProjectView_order_by!]) {
  ProjectView_aggregate(where: {PlanterId: {_eq: $planterId}}) {
    aggregate {
      count
    }
  }
  ProjectView(
    where: {PlanterId: {_eq: $planterId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    Area
    Id
    MonitoringEvents
    Name
    PlanterId
    PlantingTimeframes
    Plantings
    Region {
      Id
      Name
    }
    Applications {
      Id
      WorkflowState
      Season {
        Id
        Name
      }
    }
    TreesPlanted
    TreesApproved
    PublicPage
    WorkflowState
    Hero
  }
}
    `;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      planterId: // value for 'planterId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListProjectsQuery(baseOptions: Apollo.QueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
      }
export function useListProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
        }
export type ListProjectsQueryHookResult = ReturnType<typeof useListProjectsQuery>;
export type ListProjectsLazyQueryHookResult = ReturnType<typeof useListProjectsLazyQuery>;
export type ListProjectsQueryResult = Apollo.QueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export const ListAdminProjectsDocument = gql`
    query listAdminProjects($limit: Int!, $offset: Int!, $where: ProjectView_bool_exp, $orderBy: [ProjectView_order_by!]) {
  ProjectView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  ProjectView(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    Area
    Id
    MonitoringEvents
    Name
    FeaturedOn
    ProjectStats {
      Season
      TreesApproved
    }
    PlanterId
    Planter {
      Id
      Account {
        Id
        Name
      }
    }
    PlantingTimeframes
    Plantings
    Region {
      Id
      Name
    }
    TreesApproved
    TreesPlanted
    CreatedOn
    Reference
    PublicPage
  }
}
    `;

/**
 * __useListAdminProjectsQuery__
 *
 * To run a query within a React component, call `useListAdminProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListAdminProjectsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminProjectsQuery, ListAdminProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminProjectsQuery, ListAdminProjectsQueryVariables>(ListAdminProjectsDocument, options);
      }
export function useListAdminProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminProjectsQuery, ListAdminProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminProjectsQuery, ListAdminProjectsQueryVariables>(ListAdminProjectsDocument, options);
        }
export type ListAdminProjectsQueryHookResult = ReturnType<typeof useListAdminProjectsQuery>;
export type ListAdminProjectsLazyQueryHookResult = ReturnType<typeof useListAdminProjectsLazyQuery>;
export type ListAdminProjectsQueryResult = Apollo.QueryResult<ListAdminProjectsQuery, ListAdminProjectsQueryVariables>;
export const GetProjectNavStateDocument = gql`
    query getProjectNavState($id: uuid!) {
  Project: Project_by_pk(Id: $id) {
    Id
    Name
    Uri
    PublicPage
    FeaturedOn
    WorkflowState
    Applications {
      Id
      WorkflowState
      Season {
        Id
        Name
      }
    }
    Applications_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetProjectNavStateQuery__
 *
 * To run a query within a React component, call `useGetProjectNavStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectNavStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectNavStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectNavStateQuery(baseOptions: Apollo.QueryHookOptions<GetProjectNavStateQuery, GetProjectNavStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectNavStateQuery, GetProjectNavStateQueryVariables>(GetProjectNavStateDocument, options);
      }
export function useGetProjectNavStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectNavStateQuery, GetProjectNavStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectNavStateQuery, GetProjectNavStateQueryVariables>(GetProjectNavStateDocument, options);
        }
export type GetProjectNavStateQueryHookResult = ReturnType<typeof useGetProjectNavStateQuery>;
export type GetProjectNavStateLazyQueryHookResult = ReturnType<typeof useGetProjectNavStateLazyQuery>;
export type GetProjectNavStateQueryResult = Apollo.QueryResult<GetProjectNavStateQuery, GetProjectNavStateQueryVariables>;
export const ListProjectSupportersDocument = gql`
    query listProjectSupporters($id: uuid!, $limit: Int!, $offset: Int!) {
  Funder_aggregate(
    where: {Instruction: {Matches: {Application: {ProjectId: {_eq: $id}}}}}
  ) {
    aggregate {
      count
    }
  }
  Funder(
    limit: $limit
    offset: $offset
    where: {Instruction: {Matches: {Application: {ProjectId: {_eq: $id}}}}}
  ) {
    Account {
      Id
      Name
      Avatar
      Type
      Uri
      Region {
        Id
        Name
      }
    }
    Instruction(where: {Matches: {Application: {ProjectId: {_eq: $id}}}}) {
      Purchase {
        Total
      }
      Matches_aggregate {
        aggregate {
          sum {
            Quantity
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListProjectSupportersQuery__
 *
 * To run a query within a React component, call `useListProjectSupportersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectSupportersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectSupportersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListProjectSupportersQuery(baseOptions: Apollo.QueryHookOptions<ListProjectSupportersQuery, ListProjectSupportersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectSupportersQuery, ListProjectSupportersQueryVariables>(ListProjectSupportersDocument, options);
      }
export function useListProjectSupportersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectSupportersQuery, ListProjectSupportersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectSupportersQuery, ListProjectSupportersQueryVariables>(ListProjectSupportersDocument, options);
        }
export type ListProjectSupportersQueryHookResult = ReturnType<typeof useListProjectSupportersQuery>;
export type ListProjectSupportersLazyQueryHookResult = ReturnType<typeof useListProjectSupportersLazyQuery>;
export type ListProjectSupportersQueryResult = Apollo.QueryResult<ListProjectSupportersQuery, ListProjectSupportersQueryVariables>;
export const GetProjectStatsDocument = gql`
    query getProjectStats($id: uuid!) {
  ProjectStats(where: {ProjectId: {_eq: $id}}) {
    Season
    TreesApproved
  }
}
    `;

/**
 * __useGetProjectStatsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectStatsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectStatsQuery, GetProjectStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectStatsQuery, GetProjectStatsQueryVariables>(GetProjectStatsDocument, options);
      }
export function useGetProjectStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectStatsQuery, GetProjectStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectStatsQuery, GetProjectStatsQueryVariables>(GetProjectStatsDocument, options);
        }
export type GetProjectStatsQueryHookResult = ReturnType<typeof useGetProjectStatsQuery>;
export type GetProjectStatsLazyQueryHookResult = ReturnType<typeof useGetProjectStatsLazyQuery>;
export type GetProjectStatsQueryResult = Apollo.QueryResult<GetProjectStatsQuery, GetProjectStatsQueryVariables>;
export const GetProjectListingDocument = gql`
    query getProjectListing($where: Project_bool_exp, $limit: Int = 3, $offset: Int = 0, $orderBy: [Project_order_by!] = [{UpdatedOn: desc}, {Name: asc}, {Purpose: desc}]) {
  Count: Project_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  Projects: Project(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    Id
    Name
    Description
    CreatedOn
    Area
    Geo
    Hero
    Uri
    Region {
      Id
      Name
      Lat
    }
    District {
      Id
      Name
    }
    Purpose
    FeaturedOn
    Applications_aggregate {
      aggregate {
        sum {
          Approved
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectListingQuery__
 *
 * To run a query within a React component, call `useGetProjectListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectListingQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProjectListingQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectListingQuery, GetProjectListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectListingQuery, GetProjectListingQueryVariables>(GetProjectListingDocument, options);
      }
export function useGetProjectListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectListingQuery, GetProjectListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectListingQuery, GetProjectListingQueryVariables>(GetProjectListingDocument, options);
        }
export type GetProjectListingQueryHookResult = ReturnType<typeof useGetProjectListingQuery>;
export type GetProjectListingLazyQueryHookResult = ReturnType<typeof useGetProjectListingLazyQuery>;
export type GetProjectListingQueryResult = Apollo.QueryResult<GetProjectListingQuery, GetProjectListingQueryVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($input: DeleteProjectByIdInput!) {
  delete_project_by_id(input: $input) {
    ProjectId
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteAdminProjectByIdDocument = gql`
    mutation DeleteAdminProjectById($projectId: uuid!, $planterId: uuid!) {
  delete_PlantingSiteAsset(
    where: {PlantingSite: {Application: {ProjectId: {_eq: $projectId}}}}
  ) {
    affected_rows
  }
  delete_PlantingSite(where: {Application: {ProjectId: {_eq: $projectId}}}) {
    affected_rows
  }
  delete_ApplicationAsset(
    where: {Application: {ProjectId: {_eq: $projectId}, PlanterId: {_eq: $planterId}}}
  ) {
    affected_rows
  }
  delete_Application(
    where: {ProjectId: {_eq: $projectId}, PlanterId: {_eq: $planterId}}
  ) {
    affected_rows
  }
  delete_ProjectAsset(
    where: {Project: {Id: {_eq: $projectId}, PlanterId: {_eq: $planterId}}}
  ) {
    affected_rows
  }
  delete_Project(where: {Id: {_eq: $projectId}, PlanterId: {_eq: $planterId}}) {
    affected_rows
  }
}
    `;
export type DeleteAdminProjectByIdMutationFn = Apollo.MutationFunction<DeleteAdminProjectByIdMutation, DeleteAdminProjectByIdMutationVariables>;

/**
 * __useDeleteAdminProjectByIdMutation__
 *
 * To run a mutation, you first call `useDeleteAdminProjectByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminProjectByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminProjectByIdMutation, { data, loading, error }] = useDeleteAdminProjectByIdMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      planterId: // value for 'planterId'
 *   },
 * });
 */
export function useDeleteAdminProjectByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminProjectByIdMutation, DeleteAdminProjectByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminProjectByIdMutation, DeleteAdminProjectByIdMutationVariables>(DeleteAdminProjectByIdDocument, options);
      }
export type DeleteAdminProjectByIdMutationHookResult = ReturnType<typeof useDeleteAdminProjectByIdMutation>;
export type DeleteAdminProjectByIdMutationResult = Apollo.MutationResult<DeleteAdminProjectByIdMutation>;
export type DeleteAdminProjectByIdMutationOptions = Apollo.BaseMutationOptions<DeleteAdminProjectByIdMutation, DeleteAdminProjectByIdMutationVariables>;
export const ListProjectNotesByIdDocument = gql`
    query listProjectNotesById($projectId: uuid!) {
  ProjectNote(where: {ProjectId: {_eq: $projectId}}) {
    Id
    ProjectId
    Reference
    Notes
    User {
      Id
      FirstName
      LastName
    }
    CreatedOn
    VisitedOn
    Purpose
  }
}
    `;

/**
 * __useListProjectNotesByIdQuery__
 *
 * To run a query within a React component, call `useListProjectNotesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectNotesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectNotesByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListProjectNotesByIdQuery(baseOptions: Apollo.QueryHookOptions<ListProjectNotesByIdQuery, ListProjectNotesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectNotesByIdQuery, ListProjectNotesByIdQueryVariables>(ListProjectNotesByIdDocument, options);
      }
export function useListProjectNotesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectNotesByIdQuery, ListProjectNotesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectNotesByIdQuery, ListProjectNotesByIdQueryVariables>(ListProjectNotesByIdDocument, options);
        }
export type ListProjectNotesByIdQueryHookResult = ReturnType<typeof useListProjectNotesByIdQuery>;
export type ListProjectNotesByIdLazyQueryHookResult = ReturnType<typeof useListProjectNotesByIdLazyQuery>;
export type ListProjectNotesByIdQueryResult = Apollo.QueryResult<ListProjectNotesByIdQuery, ListProjectNotesByIdQueryVariables>;
export const CreateProjectNoteDocument = gql`
    mutation createProjectNote($object: ProjectNote_insert_input!) {
  insert_ProjectNote_one(object: $object) {
    Id
  }
}
    `;
export type CreateProjectNoteMutationFn = Apollo.MutationFunction<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>;

/**
 * __useCreateProjectNoteMutation__
 *
 * To run a mutation, you first call `useCreateProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectNoteMutation, { data, loading, error }] = useCreateProjectNoteMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>(CreateProjectNoteDocument, options);
      }
export type CreateProjectNoteMutationHookResult = ReturnType<typeof useCreateProjectNoteMutation>;
export type CreateProjectNoteMutationResult = Apollo.MutationResult<CreateProjectNoteMutation>;
export type CreateProjectNoteMutationOptions = Apollo.BaseMutationOptions<CreateProjectNoteMutation, CreateProjectNoteMutationVariables>;
export const CreateProjectNoteAssetDocument = gql`
    mutation createProjectNoteAsset($input: CreateProjectNoteAssetInput!) {
  asset: create_project_note_asset(input: $input) {
    SignedUrl
  }
}
    `;
export type CreateProjectNoteAssetMutationFn = Apollo.MutationFunction<CreateProjectNoteAssetMutation, CreateProjectNoteAssetMutationVariables>;

/**
 * __useCreateProjectNoteAssetMutation__
 *
 * To run a mutation, you first call `useCreateProjectNoteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectNoteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectNoteAssetMutation, { data, loading, error }] = useCreateProjectNoteAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectNoteAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectNoteAssetMutation, CreateProjectNoteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectNoteAssetMutation, CreateProjectNoteAssetMutationVariables>(CreateProjectNoteAssetDocument, options);
      }
export type CreateProjectNoteAssetMutationHookResult = ReturnType<typeof useCreateProjectNoteAssetMutation>;
export type CreateProjectNoteAssetMutationResult = Apollo.MutationResult<CreateProjectNoteAssetMutation>;
export type CreateProjectNoteAssetMutationOptions = Apollo.BaseMutationOptions<CreateProjectNoteAssetMutation, CreateProjectNoteAssetMutationVariables>;
export const DeleteProjectNoteAssetDocument = gql`
    mutation deleteProjectNoteAsset($id: uuid!) {
  delete_ProjectNoteAsset(where: {Id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteProjectNoteAssetMutationFn = Apollo.MutationFunction<DeleteProjectNoteAssetMutation, DeleteProjectNoteAssetMutationVariables>;

/**
 * __useDeleteProjectNoteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteProjectNoteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectNoteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectNoteAssetMutation, { data, loading, error }] = useDeleteProjectNoteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectNoteAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectNoteAssetMutation, DeleteProjectNoteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectNoteAssetMutation, DeleteProjectNoteAssetMutationVariables>(DeleteProjectNoteAssetDocument, options);
      }
export type DeleteProjectNoteAssetMutationHookResult = ReturnType<typeof useDeleteProjectNoteAssetMutation>;
export type DeleteProjectNoteAssetMutationResult = Apollo.MutationResult<DeleteProjectNoteAssetMutation>;
export type DeleteProjectNoteAssetMutationOptions = Apollo.BaseMutationOptions<DeleteProjectNoteAssetMutation, DeleteProjectNoteAssetMutationVariables>;
export const UpdateProjectNoteDocument = gql`
    mutation updateProjectNote($id: uuid!, $set: ProjectNote_set_input) {
  update_ProjectNote_by_pk(pk_columns: {Id: $id}, _set: $set) {
    Id
  }
}
    `;
export type UpdateProjectNoteMutationFn = Apollo.MutationFunction<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;

/**
 * __useUpdateProjectNoteMutation__
 *
 * To run a mutation, you first call `useUpdateProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectNoteMutation, { data, loading, error }] = useUpdateProjectNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateProjectNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>(UpdateProjectNoteDocument, options);
      }
export type UpdateProjectNoteMutationHookResult = ReturnType<typeof useUpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationResult = Apollo.MutationResult<UpdateProjectNoteMutation>;
export type UpdateProjectNoteMutationOptions = Apollo.BaseMutationOptions<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>;
export const GetProjectNoteByIdDocument = gql`
    query getProjectNoteById($id: uuid!) {
  ProjectNote_by_pk(Id: $id) {
    CreatedOn
    Id
    Notes
    Participants
    ProjectId
    Purpose
    Reference
    UpdatedOn
    UserId
    User {
      Id
      FirstName
      LastName
    }
    VisitedOn
    ProjectNoteApplications {
      Id
      Application {
        Id
        Reference
        WorkflowState
        Season {
          Id
          Name
        }
      }
    }
    ProjectNoteAssets {
      Id
      Uri
      FileName
    }
    Project {
      Id
      Name
      Geo
      Planter {
        Id
        Name
      }
    }
  }
}
    `;

/**
 * __useGetProjectNoteByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectNoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectNoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectNoteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectNoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectNoteByIdQuery, GetProjectNoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectNoteByIdQuery, GetProjectNoteByIdQueryVariables>(GetProjectNoteByIdDocument, options);
      }
export function useGetProjectNoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectNoteByIdQuery, GetProjectNoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectNoteByIdQuery, GetProjectNoteByIdQueryVariables>(GetProjectNoteByIdDocument, options);
        }
export type GetProjectNoteByIdQueryHookResult = ReturnType<typeof useGetProjectNoteByIdQuery>;
export type GetProjectNoteByIdLazyQueryHookResult = ReturnType<typeof useGetProjectNoteByIdLazyQuery>;
export type GetProjectNoteByIdQueryResult = Apollo.QueryResult<GetProjectNoteByIdQuery, GetProjectNoteByIdQueryVariables>;
export const DeleteProjectNoteApplicationDocument = gql`
    mutation deleteProjectNoteApplication($id: uuid!) {
  delete_ProjectNoteApplication_by_pk(Id: $id) {
    Id
  }
}
    `;
export type DeleteProjectNoteApplicationMutationFn = Apollo.MutationFunction<DeleteProjectNoteApplicationMutation, DeleteProjectNoteApplicationMutationVariables>;

/**
 * __useDeleteProjectNoteApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteProjectNoteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectNoteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectNoteApplicationMutation, { data, loading, error }] = useDeleteProjectNoteApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectNoteApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectNoteApplicationMutation, DeleteProjectNoteApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectNoteApplicationMutation, DeleteProjectNoteApplicationMutationVariables>(DeleteProjectNoteApplicationDocument, options);
      }
export type DeleteProjectNoteApplicationMutationHookResult = ReturnType<typeof useDeleteProjectNoteApplicationMutation>;
export type DeleteProjectNoteApplicationMutationResult = Apollo.MutationResult<DeleteProjectNoteApplicationMutation>;
export type DeleteProjectNoteApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteProjectNoteApplicationMutation, DeleteProjectNoteApplicationMutationVariables>;
export const CreateProjectNoteApplicationDocument = gql`
    mutation createProjectNoteApplication($objects: [ProjectNoteApplication_insert_input!]!) {
  insert_ProjectNoteApplication(objects: $objects) {
    affected_rows
  }
}
    `;
export type CreateProjectNoteApplicationMutationFn = Apollo.MutationFunction<CreateProjectNoteApplicationMutation, CreateProjectNoteApplicationMutationVariables>;

/**
 * __useCreateProjectNoteApplicationMutation__
 *
 * To run a mutation, you first call `useCreateProjectNoteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectNoteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectNoteApplicationMutation, { data, loading, error }] = useCreateProjectNoteApplicationMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreateProjectNoteApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectNoteApplicationMutation, CreateProjectNoteApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectNoteApplicationMutation, CreateProjectNoteApplicationMutationVariables>(CreateProjectNoteApplicationDocument, options);
      }
export type CreateProjectNoteApplicationMutationHookResult = ReturnType<typeof useCreateProjectNoteApplicationMutation>;
export type CreateProjectNoteApplicationMutationResult = Apollo.MutationResult<CreateProjectNoteApplicationMutation>;
export type CreateProjectNoteApplicationMutationOptions = Apollo.BaseMutationOptions<CreateProjectNoteApplicationMutation, CreateProjectNoteApplicationMutationVariables>;
export const GetAdminPurchaseDocument = gql`
    query getAdminPurchase($purchaseId: uuid!) {
  AdminPurchaseView(limit: 1, where: {Id: {_eq: $purchaseId}}) {
    Id
    PaymentMethod
    CreatedOn
    DistrictName
    FilterState
    FunderId
    FunderName
    FunderRegionName
    GiftDeliveryDate
    HoldOnMatch
    InstructionId
    Matched
    ProductName
    AccountId
    PurchaseState
    PurchaseTotal
    PurchasePrice
    ReceiptEmail
    ReceiptName
    RecipientEmail
    RecipientName
    Reference
    RegionId
    RegionName
    RegistryId
    RegistryName
    SeasonName
    Trees
    TypeName
    Unmatched
    SubscriptionId
    Attachments(where: {Generated: {_eq: true}}) {
      Id
      Type
      Generated
      Filename
    }
  }
}
    `;

/**
 * __useGetAdminPurchaseQuery__
 *
 * To run a query within a React component, call `useGetAdminPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPurchaseQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useGetAdminPurchaseQuery(baseOptions: Apollo.QueryHookOptions<GetAdminPurchaseQuery, GetAdminPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminPurchaseQuery, GetAdminPurchaseQueryVariables>(GetAdminPurchaseDocument, options);
      }
export function useGetAdminPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPurchaseQuery, GetAdminPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminPurchaseQuery, GetAdminPurchaseQueryVariables>(GetAdminPurchaseDocument, options);
        }
export type GetAdminPurchaseQueryHookResult = ReturnType<typeof useGetAdminPurchaseQuery>;
export type GetAdminPurchaseLazyQueryHookResult = ReturnType<typeof useGetAdminPurchaseLazyQuery>;
export type GetAdminPurchaseQueryResult = Apollo.QueryResult<GetAdminPurchaseQuery, GetAdminPurchaseQueryVariables>;
export const GetInstructionViewDocument = gql`
    query getInstructionView($purchaseId: uuid!) {
  InstructionView(where: {AdminPurchaseView: {Id: {_eq: $purchaseId}}}) {
    Id
    Matched
    Unmatched
    Trees
    HoldOnMatch
    AdminPurchaseView {
      Id
      CreatedOn
      DistrictName
      FilterState
      FunderId
      FunderName
      FunderRegionName
      GiftDeliveryDate
      HoldOnMatch
      InstructionId
      Matched
      ProductName
      PurchaseState
      ReceiptEmail
      ReceiptName
      Reference
      RegionId
      RegionName
      RegistryName
      SeasonName
      Trees
      TypeName
      Unmatched
      Attachments(where: {Generated: {_eq: true}}) {
        Id
        Type
        Generated
        Filename
      }
    }
  }
}
    `;

/**
 * __useGetInstructionViewQuery__
 *
 * To run a query within a React component, call `useGetInstructionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructionViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructionViewQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useGetInstructionViewQuery(baseOptions: Apollo.QueryHookOptions<GetInstructionViewQuery, GetInstructionViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstructionViewQuery, GetInstructionViewQueryVariables>(GetInstructionViewDocument, options);
      }
export function useGetInstructionViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstructionViewQuery, GetInstructionViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstructionViewQuery, GetInstructionViewQueryVariables>(GetInstructionViewDocument, options);
        }
export type GetInstructionViewQueryHookResult = ReturnType<typeof useGetInstructionViewQuery>;
export type GetInstructionViewLazyQueryHookResult = ReturnType<typeof useGetInstructionViewLazyQuery>;
export type GetInstructionViewQueryResult = Apollo.QueryResult<GetInstructionViewQuery, GetInstructionViewQueryVariables>;
export const GetInstructionViewWithMatchesDocument = gql`
    query getInstructionViewWithMatches($purchaseId: uuid!) {
  InstructionView(where: {AdminPurchaseView: {Id: {_eq: $purchaseId}}}) {
    Id
    Matched
    Unmatched
    Trees
    PurchaseId
    Reference
    AdminPurchaseView {
      Id
      CreatedOn
      DistrictName
      FilterState
      FunderId
      FunderName
      FunderRegionName
      GiftDeliveryDate
      HoldOnMatch
      InstructionId
      Matched
      ProductName
      PurchaseState
      ReceiptEmail
      ReceiptName
      Reference
      RegionId
      RegionName
      RegistryName
      SeasonName
      Trees
      TypeName
      Unmatched
      Attachments(where: {Generated: {_eq: true}}) {
        Id
        Type
        Generated
        Filename
      }
    }
    Matches {
      Id
      Quantity
      Application {
        Id
        CreatedOn
        District {
          Id
          Name
        }
        Name
        Planter {
          Id
          Name
          Account {
            Id
            Email
          }
        }
        Reference
        Region {
          Id
          Name
        }
        Season {
          Id
          Name
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstructionViewWithMatchesQuery__
 *
 * To run a query within a React component, call `useGetInstructionViewWithMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructionViewWithMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructionViewWithMatchesQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useGetInstructionViewWithMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetInstructionViewWithMatchesQuery, GetInstructionViewWithMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstructionViewWithMatchesQuery, GetInstructionViewWithMatchesQueryVariables>(GetInstructionViewWithMatchesDocument, options);
      }
export function useGetInstructionViewWithMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstructionViewWithMatchesQuery, GetInstructionViewWithMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstructionViewWithMatchesQuery, GetInstructionViewWithMatchesQueryVariables>(GetInstructionViewWithMatchesDocument, options);
        }
export type GetInstructionViewWithMatchesQueryHookResult = ReturnType<typeof useGetInstructionViewWithMatchesQuery>;
export type GetInstructionViewWithMatchesLazyQueryHookResult = ReturnType<typeof useGetInstructionViewWithMatchesLazyQuery>;
export type GetInstructionViewWithMatchesQueryResult = Apollo.QueryResult<GetInstructionViewWithMatchesQuery, GetInstructionViewWithMatchesQueryVariables>;
export const ListAdminPurchasesDocument = gql`
    query listAdminPurchases($offset: Int!, $where: AdminPurchaseView_bool_exp, $order_by: [AdminPurchaseView_order_by!]) {
  AdminPurchaseView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  AdminPurchaseView(
    limit: 10
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    Id
    Account {
      Id
      Memberships {
        Id
        UserId
      }
    }
    CreatedOn
    FilterState
    FunderName
    FunderRegionName
    HoldOnMatch
    InstructionId
    Matched
    AccountId
    ReceiptEmail
    Reference
    RegionId
    RegionName
    SeasonName
    Trees
    TypeName
    Unmatched
    PurchasePrice
    PurchaseTotal
    SubscriptionId
  }
}
    `;

/**
 * __useListAdminPurchasesQuery__
 *
 * To run a query within a React component, call `useListAdminPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminPurchasesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useListAdminPurchasesQuery(baseOptions: Apollo.QueryHookOptions<ListAdminPurchasesQuery, ListAdminPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminPurchasesQuery, ListAdminPurchasesQueryVariables>(ListAdminPurchasesDocument, options);
      }
export function useListAdminPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminPurchasesQuery, ListAdminPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminPurchasesQuery, ListAdminPurchasesQueryVariables>(ListAdminPurchasesDocument, options);
        }
export type ListAdminPurchasesQueryHookResult = ReturnType<typeof useListAdminPurchasesQuery>;
export type ListAdminPurchasesLazyQueryHookResult = ReturnType<typeof useListAdminPurchasesLazyQuery>;
export type ListAdminPurchasesQueryResult = Apollo.QueryResult<ListAdminPurchasesQuery, ListAdminPurchasesQueryVariables>;
export const DeleteMatchesDocument = gql`
    mutation DeleteMatches($input: DeleteMatchesInput!) {
  delete_matches(input: $input) {
    MatchIds
  }
}
    `;
export type DeleteMatchesMutationFn = Apollo.MutationFunction<DeleteMatchesMutation, DeleteMatchesMutationVariables>;

/**
 * __useDeleteMatchesMutation__
 *
 * To run a mutation, you first call `useDeleteMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchesMutation, { data, loading, error }] = useDeleteMatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMatchesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchesMutation, DeleteMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchesMutation, DeleteMatchesMutationVariables>(DeleteMatchesDocument, options);
      }
export type DeleteMatchesMutationHookResult = ReturnType<typeof useDeleteMatchesMutation>;
export type DeleteMatchesMutationResult = Apollo.MutationResult<DeleteMatchesMutation>;
export type DeleteMatchesMutationOptions = Apollo.BaseMutationOptions<DeleteMatchesMutation, DeleteMatchesMutationVariables>;
export const CreateMatchFromInstructionDocument = gql`
    mutation createMatchFromInstruction($input: CreateMatchFromInstructionInput!) {
  create_match_from_instruction(input: $input) {
    InstructionId
  }
}
    `;
export type CreateMatchFromInstructionMutationFn = Apollo.MutationFunction<CreateMatchFromInstructionMutation, CreateMatchFromInstructionMutationVariables>;

/**
 * __useCreateMatchFromInstructionMutation__
 *
 * To run a mutation, you first call `useCreateMatchFromInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchFromInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchFromInstructionMutation, { data, loading, error }] = useCreateMatchFromInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchFromInstructionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchFromInstructionMutation, CreateMatchFromInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchFromInstructionMutation, CreateMatchFromInstructionMutationVariables>(CreateMatchFromInstructionDocument, options);
      }
export type CreateMatchFromInstructionMutationHookResult = ReturnType<typeof useCreateMatchFromInstructionMutation>;
export type CreateMatchFromInstructionMutationResult = Apollo.MutationResult<CreateMatchFromInstructionMutation>;
export type CreateMatchFromInstructionMutationOptions = Apollo.BaseMutationOptions<CreateMatchFromInstructionMutation, CreateMatchFromInstructionMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation createPayment($input: CreatePaymentInput!) {
  create_payment(input: $input) {
    PaymentIntentClientSecret
    PurchaseId
    SubscriptionId
    Hash
    Token
  }
}
    `;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CreateGuestPaymentDocument = gql`
    mutation createGuestPayment($input: CreateGuestPaymentInput!) {
  create_guest_payment(input: $input) {
    PaymentIntentClientSecret
    PurchaseId
    SubscriptionId
    Hash
    Token
  }
}
    `;
export type CreateGuestPaymentMutationFn = Apollo.MutationFunction<CreateGuestPaymentMutation, CreateGuestPaymentMutationVariables>;

/**
 * __useCreateGuestPaymentMutation__
 *
 * To run a mutation, you first call `useCreateGuestPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestPaymentMutation, { data, loading, error }] = useCreateGuestPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGuestPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuestPaymentMutation, CreateGuestPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuestPaymentMutation, CreateGuestPaymentMutationVariables>(CreateGuestPaymentDocument, options);
      }
export type CreateGuestPaymentMutationHookResult = ReturnType<typeof useCreateGuestPaymentMutation>;
export type CreateGuestPaymentMutationResult = Apollo.MutationResult<CreateGuestPaymentMutation>;
export type CreateGuestPaymentMutationOptions = Apollo.BaseMutationOptions<CreateGuestPaymentMutation, CreateGuestPaymentMutationVariables>;
export const UpdateInstructionHoldStatusDocument = gql`
    mutation updateInstructionHoldStatus($id: uuid!, $holdStatus: Boolean!) {
  update_Instruction_by_pk(
    pk_columns: {Id: $id}
    _set: {HoldOnMatch: $holdStatus}
  ) {
    Id
  }
}
    `;
export type UpdateInstructionHoldStatusMutationFn = Apollo.MutationFunction<UpdateInstructionHoldStatusMutation, UpdateInstructionHoldStatusMutationVariables>;

/**
 * __useUpdateInstructionHoldStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInstructionHoldStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstructionHoldStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstructionHoldStatusMutation, { data, loading, error }] = useUpdateInstructionHoldStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      holdStatus: // value for 'holdStatus'
 *   },
 * });
 */
export function useUpdateInstructionHoldStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstructionHoldStatusMutation, UpdateInstructionHoldStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstructionHoldStatusMutation, UpdateInstructionHoldStatusMutationVariables>(UpdateInstructionHoldStatusDocument, options);
      }
export type UpdateInstructionHoldStatusMutationHookResult = ReturnType<typeof useUpdateInstructionHoldStatusMutation>;
export type UpdateInstructionHoldStatusMutationResult = Apollo.MutationResult<UpdateInstructionHoldStatusMutation>;
export type UpdateInstructionHoldStatusMutationOptions = Apollo.BaseMutationOptions<UpdateInstructionHoldStatusMutation, UpdateInstructionHoldStatusMutationVariables>;
export const ProcessPurchaseDocument = gql`
    mutation processPurchase($purchaseId: String!) {
  process_purchase(input: {PurchaseId: $purchaseId}) {
    PurchaseId
  }
}
    `;
export type ProcessPurchaseMutationFn = Apollo.MutationFunction<ProcessPurchaseMutation, ProcessPurchaseMutationVariables>;

/**
 * __useProcessPurchaseMutation__
 *
 * To run a mutation, you first call `useProcessPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPurchaseMutation, { data, loading, error }] = useProcessPurchaseMutation({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useProcessPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPurchaseMutation, ProcessPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPurchaseMutation, ProcessPurchaseMutationVariables>(ProcessPurchaseDocument, options);
      }
export type ProcessPurchaseMutationHookResult = ReturnType<typeof useProcessPurchaseMutation>;
export type ProcessPurchaseMutationResult = Apollo.MutationResult<ProcessPurchaseMutation>;
export type ProcessPurchaseMutationOptions = Apollo.BaseMutationOptions<ProcessPurchaseMutation, ProcessPurchaseMutationVariables>;
export const VoidPurchaseDocument = gql`
    mutation voidPurchase($purchaseId: String!) {
  void_purchase(input: {PurchaseId: $purchaseId}) {
    PurchaseId
  }
}
    `;
export type VoidPurchaseMutationFn = Apollo.MutationFunction<VoidPurchaseMutation, VoidPurchaseMutationVariables>;

/**
 * __useVoidPurchaseMutation__
 *
 * To run a mutation, you first call `useVoidPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidPurchaseMutation, { data, loading, error }] = useVoidPurchaseMutation({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useVoidPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<VoidPurchaseMutation, VoidPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidPurchaseMutation, VoidPurchaseMutationVariables>(VoidPurchaseDocument, options);
      }
export type VoidPurchaseMutationHookResult = ReturnType<typeof useVoidPurchaseMutation>;
export type VoidPurchaseMutationResult = Apollo.MutationResult<VoidPurchaseMutation>;
export type VoidPurchaseMutationOptions = Apollo.BaseMutationOptions<VoidPurchaseMutation, VoidPurchaseMutationVariables>;
export const CreateAdminPaymentDocument = gql`
    mutation createAdminPayment($input: CreateAdminPaymentInput!) {
  create_admin_payment(input: $input) {
    PurchaseId
  }
}
    `;
export type CreateAdminPaymentMutationFn = Apollo.MutationFunction<CreateAdminPaymentMutation, CreateAdminPaymentMutationVariables>;

/**
 * __useCreateAdminPaymentMutation__
 *
 * To run a mutation, you first call `useCreateAdminPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminPaymentMutation, { data, loading, error }] = useCreateAdminPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminPaymentMutation, CreateAdminPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminPaymentMutation, CreateAdminPaymentMutationVariables>(CreateAdminPaymentDocument, options);
      }
export type CreateAdminPaymentMutationHookResult = ReturnType<typeof useCreateAdminPaymentMutation>;
export type CreateAdminPaymentMutationResult = Apollo.MutationResult<CreateAdminPaymentMutation>;
export type CreateAdminPaymentMutationOptions = Apollo.BaseMutationOptions<CreateAdminPaymentMutation, CreateAdminPaymentMutationVariables>;
export const GetPurchasesForAccountDocument = gql`
    query getPurchasesForAccount($limit: Int = 5, $offset: Int = 0, $accountId: uuid!, $orderBy: [PurchaseDashboardView_order_by!]) {
  PurchaseDashboardView(
    limit: $limit
    offset: $offset
    where: {State: {_nin: [6, 8]}, Funder: {Account: {Id: {_eq: $accountId}}}}
    order_by: $orderBy
  ) {
    Token
    Quantity
    CreatedOn
    Amount
    Total
    SubscriptionId
    Funder {
      Account {
        Id
        Name
      }
    }
    Type
    State
  }
  PurchaseDashboardView_aggregate(
    where: {State: {_nin: [6, 8]}, Funder: {Account: {Id: {_eq: $accountId}}}}
  ) {
    aggregate {
      count
      sum {
        Quantity
      }
    }
  }
}
    `;

/**
 * __useGetPurchasesForAccountQuery__
 *
 * To run a query within a React component, call `useGetPurchasesForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasesForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasesForAccountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPurchasesForAccountQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasesForAccountQuery, GetPurchasesForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasesForAccountQuery, GetPurchasesForAccountQueryVariables>(GetPurchasesForAccountDocument, options);
      }
export function useGetPurchasesForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasesForAccountQuery, GetPurchasesForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasesForAccountQuery, GetPurchasesForAccountQueryVariables>(GetPurchasesForAccountDocument, options);
        }
export type GetPurchasesForAccountQueryHookResult = ReturnType<typeof useGetPurchasesForAccountQuery>;
export type GetPurchasesForAccountLazyQueryHookResult = ReturnType<typeof useGetPurchasesForAccountLazyQuery>;
export type GetPurchasesForAccountQueryResult = Apollo.QueryResult<GetPurchasesForAccountQuery, GetPurchasesForAccountQueryVariables>;
export const ListFunderPurchasesDocument = gql`
    query listFunderPurchases($funderId: uuid!) {
  purchases: Purchase(
    order_by: {CreatedOn: desc}
    distinct_on: CreatedOn
    where: {FunderId: {_eq: $funderId}}
  ) {
    Id
    CreatedOn
  }
}
    `;

/**
 * __useListFunderPurchasesQuery__
 *
 * To run a query within a React component, call `useListFunderPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFunderPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFunderPurchasesQuery({
 *   variables: {
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useListFunderPurchasesQuery(baseOptions: Apollo.QueryHookOptions<ListFunderPurchasesQuery, ListFunderPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFunderPurchasesQuery, ListFunderPurchasesQueryVariables>(ListFunderPurchasesDocument, options);
      }
export function useListFunderPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFunderPurchasesQuery, ListFunderPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFunderPurchasesQuery, ListFunderPurchasesQueryVariables>(ListFunderPurchasesDocument, options);
        }
export type ListFunderPurchasesQueryHookResult = ReturnType<typeof useListFunderPurchasesQuery>;
export type ListFunderPurchasesLazyQueryHookResult = ReturnType<typeof useListFunderPurchasesLazyQuery>;
export type ListFunderPurchasesQueryResult = Apollo.QueryResult<ListFunderPurchasesQuery, ListFunderPurchasesQueryVariables>;
export const ListAdminBulkGiftsDocument = gql`
    query listAdminBulkGifts($offset: Int!, $where: AdminBulkGiftView_bool_exp, $order_by: [AdminBulkGiftView_order_by!]) {
  AdminBulkGiftView(
    limit: 10
    offset: $offset
    where: $where
    order_by: $order_by
  ) {
    Id
    CreatedOn
    Funder
    ReceiptEmail
    ReceiptName
    State
    RecipientCount
    User {
      Id
      FirstName
      LastName
    }
  }
  AdminBulkGiftView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useListAdminBulkGiftsQuery__
 *
 * To run a query within a React component, call `useListAdminBulkGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminBulkGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminBulkGiftsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useListAdminBulkGiftsQuery(baseOptions: Apollo.QueryHookOptions<ListAdminBulkGiftsQuery, ListAdminBulkGiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminBulkGiftsQuery, ListAdminBulkGiftsQueryVariables>(ListAdminBulkGiftsDocument, options);
      }
export function useListAdminBulkGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminBulkGiftsQuery, ListAdminBulkGiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminBulkGiftsQuery, ListAdminBulkGiftsQueryVariables>(ListAdminBulkGiftsDocument, options);
        }
export type ListAdminBulkGiftsQueryHookResult = ReturnType<typeof useListAdminBulkGiftsQuery>;
export type ListAdminBulkGiftsLazyQueryHookResult = ReturnType<typeof useListAdminBulkGiftsLazyQuery>;
export type ListAdminBulkGiftsQueryResult = Apollo.QueryResult<ListAdminBulkGiftsQuery, ListAdminBulkGiftsQueryVariables>;
export const GetAdminBulkGiftsDocument = gql`
    query getAdminBulkGifts($id: uuid!) {
  Purchase_by_pk(Id: $id) {
    Id
    State
    CreatedOn
    ReceiptEmail
    ReceiptName
    DeliverOn
    Token
    Funder {
      Id
      Account {
        Id
        Name
      }
    }
    RelatedPurchases {
      Id
      RecipientName
      RecipientEmail
      Quantity
      GiftMessage
      State
      Attachment {
        Id
        Type
        Generated
        Filename
      }
    }
    RelatedPurchases_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetAdminBulkGiftsQuery__
 *
 * To run a query within a React component, call `useGetAdminBulkGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminBulkGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminBulkGiftsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminBulkGiftsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminBulkGiftsQuery, GetAdminBulkGiftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminBulkGiftsQuery, GetAdminBulkGiftsQueryVariables>(GetAdminBulkGiftsDocument, options);
      }
export function useGetAdminBulkGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminBulkGiftsQuery, GetAdminBulkGiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminBulkGiftsQuery, GetAdminBulkGiftsQueryVariables>(GetAdminBulkGiftsDocument, options);
        }
export type GetAdminBulkGiftsQueryHookResult = ReturnType<typeof useGetAdminBulkGiftsQuery>;
export type GetAdminBulkGiftsLazyQueryHookResult = ReturnType<typeof useGetAdminBulkGiftsLazyQuery>;
export type GetAdminBulkGiftsQueryResult = Apollo.QueryResult<GetAdminBulkGiftsQuery, GetAdminBulkGiftsQueryVariables>;
export const GetAdminPurchaseByIdDocument = gql`
    query getAdminPurchaseById($id: uuid!) {
  Purchase_by_pk(Id: $id) {
    Id
    Token
    CreatedOn
    RecipientEmail
    PublicName
    PublicMessage
    SubscriptionId
  }
}
    `;

/**
 * __useGetAdminPurchaseByIdQuery__
 *
 * To run a query within a React component, call `useGetAdminPurchaseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPurchaseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPurchaseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminPurchaseByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAdminPurchaseByIdQuery, GetAdminPurchaseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminPurchaseByIdQuery, GetAdminPurchaseByIdQueryVariables>(GetAdminPurchaseByIdDocument, options);
      }
export function useGetAdminPurchaseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPurchaseByIdQuery, GetAdminPurchaseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminPurchaseByIdQuery, GetAdminPurchaseByIdQueryVariables>(GetAdminPurchaseByIdDocument, options);
        }
export type GetAdminPurchaseByIdQueryHookResult = ReturnType<typeof useGetAdminPurchaseByIdQuery>;
export type GetAdminPurchaseByIdLazyQueryHookResult = ReturnType<typeof useGetAdminPurchaseByIdLazyQuery>;
export type GetAdminPurchaseByIdQueryResult = Apollo.QueryResult<GetAdminPurchaseByIdQuery, GetAdminPurchaseByIdQueryVariables>;
export const UpdateAdminPurchaseRecipientEmailDocument = gql`
    mutation updateAdminPurchaseRecipientEmail($id: uuid!, $email: String!) {
  update_Purchase_by_pk(pk_columns: {Id: $id}, _set: {RecipientEmail: $email}) {
    Id
    RecipientEmail
  }
}
    `;
export type UpdateAdminPurchaseRecipientEmailMutationFn = Apollo.MutationFunction<UpdateAdminPurchaseRecipientEmailMutation, UpdateAdminPurchaseRecipientEmailMutationVariables>;

/**
 * __useUpdateAdminPurchaseRecipientEmailMutation__
 *
 * To run a mutation, you first call `useUpdateAdminPurchaseRecipientEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminPurchaseRecipientEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminPurchaseRecipientEmailMutation, { data, loading, error }] = useUpdateAdminPurchaseRecipientEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateAdminPurchaseRecipientEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminPurchaseRecipientEmailMutation, UpdateAdminPurchaseRecipientEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminPurchaseRecipientEmailMutation, UpdateAdminPurchaseRecipientEmailMutationVariables>(UpdateAdminPurchaseRecipientEmailDocument, options);
      }
export type UpdateAdminPurchaseRecipientEmailMutationHookResult = ReturnType<typeof useUpdateAdminPurchaseRecipientEmailMutation>;
export type UpdateAdminPurchaseRecipientEmailMutationResult = Apollo.MutationResult<UpdateAdminPurchaseRecipientEmailMutation>;
export type UpdateAdminPurchaseRecipientEmailMutationOptions = Apollo.BaseMutationOptions<UpdateAdminPurchaseRecipientEmailMutation, UpdateAdminPurchaseRecipientEmailMutationVariables>;
export const UpdatePurchaseRecipientEmailDocument = gql`
    mutation updatePurchaseRecipientEmail($input: UpdatePurchaseRecipientEmailInput!) {
  update_purchase_recipient_email(input: $input) {
    Id
    Email
  }
}
    `;
export type UpdatePurchaseRecipientEmailMutationFn = Apollo.MutationFunction<UpdatePurchaseRecipientEmailMutation, UpdatePurchaseRecipientEmailMutationVariables>;

/**
 * __useUpdatePurchaseRecipientEmailMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseRecipientEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseRecipientEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseRecipientEmailMutation, { data, loading, error }] = useUpdatePurchaseRecipientEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchaseRecipientEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseRecipientEmailMutation, UpdatePurchaseRecipientEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseRecipientEmailMutation, UpdatePurchaseRecipientEmailMutationVariables>(UpdatePurchaseRecipientEmailDocument, options);
      }
export type UpdatePurchaseRecipientEmailMutationHookResult = ReturnType<typeof useUpdatePurchaseRecipientEmailMutation>;
export type UpdatePurchaseRecipientEmailMutationResult = Apollo.MutationResult<UpdatePurchaseRecipientEmailMutation>;
export type UpdatePurchaseRecipientEmailMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseRecipientEmailMutation, UpdatePurchaseRecipientEmailMutationVariables>;
export const ResendGiftCertificateDocument = gql`
    mutation resendGiftCertificate($input: ResendGiftCertificateInput!) {
  resend_gift_certificate(input: $input) {
    PurchaseId
  }
}
    `;
export type ResendGiftCertificateMutationFn = Apollo.MutationFunction<ResendGiftCertificateMutation, ResendGiftCertificateMutationVariables>;

/**
 * __useResendGiftCertificateMutation__
 *
 * To run a mutation, you first call `useResendGiftCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendGiftCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendGiftCertificateMutation, { data, loading, error }] = useResendGiftCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendGiftCertificateMutation(baseOptions?: Apollo.MutationHookOptions<ResendGiftCertificateMutation, ResendGiftCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendGiftCertificateMutation, ResendGiftCertificateMutationVariables>(ResendGiftCertificateDocument, options);
      }
export type ResendGiftCertificateMutationHookResult = ReturnType<typeof useResendGiftCertificateMutation>;
export type ResendGiftCertificateMutationResult = Apollo.MutationResult<ResendGiftCertificateMutation>;
export type ResendGiftCertificateMutationOptions = Apollo.BaseMutationOptions<ResendGiftCertificateMutation, ResendGiftCertificateMutationVariables>;
export const AdminUpdatePurchaseErrorDocument = gql`
    mutation adminUpdatePurchaseError($token: String!, $paymentError: String!) {
  update_Purchase(
    where: {Token: {_eq: $token}, State: {_in: [2, 8]}}
    _set: {State: 8, PaymentError: $paymentError}
  ) {
    affected_rows
    returning {
      Id
    }
  }
}
    `;
export type AdminUpdatePurchaseErrorMutationFn = Apollo.MutationFunction<AdminUpdatePurchaseErrorMutation, AdminUpdatePurchaseErrorMutationVariables>;

/**
 * __useAdminUpdatePurchaseErrorMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePurchaseErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePurchaseErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePurchaseErrorMutation, { data, loading, error }] = useAdminUpdatePurchaseErrorMutation({
 *   variables: {
 *      token: // value for 'token'
 *      paymentError: // value for 'paymentError'
 *   },
 * });
 */
export function useAdminUpdatePurchaseErrorMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePurchaseErrorMutation, AdminUpdatePurchaseErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePurchaseErrorMutation, AdminUpdatePurchaseErrorMutationVariables>(AdminUpdatePurchaseErrorDocument, options);
      }
export type AdminUpdatePurchaseErrorMutationHookResult = ReturnType<typeof useAdminUpdatePurchaseErrorMutation>;
export type AdminUpdatePurchaseErrorMutationResult = Apollo.MutationResult<AdminUpdatePurchaseErrorMutation>;
export type AdminUpdatePurchaseErrorMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePurchaseErrorMutation, AdminUpdatePurchaseErrorMutationVariables>;
export const UpdatePurchaseErrorDocument = gql`
    mutation updatePurchaseError($input: UpdatePurchaseErrorInput!) {
  update_purchase_error(input: $input) {
    PurchaseId
  }
}
    `;
export type UpdatePurchaseErrorMutationFn = Apollo.MutationFunction<UpdatePurchaseErrorMutation, UpdatePurchaseErrorMutationVariables>;

/**
 * __useUpdatePurchaseErrorMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseErrorMutation, { data, loading, error }] = useUpdatePurchaseErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchaseErrorMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseErrorMutation, UpdatePurchaseErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseErrorMutation, UpdatePurchaseErrorMutationVariables>(UpdatePurchaseErrorDocument, options);
      }
export type UpdatePurchaseErrorMutationHookResult = ReturnType<typeof useUpdatePurchaseErrorMutation>;
export type UpdatePurchaseErrorMutationResult = Apollo.MutationResult<UpdatePurchaseErrorMutation>;
export type UpdatePurchaseErrorMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseErrorMutation, UpdatePurchaseErrorMutationVariables>;
export const UpdateAdminPurchasePublicMessageDocument = gql`
    mutation updateAdminPurchasePublicMessage($purchaseId: uuid!, $name: String, $message: String) {
  update_Purchase_by_pk(
    pk_columns: {Id: $purchaseId}
    _set: {PublicName: $name, PublicMessage: $message}
  ) {
    Id
  }
  update_UserEvent(
    where: {ReferenceId: {_eq: $purchaseId}}
    _set: {Name: $name, Comment: $message}
  ) {
    affected_rows
    returning {
      Id
    }
  }
}
    `;
export type UpdateAdminPurchasePublicMessageMutationFn = Apollo.MutationFunction<UpdateAdminPurchasePublicMessageMutation, UpdateAdminPurchasePublicMessageMutationVariables>;

/**
 * __useUpdateAdminPurchasePublicMessageMutation__
 *
 * To run a mutation, you first call `useUpdateAdminPurchasePublicMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminPurchasePublicMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminPurchasePublicMessageMutation, { data, loading, error }] = useUpdateAdminPurchasePublicMessageMutation({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *      name: // value for 'name'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateAdminPurchasePublicMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminPurchasePublicMessageMutation, UpdateAdminPurchasePublicMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminPurchasePublicMessageMutation, UpdateAdminPurchasePublicMessageMutationVariables>(UpdateAdminPurchasePublicMessageDocument, options);
      }
export type UpdateAdminPurchasePublicMessageMutationHookResult = ReturnType<typeof useUpdateAdminPurchasePublicMessageMutation>;
export type UpdateAdminPurchasePublicMessageMutationResult = Apollo.MutationResult<UpdateAdminPurchasePublicMessageMutation>;
export type UpdateAdminPurchasePublicMessageMutationOptions = Apollo.BaseMutationOptions<UpdateAdminPurchasePublicMessageMutation, UpdateAdminPurchasePublicMessageMutationVariables>;
export const UpdatePurchasePublicMessageDocument = gql`
    mutation updatePurchasePublicMessage($input: UpdatePurchasePublicMessageInput!) {
  update_purchase_public_message(input: $input) {
    UserEventId
  }
}
    `;
export type UpdatePurchasePublicMessageMutationFn = Apollo.MutationFunction<UpdatePurchasePublicMessageMutation, UpdatePurchasePublicMessageMutationVariables>;

/**
 * __useUpdatePurchasePublicMessageMutation__
 *
 * To run a mutation, you first call `useUpdatePurchasePublicMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchasePublicMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchasePublicMessageMutation, { data, loading, error }] = useUpdatePurchasePublicMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchasePublicMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchasePublicMessageMutation, UpdatePurchasePublicMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchasePublicMessageMutation, UpdatePurchasePublicMessageMutationVariables>(UpdatePurchasePublicMessageDocument, options);
      }
export type UpdatePurchasePublicMessageMutationHookResult = ReturnType<typeof useUpdatePurchasePublicMessageMutation>;
export type UpdatePurchasePublicMessageMutationResult = Apollo.MutationResult<UpdatePurchasePublicMessageMutation>;
export type UpdatePurchasePublicMessageMutationOptions = Apollo.BaseMutationOptions<UpdatePurchasePublicMessageMutation, UpdatePurchasePublicMessageMutationVariables>;
export const GetPurchaseDetailByTokenDocument = gql`
    query getPurchaseDetailByToken($token: String!) {
  Purchase(where: {Token: {_eq: $token}}, order_by: {Reference: asc}) {
    Id
    CreatedOn
    PaymentMethod
    State
    Type
    Amount
    Region {
      Id
      Name
      AltName
    }
    PublicMessage
    ReceiptEmail
    ReceiptName
    Reference
    RecipientEmail
    RecipientName
    From
    DeliverOn
    GiftMessage
    SubscriptionId
    GiftTemplate {
      Id
      Preview
      Name
    }
    Quantity
    RegistryId
    Registry {
      Id
      Uri
      Name
    }
    Attachment {
      Id
      Generated
      Type
    }
    SubscriptionId
  }
  Purchase_aggregate(where: {Token: {_eq: $token}}, order_by: {Reference: asc}) {
    aggregate {
      sum {
        Quantity
      }
      sum {
        Total
      }
    }
  }
}
    `;

/**
 * __useGetPurchaseDetailByTokenQuery__
 *
 * To run a query within a React component, call `useGetPurchaseDetailByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseDetailByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseDetailByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetPurchaseDetailByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseDetailByTokenQuery, GetPurchaseDetailByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseDetailByTokenQuery, GetPurchaseDetailByTokenQueryVariables>(GetPurchaseDetailByTokenDocument, options);
      }
export function useGetPurchaseDetailByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseDetailByTokenQuery, GetPurchaseDetailByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseDetailByTokenQuery, GetPurchaseDetailByTokenQueryVariables>(GetPurchaseDetailByTokenDocument, options);
        }
export type GetPurchaseDetailByTokenQueryHookResult = ReturnType<typeof useGetPurchaseDetailByTokenQuery>;
export type GetPurchaseDetailByTokenLazyQueryHookResult = ReturnType<typeof useGetPurchaseDetailByTokenLazyQuery>;
export type GetPurchaseDetailByTokenQueryResult = Apollo.QueryResult<GetPurchaseDetailByTokenQuery, GetPurchaseDetailByTokenQueryVariables>;
export const GetRegistryViewDocument = gql`
    query getRegistryView($id: uuid!, $funderId: uuid!) {
  RegistryView(where: {Id: {_eq: $id}, Account: {FunderId: {_eq: $funderId}}}) {
    Id
    Reference
    Name
    ClosesOn
    CreatedOn
    IsClosed
    IsCampaign
    Summary
    Uri
    Description
    Hero
    Trees
    Gifts
    RegionName
    IsHidden
    RegionId
    Account {
      Id
      Name
    }
  }
}
    `;

/**
 * __useGetRegistryViewQuery__
 *
 * To run a query within a React component, call `useGetRegistryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useGetRegistryViewQuery(baseOptions: Apollo.QueryHookOptions<GetRegistryViewQuery, GetRegistryViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistryViewQuery, GetRegistryViewQueryVariables>(GetRegistryViewDocument, options);
      }
export function useGetRegistryViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistryViewQuery, GetRegistryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistryViewQuery, GetRegistryViewQueryVariables>(GetRegistryViewDocument, options);
        }
export type GetRegistryViewQueryHookResult = ReturnType<typeof useGetRegistryViewQuery>;
export type GetRegistryViewLazyQueryHookResult = ReturnType<typeof useGetRegistryViewLazyQuery>;
export type GetRegistryViewQueryResult = Apollo.QueryResult<GetRegistryViewQuery, GetRegistryViewQueryVariables>;
export const ListRegistriesDocument = gql`
    query listRegistries($funderId: uuid!, $limit: Int!, $offset: Int!) {
  registriesAggregate: RegistryView_aggregate(
    where: {Account: {FunderId: {_eq: $funderId}}}
  ) {
    aggregate {
      count
    }
  }
  registries: RegistryView(
    limit: $limit
    offset: $offset
    order_by: {CreatedOn: desc}
    where: {Account: {FunderId: {_eq: $funderId}}}
  ) {
    Id
    ClosesOn
    CreatedOn
    Description
    Gifts
    Hero
    IsClosed
    Name
    RegionName
    Trees
    Uri
    Purchases_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useListRegistriesQuery__
 *
 * To run a query within a React component, call `useListRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegistriesQuery({
 *   variables: {
 *      funderId: // value for 'funderId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListRegistriesQuery(baseOptions: Apollo.QueryHookOptions<ListRegistriesQuery, ListRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegistriesQuery, ListRegistriesQueryVariables>(ListRegistriesDocument, options);
      }
export function useListRegistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegistriesQuery, ListRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegistriesQuery, ListRegistriesQueryVariables>(ListRegistriesDocument, options);
        }
export type ListRegistriesQueryHookResult = ReturnType<typeof useListRegistriesQuery>;
export type ListRegistriesLazyQueryHookResult = ReturnType<typeof useListRegistriesLazyQuery>;
export type ListRegistriesQueryResult = Apollo.QueryResult<ListRegistriesQuery, ListRegistriesQueryVariables>;
export const GetAdminRegistryViewDocument = gql`
    query getAdminRegistryView($id: uuid!) {
  RegistryView(where: {Id: {_eq: $id}}) {
    Id
    Reference
    Name
    ClosesOn
    CreatedOn
    IsClosed
    IsCampaign
    Summary
    Uri
    Description
    Hero
    Trees
    Gifts
    RegionName
    IsHidden
    RegionId
    Account {
      Id
      Name
      Email
    }
  }
}
    `;

/**
 * __useGetAdminRegistryViewQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdminRegistryViewQuery(baseOptions: Apollo.QueryHookOptions<GetAdminRegistryViewQuery, GetAdminRegistryViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminRegistryViewQuery, GetAdminRegistryViewQueryVariables>(GetAdminRegistryViewDocument, options);
      }
export function useGetAdminRegistryViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminRegistryViewQuery, GetAdminRegistryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminRegistryViewQuery, GetAdminRegistryViewQueryVariables>(GetAdminRegistryViewDocument, options);
        }
export type GetAdminRegistryViewQueryHookResult = ReturnType<typeof useGetAdminRegistryViewQuery>;
export type GetAdminRegistryViewLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryViewLazyQuery>;
export type GetAdminRegistryViewQueryResult = Apollo.QueryResult<GetAdminRegistryViewQuery, GetAdminRegistryViewQueryVariables>;
export const ListAdminRegistriesDocument = gql`
    query listAdminRegistries($offset: Int!, $where: Registry_bool_exp, $order: [Registry_order_by!]) {
  Registry(offset: $offset, limit: 10, where: $where, order_by: $order) {
    Id
    Reference
    Name
    Uri
    IsClosed
    CreatedOn
    ClosesOn
    Funder {
      Account {
        Id
        Name
        Email
      }
    }
  }
  Registry_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useListAdminRegistriesQuery__
 *
 * To run a query within a React component, call `useListAdminRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminRegistriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAdminRegistriesQuery(baseOptions: Apollo.QueryHookOptions<ListAdminRegistriesQuery, ListAdminRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAdminRegistriesQuery, ListAdminRegistriesQueryVariables>(ListAdminRegistriesDocument, options);
      }
export function useListAdminRegistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminRegistriesQuery, ListAdminRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAdminRegistriesQuery, ListAdminRegistriesQueryVariables>(ListAdminRegistriesDocument, options);
        }
export type ListAdminRegistriesQueryHookResult = ReturnType<typeof useListAdminRegistriesQuery>;
export type ListAdminRegistriesLazyQueryHookResult = ReturnType<typeof useListAdminRegistriesLazyQuery>;
export type ListAdminRegistriesQueryResult = Apollo.QueryResult<ListAdminRegistriesQuery, ListAdminRegistriesQueryVariables>;
export const GetRegistryByUriDocument = gql`
    query getRegistryByUri($uri: String!) {
  Registry(where: {Uri: {_eq: $uri}}) {
    Id
    Name
  }
}
    `;

/**
 * __useGetRegistryByUriQuery__
 *
 * To run a query within a React component, call `useGetRegistryByUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryByUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryByUriQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *   },
 * });
 */
export function useGetRegistryByUriQuery(baseOptions: Apollo.QueryHookOptions<GetRegistryByUriQuery, GetRegistryByUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistryByUriQuery, GetRegistryByUriQueryVariables>(GetRegistryByUriDocument, options);
      }
export function useGetRegistryByUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistryByUriQuery, GetRegistryByUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistryByUriQuery, GetRegistryByUriQueryVariables>(GetRegistryByUriDocument, options);
        }
export type GetRegistryByUriQueryHookResult = ReturnType<typeof useGetRegistryByUriQuery>;
export type GetRegistryByUriLazyQueryHookResult = ReturnType<typeof useGetRegistryByUriLazyQuery>;
export type GetRegistryByUriQueryResult = Apollo.QueryResult<GetRegistryByUriQuery, GetRegistryByUriQueryVariables>;
export const GetRegistryByIdDocument = gql`
    query getRegistryById($id: uuid!) {
  Registry_by_pk(Id: $id) {
    Id
    Uri
    Name
    IsCampaign
    CreatedOn
    ClosesOn
    RegionId
    Funder {
      Id
      Account {
        Id
        Name
      }
    }
  }
}
    `;

/**
 * __useGetRegistryByIdQuery__
 *
 * To run a query within a React component, call `useGetRegistryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegistryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRegistryByIdQuery, GetRegistryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistryByIdQuery, GetRegistryByIdQueryVariables>(GetRegistryByIdDocument, options);
      }
export function useGetRegistryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistryByIdQuery, GetRegistryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistryByIdQuery, GetRegistryByIdQueryVariables>(GetRegistryByIdDocument, options);
        }
export type GetRegistryByIdQueryHookResult = ReturnType<typeof useGetRegistryByIdQuery>;
export type GetRegistryByIdLazyQueryHookResult = ReturnType<typeof useGetRegistryByIdLazyQuery>;
export type GetRegistryByIdQueryResult = Apollo.QueryResult<GetRegistryByIdQuery, GetRegistryByIdQueryVariables>;
export const GetRegistryViewByUriDocument = gql`
    query getRegistryViewByUri($uri: String!, $isClosed: Boolean = false) {
  registries: RegistryView(where: {Uri: {_eq: $uri}, IsClosed: {_eq: $isClosed}}) {
    Id
    ClosesOn
    CreatedOn
    Name
    Uri
    Description
    Hero
    Trees
    Gifts
    IsCampaign
    Summary
    Account {
      Id
      Name
      Type
      Uri
      Email
      Funder {
        Id
        IsHidden
      }
      Planter {
        Id
        IsHidden
      }
    }
  }
}
    `;

/**
 * __useGetRegistryViewByUriQuery__
 *
 * To run a query within a React component, call `useGetRegistryViewByUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryViewByUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryViewByUriQuery({
 *   variables: {
 *      uri: // value for 'uri'
 *      isClosed: // value for 'isClosed'
 *   },
 * });
 */
export function useGetRegistryViewByUriQuery(baseOptions: Apollo.QueryHookOptions<GetRegistryViewByUriQuery, GetRegistryViewByUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistryViewByUriQuery, GetRegistryViewByUriQueryVariables>(GetRegistryViewByUriDocument, options);
      }
export function useGetRegistryViewByUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistryViewByUriQuery, GetRegistryViewByUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistryViewByUriQuery, GetRegistryViewByUriQueryVariables>(GetRegistryViewByUriDocument, options);
        }
export type GetRegistryViewByUriQueryHookResult = ReturnType<typeof useGetRegistryViewByUriQuery>;
export type GetRegistryViewByUriLazyQueryHookResult = ReturnType<typeof useGetRegistryViewByUriLazyQuery>;
export type GetRegistryViewByUriQueryResult = Apollo.QueryResult<GetRegistryViewByUriQuery, GetRegistryViewByUriQueryVariables>;
export const GetRegistriesDocument = gql`
    query getRegistries($offset: Int!, $orderBy: [RegistryView_order_by!]!) {
  registriesAggregate: RegistryView_aggregate(
    where: {IsClosed: {_eq: false}, IsHidden: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
  registries: RegistryView(
    limit: 20
    offset: $offset
    order_by: $orderBy
    where: {IsClosed: {_eq: false}, IsHidden: {_eq: false}}
  ) {
    Id
    ClosesOn
    CreatedOn
    Name
    Uri
    Description
    Hero
    Trees
    Gifts
    IsCampaign
    Summary
  }
}
    `;

/**
 * __useGetRegistriesQuery__
 *
 * To run a query within a React component, call `useGetRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistriesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetRegistriesQuery(baseOptions: Apollo.QueryHookOptions<GetRegistriesQuery, GetRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistriesQuery, GetRegistriesQueryVariables>(GetRegistriesDocument, options);
      }
export function useGetRegistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistriesQuery, GetRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistriesQuery, GetRegistriesQueryVariables>(GetRegistriesDocument, options);
        }
export type GetRegistriesQueryHookResult = ReturnType<typeof useGetRegistriesQuery>;
export type GetRegistriesLazyQueryHookResult = ReturnType<typeof useGetRegistriesLazyQuery>;
export type GetRegistriesQueryResult = Apollo.QueryResult<GetRegistriesQuery, GetRegistriesQueryVariables>;
export const UpdateRegistryDocument = gql`
    mutation updateRegistry($id: uuid!, $input: Registry_set_input!) {
  update_Registry_by_pk(pk_columns: {Id: $id}, _set: $input) {
    Id
  }
}
    `;
export type UpdateRegistryMutationFn = Apollo.MutationFunction<UpdateRegistryMutation, UpdateRegistryMutationVariables>;

/**
 * __useUpdateRegistryMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryMutation, { data, loading, error }] = useUpdateRegistryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegistryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegistryMutation, UpdateRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegistryMutation, UpdateRegistryMutationVariables>(UpdateRegistryDocument, options);
      }
export type UpdateRegistryMutationHookResult = ReturnType<typeof useUpdateRegistryMutation>;
export type UpdateRegistryMutationResult = Apollo.MutationResult<UpdateRegistryMutation>;
export type UpdateRegistryMutationOptions = Apollo.BaseMutationOptions<UpdateRegistryMutation, UpdateRegistryMutationVariables>;
export const CreateRegistryDocument = gql`
    mutation createRegistry($input: CreateRegistryInput!) {
  create_registry(input: $input) {
    Id
  }
}
    `;
export type CreateRegistryMutationFn = Apollo.MutationFunction<CreateRegistryMutation, CreateRegistryMutationVariables>;

/**
 * __useCreateRegistryMutation__
 *
 * To run a mutation, you first call `useCreateRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryMutation, { data, loading, error }] = useCreateRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegistryMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegistryMutation, CreateRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegistryMutation, CreateRegistryMutationVariables>(CreateRegistryDocument, options);
      }
export type CreateRegistryMutationHookResult = ReturnType<typeof useCreateRegistryMutation>;
export type CreateRegistryMutationResult = Apollo.MutationResult<CreateRegistryMutation>;
export type CreateRegistryMutationOptions = Apollo.BaseMutationOptions<CreateRegistryMutation, CreateRegistryMutationVariables>;
export const InsertRegistryDocument = gql`
    mutation insertRegistry($input: Registry_insert_input!) {
  insert_Registry_one(object: $input) {
    Id
  }
}
    `;
export type InsertRegistryMutationFn = Apollo.MutationFunction<InsertRegistryMutation, InsertRegistryMutationVariables>;

/**
 * __useInsertRegistryMutation__
 *
 * To run a mutation, you first call `useInsertRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRegistryMutation, { data, loading, error }] = useInsertRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertRegistryMutation(baseOptions?: Apollo.MutationHookOptions<InsertRegistryMutation, InsertRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRegistryMutation, InsertRegistryMutationVariables>(InsertRegistryDocument, options);
      }
export type InsertRegistryMutationHookResult = ReturnType<typeof useInsertRegistryMutation>;
export type InsertRegistryMutationResult = Apollo.MutationResult<InsertRegistryMutation>;
export type InsertRegistryMutationOptions = Apollo.BaseMutationOptions<InsertRegistryMutation, InsertRegistryMutationVariables>;
export const UpdateAdminRegistriesForClosureDocument = gql`
    mutation UpdateAdminRegistriesForClosure($now: timestamp!) {
  closedRegistries: update_Registry(
    where: {ClosesOn: {_lt: $now}, IsClosed: {_eq: false}}
    _set: {IsClosed: true}
  ) {
    affected_rows
    returning {
      Id
      Name
      IsClosed
      ClosesOn
    }
  }
}
    `;
export type UpdateAdminRegistriesForClosureMutationFn = Apollo.MutationFunction<UpdateAdminRegistriesForClosureMutation, UpdateAdminRegistriesForClosureMutationVariables>;

/**
 * __useUpdateAdminRegistriesForClosureMutation__
 *
 * To run a mutation, you first call `useUpdateAdminRegistriesForClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminRegistriesForClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminRegistriesForClosureMutation, { data, loading, error }] = useUpdateAdminRegistriesForClosureMutation({
 *   variables: {
 *      now: // value for 'now'
 *   },
 * });
 */
export function useUpdateAdminRegistriesForClosureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminRegistriesForClosureMutation, UpdateAdminRegistriesForClosureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminRegistriesForClosureMutation, UpdateAdminRegistriesForClosureMutationVariables>(UpdateAdminRegistriesForClosureDocument, options);
      }
export type UpdateAdminRegistriesForClosureMutationHookResult = ReturnType<typeof useUpdateAdminRegistriesForClosureMutation>;
export type UpdateAdminRegistriesForClosureMutationResult = Apollo.MutationResult<UpdateAdminRegistriesForClosureMutation>;
export type UpdateAdminRegistriesForClosureMutationOptions = Apollo.BaseMutationOptions<UpdateAdminRegistriesForClosureMutation, UpdateAdminRegistriesForClosureMutationVariables>;
export const DeleteRegistryDocument = gql`
    mutation deleteRegistry($input: DeleteRegistryWithNoGiftsInput!) {
  delete_registry_with_no_gifts(input: $input) {
    afffectedRows
  }
}
    `;
export type DeleteRegistryMutationFn = Apollo.MutationFunction<DeleteRegistryMutation, DeleteRegistryMutationVariables>;

/**
 * __useDeleteRegistryMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryMutation, { data, loading, error }] = useDeleteRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegistryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegistryMutation, DeleteRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegistryMutation, DeleteRegistryMutationVariables>(DeleteRegistryDocument, options);
      }
export type DeleteRegistryMutationHookResult = ReturnType<typeof useDeleteRegistryMutation>;
export type DeleteRegistryMutationResult = Apollo.MutationResult<DeleteRegistryMutation>;
export type DeleteRegistryMutationOptions = Apollo.BaseMutationOptions<DeleteRegistryMutation, DeleteRegistryMutationVariables>;
export const DeleteAdminRegistryDocument = gql`
    mutation deleteAdminRegistry($id: uuid!, $funderId: uuid!) {
  delete_Registry(where: {Id: {_eq: $id}, FunderId: {_eq: $funderId}}) {
    affected_rows
  }
}
    `;
export type DeleteAdminRegistryMutationFn = Apollo.MutationFunction<DeleteAdminRegistryMutation, DeleteAdminRegistryMutationVariables>;

/**
 * __useDeleteAdminRegistryMutation__
 *
 * To run a mutation, you first call `useDeleteAdminRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminRegistryMutation, { data, loading, error }] = useDeleteAdminRegistryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useDeleteAdminRegistryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminRegistryMutation, DeleteAdminRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminRegistryMutation, DeleteAdminRegistryMutationVariables>(DeleteAdminRegistryDocument, options);
      }
export type DeleteAdminRegistryMutationHookResult = ReturnType<typeof useDeleteAdminRegistryMutation>;
export type DeleteAdminRegistryMutationResult = Apollo.MutationResult<DeleteAdminRegistryMutation>;
export type DeleteAdminRegistryMutationOptions = Apollo.BaseMutationOptions<DeleteAdminRegistryMutation, DeleteAdminRegistryMutationVariables>;
export const CreatePurchasesReportDocument = gql`
    mutation createPurchasesReport($input: CreatePurchasesReportInput!) {
  report: create_purchases_report(input: $input) {
    Report {
      Id
      Filename
      Expires
      State
      Type
      CreatedOn
      UpdatedOn
    }
  }
}
    `;
export type CreatePurchasesReportMutationFn = Apollo.MutationFunction<CreatePurchasesReportMutation, CreatePurchasesReportMutationVariables>;

/**
 * __useCreatePurchasesReportMutation__
 *
 * To run a mutation, you first call `useCreatePurchasesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchasesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchasesReportMutation, { data, loading, error }] = useCreatePurchasesReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePurchasesReportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchasesReportMutation, CreatePurchasesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchasesReportMutation, CreatePurchasesReportMutationVariables>(CreatePurchasesReportDocument, options);
      }
export type CreatePurchasesReportMutationHookResult = ReturnType<typeof useCreatePurchasesReportMutation>;
export type CreatePurchasesReportMutationResult = Apollo.MutationResult<CreatePurchasesReportMutation>;
export type CreatePurchasesReportMutationOptions = Apollo.BaseMutationOptions<CreatePurchasesReportMutation, CreatePurchasesReportMutationVariables>;
export const CreateTreePoolReportDocument = gql`
    mutation createTreePoolReport($input: CreateTreePoolReportInput!) {
  report: create_tree_pool_report(input: $input) {
    Report {
      Id
      Filename
      Expires
      State
      Type
      CreatedOn
      UpdatedOn
    }
  }
}
    `;
export type CreateTreePoolReportMutationFn = Apollo.MutationFunction<CreateTreePoolReportMutation, CreateTreePoolReportMutationVariables>;

/**
 * __useCreateTreePoolReportMutation__
 *
 * To run a mutation, you first call `useCreateTreePoolReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTreePoolReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTreePoolReportMutation, { data, loading, error }] = useCreateTreePoolReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTreePoolReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateTreePoolReportMutation, CreateTreePoolReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTreePoolReportMutation, CreateTreePoolReportMutationVariables>(CreateTreePoolReportDocument, options);
      }
export type CreateTreePoolReportMutationHookResult = ReturnType<typeof useCreateTreePoolReportMutation>;
export type CreateTreePoolReportMutationResult = Apollo.MutationResult<CreateTreePoolReportMutation>;
export type CreateTreePoolReportMutationOptions = Apollo.BaseMutationOptions<CreateTreePoolReportMutation, CreateTreePoolReportMutationVariables>;
export const CreateAccountsReportDocument = gql`
    mutation createAccountsReport($input: CreateAccountsReportInput!) {
  report: create_accounts_report(input: $input) {
    Report {
      Id
      Filename
      Expires
      State
      Type
      CreatedOn
      UpdatedOn
    }
  }
}
    `;
export type CreateAccountsReportMutationFn = Apollo.MutationFunction<CreateAccountsReportMutation, CreateAccountsReportMutationVariables>;

/**
 * __useCreateAccountsReportMutation__
 *
 * To run a mutation, you first call `useCreateAccountsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountsReportMutation, { data, loading, error }] = useCreateAccountsReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountsReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountsReportMutation, CreateAccountsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountsReportMutation, CreateAccountsReportMutationVariables>(CreateAccountsReportDocument, options);
      }
export type CreateAccountsReportMutationHookResult = ReturnType<typeof useCreateAccountsReportMutation>;
export type CreateAccountsReportMutationResult = Apollo.MutationResult<CreateAccountsReportMutation>;
export type CreateAccountsReportMutationOptions = Apollo.BaseMutationOptions<CreateAccountsReportMutation, CreateAccountsReportMutationVariables>;
export const GetReportDocument = gql`
    query getReport($id: uuid!) {
  report: Report_by_pk(Id: $id) {
    Id
    Filename
    Expires
    State
    Type
    CreatedOn
    UpdatedOn
  }
}
    `;

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportQuery(baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
      }
export function useGetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>;
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>;
export type GetReportQueryResult = Apollo.QueryResult<GetReportQuery, GetReportQueryVariables>;
export const GeneratePresignedUrlDocument = gql`
    query generatePresignedUrl($path: String!) {
  presignedUrl: generate_presigned_url(S3Path: $path)
}
    `;

/**
 * __useGeneratePresignedUrlQuery__
 *
 * To run a query within a React component, call `useGeneratePresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePresignedUrlQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGeneratePresignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>(GeneratePresignedUrlDocument, options);
      }
export function useGeneratePresignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>(GeneratePresignedUrlDocument, options);
        }
export type GeneratePresignedUrlQueryHookResult = ReturnType<typeof useGeneratePresignedUrlQuery>;
export type GeneratePresignedUrlLazyQueryHookResult = ReturnType<typeof useGeneratePresignedUrlLazyQuery>;
export type GeneratePresignedUrlQueryResult = Apollo.QueryResult<GeneratePresignedUrlQuery, GeneratePresignedUrlQueryVariables>;
export const GeneratePutObjectPresignedUrlDocument = gql`
    mutation generatePutObjectPresignedUrl($input: GeneratePutObjectPresignedUrlInput!) {
  generate_put_object_presigned_url(input: $input) {
    S3Key
    SignedUrl
  }
}
    `;
export type GeneratePutObjectPresignedUrlMutationFn = Apollo.MutationFunction<GeneratePutObjectPresignedUrlMutation, GeneratePutObjectPresignedUrlMutationVariables>;

/**
 * __useGeneratePutObjectPresignedUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePutObjectPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePutObjectPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePutObjectPresignedUrlMutation, { data, loading, error }] = useGeneratePutObjectPresignedUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePutObjectPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePutObjectPresignedUrlMutation, GeneratePutObjectPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePutObjectPresignedUrlMutation, GeneratePutObjectPresignedUrlMutationVariables>(GeneratePutObjectPresignedUrlDocument, options);
      }
export type GeneratePutObjectPresignedUrlMutationHookResult = ReturnType<typeof useGeneratePutObjectPresignedUrlMutation>;
export type GeneratePutObjectPresignedUrlMutationResult = Apollo.MutationResult<GeneratePutObjectPresignedUrlMutation>;
export type GeneratePutObjectPresignedUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePutObjectPresignedUrlMutation, GeneratePutObjectPresignedUrlMutationVariables>;
export const ListOpenSeasonsDocument = gql`
    query ListOpenSeasons {
  Season(where: {ApplicationsClosed: {_eq: false}}) {
    Id
    Name
  }
}
    `;

/**
 * __useListOpenSeasonsQuery__
 *
 * To run a query within a React component, call `useListOpenSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOpenSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOpenSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOpenSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<ListOpenSeasonsQuery, ListOpenSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOpenSeasonsQuery, ListOpenSeasonsQueryVariables>(ListOpenSeasonsDocument, options);
      }
export function useListOpenSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOpenSeasonsQuery, ListOpenSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOpenSeasonsQuery, ListOpenSeasonsQueryVariables>(ListOpenSeasonsDocument, options);
        }
export type ListOpenSeasonsQueryHookResult = ReturnType<typeof useListOpenSeasonsQuery>;
export type ListOpenSeasonsLazyQueryHookResult = ReturnType<typeof useListOpenSeasonsLazyQuery>;
export type ListOpenSeasonsQueryResult = Apollo.QueryResult<ListOpenSeasonsQuery, ListOpenSeasonsQueryVariables>;
export const ListSeasonsDocument = gql`
    query listSeasons {
  Season(order_by: {Name: desc}) {
    Id
    Name
    ApplicationsClosed
  }
}
    `;

/**
 * __useListSeasonsQuery__
 *
 * To run a query within a React component, call `useListSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<ListSeasonsQuery, ListSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSeasonsQuery, ListSeasonsQueryVariables>(ListSeasonsDocument, options);
      }
export function useListSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSeasonsQuery, ListSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSeasonsQuery, ListSeasonsQueryVariables>(ListSeasonsDocument, options);
        }
export type ListSeasonsQueryHookResult = ReturnType<typeof useListSeasonsQuery>;
export type ListSeasonsLazyQueryHookResult = ReturnType<typeof useListSeasonsLazyQuery>;
export type ListSeasonsQueryResult = Apollo.QueryResult<ListSeasonsQuery, ListSeasonsQueryVariables>;
export const GetRegionByIdDocument = gql`
    query getRegionById($regionId: uuid!) {
  Region(where: {Id: {_eq: $regionId}}) {
    Id
    Name
    AltName
  }
}
    `;

/**
 * __useGetRegionByIdQuery__
 *
 * To run a query within a React component, call `useGetRegionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionByIdQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetRegionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRegionByIdQuery, GetRegionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionByIdQuery, GetRegionByIdQueryVariables>(GetRegionByIdDocument, options);
      }
export function useGetRegionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionByIdQuery, GetRegionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionByIdQuery, GetRegionByIdQueryVariables>(GetRegionByIdDocument, options);
        }
export type GetRegionByIdQueryHookResult = ReturnType<typeof useGetRegionByIdQuery>;
export type GetRegionByIdLazyQueryHookResult = ReturnType<typeof useGetRegionByIdLazyQuery>;
export type GetRegionByIdQueryResult = Apollo.QueryResult<GetRegionByIdQuery, GetRegionByIdQueryVariables>;
export const ListRegionsForFormDocument = gql`
    query listRegionsForForm {
  Region(where: {Type: {_in: ["Region", "National", "International"]}}) {
    Id
    Lookups
    Name
    ProperSpelling
    AltName
    Type
  }
}
    `;

/**
 * __useListRegionsForFormQuery__
 *
 * To run a query within a React component, call `useListRegionsForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionsForFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionsForFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRegionsForFormQuery(baseOptions?: Apollo.QueryHookOptions<ListRegionsForFormQuery, ListRegionsForFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionsForFormQuery, ListRegionsForFormQueryVariables>(ListRegionsForFormDocument, options);
      }
export function useListRegionsForFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionsForFormQuery, ListRegionsForFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionsForFormQuery, ListRegionsForFormQueryVariables>(ListRegionsForFormDocument, options);
        }
export type ListRegionsForFormQueryHookResult = ReturnType<typeof useListRegionsForFormQuery>;
export type ListRegionsForFormLazyQueryHookResult = ReturnType<typeof useListRegionsForFormLazyQuery>;
export type ListRegionsForFormQueryResult = Apollo.QueryResult<ListRegionsForFormQuery, ListRegionsForFormQueryVariables>;
export const ListRegionsDocument = gql`
    query listRegions {
  Region(where: {Type: {_in: ["Region", "National", "International"]}}) {
    Id
    Lookups
    Name
  }
}
    `;

/**
 * __useListRegionsQuery__
 *
 * To run a query within a React component, call `useListRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRegionsQuery(baseOptions?: Apollo.QueryHookOptions<ListRegionsQuery, ListRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionsQuery, ListRegionsQueryVariables>(ListRegionsDocument, options);
      }
export function useListRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionsQuery, ListRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionsQuery, ListRegionsQueryVariables>(ListRegionsDocument, options);
        }
export type ListRegionsQueryHookResult = ReturnType<typeof useListRegionsQuery>;
export type ListRegionsLazyQueryHookResult = ReturnType<typeof useListRegionsLazyQuery>;
export type ListRegionsQueryResult = Apollo.QueryResult<ListRegionsQuery, ListRegionsQueryVariables>;
export const ListDistrictsDocument = gql`
    query listDistricts {
  District {
    Id
    Lookups
    Name
  }
}
    `;

/**
 * __useListDistrictsQuery__
 *
 * To run a query within a React component, call `useListDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDistrictsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<ListDistrictsQuery, ListDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDistrictsQuery, ListDistrictsQueryVariables>(ListDistrictsDocument, options);
      }
export function useListDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDistrictsQuery, ListDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDistrictsQuery, ListDistrictsQueryVariables>(ListDistrictsDocument, options);
        }
export type ListDistrictsQueryHookResult = ReturnType<typeof useListDistrictsQuery>;
export type ListDistrictsLazyQueryHookResult = ReturnType<typeof useListDistrictsLazyQuery>;
export type ListDistrictsQueryResult = Apollo.QueryResult<ListDistrictsQuery, ListDistrictsQueryVariables>;
export const ListSeasonsAndSpeciesDocument = gql`
    query listSeasonsAndSpecies {
  Season(order_by: {Name: desc}) {
    Id
    Name
  }
  Species {
    Id
    Name
    Scientific
    Type
  }
}
    `;

/**
 * __useListSeasonsAndSpeciesQuery__
 *
 * To run a query within a React component, call `useListSeasonsAndSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSeasonsAndSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSeasonsAndSpeciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSeasonsAndSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<ListSeasonsAndSpeciesQuery, ListSeasonsAndSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSeasonsAndSpeciesQuery, ListSeasonsAndSpeciesQueryVariables>(ListSeasonsAndSpeciesDocument, options);
      }
export function useListSeasonsAndSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSeasonsAndSpeciesQuery, ListSeasonsAndSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSeasonsAndSpeciesQuery, ListSeasonsAndSpeciesQueryVariables>(ListSeasonsAndSpeciesDocument, options);
        }
export type ListSeasonsAndSpeciesQueryHookResult = ReturnType<typeof useListSeasonsAndSpeciesQuery>;
export type ListSeasonsAndSpeciesLazyQueryHookResult = ReturnType<typeof useListSeasonsAndSpeciesLazyQuery>;
export type ListSeasonsAndSpeciesQueryResult = Apollo.QueryResult<ListSeasonsAndSpeciesQuery, ListSeasonsAndSpeciesQueryVariables>;
export const ListRegionsAndDistrictsDocument = gql`
    query listRegionsAndDistricts {
  District {
    Id
    Lookups
    Name
    ProperSpelling
    RegionDistricts {
      RegionId
    }
  }
  Region(where: {Type: {_in: ["Region", "National"]}}) {
    Id
    AltName
    Lookups
    Name
    ProperSpelling
    Reference
  }
}
    `;

/**
 * __useListRegionsAndDistrictsQuery__
 *
 * To run a query within a React component, call `useListRegionsAndDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionsAndDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionsAndDistrictsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRegionsAndDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<ListRegionsAndDistrictsQuery, ListRegionsAndDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionsAndDistrictsQuery, ListRegionsAndDistrictsQueryVariables>(ListRegionsAndDistrictsDocument, options);
      }
export function useListRegionsAndDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionsAndDistrictsQuery, ListRegionsAndDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionsAndDistrictsQuery, ListRegionsAndDistrictsQueryVariables>(ListRegionsAndDistrictsDocument, options);
        }
export type ListRegionsAndDistrictsQueryHookResult = ReturnType<typeof useListRegionsAndDistrictsQuery>;
export type ListRegionsAndDistrictsLazyQueryHookResult = ReturnType<typeof useListRegionsAndDistrictsLazyQuery>;
export type ListRegionsAndDistrictsQueryResult = Apollo.QueryResult<ListRegionsAndDistrictsQuery, ListRegionsAndDistrictsQueryVariables>;
export const ListRegionsForSearchApplicationsDocument = gql`
    query listRegionsForSearchApplications {
  Region(
    order_by: [{Reference: asc}]
    where: {Type: {_in: ["Region", "National"]}}
  ) {
    Id
    Name
  }
}
    `;

/**
 * __useListRegionsForSearchApplicationsQuery__
 *
 * To run a query within a React component, call `useListRegionsForSearchApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionsForSearchApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionsForSearchApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRegionsForSearchApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<ListRegionsForSearchApplicationsQuery, ListRegionsForSearchApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionsForSearchApplicationsQuery, ListRegionsForSearchApplicationsQueryVariables>(ListRegionsForSearchApplicationsDocument, options);
      }
export function useListRegionsForSearchApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionsForSearchApplicationsQuery, ListRegionsForSearchApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionsForSearchApplicationsQuery, ListRegionsForSearchApplicationsQueryVariables>(ListRegionsForSearchApplicationsDocument, options);
        }
export type ListRegionsForSearchApplicationsQueryHookResult = ReturnType<typeof useListRegionsForSearchApplicationsQuery>;
export type ListRegionsForSearchApplicationsLazyQueryHookResult = ReturnType<typeof useListRegionsForSearchApplicationsLazyQuery>;
export type ListRegionsForSearchApplicationsQueryResult = Apollo.QueryResult<ListRegionsForSearchApplicationsQuery, ListRegionsForSearchApplicationsQueryVariables>;
export const GetDashboardDataDocument = gql`
    query getDashboardData {
  PlanterStatsForUser {
    MostPopularRegion
    MostPopularSpecies
    Rank
    SeasonName
    TotalMonitorings
    TotalApplications
    TotalProjects
    TreesApproved
    AccountYearJoined
  }
  FunderStatsForUser {
    PlantersSupported
    ProjectSupported
    Rank
    SeasonName
    TreesFunded
    AccountYearJoined
  }
}
    `;

/**
 * __useGetDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardDataQuery, GetDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardDataQuery, GetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
      }
export function useGetDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardDataQuery, GetDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardDataQuery, GetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
        }
export type GetDashboardDataQueryHookResult = ReturnType<typeof useGetDashboardDataQuery>;
export type GetDashboardDataLazyQueryHookResult = ReturnType<typeof useGetDashboardDataLazyQuery>;
export type GetDashboardDataQueryResult = Apollo.QueryResult<GetDashboardDataQuery, GetDashboardDataQueryVariables>;
export const GetPlanterViewDocument = gql`
    query getPlanterView($limit: Int!, $offset: Int!, $where: PlanterView_bool_exp, $order_by: [PlanterView_order_by!]) {
  PlanterView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  PlanterView(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    TotalTreesApproved
    Avatar
    CurrentSeason
    BeforeLastSeason
    Id
    LastSeason
    Name
    ApplicationCount
    Rank
    RegionId
    RegionName
    Type
    Uri
  }
}
    `;

/**
 * __useGetPlanterViewQuery__
 *
 * To run a query within a React component, call `useGetPlanterViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanterViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanterViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetPlanterViewQuery(baseOptions: Apollo.QueryHookOptions<GetPlanterViewQuery, GetPlanterViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanterViewQuery, GetPlanterViewQueryVariables>(GetPlanterViewDocument, options);
      }
export function useGetPlanterViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanterViewQuery, GetPlanterViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanterViewQuery, GetPlanterViewQueryVariables>(GetPlanterViewDocument, options);
        }
export type GetPlanterViewQueryHookResult = ReturnType<typeof useGetPlanterViewQuery>;
export type GetPlanterViewLazyQueryHookResult = ReturnType<typeof useGetPlanterViewLazyQuery>;
export type GetPlanterViewQueryResult = Apollo.QueryResult<GetPlanterViewQuery, GetPlanterViewQueryVariables>;
export const GetFunderViewDocument = gql`
    query getFunderView($limit: Int!, $offset: Int!, $where: FunderView_bool_exp, $order_by: [FunderView_order_by!]) {
  FunderView_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  FunderView(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    Avatar
    BeforeLastSeason
    CurrentSeason
    Id
    LastSeason
    Name
    PlanterCount
    Rank
    RegionId
    RegionName
    TotalCount
    Type
    Uri
  }
}
    `;

/**
 * __useGetFunderViewQuery__
 *
 * To run a query within a React component, call `useGetFunderViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetFunderViewQuery(baseOptions: Apollo.QueryHookOptions<GetFunderViewQuery, GetFunderViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderViewQuery, GetFunderViewQueryVariables>(GetFunderViewDocument, options);
      }
export function useGetFunderViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderViewQuery, GetFunderViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderViewQuery, GetFunderViewQueryVariables>(GetFunderViewDocument, options);
        }
export type GetFunderViewQueryHookResult = ReturnType<typeof useGetFunderViewQuery>;
export type GetFunderViewLazyQueryHookResult = ReturnType<typeof useGetFunderViewLazyQuery>;
export type GetFunderViewQueryResult = Apollo.QueryResult<GetFunderViewQuery, GetFunderViewQueryVariables>;
export const GetTreePoolStatsDocument = gql`
    query getTreePoolStats {
  statistics: TreePoolStatsView {
    Applications
    Approved
    ApplicationsApproved
    Funders
    Id
    Matched
    Name
    Total
    TreesMatched
    TreesUnmatched
    Unmatched
  }
}
    `;

/**
 * __useGetTreePoolStatsQuery__
 *
 * To run a query within a React component, call `useGetTreePoolStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreePoolStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreePoolStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTreePoolStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTreePoolStatsQuery, GetTreePoolStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreePoolStatsQuery, GetTreePoolStatsQueryVariables>(GetTreePoolStatsDocument, options);
      }
export function useGetTreePoolStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreePoolStatsQuery, GetTreePoolStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreePoolStatsQuery, GetTreePoolStatsQueryVariables>(GetTreePoolStatsDocument, options);
        }
export type GetTreePoolStatsQueryHookResult = ReturnType<typeof useGetTreePoolStatsQuery>;
export type GetTreePoolStatsLazyQueryHookResult = ReturnType<typeof useGetTreePoolStatsLazyQuery>;
export type GetTreePoolStatsQueryResult = Apollo.QueryResult<GetTreePoolStatsQuery, GetTreePoolStatsQueryVariables>;
export const GetTreesFundedDocument = gql`
    query getTreesFunded {
  funderStats: FunderStatsForUser {
    SeasonName
    TreesFunded
  }
}
    `;

/**
 * __useGetTreesFundedQuery__
 *
 * To run a query within a React component, call `useGetTreesFundedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreesFundedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreesFundedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTreesFundedQuery(baseOptions?: Apollo.QueryHookOptions<GetTreesFundedQuery, GetTreesFundedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreesFundedQuery, GetTreesFundedQueryVariables>(GetTreesFundedDocument, options);
      }
export function useGetTreesFundedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreesFundedQuery, GetTreesFundedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreesFundedQuery, GetTreesFundedQueryVariables>(GetTreesFundedDocument, options);
        }
export type GetTreesFundedQueryHookResult = ReturnType<typeof useGetTreesFundedQuery>;
export type GetTreesFundedLazyQueryHookResult = ReturnType<typeof useGetTreesFundedLazyQuery>;
export type GetTreesFundedQueryResult = Apollo.QueryResult<GetTreesFundedQuery, GetTreesFundedQueryVariables>;
export const GetStatisticsDocument = gql`
    query getStatistics @cached(ttl: 300) {
  statistics: StatisticsView {
    PlantingsSupported
    TotalPlantersAndFunders
    TotalTrees
    TotalTreesFundedAndGifted
    TotalTreesFunded
    TotalTreesGifted
    TotalOpenRegistries
  }
}
    `;

/**
 * __useGetStatisticsQuery__
 *
 * To run a query within a React component, call `useGetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, options);
      }
export function useGetStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, options);
        }
export type GetStatisticsQueryHookResult = ReturnType<typeof useGetStatisticsQuery>;
export type GetStatisticsLazyQueryHookResult = ReturnType<typeof useGetStatisticsLazyQuery>;
export type GetStatisticsQueryResult = Apollo.QueryResult<GetStatisticsQuery, GetStatisticsQueryVariables>;
export const GetAccountSubscriptionDetailsDocument = gql`
    query getAccountSubscriptionDetails($funderId: uuid!) {
  Subscription(where: {FunderId: {_eq: $funderId}, State: {_eq: "active"}}) {
    Id
    CreatedOn
    FunderId
    PlantingRegionId
    PublicMessage
    PublicName
    Quantity
    ReceiptEmail
    ReceiptName
    UpdatedOn
    UserId
    StripeSubscriptionId
    Region {
      Id
      Name
    }
    Funder {
      Account {
        StripeCustomerId
        PaymentMethodDescriptor
      }
    }
  }
}
    `;

/**
 * __useGetAccountSubscriptionDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccountSubscriptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSubscriptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSubscriptionDetailsQuery({
 *   variables: {
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useGetAccountSubscriptionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountSubscriptionDetailsQuery, GetAccountSubscriptionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSubscriptionDetailsQuery, GetAccountSubscriptionDetailsQueryVariables>(GetAccountSubscriptionDetailsDocument, options);
      }
export function useGetAccountSubscriptionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSubscriptionDetailsQuery, GetAccountSubscriptionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSubscriptionDetailsQuery, GetAccountSubscriptionDetailsQueryVariables>(GetAccountSubscriptionDetailsDocument, options);
        }
export type GetAccountSubscriptionDetailsQueryHookResult = ReturnType<typeof useGetAccountSubscriptionDetailsQuery>;
export type GetAccountSubscriptionDetailsLazyQueryHookResult = ReturnType<typeof useGetAccountSubscriptionDetailsLazyQuery>;
export type GetAccountSubscriptionDetailsQueryResult = Apollo.QueryResult<GetAccountSubscriptionDetailsQuery, GetAccountSubscriptionDetailsQueryVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription($accountId: String!) {
  subscription: get_subscription(input: {AccountId: $accountId}) {
    CardLastFour
    Subscription {
      TotalQuantity
      TotalAmount
      StartDate
      NextChargeDate
    }
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const UpdateAdminSubscriptionDocument = gql`
    mutation updateAdminSubscription($id: uuid!, $input: Subscription_set_input) {
  subscription: update_Subscription_by_pk(pk_columns: {Id: $id}, _set: $input) {
    CreatedOn
    FunderId
    Id
    PlantingRegionId
    PublicMessage
    PublicName
    Quantity
    ReceiptEmail
    ReceiptName
    UpdatedOn
    UserId
  }
}
    `;
export type UpdateAdminSubscriptionMutationFn = Apollo.MutationFunction<UpdateAdminSubscriptionMutation, UpdateAdminSubscriptionMutationVariables>;

/**
 * __useUpdateAdminSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateAdminSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminSubscriptionMutation, { data, loading, error }] = useUpdateAdminSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminSubscriptionMutation, UpdateAdminSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminSubscriptionMutation, UpdateAdminSubscriptionMutationVariables>(UpdateAdminSubscriptionDocument, options);
      }
export type UpdateAdminSubscriptionMutationHookResult = ReturnType<typeof useUpdateAdminSubscriptionMutation>;
export type UpdateAdminSubscriptionMutationResult = Apollo.MutationResult<UpdateAdminSubscriptionMutation>;
export type UpdateAdminSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateAdminSubscriptionMutation, UpdateAdminSubscriptionMutationVariables>;
export const UpdateAdminSubscriptionByStripeIdDocument = gql`
    mutation updateAdminSubscriptionByStripeId($stripeId: String!, $input: Subscription_set_input) {
  subscriptions: update_Subscription(
    where: {StripeSubscriptionId: {_eq: $stripeId}}
    _set: $input
  ) {
    returning {
      Id
      ReceiptEmail
      ReceiptName
    }
  }
}
    `;
export type UpdateAdminSubscriptionByStripeIdMutationFn = Apollo.MutationFunction<UpdateAdminSubscriptionByStripeIdMutation, UpdateAdminSubscriptionByStripeIdMutationVariables>;

/**
 * __useUpdateAdminSubscriptionByStripeIdMutation__
 *
 * To run a mutation, you first call `useUpdateAdminSubscriptionByStripeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminSubscriptionByStripeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminSubscriptionByStripeIdMutation, { data, loading, error }] = useUpdateAdminSubscriptionByStripeIdMutation({
 *   variables: {
 *      stripeId: // value for 'stripeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminSubscriptionByStripeIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminSubscriptionByStripeIdMutation, UpdateAdminSubscriptionByStripeIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminSubscriptionByStripeIdMutation, UpdateAdminSubscriptionByStripeIdMutationVariables>(UpdateAdminSubscriptionByStripeIdDocument, options);
      }
export type UpdateAdminSubscriptionByStripeIdMutationHookResult = ReturnType<typeof useUpdateAdminSubscriptionByStripeIdMutation>;
export type UpdateAdminSubscriptionByStripeIdMutationResult = Apollo.MutationResult<UpdateAdminSubscriptionByStripeIdMutation>;
export type UpdateAdminSubscriptionByStripeIdMutationOptions = Apollo.BaseMutationOptions<UpdateAdminSubscriptionByStripeIdMutation, UpdateAdminSubscriptionByStripeIdMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($input: UpdateAccountSubscriptionInput!) {
  update_account_subscription(input: $input) {
    Id
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($input: CancelSubscriptionInput!) {
  subscription: cancel_subscription(input: $input) {
    Id
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: String!) {
  User(where: {Email: {_eq: $email}}) {
    Id
    Email
    FirstName
    LastName
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const UpdateUserFirstAndLastNameDocument = gql`
    mutation updateUserFirstAndLastName($id: uuid!, $firstName: String, $lastName: String) {
  update_User_by_pk(
    pk_columns: {Id: $id}
    _set: {FirstName: $firstName, LastName: $lastName}
  ) {
    Id
    FirstName
    LastName
  }
}
    `;
export type UpdateUserFirstAndLastNameMutationFn = Apollo.MutationFunction<UpdateUserFirstAndLastNameMutation, UpdateUserFirstAndLastNameMutationVariables>;

/**
 * __useUpdateUserFirstAndLastNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserFirstAndLastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFirstAndLastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFirstAndLastNameMutation, { data, loading, error }] = useUpdateUserFirstAndLastNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserFirstAndLastNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFirstAndLastNameMutation, UpdateUserFirstAndLastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFirstAndLastNameMutation, UpdateUserFirstAndLastNameMutationVariables>(UpdateUserFirstAndLastNameDocument, options);
      }
export type UpdateUserFirstAndLastNameMutationHookResult = ReturnType<typeof useUpdateUserFirstAndLastNameMutation>;
export type UpdateUserFirstAndLastNameMutationResult = Apollo.MutationResult<UpdateUserFirstAndLastNameMutation>;
export type UpdateUserFirstAndLastNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserFirstAndLastNameMutation, UpdateUserFirstAndLastNameMutationVariables>;
export const GetUserAndMembershipsDocument = gql`
    query getUserAndMemberships($id: uuid!) {
  User: User_by_pk(Id: $id) {
    Id
    Identifier
    Email
    FirstName
    LastName
    Account {
      Id
      CreatedOn
      FunderId
      PlanterId
      Avatar
      Banner
      Type
      Name
      Email
      Uri
      StripeCustomerId
      PaymentMethodDescriptor
      Funder {
        Id
        Name
        IsHidden
      }
      Planter {
        Id
        IsHidden
        ProjectsCount
      }
    }
    ActiveAccountId
    ActiveProfileType
  }
  Membership(where: {UserId: {_eq: $id}}) {
    Id
    Account {
      Id
      Name
      Avatar
      FunderId
      PlanterId
    }
    AccountId
    Type
  }
}
    `;

/**
 * __useGetUserAndMembershipsQuery__
 *
 * To run a query within a React component, call `useGetUserAndMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAndMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAndMembershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAndMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAndMembershipsQuery, GetUserAndMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAndMembershipsQuery, GetUserAndMembershipsQueryVariables>(GetUserAndMembershipsDocument, options);
      }
export function useGetUserAndMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAndMembershipsQuery, GetUserAndMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAndMembershipsQuery, GetUserAndMembershipsQueryVariables>(GetUserAndMembershipsDocument, options);
        }
export type GetUserAndMembershipsQueryHookResult = ReturnType<typeof useGetUserAndMembershipsQuery>;
export type GetUserAndMembershipsLazyQueryHookResult = ReturnType<typeof useGetUserAndMembershipsLazyQuery>;
export type GetUserAndMembershipsQueryResult = Apollo.QueryResult<GetUserAndMembershipsQuery, GetUserAndMembershipsQueryVariables>;
export const UpdateActiveAccountIdDocument = gql`
    mutation updateActiveAccountId($ActiveAccountId: uuid!, $id: uuid!, $ActiveProfileType: String!) {
  update_User_by_pk(
    pk_columns: {Id: $id}
    _set: {ActiveAccountId: $ActiveAccountId, ActiveProfileType: $ActiveProfileType}
  ) {
    ActiveAccountId
    ActiveProfileType
  }
}
    `;
export type UpdateActiveAccountIdMutationFn = Apollo.MutationFunction<UpdateActiveAccountIdMutation, UpdateActiveAccountIdMutationVariables>;

/**
 * __useUpdateActiveAccountIdMutation__
 *
 * To run a mutation, you first call `useUpdateActiveAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActiveAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActiveAccountIdMutation, { data, loading, error }] = useUpdateActiveAccountIdMutation({
 *   variables: {
 *      ActiveAccountId: // value for 'ActiveAccountId'
 *      id: // value for 'id'
 *      ActiveProfileType: // value for 'ActiveProfileType'
 *   },
 * });
 */
export function useUpdateActiveAccountIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActiveAccountIdMutation, UpdateActiveAccountIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActiveAccountIdMutation, UpdateActiveAccountIdMutationVariables>(UpdateActiveAccountIdDocument, options);
      }
export type UpdateActiveAccountIdMutationHookResult = ReturnType<typeof useUpdateActiveAccountIdMutation>;
export type UpdateActiveAccountIdMutationResult = Apollo.MutationResult<UpdateActiveAccountIdMutation>;
export type UpdateActiveAccountIdMutationOptions = Apollo.BaseMutationOptions<UpdateActiveAccountIdMutation, UpdateActiveAccountIdMutationVariables>;
export const GetUserAndProductDocument = gql`
    query getUserAndProduct($userId: uuid!) {
  user: User_by_pk(Id: $userId) {
    Id
    Identifier
    Email
    FirstName
    LastName
    Account {
      Id
      FunderId
      PlanterId
      Avatar
      Banner
      Type
      Name
      Email
    }
  }
  product: Product(where: {IsArchived: {_eq: false}}, limit: 1) {
    Id
  }
}
    `;

/**
 * __useGetUserAndProductQuery__
 *
 * To run a query within a React component, call `useGetUserAndProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAndProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAndProductQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserAndProductQuery(baseOptions: Apollo.QueryHookOptions<GetUserAndProductQuery, GetUserAndProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAndProductQuery, GetUserAndProductQueryVariables>(GetUserAndProductDocument, options);
      }
export function useGetUserAndProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAndProductQuery, GetUserAndProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAndProductQuery, GetUserAndProductQueryVariables>(GetUserAndProductDocument, options);
        }
export type GetUserAndProductQueryHookResult = ReturnType<typeof useGetUserAndProductQuery>;
export type GetUserAndProductLazyQueryHookResult = ReturnType<typeof useGetUserAndProductLazyQuery>;
export type GetUserAndProductQueryResult = Apollo.QueryResult<GetUserAndProductQuery, GetUserAndProductQueryVariables>;
export const ListUserEventsDocument = gql`
    query listUserEvents($limit: Int!, $offset: Int! = 0, $types: [Int!] = [1, 2, 8]) {
  userEvents: UserEventView(
    limit: $limit
    offset: $offset
    order_by: {CreatedOn: desc}
    where: {Type: {_in: $types}}
  ) {
    Id
    Type
    Comment
    CreatedOn
    Name
    Uri
    Description
    Avatar
    RegistryUri
    RegistryName
    Quantity
    RegionName
    ProjectUri
    ProjectName
    PurchaseType
    HasSubscriptionId
  }
}
    `;

/**
 * __useListUserEventsQuery__
 *
 * To run a query within a React component, call `useListUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserEventsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useListUserEventsQuery(baseOptions: Apollo.QueryHookOptions<ListUserEventsQuery, ListUserEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserEventsQuery, ListUserEventsQueryVariables>(ListUserEventsDocument, options);
      }
export function useListUserEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserEventsQuery, ListUserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserEventsQuery, ListUserEventsQueryVariables>(ListUserEventsDocument, options);
        }
export type ListUserEventsQueryHookResult = ReturnType<typeof useListUserEventsQuery>;
export type ListUserEventsLazyQueryHookResult = ReturnType<typeof useListUserEventsLazyQuery>;
export type ListUserEventsQueryResult = Apollo.QueryResult<ListUserEventsQuery, ListUserEventsQueryVariables>;
export const CountUserEventsDocument = gql`
    query countUserEvents {
  userEventsAggregate: UserEventView_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountUserEventsQuery__
 *
 * To run a query within a React component, call `useCountUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUserEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountUserEventsQuery(baseOptions?: Apollo.QueryHookOptions<CountUserEventsQuery, CountUserEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUserEventsQuery, CountUserEventsQueryVariables>(CountUserEventsDocument, options);
      }
export function useCountUserEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUserEventsQuery, CountUserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUserEventsQuery, CountUserEventsQueryVariables>(CountUserEventsDocument, options);
        }
export type CountUserEventsQueryHookResult = ReturnType<typeof useCountUserEventsQuery>;
export type CountUserEventsLazyQueryHookResult = ReturnType<typeof useCountUserEventsLazyQuery>;
export type CountUserEventsQueryResult = Apollo.QueryResult<CountUserEventsQuery, CountUserEventsQueryVariables>;
export const GetAdminUserDocument = gql`
    query getAdminUser($userId: uuid!) {
  User_by_pk(Id: $userId) {
    Id
    CreatedOn
    Email
    FirstName
    LastName
    Account {
      Id
      CreatedOn
      Name
      Email
      Reference
      Type
      PlanterId
      FunderId
    }
    Memberships {
      Id
      Account {
        Id
        CreatedOn
        Name
        Email
        Reference
        Type
        Memberships {
          Id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
      }
export function useGetAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetUserAccountIntercomDataDocument = gql`
    query getUserAccountIntercomData {
  get_user_account_intercom_data {
    AdminProfileLink
    ApplicationDate
    Avatar
    CreatedOn
    Email
    FirstName
    IdType
    IsProfileHidden
    LastName
    ProfileLink
    ProfileId
    ProfileName
    Profiles {
      Name
      ProfileLink
      ProfileType
    }
    District
    FundedAmount
    FundedQuantity
    PhoneNumber
    PrimaryCategory
    SecondaryCategory
    Region
    TreesAppliedFor
    TreesApproved
    LastFunded
    LastApplied
    TreesPlanted
    HasSubscriptions
    SubscriptionCreatedOn
    SubscriptionState
    SubscriptionQuantity
    SubscriptionCancelledOn
    Hash
  }
}
    `;

/**
 * __useGetUserAccountIntercomDataQuery__
 *
 * To run a query within a React component, call `useGetUserAccountIntercomDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountIntercomDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountIntercomDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAccountIntercomDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAccountIntercomDataQuery, GetUserAccountIntercomDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountIntercomDataQuery, GetUserAccountIntercomDataQueryVariables>(GetUserAccountIntercomDataDocument, options);
      }
export function useGetUserAccountIntercomDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountIntercomDataQuery, GetUserAccountIntercomDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountIntercomDataQuery, GetUserAccountIntercomDataQueryVariables>(GetUserAccountIntercomDataDocument, options);
        }
export type GetUserAccountIntercomDataQueryHookResult = ReturnType<typeof useGetUserAccountIntercomDataQuery>;
export type GetUserAccountIntercomDataLazyQueryHookResult = ReturnType<typeof useGetUserAccountIntercomDataLazyQuery>;
export type GetUserAccountIntercomDataQueryResult = Apollo.QueryResult<GetUserAccountIntercomDataQuery, GetUserAccountIntercomDataQueryVariables>;
export const GetAdminUserIntercomDataDocument = gql`
    query getAdminUserIntercomData($userId: uuid!, $currentSeason: uuid!, $lastSeason: uuid!, $yearStart: timestamp!) {
  UserData: User_by_pk(Id: $userId) {
    Id
    FirstName
    LastName
    Email
    CreatedOn
    Account {
      Id
      Name
      Email
      Phone
      Uri
      Avatar
      Id
      Type
      BusinessType
      OrgType
      GovType
      SchoolType
      Sector
      Region {
        Id
        Name
      }
      District {
        Id
        Name
      }
      Funder {
        Id
        Subscriptions(order_by: {CreatedOn: desc}) {
          CancelDate
          CreatedOn
          Quantity
          State
        }
        IsHidden
        LastFunded: Instruction_aggregate(where: {Purchase: {State: {_eq: 4}}}) {
          aggregate {
            max {
              CreatedOn
            }
          }
        }
        TreesFunded: Instruction_aggregate(
          where: {Purchase: {State: {_eq: 4}, CreatedOn: {_gt: $yearStart}}}
        ) {
          nodes {
            Purchase {
              Total
              Quantity
            }
          }
        }
      }
      Planter {
        Id
        IsHidden
        PlantingData: Application {
          Plantings_aggregate(where: {SeasonId: {_eq: $lastSeason}}) {
            aggregate {
              sum {
                Quantity
              }
            }
          }
        }
        TreeData: Application_aggregate(where: {SeasonId: {_eq: $currentSeason}}) {
          aggregate {
            sum {
              Approved
              Required
            }
          }
        }
        ApplicationData: Application_aggregate {
          aggregate {
            min {
              CreatedOn
            }
            max {
              CreatedOn
            }
          }
        }
      }
    }
    Memberships {
      Account {
        Id
        Name
        Uri
        Type
      }
    }
  }
}
    `;

/**
 * __useGetAdminUserIntercomDataQuery__
 *
 * To run a query within a React component, call `useGetAdminUserIntercomDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserIntercomDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserIntercomDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      currentSeason: // value for 'currentSeason'
 *      lastSeason: // value for 'lastSeason'
 *      yearStart: // value for 'yearStart'
 *   },
 * });
 */
export function useGetAdminUserIntercomDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserIntercomDataQuery, GetAdminUserIntercomDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserIntercomDataQuery, GetAdminUserIntercomDataQueryVariables>(GetAdminUserIntercomDataDocument, options);
      }
export function useGetAdminUserIntercomDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserIntercomDataQuery, GetAdminUserIntercomDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserIntercomDataQuery, GetAdminUserIntercomDataQueryVariables>(GetAdminUserIntercomDataDocument, options);
        }
export type GetAdminUserIntercomDataQueryHookResult = ReturnType<typeof useGetAdminUserIntercomDataQuery>;
export type GetAdminUserIntercomDataLazyQueryHookResult = ReturnType<typeof useGetAdminUserIntercomDataLazyQuery>;
export type GetAdminUserIntercomDataQueryResult = Apollo.QueryResult<GetAdminUserIntercomDataQuery, GetAdminUserIntercomDataQueryVariables>;
export const GetUserEventViewsForRegistryDocument = gql`
    query getUserEventViewsForRegistry($offset: Int!, $registryId: uuid!) {
  UserEventView_aggregate(where: {RegistryId: {_eq: $registryId}}) {
    aggregate {
      count
    }
  }
  UserEventView(
    offset: $offset
    order_by: {CreatedOn: desc}
    limit: 10
    where: {RegistryId: {_eq: $registryId}}
  ) {
    Id
    Avatar
    Comment
    CreatedOn
    Description
    Name
  }
}
    `;

/**
 * __useGetUserEventViewsForRegistryQuery__
 *
 * To run a query within a React component, call `useGetUserEventViewsForRegistryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventViewsForRegistryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventViewsForRegistryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      registryId: // value for 'registryId'
 *   },
 * });
 */
export function useGetUserEventViewsForRegistryQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventViewsForRegistryQuery, GetUserEventViewsForRegistryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventViewsForRegistryQuery, GetUserEventViewsForRegistryQueryVariables>(GetUserEventViewsForRegistryDocument, options);
      }
export function useGetUserEventViewsForRegistryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventViewsForRegistryQuery, GetUserEventViewsForRegistryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventViewsForRegistryQuery, GetUserEventViewsForRegistryQueryVariables>(GetUserEventViewsForRegistryDocument, options);
        }
export type GetUserEventViewsForRegistryQueryHookResult = ReturnType<typeof useGetUserEventViewsForRegistryQuery>;
export type GetUserEventViewsForRegistryLazyQueryHookResult = ReturnType<typeof useGetUserEventViewsForRegistryLazyQuery>;
export type GetUserEventViewsForRegistryQueryResult = Apollo.QueryResult<GetUserEventViewsForRegistryQuery, GetUserEventViewsForRegistryQueryVariables>;
export const GetLatestUserEventDocument = gql`
    query getLatestUserEvent($where: UserEventView_bool_exp) {
  UserEventView(limit: 1, order_by: {CreatedOn: desc}, where: $where) {
    CreatedOn
    Comment
    Name
    Quantity
    Type
    PurchaseType
    HasSubscriptionId
  }
}
    `;

/**
 * __useGetLatestUserEventQuery__
 *
 * To run a query within a React component, call `useGetLatestUserEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestUserEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestUserEventQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLatestUserEventQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestUserEventQuery, GetLatestUserEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestUserEventQuery, GetLatestUserEventQueryVariables>(GetLatestUserEventDocument, options);
      }
export function useGetLatestUserEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestUserEventQuery, GetLatestUserEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestUserEventQuery, GetLatestUserEventQueryVariables>(GetLatestUserEventDocument, options);
        }
export type GetLatestUserEventQueryHookResult = ReturnType<typeof useGetLatestUserEventQuery>;
export type GetLatestUserEventLazyQueryHookResult = ReturnType<typeof useGetLatestUserEventLazyQuery>;
export type GetLatestUserEventQueryResult = Apollo.QueryResult<GetLatestUserEventQuery, GetLatestUserEventQueryVariables>;
export const namedOperations = {
  Query: {
    listAdminAccounts: 'listAdminAccounts',
    getAdminAccount: 'getAdminAccount',
    getAccountAndProduct: 'getAccountAndProduct',
    getAdminAccountRegistries: 'getAdminAccountRegistries',
    getAdminAccountApplicationsView: 'getAdminAccountApplicationsView',
    getAdminAccountPurchases: 'getAdminAccountPurchases',
    listAccountSupporters: 'listAccountSupporters',
    getAccountByUri: 'getAccountByUri',
    getAccount: 'getAccount',
    getAccountSupporters: 'getAccountSupporters',
    getAccountAndPlanterRegistration: 'getAccountAndPlanterRegistration',
    getApplication: 'getApplication',
    listApplications: 'listApplications',
    getApplicationCountForPlanterRegistration: 'getApplicationCountForPlanterRegistration',
    getAdminApplication: 'getAdminApplication',
    getAdminApplicationByPlanterRegistrationId: 'getAdminApplicationByPlanterRegistrationId',
    listAdminApplicationsView: 'listAdminApplicationsView',
    getAdminApplicationMatches: 'getAdminApplicationMatches',
    getAdminApplicationProject: 'getAdminApplicationProject',
    listAdminApplicationsForProject: 'listAdminApplicationsForProject',
    getApplicationForWorkflowStateTransition: 'getApplicationForWorkflowStateTransition',
    getApplicationNavState: 'getApplicationNavState',
    listAdminApplicationsByProjectId: 'listAdminApplicationsByProjectId',
    ListAccountPurchaseReceipts: 'ListAccountPurchaseReceipts',
    listAttachments: 'listAttachments',
    getAttachment: 'getAttachment',
    getPurchaseAttachmentStatus: 'getPurchaseAttachmentStatus',
    listCertifications: 'listCertifications',
    getDashboardProjectsSupportedCount: 'getDashboardProjectsSupportedCount',
    getDashboardTabsData: 'getDashboardTabsData',
    GetFunderStats: 'GetFunderStats',
    GetFunderSupportStats: 'GetFunderSupportStats',
    FunderSupportedProjectTreeCount: 'FunderSupportedProjectTreeCount',
    listGiftCategories: 'listGiftCategories',
    listGiftTemplates: 'listGiftTemplates',
    getBulkGiftAttributes: 'getBulkGiftAttributes',
    listBulkGiftRecipients: 'listBulkGiftRecipients',
    getGiftPreview: 'getGiftPreview',
    listAdminInstructions: 'listAdminInstructions',
    getActiveInviteByEmail: 'getActiveInviteByEmail',
    getInviteById: 'getInviteById',
    getActiveInviteAccountByCode: 'getActiveInviteAccountByCode',
    GetInviteByCodeWithUser: 'GetInviteByCodeWithUser',
    GetMembershipAndAccounts: 'GetMembershipAndAccounts',
    listAccountMembershipsAndInvites: 'listAccountMembershipsAndInvites',
    listAccountMemberships: 'listAccountMemberships',
    getMonitoringForApplicationWorkflowStateTransition: 'getMonitoringForApplicationWorkflowStateTransition',
    getMonitorings: 'getMonitorings',
    getMonitoringEvent: 'getMonitoringEvent',
    getPlanterRegistration: 'getPlanterRegistration',
    getAccountPlanterRegistration: 'getAccountPlanterRegistration',
    GetPlanterStats: 'GetPlanterStats',
    GetPlanterSupportStats: 'GetPlanterSupportStats',
    getAdminPlanterRegistration: 'getAdminPlanterRegistration',
    getPlanting: 'getPlanting',
    listOrphanedPlantings: 'listOrphanedPlantings',
    getAdminPlanting: 'getAdminPlanting',
    getPlantingForApplicationWorkflowStateTransition: 'getPlantingForApplicationWorkflowStateTransition',
    listProjectPlantings: 'listProjectPlantings',
    getAdminApplicationPlantingReports: 'getAdminApplicationPlantingReports',
    getProductAndPrices: 'getProductAndPrices',
    getAllProductAndPrices: 'getAllProductAndPrices',
    getAccountProjects: 'getAccountProjects',
    getSupportedProjects: 'getSupportedProjects',
    getProjectsByUris: 'getProjectsByUris',
    getProjectByUri: 'getProjectByUri',
    getProject: 'getProject',
    getAdminProject: 'getAdminProject',
    listProjects: 'listProjects',
    listAdminProjects: 'listAdminProjects',
    getProjectNavState: 'getProjectNavState',
    listProjectSupporters: 'listProjectSupporters',
    getProjectStats: 'getProjectStats',
    getProjectListing: 'getProjectListing',
    listProjectNotesById: 'listProjectNotesById',
    getProjectNoteById: 'getProjectNoteById',
    getAdminPurchase: 'getAdminPurchase',
    getInstructionView: 'getInstructionView',
    getInstructionViewWithMatches: 'getInstructionViewWithMatches',
    listAdminPurchases: 'listAdminPurchases',
    getPurchasesForAccount: 'getPurchasesForAccount',
    listFunderPurchases: 'listFunderPurchases',
    listAdminBulkGifts: 'listAdminBulkGifts',
    getAdminBulkGifts: 'getAdminBulkGifts',
    getAdminPurchaseById: 'getAdminPurchaseById',
    getPurchaseDetailByToken: 'getPurchaseDetailByToken',
    getRegistryView: 'getRegistryView',
    listRegistries: 'listRegistries',
    getAdminRegistryView: 'getAdminRegistryView',
    listAdminRegistries: 'listAdminRegistries',
    getRegistryByUri: 'getRegistryByUri',
    getRegistryById: 'getRegistryById',
    getRegistryViewByUri: 'getRegistryViewByUri',
    getRegistries: 'getRegistries',
    getReport: 'getReport',
    generatePresignedUrl: 'generatePresignedUrl',
    ListOpenSeasons: 'ListOpenSeasons',
    listSeasons: 'listSeasons',
    getRegionById: 'getRegionById',
    listRegionsForForm: 'listRegionsForForm',
    listRegions: 'listRegions',
    listDistricts: 'listDistricts',
    listSeasonsAndSpecies: 'listSeasonsAndSpecies',
    listRegionsAndDistricts: 'listRegionsAndDistricts',
    listRegionsForSearchApplications: 'listRegionsForSearchApplications',
    getDashboardData: 'getDashboardData',
    getPlanterView: 'getPlanterView',
    getFunderView: 'getFunderView',
    getTreePoolStats: 'getTreePoolStats',
    getTreesFunded: 'getTreesFunded',
    getStatistics: 'getStatistics',
    getAccountSubscriptionDetails: 'getAccountSubscriptionDetails',
    getSubscription: 'getSubscription',
    getUserByEmail: 'getUserByEmail',
    getUserAndMemberships: 'getUserAndMemberships',
    getUserAndProduct: 'getUserAndProduct',
    listUserEvents: 'listUserEvents',
    countUserEvents: 'countUserEvents',
    getAdminUser: 'getAdminUser',
    getUserAccountIntercomData: 'getUserAccountIntercomData',
    getAdminUserIntercomData: 'getAdminUserIntercomData',
    getUserEventViewsForRegistry: 'getUserEventViewsForRegistry',
    getLatestUserEvent: 'getLatestUserEvent'
  },
  Mutation: {
    createAccount: 'createAccount',
    updatePaymentMethod: 'updatePaymentMethod',
    updateAccount: 'updateAccount',
    createFunder: 'createFunder',
    createPlanter: 'createPlanter',
    updateAddress: 'updateAddress',
    updateAdminAccountByStripeId: 'updateAdminAccountByStripeId',
    createAccountProfile: 'createAccountProfile',
    createApplication: 'createApplication',
    createAdminApplication: 'createAdminApplication',
    deleteDraftApplication: 'deleteDraftApplication',
    updateApplication: 'updateApplication',
    updateProjectApplicationsRegionDistrict: 'updateProjectApplicationsRegionDistrict',
    updateApplicationCounts: 'updateApplicationCounts',
    updateApplicationHoldOnMatch: 'updateApplicationHoldOnMatch',
    updateApplicationSeason: 'updateApplicationSeason',
    createMatchFromApplication: 'createMatchFromApplication',
    createActionNote: 'createActionNote',
    createApplicationAsset: 'createApplicationAsset',
    createProjectAsset: 'createProjectAsset',
    createProjectHero: 'createProjectHero',
    createPlanterRegistrationAsset: 'createPlanterRegistrationAsset',
    createPlantingAsset: 'createPlantingAsset',
    deleteApplicationAsset: 'deleteApplicationAsset',
    deleteProjectAsset: 'deleteProjectAsset',
    deletePlanterRegistrationAsset: 'deletePlanterRegistrationAsset',
    deletePlantingAsset: 'deletePlantingAsset',
    createMonitoringAsset: 'createMonitoringAsset',
    createAccountAsset: 'createAccountAsset',
    createPlantingSiteAsset: 'createPlantingSiteAsset',
    deletePlantingSiteAsset: 'deletePlantingSiteAsset',
    regeneratePdf: 'regeneratePdf',
    createAttachment: 'createAttachment',
    createGiftPayment: 'createGiftPayment',
    createGiftGuestPayment: 'createGiftGuestPayment',
    importBulkGift: 'importBulkGift',
    CreateAccountUserInvite: 'CreateAccountUserInvite',
    acceptAccountInvite: 'acceptAccountInvite',
    declineAccountInvite: 'declineAccountInvite',
    deleteAccountInvite: 'deleteAccountInvite',
    updateAccountInviteStatus: 'updateAccountInviteStatus',
    updateExpiredInvites: 'updateExpiredInvites',
    CreateMembership: 'CreateMembership',
    UpdateMembershipRole: 'UpdateMembershipRole',
    changeUserMembershipType: 'changeUserMembershipType',
    DeleteMembership: 'DeleteMembership',
    deleteUserMembership: 'deleteUserMembership',
    createMonitoringEvent: 'createMonitoringEvent',
    createPlanterRegistration: 'createPlanterRegistration',
    updatePlanterRegistration: 'updatePlanterRegistration',
    insertPlanterRegistration: 'insertPlanterRegistration',
    createPlantingSite: 'createPlantingSite',
    updatePlantingSite: 'updatePlantingSite',
    createPlanting: 'createPlanting',
    updatePlanting: 'updatePlanting',
    deletePlanting: 'deletePlanting',
    updateAdminProject: 'updateAdminProject',
    updateProject: 'updateProject',
    createAdminProject: 'createAdminProject',
    createProject: 'createProject',
    DeleteProject: 'DeleteProject',
    DeleteAdminProjectById: 'DeleteAdminProjectById',
    createProjectNote: 'createProjectNote',
    createProjectNoteAsset: 'createProjectNoteAsset',
    deleteProjectNoteAsset: 'deleteProjectNoteAsset',
    updateProjectNote: 'updateProjectNote',
    deleteProjectNoteApplication: 'deleteProjectNoteApplication',
    createProjectNoteApplication: 'createProjectNoteApplication',
    DeleteMatches: 'DeleteMatches',
    createMatchFromInstruction: 'createMatchFromInstruction',
    createPayment: 'createPayment',
    createGuestPayment: 'createGuestPayment',
    updateInstructionHoldStatus: 'updateInstructionHoldStatus',
    processPurchase: 'processPurchase',
    voidPurchase: 'voidPurchase',
    createAdminPayment: 'createAdminPayment',
    updateAdminPurchaseRecipientEmail: 'updateAdminPurchaseRecipientEmail',
    updatePurchaseRecipientEmail: 'updatePurchaseRecipientEmail',
    resendGiftCertificate: 'resendGiftCertificate',
    adminUpdatePurchaseError: 'adminUpdatePurchaseError',
    updatePurchaseError: 'updatePurchaseError',
    updateAdminPurchasePublicMessage: 'updateAdminPurchasePublicMessage',
    updatePurchasePublicMessage: 'updatePurchasePublicMessage',
    updateRegistry: 'updateRegistry',
    createRegistry: 'createRegistry',
    insertRegistry: 'insertRegistry',
    UpdateAdminRegistriesForClosure: 'UpdateAdminRegistriesForClosure',
    deleteRegistry: 'deleteRegistry',
    deleteAdminRegistry: 'deleteAdminRegistry',
    createPurchasesReport: 'createPurchasesReport',
    createTreePoolReport: 'createTreePoolReport',
    createAccountsReport: 'createAccountsReport',
    generatePutObjectPresignedUrl: 'generatePutObjectPresignedUrl',
    updateAdminSubscription: 'updateAdminSubscription',
    updateAdminSubscriptionByStripeId: 'updateAdminSubscriptionByStripeId',
    updateSubscription: 'updateSubscription',
    cancelSubscription: 'cancelSubscription',
    updateUserFirstAndLastName: 'updateUserFirstAndLastName',
    updateActiveAccountId: 'updateActiveAccountId'
  }
}